'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var styles = require('@mui/material/styles');
var Box = require('@mui/material/Box');
var Typography = require('@mui/material/Typography');
var material = require('@mui/material');
var Button = require('@mui/material/Button');
var InputBase = require('@mui/material/InputBase');
var SearchIcon = require('@mui/icons-material/Search');
var Popover = require('@mui/material/Popover');
var IconButton = require('@mui/material/IconButton');
var useScrollTrigger = require('@mui/material/useScrollTrigger');
var AppBar = require('@mui/material/AppBar');
var Divider = require('@mui/material/Divider');
var dayjs = require('dayjs');
var iconsMaterial = require('@mui/icons-material');
var ListItemText = require('@mui/material/ListItemText');
var ListItem = require('@mui/material/ListItem');
var InfiniteScroll = require('react-infinite-scroll-component');
var Tooltip = require('@mui/material/Tooltip');
var TextField = require('@mui/material/TextField');
var AdapterDayjs = require('@mui/x-date-pickers/AdapterDayjs');
var LocalizationProvider = require('@mui/x-date-pickers/LocalizationProvider');
var DatePicker = require('@mui/x-date-pickers/DatePicker');
var Toolbar = require('@mui/material/Toolbar');
var CloseIcon = require('@mui/icons-material/Close');
var Remove = require('@mui/icons-material/Remove');
var ExpandLess = require('@mui/icons-material/ExpandLess');
var ExpandMore = require('@mui/icons-material/ExpandMore');
var InputLabel = require('@mui/material/InputLabel');
var MenuItem = require('@mui/material/MenuItem');
var FormControl = require('@mui/material/FormControl');
var Select = require('@mui/material/Select');
var Table = require('@mui/material/Table');
var TableContainer = require('@mui/material/TableContainer');
var TablePagination = require('@mui/material/TablePagination');
var Paper = require('@mui/material/Paper');
var TableHead = require('@mui/material/TableHead');
var TableRow = require('@mui/material/TableRow');
var TableSortLabel = require('@mui/material/TableSortLabel');
var TableCell = require('@mui/material/TableCell');
var TableBody = require('@mui/material/TableBody');
var xDataGrid = require('@mui/x-data-grid');
var CssBaseline = require('@mui/material/CssBaseline');
var MuiDrawer = require('@mui/material/Drawer');
var List = require('@mui/material/List');
var ListItemButton = require('@mui/material/ListItemButton');
var ListItemIcon = require('@mui/material/ListItemIcon');
var LogoutIcon = require('@mui/icons-material/Logout');
var MenuIcon = require('@mui/icons-material/Menu');
var ChevronRightIcon = require('@mui/icons-material/ChevronRight');
var ChevronLeftIcon = require('@mui/icons-material/ChevronLeft');
var NavigateNextIcon = require('@mui/icons-material/NavigateNext');
var Breadcrumbs = require('@mui/material/Breadcrumbs');
var Grid = require('@mui/material/Grid');
var Dialog = require('@mui/material/Dialog');
var DialogContent = require('@mui/material/DialogContent');
var DialogActions = require('@mui/material/DialogActions');
var DialogTitle = require('@mui/material/DialogTitle');
var CheckBoxIcon = require('@mui/icons-material/CheckBox');
var CheckBoxOutlineBlankIcon = require('@mui/icons-material/CheckBoxOutlineBlank');
var am5 = require('@amcharts/amcharts5');
var am5themes_Animated = require('@amcharts/amcharts5/themes/Animated');
var xy = require('@amcharts/amcharts5/xy');
var map_data = require('@amcharts/amcharts5-geodata/usaHigh');
var map = require('@amcharts/amcharts5/map');
var Card = require('@mui/material/Card');
var CardHeader = require('@mui/material/CardHeader');
var Checkbox = require('@mui/material/Checkbox');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var InputBase__default = /*#__PURE__*/_interopDefaultLegacy(InputBase);
var SearchIcon__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon);
var Popover__default = /*#__PURE__*/_interopDefaultLegacy(Popover);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var useScrollTrigger__default = /*#__PURE__*/_interopDefaultLegacy(useScrollTrigger);
var AppBar__default = /*#__PURE__*/_interopDefaultLegacy(AppBar);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var dayjs__default = /*#__PURE__*/_interopDefaultLegacy(dayjs);
var ListItemText__default = /*#__PURE__*/_interopDefaultLegacy(ListItemText);
var ListItem__default = /*#__PURE__*/_interopDefaultLegacy(ListItem);
var InfiniteScroll__default = /*#__PURE__*/_interopDefaultLegacy(InfiniteScroll);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var Toolbar__default = /*#__PURE__*/_interopDefaultLegacy(Toolbar);
var CloseIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon);
var Remove__default = /*#__PURE__*/_interopDefaultLegacy(Remove);
var ExpandLess__default = /*#__PURE__*/_interopDefaultLegacy(ExpandLess);
var ExpandMore__default = /*#__PURE__*/_interopDefaultLegacy(ExpandMore);
var InputLabel__default = /*#__PURE__*/_interopDefaultLegacy(InputLabel);
var MenuItem__default = /*#__PURE__*/_interopDefaultLegacy(MenuItem);
var FormControl__default = /*#__PURE__*/_interopDefaultLegacy(FormControl);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);
var Table__default = /*#__PURE__*/_interopDefaultLegacy(Table);
var TableContainer__default = /*#__PURE__*/_interopDefaultLegacy(TableContainer);
var TablePagination__default = /*#__PURE__*/_interopDefaultLegacy(TablePagination);
var Paper__default = /*#__PURE__*/_interopDefaultLegacy(Paper);
var TableHead__default = /*#__PURE__*/_interopDefaultLegacy(TableHead);
var TableRow__default = /*#__PURE__*/_interopDefaultLegacy(TableRow);
var TableSortLabel__default = /*#__PURE__*/_interopDefaultLegacy(TableSortLabel);
var TableCell__default = /*#__PURE__*/_interopDefaultLegacy(TableCell);
var TableBody__default = /*#__PURE__*/_interopDefaultLegacy(TableBody);
var CssBaseline__default = /*#__PURE__*/_interopDefaultLegacy(CssBaseline);
var MuiDrawer__default = /*#__PURE__*/_interopDefaultLegacy(MuiDrawer);
var List__default = /*#__PURE__*/_interopDefaultLegacy(List);
var ListItemButton__default = /*#__PURE__*/_interopDefaultLegacy(ListItemButton);
var ListItemIcon__default = /*#__PURE__*/_interopDefaultLegacy(ListItemIcon);
var LogoutIcon__default = /*#__PURE__*/_interopDefaultLegacy(LogoutIcon);
var MenuIcon__default = /*#__PURE__*/_interopDefaultLegacy(MenuIcon);
var ChevronRightIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronRightIcon);
var ChevronLeftIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronLeftIcon);
var NavigateNextIcon__default = /*#__PURE__*/_interopDefaultLegacy(NavigateNextIcon);
var Breadcrumbs__default = /*#__PURE__*/_interopDefaultLegacy(Breadcrumbs);
var Grid__default = /*#__PURE__*/_interopDefaultLegacy(Grid);
var Dialog__default = /*#__PURE__*/_interopDefaultLegacy(Dialog);
var DialogContent__default = /*#__PURE__*/_interopDefaultLegacy(DialogContent);
var DialogActions__default = /*#__PURE__*/_interopDefaultLegacy(DialogActions);
var DialogTitle__default = /*#__PURE__*/_interopDefaultLegacy(DialogTitle);
var CheckBoxIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckBoxIcon);
var CheckBoxOutlineBlankIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckBoxOutlineBlankIcon);
var am5__namespace = /*#__PURE__*/_interopNamespace(am5);
var am5themes_Animated__default = /*#__PURE__*/_interopDefaultLegacy(am5themes_Animated);
var map_data__default = /*#__PURE__*/_interopDefaultLegacy(map_data);
var Card__default = /*#__PURE__*/_interopDefaultLegacy(Card);
var CardHeader__default = /*#__PURE__*/_interopDefaultLegacy(CardHeader);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$l = function() {
    __assign$l = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$l.apply(this, arguments);
};

function __rest$c(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$8(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$8(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArray$5(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var LevelSelector = function (props) {
    props.maxNumLevels; props.levelSelected; props.onLevelSelect; __rest$c(props, ["maxNumLevels", "levelSelected", "onLevelSelect"]);
    return React__default["default"].createElement("div", null);
    // TODO: fix this to pull from provider
    // const theme = theTheme
    // return (
    //   <Flex {...rest} sx={{ ...(theme.flex.col as ThemeUIStyleObject) }}>
    //     <Text>Level</Text>
    //     <Box sx={{ textAlign: 'center', ...theme.box.card }}>
    //       {Array.from(Array(maxNumLevels).keys())
    //         .reverse()
    //         .map(level => (
    //           <Text
    //             key={level}
    //             onClick={() => {
    //               onLevelSelect(level)
    //             }}
    //             sx={{
    //               color:
    //                 levelSelected === level
    //                   ? theme.colors.text
    //                   : theme.colors.placeholderText,
    //               cursor: 'pointer',
    //             }}
    //           >{`${level}`}</Text>
    //         ))}
    //     </Box>
    //   </Flex>
    // )
};

/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var NavBar = function (props) {
    props.logoUrl; props.FooterComponent; props.children; props.width;
    return React__default["default"].createElement("div", null);
    // return (
    //   <Flex
    //     sx={{
    //       width,
    //       height: '100vh',
    //       backgroundColor: theme.colors.navBg,
    //       ...(theme.flex.col as ThemeUIStyleObject),
    //     }}
    //   >
    //     <img
    //       src={logoUrl}
    //       alt="DeliciousAI Logo"
    //       sx={{
    //         height: 'auto',
    //         width: Number(width) - 40,
    //         margin: theme.space.large,
    //         marginTop: `${theme.space.shmedium + theme.space.large}px`,
    //         marginBottom: theme.space.xLarge,
    //         ...logoStyle,
    //       }}
    //     />
    //     {children}
    //     <Flex sx={{ flexGrow: 1 }} />
    //     {FooterComponent}
    //   </Flex>
    // )
};

/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var NavItem = function (props) {
    props.label; var routeTo = props.routeTo; props.onClick; props.children;
    reactRouterDom.useRouteMatch(routeTo);
    return React__default["default"].createElement("div", null);
    // return (
    //   <NavLink to={routeTo} onClick={onClick}>
    //     <Flex
    //       variant="flex.row"
    //       sx={{
    //         flexDirection: 'row',
    //         backgroundColor: theme.colors.navBg,
    //         color: theme.colors.navText,
    //         height: theme.sizes.navItemHeight,
    //         borderLeft: match
    //           ? `${theme.space.small}px  solid ${theme.colors.brandPrimary}`
    //           : `${theme.space.small}px solid ${theme.colors.navBg}`,
    //         paddingLeft: '28px',
    //         ':hover': {
    //           borderLeft: `${theme.space.small}px solid ${theme.colors.brandPrimary}`,
    //         },
    //         width: theme.sizes.navBarWidthWide,
    //         alignItems: 'center',
    //       }}
    //     >
    //       {children}
    //       <Text
    //         sx={{
    //           fontWeight: theme.fontWeights.bold,
    //           fontSize: theme.fontSizes.largeBody,
    //           lineHeight: `${theme.sizes.navItemHeight}px`,
    //           color: theme.colors.white,
    //           height: '100%',
    //           alignItems: 'center',
    //           alignContent: 'center',
    //           marginLeft: theme.space.large,
    //         }}
    //       >
    //         {label}
    //       </Text>
    //     </Flex>
    //   </NavLink>
    // )
};

function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$4.apply(this, arguments);
}

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize$1(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT$1 = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from$1 = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$3 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position$1 = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign$3(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position$1 > 0 ? charat(characters, --position$1) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position$1 < length ? charat(characters, position$1++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position$1)
}

/**
 * @return {number}
 */
function caret () {
	return position$1
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice$1 (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position$1 = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice$1(position$1 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace$1 (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice$1(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position$1
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position$1
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice$1(index, position$1 - 1) + '*' + from$1(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice$1(index, position$1)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$2('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$2 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace$1(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset:
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$2(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse$2(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$2(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from$1(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT$1, from$1(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify$2 (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT$1: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice$1(begin, position$1);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position$1 - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from$1(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser$5 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$5 ? undefined : weakMemoize(function () {
  return memoize$1(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$5 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$5) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$5) {
    var currentSheet;
    var finalizingPlugins = [stringify$2, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT$1) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify$2];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$3=b$1?Symbol.for("react.element"):60103,d$1=b$1?Symbol.for("react.portal"):60106,e$1=b$1?Symbol.for("react.fragment"):60107,f$3=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$2=b$1?
Symbol.for("react.suspense_list"):60120,r=b$1?Symbol.for("react.memo"):60115,t$1=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w=b$1?Symbol.for("react.fundamental"):60117,x=b$1?Symbol.for("react.responder"):60118,y=b$1?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$3:switch(a=a.type,a){case l$1:case m$1:case e$1:case g$1:case f$3:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t$1:case r:case h$1:return a;default:return u}}case d$1:return u}}}function A(a){return z(a)===m$1}reactIs_production_min$1.AsyncMode=l$1;reactIs_production_min$1.ConcurrentMode=m$1;reactIs_production_min$1.ContextConsumer=k$1;reactIs_production_min$1.ContextProvider=h$1;reactIs_production_min$1.Element=c$3;reactIs_production_min$1.ForwardRef=n$1;reactIs_production_min$1.Fragment=e$1;reactIs_production_min$1.Lazy=t$1;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d$1;
reactIs_production_min$1.Profiler=g$1;reactIs_production_min$1.StrictMode=f$3;reactIs_production_min$1.Suspense=p$1;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l$1};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k$1};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h$1};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$3};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n$1};reactIs_production_min$1.isFragment=function(a){return z(a)===e$1};reactIs_production_min$1.isLazy=function(a){return z(a)===t$1};
reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d$1};reactIs_production_min$1.isProfiler=function(a){return z(a)===g$1};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f$3};reactIs_production_min$1.isSuspense=function(a){return z(a)===p$1};
reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g$1||a===f$3||a===p$1||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v$1)};reactIs_production_min$1.typeOf=z;

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$1.AsyncMode = AsyncMode;
reactIs_development$1.ConcurrentMode = ConcurrentMode;
reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min$1;
} else {
  reactIs$1.exports = reactIs_development$1;
}

var isBrowser$4 = typeof document !== 'undefined';
function getRegisteredStyles$1(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles$1 = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$4 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles$1 = function insertStyles(cache, serialized, isStringTag) {
  registerStyles$1(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$4 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$4 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2$1(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys$1 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$2 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR$1 = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex$1 = /[A-Z]|^ms/g;
var animationRegex$1 = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty$1 = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue$1 = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName$1 = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty$1(styleName) ? styleName : styleName.replace(hyphenateRegex$1, '-$&').toLowerCase();
});

var processStyleValue$1 = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex$1, function (match, p1, p2) {
            cursor$1 = {
              name: p1,
              styles: p2,
              next: cursor$1
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys$1[key] !== 1 && !isCustomProperty$1(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern$1 = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues$1 = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue$1 = processStyleValue$1;
  var msPattern$1 = /^-ms-/;
  var hyphenPattern$1 = /-(.)/g;
  var hyphenatedCache$1 = {};

  processStyleValue$1 = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues$1.indexOf(value) === -1 && !contentValuePattern$1.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue$1(key, value);

    if (processed !== '' && !isCustomProperty$1(key) && key.indexOf('-') !== -1 && hyphenatedCache$1[key] === undefined) {
      hyphenatedCache$1[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern$1, 'ms-').replace(hyphenPattern$1, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage$1 = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation$1(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage$1);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor$1 = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor$1
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor$1 = {
                name: next.name,
                styles: next.styles,
                next: cursor$1
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject$1(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor$1;
          var result = interpolation(mergedProps);
          cursor$1 = previousCursor;
          return handleInterpolation$1(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex$1, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject$1(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation$1(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue$1(value)) {
          string += processStyleName$1(_key) + ":" + processStyleValue$1(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage$1);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue$1(value[_i])) {
              string += processStyleName$1(_key) + ":" + processStyleValue$1(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation$1(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName$1(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR$1);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern$1 = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern$1;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern$1 = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor$1;
var serializeStyles$1 = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor$1 = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation$1(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$2);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation$1(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$2);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern$1, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern$1.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern$1.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2$1(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor$1,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor$1
  };
};

var isBrowser$3 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React__namespace['useInsertion' + 'Effect'] ? React__namespace['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$3 ? syncFallback : useInsertionEffect || syncFallback;

var isBrowser$2 = typeof document !== 'undefined';
var hasOwnProperty$8 = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/React.forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = React.useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$2) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = React.useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles$1(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles$1(cache, serialized, isStringTag);
  });

  if (!isBrowser$2 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles$1(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles$1(registeredStyles, undefined, React.useContext(ThemeContext));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles$1([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$8.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion$1, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React.createElement(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser = typeof document !== 'undefined';

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var createStyled$1 = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = React.useContext(ThemeContext);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/React.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$4({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled$1.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

var emStyled = newStyled;

var propTypes = {exports: {}};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$7 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$7.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$1.exports;
var assign$2 = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign$2({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

/** @license MUI v5.10.8
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$1(tag, options) {
  const stylesFactory = emStyled(tag, options);

  if (process.env.NODE_ENV !== 'production') {
    return (...styles) => {
      const component = typeof tag === 'string' ? `"${tag}"` : 'component';

      if (styles.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
      } else if (styles.some(style => style === undefined)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }

      return stylesFactory(...styles);
    };
  }

  return stylesFactory;
} // eslint-disable-next-line @typescript-eslint/naming-convention

const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};

const responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
var responsivePropType$1 = responsivePropType;

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3.apply(this, arguments);
}

function isPlainObject(item) {
  return item !== null && typeof item === 'object' && item.constructor === Object;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$3({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;

  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c$2=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f$2=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q$1=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f$2:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q$1:case p:case g:return a;default:return r}}case c$2:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q$1;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c$2;reactIs_production_min.Profiler=f$2;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q$1};reactIs_production_min.isMemo=function(a){return v(a)===p};
reactIs_production_min.isPortal=function(a){return v(a)===c$2};reactIs_production_min.isProfiler=function(a){return v(a)===f$2};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f$2||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q$1||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min.typeOf=v;

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types.
var REACT_ELEMENT_TYPE = Symbol.for('react.element');
var REACT_PORTAL_TYPE = Symbol.for('react.portal');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
var REACT_CONTEXT_TYPE = Symbol.for('react.context');
var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
var REACT_MEMO_TYPE = Symbol.for('react.memo');
var REACT_LAZY_TYPE = Symbol.for('react.lazy');
var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

// -----------------------------------------------------------------------------

var enableScopeAPI = false; // Experimental Create Event Handle API.
var enableCacheElement = false;
var enableTransitionTracing = false; // No known bugs, but needs performance testing

var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
// stuff. Intended to enable React core members to more easily debug scheduling
// issues in DEV builds.

var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

var REACT_MODULE_REFERENCE;

{
  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
}

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_SERVER_CONTEXT_TYPE:
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}
function isSuspenseList(object) {
  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
}

reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.SuspenseList = SuspenseList;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isSuspenseList = isSuspenseList;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match = `${fn}`.match(fnNameMatchRegex);
  const name = match && match[1];
  return name || '';
}

function getFunctionComponentName(Component, fallback = '') {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  } // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`


  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case reactIs.exports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIs.exports.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$2.apply(this, arguments);
}

function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

// For instance with the first breakpoint xs: [xs, sm[.

const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen

};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};

  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }

      return acc;
    }, {});
  }

  const output = styleFromPropValue(propValue);
  return output;
}

function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;

  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;

    if (isBreakpointUnused) {
      delete acc[key];
    }

    return acc;
  }, style);
}

function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  } // Check if CSS variables are used


  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);

    if (val != null) {
      return val;
    }
  }

  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }

    return null;
  }, obj);
}

function getValue$1(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;

  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }

  if (transform) {
    value = transform(value, userValue);
  }

  return value;
}

function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  const fn = props => {
    if (props[prop] == null) {
      return null;
    }

    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};

    const styleFromPropValue = propValueFinal => {
      let value = getValue$1(themeMapping, transform, propValueFinal);

      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getValue$1(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize(propValueFinal)}`, propValueFinal);
      }

      if (cssProperty === false) {
        return value;
      }

      return {
        [cssProperty]: value
      };
    };

    return handleBreakpoints(props, propValue, styleFromPropValue);
  };

  fn.propTypes = process.env.NODE_ENV !== 'production' ? {
    [prop]: responsivePropType$1
  } : {};
  fn.filterProps = [prop];
  return fn;
}

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }

      return acc;
    }, {});
  };

  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce((acc, style) => Object.assign(acc, style.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}

function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;

  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;

  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join('\n'));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, 'It should be a number, an array or a function.'].join('\n'));
  }

  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  const abs = Math.abs(propValue);
  const transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}

function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }

  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}

function style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}
process.env.NODE_ENV !== 'production' ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
process.env.NODE_ENV !== 'production' ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};

function spacing(props) {
  return style(props, spacingKeys);
}

spacing.propTypes = process.env.NODE_ENV !== 'production' ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;

function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return `${value}px solid`;
}

const border = style$1({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
const borderTop = style$1({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
const borderRight = style$1({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
const borderBottom = style$1({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
const borderLeft = style$1({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
const borderColor = style$1({
  prop: 'borderColor',
  themeKey: 'palette'
});
const borderTopColor = style$1({
  prop: 'borderTopColor',
  themeKey: 'palette'
});
const borderRightColor = style$1({
  prop: 'borderRightColor',
  themeKey: 'palette'
});
const borderBottomColor = style$1({
  prop: 'borderBottomColor',
  themeKey: 'palette'
});
const borderLeftColor = style$1({
  prop: 'borderLeftColor',
  themeKey: 'palette'
});
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4, 'borderRadius');

    const styleFromPropValue = propValue => ({
      borderRadius: getValue(transformer, propValue)
    });

    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }

  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius.filterProps = ['borderRadius'];
const borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
var borders$1 = borders;

const displayPrint = style$1({
  prop: 'displayPrint',
  cssProperty: false,
  transform: value => ({
    '@media print': {
      display: value
    }
  })
});
const displayRaw = style$1({
  prop: 'display'
});
const overflow = style$1({
  prop: 'overflow'
});
const textOverflow = style$1({
  prop: 'textOverflow'
});
const visibility = style$1({
  prop: 'visibility'
});
const whiteSpace = style$1({
  prop: 'whiteSpace'
});
var display = compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

const flexBasis = style$1({
  prop: 'flexBasis'
});
const flexDirection = style$1({
  prop: 'flexDirection'
});
const flexWrap = style$1({
  prop: 'flexWrap'
});
const justifyContent = style$1({
  prop: 'justifyContent'
});
const alignItems = style$1({
  prop: 'alignItems'
});
const alignContent = style$1({
  prop: 'alignContent'
});
const order = style$1({
  prop: 'order'
});
const flex = style$1({
  prop: 'flex'
});
const flexGrow = style$1({
  prop: 'flexGrow'
});
const flexShrink = style$1({
  prop: 'flexShrink'
});
const alignSelf = style$1({
  prop: 'alignSelf'
});
const justifyItems = style$1({
  prop: 'justifyItems'
});
const justifySelf = style$1({
  prop: 'justifySelf'
});
const flexbox = compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
var flexbox$1 = flexbox;

const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'gap');

    const styleFromPropValue = propValue => ({
      gap: getValue(transformer, propValue)
    });

    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }

  return null;
};
gap.propTypes = process.env.NODE_ENV !== 'production' ? {
  gap: responsivePropType$1
} : {};
gap.filterProps = ['gap'];
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'columnGap');

    const styleFromPropValue = propValue => ({
      columnGap: getValue(transformer, propValue)
    });

    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }

  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  columnGap: responsivePropType$1
} : {};
columnGap.filterProps = ['columnGap'];
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'rowGap');

    const styleFromPropValue = propValue => ({
      rowGap: getValue(transformer, propValue)
    });

    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }

  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  rowGap: responsivePropType$1
} : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = style$1({
  prop: 'gridColumn'
});
const gridRow = style$1({
  prop: 'gridRow'
});
const gridAutoFlow = style$1({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = style$1({
  prop: 'gridAutoColumns'
});
const gridAutoRows = style$1({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = style$1({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = style$1({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = style$1({
  prop: 'gridTemplateAreas'
});
const gridArea = style$1({
  prop: 'gridArea'
});
const grid = compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
var grid$1 = grid;

function transform$1(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }

  return value;
}

const color = style$1({
  prop: 'color',
  themeKey: 'palette',
  transform: transform$1
});
const bgcolor = style$1({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: transform$1
});
const backgroundColor = style$1({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: transform$1
});
const palette = compose(color, bgcolor, backgroundColor);
var palette$1 = palette;

const position = style$1({
  prop: 'position'
});
const zIndex = style$1({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
const top = style$1({
  prop: 'top'
});
const right = style$1({
  prop: 'right'
});
const bottom = style$1({
  prop: 'bottom'
});
const left = style$1({
  prop: 'left'
});
var positions = compose(position, zIndex, top, right, bottom, left);

const boxShadow = style$1({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
var shadows = boxShadow;

function transform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}

const width = style$1({
  prop: 'width',
  transform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;

      const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || values[propValue];
      return {
        maxWidth: breakpoint || transform(propValue)
      };
    };

    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }

  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = style$1({
  prop: 'minWidth',
  transform
});
const height = style$1({
  prop: 'height',
  transform
});
const maxHeight = style$1({
  prop: 'maxHeight',
  transform
});
const minHeight = style$1({
  prop: 'minHeight',
  transform
});
style$1({
  prop: 'size',
  cssProperty: 'width',
  transform
});
style$1({
  prop: 'size',
  cssProperty: 'height',
  transform
});
const boxSizing = style$1({
  prop: 'boxSizing'
});
const sizing = compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
var sizing$1 = sizing;

const fontFamily = style$1({
  prop: 'fontFamily',
  themeKey: 'typography'
});
const fontSize = style$1({
  prop: 'fontSize',
  themeKey: 'typography'
});
const fontStyle = style$1({
  prop: 'fontStyle',
  themeKey: 'typography'
});
const fontWeight = style$1({
  prop: 'fontWeight',
  themeKey: 'typography'
});
const letterSpacing = style$1({
  prop: 'letterSpacing'
});
const textTransform = style$1({
  prop: 'textTransform'
});
const lineHeight = style$1({
  prop: 'lineHeight'
});
const textAlign = style$1({
  prop: 'textAlign'
});
const typographyVariant = style$1({
  prop: 'typography',
  cssProperty: false,
  themeKey: 'typography'
});
const typography = compose(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign, textTransform);
var typography$1 = typography;

const filterPropsMapping = {
  borders: borders$1.filterProps,
  display: display.filterProps,
  flexbox: flexbox$1.filterProps,
  grid: grid$1.filterProps,
  positions: positions.filterProps,
  palette: palette$1.filterProps,
  shadows: shadows.filterProps,
  sizing: sizing$1.filterProps,
  spacing: spacing.filterProps,
  typography: typography$1.filterProps
};
const styleFunctionMapping = {
  borders: borders$1,
  display,
  flexbox: flexbox$1,
  grid: grid$1,
  positions,
  palette: palette$1,
  shadows,
  sizing: sizing$1,
  spacing,
  typography: typography$1
};
Object.keys(filterPropsMapping).reduce((acc, styleFnName) => {
  filterPropsMapping[styleFnName].forEach(propName => {
    acc[propName] = styleFunctionMapping[styleFnName];
  });
  return acc;
}, {});

function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}

function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
} // eslint-disable-next-line @typescript-eslint/naming-convention


function unstable_createStyleFunctionSx(styleFunctionMapping$1 = styleFunctionMapping) {
  const propToStyleFunction = Object.keys(styleFunctionMapping$1).reduce((acc, styleFnName) => {
    styleFunctionMapping$1[styleFnName].filterProps.forEach(propName => {
      acc[propName] = styleFunctionMapping$1[styleFnName];
    });
    return acc;
  }, {});

  function getThemeValue(prop, value, theme) {
    const inputProps = {
      [prop]: value,
      theme
    };
    const styleFunction = propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
      [prop]: value
    };
  }

  function styleFunctionSx(props) {
    const {
      sx,
      theme = {}
    } = props || {};

    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */


    function traverse(sxInput) {
      let sxObject = sxInput;

      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }

      if (!sxObject) {
        return null;
      }

      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);

        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (propToStyleFunction[styleKey]) {
              css = merge(css, getThemeValue(styleKey, value, theme));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, x => ({
                [styleKey]: x
              }));

              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = merge(css, breakpointsValues);
              }
            }
          } else {
            css = merge(css, getThemeValue(styleKey, value, theme));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }

    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }

  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];
var defaultStyleFunctionSx = styleFunctionSx;

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$4 = ["values", "unit", "step"];

const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || []; // Sort in ascending order

  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$2({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
}; // Keep in mind that @media is inclusive by the CSS specification.


function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536 // large screen

    },
    unit = 'px',
    step = 5
  } = breakpoints,
        other = _objectWithoutPropertiesLoose$3(breakpoints, _excluded$4);

  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);

  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }

  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }

  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }

  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }

    return up(key);
  }

  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);

    if (keyIndex === 0) {
      return up(keys[1]);
    }

    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }

    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }

  return _extends$2({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

const shape = {
  borderRadius: 4
};
var shape$1 = shape;

/* tslint:enable:unified-signatures */
function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  const transform = createUnarySpacing({
    spacing: spacingInput
  });

  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== 'production') {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }

    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };

  spacing.mui = true;
  return spacing;
}

const _excluded$3 = ["breakpoints", "palette", "spacing", "shape"];

function createTheme(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options,
        other = _objectWithoutPropertiesLoose$3(options, _excluded$3);

  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: _extends$2({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: _extends$2({}, shape$1, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  return muiTheme;
}

const _excluded$2 = ["variant"];

function isEmpty$2(string) {
  return string.length === 0;
}
/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created.
 */


function propsToClassKey(props) {
  const {
    variant
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$2);

  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty$2(classKey) ? props[key] : capitalize(props[key]);
    } else {
      classKey += `${isEmpty$2(classKey) ? key : capitalize(key)}${capitalize(props[key].toString())}`;
    }
  });
  return classKey;
}

const _excluded$1 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"],
      _excluded2$1 = ["theme"],
      _excluded3$1 = ["theme"];

function isEmpty$1(obj) {
  return Object.keys(obj).length === 0;
} // https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40


function isStringTag(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }

  return null;
};

const getVariantStyles = (name, theme) => {
  let variants = [];

  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }

  const variantsStyles = {};
  variants.forEach(definition => {
    const key = propsToClassKey(definition.props);
    variantsStyles[key] = definition.style;
  });
  return variantsStyles;
};

const variantsResolver = (props, styles, theme, name) => {
  var _theme$components, _theme$components$nam;

  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;

  if (themeVariants) {
    themeVariants.forEach(themeVariant => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach(key => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });

      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
      }
    });
  }

  return variantsStyles;
}; // Update /system/styled/#api in case if this changes


function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = createTheme();

const lowercaseFirstLetter = string => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};

function createStyled(input = {}) {
  const {
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp,
    styleFunctionSx = defaultStyleFunctionSx
  } = input;

  const systemSx = props => {
    const theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
    return styleFunctionSx(_extends$2({}, props, {
      theme
    }));
  };

  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    internal_processStyles(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));

    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      overridesResolver
    } = inputOptions,
          options = _objectWithoutPropertiesLoose$3(inputOptions, _excluded$1); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.


    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== 'Root' || false;
    const skipSx = inputSkipSx || false;
    let label;

    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        label = `${componentName}-${lowercaseFirstLetter(componentSlot || 'Root')}`;
      }
    }

    let shouldForwardPropOption = shouldForwardProp;

    if (componentSlot === 'Root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }

    const defaultStyledResolver = styled$1(tag, _extends$2({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));

    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map(stylesArg => {
        // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        return typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg ? _ref => {
          let {
            theme: themeInput
          } = _ref,
              other = _objectWithoutPropertiesLoose$3(_ref, _excluded2$1);

          return stylesArg(_extends$2({
            theme: isEmpty$1(themeInput) ? defaultTheme : themeInput
          }, other));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;

      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
          const styleOverrides = getStyleOverrides(componentName, theme);

          if (styleOverrides) {
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = typeof slotStyle === 'function' ? slotStyle(_extends$2({}, props, {
                theme
              })) : slotStyle;
            });
            return overridesResolver(props, resolvedStyleOverrides);
          }

          return null;
        });
      }

      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }

      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }

      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;

      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill(''); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.

        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === 'function' && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      styleArg.__emotion_real !== styleArg) {
        // If the type is function, we need to define the default theme.
        transformedStyleArg = _ref2 => {
          let {
            theme: themeInput
          } = _ref2,
              other = _objectWithoutPropertiesLoose$3(_ref2, _excluded3$1);

          return styleArg(_extends$2({
            theme: isEmpty$1(themeInput) ? defaultTheme : themeInput
          }, other));
        };
      }

      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);

      if (process.env.NODE_ENV !== 'production') {
        let displayName;

        if (componentName) {
          displayName = `${componentName}${componentSlot || ''}`;
        }

        if (displayName === undefined) {
          displayName = `Styled(${getDisplayName(tag)})`;
        }

        Component.displayName = displayName;
      }

      return Component;
    };

    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }

    return muiStyledResolver;
  };
}

/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Clark Sandholtz <clark.sandholtz@deliciousai.com>
 */
var Colors = {
    BLACK: '#000000',
    // TODO: deprecate these Greys
    // ------------------------
    GRAY_0: '#1E1E1E',
    GRAY_1: '#333333',
    GRAY_2: '#4F4F4F',
    GRAY_3: '#828282',
    GRAY_4: '#BDBDBD',
    GRAY_5: '#E0E0E0',
    GRAY_6: '#F2F2F2',
    GRAY_7: '#F8F8F8',
    GRAY_8: '#F5F5F5',
    GRAY_9: '#EEEEEE',
    // ------------------------
    GRAY_50: '#FAFAFA',
    GRAY_100: '#F5F5F5',
    GRAY_200: '#EEEEEE',
    GRAY_300: '#E0E0E0',
    GRAY_400: '#BDBDBD',
    GRAY_500: '#9E9E9E',
    GRAY_600: '#757575',
    GRAY_700: '#616161',
    GRAY_800: '#424242',
    GRAY_900: '#212121',
    WHITE: '#FFFFFF',
    PRIMARY: '#E31D25',
    SECONDARY: '#1D1F20',
    RED: '#E62937',
    ORANGE: '#F2994A',
    YELLOW: '#FFCB00',
    GREEN_1: '#009E2F',
    GREEN_2: '#27AE60',
    GREEN_3: '#6FCF97',
    BLUE_1: '#0079F1',
    BLUE_2: '#2D9CDB',
    BLUE_3: '#56CCF2',
    BLUE_4: '#0079F1',
    PURPLE_1: '#873CBE',
    PURPLE_2: '#BB6BD9',
};
var Tints = {
    red: [
        '#eb5757',
        '#d44e4e',
        '#bc4646',
        '#a53d3d',
        '#8d3434',
        '#762c2c',
        '#5e2323',
        '#461a1a',
        '#2f1111',
        '#170909',
        '#000000',
    ],
    orange: [
        '#f2994a',
        '#da8a43',
        '#c27a3b',
        '#a96b34',
        '#915c2c',
        '#794d25',
        '#613d1e',
        '#492e16',
        '#301f0f',
        '#180f07',
        '#000000',
    ],
    yellow: [
        '#f2c94c',
        '#dab544',
        '#c2a13d',
        '#a98d35',
        '#91792e',
        '#796526',
        '#61501e',
        '#493c17',
        '#30280f',
        '#181408',
        '#000000',
    ],
    green: [
        '#219653',
        '#1e874b',
        '#1a7842',
        '#17693a',
        '#145a32',
        '#114b2a',
        '#0d3c21',
        '#0a2d19',
        '#071e11',
        '#030f08',
        '#000000',
    ],
    blue: [
        '#2f80ed',
        '#2a73d5',
        '#2666be',
        '#215aa6',
        '#1c4d8e',
        '#184077',
        '#13335f',
        '#0e2647',
        '#091a2f',
        '#050d18',
        '#000000',
    ],
    purple: [
        '#9b51e0',
        '#8c49ca',
        '#7c41b3',
        '#6d399d',
        '#5d3186',
        '#4e2970',
        '#3e205a',
        '#2e1843',
        '#1f102d',
        '#0f0816',
        '#000000',
    ],
    black: [
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
    ],
    white: [
        '#ffffff',
        '#e6e6e6',
        '#cccccc',
        '#b3b3b3',
        '#999999',
        '#808080',
        '#666666',
        '#4c4c4c',
        '#333333',
        '#191919',
        '#000000',
    ],
};
var Shades = {
    red: [
        '#eb5757',
        '#ed6868',
        '#ef7979',
        '#f18989',
        '#f39a9a',
        '#f5abab',
        '#f7bcbc',
        '#f9cdcd',
        '#fbdddd',
        '#fdeeee',
        '#ffffff',
    ],
    orange: [
        '#f2994a',
        '#f3a35c',
        '#f5ad6e',
        '#f6b880',
        '#f7c292',
        '#f9cca5',
        '#fad6b7',
        '#fbe0c9',
        '#fcebdb',
        '#fef5ed',
        '#ffffff',
    ],
    yellow: [
        '#f2c94c',
        '#f3ce5e',
        '#f5d470',
        '#f6d982',
        '#f7df94',
        '#f9e4a6',
        '#fae9b7',
        '#fbefc9',
        '#fcf4db',
        '#fefaed',
        '#ffffff',
    ],
    green: [
        '#219653',
        '#37a164',
        '#4dab75',
        '#64b687',
        '#7ac098',
        '#90cba9',
        '#a6d5ba',
        '#bce0cb',
        '#d3eadd',
        '#e9f5ee',
        '#ffffff',
    ],
    blue: [
        '#2f80ed',
        '#448def',
        '#5999f1',
        '#6da6f2',
        '#82b3f4',
        '#97c0f6',
        '#acccf8',
        '#c1d9fa',
        '#d5e6fb',
        '#eaf2fd',
        '#ffffff',
    ],
    purple: [
        '#9b51e0',
        '#a562e3',
        '#af74e6',
        '#b985e9',
        '#c397ec',
        '#cda8f0',
        '#d7b9f3',
        '#e1cbf6',
        '#ebdcf9',
        '#f5eefc',
        '#ffffff',
    ],
    black: [
        '#000000',
        '#1a1a1a',
        '#333333',
        '#4d4d4d',
        '#666666',
        '#808080',
        '#999999',
        '#b3b3b3',
        '#cccccc',
        '#e6e6e6',
        '#ffffff',
    ],
    white: [
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#ffffff',
    ],
};
var SortedShadesList = [
    Colors.RED,
    Colors.ORANGE,
    Colors.YELLOW,
    Colors.GREEN_1,
    Colors.BLUE_1,
    Colors.PURPLE_1,
    Shades.red[1],
    Shades.orange[1],
    Shades.yellow[1],
    Shades.green[1],
    Shades.blue[1],
    Shades.purple[1],
    Tints.red[1],
    Tints.orange[1],
    Tints.yellow[1],
    Tints.green[1],
    Tints.blue[1],
    Tints.purple[1],
    Shades.red[2],
    Shades.orange[2],
    Shades.yellow[2],
    Shades.green[2],
    Shades.blue[2],
    Shades.purple[2],
    Tints.red[2],
    Tints.orange[2],
    Tints.yellow[2],
    Tints.green[2],
    Tints.blue[2],
    Tints.purple[2],
    Shades.red[3],
    Shades.orange[3],
    Shades.yellow[3],
    Shades.green[3],
    Shades.blue[3],
    Shades.purple[3],
    Tints.red[3],
    Tints.orange[3],
    Tints.yellow[3],
    Tints.green[3],
    Tints.blue[3],
    Tints.purple[3],
    Shades.red[4],
    Shades.orange[4],
    Shades.yellow[4],
    Shades.green[4],
    Shades.blue[4],
    Shades.purple[4],
    Tints.red[4],
    Tints.orange[4],
    Tints.yellow[4],
    Tints.green[4],
    Tints.blue[4],
    Tints.purple[4],
    Shades.red[5],
    Shades.orange[5],
    Shades.yellow[5],
    Shades.green[5],
    Shades.blue[5],
    Shades.purple[5],
    Tints.red[5],
    Tints.orange[5],
    Tints.yellow[5],
    Tints.green[5],
    Tints.blue[5],
    Tints.purple[5],
    Shades.red[6],
    Shades.orange[6],
    Shades.yellow[6],
    Shades.green[6],
    Shades.blue[6],
    Shades.purple[6],
    Tints.red[6],
    Tints.orange[6],
    Tints.yellow[6],
    Tints.green[6],
    Tints.blue[6],
    Tints.purple[6],
    Shades.red[7],
    Shades.orange[7],
    Shades.yellow[7],
    Shades.green[7],
    Shades.blue[7],
    Shades.purple[7],
    Tints.red[7],
    Tints.orange[7],
    Tints.yellow[7],
    Tints.green[7],
    Tints.blue[7],
    Tints.purple[7],
    Shades.red[8],
    Shades.orange[8],
    Shades.yellow[8],
    Shades.green[8],
    Shades.blue[8],
    Shades.purple[8],
    Tints.red[8],
    Tints.orange[8],
    Tints.yellow[8],
    Tints.green[8],
    Tints.blue[8],
    Tints.purple[8],
];

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var DisplayFlexRowBase = {
    display: 'flex',
    flexDirection: 'row',
};
var DisplayFlexColumnBase = {
    display: 'flex',
    flexDirection: 'column',
};
var daiThemeOptions = {
    palette: {
        mode: 'light',
        primary: {
            main: Colors.PRIMARY,
            light: Colors.WHITE,
            dark: Colors.BLACK,
            contrastText: Colors.WHITE,
        },
        secondary: {
            main: Colors.SECONDARY,
            light: Colors.GRAY_700,
        },
        grey: {
            50: Colors.GRAY_50,
            100: Colors.GRAY_100,
            200: Colors.GRAY_200,
            300: Colors.GRAY_300,
            400: Colors.GRAY_400,
            500: Colors.GRAY_500,
            600: Colors.GRAY_600,
            700: Colors.GRAY_700,
            800: Colors.GRAY_800,
            900: Colors.GRAY_900,
        },
        background: {
            default: Colors.WHITE,
            paper: Colors.BLACK,
        },
        warning: {
            main: Colors.YELLOW,
        },
    },
    shape: {
        borderRadius: 4,
    },
    typography: {
        h5: {
            fontWeight: 700,
        },
        h6: {
            fontWeight: 500,
            fontSize: '1.25rem',
            lineHeight: 1.6,
            letterSpacing: '0.0075em',
        },
        subtitle1: {
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: 1.75,
            letterSpacing: '0.00938em',
        },
    },
    view: {
        flex: {
            display: 'flex',
        },
        row: {
            std: DisplayFlexRowBase,
            center: __assign$l(__assign$l({}, DisplayFlexRowBase), { justifyContent: 'center', alignItems: 'center' }),
            right: __assign$l(__assign$l({}, DisplayFlexRowBase), { justifyContent: 'right', alignItems: 'center' }),
            left: __assign$l(__assign$l({}, DisplayFlexRowBase), { justifyContent: 'left', alignItems: 'center' }),
            between: __assign$l(__assign$l({}, DisplayFlexRowBase), { justifyContent: 'space-between', alignItems: 'center' }),
        },
        col: {
            std: DisplayFlexColumnBase,
            center: __assign$l(__assign$l({}, DisplayFlexColumnBase), { justifyContent: 'center', alignItems: 'center' }),
            right: __assign$l(__assign$l({}, DisplayFlexColumnBase), { justifyContent: 'center', alignItems: 'right' }),
            left: __assign$l(__assign$l({}, DisplayFlexColumnBase), { justifyContent: 'center', alignItems: 'left' }),
            between: __assign$l(__assign$l({}, DisplayFlexColumnBase), { justifyContent: 'center', alignItems: 'space-between' }),
        },
    },
    navigation: {
        drawer: {
            width: { closed: 56, open: 240 },
        },
    },
    duration: {
        snackbarClose: 6000,
    },
    sizes: {
        filter: {
            width: { xs: 350, sm: 400, md: 400, lg: 500, xl: 500 },
        },
        actionBar: {
            width: {
                xl: 256,
                lg: 256,
                md: 256,
                sm: 256,
                xs: 256,
            },
        },
        table: {
            rowHeight: 30,
            container: {
                modalHeight: {
                    xl: 700,
                    lg: 600,
                    md: 550,
                    sm: 500,
                    xs: 450,
                },
            },
            column: {
                width: {
                    xl: 250,
                    lg: 200,
                    md: 100,
                    sm: 50,
                    xs: 10,
                },
            },
            page: {
                xl: 100,
                lg: 75,
                md: 50,
                sm: 25,
                xs: 10,
            },
        },
        forms: {
            xl: 400,
            lg: 300,
            md: 250,
            sm: 100,
            xs: 50,
        },
        modal: {
            xl: 800,
            lg: 600,
            md: 400,
            sm: 200,
            xs: 100,
        },
        searchSelect: {
            xl: 500,
            lg: 400,
            md: 300,
            sm: 200,
            xs: 100,
        },
        sidebar: {
            width: {
                variant: {
                    lg: {
                        xl: 450,
                        lg: 400,
                        md: 375,
                        sm: 266,
                    },
                    sm: {
                        xl: 350,
                        lg: 300,
                        md: 275,
                        sm: 166,
                    },
                },
            },
        },
        img: {
            xl: 500,
            lg: 300,
            md: 200,
            sm: 100,
            xs: 50,
        },
        skeleton: {
            xl: 50,
            lg: 40,
            md: 20,
            sm: 12,
            xs: 6,
            tiny: 1,
        },
        icon: {
            sm: {
                height: 24,
                width: 24,
            },
            lg: {
                height: 36,
                width: 36,
            },
        },
    },
    components: {
        MuiTableContainer: {
            styleOverrides: {
                root: function (_a) {
                    var _b;
                    var theme = _a.theme, ownerState = _a.ownerState;
                    return (__assign$l({}, (ownerState.className === 'modal'
                        ? {
                            '@media screen and (min-height: 850px)': {
                                height: theme.sizes.table.container.modalHeight.md,
                            },
                            '@media screen and (max-height: 850px)': {
                                height: theme.sizes.table.container.modalHeight.xs,
                            },
                        }
                        : ownerState.className === 'dai-table'
                            ? (_b = {},
                                _b[theme.breakpoints.up('lg')] = {
                                    height: '80vh',
                                },
                                _b[theme.breakpoints.between('sm', 'lg')] = {
                                    height: '78vh',
                                },
                                _b[theme.breakpoints.only('xs')] = {
                                    height: '80vh',
                                },
                                _b) : {})));
                },
            },
        },
        MuiSpeedDialAction: {
            styleOverrides: {
                staticTooltipLabel: function (_a) {
                    var theme = _a.theme;
                    return ({
                        color: theme.palette.primary.light,
                    });
                },
            },
        },
        MuiSpeedDial: {
            defaultProps: {
                direction: 'up',
                FabProps: {
                    sx: function (theme) { return ({
                        color: theme.palette.primary.light,
                    }); },
                },
            },
            styleOverrides: {
                root: {
                    position: 'absolute',
                },
                directionUp: function (_a) {
                    var _b;
                    var theme = _a.theme;
                    return (_b = {},
                        _b[theme.breakpoints.only('xs')] = {
                            bottom: theme.spacing(8),
                            right: theme.spacing(1),
                        },
                        _b[theme.breakpoints.up('sm')] = {
                            bottom: theme.spacing(6),
                            right: theme.spacing(1),
                        },
                        _b);
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: function (_a) {
                    var theme = _a.theme;
                    return ({
                        maxWidth: theme.sizes.modal.xl,
                    });
                },
            },
        },
        MuiFormControl: {
            defaultProps: {
                fullWidth: true,
            },
        },
        MuiInputBase: {
            defaultProps: {
                color: 'secondary',
            },
            styleOverrides: {
                root: function (_a) {
                    var _b;
                    var theme = _a.theme;
                    return (_b = {},
                        _b[theme.breakpoints.between('xs', 'sm')] = {
                            width: '100%',
                        },
                        _b);
                },
            },
        },
        MuiInputLabel: {
            defaultProps: {
                color: 'secondary',
            },
        },
        MuiButton: {
            styleOverrides: {
                root: function (_a) {
                    var theme = _a.theme;
                    return ({
                        ':hover': {
                            backgroundColor: theme.palette.grey['200'],
                            color: theme.palette.secondary.main,
                            '& .MuiSvgIcon-root': {
                                color: theme.palette.secondary.main,
                            },
                        },
                    });
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: function (_a) {
                    var theme = _a.theme;
                    return ({ backgroundColor: theme.palette.primary.light });
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: function (_a) {
                    var theme = _a.theme;
                    return ({
                        color: theme.palette.secondary.main,
                        backgroundColor: theme.palette.primary.light,
                    });
                },
                colorSecondary: function (_a) {
                    var theme = _a.theme;
                    return ({
                        color: theme.palette.primary.light,
                        backgroundColor: theme.palette.secondary.main,
                    });
                },
            },
        },
        MuiSvgIcon: {
            defaultProps: {
                color: 'primary',
            },
            styleOverrides: {
                colorPrimary: function (_a) {
                    var theme = _a.theme;
                    return ({
                        color: theme.palette.secondary.main,
                    });
                },
                colorSecondary: function (_a) {
                    var theme = _a.theme;
                    return ({
                        color: theme.palette.primary.light,
                    });
                },
                colorAction: function (_a) {
                    var theme = _a.theme;
                    return ({
                        color: theme.palette.primary.main,
                    });
                },
            },
        },
        MuiListItemText: {
            defaultProps: {},
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState, theme = _a.theme;
                    return ({
                        color: ownerState.className === 'light'
                            ? theme.palette.primary.light
                            : theme.palette.secondary.main,
                    });
                },
                secondary: function (_a) {
                    var ownerState = _a.ownerState, theme = _a.theme;
                    return ({
                        color: ownerState.className === 'light'
                            ? theme.palette.primary.light
                            : theme.palette.secondary.main,
                    });
                },
            },
        },
        MuiListSubheader: {
            styleOverrides: {
                root: function (_a) {
                    var theme = _a.theme;
                    return ({ backgroundColor: theme.palette.primary.light });
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                groupLabel: function (_a) {
                    var theme = _a.theme;
                    return ({
                        backgroundColor: theme.palette.primary.light,
                    });
                },
            },
        },
        MuiSkeleton: {
            defaultProps: {
                animation: 'wave',
            },
        },
        MuiChip: {
            defaultProps: {
                color: 'primary',
            },
            styleOverrides: {
                colorPrimary: function (_a) {
                    var theme = _a.theme;
                    return ({
                        backgroundColor: theme.palette.grey['100'],
                    });
                },
            },
            variants: [
                {
                    props: { variant: 'bold-light-hoverable' },
                    style: function (_a) {
                        var theme = _a.theme;
                        return ({
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.secondary.main,
                            '&:hover': {
                                backgroundColor: styles.alpha(theme.palette.grey['400'], 0.5),
                            },
                            '& .MuiChip-label': {
                                fontWeight: 'bold',
                            },
                        });
                    },
                },
                {
                    props: { variant: 'bold-light' },
                    style: function (_a) {
                        var theme = _a.theme;
                        return ({
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.secondary.main,
                            '& .MuiChip-label': {
                                fontWeight: 'bold',
                            },
                        });
                    },
                },
                {
                    props: { variant: 'bold-dark-hoverable' },
                    style: function (_a) {
                        var theme = _a.theme;
                        return ({
                            backgroundColor: theme.palette.grey['200'],
                            color: theme.palette.secondary.main,
                            '&:hover': {
                                backgroundColor: styles.alpha(theme.palette.grey['400'], 0.5),
                            },
                            '& .MuiChip-label': {
                                fontWeight: 'bold',
                            },
                        });
                    },
                },
                {
                    props: { variant: 'bold-dark' },
                    style: function (_a) {
                        var theme = _a.theme;
                        return ({
                            backgroundColor: theme.palette.grey['200'],
                            color: theme.palette.secondary.main,
                            '& .MuiChip-label': {
                                fontWeight: 'bold',
                            },
                        });
                    },
                },
            ],
        },
    },
};
var MuiTheme = styles.createTheme(daiThemeOptions);
var styled = createStyled({ defaultTheme: MuiTheme });

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
exports.ThemeVariantsEnum = void 0;
(function (ThemeVariantsEnum) {
    ThemeVariantsEnum["LIGHT"] = "light";
    ThemeVariantsEnum["DARK"] = "dark";
})(exports.ThemeVariantsEnum || (exports.ThemeVariantsEnum = {}));

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var NavigationDrawerContext = React__default["default"].createContext({
    isOpen: false,
    setIsOpen: function (_) { return null; },
});

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FlexBox = {
    Col: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.col.std;
    }),
    ColRight: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.col.right;
    }),
    ColLeft: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.col.left;
    }),
    ColCenter: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.col.center;
    }),
    ColBetween: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.col.between;
    }),
    Row: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.row.std;
    }),
    RowRight: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.row.right;
    }),
    RowLeft: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.row.left;
    }),
    RowCenter: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.row.center;
    }),
    RowBetween: styled(material.Box)(function (_a) {
        var theme = _a.theme;
        return theme.view.row.between;
    }),
};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var LargeCounterContainer = styled(Box__default["default"])(function (_a) {
    var theme = _a.theme;
    return ({
        minWidth: 70,
        height: 70,
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
    });
});
var ActionBar = function (props) {
    var _a = props.count, count = _a === void 0 ? 0 : _a, speedDialIcon = props.speedDialIcon, bulkActions = props.bulkActions;
    var drawerIsOpen = React.useContext(NavigationDrawerContext).isOpen;
    var LargeActionBarContainer = styled(Box__default["default"])(function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = {
                position: 'fixed',
                left: "calc(50% + ".concat(theme.navigation.drawer.width[drawerIsOpen ? 'open' : 'closed'] / 2, "px)"),
                bottom: -40,
                transform: 'translate(-50%, -50%)'
            },
            _b[theme.breakpoints.down(drawerIsOpen ? 1540 : 1350)] = {
                display: 'none',
            },
            _b);
    });
    // @ts-ignore: TODO: Figure out ts error
    var LargeActionsContainer = styled(Box__default["default"])(function (_a) {
        var theme = _a.theme;
        return (__assign$l({ height: 70, backgroundColor: theme.palette.secondary.main, borderTopRightRadius: theme.shape.borderRadius, borderBottomRightRadius: theme.shape.borderRadius, borderTopLeftRadius: count === 0 ? theme.shape.borderRadius : null, borderBottomLeftRadius: count === 0 ? theme.shape.borderRadius : null }, theme.view.row.center));
    });
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__default["default"].createElement(Box__default["default"], { component: "menu", sx: function (theme) {
                var _a;
                return (_a = {},
                    _a[theme.breakpoints.up(drawerIsOpen ? 1540 : 1350)] = {
                        display: 'none',
                    },
                    _a);
            } },
            React__default["default"].createElement(material.SpeedDial, { ariaLabel: "SpeedDial", hidden: false, icon: count ? (React__default["default"].createElement(Typography__default["default"], { variant: "h5" }, count)) : (speedDialIcon), direction: 'up' }, bulkActions
                .filter(function (ba) { return ba.condition && !ba.disabled; })
                .map(function (action) { return (React__default["default"].createElement(material.SpeedDialAction, { key: action.label, onClick: action.onClick, icon: action.icon, tooltipTitle: action.label, tooltipOpen: true })); }))),
        React__default["default"].createElement(LargeActionBarContainer, { component: "menu" },
            React__default["default"].createElement(FlexBox.RowRight, { sx: function (theme) { return ({
                    borderRadius: theme.shape.borderRadius,
                    boxShadow: theme.shadows[13],
                }); } },
                count > 0 ? (React__default["default"].createElement(LargeCounterContainer, null,
                    React__default["default"].createElement(FlexBox.RowCenter, null,
                        React__default["default"].createElement(Typography__default["default"], { sx: function (theme) { return ({
                                fontSize: 48,
                                color: theme.palette.primary.light,
                                fontWeight: theme.typography.fontWeightBold,
                            }); } }, count)))) : null,
                React__default["default"].createElement(LargeActionsContainer, null, bulkActions
                    .filter(function (ba) { return ba.condition; })
                    .map(function (action, index) { return (React__default["default"].createElement(Button__default["default"], { key: index, onClick: action.onClick, disabled: action.disabled, sx: function (theme) { return ({
                        '&:hover': {
                            background: theme.palette.grey['800'],
                        },
                    }); } },
                    React__default["default"].createElement(FlexBox.ColCenter, null,
                        React__default["default"].createElement(material.ListItem, null,
                            React__default["default"].createElement(material.ListItemAvatar, null,
                                React__default["default"].createElement(material.Avatar, { sx: function (theme) { return ({
                                        bgcolor: theme.palette.secondary.light,
                                    }); } }, action.icon)),
                            React__default["default"].createElement(material.ListItemText, { primary: action.label, className: exports.ThemeVariantsEnum.LIGHT }))))); }))))));
};

/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
var CustomIcon = function (props) {
    return (React__default["default"].createElement(Box__default["default"], { sx: __assign$l({ height: 24, verticalAlign: 'middle', cursor: props.onClick ? 'pointer' : null }, props.style), onClick: props.onClick },
        React__default["default"].createElement("img", { src: props.src[0] === '/' ? props.src : "/".concat(props.src) })));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ScreenController = {
    Mobile: styled(material.Box)(function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = {},
            _b[theme.breakpoints.only('xs')] = {
                display: 'block',
            },
            _b[theme.breakpoints.not('xs')] = {
                display: 'none',
            },
            _b);
    }),
    Tablet: styled(material.Box)(function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = {},
            _b[theme.breakpoints.only('md')] = {
                display: 'block',
            },
            _b[theme.breakpoints.not('md')] = {
                display: 'none',
            },
            _b);
    }),
    Desktop: styled(material.Box)(function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = {},
            _b[theme.breakpoints.up('lg')] = {
                display: 'block',
            },
            _b[theme.breakpoints.down('lg')] = {
                display: 'none',
            },
            _b);
    }),
    NonDesktop: styled(material.Box)(function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = {},
            _b[theme.breakpoints.down('lg')] = {
                display: 'block',
            },
            _b[theme.breakpoints.up('lg')] = {
                display: 'none',
            },
            _b);
    }),
    LargeScreen: styled(material.Box)(function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = {},
            _b[theme.breakpoints.only('xs')] = {
                display: 'none',
            },
            _b[theme.breakpoints.not('xs')] = {
                display: 'block',
            },
            _b);
    }),
    None: styled(material.Box)(function () { return ({
        display: 'none',
    }); }),
    All: styled(material.Box)(function () { return ({
        display: 'block',
    }); }),
};

/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
var Search = styles.styled(Box__default["default"])(function (_a) {
    var _b;
    var theme = _a.theme; _a.sx;
    return (_b = {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: styles.alpha(theme.palette.grey['200'], 0.75),
            '&:hover': {
                backgroundColor: styles.alpha(theme.palette.grey['200'], 1),
            },
            marginLeft: 0,
            width: '100%'
        },
        _b[theme.breakpoints.up('sm')] = {
            width: 'auto',
        },
        _b);
});
var SearchIconWrapper = styles.styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    });
});
var StyledInputBase = styles.styled(InputBase__default["default"])(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        color: 'inherit',
        '& .MuiInputBase-input': (_b = {
                padding: theme.spacing(1, 1, 1, 0),
                // vertical padding + font size from searchIcon
                paddingLeft: "calc(1em + ".concat(theme.spacing(4), ")"),
                transition: theme.transitions.create('width'),
                width: '100%'
            },
            _b[theme.breakpoints.up('sm')] = {
                width: '12ch',
                '&:focus': {
                    width: '20ch',
                },
            },
            _b),
    });
});
var SearchBar = function (props) {
    var useResponsive = props.useResponsive, value = props.value, onChange = props.onChange, _a = props.placeholder, placeholder = _a === void 0 ? 'Search...' : _a;
    var _b = React__namespace.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        return setAnchorEl(event.currentTarget);
    };
    var handleClose = function () { return setAnchorEl(null); };
    var open = Boolean(anchorEl);
    var id = open ? 'search-popover' : undefined;
    var StandardSearchBar = (React__namespace.createElement(Search, { sx: {} },
        React__namespace.createElement(SearchIconWrapper, null,
            React__namespace.createElement(SearchIcon__default["default"], null)),
        React__namespace.createElement(StyledInputBase, { value: value, onChange: function (event) { return onChange && onChange(event.target.value); }, placeholder: placeholder, inputProps: { 'aria-label': 'search' } })));
    var MobileContainer = ScreenController[useResponsive ? 'Mobile' : 'None'];
    var LargeScreenContainer = ScreenController[useResponsive ? 'LargeScreen' : 'All'];
    return (React__namespace.createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__namespace.createElement(LargeScreenContainer, null, StandardSearchBar),
        React__namespace.createElement(MobileContainer, null,
            React__namespace.createElement(IconButton__default["default"], { "aria-describedby": id, onClick: handleClick },
                React__namespace.createElement(SearchIcon__default["default"], null)),
            React__namespace.createElement(Popover__default["default"], { PaperProps: { sx: function (theme) { return ({ bgcolor: theme.palette.grey['200'] }); } }, id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, StandardSearchBar))));
};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
// TODO: Change back to 'settings.svg'. Add modal that shows logout button.
var Layout = function (props) {
    props.navItems; props.user; props.logout; props.children; props.fullNavBarOpen; props.setFullNavBarOpen;
    return React__default["default"].createElement("div", null);
    // return (
    //   <Grid
    //     gap={0}
    //     columns={
    //       setFullNavBarOpen === undefined || fullNavBarOpen
    //         ? '256px auto'
    //         : '72px auto'
    //     }
    //     sx={{ height: '100vh', width: '100%' }}
    //   >
    //     <NavBar
    //       logoUrl={
    //         setFullNavBarOpen === undefined || fullNavBarOpen
    //           ? '/logo-white.svg'
    //           : '/logo-white-mini.svg'
    //       }
    //       logoStyle={
    //         setFullNavBarOpen === undefined || fullNavBarOpen
    //           ? {}
    //           : {
    //               height: 28,
    //               width: 28,
    //             }
    //       }
    //       FooterComponent={
    //         <Flex>
    //           {user ? (
    //             <Flex
    //               sx={{
    //                 flexDirection: 'column',
    //               }}
    //             >
    //               {setFullNavBarOpen !== undefined && (
    //                 <Flex
    //                   sx={{
    //                     justifyContent: 'center',
    //                     marginLeft: fullNavBarOpen ? 200 : null,
    //                   }}
    //                 >
    //                   <Flex
    //                     sx={{
    //                       height: 30,
    //                       width: 30,
    //                       backgroundColor: '#353636',
    //                       borderRadius: '50%',
    //                       display: 'flex',
    //                       alignItems: 'center',
    //                       justifyContent: 'center',
    //                       color: Colors.WHITE,
    //                       alignContent: 'center',
    //                     }}
    //                     onClick={() => setFullNavBarOpen(!fullNavBarOpen)}
    //                   >
    //                     {fullNavBarOpen ? <ChevronLeft /> : <ChevronRight />}
    //                   </Flex>
    //                 </Flex>
    //               )}
    //               <Flex
    //                 sx={{
    //                   flexDirection: 'row',
    //                   padding: `${theme.space.melarge}px`,
    //                 }}
    //               >
    //                 <img
    //                   src={'/profile.svg'}
    //                   alt="DeliciousAI Logo"
    //                   sx={{
    //                     height: '45px',
    //                     width: '45px',
    //                     verticalAlign: 'middle',
    //                     borderRadius: '50%',
    //                   }}
    //                 />
    //                 <Flex
    //                   style={{
    //                     marginLeft: theme.space.shmedium,
    //                     flexDirection: 'column',
    //                   }}
    //                 >
    //                   {setFullNavBarOpen === undefined ||
    //                     (fullNavBarOpen && (
    //                       <Text
    //                         sx={{
    //                           fontWeight: theme.fontWeights.heading,
    //                           fontSize: theme.fontSizes.mediumBody,
    //                           color: 'white',
    //                           height: '100%',
    //                           alignItems: 'center',
    //                           alignContent: 'center',
    //                         }}
    //                       >
    //                         {`${user?.firstName} ${user?.lastName}`}
    //                       </Text>
    //                     ))}
    //                   <Text
    //                     sx={{
    //                       fontSize: theme.fontSizes.body,
    //                       color: 'white',
    //                       height: '100%',
    //                       alignItems: 'center',
    //                       alignContent: 'center',
    //                     }}
    //                   >
    //                     {`${user?.groups[0] ? user?.groups[0].toString() : ''}`}
    //                   </Text>
    //                 </Flex>
    //               </Flex>
    //               <Flex
    //                 sx={{
    //                   padding: theme.space.melarge,
    //                   paddingLeft: theme.space.large,
    //                   paddingTop: '0px',
    //                   justifyContent: 'flex-begin',
    //                   cursor: 'pointer',
    //                 }}
    //                 onClick={logout}
    //               >
    //                 <CustomIcon src={'/log-out-white.svg'} />
    //                 <Text
    //                   sx={{
    //                     fontWeight: theme.fontWeights.heading,
    //                     fontSize: theme.fontSizes.mediumBody,
    //                     color: 'white',
    //                     height: '100%',
    //                     alignItems: 'center',
    //                     alignContent: 'center',
    //                     textAlign: 'right',
    //                     marginLeft: theme.space.medium,
    //                   }}
    //                 >
    //                   {setFullNavBarOpen === undefined || fullNavBarOpen
    //                     ? 'Logout'
    //                     : ''}
    //                 </Text>
    //               </Flex>
    //             </Flex>
    //           ) : null}
    //         </Flex>
    //       }
    //     >
    //       {navItems}
    //     </NavBar>
    //     <Box
    //       sx={{
    //         height: '100vh',
    //         width: '100%',
    //         flex: 1,
    //         backgroundColor: theme.colors.primaryBg,
    //       }}
    //     >
    //       {children}
    //     </Box>
    //   </Grid>
    // )
};

/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ElevationScroll = function (props) {
    var children = props.children;
    var trigger = useScrollTrigger__default["default"]({
        disableHysteresis: true,
        threshold: 0,
    });
    return React__default["default"].cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
};
var PageTitle = function (props) {
    var title = props.title, RightComponent = props.RightComponent, _a = props.disableTypography, disableTypography = _a === void 0 ? false : _a;
    var TitleContainer = disableTypography ? FlexBox.Row : Typography__default["default"];
    var TitleProps = disableTypography ? { flex: 1 } : { variant: 'h5' };
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__default["default"].createElement(ElevationScroll, null,
            React__default["default"].createElement(AppBar__default["default"], { position: "sticky" },
                React__default["default"].createElement(ScreenController.LargeScreen, null,
                    React__default["default"].createElement(FlexBox.RowBetween, { flexGrow: 1, sx: function (theme) { return (__assign$l(__assign$l({}, theme.mixins.toolbar), { p: theme.spacing(0, 2) })); } },
                        React__default["default"].createElement(TitleContainer, __assign$l({}, TitleProps), title),
                        RightComponent),
                    React__default["default"].createElement(Divider__default["default"], { color: MuiTheme.palette.grey['200'] }))))));
};

/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var GenericUICard = function (props) {
    return (React__default["default"].createElement(material.Card, { ref: props.ref, onClick: props.onClick, sx: {
            backgroundColor: props.focused ? 'mainBg' : null,
            borderLeft: props.active && props.activeColor
                ? "solid 8px ".concat(props.activeColor)
                : null,
            alignItems: 'center',
            padding: 3,
            height: props.height ? props.height : undefined,
            flexGrow: 1,
            justifyContent: 'space-between',
            // ...props.style,
        } },
        React__default["default"].createElement(FlexBox.Row, { sx: { justifyContent: 'space-between' } },
            React__default["default"].createElement(FlexBox.Row, null,
                props.LeftComponent,
                props.Body),
            props.RightComponent)));
};

/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var GenericImageCard = function (props) {
    var imageSource = props.imageSource, imageAlt = props.imageAlt, joinImageAndBody = props.joinImageAndBody, flexStyle = props.flexStyle, joinedStyle = props.joinedStyle, imageStyle = props.imageStyle, Body = props.Body, rest = __rest$c(props, ["imageSource", "imageAlt", "joinImageAndBody", "flexStyle", "joinedStyle", "imageStyle", "Body"]);
    return (React__default["default"].createElement(FlexBox.Col, { sx: flexStyle }, joinImageAndBody ? (React__default["default"].createElement(GenericUICard, __assign$l({ LeftComponent: React__default["default"].createElement(FlexBox.Col, { sx: joinedStyle },
            React__default["default"].createElement("img", { src: imageSource, alt: imageAlt, style: imageStyle }),
            Body) }, rest))) : (React__default["default"].createElement(GenericUICard, __assign$l({ LeftComponent: React__default["default"].createElement("img", { src: imageSource, alt: imageAlt, style: imageStyle }), Body: Body }, rest)))));
};

/**
 * Copyright © 2021 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
/**
 * Hook that alerts clicks outside of the passed ref
 */
var useOutsideAlerter = function (ref, handler) {
    React.useEffect(function () {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, handler]);
};

/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var SelectInputWrapper = function (props) {
    props.inputValue; props.label; props.placeholder; props.items; props.onItemSelected; props.searchPlaceholder; props.setNewItemToAdd; props.setShowModal; props.loading; props.searchQuery; props.setSearchQuery; props.multipleSelect; props.onClear; props.shortDesc;
    var _b = React.useState(false); _b[0]; var setShowDropdown = _b[1];
    var _c = React.useState([]); _c[0]; _c[1];
    var wrapperRef = React.useRef(null);
    React.useRef(null);
    useOutsideAlerter(wrapperRef, function () {
        setShowDropdown(false);
    });
    return React__default["default"].createElement("div", null);
    //   return (
    //     <Flex
    //       ref={wrapperRef}
    //       sx={{
    //         flexDirection: 'column',
    //         flexGrow: 1,
    //         position: 'relative',
    //         ...sx,
    //       }}
    //     >
    //       <Label
    //         htmlFor="name"
    //         sx={{
    //           fontSize: theme.fontSizes.smallBody,
    //           color: Colors.BLACK,
    //           opacity: 0.8,
    //           margin: '20px 0px 8px',
    //         }}
    //       >
    //         {label}
    //       </Label>
    //       <Flex
    //         sx={{
    //           ...styles.container,
    //         }}
    //       >
    //         <Input
    //           value={inputValue}
    //           onChange={event => {
    //             if (setSearchQuery) {
    //               const { value } = event.target
    //               handleTypingInInputBox(value)
    //             } else {
    //               setShowDropdown(true)
    //             }
    //           }}
    //           placeholder={placeholder}
    //           sx={styles.inputBar}
    //         />
    //         <CustomIcon
    //           src={showDropdown ? '/chevron-up.svg' : '/chevron-down.svg'}
    //           style={{
    //             marginRight: theme.space.large,
    //             right: 0,
    //             position: 'absolute',
    //             alignItems: 'center',
    //           }}
    //           onClick={() => {
    //             setShowDropdown(!showDropdown)
    //           }}
    //         />
    //       </Flex>
    //       {showDropdown && (
    //         <Flex
    //           sx={{
    //             flexDirection: 'column',
    //             ...styles.dropdownContainer,
    //           }}
    //         >
    //           {setSearchQuery && searchPlaceholder && (
    //             <Flex
    //               sx={{
    //                 flexDirection: 'row',
    //                 width: '100%',
    //                 marginBottom: '8px',
    //               }}
    //             >
    //               <SearchBar
    //                 onChange={value => setSearchQuery(value)}
    //                 inputRef={searchBarRef}
    //               />
    //               {onClear ? (
    //                 <Button
    //                   sx={styles.clearButton}
    //                   onClick={() => {
    //                     setSelectedItems([])
    //                     onClear()
    //                     setShowDropdown(false)
    //                   }}
    //                 >
    //                   Clear
    //                 </Button>
    //               ) : null}
    //               <Button
    //                 sx={styles.dropdownButton}
    //                 disabled={searchQuery === ''}
    //                 onClick={() => {
    //                   if (setNewItemToAdd && !!searchQuery) {
    //                     setNewItemToAdd(searchQuery)
    //                   }
    //                   setShowDropdown(false)
    //                 }}
    //               >
    //                 <CustomIcon src={'plus.svg'} style={{ width: '16px' }} />
    //               </Button>
    //             </Flex>
    //           )}
    //           {loading ? (
    //             <Flex
    //               sx={{
    //                 flexDirection: 'column',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //                 margin: 40,
    //               }}
    //             >
    //               <Spinner />
    //             </Flex>
    //           ) : (
    //             <ItemList
    //               items={items}
    //               shortDesc={shortDesc}
    //               searchTerm={searchQuery || ''}
    //               onItemSelected={onItemSelected}
    //               selectedItems={selectedItems}
    //               setSelectedItems={setSelectedItems}
    //               multipleSelect={multipleSelect}
    //               onClose={setShowDropdown}
    //               setNewItemToAdd={setNewItemToAdd}
    //               setShowModal={show => {
    //                 setShowDropdown(false)
    //                 if (setShowModal) {
    //                   setShowModal(show)
    //                 }
    //                 if (setSearchQuery) {
    //                   setSearchQuery('')
    //                 }
    //               }}
    //             />
    //           )}
    //         </Flex>
    //       )}
    //     </Flex>
    //   )
    // }
    // const createStyles = () => {
    //   return {
    //     container: {
    //       alignItems: 'center',
    //       flexGrow: 1,
    //       zIndex: 0,
    //       position: 'relative' as 'relative',
    //       backgroundColor: Colors.GRAY_9,
    //       borderRadius: theme.radii.box,
    //     },
    //     inputBar: {
    //       borderRadius: 10,
    //       backgroundColor: Colors.GRAY_6,
    //       fontFamily:
    //         '"Roboto", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    //       padding: 10,
    //       border: 'none',
    //       flexGrow: 1,
    //       paddingLeft: 20,
    //     },
    //     dropdownContainer: {
    //       zIndex: 10,
    //       backgroundColor: Colors.WHITE,
    //       marginLeft: 16,
    //       paddingTop: 10,
    //       maxHeight: 400,
    //       borderRadius: 10,
    //       position: 'absolute' as 'absolute',
    //       bottom: '34px',
    //       width: 'calc(100% - 16px)',
    //       boxShadow: theme.shadows.productItem,
    //     },
    //     clearButton: {
    //       color: '#757575',
    //       fontSize: 16,
    //       fontWeight: 600,
    //       lineHeight: '20px',
    //       paddingLeft: 16,
    //       paddingRight: 16,
    //       height: '44px',
    //       borderRadius: '8px',
    //       display: 'flex',
    //       alignItems: 'center',
    //       justifyContent: 'center',
    //       padding: 10,
    //       cursor: 'pointer',
    //       backgroundColor: '#E0E0E0',
    //       marginRight: '8px',
    //     },
    //     dropdownButton: {
    //       color: Colors.GRAY_5,
    //       fontSize: 16,
    //       fontWeight: 600,
    //       lineHeight: '20px',
    //       paddingLeft: 16,
    //       paddingRight: 16,
    //       height: '44px',
    //       borderRadius: '8px',
    //       display: 'flex',
    //       alignItems: 'center',
    //       justifyContent: 'center',
    //       padding: 10,
    //       cursor: 'pointer',
    //       width: '44px',
    //       backgroundColor: 'border',
    //       marginRight: '8px',
    //     },
    //   }
};

/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ItemList = function (props) {
    props.items; props.searchTerm; props.onItemSelected; props.selectedItems; props.setSelectedItems; props.setNewItemToAdd; props.setShowModal; props.onClose; props.multipleSelect; props.shortDesc;
    return React__default["default"].createElement("div", null);
    // return (
    //   <Flex
    //     sx={{
    //       flexDirection: 'column',
    //       overflowY: 'scroll',
    //     }}
    //   >
    //     {items.length > 0 ? (
    //       items.map((item, index) => {
    //         return (
    //           <Button
    //             key={item}
    //             sx={{
    //               flex: `1 0 ${theme.sizes.listItem}px`,
    //               ...(selectedItems.find(s => s === item)
    //                 ? theme.buttons.dropdownPrimary
    //                 : theme.buttons.dropdownSecondary),
    //               '&:hover': {
    //                 backgroundColor: theme.colors.secondaryBg,
    //                 ...(item == items[items.length - 1]
    //                   ? {
    //                       borderBottomLeftRadius: theme.radii.button,
    //                       borderBottomRightRadius: theme.radii.button,
    //                     }
    //                   : null),
    //                 cursor: 'pointer',
    //               },
    //             }}
    //             onClick={() => {
    //               if (!selectedItems.find(s => s === item)) {
    //                 if (onClose && !multipleSelect) {
    //                   onClose(false)
    //                   setSelectedItems([item])
    //                 } else {
    //                   setSelectedItems([...selectedItems, item])
    //                 }
    //                 onItemSelected(item, true)
    //               } else {
    //                 if (onClose && !multipleSelect) {
    //                   onClose(false)
    //                   setSelectedItems([item])
    //                 } else {
    //                   setSelectedItems(
    //                     selectedItems.filter((s: string) => s !== item),
    //                   )
    //                 }
    //                 onItemSelected(item, false)
    //               }
    //             }}
    //           >
    //             {`${display(item)} ${shortDesc ? shortDesc[index] : ''}`}
    //           </Button>
    //         )
    //       })
    //     ) : setNewItemToAdd && setShowModal && searchTerm !== '' ? (
    //       <Flex
    //         sx={{
    //           flexDirection: 'column',
    //           justifyContent: 'center',
    //           margin: `${theme.space.large}px`,
    //         }}
    //       >
    //         <Text sx={{ marginX: `30px` }}>
    //           We couldn't find that one. Want to add it?
    //         </Text>
    //         <Button
    //           sx={{
    //             marginX: 30,
    //             backgroundColor: Colors.GRAY_7,
    //             color: Colors.GRAY_2,
    //           }}
    //           onClick={() => {
    //             setShowModal(true)
    //             setNewItemToAdd(searchTerm)
    //           }}
    //         >
    //           Add it
    //         </Button>
    //       </Flex>
    //     ) : (
    //       <Text sx={{ textAlign: 'center', margin: `${theme.space.large}px` }}>
    //         {searchTerm !== ''
    //           ? "We couldn't find that one. Try a new search."
    //           : 'Enter a term to search.'}
    //       </Text>
    //     )}
    //   </Flex>
    // )
};

/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
var TextInputWrapper = function (props) {
    props.inputValue; props.setInputValue; props.label; props.placeholder; props.inputType;
    return React__default["default"].createElement("div", null);
    // return (
    //   <Flex sx={{ flexGrow: 1, flexDirection: 'column', ...sx }}>
    //     <Label
    //       htmlFor="name"
    //       sx={{
    //         fontSize: `${theme.fontSizes.smallBody}px`,
    //         marginBottom: `${theme.space.shmedium}px`,
    //         marginTop: `${theme.space.large}px`,
    //         color: 'black',
    //         opacity: 0.8,
    //       }}
    //     >
    //       {label}
    //     </Label>
    //     <Input
    //       type={inputType}
    //       value={inputValue}
    //       placeholder={placeholder}
    //       onChange={e => setInputValue(e.target.value)}
    //       sx={{
    //         borderRadius: 10,
    //         backgroundColor: Colors.GRAY_6,
    //         fontFamily:
    //           '"Roboto", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    //         padding: 10,
    //         border: 'none',
    //         flexGrow: 1,
    //         paddingLeft: 20,
    //       }}
    //     />
    //   </Flex>
    // )
};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Clark Sandholtz <clark.sandholtz@deliciousai.com>
 */
var transformSingleProductImage = function (image) { return ({
    id: image.id,
    url: image.url,
}); };

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Clark Sandholtz <clarksandholtz@gmail.com>
 */
var isProductType = function (toBeDetermined) {
    return !!toBeDetermined.name;
};
var transformSuggestedProducts = function (suggestedProducts) {
    return (suggestedProducts === null || suggestedProducts === void 0 ? void 0 : suggestedProducts.map(function (suggestedProduct) { return ({
        id: suggestedProduct.id,
        upcA: suggestedProduct.upcA,
        name: suggestedProduct.name,
        created: suggestedProduct.created,
        modified: suggestedProduct.modified,
        brand: suggestedProduct.brand && {
            id: suggestedProduct.brand.id,
            name: suggestedProduct.brand.name,
        },
        marketingImageUrl: suggestedProduct.marketingImageUrl,
        images: suggestedProduct.images.map(transformSingleProductImage),
        packaging: suggestedProduct.packaging
            ? __assign$l({}, suggestedProduct.packaging) : null,
        verified: !!suggestedProduct.verifiedBy,
    }); })) || null;
};
var transformProduct = function (products) {
    return ((products === null || products === void 0 ? void 0 : products.map(function (p) {
        return getProduct(p);
    })) || null);
};
var getElDoradoProduct = function (p) {
    return {
        id: p.id,
        description: '',
        upcA: '',
        marketingImageUrl: p.marketingImageUrl || '',
    };
};
var getProduct = function (p, healthScore) {
    return {
        id: p.id,
        upcA: p.upcA,
        name: p.name,
        brand: p.brand
            ? {
                id: p.brand.id,
                name: p.brand.name,
            }
            : null,
        category: p.companyCategory
            ? {
                category: p.companyCategory.category,
                id: p.companyCategory.id,
            }
            : undefined,
        marketingImageUrl: p.marketingImageUrl,
        images: [],
        packaging: p.packaging
            ? {
                size: p.packaging.size,
                quantity: p.packaging.quantity,
                container: p.packaging.container,
                unit: p.packaging.unit,
            }
            : null,
        flavors: p.flavors.filter(function (f) { return f.displayFlavor; }).map(function (f) { return f.flavor; }),
        healthScore: Number(healthScore === null || healthScore === void 0 ? void 0 : healthScore.toFixed(2)),
        verified: !!p.verifiedBy,
    };
};
var transformProductInfoErrors = function (products) {
    return ((products === null || products === void 0 ? void 0 : products.map(function (p) {
        return getProductWithInfoErrors(p);
    })) || null);
};
var getProductWithInfoErrors = function (p, healthScore) {
    var _a, _b;
    return {
        id: p.id,
        upcA: p.upcA,
        name: p.name,
        created: p.created,
        modified: p.modified,
        lastInAudit: p.lastInAudit,
        source: p.source,
        lastBarcodeScan: p.lastTimeBarcodeScanned,
        brand: p.brand
            ? {
                id: p.brand.id,
                name: p.brand.name,
            }
            : null,
        flagged: p.flagged
            ? {
                reason: p.flagged.reason,
                date: p.flagged.date,
                flaggedBy: p.flagged.flaggedBy
                    ? {
                        uuid: p.flagged.flaggedBy.uuid,
                        id: p.flagged.flaggedBy.id,
                        email: p.flagged.flaggedBy.email,
                        firstName: p.flagged.flaggedBy.firstName,
                        lastName: p.flagged.flaggedBy.lastName,
                    }
                    : null,
                levelRaisedBy: p.flagged.levelRaisedBy
                    ? {
                        username: p.flagged.levelRaisedBy.username,
                        firstName: p.flagged.levelRaisedBy.firstName,
                        lastName: p.flagged.levelRaisedBy.lastName,
                        email: p.flagged.levelRaisedBy.email,
                    }
                    : null,
            }
            : null,
        category: p.companyCategory
            ? {
                category: p.companyCategory.category,
                id: p.companyCategory.id,
            }
            : undefined,
        marketingImageUrl: p.marketingImageUrl,
        images: [],
        packaging: p.packaging
            ? {
                size: p.packaging.size,
                quantity: p.packaging.quantity,
                container: (_a = p.packaging.container) === null || _a === void 0 ? void 0 : _a.replace('_', ' '),
                unit: p.packaging.unit,
            }
            : null,
        flavors: p.flavors.map(function (f) { return f.flavor; }),
        healthScore: Number(healthScore === null || healthScore === void 0 ? void 0 : healthScore.toFixed(2)),
        verified: !!p.verifiedBy,
        verifiedByName: p.verifiedByUser
            ? "".concat(p.verifiedByUser.firstName, " ").concat(p.verifiedByUser.lastName)
            : '',
        manufacturer: (_b = p.manufacturer) === null || _b === void 0 ? void 0 : _b.name,
    };
};
var UNIDENTIFIED_PRODUCT = {
    id: '000000000000',
    upcA: '000000000000',
    name: 'Unidentified Product',
    created: null,
    modified: null,
    brand: null,
    marketingImageUrl: null,
    primaryMarketingImage: undefined,
    images: [],
    packaging: null,
    flagged: undefined,
    flavors: [],
    verified: false,
};

var lib$4 = {};

var fragments$1 = {};

var AdminAuditFragment = {};

var genericMessage = "Invariant Violation";
var _a$3 = Object.setPrototypeOf, setPrototypeOf = _a$3 === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a$3;
var InvariantError = /** @class */ (function (_super) {
    __extends(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant$1(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant$1 || (invariant$1 = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}

function maybe$2(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}

var global$1 = (maybe$2(function () { return globalThis; }) ||
    maybe$2(function () { return window; }) ||
    maybe$2(function () { return self; }) ||
    maybe$2(function () { return global; }) || maybe$2(function () { return maybe$2.constructor("return this")(); }));

var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
    try {
        return Boolean(__DEV__);
    }
    catch (_a) {
        Object.defineProperty(global$1, GLOBAL_KEY, {
            value: maybe$2(function () { return process.env.NODE_ENV; }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true,
        });
        return global$1[GLOBAL_KEY];
    }
}
var DEV = getDEV();

function maybe$1(thunk) {
  try { return thunk() } catch (_) {}
}

var safeGlobal = (
  maybe$1(function() { return globalThis }) ||
  maybe$1(function() { return window }) ||
  maybe$1(function() { return self }) ||
  maybe$1(function() { return global }) ||
  // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  maybe$1(function() { return maybe$1.constructor("return this")() })
);

var needToRemove = false;

function install() {
  if (safeGlobal &&
      !maybe$1(function() { return process.env.NODE_ENV }) &&
      !maybe$1(function() { return process })) {
    Object.defineProperty(safeGlobal, "process", {
      value: {
        env: {
          // This default needs to be "production" instead of "development", to
          // avoid the problem https://github.com/graphql/graphql-js/pull/2894
          // will eventually solve, once merged and released.
          NODE_ENV: "production",
        },
      },
      // Let anyone else change global.process as they see fit, but hide it from
      // Object.keys(global) enumeration.
      configurable: true,
      enumerable: false,
      writable: true,
    });
    needToRemove = true;
  }
}

// Call install() at least once, when this module is imported.
install();

function remove() {
  if (needToRemove) {
    delete safeGlobal.process;
    needToRemove = false;
  }
}

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof$3(value) == 'object' && value !== null;
}

// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator

var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    _ref[0];
        var line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message);
    _this.name = 'GraphQLError';
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.

    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined);
    var nodeLocations = [];

    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;

      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;

      if (loc != null) {
        nodeLocations.push(loc);
      }
    }

    nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.

    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function (loc) {
      return loc.start;
    });
    _this.locations = positions && source ? positions.map(function (pos) {
      return getLocation(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function (loc) {
      return getLocation(loc.source, loc.start);
    });
    _this.path = path !== null && path !== void 0 ? path : undefined;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;

    if (extensions == null && isObjectLike(originalExtensions)) {
      _this.extensions = _objectSpread$1({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    } // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
    // This ensures that the simplest possible GraphQL service adheres to the spec.


    Object.defineProperties(_assertThisInitialized(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass$2(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var nodejsCustomInspectSymbol$1 = nodejsCustomInspectSymbol;

/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || invariant(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (nodejsCustomInspectSymbol$1) {
    classObject.prototype[nodejsCustomInspectSymbol$1] = fn;
  }
}

/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }
var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof$1(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(nodejsCustomInspectSymbol$1)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var instanceOf = process.env.NODE_ENV === 'production' ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  if (value instanceof constructor) {
    return true;
  }

  if (_typeof(value) === 'object' && value !== null) {
    var _value$constructor;

    var className = constructor.prototype[Symbol.toStringTag];
    var valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
    Symbol.toStringTag in value ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;

    if (className === valueClassName) {
      var stringifiedValue = inspect(value);
      throw new Error("Cannot use ".concat(className, " \"").concat(stringifiedValue, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
    }
  }

  return false;
};

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || devAssert(0, "Body must be a string. Received: ".concat(inspect(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || devAssert(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  _createClass$1(Source, [{
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return instanceOf(source, Source);
}

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new Token(TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new Token(TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new Token(TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new Token(TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new Token(TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new Token(TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new Token(TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new Token(TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new Token(TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new Token(TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new Token(TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new Token(TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new Token(TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new Token(TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw syntaxError(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new Token(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Token(TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new Token(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new Token(TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new Token(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, dedentBlockStringValue(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Token(TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse$1(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(TokenKind.NAME);
    return {
      kind: Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: Kind.DOCUMENT,
      definitions: this.many(TokenKind.SOF, this.parseDefinition, TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(TokenKind.BRACE_L)) {
      return {
        kind: Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: Kind.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseVariableDefinition, TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return {
      kind: Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: Kind.SELECTION_SET,
      selections: this.many(TokenKind.BRACE_L, this.parseSelection, TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: Kind.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return {
      kind: Kind.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case TokenKind.INT:
        this._lexer.advance();

        return {
          kind: Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: Kind.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: Kind.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: Kind.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: Kind.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return {
      kind: Kind.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = {
        kind: Kind.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(TokenKind.BANG)) {
      return {
        kind: Kind.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
    return {
      kind: Kind.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(TokenKind.AMP) || this.peek(TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(TokenKind.BRACE_L) && this._lexer.lookahead().kind === TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(TokenKind.BRACE_L, this.parseFieldDefinition, TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseInputValueDef, TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: Kind.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS) ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseEnumValueDefinition, TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseInputValueDef, TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: Kind.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new Location(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? "\"".concat(kind, "\"") : kind;
}

/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error("Invalid AST Node: ".concat(inspect(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap$1('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap$1(' = ', defaultValue) + wrap$1(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap$1('', alias, ': ') + name;
    var argsLine = prefix + wrap$1('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap$1('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap$1(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap$1('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap$1('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap$1('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap$1('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap$1('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap$1('(\n', indent(join(args, '\n')), '\n)') : wrap$1('(', join(args, ', '), ')')) + ': ' + type + wrap$1(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap$1('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap$1('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap$1('(\n', indent(join(args, '\n')), '\n)') : wrap$1('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap$1('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap$1('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap$1('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap$1(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap$1('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}

function removeTemporaryGlobals() {
    return typeof Source === "function" ? remove() : remove();
}

function checkDEV() {
    __DEV__ ? invariant$1("boolean" === typeof DEV, DEV) : invariant$1("boolean" === typeof DEV, 38);
}
removeTemporaryGlobals();
checkDEV();

function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? invariant$1(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : invariant$1(evaledValue !== void 0, 39);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    visit(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) &&
                (!all || !nameSet.size)) {
                return BREAK;
            }
        },
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(['client', 'export'], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            __DEV__ ? invariant$1(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : invariant$1(directiveArguments && directiveArguments.length === 1, 40);
            var ifArgument = directiveArguments[0];
            __DEV__ ? invariant$1(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : invariant$1(ifArgument.name && ifArgument.name.value === 'if', 41);
            var ifValue = ifArgument.value;
            __DEV__ ? invariant$1(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : invariant$1(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 42);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}

function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw __DEV__ ? new InvariantError("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new InvariantError(43);
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? invariant$1(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : invariant$1(fragments.length === 1, 44);
        actualFragmentName = fragments[0].name.value;
    }
    var query = __assign$l(__assign$l({}, document), { definitions: __spreadArray$5([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread': {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? invariant$1(fragment, "No fragment named ".concat(fragmentName)) : invariant$1(fragment, 45);
            return fragment || null;
        }
        default:
            return null;
    }
}

function isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function isDocumentNode(value) {
    return (isNonNullObject(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw __DEV__ ? new InvariantError("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.') : new InvariantError(54);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat(stringify$1(filteredArgs_1), ")");
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = stringify$1(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(stringify$1(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = stringify$1;
        stringify$1 = s;
        return previous;
    },
});
var stringify$1 = function defaultStringify(value) {
    return JSON.stringify(value, stringifyReplacer);
};
function stringifyReplacer(_key, value) {
    if (isNonNullObject(value) && !Array.isArray(value)) {
        value = Object.keys(value).sort().reduce(function (copy, key) {
            copy[key] = value[key];
            return copy;
        }, {});
    }
    return value;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') {
        return result.__typename;
    }
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (isField(selection)) {
            if (selection.name.value === '__typename') {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else {
            var typename = getTypenameFromResult(result, getFragmentFromSelection(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') {
                return typename;
            }
        }
    }
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}

function checkDocument(doc) {
    __DEV__ ? invariant$1(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : invariant$1(doc && doc.kind === 'Document', 46);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw __DEV__ ? new InvariantError("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new InvariantError(47);
        }
        return definition;
    });
    __DEV__ ? invariant$1(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : invariant$1(operations.length <= 1, 48);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    __DEV__ ? invariant$1(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : invariant$1(queryDef && queryDef.operation === 'query', 49);
    return queryDef;
}
function getFragmentDefinition(doc) {
    __DEV__ ? invariant$1(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : invariant$1(doc.kind === 'Document', 50);
    __DEV__ ? invariant$1(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : invariant$1(doc.definitions.length <= 1, 51);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? invariant$1(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : invariant$1(fragmentDef.kind === 'FragmentDefinition', 52);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw __DEV__ ? new InvariantError('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new InvariantError(53);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                valueToObjectRepresentation(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}

function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}

var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function (selection) { return selection.kind === 'FragmentSpread' &&
        isEmpty(fragmentMap[selection.name.value], fragmentMap); });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty(visit(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !!v.name && !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !!fs.name && !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
var addTypenameToDocument = Object.assign(function (doc) {
    return visit(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return __assign$l(__assign$l({}, node), { selections: __spreadArray$5(__spreadArray$5([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                __DEV__ && invariant$1.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(visit(doc, {
        OperationDefinition: {
            enter: function (node) {
                return __assign$l(__assign$l({}, node), { variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) : [] });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(visit(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = visit(document, {
        OperationDefinition: {
            enter: function (node) {
                return __assign$l(__assign$l({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = visit(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}

var hasOwnProperty$6 = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = isNonNullObject;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if (isNonNullObject(source) && isNonNullObject(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (hasOwnProperty$6.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, __spreadArray$5([target, source, sourceKey], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if (isNonNullObject(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = __assign$l({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

var toString$3 = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (toString$3.call(val)) {
        case "[object Array]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}

function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if (isNonNullObject(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if (isNonNullObject(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (__DEV__) {
        deepFreeze(obj);
    }
    return obj;
}

function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}

function asyncMap(observable, mapFn, catchFn) {
    return new Observable(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, delegate) {
            if (examiner) {
                return function (arg) {
                    ++activeCallbackCount;
                    var both = function () { return examiner(arg); };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) {
                        --activeCallbackCount;
                        next && next.call(observer, result);
                        if (completed) {
                            handler.complete();
                        }
                    }, function (error) {
                        --activeCallbackCount;
                        throw error;
                    }).catch(function (caught) {
                        error && error.call(observer, caught);
                    });
                };
            }
            else {
                return function (arg) { return delegate && delegate.call(observer, arg); };
            }
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function () {
                completed = true;
                if (!activeCallbackCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}

var canUseWeakMap = typeof WeakMap === 'function' &&
    maybe$2(function () { return navigator.product; }) !== 'ReactNative';
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof maybe$2(function () { return window.document.createElement; }) === "function";
var usingJSDOM = maybe$2(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
var canUseLayoutEffect = canUseDOM && !usingJSDOM;

function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: Observable });
    }
    if (canUseSymbol && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}

function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var Concast = (function (_super) {
    __extends(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    iterateObserversSafely(_this.observers, "error", error);
                }
            },
            complete: function () {
                var sub = _this.sub;
                if (sub !== null) {
                    var value = _this.sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest &&
                            _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        iterateObserversSafely(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return _this.sub = obs.subscribe(_this.handlers); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function (_) { });
        if (typeof sources === "function") {
            sources = [new Observable(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            if (this.sub === null &&
                nextOrError === "next" &&
                observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) &&
            this.observers.size < 1) {
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(Observable));
fixObservableSubclass(Concast);

function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}

function graphQLResultHasError(result) {
    return (result.errors && result.errors.length > 0) || false;
}

function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}

var prefixCounts = new Map();
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

function stringifyForDisplay(value) {
    var undefId = makeUniqueId("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}

function mergeOptions(defaults, options) {
    return compact(defaults, options, options.variables && {
        variables: __assign$l(__assign$l({}, (defaults && defaults.variables)), options.variables),
    });
}

function fromError(errorValue) {
    return new Observable(function (observer) {
        observer.error(errorValue);
    });
}

function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    __DEV__ && invariant$1.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}

function fromPromise(promise) {
    return new Observable(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}

var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw __DEV__ ? new InvariantError("illegal argument: ".concat(key)) : new InvariantError(26);
        }
    }
    return operation;
}

function createOperation(starting, operation) {
    var context = __assign$l({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = __assign$l(__assign$l({}, context), next(context));
        }
        else {
            context = __assign$l(__assign$l({}, context), next);
        }
    };
    var getContext = function () { return (__assign$l({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    return operation;
}

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? getOperationName(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}

function passthrough(op, forward) {
    return (forward ? forward(op) : Observable.of());
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var LinkError = (function (_super) {
    __extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return Observable.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation)
                    ? leftLink.request(operation) || Observable.of()
                    : rightLink.request(operation) || Observable.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation)
                    ? leftLink.request(operation, forward) || Observable.of()
                    : rightLink.request(operation, forward) || Observable.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            __DEV__ && invariant$1.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || Observable.of(); }) || Observable.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || Observable.of();
                }) || Observable.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw __DEV__ ? new InvariantError('request is not implemented') : new InvariantError(21);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

var empty = ApolloLink.empty;

var from = ApolloLink.from;

var split = ApolloLink.split;

var concat$1 = ApolloLink.concat;

var execute = ApolloLink.execute;

var version$1 = '3.7.1';

function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUseAsyncIteratorSymbol &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}

function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}

function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}

function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}

function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}

function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}

var hasOwnProperty$5 = Object.prototype.hasOwnProperty;
function readMultipartBody(response, observer) {
    var _a, _b, _c;
    return __awaiter$8(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _d, value, done, chunk, bi, message, i, headers, contentType_1, body, result;
        var _e;
        return __generator$8(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter))
                        ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _f.label = 1;
                case 1:
                    if (!running) return [3, 3];
                    return [4, iterator.next()];
                case 2:
                    _d = _f.sent(), value = _d.value, done = _d.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary);
                    while (bi > -1) {
                        message = void 0;
                        _e = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _e[0], buffer = _e[1];
                        if (message.trim()) {
                            i = message.indexOf("\r\n\r\n");
                            headers = parseHeaders(message.slice(0, i));
                            contentType_1 = headers["content-type"];
                            if (contentType_1 &&
                                contentType_1.toLowerCase().indexOf("application/json") === -1) {
                                throw new Error("Unsupported patch content type: application/json is required.");
                            }
                            body = message.slice(i);
                            try {
                                result = parseJsonBody(response, body.replace("\r\n", ""));
                                if (Object.keys(result).length > 1 ||
                                    "data" in result ||
                                    "incremental" in result ||
                                    "errors" in result) {
                                    (_b = observer.next) === null || _b === void 0 ? void 0 : _b.call(observer, result);
                                }
                            }
                            catch (err) {
                                handleError(err, observer);
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3, 1];
                case 3:
                    (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
                    return [2];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        throwServerError(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    var _a, _b;
    if (err.name === "AbortError")
        return;
    if (err.result && err.result.errors && err.result.data) {
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, err.result);
    }
    (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, err);
}
function readJsonBody(response, operation, observer) {
    parseAndCheckHttpResponse(operation)(response)
        .then(function (result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 ? void 0 : _b.call(observer);
    })
        .catch(function (err) { return handleError(err, observer); });
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (response.status >= 300) {
                throwServerError(response, result, "Response not successful: Received status code ".concat(response.status));
            }
            if (!Array.isArray(result) &&
                !hasOwnProperty$5.call(result, "data") &&
                !hasOwnProperty$5.call(result, "errors")) {
                throwServerError(response, result, "Server response was missing for query '".concat(Array.isArray(operations)
                    ? operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = __DEV__ ? new InvariantError("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new InvariantError(23);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, __spreadArray$5([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = __assign$l(__assign$l(__assign$l({}, options), config.options), { headers: __assign$l(__assign$l({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = __assign$l(__assign$l({}, http), config.http);
    });
    options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = printer(query, print);
    return {
        options: options,
        body: body,
    };
}
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = { originalName: name, value: headers[name] };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        throw __DEV__ ? new InvariantError("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new InvariantError(22);
    }
};

var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};

var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};

function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}

var backupFetch = maybe$2(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? defaultPrinter : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = __rest$c(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (__DEV__) {
        checkFetcher(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = __assign$l(__assign$l({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = selectHttpOptionsAndBodyInternal(operation, print, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            visit(operation.query, {
                Variable: function (node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') {
                        unusedNames_1.delete(node.name.value);
                    }
                },
            });
            if (unusedNames_1.size) {
                body.variables = __assign$l({}, body.variables);
                unusedNames_1.forEach(function (name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (hasDirectives(['defer'], operation.query)) {
            options.headers.accept = "multipart/mixed; deferSpec=20220824, application/json";
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new Observable(function (observer) {
            var currentFetch = preferredFetch || maybe$2(function () { return fetch; }) || backupFetch;
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return readMultipartBody(response, observer);
                }
                else {
                    return readJsonBody(response, operation, observer);
                }
            })
                .catch(function (err) { return handleError(err, observer); });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};

var HttpLink = (function (_super) {
    __extends(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, createHttpLink(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(ApolloLink));

var _a$2 = Object.prototype, toString$2 = _a$2.toString, hasOwnProperty$4 = _a$2.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString$2.call(a);
    var bTag = toString$2.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = definedKeys(a);
            var bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty$4.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            var len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            var aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
var nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}

function isExecutionPatchIncrementalResult(value) {
    return !!value.incremental;
}

// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function () { return Object.create(null); };
// Useful for processing arguments objects as well as arrays.
var _a$1 = Array.prototype, forEach = _a$1.forEach, slice = _a$1.slice;
var Trie = /** @class */ (function () {
    function Trie(weakness, makeData) {
        if (weakness === void 0) { weakness = true; }
        if (makeData === void 0) { makeData = defaultMakeData; }
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function (array) {
        var node = this;
        forEach.call(array, function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = this.makeData(slice.call(array)));
    };
    Trie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext$1 = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE$1 = {};
var idCounter$1 = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass$1 = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter$1++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext$1; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE$1)
                    break;
                if (context_1 !== currentContext$1) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext$1.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext$1) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext$1.slots[this.id] = MISSING_VALUE$1;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext$1.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext$1;
        currentContext$1 = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext$1 = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext$1;
        return function () {
            var saved = currentContext$1;
            try {
                currentContext$1 = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext$1 = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext$1) {
            var saved = currentContext$1;
            try {
                currentContext$1 = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext$1 = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey$1 = "@wry/context:Slot";
var host$1 = Array;
var Slot$1 = host$1[globalKey$1] || function () {
    var Slot = makeSlotClass$1();
    try {
        Object.defineProperty(host$1, globalKey$1, {
            value: host$1[globalKey$1] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

Slot$1.bind; Slot$1.noContext;

function defaultDispose() { }
var Cache$1 = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function (key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    };
    Cache.prototype.set = function (key, value) {
        var node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot$1();

var _a;
var hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var 
// This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
toArray = (_a = Array.from, _a === void 0 ? function (collection) {
    var array = [];
    collection.forEach(function (item) { return array.push(item); });
    return array;
} : _a);
function maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function () {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function (args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, function (parent, child) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function () {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function (dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function () {
        var _this = this;
        if (this.deps) {
            toArray(this.deps).forEach(function (dep) { return dep.delete(_this); });
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = toArray(child.parents);
        for (var i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    var parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

var EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true,
};
function dep(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) {
                depsByKey.set(key, dep_1 = new Set);
            }
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = (entryMethodName &&
                hasOwnProperty$3.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            toArray(dep).forEach(function (entry) { return entry[m_1](); });
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

function makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new Trie(typeof WeakMap === "function");
    return function () {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
makeDefaultMakeCacheKeyFunction();
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache$1(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey ||
        makeDefaultMakeCacheKeyFunction();
    var optimistic = function () {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function () { return cache.delete(key); };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false,
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}

var ApolloCache = (function () {
    function ApolloCache() {
        this.getFragmentDoc = wrap(getFragmentQueryDocument);
    }
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic :
            options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function () { return updateResult = options.update(_this); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read(__assign$l(__assign$l({}, options), { rootId: options.id || 'ROOT_QUERY', optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read(__assign$l(__assign$l({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = __rest$c(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = __rest$c(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery(__assign$l(__assign$l({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment(__assign$l(__assign$l({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

var Cache;
(function (Cache) {
})(Cache || (Cache = {}));

var MissingFieldError = (function (_super) {
    __extends(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}
var isArray = Array.isArray;
function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id } :
                    !isNullish(_id) ? { _id: _id } :
                        void 0;
        }
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat((typeof id === "number" ||
                typeof id === "string") ? id : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false,
};
function normalizeConfig(config) {
    return compact(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return isReference(objectOrReference)
        ? store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if (isNonNullObject(result)) {
        return isArray(result)
            ? result.every(function (item) { return selectionSetMatchesResult(selectionSet, item, variables); })
            : selectionSet.selections.every(function (field) {
                if (isField(field) && shouldInclude(field, variables)) {
                    var key = resultKeyNameFromField(field);
                    return hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables));
                }
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return isNonNullObject(value) &&
        !isReference(value) &&
        !isArray(value);
}
function makeProcessedFieldsMerger() {
    return new DeepMerger;
}
function extractFragmentContext(document, fragments) {
    var fragmentMap = createFragmentMap(getFragmentDefinitions(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}

var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function (objectOrReference, storeFieldName) { return maybeDeepFreeze(isReference(objectOrReference)
            ? _this.get(objectOrReference.__ref, storeFieldName)
            : objectOrReference && objectOrReference[storeFieldName]); };
        this.canRead = function (objOrRef) {
            return isReference(objOrRef)
                ? _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return makeReference(objOrIdOrRef);
            }
            if (isReference(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = makeReference(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function () {
        return __assign$l({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (hasOwn.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && hasOwn.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            hasOwn.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (hasOwn.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        if (isReference(older))
            older = older.__ref;
        if (isReference(newer))
            newer = newer.__ref;
        var existing = typeof older === "string"
            ? this.lookup(dataId = older)
            : older;
        var incoming = typeof newer === "string"
            ? this.lookup(dataId = newer)
            : newer;
        if (!incoming)
            return;
        __DEV__ ? invariant$1(typeof dataId === "string", "store.merge expects a string ID") : invariant$1(typeof dataId === "string", 1);
        var merged = new DeepMerger(storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = fieldNameFromStoreName(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) { return _this.group.dirty(dataId, fieldName); });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: isReference,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) { return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                    fieldName: fieldNameOrOptions,
                    from: from || makeReference(dataId),
                } : fieldNameOrOptions, { store: _this }); },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = fieldNameFromStoreName(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function"
                    ? fields
                    : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE :
                        modify(maybeDeepFreeze(fieldValue), __assign$l(__assign$l({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) }));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args
                ? this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (hasOwn.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!hasOwn.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && hasOwn.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = __rest$c(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (hasOwn.call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!hasOwn.call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            workSet_1.forEach(function (obj) {
                if (isReference(obj)) {
                    found_1[obj.__ref] = true;
                }
                if (isNonNullObject(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        if (isNonNullObject(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());
var CacheGroup = (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? dep() : null;
        this.keyMaker = new Trie(canUseWeakMap);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = fieldNameFromStoreName(storeFieldName);
            if (fieldName !== storeFieldName) {
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    var Root = (function (_super) {
        __extends(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new Trie(canUseWeakMap);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
var Layer = (function (_super) {
    __extends(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!equal(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        if (parent === this.parent)
            return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return __assign$l(__assign$l({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return hasOwn.call(this.data, dataId) ? __assign$l(__assign$l({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}(EntityStore));
var Stump = (function (_super) {
    __extends(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        return this;
    };
    Stump.prototype.merge = function () {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return equal(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    return !!(store instanceof EntityStore && store.group.caching);
}

function shallowCopy(value) {
    if (isNonNullObject(value)) {
        return isArray(value)
            ? value.slice(0)
            : __assign$l({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
var ObjectCanon = (function () {
    function ObjectCanon() {
        this.known = new (canUseWeakSet ? WeakSet : Set)();
        this.pool = new Trie(canUseWeakMap);
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return isNonNullObject(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if (isNonNullObject(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if (isNonNullObject(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, node.keys = { sorted: keys, json: json });
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());
var canonicalStringify = Object.assign(function (value) {
    if (isNonNullObject(value)) {
        if (stringifyCanon === void 0) {
            resetCanonicalStringify();
        }
        var canonical = stringifyCanon.admit(value);
        var json = stringifyCache.get(canonical);
        if (json === void 0) {
            stringifyCache.set(canonical, json = JSON.stringify(canonical));
        }
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: resetCanonicalStringify,
});
var stringifyCanon;
var stringifyCache;
function resetCanonicalStringify() {
    stringifyCanon = new ObjectCanon;
    stringifyCache = new (canUseWeakMap ? WeakMap : Map)();
}

function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults,
    ];
}
var StoreReader = (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUseWeakMap ? WeakMap : Map)();
        this.config = compact(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: shouldCanonizeResults(config),
        });
        this.canon = config.canon || new ObjectCanon;
        this.executeSelectionSet = wrap(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return __assign$l(__assign$l({}, other), { result: _this.canon.admit(other.result) });
                }
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: execSelectionSetKeyArgs,
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, isReference(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            }
        });
        this.executeSubSelectedArray = wrap(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            }
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new ObjectCanon;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = __assign$l(__assign$l({}, getDefaultValues(getQueryDefinition(query))), variables);
        var rootRef = makeReference(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: getMainDefinition(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: __assign$l({ store: store, query: query, policies: policies, variables: variables, varString: canonicalStringify(variables), canonizeResults: canonizeResults }, extractFragmentContext(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            missing = [new MissingFieldError(firstMissing(execResult.missing), execResult.missing, query, variables)];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if (isReference(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new DeepMerger();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            if (!shouldInclude(selection, variables))
                return;
            if (isField(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = resultKeyNameFromField(selection);
                if (fieldValue === void 0) {
                    if (!addTypenameToDocument.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat(isReference(objectOrReference)
                                ? objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if (isArray(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: isReference(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = getFragmentFromSelection(selection, context.lookupFragment);
                if (!fragment && selection.kind === Kind.FRAGMENT_SPREAD) {
                    throw __DEV__ ? new InvariantError("No fragment named ".concat(selection.name.value)) : new InvariantError(5);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = mergeDeepArray(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults
            ? this.canon.admit(finalResult)
            : maybeDeepFreeze(finalResult);
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new DeepMerger();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            if (item === null) {
                return null;
            }
            if (isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: isReference(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (__DEV__) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());
function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if (isNonNullObject(value)) {
                __DEV__ ? invariant$1(!isReference(value), "Missing selection set for object of type ".concat(getTypenameFromStoreObject(store, value), " returned for query field ").concat(field.name.value)) : invariant$1(!isReference(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(function () { return globalThis; }) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(function () { return global; }) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
var globalHost = host;
var Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());

Slot.bind; Slot.noContext;

var cacheSlot = new Slot();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, info = {
            vars: new Set,
            dep: dep(),
        });
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    getCacheInfo(cache).dep.dirty(rv);
                    broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}

var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
        var extract = function (from, key) { return context.readField(key, from); };
        var keyObject = context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
            var extracted = extractKeyPath(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 &&
                object !== context.storeObject &&
                hasOwn.call(object, schemaKeyPath[0])) {
                extracted = extractKeyPath(object, schemaKeyPath, extractKey);
            }
            __DEV__ ? invariant$1(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : invariant$1(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function (args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = collectSpecifierPaths(specifier, function (keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && isNonEmptyArray(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                    var directiveArgs = d && argumentsObjectFromField(d, variables);
                    return directiveArgs && extractKeyPath(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && hasOwn.call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return extractKeyPath(variables, varKeyPath);
                }
                return;
            }
            if (args) {
                return extractKeyPath(args, keyPath);
            }
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") {
            fieldName += ":" + suffix;
        }
        return fieldName;
    });
}
function collectSpecifierPaths(specifier, extractor) {
    var merger = new DeepMerger;
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if (isArray(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!isArray(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    extract = extract || extractKey;
    return normalize$1(path.reduce(function reducer(obj, key) {
        return isArray(obj)
            ? obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize$1(value) {
    if (isNonNullObject(value)) {
        if (isArray(value)) {
            return value.map(normalize$1);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) { return extractKeyPath(value, path); });
    }
    return value;
}

getStoreKeyName.setStringify(canonicalStringify);
function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args :
        spec.field ? argumentsObjectFromField(spec.field, spec.variables) : null;
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = __assign$l({ dataIdFromObject: defaultDataIdFromObject }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename ||
            ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = __assign$l(__assign$l({}, partialContext), { typename: typename, storeObject: storeObject, readField: partialContext && partialContext.readField || function () {
                var options = normalizeReadFieldOptions(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables,
                });
            } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn(object, context);
            if (isArray(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = __rest$c(_a, ["queryType", "mutationType", "subscriptionType"]);
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (hasOwn.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge :
                    merge === true ? mergeTrueFn :
                        merge === false ? mergeFalseFn :
                            existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn =
            keyFields === false ? nullKeyFieldsFn :
                isArray(keyFields) ? keyFieldsFnFromSpecifier(keyFields) :
                    typeof keyFields === "function" ? keyFields :
                        existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        keyArgs === false ? simpleKeyArgsFn :
                            isArray(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) :
                                typeof keyArgs === "function" ? keyArgs :
                                    existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? invariant$1(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : invariant$1(!old || old === which, 3);
            if (old)
                delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(TypeOrFieldNameRegExp);
                if (!match || match[0] !== subtype) {
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!hasOwn.call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) {
                supertypes.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = __rest$c(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || (createIfMissing && (fieldPolicies[fieldName] = Object.create(null)));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, supertypeSet = new Set());
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes &&
            this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            __DEV__ && invariant$1.warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        }
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    i === workQueue_1.length - 1 &&
                    selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if (isArray(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName = fieldSpec.field
                ? storeKeyNameFromField(fieldSpec.field, fieldSpec.variables)
                : getStoreKeyName(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        if (storeFieldName === false) {
            return fieldName;
        }
        return fieldName === fieldNameFromStoreName(storeFieldName)
            ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = fieldNameFromStoreName(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage(isReference(objectOrReference)
                ? objectOrReference.__ref
                : objectOrReference, storeFieldName));
            return cacheSlot.withValue(this.cache, read, [existing, readOptions]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            return incoming;
        }
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, { typename: typename, fieldName: field.name.value, field: field, variables: context.variables }, context, storage || Object.create(null)));
    };
    return Policies;
}());
function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: isReference,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = __assign$l({}, fieldNameOrOptions);
        if (!hasOwn.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (__DEV__ && options.from === void 0) {
        __DEV__ && invariant$1.warn("Undefined 'from' passed to readField with arguments ".concat(stringifyForDisplay(Array.from(readFieldArgs))));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if (isArray(existing) || isArray(incoming)) {
            throw __DEV__ ? new InvariantError("Cannot automatically merge arrays") : new InvariantError(4);
        }
        if (isNonNullObject(existing) &&
            isNonNullObject(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if (isReference(existing) &&
                storeValueIsStoreObject(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if (storeValueIsStoreObject(existing) &&
                isReference(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if (storeValueIsStoreObject(existing) &&
                storeValueIsStoreObject(incoming)) {
                return __assign$l(__assign$l({}, existing), incoming);
            }
        }
        return incoming;
    };
}

function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, flavored = (context.clientOnly === clientOnly &&
            context.deferred === deferred) ? context : __assign$l(__assign$l({}, context), { clientOnly: clientOnly, deferred: deferred }));
    }
    return flavored;
}
var StoreWriter = (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = getOperationDefinition(query);
        var merger = makeProcessedFieldsMerger();
        variables = __assign$l(__assign$l({}, getDefaultValues(operationDefinition)), variables);
        var context = __assign$l(__assign$l({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: canonicalStringify(variables) }, extractFragmentContext(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map, clientOnly: false, deferred: false, flavors: new Map });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map },
            context: context,
        });
        if (!isReference(ref)) {
            throw __DEV__ ? new InvariantError("Could not identify object ".concat(JSON.stringify(result))) : new InvariantError(7);
        }
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = makeReference(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if (isReference(applied)) {
                    return;
                }
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[fieldNameFromStoreName(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            getTypenameFromResult(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if (isReference(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField(__assign$l(__assign$l({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = resultKeyNameFromField(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet
                    ? getContextFlavor(context, false, false)
                    : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet &&
                    (isReference(incomingValue) ||
                        storeValueIsStoreObject(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (__DEV__ &&
                !context.clientOnly &&
                !context.deferred &&
                !addTypenameToDocument.added(field) &&
                !policies.getReadFunction(typename, field.name.value)) {
                __DEV__ && invariant$1.error("Missing field '".concat(resultKeyNameFromField(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
            }
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) {
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = makeReference(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            return __DEV__ ? cloneDeep(value) : value;
        }
        if (isArray(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = getTypenameFromResult(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new Trie(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!shouldInclude(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) &&
                    isNonEmptyArray(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = argumentsObjectFromField(dir, context.variables);
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                        }
                    });
                }
                if (isField(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = getFragmentFromSelection(selection, context.lookupFragment);
                    if (!fragment && selection.kind === Kind.FRAGMENT_SPREAD) {
                        throw __DEV__ ? new InvariantError("No fragment named ".concat(selection.name.value)) : new InvariantError(8);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !isReference(incoming)) {
            var e_1 = (!isArray(incoming) &&
                (isReference(existing) || storeValueIsStoreObject(existing))) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [isReference(e_1) ? e_1.__ref : e_1];
            }
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return isArray(from)
                    ? (typeof name === "number" ? from[name] : void 0)
                    : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    invariant$1(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                incoming = (isArray(i_1) ? i_1.slice(0) : __assign$l({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());
var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? __assign$l(__assign$l({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map :
        left.map.size ? left.map : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    if (isReference(existing))
        return;
    if (equal(existing, incoming))
        return;
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    if (!isArray(existing) &&
        !isArray(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" &&
                !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    __DEV__ && invariant$1.warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length
        ? "either ensure all objects of type " +
            childTypenames.join(" and ") + " have an ID or a custom merge function, or "
        : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}

var InMemoryCache = (function (_super) {
    __extends(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = makeVar;
        _this.txCount = 0;
        _this.config = normalizeConfig(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        var rootStore = this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new StoreWriter(this, this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: shouldCanonizeResults(this.config),
            canon: resetResultIdentities
                ? void 0
                : previousReader && previousReader.canon,
            fragments: fragments,
        }), fragments);
        this.maybeBroadcastWatch = wrap(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, canonicalStringify({ optimistic: optimistic, id: id, variables: variables }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group,
        ]).forEach(function (group) { return group.resetCaching(); });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore(__assign$l(__assign$l({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null;
        }
        catch (e) {
            if (e instanceof MissingFieldError) {
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (hasOwn.call(options, "id") && !options.id) {
            return false;
        }
        var store = options.optimistic
            ? this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore(__assign$l(__assign$l({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            recallCache(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            if (_this.watches.delete(watch) && !_this.watches.size) {
                forgetCache(_this);
            }
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        canonicalStringify.reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function (object) {
        if (isReference(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            __DEV__ && invariant$1.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (hasOwn.call(options, "id")) {
                return false;
            }
            options = __assign$l(__assign$l({}, options), { id: "ROOT_QUERY" });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        canonicalStringify.reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            forgetCache(this);
        }
        else {
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return updateResult = update(_this);
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            this.broadcastWatches(__assign$l(__assign$l({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            perform(this.data);
        }
        else {
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches(__assign$l(__assign$l({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || (optimisticId !== null),
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = addTypenameToDocument(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.transformForLink = function (document) {
        var fragments = this.config.fragments;
        return fragments
            ? fragments.transform(document)
            : document;
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic &&
                typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                return;
            }
        }
        if (!lastDiff || !equal(lastDiff.result, diff.result)) {
            c.callback(c.lastDiff = diff, lastDiff);
        }
    };
    return InMemoryCache;
}(ApolloCache));

function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (isNonEmptyArray(err.graphQLErrors) || isNonEmptyArray(err.clientErrors)) {
        var errors = (err.graphQLErrors || [])
            .concat(err.clientErrors || []);
        errors.forEach(function (error) {
            var errorMessage = error
                ? error.message
                : 'Error message not found.';
            message += "".concat(errorMessage, "\n");
        });
    }
    if (err.networkError) {
        message += "".concat(err.networkError.message, "\n");
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    __extends(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}

var assign$1 = Object.assign, hasOwnProperty$2 = Object.hasOwnProperty;
var ObservableQuery = (function (_super) {
    __extends(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            if (first) {
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? (fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy) : _f;
        _this.options = __assign$l(__assign$l({}, options), { initialFetchPolicy: initialFetchPolicy, fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = getOperationDefinition(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function () {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            NetworkStatus.ready;
        var result = __assign$l(__assign$l({}, lastResult), { loading: isNetworkRequestInFlight(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache' ||
            fetchPolicy === 'standby' ||
            this.queryManager.transform(this.options.query).hasForcedResolvers) ;
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if (equal(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                delete result.partial;
                if (diff.complete &&
                    result.networkStatus === NetworkStatus.loading &&
                    (fetchPolicy === 'cache-first' ||
                        fetchPolicy === 'cache-only')) {
                    result.networkStatus = NetworkStatus.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (__DEV__ &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult, variables) {
        return (!this.last ||
            !equal(this.last.result, newResult) ||
            (variables && !equal(this.last.variables, variables)));
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || equal(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0,
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === 'no-cache') {
            reobserveOptions.fetchPolicy = 'no-cache';
        }
        else {
            reobserveOptions.fetchPolicy = 'network-only';
        }
        if (__DEV__ && variables && hasOwnProperty$2.call(variables, "variables")) {
            var queryDef = getQueryDefinition(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                __DEV__ && invariant$1.warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
            }
        }
        if (variables && !equal(this.options.variables, variables)) {
            reobserveOptions.variables = this.options.variables = __assign$l(__assign$l({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, NetworkStatus.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = __assign$l(__assign$l({}, (fetchMoreOptions.query ? fetchMoreOptions : __assign$l(__assign$l(__assign$l(__assign$l({}, this.options), { query: this.query }), fetchMoreOptions), { variables: __assign$l(__assign$l({}, this.options.variables), fetchMoreOptions.variables) }))), { fetchPolicy: "no-cache" });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = NetworkStatus.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, NetworkStatus.fetchMore).then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === NetworkStatus.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) { return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables,
                        }); });
                    }
                    else {
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        }).finally(function () {
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && invariant$1.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function (variables) {
        if (equal(this.variables, variables)) {
            return this.observers.size
                ? this.result()
                : Promise.resolve();
        }
        this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, NetworkStatus.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") {
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager.fetchQueryObservable(this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo &&
            pollingInfo.interval === pollInterval) {
            return;
        }
        __DEV__ ? invariant$1(pollInterval, 'Attempted to start a polling query without a polling interval.') : invariant$1(pollInterval, 12);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (!isNetworkRequestInFlight(_this.queryInfo.networkStatus)) {
                    _this.reobserve({
                        fetchPolicy: _this.options.initialFetchPolicy === 'no-cache' ? 'no-cache' : 'network-only',
                    }, NetworkStatus.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        this.last = __assign$l(__assign$l({}, this.last), { result: this.queryManager.assumeImmutableResults
                ? newResult
                : cloneDeep(newResult), variables: variables });
        if (!isNonEmptyArray(newResult.errors)) {
            delete this.last.error;
        }
        return this.last;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === NetworkStatus.refetch ||
            newNetworkStatus === NetworkStatus.fetchMore ||
            newNetworkStatus === NetworkStatus.poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = compact(this.options, newOptions || {});
        var options = useDisposableConcast
            ? mergedOptions
            : assign$1(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions &&
                newOptions.variables &&
                !equal(newOptions.variables, oldVariables) &&
                options.fetchPolicy !== "standby" &&
                options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = NetworkStatus.setVariables;
                }
            }
        }
        var variables = options.variables && __assign$l({}, options.variables);
        var concast = this.fetch(options, newNetworkStatus);
        var observer = {
            next: function (result) {
                _this.reportResult(result, variables);
            },
            error: function (error) {
                _this.reportError(error, variables);
            },
        };
        if (!useDisposableConcast) {
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast.promise;
    };
    ObservableQuery.prototype.observe = function () {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result, variables)) {
            if (lastError || !result.partial || this.options.returnPartialData) {
                this.updateLastResult(result, variables);
            }
            iterateObserversSafely(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        var errorResult = __assign$l(__assign$l({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: NetworkStatus.error, loading: false });
        this.updateLastResult(errorResult, variables);
        iterateObserversSafely(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}(Observable));
fixObservableSubclass(ObservableQuery);
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" ||
        fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            nextFetchPolicy: function () {
                this.nextFetchPolicy = nextFetchPolicy;
                if (typeof nextFetchPolicy === "function") {
                    return nextFetchPolicy.apply(this, arguments);
                }
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && invariant$1.error('Unhandled error', error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (__DEV__ && missing) {
        __DEV__ && invariant$1.debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
    }
}

var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = mergeDeep(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return __awaiter$8(this, void 0, void 0, function () {
            return __generator$8(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return (__assign$l(__assign$l({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (hasDirectives(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return removeClientSetsFromDocument(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return __assign$l(__assign$l({}, context), { cache: cache, getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return __awaiter$8(this, void 0, void 0, function () {
            return __generator$8(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return (__assign$l(__assign$l({}, variables), data.exportedVariables)); })];
                }
                return [2, __assign$l({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        visit(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return BREAK;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: buildQueryFromSelectionSet(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return __awaiter$8(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return __generator$8(this, function (_b) {
                mainDefinition = getMainDefinition(document);
                fragments = getFragmentDefinitions(document);
                fragmentMap = createFragmentMap(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: __assign$l(__assign$l({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return __awaiter$8(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return __generator$8(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return __awaiter$8(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return __generator$8(this, function (_a) {
                        if (!shouldInclude(selection, variables)) {
                            return [2];
                        }
                        if (isField(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[resultKeyNameFromField(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (isInlineFragment(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                            __DEV__ ? invariant$1(fragment, "No fragment named ".concat(selection.name.value)) : invariant$1(fragment, 11);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return mergeDeepArray(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return __awaiter$8(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return __generator$8(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = resultKeyNameFromField(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(cacheSlot.withValue(this.cache, resolve, [
                                rootValue,
                                argumentsObjectFromField(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

var destructiveMethodCounts = new (canUseWeakMap ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var QueryInfo = (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || NetworkStatus.loading;
        if (this.variables &&
            this.networkStatus !== NetworkStatus.loading &&
            !equal(this.variables, query.variables)) {
            networkStatus = NetworkStatus.setVariables;
        }
        if (!equal(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function (variables) {
        if (variables === void 0) { variables = this.variables; }
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && equal(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions(),
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty &&
            !equal(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    oq["observe"]();
                }
                else {
                    reobserveCacheFirst(oq);
                }
            });
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if (isNetworkRequestInFlight(this.networkStatus) &&
            this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" &&
                fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = __assign$l(__assign$l({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch ||
            !equal(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            equal(variables, lastWrite.variables) &&
            equal(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var graphQLErrors = isNonEmptyArray(result.errors)
            ? result.errors.slice(0)
            : [];
        this.reset();
        if ('incremental' in result && isNonEmptyArray(result.incremental)) {
            var mergedData_1 = this.getDiff().result;
            var merger_1 = new DeepMerger();
            result.incremental.forEach(function (_a) {
                var data = _a.data, path = _a.path, errors = _a.errors;
                for (var i = path.length - 1; i >= 0; --i) {
                    var key = path[i];
                    var isNumericKey = !isNaN(+key);
                    var parent_1 = isNumericKey ? [] : {};
                    parent_1[key] = data;
                    data = parent_1;
                }
                if (errors) {
                    graphQLErrors.push.apply(graphQLErrors, errors);
                }
                mergedData_1 = merger_1.merge(mergedData_1, data);
            });
            result.data = mergedData_1;
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === 'no-cache') {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        if (_this.lastDiff &&
                            _this.lastDiff.diff.complete) {
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    if (!_this.stopped) {
                        _this.updateWatch(options.variables);
                    }
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return this.networkStatus = NetworkStatus.ready;
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = NetworkStatus.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());
function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" ||
        errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}

var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new (canUseWeakMap ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new InvariantError('QueryManager stopped while query was in flight') : new InvariantError(13));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return __awaiter$8(this, void 0, void 0, function () {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return __generator$8(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        __DEV__ ? invariant$1(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : invariant$1(mutation, 14);
                        __DEV__ ? invariant$1(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : invariant$1(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', 15);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_j.sent());
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, __assign$l(__assign$l({}, context), { optimisticResponse: optimisticResponse }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                        throw new ApolloError({
                                            graphQLErrors: result.errors,
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = __assign$l({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === 'ignore' &&
                                        graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        resolve(storeResult);
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof ApolloError ? err : new ApolloError({
                                            networkError: err,
                                        }));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            cacheWrites.push({
                result: result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !hasOwnProperty$1.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: document && getOperationName(document) || void 0,
                            queryVariables: variables,
                        });
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            mutation.refetchQueries ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    var update = mutation.update;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete && !(isExecutionPatchIncrementalResult(result))) {
                                result = __assign$l(__assign$l({}, result), { data: diff.result });
                            }
                        }
                        update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables,
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields) {
                        cache.modify({
                            id: 'ROOT_MUTATION',
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function"
            ? optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult(__assign$l(__assign$l({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                __DEV__ && invariant$1.error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = removeConnectionDirectiveFromDocument(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: hasClientExports(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: getDefaultValues(getOperationDefinition(transformed)),
                asQuery: __assign$l(__assign$l({}, transformed), { definitions: transformed.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return __assign$l(__assign$l({}, def), { operation: "query" });
                        }
                        return def;
                    }) })
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return __assign$l(__assign$l({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        options = __assign$l(__assign$l({}, options), { variables: this.getVariables(options.query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        __DEV__ ? invariant$1(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.') : invariant$1(options.query, 16);
        __DEV__ ? invariant$1(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : invariant$1(options.query.kind === 'Document', 17);
        __DEV__ ? invariant$1(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : invariant$1(!options.returnPartialData, 18);
        __DEV__ ? invariant$1(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : invariant$1(!options.pollInterval, 19);
        return this.fetchQuery(queryId, options).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        this.cancelPendingFetches(__DEV__ ? new InvariantError('Store reset while query was in flight (not completed in link chain)') : new InvariantError(20));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                queryInfo.networkStatus = NetworkStatus.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if (isDocumentNode(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc).document, false);
                }
                else if (isNonNullObject(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                var queryId = makeUniqueId("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: __assign$l(__assign$l({}, options), { fetchPolicy: "network-only" }),
                });
                invariant$1(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (__DEV__ && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    __DEV__ && invariant$1.warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" &&
                    fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== 'no-cache') {
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: 'ROOT_SUBSCRIPTION',
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                if (graphQLResultHasError(result)) {
                    throw new ApolloError({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: getOperationName(serverQuery) || void 0,
                context: this.prepareContext(__assign$l(__assign$l({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = canonicalStringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new Concast([
                        execute(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function () {
                        if (byVariables_1.delete(varJson_1) &&
                            byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(serverQuery);
                        }
                    });
                }
            }
            else {
                observable = new Concast([
                    execute(link, operation)
                ]);
            }
        }
        else {
            observable = new Concast([
                Observable.of({ data: {} })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        options = cloneDeep(options);
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = isNonEmptyArray(result.errors)
                ? result.errors.slice(0)
                : [];
            if ('incremental' in result && isNonEmptyArray(result.incremental)) {
                result.incremental.forEach(function (incrementalResult) {
                    if (incrementalResult.errors) {
                        graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
                    }
                });
            }
            var hasErrors = isNonEmptyArray(graphQLErrors);
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    throw queryInfo.markError(new ApolloError({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: NetworkStatus.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = NetworkStatus.error;
            }
            return aqr;
        }, function (networkError) {
            var error = isApolloError(networkError)
                ? networkError
                : new ApolloError({ networkError: networkError });
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = NetworkStatus.loading; }
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            normalized.variables = variables;
            var concastSources = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" &&
                concastSources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return concastSources;
        };
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast = new Concast(this.transform(normalized.query).hasClientExports
            ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables)
            : fromVariables(normalized.variables));
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return concast;
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? makeUniqueId("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map;
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                optimistic: optimistic && removeOptimistic || false,
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo &&
                        watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                result = oq.refetch();
                            }
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset();
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(variables); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || NetworkStatus.loading; }
            var data = diff.result;
            if (__DEV__ &&
                !returnPartialData &&
                !equal(data, {})) {
                logMissingFieldErrors(diff.missing);
            }
            var fromData = function (data) { return Observable.of(__assign$l({ data: data, loading: isNetworkRequestInFlight(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true }))); };
            if (data && _this.transform(query).hasForcedResolvers) {
                return _this.localState.runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                }).then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 :
            (networkStatus === NetworkStatus.refetch &&
                refetchWritePolicy !== "merge") ? 1
                : 2;
        var resultsFromLink = function () { return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
            variables: variables,
            context: context,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
        }); };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            isNetworkRequestInFlight(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return [
                        resultsFromCache(diff, queryInfo.markReady()),
                    ];
                }
                if (returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady()),
                ];
            case "network-only":
                if (shouldNotify) {
                    return [
                        resultsFromCache(readCache()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "no-cache":
                if (shouldNotify) {
                    return [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return __assign$l(__assign$l({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

var hasSuggestedDevtools = false;
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' &&
            !window.__APOLLO_CLIENT__ &&
            __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link = uri
                ? new HttpLink({ uri: uri, credentials: credentials, headers: headers })
                : ApolloLink.empty();
        }
        if (!cache) {
            throw __DEV__ ? new InvariantError("To initialize Apollo Client, you must specify a 'cache' property " +
                "in the options object. \n" +
                "For more information, please visit: https://go.apollo.dev/c/docs") : new InvariantError(9);
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && __DEV__) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self &&
                !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) {
                        url = "https://chrome.google.com/webstore/detail/" +
                            "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    }
                    else if (ua.indexOf("Firefox/") > -1) {
                        url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                }
                if (url) {
                    __DEV__ && invariant$1.log("Download the Apollo DevTools for a better development " +
                        "experience: " + url);
                }
            }
        }
        this.version = version$1;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.getQueryStore(),
                            mutations: _this.queryManager.mutationStore || {},
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            } : void 0,
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = mergeOptions(this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = __assign$l(__assign$l({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = mergeOptions(this.defaultOptions.query, options);
        }
        __DEV__ ? invariant$1(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.') : invariant$1(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = __assign$l(__assign$l({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = mergeOptions(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.writeFragment = function (options) {
        this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return execute(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: false,
        }); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: true,
        }); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function (error) {
            __DEV__ && invariant$1.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return __assign$l(__assign$l({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse$1(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;

var contextKey = canUseSymbol
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
function getApolloContext() {
    var context = React__namespace.createContext[contextKey];
    if (!context) {
        Object.defineProperty(React__namespace.createContext, contextKey, {
            value: context = React__namespace.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}

var ApolloConsumer = function (props) {
    var ApolloContext = getApolloContext();
    return (React__namespace.createElement(ApolloContext.Consumer, null, function (context) {
        __DEV__ ? invariant$1(context && context.client, 'Could not find "client" in the context of ApolloConsumer. ' +
            'Wrap the root component in an <ApolloProvider>.') : invariant$1(context && context.client, 27);
        return props.children(context.client);
    }));
};

var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = getApolloContext();
    return (React__namespace.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
        __DEV__ ? invariant$1(context.client, 'ApolloProvider was not passed a client instance. Make ' +
            'sure you pass in your client via the "client" prop.') : invariant$1(context.client, 28);
        return (React__namespace.createElement(ApolloContext.Provider, { value: context }, children));
    }));
};

function useApolloClient(override) {
    var context = React.useContext(getApolloContext());
    var client = override || context.client;
    __DEV__ ? invariant$1(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : invariant$1(!!client, 31);
    return client;
}

var didWarnUncachedGetSnapshot = false;
var uSESKey = "useSyncExternalStore";
var realHook = React__namespace[uSESKey];
var useSyncExternalStore = realHook || (function (subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (__DEV__ &&
        !didWarnUncachedGetSnapshot &&
        value !== getSnapshot()) {
        didWarnUncachedGetSnapshot = true;
        __DEV__ && invariant$1.error('The result of getSnapshot should be cached to avoid an infinite loop');
    }
    var _a = React__namespace.useState({ inst: { value: value, getSnapshot: getSnapshot } }), inst = _a[0].inst, forceUpdate = _a[1];
    if (canUseLayoutEffect) {
        React__namespace.useLayoutEffect(function () {
            Object.assign(inst, { value: value, getSnapshot: getSnapshot });
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        }, [subscribe, value, getSnapshot]);
    }
    else {
        Object.assign(inst, { value: value, getSnapshot: getSnapshot });
    }
    React__namespace.useEffect(function () {
        if (checkIfSnapshotChanged(inst)) {
            forceUpdate({ inst: inst });
        }
        return subscribe(function handleStoreChange() {
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        });
    }, [subscribe]);
    return value;
});
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    }
    catch (_b) {
        return true;
    }
}

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? invariant$1(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : invariant$1(!!document && !!document.kind, 32);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? invariant$1(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : invariant$1(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 33);
    __DEV__ ? invariant$1(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : invariant$1(queries.length + mutations.length + subscriptions.length <= 1, 34);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? invariant$1(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : invariant$1(definitions.length === 1, 35);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    __DEV__ ? invariant$1(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : invariant$1(operation.type === type, 36);
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState(useApolloClient(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = React.useRef();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query, stateRef.current);
    }
    var state = stateRef.current;
    var _a = React.useState(0); _a[0]; var setTick = _a[1];
    state.forceUpdate = function () {
        setTick(function (tick) { return tick + 1; });
    };
    return state;
}
var InternalState = (function () {
    function InternalState(client, query, previous) {
        this.client = client;
        this.query = query;
        this.asyncResolveFns = new Set();
        this.optionsToIgnoreOnce = new (canUseWeakSet ? WeakSet : Set)();
        this.ssrDisabledResult = maybeDeepFreeze({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: NetworkStatus.loading,
        });
        this.skipStandbyResult = maybeDeepFreeze({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: NetworkStatus.ready,
        });
        this.toQueryResultCache = new (canUseWeakMap ? WeakMap : Map)();
        verifyDocumentType(query, DocumentType.Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) {
            this.previousData = previousData;
        }
    }
    InternalState.prototype.forceUpdate = function () {
        __DEV__ && invariant$1.warn("Calling default no-op implementation of InternalState#forceUpdate");
    };
    InternalState.prototype.asyncUpdate = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.asyncResolveFns.add(resolve);
            _this.optionsToIgnoreOnce.add(_this.watchQueryOptions);
            _this.forceUpdate();
        });
    };
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        this.renderPromises = React.useContext(getApolloContext()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = useSyncExternalStore(React.useCallback(function () {
            if (_this.renderPromises) {
                return function () { };
            }
            var onNext = function () {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    equal(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                }
                finally {
                    obsQuery["last"] = last;
                }
                if (!hasOwnProperty.call(error, 'graphQLErrors')) {
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !equal(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: NetworkStatus.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function () { return subscription.unsubscribe(); };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        this.unsafeHandlePartialRefetch(result);
        var queryResult = this.toQueryResult(result);
        if (!queryResult.loading && this.asyncResolveFns.size) {
            this.asyncResolveFns.forEach(function (resolve) { return resolve(queryResult); });
            this.asyncResolveFns.clear();
        }
        return queryResult;
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (this.optionsToIgnoreOnce.has(currentWatchQueryOptions) ||
            !equal(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.optionsToIgnoreOnce.delete(currentWatchQueryOptions);
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false &&
            !this.queryHookOptions.skip) {
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === 'standby') {
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.getObsQueryOptions = function () {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) {
            toMerge.push(this.queryHookOptions.defaultOptions);
        }
        toMerge.push(compact(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce(mergeOptions);
    };
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        var _b;
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip; _a.ssr; _a.onCompleted; _a.onError; _a.defaultOptions; var otherOptions = __rest$c(_a, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
        var watchQueryOptions = Object.assign(otherOptions, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === 'network-only' ||
                watchQueryOptions.fetchPolicy === 'cache-and-network')) {
            watchQueryOptions.fetchPolicy = 'cache-first';
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: 'standby',
            });
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy =
                ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) ||
                    this.getDefaultFetchPolicy();
        }
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function () {
        var _a, _b;
        return (((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
            "cache-first");
    };
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        var obsQuery = this.observable =
            this.renderPromises
                && this.renderPromises.getSSRObservable(this.watchQueryOptions)
                || this.observable
                || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = React.useMemo(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false ||
            this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) {
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result) {
        var _this = this;
        if (!result.loading) {
            Promise.resolve().then(function () {
                if (result.error) {
                    _this.onError(result.error);
                }
                else if (result.data) {
                    _this.onCompleted(result.data);
                }
            }).catch(function (error) {
                __DEV__ && invariant$1.warn(error);
            });
        }
    };
    InternalState.prototype.getCurrentResult = function () {
        if (!this.result) {
            this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data; result.partial; var resultWithoutPartial = __rest$c(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, queryResult = __assign$l(__assign$l(__assign$l({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData }));
        if (!queryResult.error && isNonEmptyArray(result.errors)) {
            queryResult.error = new ApolloError({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== 'cache-only') {
            Object.assign(result, {
                loading: true,
                networkStatus: NetworkStatus.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());

var EAGER_METHODS = [
    'refetch',
    'reobserve',
    'fetchMore',
    'updateQuery',
    'startPolling',
    'subscribeToMore',
];
function useLazyQuery(query, options) {
    var internalState = useInternalState(useApolloClient(options && options.client), query);
    var execOptionsRef = React.useRef();
    var merged = execOptionsRef.current
        ? mergeOptions(options, execOptionsRef.current)
        : options;
    var useQueryResult = internalState.useQuery(__assign$l(__assign$l({}, merged), { skip: !execOptionsRef.current }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy ||
        internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current,
    });
    var eagerMethods = React.useMemo(function () {
        var eagerMethods = {};
        var _loop_1 = function (key) {
            var method = result[key];
            eagerMethods[key] = function () {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    internalState.forceUpdate();
                }
                return method.apply(this, arguments);
            };
        };
        for (var _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++) {
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = React.useCallback(function (executeOptions) {
        execOptionsRef.current = executeOptions ? __assign$l(__assign$l({}, executeOptions), { fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy }) : {
            fetchPolicy: initialFetchPolicy,
        };
        var promise = internalState
            .asyncUpdate()
            .then(function (queryResult) { return Object.assign(queryResult, eagerMethods); });
        promise.catch(function () { });
        return promise;
    }, []);
    return [execute, result];
}

function useMutation(mutation, options) {
    var client = useApolloClient(options === null || options === void 0 ? void 0 : options.client);
    verifyDocumentType(mutation, DocumentType.Mutation);
    var _a = React.useState({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = React.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = React.useCallback(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, client = _a.client, options = _a.options, mutation = _a.mutation;
        var baseOptions = __assign$l(__assign$l({}, options), { mutation: mutation });
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = mergeOptions(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a, _b, _c;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new ApolloError({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !equal(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted) === null || _b === void 0 ? void 0 : _b.call(_a, response.data, clientOptions);
            (_c = executeOptions.onCompleted) === null || _c === void 0 ? void 0 : _c.call(executeOptions, response.data, clientOptions);
            return response;
        }).catch(function (error) {
            var _a, _b, _c, _d;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!equal(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            if (((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) || clientOptions.onError) {
                (_c = (_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onError) === null || _c === void 0 ? void 0 : _c.call(_b, error, clientOptions);
                (_d = executeOptions.onError) === null || _d === void 0 ? void 0 : _d.call(executeOptions, error, clientOptions);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = React.useCallback(function () {
        if (ref.current.isMounted) {
            setResult({ called: false, loading: false, client: client });
        }
    }, []);
    React.useEffect(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, __assign$l({ reset: reset }, result)];
}

function useSubscription(subscription, options) {
    var hasIssuedDeprecationWarningRef = React.useRef(false);
    var client = useApolloClient(options === null || options === void 0 ? void 0 : options.client);
    verifyDocumentType(subscription, DocumentType.Subscription);
    var _a = React.useState({
        loading: !(options === null || options === void 0 ? void 0 : options.skip),
        error: void 0,
        data: void 0,
        variables: options === null || options === void 0 ? void 0 : options.variables,
    }), result = _a[0], setResult = _a[1];
    if (!hasIssuedDeprecationWarningRef.current) {
        hasIssuedDeprecationWarningRef.current = true;
        if (options === null || options === void 0 ? void 0 : options.onSubscriptionData) {
            __DEV__ && invariant$1.warn(options.onData
                ? "'useSubscription' supports only the 'onSubscriptionData' or 'onData' option, but not both. Only the 'onData' option will be used."
                : "'onSubscriptionData' is deprecated and will be removed in a future major version. Please use the 'onData' option instead.");
        }
        if (options === null || options === void 0 ? void 0 : options.onSubscriptionComplete) {
            __DEV__ && invariant$1.warn(options.onComplete
                ? "'useSubscription' supports only the 'onSubscriptionComplete' or 'onComplete' option, but not both. Only the 'onComplete' option will be used."
                : "'onSubscriptionComplete' is deprecated and will be removed in a future major version. Please use the 'onComplete' option instead.");
        }
    }
    var _b = React.useState(function () {
        if (options === null || options === void 0 ? void 0 : options.skip) {
            return null;
        }
        return client.subscribe({
            query: subscription,
            variables: options === null || options === void 0 ? void 0 : options.variables,
            fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
            context: options === null || options === void 0 ? void 0 : options.context,
        });
    }), observable = _b[0], setObservable = _b[1];
    var canResetObservableRef = React.useRef(false);
    React.useEffect(function () {
        return function () {
            canResetObservableRef.current = true;
        };
    }, []);
    var ref = React.useRef({ client: client, subscription: subscription, options: options });
    React.useEffect(function () {
        var _a, _b, _c, _d;
        var shouldResubscribe = options === null || options === void 0 ? void 0 : options.shouldResubscribe;
        if (typeof shouldResubscribe === 'function') {
            shouldResubscribe = !!shouldResubscribe(options);
        }
        if (options === null || options === void 0 ? void 0 : options.skip) {
            if (!(options === null || options === void 0 ? void 0 : options.skip) !== !((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.skip) || canResetObservableRef.current) {
                setResult({
                    loading: false,
                    data: void 0,
                    error: void 0,
                    variables: options === null || options === void 0 ? void 0 : options.variables,
                });
                setObservable(null);
                canResetObservableRef.current = false;
            }
        }
        else if ((shouldResubscribe !== false &&
            (client !== ref.current.client ||
                subscription !== ref.current.subscription ||
                (options === null || options === void 0 ? void 0 : options.fetchPolicy) !== ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
                !(options === null || options === void 0 ? void 0 : options.skip) !== !((_c = ref.current.options) === null || _c === void 0 ? void 0 : _c.skip) ||
                !equal(options === null || options === void 0 ? void 0 : options.variables, (_d = ref.current.options) === null || _d === void 0 ? void 0 : _d.variables))) ||
            canResetObservableRef.current) {
            setResult({
                loading: true,
                data: void 0,
                error: void 0,
                variables: options === null || options === void 0 ? void 0 : options.variables,
            });
            setObservable(client.subscribe({
                query: subscription,
                variables: options === null || options === void 0 ? void 0 : options.variables,
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                context: options === null || options === void 0 ? void 0 : options.context,
            }));
            canResetObservableRef.current = false;
        }
        Object.assign(ref.current, { client: client, subscription: subscription, options: options });
    }, [client, subscription, options, canResetObservableRef.current]);
    React.useEffect(function () {
        if (!observable) {
            return;
        }
        var subscription = observable.subscribe({
            next: function (fetchResult) {
                var _a, _b;
                var result = {
                    loading: false,
                    data: fetchResult.data,
                    error: void 0,
                    variables: options === null || options === void 0 ? void 0 : options.variables,
                };
                setResult(result);
                if ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onData) {
                    ref.current.options.onData({
                        client: client,
                        data: result
                    });
                }
                else if ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onSubscriptionData) {
                    ref.current.options.onSubscriptionData({
                        client: client,
                        subscriptionData: result
                    });
                }
            },
            error: function (error) {
                var _a, _b;
                setResult({
                    loading: false,
                    data: void 0,
                    error: error,
                    variables: options === null || options === void 0 ? void 0 : options.variables,
                });
                (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 ? void 0 : _b.call(_a, error);
            },
            complete: function () {
                var _a, _b;
                if ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onComplete) {
                    ref.current.options.onComplete();
                }
                else if ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onSubscriptionComplete) {
                    ref.current.options.onSubscriptionComplete();
                }
            },
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [observable]);
    return result;
}

function useReactiveVar(rv) {
    var value = rv();
    var setValue = React.useState(value)[1];
    React.useEffect(function () {
        var probablySameValue = rv();
        if (value !== probablySameValue) {
            setValue(probablySameValue);
        }
        else {
            return rv.onNextChange(setValue);
        }
    }, [value]);
    return value;
}

function useFragment_experimental(options) {
    var cache = useApolloClient().cache;
    var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, rest = __rest$c(options, ["fragment", "fragmentName", "from", "optimistic"]);
    var diffOptions = __assign$l(__assign$l({}, rest), { id: typeof from === "string" ? from : cache.identify(from), query: cache["getFragmentDoc"](fragment, fragmentName), optimistic: optimistic });
    var resultRef = React.useRef();
    var latestDiff = cache.diff(diffOptions);
    return useSyncExternalStore(function (forceUpdate) {
        return cache.watch(__assign$l(__assign$l({}, diffOptions), { immediate: true, callback: function (diff) {
                if (!equal(diff, latestDiff)) {
                    resultRef.current = diffToResult(latestDiff = diff);
                    forceUpdate();
                }
            } }));
    }, function () {
        var latestDiffToResult = diffToResult(latestDiff);
        return resultRef.current &&
            equal(resultRef.current.data, latestDiffToResult.data)
            ? resultRef.current
            : (resultRef.current = latestDiffToResult);
    });
}
function diffToResult(diff) {
    var result = {
        data: diff.result,
        complete: !!diff.complete,
    };
    if (diff.missing) {
        result.missing = mergeDeepArray(diff.missing.map(function (error) { return error.missing; }));
    }
    return result;
}

var client = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ApolloClient: ApolloClient,
    mergeOptions: mergeOptions,
    ObservableQuery: ObservableQuery,
    get NetworkStatus () { return NetworkStatus; },
    isApolloError: isApolloError,
    ApolloError: ApolloError,
    get Cache () { return Cache; },
    ApolloCache: ApolloCache,
    InMemoryCache: InMemoryCache,
    MissingFieldError: MissingFieldError,
    defaultDataIdFromObject: defaultDataIdFromObject,
    makeVar: makeVar,
    fromError: fromError,
    toPromise: toPromise,
    fromPromise: fromPromise,
    throwServerError: throwServerError,
    Observable: Observable,
    isReference: isReference,
    makeReference: makeReference,
    get gql () { return gql; },
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables,
    empty: empty,
    from: from,
    split: split,
    concat: concat$1,
    execute: execute,
    ApolloLink: ApolloLink,
    parseAndCheckHttpResponse: parseAndCheckHttpResponse,
    serializeFetchParameter: serializeFetchParameter,
    fallbackHttpConfig: fallbackHttpConfig,
    defaultPrinter: defaultPrinter,
    selectHttpOptionsAndBody: selectHttpOptionsAndBody,
    selectHttpOptionsAndBodyInternal: selectHttpOptionsAndBodyInternal,
    checkFetcher: checkFetcher,
    createSignalIfSupported: createSignalIfSupported,
    selectURI: selectURI,
    createHttpLink: createHttpLink,
    HttpLink: HttpLink,
    rewriteURIForGET: rewriteURIForGET,
    setLogVerbosity: setVerbosity,
    ApolloProvider: ApolloProvider,
    ApolloConsumer: ApolloConsumer,
    getApolloContext: getApolloContext,
    resetApolloContext: getApolloContext,
    get DocumentType () { return DocumentType; },
    operationName: operationName,
    parser: parser,
    useQuery: useQuery,
    useApolloClient: useApolloClient,
    useLazyQuery: useLazyQuery,
    useMutation: useMutation,
    useSubscription: useSubscription,
    useReactiveVar: useReactiveVar,
    useFragment_experimental: useFragment_experimental
});

var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(client);

var __makeTemplateObject$4X = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AdminAuditFragment, "__esModule", { value: true });
AdminAuditFragment.ADMIN_AUDIT_FRAGMENT = void 0;
var client_1$5r = require$$0$1;
AdminAuditFragment.ADMIN_AUDIT_FRAGMENT = (0, client_1$5r.gql)(templateObject_1$4X || (templateObject_1$4X = __makeTemplateObject$4X(["\n  fragment AdminAudit on Audit {\n    id\n    employee {\n      firstName\n      lastName\n      email\n    }\n    score {\n      soviScores {\n        customerCasesCount\n        competitorCasesCount\n        category\n      }\n    }\n    dateCompleted\n    status\n    notes\n    store {\n      id\n      name\n      category\n      address {\n        address1\n      }\n    }\n  }\n"], ["\n  fragment AdminAudit on Audit {\n    id\n    employee {\n      firstName\n      lastName\n      email\n    }\n    score {\n      soviScores {\n        customerCasesCount\n        competitorCasesCount\n        category\n      }\n    }\n    dateCompleted\n    status\n    notes\n    store {\n      id\n      name\n      category\n      address {\n        address1\n      }\n    }\n  }\n"])));
var templateObject_1$4X;

var AdminAuditInventoryItemFragment = {};

var __makeTemplateObject$4W = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AdminAuditInventoryItemFragment, "__esModule", { value: true });
AdminAuditInventoryItemFragment.ADMIN_AUDIT_INVENTORY_ITEM_FRAGMENT = void 0;
var client_1$5q = require$$0$1;
AdminAuditInventoryItemFragment.ADMIN_AUDIT_INVENTORY_ITEM_FRAGMENT = (0, client_1$5q.gql)(templateObject_1$4W || (templateObject_1$4W = __makeTemplateObject$4W(["\n  fragment AdminAuditInventoryItem on AuditInventoryItem {\n    __typename\n    id\n    upc\n    quantity\n    name\n    product {\n    \tshipping {\n      \tproductsPerCase\n    \t}\n    }\n  }\n"], ["\n  fragment AdminAuditInventoryItem on AuditInventoryItem {\n    __typename\n    id\n    upc\n    quantity\n    name\n    product {\n    \tshipping {\n      \tproductsPerCase\n    \t}\n    }\n  }\n"])));
var templateObject_1$4W;

var AdminWholeAuditFragment = {};

var ProductPriceFragment = {};

var BrandFragment$1 = {};

var __makeTemplateObject$4V = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BrandFragment$1, "__esModule", { value: true });
BrandFragment$1.BRAND_FRAGMENT = void 0;
var client_1$5p = require$$0$1;
BrandFragment$1.BRAND_FRAGMENT = (0, client_1$5p.gql)(templateObject_1$4V || (templateObject_1$4V = __makeTemplateObject$4V(["\n  fragment Brand on Brand {\n    id\n    name\n  }\n"], ["\n  fragment Brand on Brand {\n    id\n    name\n  }\n"])));
var templateObject_1$4V;

var ManufacturerFragment$1 = {};

var __makeTemplateObject$4U = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ManufacturerFragment$1, "__esModule", { value: true });
ManufacturerFragment$1.MANUFACTURER_FRAGMENT = void 0;
var client_1$5o = require$$0$1;
ManufacturerFragment$1.MANUFACTURER_FRAGMENT = (0, client_1$5o.gql)(templateObject_1$4U || (templateObject_1$4U = __makeTemplateObject$4U(["\n  fragment Manufacturer on Manufacturer {\n    id\n    name\n  }\n"], ["\n  fragment Manufacturer on Manufacturer {\n    id\n    name\n  }\n"])));
var templateObject_1$4U;

var PackagingFragment$1 = {};

var __makeTemplateObject$4T = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PackagingFragment$1, "__esModule", { value: true });
PackagingFragment$1.PACKAGING_FRAGMENT = void 0;
var client_1$5n = require$$0$1;
PackagingFragment$1.PACKAGING_FRAGMENT = (0, client_1$5n.gql)(templateObject_1$4T || (templateObject_1$4T = __makeTemplateObject$4T(["\n  fragment Packaging on Packaging {\n    id\n    size\n    unit\n    quantity\n    container\n  }\n"], ["\n  fragment Packaging on Packaging {\n    id\n    size\n    unit\n    quantity\n    container\n  }\n"])));
var templateObject_1$4T;

var ProductPriceObjectFragment = {};

var __makeTemplateObject$4S = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ProductPriceObjectFragment, "__esModule", { value: true });
ProductPriceObjectFragment.PRODUCT_PRICE_OBJECT_FRAGMENT = void 0;
var client_1$5m = require$$0$1;
var BrandFragment_1$2 = BrandFragment$1;
var ManufacturerFragment_1$3 = ManufacturerFragment$1;
var PackagingFragment_1$7 = PackagingFragment$1;
ProductPriceObjectFragment.PRODUCT_PRICE_OBJECT_FRAGMENT = (0, client_1$5m.gql)(templateObject_1$4S || (templateObject_1$4S = __makeTemplateObject$4S(["\n  fragment ProductPriceObject on ProductPriceObject {\n    id\n    forStoreType\n    packaging {\n      ...Packaging\n    }\n    brand {\n      ...Brand\n    }\n    manufacturer {\n      ...Manufacturer\n    }\n    category {\n      id\n      category\n    }\n  }\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment ProductPriceObject on ProductPriceObject {\n    id\n    forStoreType\n    packaging {\n      ...Packaging\n    }\n    brand {\n      ...Brand\n    }\n    manufacturer {\n      ...Manufacturer\n    }\n    category {\n      id\n      category\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), PackagingFragment_1$7.PACKAGING_FRAGMENT, BrandFragment_1$2.BRAND_FRAGMENT, ManufacturerFragment_1$3.MANUFACTURER_FRAGMENT);
var templateObject_1$4S;

var __makeTemplateObject$4R = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ProductPriceFragment, "__esModule", { value: true });
ProductPriceFragment.PRODUCT_PRICE_FRAGMENT = void 0;
var client_1$5l = require$$0$1;
var BrandFragment_1$1 = BrandFragment$1;
var ManufacturerFragment_1$2 = ManufacturerFragment$1;
var PackagingFragment_1$6 = PackagingFragment$1;
var ProductPriceObjectFragment_1$1 = ProductPriceObjectFragment;
ProductPriceFragment.PRODUCT_PRICE_FRAGMENT = (0, client_1$5l.gql)(templateObject_1$4R || (templateObject_1$4R = __makeTemplateObject$4R(["\n  fragment ProductPrice on ProductPrice {\n    id\n    price\n    notAvailable\n    priceVisible\n    productPriceObject {\n      ...ProductPriceObject\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment ProductPrice on ProductPrice {\n    id\n    price\n    notAvailable\n    priceVisible\n    productPriceObject {\n      ...ProductPriceObject\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), ProductPriceObjectFragment_1$1.PRODUCT_PRICE_OBJECT_FRAGMENT, PackagingFragment_1$6.PACKAGING_FRAGMENT, BrandFragment_1$1.BRAND_FRAGMENT, ManufacturerFragment_1$2.MANUFACTURER_FRAGMENT);
var templateObject_1$4R;

var ScoreFragments = {};

(function (exports) {
var __makeTemplateObject = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_SCORE_FRAGMENT = exports.CATEGORY_SCORE_FRAGMENT = exports.SCORE_FRAGMENT = void 0;
var client_1 = require$$0$1;
exports.SCORE_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment Score on Score {\n    numerator\n    denominator\n  }\n"], ["\n  fragment Score on Score {\n    numerator\n    denominator\n  }\n"])));
exports.CATEGORY_SCORE_FRAGMENT = (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fragment CategoryScore on CategoryScore {\n    customerCasesCount\n    competitorCasesCount\n    category\n  }\n"], ["\n  fragment CategoryScore on CategoryScore {\n    customerCasesCount\n    competitorCasesCount\n    category\n  }\n"])));
exports.AUDIT_SCORE_FRAGMENT = (0, client_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  fragment AuditScore on AuditScore {\n    created\n    modified\n    id\n    questions {\n      ...Score\n    }\n    soviScores {\n      ...CategoryScore\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment AuditScore on AuditScore {\n    created\n    modified\n    id\n    questions {\n      ...Score\n    }\n    soviScores {\n      ...CategoryScore\n    }\n  }\n  ", "\n  ", "\n"])), exports.CATEGORY_SCORE_FRAGMENT, exports.SCORE_FRAGMENT);
var templateObject_1, templateObject_2, templateObject_3;
}(ScoreFragments));

var AuditAnswerFragment = {};

var __makeTemplateObject$4Q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AuditAnswerFragment, "__esModule", { value: true });
AuditAnswerFragment.AUDIT_ANSWER_FRAGMENT = void 0;
var client_1$5k = require$$0$1;
AuditAnswerFragment.AUDIT_ANSWER_FRAGMENT = (0, client_1$5k.gql)(templateObject_1$4Q || (templateObject_1$4Q = __makeTemplateObject$4Q(["\n  fragment AuditAnswer on AuditAnswer {\n    id\n    question\n    answeredYes\n    questionId\n    image {\n      id\n      url\n      saved\n    }\n  }\n"], ["\n  fragment AuditAnswer on AuditAnswer {\n    id\n    question\n    answeredYes\n    questionId\n    image {\n      id\n      url\n      saved\n    }\n  }\n"])));
var templateObject_1$4Q;

var CRCountItemFragment = {};

var CRCountTypeFragment = {};

var __makeTemplateObject$4P = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CRCountTypeFragment, "__esModule", { value: true });
CRCountTypeFragment.CR_COUNT_TYPE_FRAGMENT = void 0;
var client_1$5j = require$$0$1;
CRCountTypeFragment.CR_COUNT_TYPE_FRAGMENT = (0, client_1$5j.gql)(templateObject_1$4P || (templateObject_1$4P = __makeTemplateObject$4P(["\n  fragment CRCountType on CRCountType {\n    id\n    countType\n    category {\n      id\n      category\n    }\n  }\n"], ["\n  fragment CRCountType on CRCountType {\n    id\n    countType\n    category {\n      id\n      category\n    }\n  }\n"])));
var templateObject_1$4P;

var __makeTemplateObject$4O = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CRCountItemFragment, "__esModule", { value: true });
CRCountItemFragment.CR_COUNT_ITEM_FRAGMENT = void 0;
var client_1$5i = require$$0$1;
var CRCountTypeFragment_1 = CRCountTypeFragment;
CRCountItemFragment.CR_COUNT_ITEM_FRAGMENT = (0, client_1$5i.gql)(templateObject_1$4O || (templateObject_1$4O = __makeTemplateObject$4O(["\n  fragment CRCountItem on CRCountItem {\n    id\n    customerCount\n    competitorCount\n    storeAudit {\n      id\n    }\n    countType {\n      ...CRCountType\n    }\n  }\n  ", "\n"], ["\n  fragment CRCountItem on CRCountItem {\n    id\n    customerCount\n    competitorCount\n    storeAudit {\n      id\n    }\n    countType {\n      ...CRCountType\n    }\n  }\n  ", "\n"])), CRCountTypeFragment_1.CR_COUNT_TYPE_FRAGMENT);
var templateObject_1$4O;

var AdminWholeDisplayAuditFragment = {};

var __makeTemplateObject$4N = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AdminWholeDisplayAuditFragment, "__esModule", { value: true });
AdminWholeDisplayAuditFragment.ADMIN_WHOLE_DISPLAY_AUDIT_FRAGMENT = void 0;
var client_1$5h = require$$0$1;
var AdminAuditInventoryItemFragment_1 = AdminAuditInventoryItemFragment;
AdminWholeDisplayAuditFragment.ADMIN_WHOLE_DISPLAY_AUDIT_FRAGMENT = (0, client_1$5h.gql)(templateObject_1$4N || (templateObject_1$4N = __makeTemplateObject$4N(["\n  fragment AdminWholeDisplayAudit on DisplayAudit {\n    __typename\n    id\n    predictions\n    products {\n      ...AdminAuditInventoryItem\n    }\n    dateCompleted\n    display {\n      id\n      area\n      displayType\n      shortDescription\n      isCompetitor\n    }\n    employee {\n      id\n      email\n    }\n  }\n  ", "\n"], ["\n  fragment AdminWholeDisplayAudit on DisplayAudit {\n    __typename\n    id\n    predictions\n    products {\n      ...AdminAuditInventoryItem\n    }\n    dateCompleted\n    display {\n      id\n      area\n      displayType\n      shortDescription\n      isCompetitor\n    }\n    employee {\n      id\n      email\n    }\n  }\n  ", "\n"])), AdminAuditInventoryItemFragment_1.ADMIN_AUDIT_INVENTORY_ITEM_FRAGMENT);
var templateObject_1$4N;

var __makeTemplateObject$4M = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AdminWholeAuditFragment, "__esModule", { value: true });
AdminWholeAuditFragment.ADMIN_WHOLE_AUDIT_FRAGMENT = void 0;
var client_1$5g = require$$0$1;
var ProductPriceFragment_1$1 = ProductPriceFragment;
var ScoreFragments_1$2 = ScoreFragments;
var AuditAnswerFragment_1$1 = AuditAnswerFragment;
var CRCountItemFragment_1$1 = CRCountItemFragment;
var AdminWholeDisplayAuditFragment_1 = AdminWholeDisplayAuditFragment;
AdminWholeAuditFragment.ADMIN_WHOLE_AUDIT_FRAGMENT = (0, client_1$5g.gql)(templateObject_1$4M || (templateObject_1$4M = __makeTemplateObject$4M(["\n  fragment AdminWholeAudit on Audit {\n    id\n    created\n    saved\n    dateCompleted\n    displaysCompletedAt\n    pricingCompletedAt\n    surveyCompletedAt\n    employee {\n      firstName\n      lastName\n      id\n      email\n    }\n    store {\n      id\n      storeChain\n      name\n      hasAllFormulas\n      address {\n        address1\n        city\n        state\n        postalCode\n      }\n    }\n    status\n    score {\n      ...AuditScore\n    }\n    notes\n    auditAnswers {\n      ...AuditAnswer\n    }\n    displayAudits {\n      ...AdminWholeDisplayAudit\n    }\n    crCountItems {\n      ...CRCountItem\n    }\n    productPrices {\n      ...ProductPrice\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment AdminWholeAudit on Audit {\n    id\n    created\n    saved\n    dateCompleted\n    displaysCompletedAt\n    pricingCompletedAt\n    surveyCompletedAt\n    employee {\n      firstName\n      lastName\n      id\n      email\n    }\n    store {\n      id\n      storeChain\n      name\n      hasAllFormulas\n      address {\n        address1\n        city\n        state\n        postalCode\n      }\n    }\n    status\n    score {\n      ...AuditScore\n    }\n    notes\n    auditAnswers {\n      ...AuditAnswer\n    }\n    displayAudits {\n      ...AdminWholeDisplayAudit\n    }\n    crCountItems {\n      ...CRCountItem\n    }\n    productPrices {\n      ...ProductPrice\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), AuditAnswerFragment_1$1.AUDIT_ANSWER_FRAGMENT, ScoreFragments_1$2.AUDIT_SCORE_FRAGMENT, AdminWholeDisplayAuditFragment_1.ADMIN_WHOLE_DISPLAY_AUDIT_FRAGMENT, ProductPriceFragment_1$1.PRODUCT_PRICE_FRAGMENT, CRCountItemFragment_1$1.CR_COUNT_ITEM_FRAGMENT);
var templateObject_1$4M;

var AdminStoreFragment = {};

var __makeTemplateObject$4L = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AdminStoreFragment, "__esModule", { value: true });
AdminStoreFragment.ADMIN_STORE_FRAGMENT = void 0;
var client_1$5f = require$$0$1;
AdminStoreFragment.ADMIN_STORE_FRAGMENT = (0, client_1$5f.gql)(templateObject_1$4L || (templateObject_1$4L = __makeTemplateObject$4L(["\n  fragment AdminStore on CompanyStore {\n    id\n    totalAudits\n    distance\n    physicalStoreId\n    storeChain\n    name\n    internalStoreId\n    category\n    hasAllFormulas\n    isActive\n    allOptimizingPaused\n    optimizingPausedAt\n    resumeOptimizingAt\n    numTimesOptimizeHighPerYear\n    numTimesOptimizeMediumPerYear\n    numTimesOptimizeLowPerYear\n    timesPerWeekTwoDScan\n    image {\n      id\n      url\n    }\n    address {\n      address1\n      address2\n      city\n      state\n      postalCode\n    }\n    point {\n      latitude\n      longitude\n    }\n    lastAudit\n    daysSinceAudit\n    region {\n      name\n    }\n    categorySoviFormulaGroup {\n      id\n      name\n    }\n    coldAvailabilityFormulaGroup {\n      id\n      name\n    }\n    users {\n      email\n    }\n  }\n"], ["\n  fragment AdminStore on CompanyStore {\n    id\n    totalAudits\n    distance\n    physicalStoreId\n    storeChain\n    name\n    internalStoreId\n    category\n    hasAllFormulas\n    isActive\n    allOptimizingPaused\n    optimizingPausedAt\n    resumeOptimizingAt\n    numTimesOptimizeHighPerYear\n    numTimesOptimizeMediumPerYear\n    numTimesOptimizeLowPerYear\n    timesPerWeekTwoDScan\n    image {\n      id\n      url\n    }\n    address {\n      address1\n      address2\n      city\n      state\n      postalCode\n    }\n    point {\n      latitude\n      longitude\n    }\n    lastAudit\n    daysSinceAudit\n    region {\n      name\n    }\n    categorySoviFormulaGroup {\n      id\n      name\n    }\n    coldAvailabilityFormulaGroup {\n      id\n      name\n    }\n    users {\n      email\n    }\n  }\n"])));
var templateObject_1$4L;

var AuditInventoryItemFragment = {};

var __makeTemplateObject$4K = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AuditInventoryItemFragment, "__esModule", { value: true });
AuditInventoryItemFragment.AUDIT_INVENTORY_ITEM_FRAGMENT = void 0;
var client_1$5e = require$$0$1;
AuditInventoryItemFragment.AUDIT_INVENTORY_ITEM_FRAGMENT = (0, client_1$5e.gql)(templateObject_1$4K || (templateObject_1$4K = __makeTemplateObject$4K(["\n  fragment AuditInventoryItem on AuditInventoryItem {\n    __typename\n    id\n    upc\n    quantity\n    facingsQuantity\n  }\n"], ["\n  fragment AuditInventoryItem on AuditInventoryItem {\n    __typename\n    id\n    upc\n    quantity\n    facingsQuantity\n  }\n"])));
var templateObject_1$4K;

var AuditFragment = {};

var __makeTemplateObject$4J = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AuditFragment, "__esModule", { value: true });
AuditFragment.AUDIT_FRAGMENT = void 0;
var client_1$5d = require$$0$1;
AuditFragment.AUDIT_FRAGMENT = (0, client_1$5d.gql)(templateObject_1$4J || (templateObject_1$4J = __makeTemplateObject$4J(["\n  fragment Audit on Audit {\n    id\n    employee {\n      firstName\n      lastName\n      email\n    }\n    dateCompleted\n    status\n    notes\n    store {\n      id\n      name\n      category\n      address {\n        address1\n      }\n    }\n  }\n"], ["\n  fragment Audit on Audit {\n    id\n    employee {\n      firstName\n      lastName\n      email\n    }\n    dateCompleted\n    status\n    notes\n    store {\n      id\n      name\n      category\n      address {\n        address1\n      }\n    }\n  }\n"])));
var templateObject_1$4J;

var BasicBoundingBoxesFragment = {};

var BasicProductFragment = {};

var __makeTemplateObject$4I = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BasicProductFragment, "__esModule", { value: true });
BasicProductFragment.BASIC_PRODUCT_FRAGMENT = void 0;
var client_1$5c = require$$0$1;
BasicProductFragment.BASIC_PRODUCT_FRAGMENT = (0, client_1$5c.gql)(templateObject_1$4I || (templateObject_1$4I = __makeTemplateObject$4I(["\n  fragment BasicProduct on Product {\n    id\n    upcA\n    name\n    marketingImageUrl\n  }\n"], ["\n  fragment BasicProduct on Product {\n    id\n    upcA\n    name\n    marketingImageUrl\n  }\n"])));
var templateObject_1$4I;

var __makeTemplateObject$4H = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BasicBoundingBoxesFragment, "__esModule", { value: true });
BasicBoundingBoxesFragment.BASIC_BOUNDING_BOXES_FRAGMENT = void 0;
var client_1$5b = require$$0$1;
var BasicProductFragment_1$1 = BasicProductFragment;
BasicBoundingBoxesFragment.BASIC_BOUNDING_BOXES_FRAGMENT = (0, client_1$5b.gql)(templateObject_1$4H || (templateObject_1$4H = __makeTemplateObject$4H(["\n  fragment BasicBoundingBoxes on BoundingBoxSet {\n    id\n    created\n    modified\n    verified\n    boundingBoxes {\n      id\n      label\n      verifiedLocation\n      confidence\n      coordinates {\n        minX\n        maxX\n        minY\n        maxY\n      }\n    }\n  }\n  ", "\n"], ["\n  fragment BasicBoundingBoxes on BoundingBoxSet {\n    id\n    created\n    modified\n    verified\n    boundingBoxes {\n      id\n      label\n      verifiedLocation\n      confidence\n      coordinates {\n        minX\n        maxX\n        minY\n        maxY\n      }\n    }\n  }\n  ", "\n"])), BasicProductFragment_1$1.BASIC_PRODUCT_FRAGMENT);
var templateObject_1$4H;

var AuditQuestionFragment = {};

var __makeTemplateObject$4G = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AuditQuestionFragment, "__esModule", { value: true });
AuditQuestionFragment.AUDIT_QUESTION_FRAGMENT = void 0;
var client_1$5a = require$$0$1;
AuditQuestionFragment.AUDIT_QUESTION_FRAGMENT = (0, client_1$5a.gql)(templateObject_1$4G || (templateObject_1$4G = __makeTemplateObject$4G(["\n  fragment AuditQuestion on AuditQuestion {\n    id\n    question\n    category\n    pointWorth\n    group\n    active\n    hideInApp\n  }\n"], ["\n  fragment AuditQuestion on AuditQuestion {\n    id\n    question\n    category\n    pointWorth\n    group\n    active\n    hideInApp\n  }\n"])));
var templateObject_1$4G;

var BasicDisplayAuditImageFragment = {};

var __makeTemplateObject$4F = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BasicDisplayAuditImageFragment, "__esModule", { value: true });
BasicDisplayAuditImageFragment.BASIC_DISPLAY_AUDIT_IMAGE_FRAGMENT = void 0;
var client_1$59 = require$$0$1;
var BasicBoundingBoxesFragment_1 = BasicBoundingBoxesFragment;
var BasicProductFragment_1 = BasicProductFragment;
BasicDisplayAuditImageFragment.BASIC_DISPLAY_AUDIT_IMAGE_FRAGMENT = (0, client_1$59.gql)(templateObject_1$4F || (templateObject_1$4F = __makeTemplateObject$4F(["\n  fragment BasicDisplayAuditImage on DisplayAuditImage {\n    id\n    url\n    created\n    boundingBoxSet {\n      ...BasicBoundingBoxes\n    }\n    products {\n      ...BasicProduct\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment BasicDisplayAuditImage on DisplayAuditImage {\n    id\n    url\n    created\n    boundingBoxSet {\n      ...BasicBoundingBoxes\n    }\n    products {\n      ...BasicProduct\n    }\n  }\n  ", "\n  ", "\n"])), BasicBoundingBoxesFragment_1.BASIC_BOUNDING_BOXES_FRAGMENT, BasicProductFragment_1.BASIC_PRODUCT_FRAGMENT);
var templateObject_1$4F;

var BoundingBoxesFragment = {};

var WhiteRabbitProductFragment = {};

var ShippingFragment$1 = {};

var __makeTemplateObject$4E = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ShippingFragment$1, "__esModule", { value: true });
ShippingFragment$1.SHIPPING_FRAGMENT = void 0;
var client_1$58 = require$$0$1;
ShippingFragment$1.SHIPPING_FRAGMENT = (0, client_1$58.gql)(templateObject_1$4E || (templateObject_1$4E = __makeTemplateObject$4E(["\n  fragment Shipping on Shipping {\n    id\n    consumablesPerCase\n    productsPerCase\n  }\n"], ["\n  fragment Shipping on Shipping {\n    id\n    consumablesPerCase\n    productsPerCase\n  }\n"])));
var templateObject_1$4E;

var __makeTemplateObject$4D = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(WhiteRabbitProductFragment, "__esModule", { value: true });
WhiteRabbitProductFragment.WHITE_RABBIT_SIMPLE_PRODUCT_FRAGMENT = void 0;
var client_1$57 = require$$0$1;
var PackagingFragment_1$5 = PackagingFragment$1;
var ShippingFragment_1$4 = ShippingFragment$1;
WhiteRabbitProductFragment.WHITE_RABBIT_SIMPLE_PRODUCT_FRAGMENT = (0, client_1$57.gql)(templateObject_1$4D || (templateObject_1$4D = __makeTemplateObject$4D(["\n  fragment WhiteRabbitSimpleProduct on Product {\n    id\n    upcA\n    upcE\n    name\n    isActive\n    brand {\n      id\n      name\n    }\n    manufacturer {\n      id\n      name\n    }\n    marketingImageUrl\n    packaging {\n      ...Packaging\n    }\n    shipping {\n      ...Shipping\n    }\n    flavors {\n      id\n      flavor\n      displayFlavor\n    }\n    companyCategory {\n      id\n      category\n      parentCategory\n    }\n    geometry {\n      id\n      geometry\n    }\n    verifiedBy\n  }\n  ", "\n  ", "\n"], ["\n  fragment WhiteRabbitSimpleProduct on Product {\n    id\n    upcA\n    upcE\n    name\n    isActive\n    brand {\n      id\n      name\n    }\n    manufacturer {\n      id\n      name\n    }\n    marketingImageUrl\n    packaging {\n      ...Packaging\n    }\n    shipping {\n      ...Shipping\n    }\n    flavors {\n      id\n      flavor\n      displayFlavor\n    }\n    companyCategory {\n      id\n      category\n      parentCategory\n    }\n    geometry {\n      id\n      geometry\n    }\n    verifiedBy\n  }\n  ", "\n  ", "\n"])), PackagingFragment_1$5.PACKAGING_FRAGMENT, ShippingFragment_1$4.SHIPPING_FRAGMENT);
var templateObject_1$4D;

var __makeTemplateObject$4C = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BoundingBoxesFragment, "__esModule", { value: true });
BoundingBoxesFragment.BOUNDING_BOXES_FRAGMENT = void 0;
var client_1$56 = require$$0$1;
var WhiteRabbitProductFragment_1$1 = WhiteRabbitProductFragment;
BoundingBoxesFragment.BOUNDING_BOXES_FRAGMENT = (0, client_1$56.gql)(templateObject_1$4C || (templateObject_1$4C = __makeTemplateObject$4C(["\n  fragment BoundingBoxes on BoundingBoxSet {\n    id\n    created\n    modified\n    verified\n    verifiedBy {\n      id\n      firstName\n      lastName\n      email\n    }\n    verifiedDate\n    boundingBoxes {\n      id\n      label\n      verifiedLocation\n      elDoradoId\n      confidence\n      coordinates {\n        minX\n        maxX\n        minY\n        maxY\n      }\n      verified\n    }\n  }\n  ", "\n"], ["\n  fragment BoundingBoxes on BoundingBoxSet {\n    id\n    created\n    modified\n    verified\n    verifiedBy {\n      id\n      firstName\n      lastName\n      email\n    }\n    verifiedDate\n    boundingBoxes {\n      id\n      label\n      verifiedLocation\n      elDoradoId\n      confidence\n      coordinates {\n        minX\n        maxX\n        minY\n        maxY\n      }\n      verified\n    }\n  }\n  ", "\n"])), WhiteRabbitProductFragment_1$1.WHITE_RABBIT_SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$4C;

var BoundingCubeFragment = {};

var PointFragment = {};

var __makeTemplateObject$4B = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PointFragment, "__esModule", { value: true });
PointFragment.POINT_FRAGMENT = void 0;
var client_1$55 = require$$0$1;
PointFragment.POINT_FRAGMENT = (0, client_1$55.gql)(templateObject_1$4B || (templateObject_1$4B = __makeTemplateObject$4B(["\n  fragment Point on Point {\n    x\n    y\n    z\n  }\n"], ["\n  fragment Point on Point {\n    x\n    y\n    z\n  }\n"])));
var templateObject_1$4B;

var __makeTemplateObject$4A = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BoundingCubeFragment, "__esModule", { value: true });
BoundingCubeFragment.BOUNDING_CUBE_FRAGMENT = void 0;
var client_1$54 = require$$0$1;
var PointFragment_1 = PointFragment;
BoundingCubeFragment.BOUNDING_CUBE_FRAGMENT = (0, client_1$54.gql)(templateObject_1$4A || (templateObject_1$4A = __makeTemplateObject$4A(["\n  fragment BoundingCube on BoundingCube {\n    x1 {\n      ...Point\n    }\n    x2 {\n      ...Point\n    }\n    y1 {\n      ...Point\n    }\n    z1 {\n      ...Point\n    }\n    width\n    height\n    depth\n  }\n  ", "\n"], ["\n  fragment BoundingCube on BoundingCube {\n    x1 {\n      ...Point\n    }\n    x2 {\n      ...Point\n    }\n    y1 {\n      ...Point\n    }\n    z1 {\n      ...Point\n    }\n    width\n    height\n    depth\n  }\n  ", "\n"])), PointFragment_1.POINT_FRAGMENT);
var templateObject_1$4A;

var ComplianceAuditFragment = {};

var SegmentComplianceGroupFragment = {};

var ShelfComplianceGroupFragment = {};

var ModComActualFacing = {};

var __makeTemplateObject$4z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ModComActualFacing, "__esModule", { value: true });
ModComActualFacing.MOD_COM_ACTUAL_FACING = void 0;
var client_1$53 = require$$0$1;
ModComActualFacing.MOD_COM_ACTUAL_FACING = (0, client_1$53.gql)(templateObject_1$4z || (templateObject_1$4z = __makeTemplateObject$4z(["\n  fragment ModComActualFacing on Actual {\n    upc\n    index\n    vFacingUpcs\n    distanceFromHome\n  }\n"], ["\n  fragment ModComActualFacing on Actual {\n    upc\n    index\n    vFacingUpcs\n    distanceFromHome\n  }\n"])));
var templateObject_1$4z;

var __makeTemplateObject$4y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ShelfComplianceGroupFragment, "__esModule", { value: true });
ShelfComplianceGroupFragment.SHELF_COMPLIANCE_GROUP_FRAGMENT = void 0;
var client_1$52 = require$$0$1;
var ModComActualFacing_1 = ModComActualFacing;
ShelfComplianceGroupFragment.SHELF_COMPLIANCE_GROUP_FRAGMENT = (0, client_1$52.gql)(templateObject_1$4y || (templateObject_1$4y = __makeTemplateObject$4y(["\n  fragment ShelfComplianceGroup on ShelfComplianceGroup {\n    id\n    strictScore\n    sequenceScore\n    shelf {\n      isUnderShelf\n      yOffset\n      depth\n      displayShelfNumber\n      segmentShelfNumber\n    }\n    productScores {\n      upc\n      totalProductFullness\n      requiredVerticalFacings\n      requiredFacingsCount\n      compliantFacingsCount\n      totalAvailableProducts\n    }\n    facingScores {\n      upc\n      score\n      issue\n      resolved\n      actuals {\n        ...ModComActualFacing\n      }\n    }\n  }\n  ", "\n"], ["\n  fragment ShelfComplianceGroup on ShelfComplianceGroup {\n    id\n    strictScore\n    sequenceScore\n    shelf {\n      isUnderShelf\n      yOffset\n      depth\n      displayShelfNumber\n      segmentShelfNumber\n    }\n    productScores {\n      upc\n      totalProductFullness\n      requiredVerticalFacings\n      requiredFacingsCount\n      compliantFacingsCount\n      totalAvailableProducts\n    }\n    facingScores {\n      upc\n      score\n      issue\n      resolved\n      actuals {\n        ...ModComActualFacing\n      }\n    }\n  }\n  ", "\n"])), ModComActualFacing_1.MOD_COM_ACTUAL_FACING);
var templateObject_1$4y;

var __makeTemplateObject$4x = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SegmentComplianceGroupFragment, "__esModule", { value: true });
SegmentComplianceGroupFragment.SEGMENT_COMPLIANCE_GROUP_FRAGMENT = void 0;
var client_1$51 = require$$0$1;
var ShelfComplianceGroupFragment_1 = ShelfComplianceGroupFragment;
SegmentComplianceGroupFragment.SEGMENT_COMPLIANCE_GROUP_FRAGMENT = (0, client_1$51.gql)(templateObject_1$4x || (templateObject_1$4x = __makeTemplateObject$4x(["\n  fragment SegmentComplianceGroup on SegmentComplianceGroup {\n    id\n    segment {\n      segmentNumber\n    }\n    scanComplete\n    strictScore\n    sequenceScore\n    shelfCompliance {\n      ...ShelfComplianceGroup\n    }\n  }\n  ", "\n"], ["\n  fragment SegmentComplianceGroup on SegmentComplianceGroup {\n    id\n    segment {\n      segmentNumber\n    }\n    scanComplete\n    strictScore\n    sequenceScore\n    shelfCompliance {\n      ...ShelfComplianceGroup\n    }\n  }\n  ", "\n"])), ShelfComplianceGroupFragment_1.SHELF_COMPLIANCE_GROUP_FRAGMENT);
var templateObject_1$4x;

var UserFragment = {};

var __makeTemplateObject$4w = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UserFragment, "__esModule", { value: true });
UserFragment.USER_FRAGMENT = void 0;
var client_1$50 = require$$0$1;
UserFragment.USER_FRAGMENT = (0, client_1$50.gql)(templateObject_1$4w || (templateObject_1$4w = __makeTemplateObject$4w(["\n  fragment User on User {\n    uuid\n    id\n    email\n    firstName\n    lastName\n    username\n    created\n    isStaff\n    isSuperuser\n    isActive\n    customerUserId\n    mainRole\n    roles\n    supervisor {\n      firstName\n      lastName\n    }\n    stores {\n      id\n    }\n  }\n"], ["\n  fragment User on User {\n    uuid\n    id\n    email\n    firstName\n    lastName\n    username\n    created\n    isStaff\n    isSuperuser\n    isActive\n    customerUserId\n    mainRole\n    roles\n    supervisor {\n      firstName\n      lastName\n    }\n    stores {\n      id\n    }\n  }\n"])));
var templateObject_1$4w;

var __makeTemplateObject$4v = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ComplianceAuditFragment, "__esModule", { value: true });
ComplianceAuditFragment.MODULAR_COMPLIANCE_AUDIT_FRAGMENT = void 0;
var client_1$4$ = require$$0$1;
var SegmentComplianceGroupFragment_1 = SegmentComplianceGroupFragment;
var UserFragment_1$7 = UserFragment;
ComplianceAuditFragment.MODULAR_COMPLIANCE_AUDIT_FRAGMENT = (0, client_1$4$.gql)(templateObject_1$4v || (templateObject_1$4v = __makeTemplateObject$4v(["\n  fragment ComplianceAudit on ComplianceAudit {\n    id\n    displayId\n    dateCompleted\n    saved\n    strictScore\n    sequenceScore\n    employee {\n      ...User\n    }\n    segmentCompliance {\n      ...SegmentComplianceGroup\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment ComplianceAudit on ComplianceAudit {\n    id\n    displayId\n    dateCompleted\n    saved\n    strictScore\n    sequenceScore\n    employee {\n      ...User\n    }\n    segmentCompliance {\n      ...SegmentComplianceGroup\n    }\n  }\n  ", "\n  ", "\n"])), SegmentComplianceGroupFragment_1.SEGMENT_COMPLIANCE_GROUP_FRAGMENT, UserFragment_1$7.USER_FRAGMENT);
var templateObject_1$4v;

var CubeDimensions = {};

var __makeTemplateObject$4u = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CubeDimensions, "__esModule", { value: true });
CubeDimensions.CUBE_DIMENSIONS = void 0;
var client_1$4_ = require$$0$1;
CubeDimensions.CUBE_DIMENSIONS = (0, client_1$4_.gql)(templateObject_1$4u || (templateObject_1$4u = __makeTemplateObject$4u(["\n  fragment CubeDimensions on CubeDimensions {\n    width\n    height\n    depth\n  }\n"], ["\n  fragment CubeDimensions on CubeDimensions {\n    width\n    height\n    depth\n  }\n"])));
var templateObject_1$4u;

var DIsplaySegmentFragment = {};

var DisplayShelfFragment = {};

var __makeTemplateObject$4t = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DisplayShelfFragment, "__esModule", { value: true });
DisplayShelfFragment.DISPLAY_SHELF_FRAGMENT = void 0;
var client_1$4Z = require$$0$1;
DisplayShelfFragment.DISPLAY_SHELF_FRAGMENT = (0, client_1$4Z.gql)(templateObject_1$4t || (templateObject_1$4t = __makeTemplateObject$4t(["\n  fragment DisplayShelf on DisplayShelf {\n    id\n    name\n    displayShelfNumber\n    segmentShelfNumber\n    isUnderShelf\n    height\n    shoppableHeight\n    width\n    depth\n    yOffset\n    products {\n      upc\n      name\n      package\n      orientation\n      facings\n      vFacings\n      startX\n      endX\n      width\n      height\n      depth\n      otherUpcs\n    }\n  }\n"], ["\n  fragment DisplayShelf on DisplayShelf {\n    id\n    name\n    displayShelfNumber\n    segmentShelfNumber\n    isUnderShelf\n    height\n    shoppableHeight\n    width\n    depth\n    yOffset\n    products {\n      upc\n      name\n      package\n      orientation\n      facings\n      vFacings\n      startX\n      endX\n      width\n      height\n      depth\n      otherUpcs\n    }\n  }\n"])));
var templateObject_1$4t;

var __makeTemplateObject$4s = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DIsplaySegmentFragment, "__esModule", { value: true });
DIsplaySegmentFragment.DISPLAY_SEGMENT_FRAGMENT = void 0;
var client_1$4Y = require$$0$1;
var DisplayShelfFragment_1 = DisplayShelfFragment;
DIsplaySegmentFragment.DISPLAY_SEGMENT_FRAGMENT = (0, client_1$4Y.gql)(templateObject_1$4s || (templateObject_1$4s = __makeTemplateObject$4s(["\n  fragment DisplaySegment on DisplaySegment {\n    id\n    name\n    segmentNumber\n    shelves {\n      ...DisplayShelf\n    }\n    height\n    width\n    depth\n    xOffset\n  }\n  ", "\n"], ["\n  fragment DisplaySegment on DisplaySegment {\n    id\n    name\n    segmentNumber\n    shelves {\n      ...DisplayShelf\n    }\n    height\n    width\n    depth\n    xOffset\n  }\n  ", "\n"])), DisplayShelfFragment_1.DISPLAY_SHELF_FRAGMENT);
var templateObject_1$4s;

var DisplayAuditFragment = {};

var __makeTemplateObject$4r = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DisplayAuditFragment, "__esModule", { value: true });
DisplayAuditFragment.DISPLAY_AUDIT_FRAGMENT = void 0;
var client_1$4X = require$$0$1;
var AuditInventoryItemFragment_1$1 = AuditInventoryItemFragment;
DisplayAuditFragment.DISPLAY_AUDIT_FRAGMENT = (0, client_1$4X.gql)(templateObject_1$4r || (templateObject_1$4r = __makeTemplateObject$4r(["\n  fragment DisplayAudit on DisplayAudit {\n    __typename\n    id\n    predictions\n    products {\n      ...AuditInventoryItem\n    }\n    dateCompleted\n    display {\n      id\n      isCompetitor\n      area\n    }\n  }\n  ", "\n"], ["\n  fragment DisplayAudit on DisplayAudit {\n    __typename\n    id\n    predictions\n    products {\n      ...AuditInventoryItem\n    }\n    dateCompleted\n    display {\n      id\n      isCompetitor\n      area\n    }\n  }\n  ", "\n"])), AuditInventoryItemFragment_1$1.AUDIT_INVENTORY_ITEM_FRAGMENT);
var templateObject_1$4r;

var DisplayAuditImageFragment = {};

var __makeTemplateObject$4q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DisplayAuditImageFragment, "__esModule", { value: true });
DisplayAuditImageFragment.DISPLAY_AUDIT_IMAGE_FRAGMENT = void 0;
var client_1$4W = require$$0$1;
var BoundingBoxesFragment_1$4 = BoundingBoxesFragment;
var WhiteRabbitProductFragment_1 = WhiteRabbitProductFragment;
DisplayAuditImageFragment.DISPLAY_AUDIT_IMAGE_FRAGMENT = (0, client_1$4W.gql)(templateObject_1$4q || (templateObject_1$4q = __makeTemplateObject$4q(["\n  fragment DisplayAuditImage on DisplayAuditImage {\n    id\n    url\n    boundingBoxSet {\n      ...BoundingBoxes\n    }\n    products {\n      ...WhiteRabbitSimpleProduct\n    }\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        email\n      }\n      levelRaisedBy {\n        email\n        firstName\n        lastName\n      }\n      date\n    }\n    protectedBoxes {\n      id\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment DisplayAuditImage on DisplayAuditImage {\n    id\n    url\n    boundingBoxSet {\n      ...BoundingBoxes\n    }\n    products {\n      ...WhiteRabbitSimpleProduct\n    }\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        email\n      }\n      levelRaisedBy {\n        email\n        firstName\n        lastName\n      }\n      date\n    }\n    protectedBoxes {\n      id\n    }\n  }\n  ", "\n  ", "\n"])), BoundingBoxesFragment_1$4.BOUNDING_BOXES_FRAGMENT, WhiteRabbitProductFragment_1.WHITE_RABBIT_SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$4q;

var DisplayFragmentWithPlanogram = {};

var PlanogramFragment = {};

var __makeTemplateObject$4p = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PlanogramFragment, "__esModule", { value: true });
PlanogramFragment.PLANOGRAM_FRAGMENT = void 0;
var client_1$4V = require$$0$1;
var DIsplaySegmentFragment_1 = DIsplaySegmentFragment;
PlanogramFragment.PLANOGRAM_FRAGMENT = (0, client_1$4V.gql)(templateObject_1$4p || (templateObject_1$4p = __makeTemplateObject$4p(["\n  fragment Planogram on Planogram {\n    numSegments\n    segments {\n      ...DisplaySegment\n    }\n  }\n  ", "\n"], ["\n  fragment Planogram on Planogram {\n    numSegments\n    segments {\n      ...DisplaySegment\n    }\n  }\n  ", "\n"])), DIsplaySegmentFragment_1.DISPLAY_SEGMENT_FRAGMENT);
var templateObject_1$4p;

var __makeTemplateObject$4o = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DisplayFragmentWithPlanogram, "__esModule", { value: true });
DisplayFragmentWithPlanogram.DISPLAY_FRAGMENT_WITH_PLANOGRAM = void 0;
var client_1$4U = require$$0$1;
var PlanogramFragment_1 = PlanogramFragment;
DisplayFragmentWithPlanogram.DISPLAY_FRAGMENT_WITH_PLANOGRAM = (0, client_1$4U.gql)(templateObject_1$4o || (templateObject_1$4o = __makeTemplateObject$4o(["\n  fragment DisplayFragmentWithPlanogram on Display {\n    id\n    created\n    saved\n    planogram {\n      ...Planogram\n    }\n    idealInventory {\n      upcs\n    }\n  }\n  ", "\n"], ["\n  fragment DisplayFragmentWithPlanogram on Display {\n    id\n    created\n    saved\n    planogram {\n      ...Planogram\n    }\n    idealInventory {\n      upcs\n    }\n  }\n  ", "\n"])), PlanogramFragment_1.PLANOGRAM_FRAGMENT);
var templateObject_1$4o;

var DisplayFragment = {};

var __makeTemplateObject$4n = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DisplayFragment, "__esModule", { value: true });
DisplayFragment.DISPLAY_FRAGMENT = void 0;
var client_1$4T = require$$0$1;
var CubeDimensions_1$1 = CubeDimensions;
DisplayFragment.DISPLAY_FRAGMENT = (0, client_1$4T.gql)(templateObject_1$4n || (templateObject_1$4n = __makeTemplateObject$4n(["\n  fragment Display on Display {\n    id\n    qrId\n    created\n    name\n    shortDescription\n    displayType\n    extraInfo\n    saved\n    isCompetitor\n    salesVolume\n    images {\n      id\n      url\n    }\n    area\n    numCoolerDoors\n    doorHandlePlacement\n    idealInventory {\n      upcs\n    }\n    latestRecommendations {\n      id\n      created\n      score\n      productRecommendations {\n        id\n        count\n        upc\n      }\n    }\n    point {\n      latitude\n      longitude\n    }\n    boundingCubes {\n      ...CubeDimensions\n    }\n    dateRemoved\n    movedToDisplay {\n      id\n    }\n    previousAuditUpcs\n    needsFieldVerifiedCountsPostScan\n    needsFieldVerifiedCountsPreScan\n    lastAudited\n    merchandisingState\n  }\n\n  ", "\n"], ["\n  fragment Display on Display {\n    id\n    qrId\n    created\n    name\n    shortDescription\n    displayType\n    extraInfo\n    saved\n    isCompetitor\n    salesVolume\n    images {\n      id\n      url\n    }\n    area\n    numCoolerDoors\n    doorHandlePlacement\n    idealInventory {\n      upcs\n    }\n    latestRecommendations {\n      id\n      created\n      score\n      productRecommendations {\n        id\n        count\n        upc\n      }\n    }\n    point {\n      latitude\n      longitude\n    }\n    boundingCubes {\n      ...CubeDimensions\n    }\n    dateRemoved\n    movedToDisplay {\n      id\n    }\n    previousAuditUpcs\n    needsFieldVerifiedCountsPostScan\n    needsFieldVerifiedCountsPreScan\n    lastAudited\n    merchandisingState\n  }\n\n  ", "\n"])), CubeDimensions_1$1.CUBE_DIMENSIONS);
var templateObject_1$4n;

var DisplaySalesFragment = {};

var __makeTemplateObject$4m = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DisplaySalesFragment, "__esModule", { value: true });
DisplaySalesFragment.DISPLAY_TRANSACTION_FRAGMENT = void 0;
var client_1$4S = require$$0$1;
var UserFragment_1$6 = UserFragment;
DisplaySalesFragment.DISPLAY_TRANSACTION_FRAGMENT = (0, client_1$4S.gql)(templateObject_1$4m || (templateObject_1$4m = __makeTemplateObject$4m(["\n  fragment DisplayTransaction on DisplayTransaction {\n    displayId\n    upc\n    brand\n    periodStartDate\n    periodEndDate\n    quantity\n    employee {\n      ...User  \n    }\n  }\n  ", "\n"], ["\n  fragment DisplayTransaction on DisplayTransaction {\n    displayId\n    upc\n    brand\n    periodStartDate\n    periodEndDate\n    quantity\n    employee {\n      ...User  \n    }\n  }\n  ", "\n"])), UserFragment_1$6.USER_FRAGMENT);
var templateObject_1$4m;

var DisplayWithStoreDataFragment = {};

var StoreFragment = {};

var TaskFragment = {};

var __makeTemplateObject$4l = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(TaskFragment, "__esModule", { value: true });
TaskFragment.TASK_FRAGMENT = void 0;
var client_1$4R = require$$0$1;
var UserFragment_1$5 = UserFragment;
var DisplayFragment_1$4 = DisplayFragment;
TaskFragment.TASK_FRAGMENT = (0, client_1$4R.gql)(templateObject_1$4l || (templateObject_1$4l = __makeTemplateObject$4l(["\n  fragment Task on TaskBase {\n    id\n    description\n    assignedUser {\n      ...User\n    }\n    createdBy {\n      ...User\n    }\n    store {\n      id\n      name\n    }\n    progress {\n      status\n      dateCompleted\n      user {\n        ...User\n      }\n      created\n      modified\n      errorMessage\n    }\n    created\n    modified\n    ... on DisplayTask {\n      __typename\n      description\n      taskType\n      display {\n        ...Display\n      }\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment Task on TaskBase {\n    id\n    description\n    assignedUser {\n      ...User\n    }\n    createdBy {\n      ...User\n    }\n    store {\n      id\n      name\n    }\n    progress {\n      status\n      dateCompleted\n      user {\n        ...User\n      }\n      created\n      modified\n      errorMessage\n    }\n    created\n    modified\n    ... on DisplayTask {\n      __typename\n      description\n      taskType\n      display {\n        ...Display\n      }\n    }\n  }\n  ", "\n  ", "\n"])), UserFragment_1$5.USER_FRAGMENT, DisplayFragment_1$4.DISPLAY_FRAGMENT);
var templateObject_1$4l;

var StoreAddressFragment = {};

var __makeTemplateObject$4k = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(StoreAddressFragment, "__esModule", { value: true });
StoreAddressFragment.STORE_ADDRESS_FRAGMENT = void 0;
var client_1$4Q = require$$0$1;
StoreAddressFragment.STORE_ADDRESS_FRAGMENT = (0, client_1$4Q.gql)(templateObject_1$4k || (templateObject_1$4k = __makeTemplateObject$4k(["\n  fragment StoreAddress on Address {\n    address1\n    address2\n    city\n    state\n    postalCode\n  }\n"], ["\n  fragment StoreAddress on Address {\n    address1\n    address2\n    city\n    state\n    postalCode\n  }\n"])));
var templateObject_1$4k;

var __makeTemplateObject$4j = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(StoreFragment, "__esModule", { value: true });
StoreFragment.STORE_FRAGMENT = void 0;
var client_1$4P = require$$0$1;
var TaskFragment_1 = TaskFragment;
var StoreAddressFragment_1$4 = StoreAddressFragment;
StoreFragment.STORE_FRAGMENT = (0, client_1$4P.gql)(templateObject_1$4j || (templateObject_1$4j = __makeTemplateObject$4j(["\n  fragment Store on CompanyStore {\n    id\n    isActive\n    totalAudits\n    distance\n    physicalStoreId\n    storeChain\n    name\n    internalStoreId\n    category\n    hasAllFormulas\n    image {\n      id\n      url\n    }\n    address {\n      ...StoreAddress\n    }\n    point {\n      latitude\n      longitude\n    }\n    lastAudit\n    daysSinceAudit\n    tasks {\n      ...Task\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment Store on CompanyStore {\n    id\n    isActive\n    totalAudits\n    distance\n    physicalStoreId\n    storeChain\n    name\n    internalStoreId\n    category\n    hasAllFormulas\n    image {\n      id\n      url\n    }\n    address {\n      ...StoreAddress\n    }\n    point {\n      latitude\n      longitude\n    }\n    lastAudit\n    daysSinceAudit\n    tasks {\n      ...Task\n    }\n  }\n  ", "\n  ", "\n"])), TaskFragment_1.TASK_FRAGMENT, StoreAddressFragment_1$4.STORE_ADDRESS_FRAGMENT);
var templateObject_1$4j;

var __makeTemplateObject$4i = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DisplayWithStoreDataFragment, "__esModule", { value: true });
DisplayWithStoreDataFragment.DISPLAY_WITH_STORE_DATA_FRAGMENT = void 0;
var client_1$4O = require$$0$1;
var StoreFragment_1 = StoreFragment;
DisplayWithStoreDataFragment.DISPLAY_WITH_STORE_DATA_FRAGMENT = (0, client_1$4O.gql)(templateObject_1$4i || (templateObject_1$4i = __makeTemplateObject$4i(["\n  fragment DisplayWithStoreData on Display {\n    id\n    created\n    name\n    shortDescription\n    displayType\n    extraInfo\n    saved\n    isCompetitor\n    salesVolume\n    images {\n      id\n      url\n    }\n    area\n    numCoolerDoors\n    doorHandlePlacement\n    idealInventory {\n      upcs\n    }\n    latestRecommendations {\n      id\n      created\n      score\n      productRecommendations {\n        count\n        upc\n      }\n    }\n    point {\n      latitude\n      longitude\n    }\n    dateRemoved\n    movedToDisplay {\n      id\n    }\n    previousAuditUpcs\n    merchandisingState\n    needsFieldVerifiedCountsPostScan\n    needsFieldVerifiedCountsPreScan\n    store {\n      ...Store\n      company {\n        id\n      }\n    }\n  }\n  ", "\n"], ["\n  fragment DisplayWithStoreData on Display {\n    id\n    created\n    name\n    shortDescription\n    displayType\n    extraInfo\n    saved\n    isCompetitor\n    salesVolume\n    images {\n      id\n      url\n    }\n    area\n    numCoolerDoors\n    doorHandlePlacement\n    idealInventory {\n      upcs\n    }\n    latestRecommendations {\n      id\n      created\n      score\n      productRecommendations {\n        count\n        upc\n      }\n    }\n    point {\n      latitude\n      longitude\n    }\n    dateRemoved\n    movedToDisplay {\n      id\n    }\n    previousAuditUpcs\n    merchandisingState\n    needsFieldVerifiedCountsPostScan\n    needsFieldVerifiedCountsPreScan\n    store {\n      ...Store\n      company {\n        id\n      }\n    }\n  }\n  ", "\n"])), StoreFragment_1.STORE_FRAGMENT);
var templateObject_1$4i;

var DrawMapTaskFragment = {};

var PhysicalStoreFragment = {};

var __makeTemplateObject$4h = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PhysicalStoreFragment, "__esModule", { value: true });
PhysicalStoreFragment.PHYSICAL_STORE_FRAGMENT = void 0;
var client_1$4N = require$$0$1;
var StoreAddressFragment_1$3 = StoreAddressFragment;
PhysicalStoreFragment.PHYSICAL_STORE_FRAGMENT = (0, client_1$4N.gql)(templateObject_1$4h || (templateObject_1$4h = __makeTemplateObject$4h(["\n  fragment PhysicalStore on Store {\n    id\n    name\n    category\n    modified\n    image {\n      id\n      url\n    }\n    address {\n      ...StoreAddress\n    }\n  }\n  ", "\n"], ["\n  fragment PhysicalStore on Store {\n    id\n    name\n    category\n    modified\n    image {\n      id\n      url\n    }\n    address {\n      ...StoreAddress\n    }\n  }\n  ", "\n"])), StoreAddressFragment_1$3.STORE_ADDRESS_FRAGMENT);
var templateObject_1$4h;

var __makeTemplateObject$4g = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DrawMapTaskFragment, "__esModule", { value: true });
DrawMapTaskFragment.DRAW_MAP_TASK_FRAGMENT = void 0;
var client_1$4M = require$$0$1;
var UserFragment_1$4 = UserFragment;
var PhysicalStoreFragment_1 = PhysicalStoreFragment;
DrawMapTaskFragment.DRAW_MAP_TASK_FRAGMENT = (0, client_1$4M.gql)(templateObject_1$4g || (templateObject_1$4g = __makeTemplateObject$4g(["\n  fragment DrawMapTask on IndoorMapDrawTask {\n    id\n    needsScan\n    scannerPaidOn\n    scanVerifiedOn\n    store {\n      ...PhysicalStore\n    }\n    mapper {\n      ...User\n    }\n    scanner {\n      ...User\n    }\n    storeAreas {\n      id\n      name\n      defaultForStoreSize\n    }\n    daiEmployeeVerifier {\n      ...User\n    }\n    mapUploadedOn\n    scannerVerifiedOn\n    daiEmployeeVerifiedOn\n    scanBucketFilePath\n    faroBucketFilePath\n    pdfBucketFilePath\n    comments {\n      comment\n      id\n      user {\n        ...User\n      }\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment DrawMapTask on IndoorMapDrawTask {\n    id\n    needsScan\n    scannerPaidOn\n    scanVerifiedOn\n    store {\n      ...PhysicalStore\n    }\n    mapper {\n      ...User\n    }\n    scanner {\n      ...User\n    }\n    storeAreas {\n      id\n      name\n      defaultForStoreSize\n    }\n    daiEmployeeVerifier {\n      ...User\n    }\n    mapUploadedOn\n    scannerVerifiedOn\n    daiEmployeeVerifiedOn\n    scanBucketFilePath\n    faroBucketFilePath\n    pdfBucketFilePath\n    comments {\n      comment\n      id\n      user {\n        ...User\n      }\n    }\n  }\n  ", "\n  ", "\n"])), UserFragment_1$4.USER_FRAGMENT, PhysicalStoreFragment_1.PHYSICAL_STORE_FRAGMENT);
var templateObject_1$4g;

var FlaggableObjectFragment = {};

var SimpleProductFragment = {};

var __makeTemplateObject$4f = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SimpleProductFragment, "__esModule", { value: true });
SimpleProductFragment.SIMPLE_PRODUCT_FRAGMENT = void 0;
var client_1$4L = require$$0$1;
var PackagingFragment_1$4 = PackagingFragment$1;
var ShippingFragment_1$3 = ShippingFragment$1;
SimpleProductFragment.SIMPLE_PRODUCT_FRAGMENT = (0, client_1$4L.gql)(templateObject_1$4f || (templateObject_1$4f = __makeTemplateObject$4f(["\n  fragment SimpleProduct on Product {\n    id\n    upcA\n    upcE\n    name\n    isActive\n    brand {\n      id\n      name\n    }\n    manufacturer {\n      id\n      name\n    }\n    marketingImageUrl\n    packaging {\n      ...Packaging\n    }\n    shipping {\n      ...Shipping\n    }\n    flavors {\n      id\n      flavor\n      displayFlavor\n    }\n    companyCategory {\n      id\n      category\n      parentCategory\n    }\n    geometry {\n      id\n      geometry\n    }\n    verifiedBy\n    images {\n      url\n      id\n      bucketFileName\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment SimpleProduct on Product {\n    id\n    upcA\n    upcE\n    name\n    isActive\n    brand {\n      id\n      name\n    }\n    manufacturer {\n      id\n      name\n    }\n    marketingImageUrl\n    packaging {\n      ...Packaging\n    }\n    shipping {\n      ...Shipping\n    }\n    flavors {\n      id\n      flavor\n      displayFlavor\n    }\n    companyCategory {\n      id\n      category\n      parentCategory\n    }\n    geometry {\n      id\n      geometry\n    }\n    verifiedBy\n    images {\n      url\n      id\n      bucketFileName\n    }\n  }\n  ", "\n  ", "\n"])), PackagingFragment_1$4.PACKAGING_FRAGMENT, ShippingFragment_1$3.SHIPPING_FRAGMENT);
var templateObject_1$4f;

var __makeTemplateObject$4e = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(FlaggableObjectFragment, "__esModule", { value: true });
FlaggableObjectFragment.FLAGGABLE_OBJECT_FRAGMENT = void 0;
var client_1$4K = require$$0$1;
var SimpleProductFragment_1$6 = SimpleProductFragment;
var DisplayAuditImageFragment_1$1 = DisplayAuditImageFragment;
var UserFragment_1$3 = UserFragment;
FlaggableObjectFragment.FLAGGABLE_OBJECT_FRAGMENT = (0, client_1$4K.gql)(templateObject_1$4e || (templateObject_1$4e = __makeTemplateObject$4e(["\n  fragment FlaggableObject on FlaggableObject {\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        ...User\n      }\n      levelRaisedBy {\n        ...User\n      }\n      date\n    }\n    ... on DisplayAuditImage {\n      ...DisplayAuditImage\n    }\n    ... on Product {\n      ...SimpleProduct\n    }\n  }\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment FlaggableObject on FlaggableObject {\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        ...User\n      }\n      levelRaisedBy {\n        ...User\n      }\n      date\n    }\n    ... on DisplayAuditImage {\n      ...DisplayAuditImage\n    }\n    ... on Product {\n      ...SimpleProduct\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), UserFragment_1$3.USER_FRAGMENT, DisplayAuditImageFragment_1$1.DISPLAY_AUDIT_IMAGE_FRAGMENT, SimpleProductFragment_1$6.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$4e;

var FullStoreFragment = {};

var __makeTemplateObject$4d = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(FullStoreFragment, "__esModule", { value: true });
FullStoreFragment.FULL_STORE_FRAGMENT = void 0;
var client_1$4J = require$$0$1;
var DisplayFragment_1$3 = DisplayFragment;
var StoreAddressFragment_1$2 = StoreAddressFragment;
FullStoreFragment.FULL_STORE_FRAGMENT = (0, client_1$4J.gql)(templateObject_1$4d || (templateObject_1$4d = __makeTemplateObject$4d(["\n  fragment FullStore on CompanyStore {\n    id\n    name\n    isActive\n    distance\n    daysSinceAudit\n    category\n    physicalStoreId\n    internalStoreId\n    hasAllFormulas\n    image {\n      url\n      id\n    }\n    address {\n      ...StoreAddress\n    }\n    point {\n      latitude\n      longitude\n    }\n    storeMap {\n      id\n      geoJson\n    }\n    storeChain\n    displays {\n      ...Display\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment FullStore on CompanyStore {\n    id\n    name\n    isActive\n    distance\n    daysSinceAudit\n    category\n    physicalStoreId\n    internalStoreId\n    hasAllFormulas\n    image {\n      url\n      id\n    }\n    address {\n      ...StoreAddress\n    }\n    point {\n      latitude\n      longitude\n    }\n    storeMap {\n      id\n      geoJson\n    }\n    storeChain\n    displays {\n      ...Display\n    }\n  }\n  ", "\n  ", "\n"])), DisplayFragment_1$3.DISPLAY_FRAGMENT, StoreAddressFragment_1$2.STORE_ADDRESS_FRAGMENT);
var templateObject_1$4d;

var GeographicHierarchyDraftFragment = {};

var __makeTemplateObject$4c = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GeographicHierarchyDraftFragment, "__esModule", { value: true });
GeographicHierarchyDraftFragment.GEOOGRAPHIC_HIERARCHY_DRAFT = void 0;
var client_1$4I = require$$0$1;
GeographicHierarchyDraftFragment.GEOOGRAPHIC_HIERARCHY_DRAFT = (0, client_1$4I.gql)(templateObject_1$4c || (templateObject_1$4c = __makeTemplateObject$4c(["\n  fragment GeographicHierarchyDraft on RouteDraft {\n    rar {\n      uuid\n      id\n      email\n      firstName\n      lastName\n      username\n      customerUserId\n      mainRole\n      roles\n    }\n    stores {\n      id\n      name\n      internalStoreId\n      category\n      image {\n        id\n        url\n      }\n      address {\n        ...StoreAddress\n      }\n    }\n    approvedBy {\n      firstName\n      lastName\n    }\n    routeId\n    routeName\n  \n  }\n"], ["\n  fragment GeographicHierarchyDraft on RouteDraft {\n    rar {\n      uuid\n      id\n      email\n      firstName\n      lastName\n      username\n      customerUserId\n      mainRole\n      roles\n    }\n    stores {\n      id\n      name\n      internalStoreId\n      category\n      image {\n        id\n        url\n      }\n      address {\n        ...StoreAddress\n      }\n    }\n    approvedBy {\n      firstName\n      lastName\n    }\n    routeId\n    routeName\n  \n  }\n"])));
var templateObject_1$4c;

var GeographicHierarchyLeadFragment = {};

var __makeTemplateObject$4b = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GeographicHierarchyLeadFragment, "__esModule", { value: true });
GeographicHierarchyLeadFragment.GEOGRAPHIC_HIERARCHY_LEAD_CANDIDATE_FRAGMENT = void 0;
var client_1$4H = require$$0$1;
GeographicHierarchyLeadFragment.GEOGRAPHIC_HIERARCHY_LEAD_CANDIDATE_FRAGMENT = (0, client_1$4H.gql)(templateObject_1$4b || (templateObject_1$4b = __makeTemplateObject$4b(["\n  fragment GeographicHierarchyLead on GeographicHierarchyLeadCandidate {\n    uuid\n    id\n    email\n    firstName\n    lastName\n    username\n    customerUserId\n    numDraftsApproved\n    numDraftsTotal\n    mainRole\n    territoryId\n  }\n"], ["\n  fragment GeographicHierarchyLead on GeographicHierarchyLeadCandidate {\n    uuid\n    id\n    email\n    firstName\n    lastName\n    username\n    customerUserId\n    numDraftsApproved\n    numDraftsTotal\n    mainRole\n    territoryId\n  }\n"])));
var templateObject_1$4b;

var MLModelFileFragment = {};

var __makeTemplateObject$4a = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(MLModelFileFragment, "__esModule", { value: true });
MLModelFileFragment.ML_MODEL_FILE_FRAGMENT = void 0;
var client_1$4G = require$$0$1;
MLModelFileFragment.ML_MODEL_FILE_FRAGMENT = (0, client_1$4G.gql)(templateObject_1$4a || (templateObject_1$4a = __makeTemplateObject$4a(["\n  fragment MLModelFile on MLModel {\n    id\n    version\n    bucketFileName\n    namesBucketFileName\n    modelType\n    configBucketFileName\n  }\n"], ["\n  fragment MLModelFile on MLModel {\n    id\n    version\n    bucketFileName\n    namesBucketFileName\n    modelType\n    configBucketFileName\n  }\n"])));
var templateObject_1$4a;

var MLModelFragment = {};

var __makeTemplateObject$49 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(MLModelFragment, "__esModule", { value: true });
MLModelFragment.ML_MODEL_FRAGMENT = void 0;
var client_1$4F = require$$0$1;
MLModelFragment.ML_MODEL_FRAGMENT = (0, client_1$4F.gql)(templateObject_1$49 || (templateObject_1$49 = __makeTemplateObject$49(["\n  fragment MLModel on MLModel {\n    id\n    modelType\n    version\n    namesBucketFileName\n    bucketFileName\n    dataset {\n      id\n    }\n  }\n"], ["\n  fragment MLModel on MLModel {\n    id\n    modelType\n    version\n    namesBucketFileName\n    bucketFileName\n    dataset {\n      id\n    }\n  }\n"])));
var templateObject_1$49;

var MerchandiserDisplayScanImageFragment = {};

var __makeTemplateObject$48 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(MerchandiserDisplayScanImageFragment, "__esModule", { value: true });
MerchandiserDisplayScanImageFragment.MERCHANDISER_DISPLAY_SCAN_IMAGE_FRAGMENT = void 0;
var client_1$4E = require$$0$1;
var BoundingBoxesFragment_1$3 = BoundingBoxesFragment;
var SimpleProductFragment_1$5 = SimpleProductFragment;
MerchandiserDisplayScanImageFragment.MERCHANDISER_DISPLAY_SCAN_IMAGE_FRAGMENT = (0, client_1$4E.gql)(templateObject_1$48 || (templateObject_1$48 = __makeTemplateObject$48(["\n  fragment MerchandiserDisplayScanImage on MerchandiserDisplayScanImage {\n    id\n    url\n    boundingBoxSet {\n      ...BoundingBoxes\n    }\n    products {\n      ...SimpleProduct\n    }\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        email\n      }\n      levelRaisedBy {\n        email\n        firstName\n        lastName\n      }\n      date\n    }\n    protectedBoxes {\n      id\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment MerchandiserDisplayScanImage on MerchandiserDisplayScanImage {\n    id\n    url\n    boundingBoxSet {\n      ...BoundingBoxes\n    }\n    products {\n      ...SimpleProduct\n    }\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        email\n      }\n      levelRaisedBy {\n        email\n        firstName\n        lastName\n      }\n      date\n    }\n    protectedBoxes {\n      id\n    }\n  }\n  ", "\n  ", "\n"])), BoundingBoxesFragment_1$3.BOUNDING_BOXES_FRAGMENT, SimpleProductFragment_1$5.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$48;

var MinimalStoreFragment = {};

var __makeTemplateObject$47 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(MinimalStoreFragment, "__esModule", { value: true });
MinimalStoreFragment.MINIMAL_STORE_FRAGMENT = void 0;
var client_1$4D = require$$0$1;
MinimalStoreFragment.MINIMAL_STORE_FRAGMENT = (0, client_1$4D.gql)(templateObject_1$47 || (templateObject_1$47 = __makeTemplateObject$47(["\n  fragment MinimalStore on CompanyStore {\n    id\n    name\n    category\n    physicalStoreId\n    image {\n      url\n      id\n    }\n    address {\n      address1\n      address2\n      city\n      state\n      postalCode\n    }\n    point {\n      latitude\n      longitude\n    }\n  }\n"], ["\n  fragment MinimalStore on CompanyStore {\n    id\n    name\n    category\n    physicalStoreId\n    image {\n      url\n      id\n    }\n    address {\n      address1\n      address2\n      city\n      state\n      postalCode\n    }\n    point {\n      latitude\n      longitude\n    }\n  }\n"])));
var templateObject_1$47;

var MultiProductImageFragment = {};

var MultiProductImageProductFragment = {};

var __makeTemplateObject$46 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(MultiProductImageProductFragment, "__esModule", { value: true });
MultiProductImageProductFragment.MULTI_PRODUCT_IMAGE_PRODUCT_FRAGMENT = void 0;
var client_1$4C = require$$0$1;
var PackagingFragment_1$3 = PackagingFragment$1;
MultiProductImageProductFragment.MULTI_PRODUCT_IMAGE_PRODUCT_FRAGMENT = (0, client_1$4C.gql)(templateObject_1$46 || (templateObject_1$46 = __makeTemplateObject$46(["\n  fragment MultiProductImageProduct on Product {\n    id\n    created\n    modified\n    upcA\n    name\n    brand {\n      id\n      name\n    }\n    flavors {\n      id\n      flavor\n      displayFlavor\n    }\n    packaging {\n      ...Packaging\n    }\n    marketingImageUrl\n    verifiedBy\n  }\n  ", "\n"], ["\n  fragment MultiProductImageProduct on Product {\n    id\n    created\n    modified\n    upcA\n    name\n    brand {\n      id\n      name\n    }\n    flavors {\n      id\n      flavor\n      displayFlavor\n    }\n    packaging {\n      ...Packaging\n    }\n    marketingImageUrl\n    verifiedBy\n  }\n  ", "\n"])), PackagingFragment_1$3.PACKAGING_FRAGMENT);
var templateObject_1$46;

var __makeTemplateObject$45 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(MultiProductImageFragment, "__esModule", { value: true });
MultiProductImageFragment.MULTI_PRODUCT_IMAGE_FRAGMENT = void 0;
var client_1$4B = require$$0$1;
var BoundingBoxesFragment_1$2 = BoundingBoxesFragment;
var MultiProductImageProductFragment_1 = MultiProductImageProductFragment;
MultiProductImageFragment.MULTI_PRODUCT_IMAGE_FRAGMENT = (0, client_1$4B.gql)(templateObject_1$45 || (templateObject_1$45 = __makeTemplateObject$45(["\n  fragment MultiProductImage on MultiProductImage {\n    id\n    url\n    upcSet\n    boundingBoxSet {\n      ...BoundingBoxes\n    }\n    products {\n      ...MultiProductImageProduct\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment MultiProductImage on MultiProductImage {\n    id\n    url\n    upcSet\n    boundingBoxSet {\n      ...BoundingBoxes\n    }\n    products {\n      ...MultiProductImageProduct\n    }\n  }\n  ", "\n  ", "\n"])), BoundingBoxesFragment_1$2.BOUNDING_BOXES_FRAGMENT, MultiProductImageProductFragment_1.MULTI_PRODUCT_IMAGE_PRODUCT_FRAGMENT);
var templateObject_1$45;

var PicOSGroupComplianceFragment = {};

var __makeTemplateObject$44 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSGroupComplianceFragment, "__esModule", { value: true });
PicOSGroupComplianceFragment.PICOS_GROUP_COMPLIANCE_FRAGMENT = void 0;
var client_1$4A = require$$0$1;
PicOSGroupComplianceFragment.PICOS_GROUP_COMPLIANCE_FRAGMENT = (0, client_1$4A.gql)(templateObject_1$44 || (templateObject_1$44 = __makeTemplateObject$44(["\n  fragment PicOSGroupCompliance on PicOSComplianceGroupOverview {\n    id\n    name\n    totalPriorities\n    numCompliant\n    numChildren\n    numGrandchildren\n  }\n"], ["\n  fragment PicOSGroupCompliance on PicOSComplianceGroupOverview {\n    id\n    name\n    totalPriorities\n    numCompliant\n    numChildren\n    numGrandchildren\n  }\n"])));
var templateObject_1$44;

var PicOSGroupComplianceStats = {};

var __makeTemplateObject$43 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSGroupComplianceStats, "__esModule", { value: true });
PicOSGroupComplianceStats.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT = void 0;
var client_1$4z = require$$0$1;
PicOSGroupComplianceStats.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT = (0, client_1$4z.gql)(templateObject_1$43 || (templateObject_1$43 = __makeTemplateObject$43(["\n  fragment PicOSGroupComplianceStats on PicOSGroupStatsBase {\n    numDistinctPriorities\n    totalPriorities\n    numCompliantPriorities\n    ... on PicOSAllCustomersStats {\n      numCustomers\n      numStoresSurveyed\n    }\n    ... on PicOSCustomerStats {\n      numDivisions\n      numStoresSurveyed\n    }\n    ... on PicOSRegionalStats {\n      numStoresSurveyed\n    }\n  }\n"], ["\n  fragment PicOSGroupComplianceStats on PicOSGroupStatsBase {\n    numDistinctPriorities\n    totalPriorities\n    numCompliantPriorities\n    ... on PicOSAllCustomersStats {\n      numCustomers\n      numStoresSurveyed\n    }\n    ... on PicOSCustomerStats {\n      numDivisions\n      numStoresSurveyed\n    }\n    ... on PicOSRegionalStats {\n      numStoresSurveyed\n    }\n  }\n"])));
var templateObject_1$43;

var PicOSPriorityOverviewFragment = {};

var __makeTemplateObject$42 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSPriorityOverviewFragment, "__esModule", { value: true });
PicOSPriorityOverviewFragment.PICOS_PRIORITY_OVERVIEW_FRAGMENT = void 0;
var client_1$4y = require$$0$1;
PicOSPriorityOverviewFragment.PICOS_PRIORITY_OVERVIEW_FRAGMENT = (0, client_1$4y.gql)(templateObject_1$42 || (templateObject_1$42 = __makeTemplateObject$42(["\n  fragment PicOSPriorityOverview on PicOSPriority {\n    id\n    priority\n    name\n    description\n    mandateType\n    displayElements\n    image {\n      id\n      url\n    }\n  }\n"], ["\n  fragment PicOSPriorityOverview on PicOSPriority {\n    id\n    priority\n    name\n    description\n    mandateType\n    displayElements\n    image {\n      id\n      url\n    }\n  }\n"])));
var templateObject_1$42;

var PicOSSalesCenterComplianceFragment = {};

var __makeTemplateObject$41 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSSalesCenterComplianceFragment, "__esModule", { value: true });
PicOSSalesCenterComplianceFragment.PICOS_SALES_CENTER_COMPLIANCE_FRAGMENT = void 0;
var client_1$4x = require$$0$1;
PicOSSalesCenterComplianceFragment.PICOS_SALES_CENTER_COMPLIANCE_FRAGMENT = (0, client_1$4x.gql)(templateObject_1$41 || (templateObject_1$41 = __makeTemplateObject$41(["\n  fragment PicOSSalesCenterCompliance on PicOSSalesCenterCompliance {\n    id\n    name\n    totalPriorities\n    numCompliant\n    rank\n    previousRank\n    numStoresSurveyed\n  }\n"], ["\n  fragment PicOSSalesCenterCompliance on PicOSSalesCenterCompliance {\n    id\n    name\n    totalPriorities\n    numCompliant\n    rank\n    previousRank\n    numStoresSurveyed\n  }\n"])));
var templateObject_1$41;

var PicOSStoreComplianceFragment = {};

var __makeTemplateObject$40 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSStoreComplianceFragment, "__esModule", { value: true });
PicOSStoreComplianceFragment.PICOS_STORE_COMPLIANCE_FRAGMENT = void 0;
var client_1$4w = require$$0$1;
var StoreAddressFragment_1$1 = StoreAddressFragment;
PicOSStoreComplianceFragment.PICOS_STORE_COMPLIANCE_FRAGMENT = (0, client_1$4w.gql)(templateObject_1$40 || (templateObject_1$40 = __makeTemplateObject$40(["\n  fragment PicOSStoreCompliance on PicOSStoreCompliance {\n    id\n    name\n    totalPriorities\n    numCompliant\n    rank\n    previousRank\n    address {\n      ...StoreAddress\n    }\n  }\n  ", "\n"], ["\n  fragment PicOSStoreCompliance on PicOSStoreCompliance {\n    id\n    name\n    totalPriorities\n    numCompliant\n    rank\n    previousRank\n    address {\n      ...StoreAddress\n    }\n  }\n  ", "\n"])), StoreAddressFragment_1$1.STORE_ADDRESS_FRAGMENT);
var templateObject_1$40;

var PlanogramFeedbackImagesIssuesFragment = {};

var __makeTemplateObject$3$ = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PlanogramFeedbackImagesIssuesFragment, "__esModule", { value: true });
PlanogramFeedbackImagesIssuesFragment.PLANOGRAM_FEEDBACK_IMAGES_ISSUES_FRAGMENT = void 0;
var client_1$4v = require$$0$1;
var UserFragment_1$2 = UserFragment;
PlanogramFeedbackImagesIssuesFragment.PLANOGRAM_FEEDBACK_IMAGES_ISSUES_FRAGMENT = (0, client_1$4v.gql)(templateObject_1$3$ || (templateObject_1$3$ = __makeTemplateObject$3$(["\n  fragment PlanogramFeedbackImagesIssues on PlanogramSegmentFlaggedIssueImage {\n    id\n    created\n    bucketFileName\n    url\n    displaySegment {\n      created\n      modified\n      segmentNumber\n      id\n      planogram {\n        id\n        display {\n          id\n          shortDescription\n          displayType\n          store {\n            id\n            address {\n              id\n              address1\n              address2\n              city\n              state\n              postalCode\n            }\n            store {\n              name\n              address {\n                id\n                address1\n                address2\n                city\n                state\n                postalCode\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n    flaggedReason {\n      id\n      reason\n      issueTypes\n      resolved\n      reasonBy {\n        ...User\n      }\n    }\n  }\n  ", "\n"], ["\n  fragment PlanogramFeedbackImagesIssues on PlanogramSegmentFlaggedIssueImage {\n    id\n    created\n    bucketFileName\n    url\n    displaySegment {\n      created\n      modified\n      segmentNumber\n      id\n      planogram {\n        id\n        display {\n          id\n          shortDescription\n          displayType\n          store {\n            id\n            address {\n              id\n              address1\n              address2\n              city\n              state\n              postalCode\n            }\n            store {\n              name\n              address {\n                id\n                address1\n                address2\n                city\n                state\n                postalCode\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n    flaggedReason {\n      id\n      reason\n      issueTypes\n      resolved\n      reasonBy {\n        ...User\n      }\n    }\n  }\n  ", "\n"])), UserFragment_1$2.USER_FRAGMENT);
var templateObject_1$3$;

var ProductFragment$1 = {};

var ProductImageFragment = {};

var __makeTemplateObject$3_ = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ProductImageFragment, "__esModule", { value: true });
ProductImageFragment.PRODUCT_IMAGE_FRAGMENT = void 0;
var client_1$4u = require$$0$1;
ProductImageFragment.PRODUCT_IMAGE_FRAGMENT = (0, client_1$4u.gql)(templateObject_1$3_ || (templateObject_1$3_ = __makeTemplateObject$3_(["\n  fragment ProductImage on ProductImage {\n    id\n    url\n    created\n    modified\n  }\n"], ["\n  fragment ProductImage on ProductImage {\n    id\n    url\n    created\n    modified\n  }\n"])));
var templateObject_1$3_;

var __makeTemplateObject$3Z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ProductFragment$1, "__esModule", { value: true });
ProductFragment$1.PRODUCT_FRAGMENT = void 0;
var client_1$4t = require$$0$1;
var ProductImageFragment_1$1 = ProductImageFragment;
var PackagingFragment_1$2 = PackagingFragment$1;
var ShippingFragment_1$2 = ShippingFragment$1;
ProductFragment$1.PRODUCT_FRAGMENT = (0, client_1$4t.gql)(templateObject_1$3Z || (templateObject_1$3Z = __makeTemplateObject$3Z(["\n  fragment Product on Product {\n    id\n    created\n    modified\n    upcA\n    upcE\n    name\n    isActive\n    brand {\n      id\n      name\n    }\n    manufacturer {\n      id\n      name\n    }\n    marketingImageUrl\n    images(verified: false, hasPrediction: true) {\n      ...ProductImage\n    }\n    packaging {\n      ...Packaging\n    }\n    shipping {\n      ...Shipping\n    }\n    verifiedBy\n  }\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment Product on Product {\n    id\n    created\n    modified\n    upcA\n    upcE\n    name\n    isActive\n    brand {\n      id\n      name\n    }\n    manufacturer {\n      id\n      name\n    }\n    marketingImageUrl\n    images(verified: false, hasPrediction: true) {\n      ...ProductImage\n    }\n    packaging {\n      ...Packaging\n    }\n    shipping {\n      ...Shipping\n    }\n    verifiedBy\n  }\n  ", "\n  ", "\n  ", "\n"])), ProductImageFragment_1$1.PRODUCT_IMAGE_FRAGMENT, PackagingFragment_1$2.PACKAGING_FRAGMENT, ShippingFragment_1$2.SHIPPING_FRAGMENT);
var templateObject_1$3Z;

var ReportedIssueFragment = {};

var __makeTemplateObject$3Y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ReportedIssueFragment, "__esModule", { value: true });
ReportedIssueFragment.REPORTED_ISSUE_FRAGMENT = void 0;
var client_1$4s = require$$0$1;
var UserFragment_1$1 = UserFragment;
ReportedIssueFragment.REPORTED_ISSUE_FRAGMENT = (0, client_1$4s.gql)(templateObject_1$3Y || (templateObject_1$3Y = __makeTemplateObject$3Y(["\n  fragment ReportedIssue on ReportedIssue {\n    id\n    objectId\n    issueType\n    message\n    created\n    reportedBy {\n      ...User\n    }\n  }\n  ", "\n"], ["\n  fragment ReportedIssue on ReportedIssue {\n    id\n    objectId\n    issueType\n    message\n    created\n    reportedBy {\n      ...User\n    }\n  }\n  ", "\n"])), UserFragment_1$1.USER_FRAGMENT);
var templateObject_1$3Y;

var ScanImageFragment = {};

var __makeTemplateObject$3X = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ScanImageFragment, "__esModule", { value: true });
ScanImageFragment.SCAN_IMAGE_FRAGMENT = void 0;
var client_1$4r = require$$0$1;
var BoundingBoxesFragment_1$1 = BoundingBoxesFragment;
var SimpleProductFragment_1$4 = SimpleProductFragment;
ScanImageFragment.SCAN_IMAGE_FRAGMENT = (0, client_1$4r.gql)(templateObject_1$3X || (templateObject_1$3X = __makeTemplateObject$3X(["\n  fragment ScanImage on ScanImage {\n    id\n    url\n    boundingBoxSet {\n      ...BoundingBoxes\n    }\n    productUpcs\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        email\n      }\n      levelRaisedBy {\n        email\n        firstName\n        lastName\n      }\n      date\n    }\n    protectedBoxes {\n      id\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment ScanImage on ScanImage {\n    id\n    url\n    boundingBoxSet {\n      ...BoundingBoxes\n    }\n    productUpcs\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        email\n      }\n      levelRaisedBy {\n        email\n        firstName\n        lastName\n      }\n      date\n    }\n    protectedBoxes {\n      id\n    }\n  }\n  ", "\n  ", "\n"])), BoundingBoxesFragment_1$1.BOUNDING_BOXES_FRAGMENT, SimpleProductFragment_1$4.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$3X;

var SimpleFlaggableObjectFragment = {};

var __makeTemplateObject$3W = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SimpleFlaggableObjectFragment, "__esModule", { value: true });
SimpleFlaggableObjectFragment.SIMPLE_FLAGGABLE_OBJECT_FRAGMENT = void 0;
var client_1$4q = require$$0$1;
SimpleFlaggableObjectFragment.SIMPLE_FLAGGABLE_OBJECT_FRAGMENT = (0, client_1$4q.gql)(templateObject_1$3W || (templateObject_1$3W = __makeTemplateObject$3W(["\n  fragment SimpleFlaggableObject on FlaggableObject {\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        uuid\n        id\n        email\n        firstName\n        lastName\n      }\n      levelRaisedBy {\n        uuid\n        id\n        email\n        firstName\n        lastName\n        username\n      }\n      date\n    }\n    ... on DisplayAuditImage {\n      id\n      url\n    }\n    ... on Product {\n      upcA\n    }\n  }\n"], ["\n  fragment SimpleFlaggableObject on FlaggableObject {\n    flagged {\n      level\n      reason\n      reasonType\n      moreInfo\n      flaggedBy {\n        uuid\n        id\n        email\n        firstName\n        lastName\n      }\n      levelRaisedBy {\n        uuid\n        id\n        email\n        firstName\n        lastName\n        username\n      }\n      date\n    }\n    ... on DisplayAuditImage {\n      id\n      url\n    }\n    ... on Product {\n      upcA\n    }\n  }\n"])));
var templateObject_1$3W;

var SimpleInventoryFragment = {};

var __makeTemplateObject$3V = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SimpleInventoryFragment, "__esModule", { value: true });
SimpleInventoryFragment.SIMPLE_INVENTORY_FRAGMENT = void 0;
var client_1$4p = require$$0$1;
SimpleInventoryFragment.SIMPLE_INVENTORY_FRAGMENT = (0, client_1$4p.gql)(templateObject_1$3V || (templateObject_1$3V = __makeTemplateObject$3V(["\n  fragment SimpleInventory on SimpleInventoryItem {\n    parentId\n    quantity\n    upc\n  }\n"], ["\n  fragment SimpleInventory on SimpleInventoryItem {\n    parentId\n    quantity\n    upc\n  }\n"])));
var templateObject_1$3V;

var SingleProductPointCloud = {};

var __makeTemplateObject$3U = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SingleProductPointCloud, "__esModule", { value: true });
SingleProductPointCloud.SINGLE_PRODUCT_POINT_CLOUD_FRAGMENT = void 0;
var client_1$4o = require$$0$1;
SingleProductPointCloud.SINGLE_PRODUCT_POINT_CLOUD_FRAGMENT = (0, client_1$4o.gql)(templateObject_1$3U || (templateObject_1$3U = __makeTemplateObject$3U(["\n  fragment SingleProductPointCloud on SingleProductPointCloud {\n    __typename\n    id\n    labels\n    centroids\n    predicted\n    bucketFileName\n    saved\n    created\n  }\n"], ["\n  fragment SingleProductPointCloud on SingleProductPointCloud {\n    __typename\n    id\n    labels\n    centroids\n    predicted\n    bucketFileName\n    saved\n    created\n  }\n"])));
var templateObject_1$3U;

var SimpleStoreAuditFragment = {};

var __makeTemplateObject$3T = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SimpleStoreAuditFragment, "__esModule", { value: true });
SimpleStoreAuditFragment.SIMPLE_AUDIT_FRAGMENT = void 0;
var client_1$4n = require$$0$1;
var ScoreFragments_1$1 = ScoreFragments;
SimpleStoreAuditFragment.SIMPLE_AUDIT_FRAGMENT = (0, client_1$4n.gql)(templateObject_1$3T || (templateObject_1$3T = __makeTemplateObject$3T(["\n  fragment SimpleAudit on Audit {\n    id\n    created\n    saved\n    dateCompleted\n    displaysCompletedAt\n    pricingCompletedAt\n    surveyCompletedAt\n    employee {\n      firstName\n      lastName\n      id\n      email\n    }\n    store {\n      id\n      storeChain\n      name\n      hasAllFormulas\n      address {\n        address1\n        city\n        state\n        postalCode\n      }\n    }\n    status\n    score {\n      created\n      modified\n      id\n      total {\n        ...Score\n      }\n    }\n    notes\n  }\n  ", "\n"], ["\n  fragment SimpleAudit on Audit {\n    id\n    created\n    saved\n    dateCompleted\n    displaysCompletedAt\n    pricingCompletedAt\n    surveyCompletedAt\n    employee {\n      firstName\n      lastName\n      id\n      email\n    }\n    store {\n      id\n      storeChain\n      name\n      hasAllFormulas\n      address {\n        address1\n        city\n        state\n        postalCode\n      }\n    }\n    status\n    score {\n      created\n      modified\n      id\n      total {\n        ...Score\n      }\n    }\n    notes\n  }\n  ", "\n"])), ScoreFragments_1$1.SCORE_FRAGMENT);
var templateObject_1$3T;

var StoreRegionFragment = {};

var __makeTemplateObject$3S = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(StoreRegionFragment, "__esModule", { value: true });
StoreRegionFragment.STORE_REGION_FRAGMENT = void 0;
var client_1$4m = require$$0$1;
var UserFragment_1 = UserFragment;
StoreRegionFragment.STORE_REGION_FRAGMENT = (0, client_1$4m.gql)(templateObject_1$3S || (templateObject_1$3S = __makeTemplateObject$3S(["\n  fragment StoreRegion on Region {\n    id\n    name\n    parentId\n    users {\n      ...User\n    }\n    stores {\n      id\n      name\n    }\n  }\n  ", "\n"], ["\n  fragment StoreRegion on Region {\n    id\n    name\n    parentId\n    users {\n      ...User\n    }\n    stores {\n      id\n      name\n    }\n  }\n  ", "\n"])), UserFragment_1.USER_FRAGMENT);
var templateObject_1$3S;

var TrainingFragment = {};

var __makeTemplateObject$3R = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(TrainingFragment, "__esModule", { value: true });
TrainingFragment.TRAINING_FRAGMENT = void 0;
var client_1$4l = require$$0$1;
TrainingFragment.TRAINING_FRAGMENT = (0, client_1$4l.gql)(templateObject_1$3R || (templateObject_1$3R = __makeTemplateObject$3R(["\n  fragment Training on Training {\n    title\n    description\n    id\n    timeRequired\n    groups {\n      id\n      name\n    }\n    keyTakeaways\n    deviceType\n    trainingImage {\n      id\n      url\n      bucketFileName\n    }\n    videoUrl\n  }\n"], ["\n  fragment Training on Training {\n    title\n    description\n    id\n    timeRequired\n    groups {\n      id\n      name\n    }\n    keyTakeaways\n    deviceType\n    trainingImage {\n      id\n      url\n      bucketFileName\n    }\n    videoUrl\n  }\n"])));
var templateObject_1$3R;

var TrainingImageFragment = {};

var __makeTemplateObject$3Q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(TrainingImageFragment, "__esModule", { value: true });
TrainingImageFragment.TRAINING_IMAGE_FRAGMENT = void 0;
var client_1$4k = require$$0$1;
var BoundingBoxesFragment_1 = BoundingBoxesFragment;
var SimpleProductFragment_1$3 = SimpleProductFragment;
TrainingImageFragment.TRAINING_IMAGE_FRAGMENT = (0, client_1$4k.gql)(templateObject_1$3Q || (templateObject_1$3Q = __makeTemplateObject$3Q(["\n  fragment TrainingImage on TrainingImage {\n    id\n    url\n    bucketFileName\n  }\n  ", "\n  ", "\n"], ["\n  fragment TrainingImage on TrainingImage {\n    id\n    url\n    bucketFileName\n  }\n  ", "\n  ", "\n"])), BoundingBoxesFragment_1.BOUNDING_BOXES_FRAGMENT, SimpleProductFragment_1$3.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$3Q;

var TrainingPointCloud = {};

var __makeTemplateObject$3P = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(TrainingPointCloud, "__esModule", { value: true });
TrainingPointCloud.TRAINING_POINT_CLOUD_FRAGMENT = void 0;
var client_1$4j = require$$0$1;
TrainingPointCloud.TRAINING_POINT_CLOUD_FRAGMENT = (0, client_1$4j.gql)(templateObject_1$3P || (templateObject_1$3P = __makeTemplateObject$3P(["\n  fragment TrainingPointCloud on TrainingPointCloud {\n    __typename\n    id\n    labels\n    centroids\n    predicted\n    bucketFileName\n    saved\n    created\n    metadata\n  }\n"], ["\n  fragment TrainingPointCloud on TrainingPointCloud {\n    __typename\n    id\n    labels\n    centroids\n    predicted\n    bucketFileName\n    saved\n    created\n    metadata\n  }\n"])));
var templateObject_1$3P;

var UserProductivityResultFragment = {};

Object.defineProperty(UserProductivityResultFragment, "__esModule", { value: true });
UserProductivityResultFragment.USER_PRODUCTIVITY_RESULT_FRAGMENT = void 0;
UserProductivityResultFragment.USER_PRODUCTIVITY_RESULT_FRAGMENT = "\n  refId\n  compositeId\n  date\n";

var WholeAuditFragment = {};

var WholeDisplayAuditFragment = {};

var __makeTemplateObject$3O = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(WholeDisplayAuditFragment, "__esModule", { value: true });
WholeDisplayAuditFragment.WHOLE_DISPLAY_AUDIT_FRAGMENT = void 0;
var client_1$4i = require$$0$1;
var AuditInventoryItemFragment_1 = AuditInventoryItemFragment;
WholeDisplayAuditFragment.WHOLE_DISPLAY_AUDIT_FRAGMENT = (0, client_1$4i.gql)(templateObject_1$3O || (templateObject_1$3O = __makeTemplateObject$3O(["\n  fragment WholeDisplayAudit on DisplayAudit {\n    __typename\n    id\n    predictions\n    products {\n      ...AuditInventoryItem\n    }\n    dateCompleted\n    display {\n      id\n      area\n      displayType\n      shortDescription\n      isCompetitor\n    }\n    employee {\n      id\n      email\n    }\n  }\n  ", "\n"], ["\n  fragment WholeDisplayAudit on DisplayAudit {\n    __typename\n    id\n    predictions\n    products {\n      ...AuditInventoryItem\n    }\n    dateCompleted\n    display {\n      id\n      area\n      displayType\n      shortDescription\n      isCompetitor\n    }\n    employee {\n      id\n      email\n    }\n  }\n  ", "\n"])), AuditInventoryItemFragment_1.AUDIT_INVENTORY_ITEM_FRAGMENT);
var templateObject_1$3O;

var __makeTemplateObject$3N = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(WholeAuditFragment, "__esModule", { value: true });
WholeAuditFragment.WHOLE_AUDIT_FRAGMENT = void 0;
var client_1$4h = require$$0$1;
var ProductPriceFragment_1 = ProductPriceFragment;
var WholeDisplayAuditFragment_1 = WholeDisplayAuditFragment;
var ScoreFragments_1 = ScoreFragments;
var AuditAnswerFragment_1 = AuditAnswerFragment;
var CRCountItemFragment_1 = CRCountItemFragment;
WholeAuditFragment.WHOLE_AUDIT_FRAGMENT = (0, client_1$4h.gql)(templateObject_1$3N || (templateObject_1$3N = __makeTemplateObject$3N(["\n  fragment WholeAudit on Audit {\n    id\n    created\n    saved\n    dateCompleted\n    displaysCompletedAt\n    pricingCompletedAt\n    surveyCompletedAt\n    employee {\n      firstName\n      lastName\n      id\n      email\n    }\n    store {\n      id\n      storeChain\n      name\n      hasAllFormulas\n      category\n      address {\n        address1\n        city\n        state\n        postalCode\n      }\n    }\n    status\n    score {\n      ...AuditScore\n    }\n    notes\n    auditAnswers {\n      ...AuditAnswer\n    }\n    displayAudits {\n      ...WholeDisplayAudit\n    }\n    crCountItems {\n      ...CRCountItem\n    }\n    productPrices {\n      ...ProductPrice\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment WholeAudit on Audit {\n    id\n    created\n    saved\n    dateCompleted\n    displaysCompletedAt\n    pricingCompletedAt\n    surveyCompletedAt\n    employee {\n      firstName\n      lastName\n      id\n      email\n    }\n    store {\n      id\n      storeChain\n      name\n      hasAllFormulas\n      category\n      address {\n        address1\n        city\n        state\n        postalCode\n      }\n    }\n    status\n    score {\n      ...AuditScore\n    }\n    notes\n    auditAnswers {\n      ...AuditAnswer\n    }\n    displayAudits {\n      ...WholeDisplayAudit\n    }\n    crCountItems {\n      ...CRCountItem\n    }\n    productPrices {\n      ...ProductPrice\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), AuditAnswerFragment_1.AUDIT_ANSWER_FRAGMENT, ScoreFragments_1.AUDIT_SCORE_FRAGMENT, WholeDisplayAuditFragment_1.WHOLE_DISPLAY_AUDIT_FRAGMENT, ProductPriceFragment_1.PRODUCT_PRICE_FRAGMENT, CRCountItemFragment_1.CR_COUNT_ITEM_FRAGMENT);
var templateObject_1$3N;

var WholeDisplayFragment = {};

var __makeTemplateObject$3M = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(WholeDisplayFragment, "__esModule", { value: true });
WholeDisplayFragment.WHOLE_DISPLAY_FRAGMENT = void 0;
var client_1$4g = require$$0$1;
var CubeDimensions_1 = CubeDimensions;
WholeDisplayFragment.WHOLE_DISPLAY_FRAGMENT = (0, client_1$4g.gql)(templateObject_1$3M || (templateObject_1$3M = __makeTemplateObject$3M(["\n  fragment WholeDisplay on Display {\n    id\n    qrId\n    name\n    shortDescription\n    displayType\n    extraInfo\n    saved\n    isCompetitor\n    salesVolume\n    images {\n      id\n      url\n    }\n    area\n    numCoolerDoors\n    doorHandlePlacement\n    idealInventory {\n      upcs\n    }\n    dateRemoved\n    point {\n      latitude\n      longitude\n    }\n    boundingCubes {\n      ...CubeDimensions\n    }\n  }\n\n  ", "\n"], ["\n  fragment WholeDisplay on Display {\n    id\n    qrId\n    name\n    shortDescription\n    displayType\n    extraInfo\n    saved\n    isCompetitor\n    salesVolume\n    images {\n      id\n      url\n    }\n    area\n    numCoolerDoors\n    doorHandlePlacement\n    idealInventory {\n      upcs\n    }\n    dateRemoved\n    point {\n      latitude\n      longitude\n    }\n    boundingCubes {\n      ...CubeDimensions\n    }\n  }\n\n  ", "\n"])), CubeDimensions_1.CUBE_DIMENSIONS);
var templateObject_1$3M;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(AdminAuditFragment, exports);
__exportStar(AdminAuditInventoryItemFragment, exports);
__exportStar(AdminWholeAuditFragment, exports);
__exportStar(AdminStoreFragment, exports);
__exportStar(AuditAnswerFragment, exports);
__exportStar(AdminWholeDisplayAuditFragment, exports);
__exportStar(AuditInventoryItemFragment, exports);
__exportStar(AuditFragment, exports);
__exportStar(BasicBoundingBoxesFragment, exports);
__exportStar(AuditQuestionFragment, exports);
__exportStar(BasicDisplayAuditImageFragment, exports);
__exportStar(BasicProductFragment, exports);
__exportStar(BoundingBoxesFragment, exports);
__exportStar(BoundingCubeFragment, exports);
__exportStar(BrandFragment$1, exports);
__exportStar(CRCountItemFragment, exports);
__exportStar(ComplianceAuditFragment, exports);
__exportStar(CRCountTypeFragment, exports);
__exportStar(CubeDimensions, exports);
__exportStar(DIsplaySegmentFragment, exports);
__exportStar(DisplayAuditFragment, exports);
__exportStar(DisplayAuditImageFragment, exports);
__exportStar(DisplayFragmentWithPlanogram, exports);
__exportStar(DisplayFragment, exports);
__exportStar(DisplaySalesFragment, exports);
__exportStar(DisplayShelfFragment, exports);
__exportStar(DisplayWithStoreDataFragment, exports);
__exportStar(DrawMapTaskFragment, exports);
__exportStar(FlaggableObjectFragment, exports);
__exportStar(FullStoreFragment, exports);
__exportStar(GeographicHierarchyDraftFragment, exports);
__exportStar(GeographicHierarchyLeadFragment, exports);
__exportStar(MLModelFileFragment, exports);
__exportStar(MLModelFragment, exports);
__exportStar(ManufacturerFragment$1, exports);
__exportStar(MerchandiserDisplayScanImageFragment, exports);
__exportStar(MinimalStoreFragment, exports);
__exportStar(ModComActualFacing, exports);
__exportStar(MultiProductImageFragment, exports);
__exportStar(MultiProductImageProductFragment, exports);
__exportStar(PackagingFragment$1, exports);
__exportStar(PicOSGroupComplianceFragment, exports);
__exportStar(PicOSGroupComplianceStats, exports);
__exportStar(PicOSPriorityOverviewFragment, exports);
__exportStar(PicOSSalesCenterComplianceFragment, exports);
__exportStar(PicOSStoreComplianceFragment, exports);
__exportStar(PlanogramFeedbackImagesIssuesFragment, exports);
__exportStar(PlanogramFragment, exports);
__exportStar(PointFragment, exports);
__exportStar(ProductFragment$1, exports);
__exportStar(ProductImageFragment, exports);
__exportStar(ProductPriceFragment, exports);
__exportStar(ReportedIssueFragment, exports);
__exportStar(ProductPriceObjectFragment, exports);
__exportStar(ScanImageFragment, exports);
__exportStar(ScoreFragments, exports);
__exportStar(ShelfComplianceGroupFragment, exports);
__exportStar(SegmentComplianceGroupFragment, exports);
__exportStar(ShippingFragment$1, exports);
__exportStar(SimpleFlaggableObjectFragment, exports);
__exportStar(SimpleInventoryFragment, exports);
__exportStar(SimpleProductFragment, exports);
__exportStar(SingleProductPointCloud, exports);
__exportStar(SimpleStoreAuditFragment, exports);
__exportStar(StoreAddressFragment, exports);
__exportStar(StoreFragment, exports);
__exportStar(StoreRegionFragment, exports);
__exportStar(TaskFragment, exports);
__exportStar(TrainingFragment, exports);
__exportStar(TrainingImageFragment, exports);
__exportStar(TrainingPointCloud, exports);
__exportStar(UserFragment, exports);
__exportStar(UserProductivityResultFragment, exports);
__exportStar(WhiteRabbitProductFragment, exports);
__exportStar(WholeAuditFragment, exports);
__exportStar(WholeDisplayAuditFragment, exports);
__exportStar(WholeDisplayFragment, exports);
__exportStar(PhysicalStoreFragment, exports);
}(fragments$1));

var queries$2 = {};

var AllDisplays = {};

var __makeTemplateObject$3L = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AllDisplays, "__esModule", { value: true });
AllDisplays.ALL_DISPLAYS = void 0;
var client_1$4f = require$$0$1;
AllDisplays.ALL_DISPLAYS = (0, client_1$4f.gql)(templateObject_1$3L || (templateObject_1$3L = __makeTemplateObject$3L(["\n  query AllDisplays($input: AllDisplaysInput!) {\n    displays(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        shortDescription\n        displayType\n        store {\n          id\n          name\n        }\n        images {\n          url\n        }\n        numCoolerDoors\n        idealInventory {\n          upcs\n        }\n      }\n    }\n  }\n"], ["\n  query AllDisplays($input: AllDisplaysInput!) {\n    displays(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        shortDescription\n        displayType\n        store {\n          id\n          name\n        }\n        images {\n          url\n        }\n        numCoolerDoors\n        idealInventory {\n          upcs\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$3L;

var BrandDisruptorSummaryStats = {};

var __makeTemplateObject$3K = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BrandDisruptorSummaryStats, "__esModule", { value: true });
BrandDisruptorSummaryStats.BRAND_DISRUPTOR_SUMMARY_STATS = void 0;
var client_1$4e = require$$0$1;
BrandDisruptorSummaryStats.BRAND_DISRUPTOR_SUMMARY_STATS = (0, client_1$4e.gql)(templateObject_1$3K || (templateObject_1$3K = __makeTemplateObject$3K(["\nquery SummaryStatsQuery($input: DateRangeInput!) {\n  summaryStats(input:$input) {\n      trendingUp {\n          brand {\n              id\n              name\n          }\n          delta\n      }\n      trendingDown {\n          brand {\n              id\n              name\n          }\n          delta\n      }\n      newBrands {\n        brand {\n            id\n            name\n        }\n        dateFirstObserved\n        numberOfStores\n        numberOfFacings\n      }\n  }\n}\n"], ["\nquery SummaryStatsQuery($input: DateRangeInput!) {\n  summaryStats(input:$input) {\n      trendingUp {\n          brand {\n              id\n              name\n          }\n          delta\n      }\n      trendingDown {\n          brand {\n              id\n              name\n          }\n          delta\n      }\n      newBrands {\n        brand {\n            id\n            name\n        }\n        dateFirstObserved\n        numberOfStores\n        numberOfFacings\n      }\n  }\n}\n"])));
var templateObject_1$3K;

var BrandExplorer = {};

var __makeTemplateObject$3J = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BrandExplorer, "__esModule", { value: true });
BrandExplorer.BRAND_EXPLORER = void 0;
var client_1$4d = require$$0$1;
BrandExplorer.BRAND_EXPLORER = (0, client_1$4d.gql)(templateObject_1$3J || (templateObject_1$3J = __makeTemplateObject$3J(["\nquery BrandExplorerQuery($input: DateRangeInput!) {\n    brandExplorer(input:$input) {\n    \tbrandInfo {\n        brand {\n\t\t  name\n          id\n        }\n        numStores\n        sovi\n        soviPercentChange\n      }\n    }\n}\n\n"], ["\nquery BrandExplorerQuery($input: DateRangeInput!) {\n    brandExplorer(input:$input) {\n    \tbrandInfo {\n        brand {\n\t\t  name\n          id\n        }\n        numStores\n        sovi\n        soviPercentChange\n      }\n    }\n}\n\n"])));
var templateObject_1$3J;

var BrandGeography = {};

var __makeTemplateObject$3I = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BrandGeography, "__esModule", { value: true });
BrandGeography.BRAND_GEOGRAPHY = void 0;
var client_1$4c = require$$0$1;
BrandGeography.BRAND_GEOGRAPHY = (0, client_1$4c.gql)(templateObject_1$3I || (templateObject_1$3I = __makeTemplateObject$3I(["\nquery BrandGeographyQuery($input: BrandGeographyInput!) {\n    brandGeography(input:$input) {\n    \tresults {\n        latitude\n        longitude\n        quantity\n        storeName\n        brand {\n          name\n        }\n      }\n    }\n}\n"], ["\nquery BrandGeographyQuery($input: BrandGeographyInput!) {\n    brandGeography(input:$input) {\n    \tresults {\n        latitude\n        longitude\n        quantity\n        storeName\n        brand {\n          name\n        }\n      }\n    }\n}\n"])));
var templateObject_1$3I;

var BrandLandscape = {};

var __makeTemplateObject$3H = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BrandLandscape, "__esModule", { value: true });
BrandLandscape.BRAND_LANDSCAPE = void 0;
var client_1$4b = require$$0$1;
BrandLandscape.BRAND_LANDSCAPE = (0, client_1$4b.gql)(templateObject_1$3H || (templateObject_1$3H = __makeTemplateObject$3H(["\nquery BrandLandscapeQuery($input: DateRangeInput!) {\n    brandLandscape(input:$input) {\n    \tresults {\n        brand {\n          name\n          id\n        }\n        sovi\n        changeInSovi\n      }\n  \t}\n}\n"], ["\nquery BrandLandscapeQuery($input: DateRangeInput!) {\n    brandLandscape(input:$input) {\n    \tresults {\n        brand {\n          name\n          id\n        }\n        sovi\n        changeInSovi\n      }\n  \t}\n}\n"])));
var templateObject_1$3H;

var BrandHistory = {};

var __makeTemplateObject$3G = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BrandHistory, "__esModule", { value: true });
BrandHistory.BRAND_HISTORY = void 0;
var client_1$4a = require$$0$1;
BrandHistory.BRAND_HISTORY = (0, client_1$4a.gql)(templateObject_1$3G || (templateObject_1$3G = __makeTemplateObject$3G(["\n  query BrandHistoryQuery($input: BrandHistoryInput!) {\n    brandHistory(input: $input) {\n      brandHistories {\n        brand {\n          name\n        }\n        historicalRelevancyList {\n          relevancyScore\n          date\n        }\n      }\n    }\n  }\n"], ["\n  query BrandHistoryQuery($input: BrandHistoryInput!) {\n    brandHistory(input: $input) {\n      brandHistories {\n        brand {\n          name\n        }\n        historicalRelevancyList {\n          relevancyScore\n          date\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$3G;

var CompanyCategorySoviFormulaGroups = {};

var __makeTemplateObject$3F = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CompanyCategorySoviFormulaGroups, "__esModule", { value: true });
CompanyCategorySoviFormulaGroups.COMPANY_CATEGORY_SOVI_FORMULA_GROUPS = void 0;
var client_1$49 = require$$0$1;
CompanyCategorySoviFormulaGroups.COMPANY_CATEGORY_SOVI_FORMULA_GROUPS = (0, client_1$49.gql)(templateObject_1$3F || (templateObject_1$3F = __makeTemplateObject$3F(["\n  query CompanyCategorySoviFormulaGroups {\n    companyCategorySoviFormulaGroups {\n      name\n      id\n      info\n    }\n  }\n"], ["\n  query CompanyCategorySoviFormulaGroups {\n    companyCategorySoviFormulaGroups {\n      name\n      id\n      info\n    }\n  }\n"])));
var templateObject_1$3F;

var CompanyColdAvailabilityFormulaGroups = {};

var __makeTemplateObject$3E = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CompanyColdAvailabilityFormulaGroups, "__esModule", { value: true });
CompanyColdAvailabilityFormulaGroups.COMPANY_COLD_AVAILABILITY_FORMULA_GROUPS = void 0;
var client_1$48 = require$$0$1;
CompanyColdAvailabilityFormulaGroups.COMPANY_COLD_AVAILABILITY_FORMULA_GROUPS = (0, client_1$48.gql)(templateObject_1$3E || (templateObject_1$3E = __makeTemplateObject$3E(["\n  query CompanyColdAvailabilityFormulaGroups {\n    companyColdAvailabilityFormulaGroups {\n      name\n      id\n      info\n    }\n  }\n"], ["\n  query CompanyColdAvailabilityFormulaGroups {\n    companyColdAvailabilityFormulaGroups {\n      name\n      id\n      info\n    }\n  }\n"])));
var templateObject_1$3E;

var CompanyStoreDistributions = {};

var __makeTemplateObject$3D = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CompanyStoreDistributions, "__esModule", { value: true });
CompanyStoreDistributions.COMPANY_STORE_DISTRIBUTIONS = void 0;
var client_1$47 = require$$0$1;
CompanyStoreDistributions.COMPANY_STORE_DISTRIBUTIONS = (0, client_1$47.gql)(templateObject_1$3D || (templateObject_1$3D = __makeTemplateObject$3D(["\n  query CompanyStoreDistributions($companyStoreId: ID!) {\n    distributions(companyStoreId: $companyStoreId) {\n      storeDistributedUpcs\n    }\n  }\n"], ["\n  query CompanyStoreDistributions($companyStoreId: ID!) {\n    distributions(companyStoreId: $companyStoreId) {\n      storeDistributedUpcs\n    }\n  }\n"])));
var templateObject_1$3D;

var GetAdminAuditHistory = {};

var __makeTemplateObject$3C = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminAuditHistory, "__esModule", { value: true });
GetAdminAuditHistory.GET_ADMIN_AUDIT_HISTORY = void 0;
var client_1$46 = require$$0$1;
var fragments_1$15 = fragments$1;
GetAdminAuditHistory.GET_ADMIN_AUDIT_HISTORY = (0, client_1$46.gql)(templateObject_1$3C || (templateObject_1$3C = __makeTemplateObject$3C(["\n  query GetAdminAuditHistory($input: AdminAuditsInput) {\n    adminAudits(input: $input) {\n      results {\n        ...SimpleAudit\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetAdminAuditHistory($input: AdminAuditsInput) {\n    adminAudits(input: $input) {\n      results {\n        ...SimpleAudit\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), fragments_1$15.SIMPLE_AUDIT_FRAGMENT);
var templateObject_1$3C;

var GetAdminAudits = {};

var __makeTemplateObject$3B = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminAudits, "__esModule", { value: true });
GetAdminAudits.GET_ADMIN_PORTAL_AUDITS = void 0;
var client_1$45 = require$$0$1;
var fragments_1$14 = fragments$1;
GetAdminAudits.GET_ADMIN_PORTAL_AUDITS = (0, client_1$45.gql)(templateObject_1$3B || (templateObject_1$3B = __makeTemplateObject$3B(["\n  query GetAdminPortalAudits($input: AdminPortalAuditsInput) {\n    adminPortalAudits(input: $input) {\n      results {\n        ...AdminAudit\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetAdminPortalAudits($input: AdminPortalAuditsInput) {\n    adminPortalAudits(input: $input) {\n      results {\n        ...AdminAudit\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), fragments_1$14.ADMIN_AUDIT_FRAGMENT);
var templateObject_1$3B;

var GetAdminCompanyRegions = {};

var __makeTemplateObject$3A = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminCompanyRegions, "__esModule", { value: true });
GetAdminCompanyRegions.GET_ADMIN_COMPANY_REGIONS = void 0;
var client_1$44 = require$$0$1;
GetAdminCompanyRegions.GET_ADMIN_COMPANY_REGIONS = (0, client_1$44.gql)(templateObject_1$3A || (templateObject_1$3A = __makeTemplateObject$3A(["\n  query GetAdminCompanyRegions {\n    regions {\n      id\n      name\n    }\n  }\n"], ["\n  query GetAdminCompanyRegions {\n    regions {\n      id\n      name\n    }\n  }\n"])));
var templateObject_1$3A;

var GetAdminCompanyStoreCategoriesById = {};

var __makeTemplateObject$3z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminCompanyStoreCategoriesById, "__esModule", { value: true });
GetAdminCompanyStoreCategoriesById.GET_ADMIN_COMPANY_STORE_CATEGORIES = void 0;
var client_1$43 = require$$0$1;
GetAdminCompanyStoreCategoriesById.GET_ADMIN_COMPANY_STORE_CATEGORIES = (0, client_1$43.gql)(templateObject_1$3z || (templateObject_1$3z = __makeTemplateObject$3z(["\nquery GetAdminCompanyStoreCategoriesById($input: CompanyStoresByIdsInput!) {\n    companyStoresByIds(input: $input) {\n      category\n      id\n    }\n  }\n"], ["\nquery GetAdminCompanyStoreCategoriesById($input: CompanyStoresByIdsInput!) {\n    companyStoresByIds(input: $input) {\n      category\n      id\n    }\n  }\n"])));
var templateObject_1$3z;

var GetAdminCompanyStores = {};

var __makeTemplateObject$3y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminCompanyStores, "__esModule", { value: true });
GetAdminCompanyStores.GET_ADMIN_COMPANY_STORES = void 0;
var client_1$42 = require$$0$1;
var fragments_1$13 = fragments$1;
GetAdminCompanyStores.GET_ADMIN_COMPANY_STORES = (0, client_1$42.gql)(templateObject_1$3y || (templateObject_1$3y = __makeTemplateObject$3y(["\n  query AdminCompanyStores($input: AdminCompanyStoresInput!) {\n    adminCompanyStores(input: $input) {\n      hasMore\n      count\n      results {\n        ...AdminStore\n      }\n    }\n  }\n  ", "\n"], ["\n  query AdminCompanyStores($input: AdminCompanyStoresInput!) {\n    adminCompanyStores(input: $input) {\n      hasMore\n      count\n      results {\n        ...AdminStore\n      }\n    }\n  }\n  ", "\n"])), fragments_1$13.ADMIN_STORE_FRAGMENT);
var templateObject_1$3y;

var GetAdminCompanyStoresForDownload = {};

var __makeTemplateObject$3x = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminCompanyStoresForDownload, "__esModule", { value: true });
GetAdminCompanyStoresForDownload.GET_ADMIN_COMPANY_STORES_FOR_DOWNLOAD = void 0;
var client_1$41 = require$$0$1;
var fragments_1$12 = fragments$1;
GetAdminCompanyStoresForDownload.GET_ADMIN_COMPANY_STORES_FOR_DOWNLOAD = (0, client_1$41.gql)(templateObject_1$3x || (templateObject_1$3x = __makeTemplateObject$3x(["\n  query AdminCompanyStoresForDownload($input: AdminCompanyStoresInput!) {\n    adminCompanyStores(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        name\n        internalStoreId\n        category\n        isActive\n        address {\n          ...StoreAddress\n        }\n        users {\n          email\n          isActive\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query AdminCompanyStoresForDownload($input: AdminCompanyStoresInput!) {\n    adminCompanyStores(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        name\n        internalStoreId\n        category\n        isActive\n        address {\n          ...StoreAddress\n        }\n        users {\n          email\n          isActive\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$12.STORE_ADDRESS_FRAGMENT);
var templateObject_1$3x;

var GetAdminStore = {};

var __makeTemplateObject$3w = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminStore, "__esModule", { value: true });
GetAdminStore.GET_ADMIN_STORE = void 0;
var client_1$40 = require$$0$1;
var fragments_1$11 = fragments$1;
GetAdminStore.GET_ADMIN_STORE = (0, client_1$40.gql)(templateObject_1$3w || (templateObject_1$3w = __makeTemplateObject$3w(["\n  query GetAdminStore($storeId: ID!) {\n    store(storeId: $storeId) {\n      ...AdminStore\n    }\n  }\n  ", "\n"], ["\n  query GetAdminStore($storeId: ID!) {\n    store(storeId: $storeId) {\n      ...AdminStore\n    }\n  }\n  ", "\n"])), fragments_1$11.ADMIN_STORE_FRAGMENT);
var templateObject_1$3w;

var GetAdminStoreHistory = {};

var __makeTemplateObject$3v = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminStoreHistory, "__esModule", { value: true });
GetAdminStoreHistory.GET_ADMIN_STORE_HISTORY = void 0;
var client_1$3$ = require$$0$1;
GetAdminStoreHistory.GET_ADMIN_STORE_HISTORY = (0, client_1$3$.gql)(templateObject_1$3v || (templateObject_1$3v = __makeTemplateObject$3v(["\n  query GetStoreHistory($input: StoreHistoryInput!) {\n    storeHistory(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        action\n        employee {\n          email\n        }\n        actionCompletedOn\n        numTimesOptimizeHighPerYear\n        numTimesOptimizeMediumPerYear\n        numTimesOptimizeLowPerYear\n        timesPerWeekTwoDScan\n      }\n    }\n  }\n"], ["\n  query GetStoreHistory($input: StoreHistoryInput!) {\n    storeHistory(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        action\n        employee {\n          email\n        }\n        actionCompletedOn\n        numTimesOptimizeHighPerYear\n        numTimesOptimizeMediumPerYear\n        numTimesOptimizeLowPerYear\n        timesPerWeekTwoDScan\n      }\n    }\n  }\n"])));
var templateObject_1$3v;

var GetAllCompanyUserOptions = {};

var __makeTemplateObject$3u = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAllCompanyUserOptions, "__esModule", { value: true });
GetAllCompanyUserOptions.GET_ALL_COMPANY_USER_OPTIONS = void 0;
var client_1$3_ = require$$0$1;
GetAllCompanyUserOptions.GET_ALL_COMPANY_USER_OPTIONS = (0, client_1$3_.gql)(templateObject_1$3u || (templateObject_1$3u = __makeTemplateObject$3u(["\nquery GetAllCompanyUserOptions {\n  adminCompanyAllUsers {\n      id\n      lastName\n      firstName\n  }\n}\n"], ["\nquery GetAllCompanyUserOptions {\n  adminCompanyAllUsers {\n      id\n      lastName\n      firstName\n  }\n}\n"])));
var templateObject_1$3u;

var GetAdminStoreAudit = {};

var __makeTemplateObject$3t = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAdminStoreAudit, "__esModule", { value: true });
GetAdminStoreAudit.GET_ADMIN_STORE_AUDIT = void 0;
var client_1$3Z = require$$0$1;
var fragments_1$10 = fragments$1;
GetAdminStoreAudit.GET_ADMIN_STORE_AUDIT = (0, client_1$3Z.gql)(templateObject_1$3t || (templateObject_1$3t = __makeTemplateObject$3t(["\n  query GetAdminStoreAudit($auditId: ID!) {\n    audit(auditId: $auditId) {\n      ...AdminWholeAudit\n    }\n  }\n  ", "\n"], ["\n  query GetAdminStoreAudit($auditId: ID!) {\n    audit(auditId: $auditId) {\n      ...AdminWholeAudit\n    }\n  }\n  ", "\n"])), fragments_1$10.ADMIN_WHOLE_AUDIT_FRAGMENT);
var templateObject_1$3t;

var GetAllTrainings = {};

var __makeTemplateObject$3s = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAllTrainings, "__esModule", { value: true });
GetAllTrainings.GET_ALL_TRAININGS = void 0;
var client_1$3Y = require$$0$1;
var TrainingFragment_1$2 = TrainingFragment;
GetAllTrainings.GET_ALL_TRAININGS = (0, client_1$3Y.gql)(templateObject_1$3s || (templateObject_1$3s = __makeTemplateObject$3s(["\n  query Trainings {\n    trainings {\n      ...Training\n    }\n  }\n  ", "\n"], ["\n  query Trainings {\n    trainings {\n      ...Training\n    }\n  }\n  ", "\n"])), TrainingFragment_1$2.TRAINING_FRAGMENT);
var templateObject_1$3s;

var GetAuditQuestions = {};

var __makeTemplateObject$3r = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetAuditQuestions, "__esModule", { value: true });
GetAuditQuestions.GET_AUDIT_QUESTIONS = void 0;
var client_1$3X = require$$0$1;
var fragments_1$$ = fragments$1;
GetAuditQuestions.GET_AUDIT_QUESTIONS = (0, client_1$3X.gql)(templateObject_1$3r || (templateObject_1$3r = __makeTemplateObject$3r(["\n  query GetAuditQuestions {\n    auditQuestions {\n      ...AuditQuestion\n    }\n  }\n  ", "\n"], ["\n  query GetAuditQuestions {\n    auditQuestions {\n      ...AuditQuestion\n    }\n  }\n  ", "\n"])), fragments_1$$.AUDIT_QUESTION_FRAGMENT);
var templateObject_1$3r;

var GetBrands$1 = {};

var __makeTemplateObject$3q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetBrands$1, "__esModule", { value: true });
GetBrands$1.GET_BRANDS = void 0;
var client_1$3W = require$$0$1;
GetBrands$1.GET_BRANDS = (0, client_1$3W.gql)(templateObject_1$3q || (templateObject_1$3q = __makeTemplateObject$3q(["\n  query GetBrands($input: BrandsInput) {\n    brands(input: $input) {\n      id\n      name\n    }\n  }\n"], ["\n  query GetBrands($input: BrandsInput) {\n    brands(input: $input) {\n      id\n      name\n    }\n  }\n"])));
var templateObject_1$3q;

var GetCompanies = {};

var __makeTemplateObject$3p = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanies, "__esModule", { value: true });
GetCompanies.GET_COMPANIES = void 0;
var client_1$3V = require$$0$1;
GetCompanies.GET_COMPANIES = (0, client_1$3V.gql)(templateObject_1$3p || (templateObject_1$3p = __makeTemplateObject$3p(["\n  query GetCompanies {\n    companies {\n      id\n      name\n    }\n  }\n"], ["\n  query GetCompanies {\n    companies {\n      id\n      name\n    }\n  }\n"])));
var templateObject_1$3p;

var GetCompanyAuditQuestions = {};

var __makeTemplateObject$3o = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyAuditQuestions, "__esModule", { value: true });
GetCompanyAuditQuestions.GET_COMPANY_AUDIT_QUESTIONS = void 0;
var client_1$3U = require$$0$1;
GetCompanyAuditQuestions.GET_COMPANY_AUDIT_QUESTIONS = (0, client_1$3U.gql)(templateObject_1$3o || (templateObject_1$3o = __makeTemplateObject$3o(["\n  query GetCompanyAuditQuestions($input: AuditQuestionsInput) {\n    auditQuestions(input: $input) {\n      id\n      question\n      category\n      pointWorth\n      group\n    }\n  }\n"], ["\n  query GetCompanyAuditQuestions($input: AuditQuestionsInput) {\n    auditQuestions(input: $input) {\n      id\n      question\n      category\n      pointWorth\n      group\n    }\n  }\n"])));
var templateObject_1$3o;

var GetCompanyByName = {};

var __makeTemplateObject$3n = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyByName, "__esModule", { value: true });
GetCompanyByName.GET_COMPANY_BY_NAME = void 0;
var client_1$3T = require$$0$1;
GetCompanyByName.GET_COMPANY_BY_NAME = (0, client_1$3T.gql)(templateObject_1$3n || (templateObject_1$3n = __makeTemplateObject$3n(["\n    query GetCompanyByName($name: String!) {\n      companyByName(name:$name) {\n        name\n        id\n      }\n    }\n"], ["\n    query GetCompanyByName($name: String!) {\n      companyByName(name:$name) {\n        name\n        id\n      }\n    }\n"])));
var templateObject_1$3n;

var GetCompanyChains = {};

var __makeTemplateObject$3m = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyChains, "__esModule", { value: true });
GetCompanyChains.GET_COMPANY_CHAINS = void 0;
var client_1$3S = require$$0$1;
GetCompanyChains.GET_COMPANY_CHAINS = (0, client_1$3S.gql)(templateObject_1$3m || (templateObject_1$3m = __makeTemplateObject$3m(["\n  query GetCompanyChains {\n    companyChains {\n      id\n      name\n    }\n  }\n"], ["\n  query GetCompanyChains {\n    companyChains {\n      id\n      name\n    }\n  }\n"])));
var templateObject_1$3m;

var GetCompanyProductCategories = {};

var __makeTemplateObject$3l = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyProductCategories, "__esModule", { value: true });
GetCompanyProductCategories.GET_COMPANY_PRODUCT_CATEGORIES = void 0;
var client_1$3R = require$$0$1;
GetCompanyProductCategories.GET_COMPANY_PRODUCT_CATEGORIES = (0, client_1$3R.gql)(templateObject_1$3l || (templateObject_1$3l = __makeTemplateObject$3l(["\n  query GetCompanyProductCategories($companyId: ID) {\n    companyProductCategories(companyId: $companyId) {\n      id\n      category\n      parentCategory\n    }\n  }\n"], ["\n  query GetCompanyProductCategories($companyId: ID) {\n    companyProductCategories(companyId: $companyId) {\n      id\n      category\n      parentCategory\n    }\n  }\n"])));
var templateObject_1$3l;

var GetCompanyRegions = {};

var __makeTemplateObject$3k = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyRegions, "__esModule", { value: true });
GetCompanyRegions.GET_COMPANY_REGIONS = void 0;
var client_1$3Q = require$$0$1;
var fragments_1$_ = fragments$1;
GetCompanyRegions.GET_COMPANY_REGIONS = (0, client_1$3Q.gql)(templateObject_1$3k || (templateObject_1$3k = __makeTemplateObject$3k(["\n  query GetCompanyRegions($companyId: ID!) {\n    companyRegions(companyId: $companyId) {\n      ...StoreRegion\n    }\n  }\n  ", "\n"], ["\n  query GetCompanyRegions($companyId: ID!) {\n    companyRegions(companyId: $companyId) {\n      ...StoreRegion\n    }\n  }\n  ", "\n"])), fragments_1$_.STORE_REGION_FRAGMENT);
var templateObject_1$3k;

var GetCompanyRegion = {};

var __makeTemplateObject$3j = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyRegion, "__esModule", { value: true });
GetCompanyRegion.GET_COMPANY_REGION = void 0;
var client_1$3P = require$$0$1;
var fragments_1$Z = fragments$1;
GetCompanyRegion.GET_COMPANY_REGION = (0, client_1$3P.gql)(templateObject_1$3j || (templateObject_1$3j = __makeTemplateObject$3j(["\n  query GetCompanyRegion($regionId: ID!) {\n    companyRegion(regionId: $regionId) {\n      ...StoreRegion\n    }\n  }\n  ", "\n"], ["\n  query GetCompanyRegion($regionId: ID!) {\n    companyRegion(regionId: $regionId) {\n      ...StoreRegion\n    }\n  }\n  ", "\n"])), fragments_1$Z.STORE_REGION_FRAGMENT);
var templateObject_1$3j;

var GetCompanyRegionsSimple = {};

var __makeTemplateObject$3i = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyRegionsSimple, "__esModule", { value: true });
GetCompanyRegionsSimple.GET_COMPANY_REGIONS_SIMPLE = void 0;
var client_1$3O = require$$0$1;
GetCompanyRegionsSimple.GET_COMPANY_REGIONS_SIMPLE = (0, client_1$3O.gql)(templateObject_1$3i || (templateObject_1$3i = __makeTemplateObject$3i(["\n  query GetCompanyRegionsSimple($companyId: ID!) {\n    companyRegions(companyId: $companyId) {\n      id\n      name\n      parentId\n    }\n  }\n"], ["\n  query GetCompanyRegionsSimple($companyId: ID!) {\n    companyRegions(companyId: $companyId) {\n      id\n      name\n      parentId\n    }\n  }\n"])));
var templateObject_1$3i;

var GetCompanyStoreByInternalStoreId = {};

var __makeTemplateObject$3h = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyStoreByInternalStoreId, "__esModule", { value: true });
GetCompanyStoreByInternalStoreId.GET_COMPANY_STORE_BY_INTERNAL_STORE_ID = void 0;
var client_1$3N = require$$0$1;
GetCompanyStoreByInternalStoreId.GET_COMPANY_STORE_BY_INTERNAL_STORE_ID = (0, client_1$3N.gql)(templateObject_1$3h || (templateObject_1$3h = __makeTemplateObject$3h(["\n  query CompanyStoreByInternalStoreId($internalStoreId: ID!) {\n    companyStoreByInternalStoreId(internalStoreId: $internalStoreId) {\n      id\n    }\n  }\n"], ["\n  query CompanyStoreByInternalStoreId($internalStoreId: ID!) {\n    companyStoreByInternalStoreId(internalStoreId: $internalStoreId) {\n      id\n    }\n  }\n"])));
var templateObject_1$3h;

var GetCompanyStoreOptions = {};

var __makeTemplateObject$3g = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyStoreOptions, "__esModule", { value: true });
GetCompanyStoreOptions.GET_COMPANY_STORE_OPTIONS = void 0;
var client_1$3M = require$$0$1;
GetCompanyStoreOptions.GET_COMPANY_STORE_OPTIONS = (0, client_1$3M.gql)(templateObject_1$3g || (templateObject_1$3g = __makeTemplateObject$3g(["\n  query GetCompanyStoreOptions($searchTerm: String!) {\n    companyStoreOptions(searchTerm: $searchTerm) {\n      id\n      store {\n        name\n      }\n    }\n  }\n"], ["\n  query GetCompanyStoreOptions($searchTerm: String!) {\n    companyStoreOptions(searchTerm: $searchTerm) {\n      id\n      store {\n        name\n      }\n    }\n  }\n"])));
var templateObject_1$3g;

var GetCompanyUsers = {};

var __makeTemplateObject$3f = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCompanyUsers, "__esModule", { value: true });
GetCompanyUsers.GET_COMPANY_USERS = void 0;
var client_1$3L = require$$0$1;
var fragments_1$Y = fragments$1;
GetCompanyUsers.GET_COMPANY_USERS = (0, client_1$3L.gql)(templateObject_1$3f || (templateObject_1$3f = __makeTemplateObject$3f(["\n  query GetCompanyUsers($input: CompanyUsersInput!) {\n    companyUsers(input: $input) {\n      results {\n        ...User\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetCompanyUsers($input: CompanyUsersInput!) {\n    companyUsers(input: $input) {\n      results {\n        ...User\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), fragments_1$Y.USER_FRAGMENT);
var templateObject_1$3f;

var GetCurrentMapForStore = {};

var __makeTemplateObject$3e = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCurrentMapForStore, "__esModule", { value: true });
GetCurrentMapForStore.GET_CURRENT_MAP_FOR_STORE = void 0;
var client_1$3K = require$$0$1;
GetCurrentMapForStore.GET_CURRENT_MAP_FOR_STORE = (0, client_1$3K.gql)(templateObject_1$3e || (templateObject_1$3e = __makeTemplateObject$3e(["\n  query GetCurrentMapForStore($storeId: ID!) {\n    currentStoreMap(storeId: $storeId) {\n      id\n      geoJson\n      store {\n        id\n      }\n    }\n  }\n"], ["\n  query GetCurrentMapForStore($storeId: ID!) {\n    currentStoreMap(storeId: $storeId) {\n      id\n      geoJson\n      store {\n        id\n      }\n    }\n  }\n"])));
var templateObject_1$3e;

var GetDashboard = {};

var __makeTemplateObject$3d = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDashboard, "__esModule", { value: true });
GetDashboard.GET_DASHBOARD = void 0;
var client_1$3J = require$$0$1;
GetDashboard.GET_DASHBOARD = (0, client_1$3J.gql)(templateObject_1$3d || (templateObject_1$3d = __makeTemplateObject$3d(["\n  query GetDashboard($input: DashboardInput!) {\n    dashboard(input: $input) {\n      storesCount\n      storesNeedAudits\n      storesNoImages\n    }\n  }\n"], ["\n  query GetDashboard($input: DashboardInput!) {\n    dashboard(input: $input) {\n      storesCount\n      storesNeedAudits\n      storesNoImages\n    }\n  }\n"])));
var templateObject_1$3d;

var GetDeployedMLModel = {};

var __makeTemplateObject$3c = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDeployedMLModel, "__esModule", { value: true });
GetDeployedMLModel.GET_DEPLOYED_ML_MODEL = void 0;
var client_1$3I = require$$0$1;
var MLModelFileFragment_1 = MLModelFileFragment;
GetDeployedMLModel.GET_DEPLOYED_ML_MODEL = (0, client_1$3I.gql)(templateObject_1$3c || (templateObject_1$3c = __makeTemplateObject$3c(["\n  query GetDeployedMLModel($modelType: MLModelType!) {\n    deployedMlModel(modelType: $modelType) {\n      ...MLModelFile\n    }\n  }\n  ", "\n"], ["\n  query GetDeployedMLModel($modelType: MLModelType!) {\n    deployedMlModel(modelType: $modelType) {\n      ...MLModelFile\n    }\n  }\n  ", "\n"])), MLModelFileFragment_1.ML_MODEL_FILE_FRAGMENT);
var templateObject_1$3c;

var GetDeployedMLModelsForUser = {};

var __makeTemplateObject$3b = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDeployedMLModelsForUser, "__esModule", { value: true });
GetDeployedMLModelsForUser.GET_DEPLOYED_ML_MODELS_FOR_USER = void 0;
var client_1$3H = require$$0$1;
GetDeployedMLModelsForUser.GET_DEPLOYED_ML_MODELS_FOR_USER = (0, client_1$3H.gql)(templateObject_1$3b || (templateObject_1$3b = __makeTemplateObject$3b(["\n  query GetLoggedInUserMlModels {\n    loggedInUser {\n      mlModelInfo {\n        id\n        version\n        url\n        modelType\n      }\n    }\n  }\n"], ["\n  query GetLoggedInUserMlModels {\n    loggedInUser {\n      mlModelInfo {\n        id\n        version\n        url\n        modelType\n      }\n    }\n  }\n"])));
var templateObject_1$3b;

var GetDisplay = {};

var __makeTemplateObject$3a = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplay, "__esModule", { value: true });
GetDisplay.GET_STORE_DISPLAY = void 0;
var client_1$3G = require$$0$1;
var WholeDisplayFragment_1$2 = WholeDisplayFragment;
GetDisplay.GET_STORE_DISPLAY = (0, client_1$3G.gql)(templateObject_1$3a || (templateObject_1$3a = __makeTemplateObject$3a(["\n  query GetDisplay($displayId: ID!) {\n    display(displayId: $displayId) {\n      ...WholeDisplay\n    }\n  }\n  ", "\n"], ["\n  query GetDisplay($displayId: ID!) {\n    display(displayId: $displayId) {\n      ...WholeDisplay\n    }\n  }\n  ", "\n"])), WholeDisplayFragment_1$2.WHOLE_DISPLAY_FRAGMENT);
var templateObject_1$3a;

var GetDisplayByQrId = {};

var __makeTemplateObject$39 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplayByQrId, "__esModule", { value: true });
GetDisplayByQrId.GET_DISPLAY_BY_QR_ID = void 0;
var client_1$3F = require$$0$1;
GetDisplayByQrId.GET_DISPLAY_BY_QR_ID = (0, client_1$3F.gql)(templateObject_1$39 || (templateObject_1$39 = __makeTemplateObject$39(["\nquery GetDisplayByQrId($qrId: ID!) {\n    displayByQrId(qrId: $qrId) {\n        id\n        name\n        qrId\n        images {\n            url\n        }\n        store {\n            name\n        }\n    }\n}\n"], ["\nquery GetDisplayByQrId($qrId: ID!) {\n    displayByQrId(qrId: $qrId) {\n        id\n        name\n        qrId\n        images {\n            url\n        }\n        store {\n            name\n        }\n    }\n}\n"])));
var templateObject_1$39;

var GetDisplayAuditImage = {};

var __makeTemplateObject$38 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplayAuditImage, "__esModule", { value: true });
GetDisplayAuditImage.GET_DISPLAY_AUDIT_IMAGE = void 0;
var client_1$3E = require$$0$1;
var BasicDisplayAuditImageFragment_1 = BasicDisplayAuditImageFragment;
GetDisplayAuditImage.GET_DISPLAY_AUDIT_IMAGE = (0, client_1$3E.gql)(templateObject_1$38 || (templateObject_1$38 = __makeTemplateObject$38(["\n  query GetDisplayAuditImage($imageId: ID!) {\n    displayAuditImage(imageId: $imageId) {\n      ...BasicDisplayAuditImage\n    }\n  }\n  ", "\n"], ["\n  query GetDisplayAuditImage($imageId: ID!) {\n    displayAuditImage(imageId: $imageId) {\n      ...BasicDisplayAuditImage\n    }\n  }\n  ", "\n"])), BasicDisplayAuditImageFragment_1.BASIC_DISPLAY_AUDIT_IMAGE_FRAGMENT);
var templateObject_1$38;

var GetDisplayLocations = {};

var __makeTemplateObject$37 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplayLocations, "__esModule", { value: true });
GetDisplayLocations.GET_DISPLAY_LOCATIONS = void 0;
var client_1$3D = require$$0$1;
GetDisplayLocations.GET_DISPLAY_LOCATIONS = (0, client_1$3D.gql)(templateObject_1$37 || (templateObject_1$37 = __makeTemplateObject$37(["\n\tquery DisplayLocations($input: DisplayLocationsInput!){\n\t\tdisplayLocations(input: $input){\n\t\t\tcount\n\t\t\tresults{\n\t\t\t\tname\n\t\t\t\tid\n\t\t\t\ttypes{\n\t\t\t\t\tcategory\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tquery DisplayLocations($input: DisplayLocationsInput!){\n\t\tdisplayLocations(input: $input){\n\t\t\tcount\n\t\t\tresults{\n\t\t\t\tname\n\t\t\t\tid\n\t\t\t\ttypes{\n\t\t\t\t\tcategory\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"])));
var templateObject_1$37;

var GetDisplayInventory = {};

var __makeTemplateObject$36 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplayInventory, "__esModule", { value: true });
GetDisplayInventory.GET_DISPLAY_INVENTORY = void 0;
var client_1$3C = require$$0$1;
var fragments_1$X = fragments$1;
GetDisplayInventory.GET_DISPLAY_INVENTORY = (0, client_1$3C.gql)(templateObject_1$36 || (templateObject_1$36 = __makeTemplateObject$36(["\n  query GetDisplayInventory($displayId: ID!) {\n    displayInventory(displayId: $displayId) {\n      ...SimpleInventory\n    }\n  }\n  ", "\n"], ["\n  query GetDisplayInventory($displayId: ID!) {\n    displayInventory(displayId: $displayId) {\n      ...SimpleInventory\n    }\n  }\n  ", "\n"])), fragments_1$X.SIMPLE_INVENTORY_FRAGMENT);
var templateObject_1$36;

var GetDisplayRestockHistory = {};

var __makeTemplateObject$35 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplayRestockHistory, "__esModule", { value: true });
GetDisplayRestockHistory.GET_DISPLAY_RESTOCK_HISTORY = void 0;
var client_1$3B = require$$0$1;
GetDisplayRestockHistory.GET_DISPLAY_RESTOCK_HISTORY = (0, client_1$3B.gql)(templateObject_1$35 || (templateObject_1$35 = __makeTemplateObject$35(["\n  query GetDisplayRestockHistory($input: DisplayRestockHistoryDataInput!) {\n    displayRestockHistory(input: $input) {\n      hasMore\n      count\n      results {\n        scans {\n          pointClouds {\n            bucketFileName\n            pointCount\n            centroids\n            metadata\n            predicted\n            keyframes {\n              url\n            }\n            merchandiserStep\n            recommendation {\n              productRecommendations {\n                upc\n                count\n              }\n            }\n          }\n          employee {\n            email\n          }\n        }\n        transactions {\n          upc\n          credit\n          debit\n          numFacings\n          fieldVerified\n          memo\n          dateCompleted\n        }\n        inventoryBefore {\n          upc\n          quantity\n        }\n        inventoryAfter {\n          upc\n          quantity\n        }\n      }\n    }\n  }\n"], ["\n  query GetDisplayRestockHistory($input: DisplayRestockHistoryDataInput!) {\n    displayRestockHistory(input: $input) {\n      hasMore\n      count\n      results {\n        scans {\n          pointClouds {\n            bucketFileName\n            pointCount\n            centroids\n            metadata\n            predicted\n            keyframes {\n              url\n            }\n            merchandiserStep\n            recommendation {\n              productRecommendations {\n                upc\n                count\n              }\n            }\n          }\n          employee {\n            email\n          }\n        }\n        transactions {\n          upc\n          credit\n          debit\n          numFacings\n          fieldVerified\n          memo\n          dateCompleted\n        }\n        inventoryBefore {\n          upc\n          quantity\n        }\n        inventoryAfter {\n          upc\n          quantity\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$35;

var GetDisplayScans = {};

var __makeTemplateObject$34 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplayScans, "__esModule", { value: true });
GetDisplayScans.GET_DISPLAY_SCANS = void 0;
var client_1$3A = require$$0$1;
GetDisplayScans.GET_DISPLAY_SCANS = (0, client_1$3A.gql)(templateObject_1$34 || (templateObject_1$34 = __makeTemplateObject$34(["\n  query GetDisplayScans($input: UserProductivityInput!) {\n    displayScans(input: $input) {\n      results {\n        refId\n        compositeId\n        compositeName\n        date\n        allRank\n        groupRank\n        allRankChange\n        groupRankChange\n        count\n      }\n      hasMore\n      count\n    }\n  }\n"], ["\n  query GetDisplayScans($input: UserProductivityInput!) {\n    displayScans(input: $input) {\n      results {\n        refId\n        compositeId\n        compositeName\n        date\n        allRank\n        groupRank\n        allRankChange\n        groupRankChange\n        count\n      }\n      hasMore\n      count\n    }\n  }\n"])));
var templateObject_1$34;

var GetDisplayTransactions = {};

var __makeTemplateObject$33 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplayTransactions, "__esModule", { value: true });
GetDisplayTransactions.GET_DISPLAY_TRANSACTIONS = void 0;
var client_1$3z = require$$0$1;
var fragments_1$W = fragments$1;
GetDisplayTransactions.GET_DISPLAY_TRANSACTIONS = (0, client_1$3z.gql)(templateObject_1$33 || (templateObject_1$33 = __makeTemplateObject$33(["\n  query GetDisplayTransactions($input: DisplayTransactionInput!) {\n    displayTransactions(input: $input) {\n      ...DisplayTransaction\n    }\n  }\n  ", "\n"], ["\n  query GetDisplayTransactions($input: DisplayTransactionInput!) {\n    displayTransactions(input: $input) {\n      ...DisplayTransaction\n    }\n  }\n  ", "\n"])), fragments_1$W.DISPLAY_TRANSACTION_FRAGMENT);
var templateObject_1$33;

var GetDisplayTypes = {};

var __makeTemplateObject$32 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplayTypes, "__esModule", { value: true });
GetDisplayTypes.GET_DISPLAY_TYPES = void 0;
var client_1$3y = require$$0$1;
GetDisplayTypes.GET_DISPLAY_TYPES = (0, client_1$3y.gql)(templateObject_1$32 || (templateObject_1$32 = __makeTemplateObject$32(["\n  query DisplayTypes($input: DisplayTypeInput!) {\n    displayTypes(input: $input) {\n      count\n      results {\n        name\n        id\n      }\n    }\n  }\n"], ["\n  query DisplayTypes($input: DisplayTypeInput!) {\n    displayTypes(input: $input) {\n      count\n      results {\n        name\n        id\n      }\n    }\n  }\n"])));
var templateObject_1$32;

var GetDisplaysInventoryForStore = {};

var __makeTemplateObject$31 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDisplaysInventoryForStore, "__esModule", { value: true });
GetDisplaysInventoryForStore.GET_DISPLAYS_INVENTORY_FOR_STORE = void 0;
var client_1$3x = require$$0$1;
var fragments_1$V = fragments$1;
GetDisplaysInventoryForStore.GET_DISPLAYS_INVENTORY_FOR_STORE = (0, client_1$3x.gql)(templateObject_1$31 || (templateObject_1$31 = __makeTemplateObject$31(["\n  query GetDisplaysInventoryForStore($storeId: ID!) {\n    displaysInventoryForStore(storeId: $storeId) {\n      displayId\n      inventory {\n        ...SimpleInventory\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetDisplaysInventoryForStore($storeId: ID!) {\n    displaysInventoryForStore(storeId: $storeId) {\n      displayId\n      inventory {\n        ...SimpleInventory\n      }\n    }\n  }\n  ", "\n"])), fragments_1$V.SIMPLE_INVENTORY_FRAGMENT);
var templateObject_1$31;

var GetDrawMapTask = {};

var __makeTemplateObject$30 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDrawMapTask, "__esModule", { value: true });
GetDrawMapTask.GET_DRAW_MAP_TASK = void 0;
var client_1$3w = require$$0$1;
var DrawMapTaskFragment_1$7 = DrawMapTaskFragment;
GetDrawMapTask.GET_DRAW_MAP_TASK = (0, client_1$3w.gql)(templateObject_1$30 || (templateObject_1$30 = __makeTemplateObject$30(["\n  query GetDrawMapTask($taskId: ID!) {\n    getDrawMapTask(taskId: $taskId) {\n      ...DrawMapTask\n    }\n  }\n  ", "\n"], ["\n  query GetDrawMapTask($taskId: ID!) {\n    getDrawMapTask(taskId: $taskId) {\n      ...DrawMapTask\n    }\n  }\n  ", "\n"])), DrawMapTaskFragment_1$7.DRAW_MAP_TASK_FRAGMENT);
var templateObject_1$30;

var GetDrawMapTasks = {};

var __makeTemplateObject$2$ = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDrawMapTasks, "__esModule", { value: true });
GetDrawMapTasks.GET_DRAW_MAP_TASKS = void 0;
var client_1$3v = require$$0$1;
var DrawMapTaskFragment_1$6 = DrawMapTaskFragment;
GetDrawMapTasks.GET_DRAW_MAP_TASKS = (0, client_1$3v.gql)(templateObject_1$2$ || (templateObject_1$2$ = __makeTemplateObject$2$(["\n  query GetDrawMapTasks($input: IndoorMapDrawTaskInput!) {\n    drawMapTasks(input: $input) {\n      hasMore\n      count\n      results {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetDrawMapTasks($input: IndoorMapDrawTaskInput!) {\n    drawMapTasks(input: $input) {\n      hasMore\n      count\n      results {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"])), DrawMapTaskFragment_1$6.DRAW_MAP_TASK_FRAGMENT);
var templateObject_1$2$;

var GetFlaggedObject = {};

var __makeTemplateObject$2_ = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetFlaggedObject, "__esModule", { value: true });
GetFlaggedObject.GET_FLAGGED_OBJECT = void 0;
var client_1$3u = require$$0$1;
var fragments_1$U = fragments$1;
GetFlaggedObject.GET_FLAGGED_OBJECT = (0, client_1$3u.gql)(templateObject_1$2_ || (templateObject_1$2_ = __makeTemplateObject$2_(["\n  query GetFlaggedObject($input: FlaggableObjectInput!) {\n    flaggableObject(input: $input) {\n      ...FlaggableObject\n    }\n  }\n  ", "\n"], ["\n  query GetFlaggedObject($input: FlaggableObjectInput!) {\n    flaggableObject(input: $input) {\n      ...FlaggableObject\n    }\n  }\n  ", "\n"])), fragments_1$U.FLAGGABLE_OBJECT_FRAGMENT);
var templateObject_1$2_;

var GetFlaggedObjects = {};

var __makeTemplateObject$2Z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetFlaggedObjects, "__esModule", { value: true });
GetFlaggedObjects.GET_FLAGGED_OBJECTS = void 0;
var client_1$3t = require$$0$1;
var SimpleFlaggableObjectFragment_1 = SimpleFlaggableObjectFragment;
GetFlaggedObjects.GET_FLAGGED_OBJECTS = (0, client_1$3t.gql)(templateObject_1$2Z || (templateObject_1$2Z = __makeTemplateObject$2Z(["\n  query GetFlaggedObjects($input: FlaggableObjectsInput!) {\n    objectsByFlagLevel(input: $input) {\n      results {\n        ...SimpleFlaggableObject\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetFlaggedObjects($input: FlaggableObjectsInput!) {\n    objectsByFlagLevel(input: $input) {\n      results {\n        ...SimpleFlaggableObject\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), SimpleFlaggableObjectFragment_1.SIMPLE_FLAGGABLE_OBJECT_FRAGMENT);
var templateObject_1$2Z;

var GetFlaggedReasonsByType = {};

var __makeTemplateObject$2Y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetFlaggedReasonsByType, "__esModule", { value: true });
GetFlaggedReasonsByType.GET_FLAGGED_REASONS = void 0;
var client_1$3s = require$$0$1;
GetFlaggedReasonsByType.GET_FLAGGED_REASONS = (0, client_1$3s.gql)(templateObject_1$2Y || (templateObject_1$2Y = __makeTemplateObject$2Y(["\n    query GetFlaggedReasonsByType($flagType: FlaggedType!) {\n      flaggedReasonsByType(flagType: $flagType) {\n        flaggedReasons {\n          type\n          reason\n        }\n      }\n    }\n"], ["\n    query GetFlaggedReasonsByType($flagType: FlaggedType!) {\n      flaggedReasonsByType(flagType: $flagType) {\n        flaggedReasons {\n          type\n          reason\n        }\n      }\n    }\n"])));
var templateObject_1$2Y;

var GetGeographicHierarchyDrafts = {};

var __makeTemplateObject$2X = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetGeographicHierarchyDrafts, "__esModule", { value: true });
GetGeographicHierarchyDrafts.GET_GEOGRAPHIC_HIERARCHY_DRAFTS = void 0;
var client_1$3r = require$$0$1;
var fragments_1$T = fragments$1;
GetGeographicHierarchyDrafts.GET_GEOGRAPHIC_HIERARCHY_DRAFTS = (0, client_1$3r.gql)(templateObject_1$2X || (templateObject_1$2X = __makeTemplateObject$2X(["\n  query GetGeographicHierarchyDrafts($userUuid: ID!) {\n    geographicHierarchyDrafts(userUuid: $userUuid) {\n      territoryName\n      districtManager {\n        uuid\n        firstName\n        lastName\n      }\n      assignedTerritoryUsers {\n        id\n        uuid\n      }\n      drafts {\n        ...GeographicHierarchyDraft\n      }\n    }\n  }\n  ", "\n  ", "\n"], ["\n  query GetGeographicHierarchyDrafts($userUuid: ID!) {\n    geographicHierarchyDrafts(userUuid: $userUuid) {\n      territoryName\n      districtManager {\n        uuid\n        firstName\n        lastName\n      }\n      assignedTerritoryUsers {\n        id\n        uuid\n      }\n      drafts {\n        ...GeographicHierarchyDraft\n      }\n    }\n  }\n  ", "\n  ", "\n"])), fragments_1$T.GEOOGRAPHIC_HIERARCHY_DRAFT, fragments_1$T.STORE_ADDRESS_FRAGMENT);
var templateObject_1$2X;

var GetFullUserStores = {};

var __makeTemplateObject$2W = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetFullUserStores, "__esModule", { value: true });
GetFullUserStores.GET_FULL_USER_STORES = void 0;
var client_1$3q = require$$0$1;
var fragments_1$S = fragments$1;
GetFullUserStores.GET_FULL_USER_STORES = (0, client_1$3q.gql)(templateObject_1$2W || (templateObject_1$2W = __makeTemplateObject$2W(["\n  query GetFullUserStores($input: CompanyStoresInput!) {\n    companyStores(input: $input) {\n      results {\n        ...FullStore\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetFullUserStores($input: CompanyStoresInput!) {\n    companyStores(input: $input) {\n      results {\n        ...FullStore\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), fragments_1$S.FULL_STORE_FRAGMENT);
var templateObject_1$2W;

var GetGeographicHierarchyLeadCandidates = {};

var __makeTemplateObject$2V = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetGeographicHierarchyLeadCandidates, "__esModule", { value: true });
GetGeographicHierarchyLeadCandidates.GET_GEOGRAPHIC_HIERARCHY_LEAD_CANDIDATES = void 0;
var client_1$3p = require$$0$1;
var fragments_1$R = fragments$1;
GetGeographicHierarchyLeadCandidates.GET_GEOGRAPHIC_HIERARCHY_LEAD_CANDIDATES = (0, client_1$3p.gql)(templateObject_1$2V || (templateObject_1$2V = __makeTemplateObject$2V(["\n  query GetGeographicHierarchyLeadCandidates(\n    $input: GeographicHierarchyLeadCandidatesInput!\n  ) {\n    geographicHierarchyLeadCandidates(input: $input) {\n      results {\n        ...GeographicHierarchyLead\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetGeographicHierarchyLeadCandidates(\n    $input: GeographicHierarchyLeadCandidatesInput!\n  ) {\n    geographicHierarchyLeadCandidates(input: $input) {\n      results {\n        ...GeographicHierarchyLead\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), fragments_1$R.GEOGRAPHIC_HIERARCHY_LEAD_CANDIDATE_FRAGMENT);
var templateObject_1$2V;

var GetGroups = {};

var __makeTemplateObject$2U = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetGroups, "__esModule", { value: true });
GetGroups.GET_GROUPS = void 0;
var client_1$3o = require$$0$1;
GetGroups.GET_GROUPS = (0, client_1$3o.gql)(templateObject_1$2U || (templateObject_1$2U = __makeTemplateObject$2U(["\n  query GetGroups {\n    groups {\n      id\n      name\n    }\n  }\n"], ["\n  query GetGroups {\n    groups {\n      id\n      name\n    }\n  }\n"])));
var templateObject_1$2U;

var GetImage = {};

var __makeTemplateObject$2T = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetImage, "__esModule", { value: true });
GetImage.GET_IMAGE = void 0;
var client_1$3n = require$$0$1;
var ProductImageFragment_1 = ProductImageFragment;
var MultiProductImageFragment_1$1 = MultiProductImageFragment;
var DisplayAuditImageFragment_1 = DisplayAuditImageFragment;
var MerchandiserDisplayScanImageFragment_1 = MerchandiserDisplayScanImageFragment;
var TrainingImageFragment_1 = TrainingImageFragment;
var ScanImageFragment_1 = ScanImageFragment;
GetImage.GET_IMAGE = (0, client_1$3n.gql)(templateObject_1$2T || (templateObject_1$2T = __makeTemplateObject$2T(["\n  query GetImage($imageId: ID!, $imageType: ImageType!) {\n    image(imageId: $imageId, imageType: $imageType) {\n      ... on ProductImage {\n        ...ProductImage\n      }\n      ... on MultiProductImage {\n        ...MultiProductImage\n      }\n      ... on DisplayAuditImage {\n        ...DisplayAuditImage\n      }\n      ... on MerchandiserDisplayScanImage {\n        ...MerchandiserDisplayScanImage\n      }\n      ... on ScanImage {\n        ...ScanImage\n      }\n      ... on TrainingImage {\n        ...TrainingImage\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  query GetImage($imageId: ID!, $imageType: ImageType!) {\n    image(imageId: $imageId, imageType: $imageType) {\n      ... on ProductImage {\n        ...ProductImage\n      }\n      ... on MultiProductImage {\n        ...MultiProductImage\n      }\n      ... on DisplayAuditImage {\n        ...DisplayAuditImage\n      }\n      ... on MerchandiserDisplayScanImage {\n        ...MerchandiserDisplayScanImage\n      }\n      ... on ScanImage {\n        ...ScanImage\n      }\n      ... on TrainingImage {\n        ...TrainingImage\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), MultiProductImageFragment_1$1.MULTI_PRODUCT_IMAGE_FRAGMENT, ProductImageFragment_1.PRODUCT_IMAGE_FRAGMENT, DisplayAuditImageFragment_1.DISPLAY_AUDIT_IMAGE_FRAGMENT, MerchandiserDisplayScanImageFragment_1.MERCHANDISER_DISPLAY_SCAN_IMAGE_FRAGMENT, ScanImageFragment_1.SCAN_IMAGE_FRAGMENT, TrainingImageFragment_1.TRAINING_IMAGE_FRAGMENT);
var templateObject_1$2T;

var GetLoggedInUser = {};

var __makeTemplateObject$2S = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetLoggedInUser, "__esModule", { value: true });
GetLoggedInUser.GET_LOGGED_IN_USER = void 0;
var client_1$3m = require$$0$1;
var fragments_1$Q = fragments$1;
GetLoggedInUser.GET_LOGGED_IN_USER = (0, client_1$3m.gql)(templateObject_1$2S || (templateObject_1$2S = __makeTemplateObject$2S(["\n  query GetLoggedInUser {\n    loggedInUser {\n      ...User\n    }\n  }\n  ", "\n"], ["\n  query GetLoggedInUser {\n    loggedInUser {\n      ...User\n    }\n  }\n  ", "\n"])), fragments_1$Q.USER_FRAGMENT);
var templateObject_1$2S;

var GetMLModelIfNeeded = {};

var __makeTemplateObject$2R = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetMLModelIfNeeded, "__esModule", { value: true });
GetMLModelIfNeeded.GET_ML_MODEL_IF_NEEDED = void 0;
var client_1$3l = require$$0$1;
GetMLModelIfNeeded.GET_ML_MODEL_IF_NEEDED = (0, client_1$3l.gql)(templateObject_1$2R || (templateObject_1$2R = __makeTemplateObject$2R(["\n  query GetMLModelIfNeeded($modelType: MLModelType!, $currentVersion: ID) {\n    getMlModelIfNeeded(modelType: $modelType, currentVersion: $currentVersion) {\n      id\n      bucketFileName\n      namesBucketFileName\n      modelType\n      configBucketFileName\n    }\n  }\n"], ["\n  query GetMLModelIfNeeded($modelType: MLModelType!, $currentVersion: ID) {\n    getMlModelIfNeeded(modelType: $modelType, currentVersion: $currentVersion) {\n      id\n      bucketFileName\n      namesBucketFileName\n      modelType\n      configBucketFileName\n    }\n  }\n"])));
var templateObject_1$2R;

var GetManufacturers$1 = {};

var __makeTemplateObject$2Q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetManufacturers$1, "__esModule", { value: true });
GetManufacturers$1.GET_MANUFACTURERS = void 0;
var client_1$3k = require$$0$1;
GetManufacturers$1.GET_MANUFACTURERS = (0, client_1$3k.gql)(templateObject_1$2Q || (templateObject_1$2Q = __makeTemplateObject$2Q(["\n  query GetManufacturers($searchTerm: String) {\n    manufacturers(searchTerm: $searchTerm) {\n      name\n    }\n  }\n"], ["\n  query GetManufacturers($searchTerm: String) {\n    manufacturers(searchTerm: $searchTerm) {\n      name\n    }\n  }\n"])));
var templateObject_1$2Q;

var GetMarketingImagesForProduct = {};

var __makeTemplateObject$2P = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetMarketingImagesForProduct, "__esModule", { value: true });
GetMarketingImagesForProduct.GET_MARKETING_IMAGES_FOR_PRODUCT = void 0;
var client_1$3j = require$$0$1;
GetMarketingImagesForProduct.GET_MARKETING_IMAGES_FOR_PRODUCT = (0, client_1$3j.gql)(templateObject_1$2P || (templateObject_1$2P = __makeTemplateObject$2P(["\n  query MarketingImageForProduct($productId: String!) {\n    marketingImagesForProduct(productId: $productId) {\n      id\n      url\n      bucketFileName\n    }\n  }\n"], ["\n  query MarketingImageForProduct($productId: String!) {\n    marketingImagesForProduct(productId: $productId) {\n      id\n      url\n      bucketFileName\n    }\n  }\n"])));
var templateObject_1$2P;

var GetMerchandiserStats = {};

var __makeTemplateObject$2O = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetMerchandiserStats, "__esModule", { value: true });
GetMerchandiserStats.GET_MERCHANDISER_STATS = void 0;
var client_1$3i = require$$0$1;
GetMerchandiserStats.GET_MERCHANDISER_STATS = (0, client_1$3i.gql)(templateObject_1$2O || (templateObject_1$2O = __makeTemplateObject$2O(["\n  query GetMerchandiserStats($input: MerchReportsInput) {\n    merchandisersStats(input: $input) {\n      user {\n        email\n        firstName\n        lastName\n      }\n      restocksToday\n      restocksThisWeek\n      displaysToday\n      displaysThisWeek\n      storesRestockedToday\n      storesRestockedThisWeek\n      avgScoreToday\n      avgScoreThisWeek\n      date\n    }\n  }\n"], ["\n  query GetMerchandiserStats($input: MerchReportsInput) {\n    merchandisersStats(input: $input) {\n      user {\n        email\n        firstName\n        lastName\n      }\n      restocksToday\n      restocksThisWeek\n      displaysToday\n      displaysThisWeek\n      storesRestockedToday\n      storesRestockedThisWeek\n      avgScoreToday\n      avgScoreThisWeek\n      date\n    }\n  }\n"])));
var templateObject_1$2O;

var GetPhysicalStore = {};

var __makeTemplateObject$2N = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPhysicalStore, "__esModule", { value: true });
GetPhysicalStore.GET_PHYSICAL_STORE = void 0;
var client_1$3h = require$$0$1;
var fragments_1$P = fragments$1;
GetPhysicalStore.GET_PHYSICAL_STORE = (0, client_1$3h.gql)(templateObject_1$2N || (templateObject_1$2N = __makeTemplateObject$2N(["\n  query GetPhysicalStore($storeId: ID!) {\n    physicalStore(storeId: $storeId) {\n      ...PhysicalStore\n    }\n  }\n  ", "\n"], ["\n  query GetPhysicalStore($storeId: ID!) {\n    physicalStore(storeId: $storeId) {\n      ...PhysicalStore\n    }\n  }\n  ", "\n"])), fragments_1$P.PHYSICAL_STORE_FRAGMENT);
var templateObject_1$2N;

var GetModularComplianceAudits = {};

(function (exports) {
var __makeTemplateObject = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SIMPLE_MODULAR_COMPLIANCE_AUDITS = exports.SIMPLE_MODULAR_COMPLIANCE_AUDIT_FRAGMENT = exports.GET_MODULAR_COMPLIANCE_AUDITS = void 0;
var client_1 = require$$0$1;
var fragments_1 = fragments$1;
exports.GET_MODULAR_COMPLIANCE_AUDITS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query ModularComplianceAudits($input: ComplianceAuditsInput!) {\n    modularComplianceAudits(input: $input) {\n      results {\n        ...ComplianceAudit\n        before {\n          strictScore\n          sequenceScore\n          segmentCompliance {\n            scanComplete\n            shelfCompliance {\n              shelf {\n                depth\n                isUnderShelf\n              }\n              facingScores {\n                upc\n                score\n                issue\n                actuals {\n                  upc\n                  index\n                  vFacingUpcs\n                  distanceFromHome\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query ModularComplianceAudits($input: ComplianceAuditsInput!) {\n    modularComplianceAudits(input: $input) {\n      results {\n        ...ComplianceAudit\n        before {\n          strictScore\n          sequenceScore\n          segmentCompliance {\n            scanComplete\n            shelfCompliance {\n              shelf {\n                depth\n                isUnderShelf\n              }\n              facingScores {\n                upc\n                score\n                issue\n                actuals {\n                  upc\n                  index\n                  vFacingUpcs\n                  distanceFromHome\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1.MODULAR_COMPLIANCE_AUDIT_FRAGMENT);
exports.SIMPLE_MODULAR_COMPLIANCE_AUDIT_FRAGMENT = (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fragment SimpleModularComplianceAudit on ComplianceAudit {\n    id\n    dateCompleted\n    strictScore\n    sequenceScore\n    saved\n    employee {\n      ...User\n    }\n  }\n  ", "\n"], ["\n  fragment SimpleModularComplianceAudit on ComplianceAudit {\n    id\n    dateCompleted\n    strictScore\n    sequenceScore\n    saved\n    employee {\n      ...User\n    }\n  }\n  ", "\n"])), fragments_1.USER_FRAGMENT);
exports.GET_SIMPLE_MODULAR_COMPLIANCE_AUDITS = (0, client_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  query SimpleModularComplianceAudits($input: ComplianceAuditsInput!) {\n    modularComplianceAudits(input: $input) {\n      results {\n        ...SimpleModularComplianceAudit\n      }\n    }\n  }\n  ", "\n"], ["\n  query SimpleModularComplianceAudits($input: ComplianceAuditsInput!) {\n    modularComplianceAudits(input: $input) {\n      results {\n        ...SimpleModularComplianceAudit\n      }\n    }\n  }\n  ", "\n"])), exports.SIMPLE_MODULAR_COMPLIANCE_AUDIT_FRAGMENT);
var templateObject_1, templateObject_2, templateObject_3;
}(GetModularComplianceAudits));

var GetPhysicalStores = {};

var __makeTemplateObject$2M = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPhysicalStores, "__esModule", { value: true });
GetPhysicalStores.GET_PHYSICAL_STORES = void 0;
var client_1$3g = require$$0$1;
var fragments_1$O = fragments$1;
GetPhysicalStores.GET_PHYSICAL_STORES = (0, client_1$3g.gql)(templateObject_1$2M || (templateObject_1$2M = __makeTemplateObject$2M(["\n  query GetPhysicalStores($input: StoresInput!) {\n    stores(input: $input) {\n      count\n      hasMore\n      results {\n        ...PhysicalStore\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPhysicalStores($input: StoresInput!) {\n    stores(input: $input) {\n      count\n      hasMore\n      results {\n        ...PhysicalStore\n      }\n    }\n  }\n  ", "\n"])), fragments_1$O.PHYSICAL_STORE_FRAGMENT);
var templateObject_1$2M;

var GetPicOSAllCustomersCompliance = {};

var __makeTemplateObject$2L = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSAllCustomersCompliance, "__esModule", { value: true });
GetPicOSAllCustomersCompliance.GET_PICOS_ALL_CUSTOMERS_COMPLIANCE = void 0;
var client_1$3f = require$$0$1;
var PicOSGroupComplianceFragment_1$1 = PicOSGroupComplianceFragment;
GetPicOSAllCustomersCompliance.GET_PICOS_ALL_CUSTOMERS_COMPLIANCE = (0, client_1$3f.gql)(templateObject_1$2L || (templateObject_1$2L = __makeTemplateObject$2L(["\n  query GetPicOSAllCustomersCompliance(\n    $input: PicOSAllCustomersComplianceInput!\n  ) {\n    picosAllCustomersCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        ...PicOSGroupCompliance\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSAllCustomersCompliance(\n    $input: PicOSAllCustomersComplianceInput!\n  ) {\n    picosAllCustomersCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        ...PicOSGroupCompliance\n      }\n    }\n  }\n  ", "\n"])), PicOSGroupComplianceFragment_1$1.PICOS_GROUP_COMPLIANCE_FRAGMENT);
var templateObject_1$2L;

var GetPicOSAllCustomersStats = {};

var __makeTemplateObject$2K = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSAllCustomersStats, "__esModule", { value: true });
GetPicOSAllCustomersStats.GET_PICOS_ALL_CUSTOMERS_COMPLIANCE_STATS = void 0;
var client_1$3e = require$$0$1;
var PicOSGroupComplianceStats_1$4 = PicOSGroupComplianceStats;
GetPicOSAllCustomersStats.GET_PICOS_ALL_CUSTOMERS_COMPLIANCE_STATS = (0, client_1$3e.gql)(templateObject_1$2K || (templateObject_1$2K = __makeTemplateObject$2K(["\n  query GetPicOSAllCustomersComplianceStats(\n    $input: PicOSAllCustomersComplianceInput!\n  ) {\n    picosAllCustomersStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSAllCustomersComplianceStats(\n    $input: PicOSAllCustomersComplianceInput!\n  ) {\n    picosAllCustomersStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"])), PicOSGroupComplianceStats_1$4.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT);
var templateObject_1$2K;

var GetPicOSCustomerCompliance = {};

var __makeTemplateObject$2J = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSCustomerCompliance, "__esModule", { value: true });
GetPicOSCustomerCompliance.GET_PICOS_CUSTOMER_COMPLIANCE = void 0;
var client_1$3d = require$$0$1;
var PicOSGroupComplianceFragment_1 = PicOSGroupComplianceFragment;
GetPicOSCustomerCompliance.GET_PICOS_CUSTOMER_COMPLIANCE = (0, client_1$3d.gql)(templateObject_1$2J || (templateObject_1$2J = __makeTemplateObject$2J(["\n  query GetPicOSCustomerCompliance($input: PicOSCustomerComplianceInput!) {\n    picosCustomerCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        ...PicOSGroupCompliance\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSCustomerCompliance($input: PicOSCustomerComplianceInput!) {\n    picosCustomerCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        ...PicOSGroupCompliance\n      }\n    }\n  }\n  ", "\n"])), PicOSGroupComplianceFragment_1.PICOS_GROUP_COMPLIANCE_FRAGMENT);
var templateObject_1$2J;

var GetPicOSCustomerComplianceStats = {};

var __makeTemplateObject$2I = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSCustomerComplianceStats, "__esModule", { value: true });
GetPicOSCustomerComplianceStats.GET_PICOS_CUSTOMER_COMPLIANCE_STATS = void 0;
var client_1$3c = require$$0$1;
var PicOSGroupComplianceStats_1$3 = PicOSGroupComplianceStats;
GetPicOSCustomerComplianceStats.GET_PICOS_CUSTOMER_COMPLIANCE_STATS = (0, client_1$3c.gql)(templateObject_1$2I || (templateObject_1$2I = __makeTemplateObject$2I(["\n  query GetPicOSCustomerComplianceStats($input: PicOSCustomerComplianceInput!) {\n    picosCustomerStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSCustomerComplianceStats($input: PicOSCustomerComplianceInput!) {\n    picosCustomerStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"])), PicOSGroupComplianceStats_1$3.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT);
var templateObject_1$2I;

var GetPicOSDivisionCompliance = {};

var __makeTemplateObject$2H = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSDivisionCompliance, "__esModule", { value: true });
GetPicOSDivisionCompliance.GET_PICOS_DIVISION_COMPLIANCE = void 0;
var client_1$3b = require$$0$1;
var PicOSSalesCenterComplianceFragment_1 = PicOSSalesCenterComplianceFragment;
GetPicOSDivisionCompliance.GET_PICOS_DIVISION_COMPLIANCE = (0, client_1$3b.gql)(templateObject_1$2H || (templateObject_1$2H = __makeTemplateObject$2H(["\n  query GetPicOSDivisionCompliance($input: PicOSDivisionComplianceInput!) {\n    picosDivisionCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        ...PicOSSalesCenterCompliance\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSDivisionCompliance($input: PicOSDivisionComplianceInput!) {\n    picosDivisionCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        ...PicOSSalesCenterCompliance\n      }\n    }\n  }\n  ", "\n"])), PicOSSalesCenterComplianceFragment_1.PICOS_SALES_CENTER_COMPLIANCE_FRAGMENT);
var templateObject_1$2H;

var GetPicOSDivisionComplianceStats = {};

var __makeTemplateObject$2G = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSDivisionComplianceStats, "__esModule", { value: true });
GetPicOSDivisionComplianceStats.GET_PICOS_DIVISION_COMPLIANCE_STATS = void 0;
var client_1$3a = require$$0$1;
var PicOSGroupComplianceStats_1$2 = PicOSGroupComplianceStats;
GetPicOSDivisionComplianceStats.GET_PICOS_DIVISION_COMPLIANCE_STATS = (0, client_1$3a.gql)(templateObject_1$2G || (templateObject_1$2G = __makeTemplateObject$2G(["\n  query GetPicOSDivisionComplianceStats($input: PicOSDivisionComplianceInput!) {\n    picosDivisionStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSDivisionComplianceStats($input: PicOSDivisionComplianceInput!) {\n    picosDivisionStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"])), PicOSGroupComplianceStats_1$2.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT);
var templateObject_1$2G;

var GetPicOSPriority = {};

var __makeTemplateObject$2F = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSPriority, "__esModule", { value: true });
GetPicOSPriority.GET_PICOS_PRIORITY = void 0;
var client_1$39 = require$$0$1;
var fragments_1$N = fragments$1;
GetPicOSPriority.GET_PICOS_PRIORITY = (0, client_1$39.gql)(templateObject_1$2F || (templateObject_1$2F = __makeTemplateObject$2F(["\n  query PicOSPriorities($input: PicOSPriorityInput!) {\n    picosPriorities(input: $input) {\n      count\n      hasMore\n      results {\n        name\n        id\n        priority\n        storeGroup {\n          id\n          name\n        }\n        dateCreated\n        startDate\n        endDate\n        description\n        mandateType\n        displayElements\n        displayTypes {\n          id\n          name\n        }\n        displayLocation {\n          id\n          name\n        }\n        swirePosElementRequired\n        otherCategoriesAllowed\n        otherBrandsAllowed\n        otherPackagingAllowed\n        otherProductsAllowed\n        otherDisplayTypesAllowed\n        otherDisplayLocationsAllowed\n        categories {\n          id\n          category\n        }\n        brands {\n          id\n          name\n        }\n        packaging {\n          id\n          size\n          unit\n          quantity\n          container\n          packagingString\n        }\n        products {\n          id\n          name\n        }\n        storeChain {\n          id\n          name\n        }\n        creator {\n          ...User\n        }\n        image {\n          url\n          id\n          bucketFileName\n        }\n        pricingInfo\n        cost\n      }\n    }\n  }\n  ", "\n"], ["\n  query PicOSPriorities($input: PicOSPriorityInput!) {\n    picosPriorities(input: $input) {\n      count\n      hasMore\n      results {\n        name\n        id\n        priority\n        storeGroup {\n          id\n          name\n        }\n        dateCreated\n        startDate\n        endDate\n        description\n        mandateType\n        displayElements\n        displayTypes {\n          id\n          name\n        }\n        displayLocation {\n          id\n          name\n        }\n        swirePosElementRequired\n        otherCategoriesAllowed\n        otherBrandsAllowed\n        otherPackagingAllowed\n        otherProductsAllowed\n        otherDisplayTypesAllowed\n        otherDisplayLocationsAllowed\n        categories {\n          id\n          category\n        }\n        brands {\n          id\n          name\n        }\n        packaging {\n          id\n          size\n          unit\n          quantity\n          container\n          packagingString\n        }\n        products {\n          id\n          name\n        }\n        storeChain {\n          id\n          name\n        }\n        creator {\n          ...User\n        }\n        image {\n          url\n          id\n          bucketFileName\n        }\n        pricingInfo\n        cost\n      }\n    }\n  }\n  ", "\n"])), fragments_1$N.USER_FRAGMENT);
var templateObject_1$2F;

var GetPicOSSalesCenterCompliance = {};

var __makeTemplateObject$2E = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSSalesCenterCompliance, "__esModule", { value: true });
GetPicOSSalesCenterCompliance.GET_PICOS_SALES_CENTER_COMPLIANCE = void 0;
var client_1$38 = require$$0$1;
var PicOSStoreComplianceFragment_1 = PicOSStoreComplianceFragment;
GetPicOSSalesCenterCompliance.GET_PICOS_SALES_CENTER_COMPLIANCE = (0, client_1$38.gql)(templateObject_1$2E || (templateObject_1$2E = __makeTemplateObject$2E(["\n  query GetPicOSSalesCenterCompliance(\n    $input: PicOSSalesCenterComplianceInput!\n  ) {\n    picosSalesCenterCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        ...PicOSStoreCompliance\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSSalesCenterCompliance(\n    $input: PicOSSalesCenterComplianceInput!\n  ) {\n    picosSalesCenterCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        ...PicOSStoreCompliance\n      }\n    }\n  }\n  ", "\n"])), PicOSStoreComplianceFragment_1.PICOS_STORE_COMPLIANCE_FRAGMENT);
var templateObject_1$2E;

var GetPicOSSalesCenterComplianceStats = {};

var __makeTemplateObject$2D = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSSalesCenterComplianceStats, "__esModule", { value: true });
GetPicOSSalesCenterComplianceStats.GET_PICOS_SALES_CENTER_COMPLIANCE_STATS = void 0;
var client_1$37 = require$$0$1;
var PicOSGroupComplianceStats_1$1 = PicOSGroupComplianceStats;
GetPicOSSalesCenterComplianceStats.GET_PICOS_SALES_CENTER_COMPLIANCE_STATS = (0, client_1$37.gql)(templateObject_1$2D || (templateObject_1$2D = __makeTemplateObject$2D(["\n  query GetPicOSSalesCenterComplianceStats(\n    $input: PicOSSalesCenterComplianceInput!\n  ) {\n    picosSalesCenterStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSSalesCenterComplianceStats(\n    $input: PicOSSalesCenterComplianceInput!\n  ) {\n    picosSalesCenterStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"])), PicOSGroupComplianceStats_1$1.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT);
var templateObject_1$2D;

var GetPicOSStoreCompliance = {};

var __makeTemplateObject$2C = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSStoreCompliance, "__esModule", { value: true });
GetPicOSStoreCompliance.GET_PICOS_STORE_COMPLIANCE = void 0;
var client_1$36 = require$$0$1;
GetPicOSStoreCompliance.GET_PICOS_STORE_COMPLIANCE = (0, client_1$36.gql)(templateObject_1$2C || (templateObject_1$2C = __makeTemplateObject$2C(["\n  query GetPicOSStoreCompliance($input: PicOSStoreComplianceInput!) {\n    picosStoreCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        priority\n        name\n        description\n        mandateType\n        displayElements\n        imageUrl\n        cost\n        isCompliant\n      }\n    }\n  }\n"], ["\n  query GetPicOSStoreCompliance($input: PicOSStoreComplianceInput!) {\n    picosStoreCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        priority\n        name\n        description\n        mandateType\n        displayElements\n        imageUrl\n        cost\n        isCompliant\n      }\n    }\n  }\n"])));
var templateObject_1$2C;

var GetPicOSStoreComplianceStats = {};

var __makeTemplateObject$2B = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicOSStoreComplianceStats, "__esModule", { value: true });
GetPicOSStoreComplianceStats.GET_PICOS_STORE_COMPLIANCE_STATS = void 0;
var client_1$35 = require$$0$1;
var PicOSGroupComplianceStats_1 = PicOSGroupComplianceStats;
GetPicOSStoreComplianceStats.GET_PICOS_STORE_COMPLIANCE_STATS = (0, client_1$35.gql)(templateObject_1$2B || (templateObject_1$2B = __makeTemplateObject$2B(["\n  query GetPicOSStoreComplianceStats($input: PicOSStoreComplianceInput!) {\n    picosStoreStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPicOSStoreComplianceStats($input: PicOSStoreComplianceInput!) {\n    picosStoreStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"])), PicOSGroupComplianceStats_1.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT);
var templateObject_1$2B;

var GetPicosBrands = {};

var __makeTemplateObject$2A = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicosBrands, "__esModule", { value: true });
GetPicosBrands.GET_PICOS_BRANDS = void 0;
var client_1$34 = require$$0$1;
GetPicosBrands.GET_PICOS_BRANDS = (0, client_1$34.gql)(templateObject_1$2A || (templateObject_1$2A = __makeTemplateObject$2A(["\nquery GetPicosBrands ($input: PicosBrandInput!){\n  picosBrands(input: $input){\n    hasMore\n    count\n    results{\n      name\n      id\n    }\n  }\n}\n"], ["\nquery GetPicosBrands ($input: PicosBrandInput!){\n  picosBrands(input: $input){\n    hasMore\n    count\n    results{\n      name\n      id\n    }\n  }\n}\n"])));
var templateObject_1$2A;

var GetPicosPackaging = {};

var __makeTemplateObject$2z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicosPackaging, "__esModule", { value: true });
GetPicosPackaging.GET_PICOS_PACKAGING = void 0;
var client_1$33 = require$$0$1;
GetPicosPackaging.GET_PICOS_PACKAGING = (0, client_1$33.gql)(templateObject_1$2z || (templateObject_1$2z = __makeTemplateObject$2z(["\nquery GetPicosPackaging ($input: PicosPackagingInput!){\n  picosPackaging(input: $input){\n\t\thasMore\n\t\tcount\n\t\tresults{\n\t\t\tid\n\t\t\tunit\n\t\t\tquantity\n\t\t\tcontainer\n\t\t\tpackagingString\n\t\t}\n  }\n}\n"], ["\nquery GetPicosPackaging ($input: PicosPackagingInput!){\n  picosPackaging(input: $input){\n\t\thasMore\n\t\tcount\n\t\tresults{\n\t\t\tid\n\t\t\tunit\n\t\t\tquantity\n\t\t\tcontainer\n\t\t\tpackagingString\n\t\t}\n  }\n}\n"])));
var templateObject_1$2z;

var GetPicosProducts = {};

var __makeTemplateObject$2y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPicosProducts, "__esModule", { value: true });
GetPicosProducts.GET_PICOS_PRODUCTS = void 0;
var client_1$32 = require$$0$1;
GetPicosProducts.GET_PICOS_PRODUCTS = (0, client_1$32.gql)(templateObject_1$2y || (templateObject_1$2y = __makeTemplateObject$2y(["\nquery GetPicosProducts ($input: PicosProductInput!){\n  picosProducts(input: $input){\n    hasMore\n    count\n    results{\n      name\n      id\n    }\n  }\n}\n"], ["\nquery GetPicosProducts ($input: PicosProductInput!){\n  picosProducts(input: $input){\n    hasMore\n    count\n    results{\n      name\n      id\n    }\n  }\n}\n"])));
var templateObject_1$2y;

var GetPlanogramFeedbackImageById = {};

var __makeTemplateObject$2x = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPlanogramFeedbackImageById, "__esModule", { value: true });
GetPlanogramFeedbackImageById.GET_PLANOGRAM_FEEDBACK_IMAGE_BY_ID = void 0;
var client_1$31 = require$$0$1;
var PlanogramFeedbackImagesIssuesFragment_1$1 = PlanogramFeedbackImagesIssuesFragment;
GetPlanogramFeedbackImageById.GET_PLANOGRAM_FEEDBACK_IMAGE_BY_ID = (0, client_1$31.gql)(templateObject_1$2x || (templateObject_1$2x = __makeTemplateObject$2x(["\n  query GetPlanogramFeedbackImageById($input: ID!) {\n    planogramFeedbackImageById(input: $input) {\n      ...PlanogramFeedbackImagesIssues\n    }\n  }\n  ", "\n"], ["\n  query GetPlanogramFeedbackImageById($input: ID!) {\n    planogramFeedbackImageById(input: $input) {\n      ...PlanogramFeedbackImagesIssues\n    }\n  }\n  ", "\n"])), PlanogramFeedbackImagesIssuesFragment_1$1.PLANOGRAM_FEEDBACK_IMAGES_ISSUES_FRAGMENT);
var templateObject_1$2x;

var GetPlanogramFeedbackImagesIssues = {};

var __makeTemplateObject$2w = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPlanogramFeedbackImagesIssues, "__esModule", { value: true });
GetPlanogramFeedbackImagesIssues.GET_PLANOGRAM_FEEDBACK_IMAGES_ISSUES = void 0;
var client_1$30 = require$$0$1;
var PlanogramFeedbackImagesIssuesFragment_1 = PlanogramFeedbackImagesIssuesFragment;
GetPlanogramFeedbackImagesIssues.GET_PLANOGRAM_FEEDBACK_IMAGES_ISSUES = (0, client_1$30.gql)(templateObject_1$2w || (templateObject_1$2w = __makeTemplateObject$2w(["\n  query GetPlanogramFeedbackImagesIssues($input: PlanogramFeedbackInput!) {\n    planogramFeedbackImagesIssues(input: $input) {\n      hasMore\n      count\n      results {\n        ...PlanogramFeedbackImagesIssues\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPlanogramFeedbackImagesIssues($input: PlanogramFeedbackInput!) {\n    planogramFeedbackImagesIssues(input: $input) {\n      hasMore\n      count\n      results {\n        ...PlanogramFeedbackImagesIssues\n      }\n    }\n  }\n  ", "\n"])), PlanogramFeedbackImagesIssuesFragment_1.PLANOGRAM_FEEDBACK_IMAGES_ISSUES_FRAGMENT);
var templateObject_1$2w;

var GetPlanogramImagesForProduct = {};

var __makeTemplateObject$2v = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPlanogramImagesForProduct, "__esModule", { value: true });
GetPlanogramImagesForProduct.GET_PLANOGRAM_IMAGES_FOR_PRODUCT = void 0;
var client_1$2$ = require$$0$1;
GetPlanogramImagesForProduct.GET_PLANOGRAM_IMAGES_FOR_PRODUCT = (0, client_1$2$.gql)(templateObject_1$2v || (templateObject_1$2v = __makeTemplateObject$2v(["\n  query PlanogramImagesForProduct($productId: String!) {\n    planogramImagesForProduct(productId: $productId) {\n      id\n      url\n      bucketFileName\n    }\n  }\n"], ["\n  query PlanogramImagesForProduct($productId: String!) {\n    planogramImagesForProduct(productId: $productId) {\n      id\n      url\n      bucketFileName\n    }\n  }\n"])));
var templateObject_1$2v;

var GetPointCloud = {};

var __makeTemplateObject$2u = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPointCloud, "__esModule", { value: true });
GetPointCloud.GET_POINT_CLOUD = void 0;
var client_1$2_ = require$$0$1;
GetPointCloud.GET_POINT_CLOUD = (0, client_1$2_.gql)(templateObject_1$2u || (templateObject_1$2u = __makeTemplateObject$2u(["\n  query GetPointCloud($pointCloudId: ID!) {\n    pointCloud(pointCloudId: $pointCloudId) {\n      id\n      verified\n      verifiedLocation\n      bucketFileName\n      labels\n      predicted\n      centroids\n      boundingCube {\n        x1 {\n          x\n          y\n          z\n        }\n        x2 {\n          x\n          y\n          z\n        }\n        y1 {\n          x\n          y\n          z\n        }\n        z1 {\n          x\n          y\n          z\n        }\n        width\n        height\n        depth\n      }\n      ... on DisplayAuditPointCloud {\n        keyframes {\n          id\n          bucketFileName\n          url\n          created\n        }\n      }\n      ... on MerchandiserPointCloud {\n        keyframes {\n          id\n          bucketFileName\n          url\n          created\n        }\n      }\n    }\n  }\n"], ["\n  query GetPointCloud($pointCloudId: ID!) {\n    pointCloud(pointCloudId: $pointCloudId) {\n      id\n      verified\n      verifiedLocation\n      bucketFileName\n      labels\n      predicted\n      centroids\n      boundingCube {\n        x1 {\n          x\n          y\n          z\n        }\n        x2 {\n          x\n          y\n          z\n        }\n        y1 {\n          x\n          y\n          z\n        }\n        z1 {\n          x\n          y\n          z\n        }\n        width\n        height\n        depth\n      }\n      ... on DisplayAuditPointCloud {\n        keyframes {\n          id\n          bucketFileName\n          url\n          created\n        }\n      }\n      ... on MerchandiserPointCloud {\n        keyframes {\n          id\n          bucketFileName\n          url\n          created\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$2u;

var GetPointCloudScanScores = {};

var __makeTemplateObject$2t = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPointCloudScanScores, "__esModule", { value: true });
GetPointCloudScanScores.GET_POINT_CLOUD_SCAN_SCORES = void 0;
var client_1$2Z = require$$0$1;
GetPointCloudScanScores.GET_POINT_CLOUD_SCAN_SCORES = (0, client_1$2Z.gql)(templateObject_1$2t || (templateObject_1$2t = __makeTemplateObject$2t(["\n  query GetPointCloudScores($input: UserProductivityInput!) {\n    pointCloudScanScores(input: $input) {\n      results {\n        refId\n        compositeId\n        compositeName\n        date\n        pointCloudScore\n        facingScore\n        identificationAccuracy\n      }\n      hasMore\n      count\n    }\n  }\n"], ["\n  query GetPointCloudScores($input: UserProductivityInput!) {\n    pointCloudScanScores(input: $input) {\n      results {\n        refId\n        compositeId\n        compositeName\n        date\n        pointCloudScore\n        facingScore\n        identificationAccuracy\n      }\n      hasMore\n      count\n    }\n  }\n"])));
var templateObject_1$2t;

var GetProductByUpc = {};

var __makeTemplateObject$2s = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProductByUpc, "__esModule", { value: true });
GetProductByUpc.GET_PRODUCT_BY_UPC = void 0;
var client_1$2Y = require$$0$1;
var SimpleProductFragment_1$2 = SimpleProductFragment;
GetProductByUpc.GET_PRODUCT_BY_UPC = (0, client_1$2Y.gql)(templateObject_1$2s || (templateObject_1$2s = __makeTemplateObject$2s(["\n  query GetProductByUpc($upc: ID!) {\n    productByUpc(upc: $upc) {\n      ...SimpleProduct\n    }\n  }\n  ", "\n"], ["\n  query GetProductByUpc($upc: ID!) {\n    productByUpc(upc: $upc) {\n      ...SimpleProduct\n    }\n  }\n  ", "\n"])), SimpleProductFragment_1$2.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$2s;

var GetProductCounted = {};

var __makeTemplateObject$2r = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProductCounted, "__esModule", { value: true });
GetProductCounted.GET_PRODUCT_COUNTED = void 0;
var client_1$2X = require$$0$1;
GetProductCounted.GET_PRODUCT_COUNTED = (0, client_1$2X.gql)(templateObject_1$2r || (templateObject_1$2r = __makeTemplateObject$2r(["\n  query GetProductCounted($input: ProductProductivityInput!) {\n    productCounted(input: $input) {\n      results {\n        refId\n        compositeId\n        compositeName\n        date\n        count\n        allRank\n        groupRank\n        allRankChange\n        groupRankChange\n      }\n      hasMore\n      count\n    }\n  }\n"], ["\n  query GetProductCounted($input: ProductProductivityInput!) {\n    productCounted(input: $input) {\n      results {\n        refId\n        compositeId\n        compositeName\n        date\n        count\n        allRank\n        groupRank\n        allRankChange\n        groupRankChange\n      }\n      hasMore\n      count\n    }\n  }\n"])));
var templateObject_1$2r;

var GetProductFlavors = {};

var __makeTemplateObject$2q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProductFlavors, "__esModule", { value: true });
GetProductFlavors.GET_PRODUCT_FLAVORS = void 0;
var client_1$2W = require$$0$1;
GetProductFlavors.GET_PRODUCT_FLAVORS = (0, client_1$2W.gql)(templateObject_1$2q || (templateObject_1$2q = __makeTemplateObject$2q(["\n  query GetProductFlavors($searchTerm: String) {\n    productFlavors(searchTerm: $searchTerm) {\n      id\n      flavor\n      displayFlavor\n    }\n  }\n"], ["\n  query GetProductFlavors($searchTerm: String) {\n    productFlavors(searchTerm: $searchTerm) {\n      id\n      flavor\n      displayFlavor\n    }\n  }\n"])));
var templateObject_1$2q;

var GetProductLabeledImageCounts = {};

var __makeTemplateObject$2p = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProductLabeledImageCounts, "__esModule", { value: true });
GetProductLabeledImageCounts.GET_PRODUCT_LABELED_IMAGE_COUNTS = void 0;
var client_1$2V = require$$0$1;
GetProductLabeledImageCounts.GET_PRODUCT_LABELED_IMAGE_COUNTS = (0, client_1$2V.gql)(templateObject_1$2p || (templateObject_1$2p = __makeTemplateObject$2p(["\n  query GetProductLabeledImageCounts($productInput: ProductsInput!) {\n    products(input: $productInput) {\n      count\n      results {\n        upcA\n        marketingImageUrl\n        labeledImageCounts {\n          singleVerified\n          singleUnverified\n          multiVerified\n          multiUnverified\n          multiTraining\n          multiValidation\n        }\n      }\n    }\n  }\n"], ["\n  query GetProductLabeledImageCounts($productInput: ProductsInput!) {\n    products(input: $productInput) {\n      count\n      results {\n        upcA\n        marketingImageUrl\n        labeledImageCounts {\n          singleVerified\n          singleUnverified\n          multiVerified\n          multiUnverified\n          multiTraining\n          multiValidation\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$2p;

var GetProductPriceObjects = {};

var __makeTemplateObject$2o = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProductPriceObjects, "__esModule", { value: true });
GetProductPriceObjects.GET_PRODUCT_PRICE_OBJECTS = void 0;
var client_1$2U = require$$0$1;
var ProductPriceObjectFragment_1 = ProductPriceObjectFragment;
GetProductPriceObjects.GET_PRODUCT_PRICE_OBJECTS = (0, client_1$2U.gql)(templateObject_1$2o || (templateObject_1$2o = __makeTemplateObject$2o(["\n  query GetProductPriceObjects($storeId: ID, $storeSize: ForStoreSize) {\n    productPriceObjects(storeId: $storeId, storeSize: $storeSize) {\n      ...ProductPriceObject\n    }\n  }\n  ", "\n"], ["\n  query GetProductPriceObjects($storeId: ID, $storeSize: ForStoreSize) {\n    productPriceObjects(storeId: $storeId, storeSize: $storeSize) {\n      ...ProductPriceObject\n    }\n  }\n  ", "\n"])), ProductPriceObjectFragment_1.PRODUCT_PRICE_OBJECT_FRAGMENT);
var templateObject_1$2o;

var GetProducts$1 = {};

var __makeTemplateObject$2n = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProducts$1, "__esModule", { value: true });
GetProducts$1.GET_PRODUCTS = void 0;
var client_1$2T = require$$0$1;
var SimpleProductFragment_1$1 = SimpleProductFragment;
GetProducts$1.GET_PRODUCTS = (0, client_1$2T.gql)(templateObject_1$2n || (templateObject_1$2n = __makeTemplateObject$2n(["\n  query GetProducts($input: ProductsInput) {\n    products(input: $input) {\n      results {\n        ...SimpleProduct\n      }\n      count\n      hasMore\n    }\n  }\n  ", "\n"], ["\n  query GetProducts($input: ProductsInput) {\n    products(input: $input) {\n      results {\n        ...SimpleProduct\n      }\n      count\n      hasMore\n    }\n  }\n  ", "\n"])), SimpleProductFragment_1$1.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$2n;

var GetProductsMoreInfo = {};

var __makeTemplateObject$2m = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProductsMoreInfo, "__esModule", { value: true });
GetProductsMoreInfo.GET_PRODUCTS_MORE_INFO = void 0;
var client_1$2S = require$$0$1;
var fragments_1$M = fragments$1;
GetProductsMoreInfo.GET_PRODUCTS_MORE_INFO = (0, client_1$2S.gql)(templateObject_1$2m || (templateObject_1$2m = __makeTemplateObject$2m(["\n  query GetProductsMoreInfo($input: ProductsInput) {\n    products(input: $input) {\n      results {\n        created\n        modified\n        brand {\n          id\n          name\n        }\n        packaging {\n          ...Packaging\n        }\n        shipping {\n          ...Shipping\n        }\n        name\n        upcA\n        upcE\n        id\n        description\n        photosTaken\n        lastUpdated\n        marketingImageUrl\n      }\n      hasMore\n    }\n  }\n  ", "\n  ", "\n"], ["\n  query GetProductsMoreInfo($input: ProductsInput) {\n    products(input: $input) {\n      results {\n        created\n        modified\n        brand {\n          id\n          name\n        }\n        packaging {\n          ...Packaging\n        }\n        shipping {\n          ...Shipping\n        }\n        name\n        upcA\n        upcE\n        id\n        description\n        photosTaken\n        lastUpdated\n        marketingImageUrl\n      }\n      hasMore\n    }\n  }\n  ", "\n  ", "\n"])), fragments_1$M.PACKAGING_FRAGMENT, fragments_1$M.SHIPPING_FRAGMENT);
var templateObject_1$2m;

var GetRandomObservedDisplay = {};

var __makeTemplateObject$2l = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetRandomObservedDisplay, "__esModule", { value: true });
GetRandomObservedDisplay.GET_RANDOM_OBSERVED_DISPLAY = void 0;
var client_1$2R = require$$0$1;
var DisplayFragment_1$2 = DisplayFragment;
GetRandomObservedDisplay.GET_RANDOM_OBSERVED_DISPLAY = (0, client_1$2R.gql)(templateObject_1$2l || (templateObject_1$2l = __makeTemplateObject$2l(["\n  query GetRandomObservedDisplay {\n    randomObservedDisplay {\n      ...Display\n    }\n  }\n  ", "\n"], ["\n  query GetRandomObservedDisplay {\n    randomObservedDisplay {\n      ...Display\n    }\n  }\n  ", "\n"])), DisplayFragment_1$2.DISPLAY_FRAGMENT);
var templateObject_1$2l;

var GetRecommendationComplianceScores = {};

var __makeTemplateObject$2k = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetRecommendationComplianceScores, "__esModule", { value: true });
GetRecommendationComplianceScores.GET_RECOMMENDATION_COMPLIANCE_SCORES = void 0;
var client_1$2Q = require$$0$1;
GetRecommendationComplianceScores.GET_RECOMMENDATION_COMPLIANCE_SCORES = (0, client_1$2Q.gql)(templateObject_1$2k || (templateObject_1$2k = __makeTemplateObject$2k(["\n  query GetRecommendationComplianceScores($input: UserProductivityInput!) {\n    recommendationScores(input: $input) {\n      results {\n        refId\n        compositeId\n        compositeName\n        date\n        score\n        facingsPercent\n        allRank\n        groupRank\n        allRankChange\n        groupRankChange\n      }\n      hasMore\n      count\n    }\n  }\n"], ["\n  query GetRecommendationComplianceScores($input: UserProductivityInput!) {\n    recommendationScores(input: $input) {\n      results {\n        refId\n        compositeId\n        compositeName\n        date\n        score\n        facingsPercent\n        allRank\n        groupRank\n        allRankChange\n        groupRankChange\n      }\n      hasMore\n      count\n    }\n  }\n"])));
var templateObject_1$2k;

var GetReportedIssues = {};

var __makeTemplateObject$2j = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetReportedIssues, "__esModule", { value: true });
GetReportedIssues.GET_REPORTED_ISSUES = void 0;
var client_1$2P = require$$0$1;
var fragments_1$L = fragments$1;
GetReportedIssues.GET_REPORTED_ISSUES = (0, client_1$2P.gql)(templateObject_1$2j || (templateObject_1$2j = __makeTemplateObject$2j(["\n  query GetReportedIssues($input: PaginationInput) {\n    reportedIssues(input: $input) {\n      results {\n        ...ReportedIssue\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetReportedIssues($input: PaginationInput) {\n    reportedIssues(input: $input) {\n      results {\n        ...ReportedIssue\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), fragments_1$L.REPORTED_ISSUE_FRAGMENT);
var templateObject_1$2j;

var GetScanQualityScore = {};

var __makeTemplateObject$2i = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetScanQualityScore, "__esModule", { value: true });
GetScanQualityScore.GET_SCAN_QUALITY_SCORE = void 0;
var client_1$2O = require$$0$1;
GetScanQualityScore.GET_SCAN_QUALITY_SCORE = (0, client_1$2O.gql)(templateObject_1$2i || (templateObject_1$2i = __makeTemplateObject$2i(["\n   query GetScanQualityScores($input: UserProductivityInput!) {\n      scanQualityScores(input: $input) {\n        results {\n          scanSuccessRate\n          refId\n          compositeId\n          allRank\n          groupRank\n          allRankChange\n          groupRankChange\n          compositeId\n          compositeName\n          date\n        }\n        hasMore\n        count\n      }\n   }\n"], ["\n   query GetScanQualityScores($input: UserProductivityInput!) {\n      scanQualityScores(input: $input) {\n        results {\n          scanSuccessRate\n          refId\n          compositeId\n          allRank\n          groupRank\n          allRankChange\n          groupRankChange\n          compositeId\n          compositeName\n          date\n        }\n        hasMore\n        count\n      }\n   }\n"])));
var templateObject_1$2i;

var GetScanScoringParameters = {};

var __makeTemplateObject$2h = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetScanScoringParameters, "__esModule", { value: true });
GetScanScoringParameters.GET_SCAN_SCORING_PARAMETERS = void 0;
var client_1$2N = require$$0$1;
GetScanScoringParameters.GET_SCAN_SCORING_PARAMETERS = (0, client_1$2N.gql)(templateObject_1$2h || (templateObject_1$2h = __makeTemplateObject$2h(["\n  query GetScanScoringParameters {\n    scanScoringWeights {\n      scanSuccessThreshold\n      scanSuccessFacingScoreWeight\n      scanSuccessPointCloudScoreWeight\n    }\n  }\n"], ["\n  query GetScanScoringParameters {\n    scanScoringWeights {\n      scanSuccessThreshold\n      scanSuccessFacingScoreWeight\n      scanSuccessPointCloudScoreWeight\n    }\n  }\n"])));
var templateObject_1$2h;

var GetScannerMetadata = {};

var __makeTemplateObject$2g = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetScannerMetadata, "__esModule", { value: true });
GetScannerMetadata.GET_SCANNER_METADATA = void 0;
var client_1$2M = require$$0$1;
var fragments_1$K = fragments$1;
GetScannerMetadata.GET_SCANNER_METADATA = (0, client_1$2M.gql)(templateObject_1$2g || (templateObject_1$2g = __makeTemplateObject$2g(["\n  query GetScannerMetadata($input: ScannerMetadataInput!) {\n    scannerMetadata(input: $input) {\n      count\n      hasMore\n      results {\n        user {\n          ...User\n        }\n        scans {\n          created\n          metadata\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetScannerMetadata($input: ScannerMetadataInput!) {\n    scannerMetadata(input: $input) {\n      count\n      hasMore\n      results {\n        user {\n          ...User\n        }\n        scans {\n          created\n          metadata\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$K.USER_FRAGMENT);
var templateObject_1$2g;

var GetSimpleStoreAudits = {};

var __makeTemplateObject$2f = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetSimpleStoreAudits, "__esModule", { value: true });
GetSimpleStoreAudits.GET_SIMPLE_STORE_AUDITS = void 0;
var client_1$2L = require$$0$1;
var SimpleStoreAuditFragment_1 = SimpleStoreAuditFragment;
GetSimpleStoreAudits.GET_SIMPLE_STORE_AUDITS = (0, client_1$2L.gql)(templateObject_1$2f || (templateObject_1$2f = __makeTemplateObject$2f(["\n  query GetSimpleStoreAudits($input: AuditsInput!) {\n    audits(input: $input) {\n      hasMore\n      count\n      results {\n        ...SimpleAudit\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetSimpleStoreAudits($input: AuditsInput!) {\n    audits(input: $input) {\n      hasMore\n      count\n      results {\n        ...SimpleAudit\n      }\n    }\n  }\n  ", "\n"])), SimpleStoreAuditFragment_1.SIMPLE_AUDIT_FRAGMENT);
var templateObject_1$2f;

var GetSingleProductPointClouds = {};

var __makeTemplateObject$2e = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetSingleProductPointClouds, "__esModule", { value: true });
GetSingleProductPointClouds.GET_SINGLE_PRODUCT_POINT_CLOUDS = void 0;
var client_1$2K = require$$0$1;
var SingleProductPointCloud_1 = SingleProductPointCloud;
GetSingleProductPointClouds.GET_SINGLE_PRODUCT_POINT_CLOUDS = (0, client_1$2K.gql)(templateObject_1$2e || (templateObject_1$2e = __makeTemplateObject$2e(["\n  query GetSingleProductPointClouds($input: SingleProductPointCloudsInput!) {\n    singleProductPointClouds(input: $input) {\n      count\n      hasMore\n      results {\n        ...SingleProductPointCloud\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetSingleProductPointClouds($input: SingleProductPointCloudsInput!) {\n    singleProductPointClouds(input: $input) {\n      count\n      hasMore\n      results {\n        ...SingleProductPointCloud\n      }\n    }\n  }\n  ", "\n"])), SingleProductPointCloud_1.SINGLE_PRODUCT_POINT_CLOUD_FRAGMENT);
var templateObject_1$2e;

var GetStatus = {};

var __makeTemplateObject$2d = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStatus, "__esModule", { value: true });
GetStatus.GET_STATUS = void 0;
var client_1$2J = require$$0$1;
GetStatus.GET_STATUS = (0, client_1$2J.gql)(templateObject_1$2d || (templateObject_1$2d = __makeTemplateObject$2d(["\n  query GetStatus($id: ID!) {\n    status(statusId: $id) {\n      id\n      statusType\n      status\n    }\n  }\n"], ["\n  query GetStatus($id: ID!) {\n    status(statusId: $id) {\n      id\n      statusType\n      status\n    }\n  }\n"])));
var templateObject_1$2d;

var GetSlotCountFrequency = {};

var __makeTemplateObject$2c = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetSlotCountFrequency, "__esModule", { value: true });
GetSlotCountFrequency.GET_SLOT_COUNT_FREQUENCY = void 0;
var client_1$2I = require$$0$1;
GetSlotCountFrequency.GET_SLOT_COUNT_FREQUENCY = (0, client_1$2I.gql)(templateObject_1$2c || (templateObject_1$2c = __makeTemplateObject$2c(["\n  query GetSlotCountFrequency {\n    slotCountFrequency\n  }\n"], ["\n  query GetSlotCountFrequency {\n    slotCountFrequency\n  }\n"])));
var templateObject_1$2c;

var GetStore = {};

var __makeTemplateObject$2b = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStore, "__esModule", { value: true });
GetStore.GET_STORE = void 0;
var client_1$2H = require$$0$1;
var fragments_1$J = fragments$1;
GetStore.GET_STORE = (0, client_1$2H.gql)(templateObject_1$2b || (templateObject_1$2b = __makeTemplateObject$2b(["\n  query GetStore($storeId: ID!) {\n    store(storeId: $storeId) {\n      ...Store\n    }\n  }\n  ", "\n"], ["\n  query GetStore($storeId: ID!) {\n    store(storeId: $storeId) {\n      ...Store\n    }\n  }\n  ", "\n"])), fragments_1$J.STORE_FRAGMENT);
var templateObject_1$2b;

var GetStoreAreas = {};

var __makeTemplateObject$2a = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreAreas, "__esModule", { value: true });
GetStoreAreas.GET_STORE_AREAS = void 0;
var client_1$2G = require$$0$1;
GetStoreAreas.GET_STORE_AREAS = (0, client_1$2G.gql)(templateObject_1$2a || (templateObject_1$2a = __makeTemplateObject$2a(["\n  query GetStoreAreas {\n    storeAreas {\n      id\n      name\n      defaultForStoreSize\n    }\n  }\n"], ["\n  query GetStoreAreas {\n    storeAreas {\n      id\n      name\n      defaultForStoreSize\n    }\n  }\n"])));
var templateObject_1$2a;

var GetStoreAudit = {};

var __makeTemplateObject$29 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreAudit, "__esModule", { value: true });
GetStoreAudit.GET_STORE_AUDIT = void 0;
var client_1$2F = require$$0$1;
var fragments_1$I = fragments$1;
GetStoreAudit.GET_STORE_AUDIT = (0, client_1$2F.gql)(templateObject_1$29 || (templateObject_1$29 = __makeTemplateObject$29(["\n  query GetStoreAudit($auditId: ID!) {\n    audit(auditId: $auditId) {\n      ...WholeAudit\n    }\n  }\n  ", "\n"], ["\n  query GetStoreAudit($auditId: ID!) {\n    audit(auditId: $auditId) {\n      ...WholeAudit\n    }\n  }\n  ", "\n"])), fragments_1$I.WHOLE_AUDIT_FRAGMENT);
var templateObject_1$29;

var GetStoreAudits = {};

var __makeTemplateObject$28 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreAudits, "__esModule", { value: true });
GetStoreAudits.GET_AUDITS = void 0;
var client_1$2E = require$$0$1;
var fragments_1$H = fragments$1;
GetStoreAudits.GET_AUDITS = (0, client_1$2E.gql)(templateObject_1$28 || (templateObject_1$28 = __makeTemplateObject$28(["\n  query GetAudits($input: AuditsInput!) {\n    audits(input: $input) {\n      hasMore\n      count\n      results {\n        ...WholeAudit\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetAudits($input: AuditsInput!) {\n    audits(input: $input) {\n      hasMore\n      count\n      results {\n        ...WholeAudit\n      }\n    }\n  }\n  ", "\n"])), fragments_1$H.WHOLE_AUDIT_FRAGMENT);
var templateObject_1$28;

var GetStoreChains = {};

var __makeTemplateObject$27 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreChains, "__esModule", { value: true });
GetStoreChains.GET_STORE_CHAINS = void 0;
var client_1$2D = require$$0$1;
GetStoreChains.GET_STORE_CHAINS = (0, client_1$2D.gql)(templateObject_1$27 || (templateObject_1$27 = __makeTemplateObject$27(["\nquery GetStoreChains($input: StoreChainInput!) {\n  storeChains(input: $input) {\n    count\n    hasMore\n    results {\n      id\n      name\n    }\n  }\n}\n"], ["\nquery GetStoreChains($input: StoreChainInput!) {\n  storeChains(input: $input) {\n    count\n    hasMore\n    results {\n      id\n      name\n    }\n  }\n}\n"])));
var templateObject_1$27;

var GetStoreDisplayTransactions = {};

var __makeTemplateObject$26 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreDisplayTransactions, "__esModule", { value: true });
GetStoreDisplayTransactions.GET_STORE_DISPLAY_TRANSACTIONS = void 0;
var client_1$2C = require$$0$1;
var fragments_1$G = fragments$1;
GetStoreDisplayTransactions.GET_STORE_DISPLAY_TRANSACTIONS = (0, client_1$2C.gql)(templateObject_1$26 || (templateObject_1$26 = __makeTemplateObject$26(["\n  query GetStoreDisplayTransactions($input: StoreDisplayTransactionsInput!) {\n    storeDisplayTransactions(input: $input) {\n      storeId\n      displayTransactions {\n        ...DisplayTransaction\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetStoreDisplayTransactions($input: StoreDisplayTransactionsInput!) {\n    storeDisplayTransactions(input: $input) {\n      storeId\n      displayTransactions {\n        ...DisplayTransaction\n      }\n    }\n  }\n  ", "\n"])), fragments_1$G.DISPLAY_TRANSACTION_FRAGMENT);
var templateObject_1$26;

var GetStoreDisplayWithStoreData = {};

var __makeTemplateObject$25 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreDisplayWithStoreData, "__esModule", { value: true });
GetStoreDisplayWithStoreData.GET_STORE_DISPLAY_WITH_STORE_DATA = void 0;
var client_1$2B = require$$0$1;
var DisplayWithStoreDataFragment_1 = DisplayWithStoreDataFragment;
GetStoreDisplayWithStoreData.GET_STORE_DISPLAY_WITH_STORE_DATA = (0, client_1$2B.gql)(templateObject_1$25 || (templateObject_1$25 = __makeTemplateObject$25(["\n  query GetDisplayWithStoreData($displayId: ID!) {\n    display(displayId: $displayId) {\n      ...DisplayWithStoreData\n    }\n  }\n  ", "\n"], ["\n  query GetDisplayWithStoreData($displayId: ID!) {\n    display(displayId: $displayId) {\n      ...DisplayWithStoreData\n    }\n  }\n  ", "\n"])), DisplayWithStoreDataFragment_1.DISPLAY_WITH_STORE_DATA_FRAGMENT);
var templateObject_1$25;

var GetStoreDisplays = {};

var __makeTemplateObject$24 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreDisplays, "__esModule", { value: true });
GetStoreDisplays.GET_STORE_DISPLAYS = void 0;
var client_1$2A = require$$0$1;
var DisplayFragment_1$1 = DisplayFragment;
GetStoreDisplays.GET_STORE_DISPLAYS = (0, client_1$2A.gql)(templateObject_1$24 || (templateObject_1$24 = __makeTemplateObject$24(["\n  query GetStoreDisplays($input: StoreDisplaysInput!) {\n    storeDisplays(input: $input) {\n      ...Display\n    }\n  }\n  ", "\n"], ["\n  query GetStoreDisplays($input: StoreDisplaysInput!) {\n    storeDisplays(input: $input) {\n      ...Display\n    }\n  }\n  ", "\n"])), DisplayFragment_1$1.DISPLAY_FRAGMENT);
var templateObject_1$24;

var GetStoreDisplaysWithPlanograms = {};

var __makeTemplateObject$23 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreDisplaysWithPlanograms, "__esModule", { value: true });
GetStoreDisplaysWithPlanograms.GET_STORE_DISPLAYS_WITH_PLANOGRAMS = void 0;
var client_1$2z = require$$0$1;
var fragments_1$F = fragments$1;
GetStoreDisplaysWithPlanograms.GET_STORE_DISPLAYS_WITH_PLANOGRAMS = (0, client_1$2z.gql)(templateObject_1$23 || (templateObject_1$23 = __makeTemplateObject$23(["\n  query GetDisplaysWithPlanograms($input: StoreDisplaysInput!) {\n    displaysWithPlanograms(input: $input) {\n      ...DisplayFragmentWithPlanogram\n    }\n  }\n  ", "\n"], ["\n  query GetDisplaysWithPlanograms($input: StoreDisplaysInput!) {\n    displaysWithPlanograms(input: $input) {\n      ...DisplayFragmentWithPlanogram\n    }\n  }\n  ", "\n"])), fragments_1$F.DISPLAY_FRAGMENT_WITH_PLANOGRAM);
var templateObject_1$23;

var GetStoreGroup = {};

var __makeTemplateObject$22 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreGroup, "__esModule", { value: true });
GetStoreGroup.GET_STORE_GROUPS = void 0;
var client_1$2y = require$$0$1;
var fragments_1$E = fragments$1;
GetStoreGroup.GET_STORE_GROUPS = (0, client_1$2y.gql)(templateObject_1$22 || (templateObject_1$22 = __makeTemplateObject$22(["\n  query StoreGroups($input: StoreGroupInput!) {\n    storeGroups(input: $input) {\n      count\n      results {\n        name\n        id\n        assignedTo {\n          ...User\n        }\n        parentGroup {\n          name\n        }\n        groupType\n        storeList {\n          name\n        }\n        region {\n          name\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query StoreGroups($input: StoreGroupInput!) {\n    storeGroups(input: $input) {\n      count\n      results {\n        name\n        id\n        assignedTo {\n          ...User\n        }\n        parentGroup {\n          name\n        }\n        groupType\n        storeList {\n          name\n        }\n        region {\n          name\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$E.USER_FRAGMENT);
var templateObject_1$22;

var GetStoreIds = {};

var __makeTemplateObject$21 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreIds, "__esModule", { value: true });
GetStoreIds.GET_STORE_IDS = void 0;
var client_1$2x = require$$0$1;
GetStoreIds.GET_STORE_IDS = (0, client_1$2x.gql)(templateObject_1$21 || (templateObject_1$21 = __makeTemplateObject$21(["\n  query GetStoreIds($input: CompanyStoresInput!) {\n    companyStores(input: $input) {\n      hasMore\n      count\n      results {\n        id\n      }\n    }\n  }\n"], ["\n  query GetStoreIds($input: CompanyStoresInput!) {\n    companyStores(input: $input) {\n      hasMore\n      count\n      results {\n        id\n      }\n    }\n  }\n"])));
var templateObject_1$21;

var GetStoreInventory = {};

var __makeTemplateObject$20 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreInventory, "__esModule", { value: true });
GetStoreInventory.GET_STORE_INVENTORY = void 0;
var client_1$2w = require$$0$1;
var fragments_1$D = fragments$1;
GetStoreInventory.GET_STORE_INVENTORY = (0, client_1$2w.gql)(templateObject_1$20 || (templateObject_1$20 = __makeTemplateObject$20(["\n  query GetStoreInventory($storeId: ID!) {\n    storeInventory(storeId: $storeId) {\n      ...SimpleInventory\n    }\n  }\n  ", "\n"], ["\n  query GetStoreInventory($storeId: ID!) {\n    storeInventory(storeId: $storeId) {\n      ...SimpleInventory\n    }\n  }\n  ", "\n"])), fragments_1$D.SIMPLE_INVENTORY_FRAGMENT);
var templateObject_1$20;

var GetStoreMap = {};

var __makeTemplateObject$1$ = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreMap, "__esModule", { value: true });
GetStoreMap.GET_STORE_MAP = void 0;
var client_1$2v = require$$0$1;
var StoreAddressFragment_1 = StoreAddressFragment;
GetStoreMap.GET_STORE_MAP = (0, client_1$2v.gql)(templateObject_1$1$ || (templateObject_1$1$ = __makeTemplateObject$1$(["\n  query GetStoreMap($mapId: ID!) {\n    storeMap(mapId: $mapId) {\n      geoJson\n      store {\n        name\n        category\n        image {\n          id\n          url\n        }\n        address {\n          ...StoreAddress\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetStoreMap($mapId: ID!) {\n    storeMap(mapId: $mapId) {\n      geoJson\n      store {\n        name\n        category\n        image {\n          id\n          url\n        }\n        address {\n          ...StoreAddress\n        }\n      }\n    }\n  }\n  ", "\n"])), StoreAddressFragment_1.STORE_ADDRESS_FRAGMENT);
var templateObject_1$1$;

var GetStoreTask = {};

var __makeTemplateObject$1_ = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreTask, "__esModule", { value: true });
GetStoreTask.GET_TASK = void 0;
var client_1$2u = require$$0$1;
var fragments_1$C = fragments$1;
GetStoreTask.GET_TASK = (0, client_1$2u.gql)(templateObject_1$1_ || (templateObject_1$1_ = __makeTemplateObject$1_(["\n  query GetTask($id: ID!) {\n    task(id: $id) {\n      ...Task\n    }\n  }\n  ", "\n"], ["\n  query GetTask($id: ID!) {\n    task(id: $id) {\n      ...Task\n    }\n  }\n  ", "\n"])), fragments_1$C.TASK_FRAGMENT);
var templateObject_1$1_;

var GetStoreTasks = {};

var __makeTemplateObject$1Z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreTasks, "__esModule", { value: true });
GetStoreTasks.GET_STORE_TASKS = void 0;
var client_1$2t = require$$0$1;
var fragments_1$B = fragments$1;
GetStoreTasks.GET_STORE_TASKS = (0, client_1$2t.gql)(templateObject_1$1Z || (templateObject_1$1Z = __makeTemplateObject$1Z(["\n  query GetStoreTasks($input: StoreTaskInput!) {\n    storeTasks(input: $input) {\n      results {\n        ...Task\n      }\n      hasMore\n      count\n    }\n  }\n\n  ", "\n"], ["\n  query GetStoreTasks($input: StoreTaskInput!) {\n    storeTasks(input: $input) {\n      results {\n        ...Task\n      }\n      hasMore\n      count\n    }\n  }\n\n  ", "\n"])), fragments_1$B.TASK_FRAGMENT);
var templateObject_1$1Z;

var GetStoreTypes = {};

var __makeTemplateObject$1Y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoreTypes, "__esModule", { value: true });
GetStoreTypes.GET_STORE_TYPES = void 0;
var client_1$2s = require$$0$1;
GetStoreTypes.GET_STORE_TYPES = (0, client_1$2s.gql)(templateObject_1$1Y || (templateObject_1$1Y = __makeTemplateObject$1Y(["\n\tquery StoreTypes($input: StoreTypesInput) {\n\t\tstoreTypes(input: $input)\n\t}\n"], ["\n\tquery StoreTypes($input: StoreTypesInput) {\n\t\tstoreTypes(input: $input)\n\t}\n"])));
var templateObject_1$1Y;

var GetStores = {};

var __makeTemplateObject$1X = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStores, "__esModule", { value: true });
GetStores.GET_STORES = void 0;
var client_1$2r = require$$0$1;
var fragments_1$A = fragments$1;
GetStores.GET_STORES = (0, client_1$2r.gql)(templateObject_1$1X || (templateObject_1$1X = __makeTemplateObject$1X(["\n  query GetStores($input: CompanyStoresInput!) {\n    companyStores(input: $input) {\n      hasMore\n      count\n      results {\n        ...Store\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetStores($input: CompanyStoresInput!) {\n    companyStores(input: $input) {\n      hasMore\n      count\n      results {\n        ...Store\n      }\n    }\n  }\n  ", "\n"])), fragments_1$A.STORE_FRAGMENT);
var templateObject_1$1X;

var GetStoresStats = {};

var __makeTemplateObject$1W = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoresStats, "__esModule", { value: true });
GetStoresStats.GET_STORES_STATS = void 0;
var client_1$2q = require$$0$1;
GetStoresStats.GET_STORES_STATS = (0, client_1$2q.gql)(templateObject_1$1W || (templateObject_1$1W = __makeTemplateObject$1W(["\n  query GetStoresStats($input: StoresStatsInput) {\n    storesStats(input: $input) {\n      store {\n        id\n        store {\n          name\n          address {\n            address1\n            address2\n            city\n            state\n            postalCode\n          }\n          image {\n            id\n            url\n          }\n        }\n      }\n      displaysObservedToday\n      displaysObservedTodayIds\n      displayScansToday\n      displaysScannedTodayIds\n      avgScoreToday\n      date\n      observedDisplays\n    }\n  }\n"], ["\n  query GetStoresStats($input: StoresStatsInput) {\n    storesStats(input: $input) {\n      store {\n        id\n        store {\n          name\n          address {\n            address1\n            address2\n            city\n            state\n            postalCode\n          }\n          image {\n            id\n            url\n          }\n        }\n      }\n      displaysObservedToday\n      displaysObservedTodayIds\n      displayScansToday\n      displaysScannedTodayIds\n      avgScoreToday\n      date\n      observedDisplays\n    }\n  }\n"])));
var templateObject_1$1W;

var GetStoresWithFilter = {};

var __makeTemplateObject$1V = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetStoresWithFilter, "__esModule", { value: true });
GetStoresWithFilter.GET_STORES_WITH_FILTER = void 0;
var client_1$2p = require$$0$1;
var fragments_1$z = fragments$1;
GetStoresWithFilter.GET_STORES_WITH_FILTER = (0, client_1$2p.gql)(templateObject_1$1V || (templateObject_1$1V = __makeTemplateObject$1V(["\n  query GetStoresWithFilter($input: CompanyStoresWithFilterInput!) {\n    companyStoresWithFilter(input: $input) {\n      hasMore\n      count\n      results {\n        ...Store\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetStoresWithFilter($input: CompanyStoresWithFilterInput!) {\n    companyStoresWithFilter(input: $input) {\n      hasMore\n      count\n      results {\n        ...Store\n      }\n    }\n  }\n  ", "\n"])), fragments_1$z.STORE_FRAGMENT);
var templateObject_1$1V;

var GetTraining = {};

var __makeTemplateObject$1U = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetTraining, "__esModule", { value: true });
GetTraining.GET_TRAINING = void 0;
var client_1$2o = require$$0$1;
var TrainingFragment_1$1 = TrainingFragment;
GetTraining.GET_TRAINING = (0, client_1$2o.gql)(templateObject_1$1U || (templateObject_1$1U = __makeTemplateObject$1U(["\n  query Training($trainingId: ID!) {\n    training(trainingId: $trainingId) {\n      ...Training\n    }\n  }\n  ", "\n"], ["\n  query Training($trainingId: ID!) {\n    training(trainingId: $trainingId) {\n      ...Training\n    }\n  }\n  ", "\n"])), TrainingFragment_1$1.TRAINING_FRAGMENT);
var templateObject_1$1U;

var GetTrainingPointCloud = {};

var __makeTemplateObject$1T = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetTrainingPointCloud, "__esModule", { value: true });
GetTrainingPointCloud.GET_TRAINING_POINT_CLOUD = void 0;
var client_1$2n = require$$0$1;
var TrainingPointCloud_1$3 = TrainingPointCloud;
GetTrainingPointCloud.GET_TRAINING_POINT_CLOUD = (0, client_1$2n.gql)(templateObject_1$1T || (templateObject_1$1T = __makeTemplateObject$1T(["\n  query GetTrainingPointCloud($pointCloudId: ID!) {\n    trainingPointCloud(pointCloudId: $pointCloudId) {\n      ...TrainingPointCloud\n    }\n  }\n  ", "\n"], ["\n  query GetTrainingPointCloud($pointCloudId: ID!) {\n    trainingPointCloud(pointCloudId: $pointCloudId) {\n      ...TrainingPointCloud\n    }\n  }\n  ", "\n"])), TrainingPointCloud_1$3.TRAINING_POINT_CLOUD_FRAGMENT);
var templateObject_1$1T;

var GetTrainingPointClouds = {};

var __makeTemplateObject$1S = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetTrainingPointClouds, "__esModule", { value: true });
GetTrainingPointClouds.GET_TRAINING_POINT_CLOUDS = void 0;
var client_1$2m = require$$0$1;
var TrainingPointCloud_1$2 = TrainingPointCloud;
GetTrainingPointClouds.GET_TRAINING_POINT_CLOUDS = (0, client_1$2m.gql)(templateObject_1$1S || (templateObject_1$1S = __makeTemplateObject$1S(["\n  query GetTrainingPointClouds($input: TrainingPointCloudsInput!) {\n    trainingPointClouds(input: $input) {\n      count\n      hasMore\n      results {\n        ...TrainingPointCloud\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetTrainingPointClouds($input: TrainingPointCloudsInput!) {\n    trainingPointClouds(input: $input) {\n      count\n      hasMore\n      results {\n        ...TrainingPointCloud\n      }\n    }\n  }\n  ", "\n"])), TrainingPointCloud_1$2.TRAINING_POINT_CLOUD_FRAGMENT);
var templateObject_1$1S;

var GetUnverifiedMultiProductImages = {};

var __makeTemplateObject$1R = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetUnverifiedMultiProductImages, "__esModule", { value: true });
GetUnverifiedMultiProductImages.GET_UNVERIFIED_MULTI_PRODUCT_IMAGES = void 0;
var client_1$2l = require$$0$1;
var MultiProductImageFragment_1 = MultiProductImageFragment;
GetUnverifiedMultiProductImages.GET_UNVERIFIED_MULTI_PRODUCT_IMAGES = (0, client_1$2l.gql)(templateObject_1$1R || (templateObject_1$1R = __makeTemplateObject$1R(["\n  query GetUnverifiedMultiProductImages {\n    unverifiedMultiProductImages {\n      results {\n        ...MultiProductImage\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"], ["\n  query GetUnverifiedMultiProductImages {\n    unverifiedMultiProductImages {\n      results {\n        ...MultiProductImage\n      }\n      hasMore\n      count\n    }\n  }\n  ", "\n"])), MultiProductImageFragment_1.MULTI_PRODUCT_IMAGE_FRAGMENT);
var templateObject_1$1R;

var GetUserSiblings = {};

var __makeTemplateObject$1Q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetUserSiblings, "__esModule", { value: true });
GetUserSiblings.GET_USER_SIBLINGS = void 0;
var client_1$2k = require$$0$1;
GetUserSiblings.GET_USER_SIBLINGS = (0, client_1$2k.gql)(templateObject_1$1Q || (templateObject_1$1Q = __makeTemplateObject$1Q(["\n  query GetUserSiblings($input: UserSiblingsInput!) {\n    userSiblings(input: $input) {\n      id\n      stores {\n        id\n      }\n    }\n  }\n"], ["\n  query GetUserSiblings($input: UserSiblingsInput!) {\n    userSiblings(input: $input) {\n      id\n      stores {\n        id\n      }\n    }\n  }\n"])));
var templateObject_1$1Q;

var GetUserStores = {};

var __makeTemplateObject$1P = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetUserStores, "__esModule", { value: true });
GetUserStores.GET_USER_STORES = void 0;
var client_1$2j = require$$0$1;
GetUserStores.GET_USER_STORES = (0, client_1$2j.gql)(templateObject_1$1P || (templateObject_1$1P = __makeTemplateObject$1P(["\n  query GetUserStores($input: UserCompanyStoresInput!) {\n    userStores(input: $input) {\n      id\n    }\n  }\n"], ["\n  query GetUserStores($input: UserCompanyStoresInput!) {\n    userStores(input: $input) {\n      id\n    }\n  }\n"])));
var templateObject_1$1P;

var GetUserUnderlings = {};

var __makeTemplateObject$1O = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetUserUnderlings, "__esModule", { value: true });
GetUserUnderlings.GET_USER_UNDERLINGS = void 0;
var client_1$2i = require$$0$1;
GetUserUnderlings.GET_USER_UNDERLINGS = (0, client_1$2i.gql)(templateObject_1$1O || (templateObject_1$1O = __makeTemplateObject$1O(["\n  query GetUserUnderlings($input: UserUnderlingsInput) {\n    userUnderlings(input: $input) {\n      id\n      uuid\n      firstName\n      lastName\n      email\n    }\n  }\n"], ["\n  query GetUserUnderlings($input: UserUnderlingsInput) {\n    userUnderlings(input: $input) {\n      id\n      uuid\n      firstName\n      lastName\n      email\n    }\n  }\n"])));
var templateObject_1$1O;

var GetValidImageFormats = {};

var __makeTemplateObject$1N = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetValidImageFormats, "__esModule", { value: true });
GetValidImageFormats.GET_VALID_IMAGE_FORMATS = void 0;
var client_1$2h = require$$0$1;
GetValidImageFormats.GET_VALID_IMAGE_FORMATS = (0, client_1$2h.gql)(templateObject_1$1N || (templateObject_1$1N = __makeTemplateObject$1N(["\n    query ValidImageFormat{\n        validImageFormat\n    } \n"], ["\n    query ValidImageFormat{\n        validImageFormat\n    } \n"])));
var templateObject_1$1N;

var LocalDatabaseTypes = {};

var __makeTemplateObject$1M = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(LocalDatabaseTypes, "__esModule", { value: true });
LocalDatabaseTypes.LOCAL_DATABASE_TYPES = void 0;
var client_1$2g = require$$0$1;
LocalDatabaseTypes.LOCAL_DATABASE_TYPES = (0, client_1$2g.gql)(templateObject_1$1M || (templateObject_1$1M = __makeTemplateObject$1M(["\n    query LocalProductDatabaseSchema {\n        localProductColumns\n        localProductForeignKeys {\n          companyCategoryId {\n            name\n            endTable\n          }\n          packagingId {\n            name\n            endTable\n          }\n          shippingId {\n            name\n            endTable\n          }\n          flavor {\n            name\n            endTable\n          }\n        }\n        localPackagingColumns\n        localCompanyCategoryColumns\n        localShippingColumns\n        localFlavorColumns\n        localVersionColumns\n        localProductFlavorRelationColumns\n        localProductFlavorRelationForeignKeys {\n          flavor {\n            name\n            endTable\n          }\n          productId {\n            name\n            endTable\n          }\n        }\n    }\n"], ["\n    query LocalProductDatabaseSchema {\n        localProductColumns\n        localProductForeignKeys {\n          companyCategoryId {\n            name\n            endTable\n          }\n          packagingId {\n            name\n            endTable\n          }\n          shippingId {\n            name\n            endTable\n          }\n          flavor {\n            name\n            endTable\n          }\n        }\n        localPackagingColumns\n        localCompanyCategoryColumns\n        localShippingColumns\n        localFlavorColumns\n        localVersionColumns\n        localProductFlavorRelationColumns\n        localProductFlavorRelationForeignKeys {\n          flavor {\n            name\n            endTable\n          }\n          productId {\n            name\n            endTable\n          }\n        }\n    }\n"])));
var templateObject_1$1M;

var PicOSAllPrioritiesCompliance = {};

var __makeTemplateObject$1L = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSAllPrioritiesCompliance, "__esModule", { value: true });
PicOSAllPrioritiesCompliance.PICOS_ALL_PRIORITIES_COMPLIANCE = void 0;
var client_1$2f = require$$0$1;
var PicOSPriorityOverviewFragment_1 = PicOSPriorityOverviewFragment;
PicOSAllPrioritiesCompliance.PICOS_ALL_PRIORITIES_COMPLIANCE = (0, client_1$2f.gql)(templateObject_1$1L || (templateObject_1$1L = __makeTemplateObject$1L(["\n  query PicOSAllPrioritiesCompliance(\n    $input: PicOSAllPrioritiesComplianceInput!\n  ) {\n    picosAllPrioritiesCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        priority {\n          ...PicOSPriorityOverview\n        }\n        regionCompliance {\n          name\n          compliancePercentage\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query PicOSAllPrioritiesCompliance(\n    $input: PicOSAllPrioritiesComplianceInput!\n  ) {\n    picosAllPrioritiesCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        priority {\n          ...PicOSPriorityOverview\n        }\n        regionCompliance {\n          name\n          compliancePercentage\n        }\n      }\n    }\n  }\n  ", "\n"])), PicOSPriorityOverviewFragment_1.PICOS_PRIORITY_OVERVIEW_FRAGMENT);
var templateObject_1$1L;

var PicOSAllPrioritiesComplianceStats = {};

var __makeTemplateObject$1K = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSAllPrioritiesComplianceStats, "__esModule", { value: true });
PicOSAllPrioritiesComplianceStats.PICOS_ALL_PRIORITIES_COMPLIANCE_STATS = void 0;
var client_1$2e = require$$0$1;
var fragments_1$y = fragments$1;
PicOSAllPrioritiesComplianceStats.PICOS_ALL_PRIORITIES_COMPLIANCE_STATS = (0, client_1$2e.gql)(templateObject_1$1K || (templateObject_1$1K = __makeTemplateObject$1K(["\n  query PicOSAllPrioritiesComplianceStats(\n    $input: PicOSAllPrioritiesComplianceInput!\n  ) {\n    picosAllPrioritiesStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"], ["\n  query PicOSAllPrioritiesComplianceStats(\n    $input: PicOSAllPrioritiesComplianceInput!\n  ) {\n    picosAllPrioritiesStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"])), fragments_1$y.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT);
var templateObject_1$1K;

var PicOSPriorityCompliance = {};

var __makeTemplateObject$1J = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSPriorityCompliance, "__esModule", { value: true });
PicOSPriorityCompliance.PICOS_PRIORITY_COMPLIANCE = void 0;
var client_1$2d = require$$0$1;
var fragments_1$x = fragments$1;
PicOSPriorityCompliance.PICOS_PRIORITY_COMPLIANCE = (0, client_1$2d.gql)(templateObject_1$1J || (templateObject_1$1J = __makeTemplateObject$1J(["\n  query PicOSPriorityCompliance($input: PicOSPriorityComplianceInput!) {\n    picosPriorityCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        storeName\n        divisionId\n        divisionName\n        cost\n        isCompliant\n        address {\n          ...StoreAddress\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query PicOSPriorityCompliance($input: PicOSPriorityComplianceInput!) {\n    picosPriorityCompliance(input: $input) {\n      hasMore\n      count\n      results {\n        id\n        storeName\n        divisionId\n        divisionName\n        cost\n        isCompliant\n        address {\n          ...StoreAddress\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$x.STORE_ADDRESS_FRAGMENT);
var templateObject_1$1J;

var PicOSPriorityStoresStats = {};

var __makeTemplateObject$1I = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PicOSPriorityStoresStats, "__esModule", { value: true });
PicOSPriorityStoresStats.PICOS_PRIORITY_STATS = void 0;
var client_1$2c = require$$0$1;
var fragments_1$w = fragments$1;
PicOSPriorityStoresStats.PICOS_PRIORITY_STATS = (0, client_1$2c.gql)(templateObject_1$1I || (templateObject_1$1I = __makeTemplateObject$1I(["\n  query PicOSPriorityStats($input: PicOSPriorityComplianceInput!) {\n    picosPriorityStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"], ["\n  query PicOSPriorityStats($input: PicOSPriorityComplianceInput!) {\n    picosPriorityStats(input: $input) {\n      current {\n        ...PicOSGroupComplianceStats\n      }\n      previous {\n        ...PicOSGroupComplianceStats\n      }\n    }\n  }\n  ", "\n"])), fragments_1$w.PICOS_GROUP_COMPLIANCE_STATS_FRAGMENT);
var templateObject_1$1I;

var ProductImageByUpc = {};

var __makeTemplateObject$1H = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ProductImageByUpc, "__esModule", { value: true });
ProductImageByUpc.PRODUCT_IMAGE_BY_UPC = void 0;
var client_1$2b = require$$0$1;
ProductImageByUpc.PRODUCT_IMAGE_BY_UPC = (0, client_1$2b.gql)(templateObject_1$1H || (templateObject_1$1H = __makeTemplateObject$1H(["\n  query ProductImageByUpc($upc: ID!) {\n    productByUpc(upc: $upc) {\n      id\n      upcA\n      marketingImageUrl\n    }\n  }\n"], ["\n  query ProductImageByUpc($upc: ID!) {\n    productByUpc(upc: $upc) {\n      id\n      upcA\n      marketingImageUrl\n    }\n  }\n"])));
var templateObject_1$1H;

var SearchProducts = {};

var __makeTemplateObject$1G = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SearchProducts, "__esModule", { value: true });
SearchProducts.SEARCH_PRODUCTS = void 0;
var client_1$2a = require$$0$1;
var fragments_1$v = fragments$1;
SearchProducts.SEARCH_PRODUCTS = (0, client_1$2a.gql)(templateObject_1$1G || (templateObject_1$1G = __makeTemplateObject$1G(["\n  query SearchProducts($productsInput: ProductsInput!) {\n    products(input: $productsInput) {\n      count\n      hasMore\n      results {\n        ...MultiProductImageProduct\n      }\n    }\n  }\n  ", "\n"], ["\n  query SearchProducts($productsInput: ProductsInput!) {\n    products(input: $productsInput) {\n      count\n      hasMore\n      results {\n        ...MultiProductImageProduct\n      }\n    }\n  }\n  ", "\n"])), fragments_1$v.MULTI_PRODUCT_IMAGE_PRODUCT_FRAGMENT);
var templateObject_1$1G;

var GetProductsWithError = {};

var __makeTemplateObject$1F = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProductsWithError, "__esModule", { value: true });
GetProductsWithError.GET_PRODUCTS_WITH_ERROR = void 0;
var client_1$29 = require$$0$1;
var fragments_1$u = fragments$1;
// Not using the SimpleProductFragment here so we can easily pass in $companyId to companyCategory()
GetProductsWithError.GET_PRODUCTS_WITH_ERROR = (0, client_1$29.gql)(templateObject_1$1F || (templateObject_1$1F = __makeTemplateObject$1F(["\n  query ProductsWithError($input: ProductsWithInfoErrorsInput, $companyId: ID) {\n    productsWithInfoErrors(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        upcA\n        upcE\n        name\n        isActive\n        created\n        modified\n        lastInAudit\n        lastTimeBarcodeScanned\n        source\n        brand {\n          id\n          name\n        }\n        manufacturer {\n          id\n          name\n        }\n        packaging {\n          ...Packaging\n        }\n        shipping {\n          ...Shipping\n        }\n        marketingImageUrl\n        flavors {\n          id\n          flavor\n          displayFlavor\n        }\n        companyCategory(companyId: $companyId) {\n          id\n          category\n          parentCategory\n        }\n        geometry {\n          id\n          geometry\n        }\n        verifiedBy\n        verifiedByUser {\n          firstName\n          lastName\n        }\n        ...SimpleFlaggableObject\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"], ["\n  query ProductsWithError($input: ProductsWithInfoErrorsInput, $companyId: ID) {\n    productsWithInfoErrors(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        upcA\n        upcE\n        name\n        isActive\n        created\n        modified\n        lastInAudit\n        lastTimeBarcodeScanned\n        source\n        brand {\n          id\n          name\n        }\n        manufacturer {\n          id\n          name\n        }\n        packaging {\n          ...Packaging\n        }\n        shipping {\n          ...Shipping\n        }\n        marketingImageUrl\n        flavors {\n          id\n          flavor\n          displayFlavor\n        }\n        companyCategory(companyId: $companyId) {\n          id\n          category\n          parentCategory\n        }\n        geometry {\n          id\n          geometry\n        }\n        verifiedBy\n        verifiedByUser {\n          firstName\n          lastName\n        }\n        ...SimpleFlaggableObject\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), fragments_1$u.PACKAGING_FRAGMENT, fragments_1$u.SHIPPING_FRAGMENT, fragments_1$u.SIMPLE_FLAGGABLE_OBJECT_FRAGMENT);
var templateObject_1$1F;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(AllDisplays, exports);
__exportStar(BrandDisruptorSummaryStats, exports);
__exportStar(BrandExplorer, exports);
__exportStar(BrandGeography, exports);
__exportStar(BrandLandscape, exports);
__exportStar(BrandHistory, exports);
__exportStar(CompanyCategorySoviFormulaGroups, exports);
__exportStar(CompanyColdAvailabilityFormulaGroups, exports);
__exportStar(CompanyStoreDistributions, exports);
__exportStar(GetAdminAuditHistory, exports);
__exportStar(GetAdminAudits, exports);
__exportStar(GetAdminCompanyRegions, exports);
__exportStar(GetAdminCompanyStoreCategoriesById, exports);
__exportStar(GetAdminCompanyStores, exports);
__exportStar(GetAdminCompanyStoresForDownload, exports);
__exportStar(GetAdminStore, exports);
__exportStar(GetAdminStoreHistory, exports);
__exportStar(GetAllCompanyUserOptions, exports);
__exportStar(GetAdminStoreAudit, exports);
__exportStar(GetAllTrainings, exports);
__exportStar(GetAuditQuestions, exports);
__exportStar(GetBrands$1, exports);
__exportStar(GetCompanies, exports);
__exportStar(GetCompanyAuditQuestions, exports);
__exportStar(GetCompanyByName, exports);
__exportStar(GetCompanyChains, exports);
__exportStar(GetCompanyProductCategories, exports);
__exportStar(GetCompanyRegions, exports);
__exportStar(GetCompanyRegion, exports);
__exportStar(GetCompanyRegionsSimple, exports);
__exportStar(GetCompanyStoreByInternalStoreId, exports);
__exportStar(GetCompanyStoreOptions, exports);
__exportStar(GetCompanyUsers, exports);
__exportStar(GetCurrentMapForStore, exports);
__exportStar(GetDashboard, exports);
__exportStar(GetDeployedMLModel, exports);
__exportStar(GetDeployedMLModelsForUser, exports);
__exportStar(GetDisplay, exports);
__exportStar(GetDisplayByQrId, exports);
__exportStar(GetDisplayAuditImage, exports);
__exportStar(GetDisplayLocations, exports);
__exportStar(GetDisplayInventory, exports);
__exportStar(GetDisplayRestockHistory, exports);
__exportStar(GetDisplayScans, exports);
__exportStar(GetDisplayTransactions, exports);
__exportStar(GetDisplayTypes, exports);
__exportStar(GetDisplaysInventoryForStore, exports);
__exportStar(GetDrawMapTask, exports);
__exportStar(GetDrawMapTasks, exports);
__exportStar(GetFlaggedObject, exports);
__exportStar(GetFlaggedObjects, exports);
__exportStar(GetFlaggedReasonsByType, exports);
__exportStar(GetGeographicHierarchyDrafts, exports);
__exportStar(GetFullUserStores, exports);
__exportStar(GetGeographicHierarchyLeadCandidates, exports);
__exportStar(GetGroups, exports);
__exportStar(GetImage, exports);
__exportStar(GetLoggedInUser, exports);
__exportStar(GetMLModelIfNeeded, exports);
__exportStar(GetManufacturers$1, exports);
__exportStar(GetMarketingImagesForProduct, exports);
__exportStar(GetMerchandiserStats, exports);
__exportStar(GetPhysicalStore, exports);
__exportStar(GetModularComplianceAudits, exports);
__exportStar(GetPhysicalStores, exports);
__exportStar(GetPicOSAllCustomersCompliance, exports);
__exportStar(GetPicOSAllCustomersStats, exports);
__exportStar(GetPicOSCustomerCompliance, exports);
__exportStar(GetPicOSCustomerComplianceStats, exports);
__exportStar(GetPicOSDivisionCompliance, exports);
__exportStar(GetPicOSDivisionComplianceStats, exports);
__exportStar(GetPicOSPriority, exports);
__exportStar(GetPicOSSalesCenterCompliance, exports);
__exportStar(GetPicOSSalesCenterComplianceStats, exports);
__exportStar(GetPicOSStoreCompliance, exports);
__exportStar(GetPicOSStoreComplianceStats, exports);
__exportStar(GetPicosBrands, exports);
__exportStar(GetPicosPackaging, exports);
__exportStar(GetPicosProducts, exports);
__exportStar(GetPlanogramFeedbackImageById, exports);
__exportStar(GetPlanogramFeedbackImagesIssues, exports);
__exportStar(GetPlanogramImagesForProduct, exports);
__exportStar(GetPointCloud, exports);
__exportStar(GetPointCloudScanScores, exports);
__exportStar(GetProductByUpc, exports);
__exportStar(GetProductCounted, exports);
__exportStar(GetProductFlavors, exports);
__exportStar(GetProductLabeledImageCounts, exports);
__exportStar(GetProductPriceObjects, exports);
__exportStar(GetProducts$1, exports);
__exportStar(GetProductsMoreInfo, exports);
__exportStar(GetRandomObservedDisplay, exports);
__exportStar(GetRecommendationComplianceScores, exports);
__exportStar(GetReportedIssues, exports);
__exportStar(GetScanQualityScore, exports);
__exportStar(GetScanScoringParameters, exports);
__exportStar(GetScannerMetadata, exports);
__exportStar(GetSimpleStoreAudits, exports);
__exportStar(GetSingleProductPointClouds, exports);
__exportStar(GetStatus, exports);
__exportStar(GetSlotCountFrequency, exports);
__exportStar(GetStore, exports);
__exportStar(GetStoreAreas, exports);
__exportStar(GetStoreAudit, exports);
__exportStar(GetStoreAudits, exports);
__exportStar(GetStoreChains, exports);
__exportStar(GetStoreDisplayTransactions, exports);
__exportStar(GetStoreDisplayWithStoreData, exports);
__exportStar(GetStoreDisplays, exports);
__exportStar(GetStoreDisplaysWithPlanograms, exports);
__exportStar(GetStoreGroup, exports);
__exportStar(GetStoreIds, exports);
__exportStar(GetStoreInventory, exports);
__exportStar(GetStoreMap, exports);
__exportStar(GetStoreTask, exports);
__exportStar(GetStoreTasks, exports);
__exportStar(GetStoreTypes, exports);
__exportStar(GetStores, exports);
__exportStar(GetStoresStats, exports);
__exportStar(GetStoresWithFilter, exports);
__exportStar(GetTraining, exports);
__exportStar(GetTrainingPointCloud, exports);
__exportStar(GetTrainingPointClouds, exports);
__exportStar(GetUnverifiedMultiProductImages, exports);
__exportStar(GetUserSiblings, exports);
__exportStar(GetUserStores, exports);
__exportStar(GetUserUnderlings, exports);
__exportStar(GetValidImageFormats, exports);
__exportStar(LocalDatabaseTypes, exports);
__exportStar(PicOSAllPrioritiesCompliance, exports);
__exportStar(PicOSAllPrioritiesComplianceStats, exports);
__exportStar(PicOSPriorityCompliance, exports);
__exportStar(PicOSPriorityStoresStats, exports);
__exportStar(ProductImageByUpc, exports);
__exportStar(SearchProducts, exports);
__exportStar(GetProductsWithError, exports);
}(queries$2));

var mutations$2 = {};

var AddDisplayAuditPointCloud = {};

var __makeTemplateObject$1E = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AddDisplayAuditPointCloud, "__esModule", { value: true });
AddDisplayAuditPointCloud.ADD_DISPLAY_AUDIT_POINT_CLOUD = void 0;
var client_1$28 = require$$0$1;
var BoundingCubeFragment_1 = BoundingCubeFragment;
AddDisplayAuditPointCloud.ADD_DISPLAY_AUDIT_POINT_CLOUD = (0, client_1$28.gql)(templateObject_1$1E || (templateObject_1$1E = __makeTemplateObject$1E(["\n  mutation AddDisplayAuditPointCloud($input: AddPointCloudSceneInput!) {\n    addDisplayAuditPointCloud(input: $input) {\n      displayAuditPointCloud {\n        id\n        bucketFileName\n        labels\n        predicted\n        centroids\n        metadata\n        boundingCube {\n          ...BoundingCube\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AddDisplayAuditPointCloud($input: AddPointCloudSceneInput!) {\n    addDisplayAuditPointCloud(input: $input) {\n      displayAuditPointCloud {\n        id\n        bucketFileName\n        labels\n        predicted\n        centroids\n        metadata\n        boundingCube {\n          ...BoundingCube\n        }\n      }\n    }\n  }\n  ", "\n"])), BoundingCubeFragment_1.BOUNDING_CUBE_FRAGMENT);
var templateObject_1$1E;

var AddDisplayMutation = {};

var __makeTemplateObject$1D = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AddDisplayMutation, "__esModule", { value: true });
AddDisplayMutation.ADD_DISPLAY = void 0;
var client_1$27 = require$$0$1;
var WholeDisplayFragment_1$1 = WholeDisplayFragment;
AddDisplayMutation.ADD_DISPLAY = (0, client_1$27.gql)(templateObject_1$1D || (templateObject_1$1D = __makeTemplateObject$1D(["\n  mutation AddDisplay($input: AddDisplayInput!) {\n    addDisplay(input: $input) {\n      display {\n        ...WholeDisplay\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AddDisplay($input: AddDisplayInput!) {\n    addDisplay(input: $input) {\n      display {\n        ...WholeDisplay\n      }\n    }\n  }\n  ", "\n"])), WholeDisplayFragment_1$1.WHOLE_DISPLAY_FRAGMENT);
var templateObject_1$1D;

var AddDisplaySceneTest = {};

// import { gql } from '@apollo/client'
Object.defineProperty(AddDisplaySceneTest, "__esModule", { value: true });
AddDisplaySceneTest.ADD_DISPLAY_SCENE_TEST = void 0;
AddDisplaySceneTest.ADD_DISPLAY_SCENE_TEST = '';

var AddImage = {};

var __makeTemplateObject$1C = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AddImage, "__esModule", { value: true });
AddImage.ADD_IMAGE = void 0;
var client_1$26 = require$$0$1;
var fragments_1$t = fragments$1;
AddImage.ADD_IMAGE = (0, client_1$26.gql)(templateObject_1$1C || (templateObject_1$1C = __makeTemplateObject$1C(["\n  mutation AddImage($input: AddImageInput!) {\n    addImage(input: $input) {\n      image {\n        url\n        id\n        created\n        saved\n        ... on DisplayAuditImage {\n          boundingBoxSet {\n            ...BoundingBoxes\n          }\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AddImage($input: AddImageInput!) {\n    addImage(input: $input) {\n      image {\n        url\n        id\n        created\n        saved\n        ... on DisplayAuditImage {\n          boundingBoxSet {\n            ...BoundingBoxes\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$t.BOUNDING_BOXES_FRAGMENT);
var templateObject_1$1C;

var AddImageSimpleReturn = {};

var __makeTemplateObject$1B = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AddImageSimpleReturn, "__esModule", { value: true });
AddImageSimpleReturn.ADD_IMAGE_SIMPLE_RETURN = void 0;
var client_1$25 = require$$0$1;
AddImageSimpleReturn.ADD_IMAGE_SIMPLE_RETURN = (0, client_1$25.gql)(templateObject_1$1B || (templateObject_1$1B = __makeTemplateObject$1B(["\n  mutation AddImageSimpleReturn($input: AddImageInput!) {\n    addImage(input: $input) {\n      image {\n        id\n        saved\n      }\n    }\n  }\n"], ["\n  mutation AddImageSimpleReturn($input: AddImageInput!) {\n    addImage(input: $input) {\n      image {\n        id\n        saved\n      }\n    }\n  }\n"])));
var templateObject_1$1B;

var AddPOSScansMutation = {};

var __makeTemplateObject$1A = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AddPOSScansMutation, "__esModule", { value: true });
AddPOSScansMutation.ADD_POS_SCANS = void 0;
var client_1$24 = require$$0$1;
AddPOSScansMutation.ADD_POS_SCANS = (0, client_1$24.gql)(templateObject_1$1A || (templateObject_1$1A = __makeTemplateObject$1A(["\n  mutation AddPOSScans($input: [AddPOSScanInput!]!) {\n    addPosScans(input: $input) {\n      posScans {\n        created\n        id\n        posId\n        display {\n          id\n        }\n        store {\n          id\n        }\n        area {\n          name\n        }\n        employee {\n          id\n        }\n        retiredDate\n      }\n    }\n  }\n"], ["\n  mutation AddPOSScans($input: [AddPOSScanInput!]!) {\n    addPosScans(input: $input) {\n      posScans {\n        created\n        id\n        posId\n        display {\n          id\n        }\n        store {\n          id\n        }\n        area {\n          name\n        }\n        employee {\n          id\n        }\n        retiredDate\n      }\n    }\n  }\n"])));
var templateObject_1$1A;

var AddProductMutation = {};

var __makeTemplateObject$1z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AddProductMutation, "__esModule", { value: true });
AddProductMutation.ADD_PRODUCT = void 0;
var client_1$23 = require$$0$1;
var SimpleProductFragment_1 = SimpleProductFragment;
AddProductMutation.ADD_PRODUCT = (0, client_1$23.gql)(templateObject_1$1z || (templateObject_1$1z = __makeTemplateObject$1z(["\n  mutation AddProduct($input: AddProductInput!) {\n    addProduct(input: $input) {\n      product {\n        ...SimpleProduct\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AddProduct($input: AddProductInput!) {\n    addProduct(input: $input) {\n      product {\n        ...SimpleProduct\n      }\n    }\n  }\n  ", "\n"])), SimpleProductFragment_1.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1$1z;

var AddTrainingPointCloud = {};

var __makeTemplateObject$1y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AddTrainingPointCloud, "__esModule", { value: true });
AddTrainingPointCloud.ADD_TRAINING_POINT_CLOUD = void 0;
var client_1$22 = require$$0$1;
var TrainingPointCloud_1$1 = TrainingPointCloud;
AddTrainingPointCloud.ADD_TRAINING_POINT_CLOUD = (0, client_1$22.gql)(templateObject_1$1y || (templateObject_1$1y = __makeTemplateObject$1y(["\n  mutation AddTrainingPointCloud($input: AddTrainingPointCloudInput!) {\n    addTrainingPointCloud(input: $input) {\n      pointCloud {\n        ...TrainingPointCloud\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AddTrainingPointCloud($input: AddTrainingPointCloudInput!) {\n    addTrainingPointCloud(input: $input) {\n      pointCloud {\n        ...TrainingPointCloud\n      }\n    }\n  }\n  ", "\n"])), TrainingPointCloud_1$1.TRAINING_POINT_CLOUD_FRAGMENT);
var templateObject_1$1y;

var AddUser = {};

var __makeTemplateObject$1x = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AddUser, "__esModule", { value: true });
AddUser.ADD_USER = void 0;
var client_1$21 = require$$0$1;
AddUser.ADD_USER = (0, client_1$21.gql)(templateObject_1$1x || (templateObject_1$1x = __makeTemplateObject$1x(["\n  mutation AddUser($input: AddUserInput!) {\n    addUser(input: $input) {\n      user {\n\t\t\t\tfirstName\n        lastName\n      }\n    }\n  }\n"], ["\n  mutation AddUser($input: AddUserInput!) {\n    addUser(input: $input) {\n      user {\n\t\t\t\tfirstName\n        lastName\n      }\n    }\n  }\n"])));
var templateObject_1$1x;

var AppUpdateCompanyStore = {};

var __makeTemplateObject$1w = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AppUpdateCompanyStore, "__esModule", { value: true });
AppUpdateCompanyStore.APP_UPDATE_COMPANY_STORE = void 0;
var client_1$20 = require$$0$1;
var fragments_1$s = fragments$1;
AppUpdateCompanyStore.APP_UPDATE_COMPANY_STORE = (0, client_1$20.gql)(templateObject_1$1w || (templateObject_1$1w = __makeTemplateObject$1w(["\n  mutation AppUpdateCompanyStore($input: UpdateCompanyStoreInput!) {\n    updateCompanyStore(input: $input) {\n      store {\n        ...FullStore\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AppUpdateCompanyStore($input: UpdateCompanyStoreInput!) {\n    updateCompanyStore(input: $input) {\n      store {\n        ...FullStore\n      }\n    }\n  }\n  ", "\n"])), fragments_1$s.FULL_STORE_FRAGMENT);
var templateObject_1$1w;

var AssignDrawMapTask = {};

var __makeTemplateObject$1v = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AssignDrawMapTask, "__esModule", { value: true });
AssignDrawMapTask.ASSIGN_DRAW_MAP_TASK = void 0;
var client_1$1$ = require$$0$1;
var DrawMapTaskFragment_1$5 = DrawMapTaskFragment;
AssignDrawMapTask.ASSIGN_DRAW_MAP_TASK = (0, client_1$1$.gql)(templateObject_1$1v || (templateObject_1$1v = __makeTemplateObject$1v(["\n  mutation AssignIndoorMapDrawTask($input: AssignIndoorMapDrawTaskInput!) {\n    assignIndoorMapDrawTask(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AssignIndoorMapDrawTask($input: AssignIndoorMapDrawTaskInput!) {\n    assignIndoorMapDrawTask(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"])), DrawMapTaskFragment_1$5.DRAW_MAP_TASK_FRAGMENT);
var templateObject_1$1v;

var AssignSupervisor = {};

var __makeTemplateObject$1u = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AssignSupervisor, "__esModule", { value: true });
AssignSupervisor.ASSIGN_USER_SUPERVISOR = void 0;
var client_1$1_ = require$$0$1;
AssignSupervisor.ASSIGN_USER_SUPERVISOR = (0, client_1$1_.gql)(templateObject_1$1u || (templateObject_1$1u = __makeTemplateObject$1u(["\n  mutation AssignUserSupervisor($input: AssignUserSupervisorInput!) {\n    assignSupervisor(input: $input) {\n      users {\n        uuid\n        supervisor {\n          uuid\n        }\n      }\n    }\n  }\n"], ["\n  mutation AssignUserSupervisor($input: AssignUserSupervisorInput!) {\n    assignSupervisor(input: $input) {\n      users {\n        uuid\n        supervisor {\n          uuid\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$1u;

var AssignUsersActive = {};

var __makeTemplateObject$1t = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(AssignUsersActive, "__esModule", { value: true });
AssignUsersActive.ASSIGN_USERS_ACTIVE = void 0;
var client_1$1Z = require$$0$1;
AssignUsersActive.ASSIGN_USERS_ACTIVE = (0, client_1$1Z.gql)(templateObject_1$1t || (templateObject_1$1t = __makeTemplateObject$1t(["\n  mutation AssignUsersActive($input: AssignUsersActiveInput!) {\n    assignUsersActive(input: $input) {\n      users {\n        id\n        isActive\n      }\n    }\n  }\n"], ["\n  mutation AssignUsersActive($input: AssignUsersActiveInput!) {\n    assignUsersActive(input: $input) {\n      users {\n        id\n        isActive\n      }\n    }\n  }\n"])));
var templateObject_1$1t;

var BulkDeleteAuditQuestions = {};

var __makeTemplateObject$1s = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BulkDeleteAuditQuestions, "__esModule", { value: true });
BulkDeleteAuditQuestions.BULK_DELETE_AUDIT_QUESTIONS = void 0;
var client_1$1Y = require$$0$1;
BulkDeleteAuditQuestions.BULK_DELETE_AUDIT_QUESTIONS = (0, client_1$1Y.gql)(templateObject_1$1s || (templateObject_1$1s = __makeTemplateObject$1s(["\n  mutation BulkDeleteAuditQuestions($input: BulkDeleteInput!) {\n    bulkDeleteAuditQuestions(input: $input) {\n      deleted\n    }\n  }\n"], ["\n  mutation BulkDeleteAuditQuestions($input: BulkDeleteInput!) {\n    bulkDeleteAuditQuestions(input: $input) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$1s;

var CheckStoreMap = {};

var __makeTemplateObject$1r = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CheckStoreMap, "__esModule", { value: true });
CheckStoreMap.CHECK_STORE_MAP = void 0;
var client_1$1X = require$$0$1;
CheckStoreMap.CHECK_STORE_MAP = (0, client_1$1X.gql)(templateObject_1$1r || (templateObject_1$1r = __makeTemplateObject$1r(["\n  mutation CheckStoreMap($input: StoreMapInput!) {\n    checkStoreMap(input: $input) {\n      errors {\n        message\n        feature\n        level\n      }\n      warnings {\n        message\n        feature\n        level\n      }\n      passedCheck\n    }\n  }\n"], ["\n  mutation CheckStoreMap($input: StoreMapInput!) {\n    checkStoreMap(input: $input) {\n      errors {\n        message\n        feature\n        level\n      }\n      warnings {\n        message\n        feature\n        level\n      }\n      passedCheck\n    }\n  }\n"])));
var templateObject_1$1r;

var CreateAuditQuestionMutation = {};

var __makeTemplateObject$1q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateAuditQuestionMutation, "__esModule", { value: true });
CreateAuditQuestionMutation.CREATE_AUDIT_QUESTION = void 0;
var client_1$1W = require$$0$1;
var fragments_1$r = fragments$1;
CreateAuditQuestionMutation.CREATE_AUDIT_QUESTION = (0, client_1$1W.gql)(templateObject_1$1q || (templateObject_1$1q = __makeTemplateObject$1q(["\n  mutation CreateAuditQuestion($input: CreateAuditQuestionInput!) {\n    createAuditQuestion(input: $input) {\n      auditQuestion {\n        ...AuditQuestion\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateAuditQuestion($input: CreateAuditQuestionInput!) {\n    createAuditQuestion(input: $input) {\n      auditQuestion {\n        ...AuditQuestion\n      }\n    }\n  }\n  ", "\n"])), fragments_1$r.AUDIT_QUESTION_FRAGMENT);
var templateObject_1$1q;

var CreateBrand$1 = {};

var __makeTemplateObject$1p = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateBrand$1, "__esModule", { value: true });
CreateBrand$1.CREATE_BRAND = void 0;
var client_1$1V = require$$0$1;
CreateBrand$1.CREATE_BRAND = (0, client_1$1V.gql)(templateObject_1$1p || (templateObject_1$1p = __makeTemplateObject$1p(["\n  mutation CreateBrand($name: String!) {\n    createBrand(name: $name) {\n      brand {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  mutation CreateBrand($name: String!) {\n    createBrand(name: $name) {\n      brand {\n        id\n        name\n      }\n    }\n  }\n"])));
var templateObject_1$1p;

var CreateComplianceAudit = {};

var __makeTemplateObject$1o = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateComplianceAudit, "__esModule", { value: true });
CreateComplianceAudit.CREATE_COMPLIANCE_AUDIT = void 0;
var client_1$1U = require$$0$1;
var fragments_1$q = fragments$1;
CreateComplianceAudit.CREATE_COMPLIANCE_AUDIT = (0, client_1$1U.gql)(templateObject_1$1o || (templateObject_1$1o = __makeTemplateObject$1o(["\n  mutation CreateComplianceAudit($input: CreateComplianceAuditInput!) {\n    createComplianceAudit(input: $input) {\n      complianceAudit {\n        id\n        dateCompleted\n        strictScore\n        sequenceScore\n        employee {\n          ...User\n        }\n        saved\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateComplianceAudit($input: CreateComplianceAuditInput!) {\n    createComplianceAudit(input: $input) {\n      complianceAudit {\n        id\n        dateCompleted\n        strictScore\n        sequenceScore\n        employee {\n          ...User\n        }\n        saved\n      }\n    }\n  }\n  ", "\n"])), fragments_1$q.USER_FRAGMENT);
var templateObject_1$1o;

var CreateDrawMapTaskComment = {};

var __makeTemplateObject$1n = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateDrawMapTaskComment, "__esModule", { value: true });
CreateDrawMapTaskComment.CREATE_DRAW_MAP_TASK_COMMENT = void 0;
var client_1$1T = require$$0$1;
var DrawMapTaskFragment_1$4 = DrawMapTaskFragment;
CreateDrawMapTaskComment.CREATE_DRAW_MAP_TASK_COMMENT = (0, client_1$1T.gql)(templateObject_1$1n || (templateObject_1$1n = __makeTemplateObject$1n(["\n  mutation CreateMapDrawTaskComment($input: CreateMapDrawTaskCommentInput!) {\n    createMapDrawTaskComment(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateMapDrawTaskComment($input: CreateMapDrawTaskCommentInput!) {\n    createMapDrawTaskComment(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"])), DrawMapTaskFragment_1$4.DRAW_MAP_TASK_FRAGMENT);
var templateObject_1$1n;

var CreateIndoorMapDrawTask = {};

var __makeTemplateObject$1m = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateIndoorMapDrawTask, "__esModule", { value: true });
CreateIndoorMapDrawTask.CREATE_INDOOR_MAP_DRAW_TASK = void 0;
var client_1$1S = require$$0$1;
var DrawMapTaskFragment_1$3 = DrawMapTaskFragment;
CreateIndoorMapDrawTask.CREATE_INDOOR_MAP_DRAW_TASK = (0, client_1$1S.gql)(templateObject_1$1m || (templateObject_1$1m = __makeTemplateObject$1m(["\n  mutation CreateIndoorMapDrawTask($input: CreateIndoorMapDrawTaskInput!) {\n    createIndoorMapDrawTask(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateIndoorMapDrawTask($input: CreateIndoorMapDrawTaskInput!) {\n    createIndoorMapDrawTask(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"])), DrawMapTaskFragment_1$3.DRAW_MAP_TASK_FRAGMENT);
var templateObject_1$1m;

var CreateOrUpdateGeographicTerritory = {};

var __makeTemplateObject$1l = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateOrUpdateGeographicTerritory, "__esModule", { value: true });
CreateOrUpdateGeographicTerritory.CREATE_OR_UPDATE_ZONE_TERRITORY = void 0;
var client_1$1R = require$$0$1;
CreateOrUpdateGeographicTerritory.CREATE_OR_UPDATE_ZONE_TERRITORY = (0, client_1$1R.gql)(templateObject_1$1l || (templateObject_1$1l = __makeTemplateObject$1l(["\nmutation CreateOrUpdateZoneTerritory($input: CreateOrUpdateZoneTerritoryInput!) {\n  createOrUpdateZoneTerritory(input: $input) {\n    territory {\n      manager {\n        email\n      }\n      routes {\n        id\n        manager {\n          email\n        }\n        stores {\n          id\n        }\n      }\n    }\n  }\n}\n"], ["\nmutation CreateOrUpdateZoneTerritory($input: CreateOrUpdateZoneTerritoryInput!) {\n  createOrUpdateZoneTerritory(input: $input) {\n    territory {\n      manager {\n        email\n      }\n      routes {\n        id\n        manager {\n          email\n        }\n        stores {\n          id\n        }\n      }\n    }\n  }\n}\n"])));
var templateObject_1$1l;

var CreatePicOSPriority = {};

var __makeTemplateObject$1k = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreatePicOSPriority, "__esModule", { value: true });
CreatePicOSPriority.CREATE_PICOS_PRIORITY = void 0;
var client_1$1Q = require$$0$1;
CreatePicOSPriority.CREATE_PICOS_PRIORITY = (0, client_1$1Q.gql)(templateObject_1$1k || (templateObject_1$1k = __makeTemplateObject$1k(["\n\tmutation CreatePicosPriority($input: CreatePicOSPriorityInput!){\n\t\tcreatePicosPriority(input: $input){\n\t\t\tpicosPriority{\n\t\t\t\tid\n\t\t\t\tname\n\t\t\t\tpriority\n\t\t\t\tdateCreated\n\t\t\t\tstartDate\n\t\t\t\tendDate\n\t\t\t\tdescription\n\t\t\t\tmandateType\n\t\t\t\tstoreGroup{\n\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tcreator{\n\t\t\t\tfirstName\n\t\t\t\tlastName\n\t\t\t\tusername\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t} \n"], ["\n\tmutation CreatePicosPriority($input: CreatePicOSPriorityInput!){\n\t\tcreatePicosPriority(input: $input){\n\t\t\tpicosPriority{\n\t\t\t\tid\n\t\t\t\tname\n\t\t\t\tpriority\n\t\t\t\tdateCreated\n\t\t\t\tstartDate\n\t\t\t\tendDate\n\t\t\t\tdescription\n\t\t\t\tmandateType\n\t\t\t\tstoreGroup{\n\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tcreator{\n\t\t\t\tfirstName\n\t\t\t\tlastName\n\t\t\t\tusername\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t} \n"])));
var templateObject_1$1k;

var CreateProductFlavor = {};

var __makeTemplateObject$1j = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateProductFlavor, "__esModule", { value: true });
CreateProductFlavor.CREATE_PRODUCT_FLAVOR = void 0;
var client_1$1P = require$$0$1;
CreateProductFlavor.CREATE_PRODUCT_FLAVOR = (0, client_1$1P.gql)(templateObject_1$1j || (templateObject_1$1j = __makeTemplateObject$1j(["\n  mutation CreateFlavor($flavor: String!) {\n    createProductFlavor(flavor:$flavor) {\n      productFlavor {\n        id\n        flavor\n        displayFlavor\n      }\n    }\n  }\n"], ["\n  mutation CreateFlavor($flavor: String!) {\n    createProductFlavor(flavor:$flavor) {\n      productFlavor {\n        id\n        flavor\n        displayFlavor\n      }\n    }\n  }\n"])));
var templateObject_1$1j;

var CreateRegion = {};

var __makeTemplateObject$1i = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateRegion, "__esModule", { value: true });
CreateRegion.CREATE_REGION = void 0;
var client_1$1O = require$$0$1;
var fragments_1$p = fragments$1;
CreateRegion.CREATE_REGION = (0, client_1$1O.gql)(templateObject_1$1i || (templateObject_1$1i = __makeTemplateObject$1i(["\n  mutation CreateRegion($input: CreateRegionInput!) {\n    createRegion(input: $input) {\n      region {\n        ...StoreRegion\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateRegion($input: CreateRegionInput!) {\n    createRegion(input: $input) {\n      region {\n        ...StoreRegion\n      }\n    }\n  }\n  ", "\n"])), fragments_1$p.STORE_REGION_FRAGMENT);
var templateObject_1$1i;

var CreateStoreAudit = {};

var __makeTemplateObject$1h = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateStoreAudit, "__esModule", { value: true });
CreateStoreAudit.CREATE_STORE_AUDIT = void 0;
var client_1$1N = require$$0$1;
var fragments_1$o = fragments$1;
CreateStoreAudit.CREATE_STORE_AUDIT = (0, client_1$1N.gql)(templateObject_1$1h || (templateObject_1$1h = __makeTemplateObject$1h(["\n  mutation CreateStoreAudit($input: CreateStoreAuditInput!) {\n    createStoreAudit(input: $input) {\n      audit {\n        ...WholeAudit\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateStoreAudit($input: CreateStoreAuditInput!) {\n    createStoreAudit(input: $input) {\n      audit {\n        ...WholeAudit\n      }\n    }\n  }\n  ", "\n"])), fragments_1$o.WHOLE_AUDIT_FRAGMENT);
var templateObject_1$1h;

var CreateStoreGroup = {};

var __makeTemplateObject$1g = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateStoreGroup, "__esModule", { value: true });
CreateStoreGroup.CREATE_STORE_GROUP = void 0;
var client_1$1M = require$$0$1;
var fragments_1$n = fragments$1;
CreateStoreGroup.CREATE_STORE_GROUP = (0, client_1$1M.gql)(templateObject_1$1g || (templateObject_1$1g = __makeTemplateObject$1g(["\n  mutation StoreGroupName($input: CreateStoreGroupInput!) {\n    createStoreGroup(input: $input) {\n      storeGroup {\n        id\n        name\n        parentGroup {\n          name\n        }\n        groupType\n        storeList {\n          name\n        }\n        assignedTo {\n          ...User\n        }\n        region {\n          name\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation StoreGroupName($input: CreateStoreGroupInput!) {\n    createStoreGroup(input: $input) {\n      storeGroup {\n        id\n        name\n        parentGroup {\n          name\n        }\n        groupType\n        storeList {\n          name\n        }\n        assignedTo {\n          ...User\n        }\n        region {\n          name\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$n.USER_FRAGMENT);
var templateObject_1$1g;

var CreateStoreMap = {};

var __makeTemplateObject$1f = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateStoreMap, "__esModule", { value: true });
CreateStoreMap.CREATE_STORE_MAP = void 0;
var client_1$1L = require$$0$1;
var fragments_1$m = fragments$1;
CreateStoreMap.CREATE_STORE_MAP = (0, client_1$1L.gql)(templateObject_1$1f || (templateObject_1$1f = __makeTemplateObject$1f(["\n  mutation CreateStoreMap($input: StoreMapInput!) {\n    createStoreMap(input: $input) {\n      storeMap {\n        id\n        geoJson\n        store {\n          ...PhysicalStore\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateStoreMap($input: StoreMapInput!) {\n    createStoreMap(input: $input) {\n      storeMap {\n        id\n        geoJson\n        store {\n          ...PhysicalStore\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$m.PHYSICAL_STORE_FRAGMENT);
var templateObject_1$1f;

var CreateStoreTask = {};

var __makeTemplateObject$1e = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateStoreTask, "__esModule", { value: true });
CreateStoreTask.CREATE_OR_EDIT_STORE_TASK = void 0;
var client_1$1K = require$$0$1;
var fragments_1$l = fragments$1;
CreateStoreTask.CREATE_OR_EDIT_STORE_TASK = (0, client_1$1K.gql)(templateObject_1$1e || (templateObject_1$1e = __makeTemplateObject$1e(["\n  mutation CreateOrEditStoreTask($input: CreateOrEditTaskInput!) {\n    createOrEditTask(input: $input) {\n      task {\n        __typename\n        description\n        store {\n          name\n        }\n        createdBy {\n          email\n        }\n        progress {\n          status\n          user {\n            email\n          }\n        }\n        ... on DisplayTask {\n          ...Task\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateOrEditStoreTask($input: CreateOrEditTaskInput!) {\n    createOrEditTask(input: $input) {\n      task {\n        __typename\n        description\n        store {\n          name\n        }\n        createdBy {\n          email\n        }\n        progress {\n          status\n          user {\n            email\n          }\n        }\n        ... on DisplayTask {\n          ...Task\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$l.TASK_FRAGMENT);
var templateObject_1$1e;

var CreateTrainingMutation = {};

var __makeTemplateObject$1d = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateTrainingMutation, "__esModule", { value: true });
CreateTrainingMutation.CREATE_TRAINING = void 0;
var client_1$1J = require$$0$1;
var TrainingFragment_1 = TrainingFragment;
CreateTrainingMutation.CREATE_TRAINING = (0, client_1$1J.gql)(templateObject_1$1d || (templateObject_1$1d = __makeTemplateObject$1d(["\n  mutation CreateTraining($input: TrainingInput!) {\n    createTraining(input: $input) {\n      training {\n        ...Training\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateTraining($input: TrainingInput!) {\n    createTraining(input: $input) {\n      training {\n        ...Training\n      }\n    }\n  }\n  ", "\n"])), TrainingFragment_1.TRAINING_FRAGMENT);
var templateObject_1$1d;

var DeleteAuditMutation = {};

var __makeTemplateObject$1c = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteAuditMutation, "__esModule", { value: true });
DeleteAuditMutation.DELETE_AUDIT = void 0;
var client_1$1I = require$$0$1;
DeleteAuditMutation.DELETE_AUDIT = (0, client_1$1I.gql)(templateObject_1$1c || (templateObject_1$1c = __makeTemplateObject$1c(["\n  mutation DeleteAudit($auditId: ID!) {\n    deleteAudit(auditId: $auditId) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteAudit($auditId: ID!) {\n    deleteAudit(auditId: $auditId) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$1c;

var DeleteAudits = {};

var __makeTemplateObject$1b = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteAudits, "__esModule", { value: true });
DeleteAudits.DELETE_AUDITS = void 0;
var client_1$1H = require$$0$1;
DeleteAudits.DELETE_AUDITS = (0, client_1$1H.gql)(templateObject_1$1b || (templateObject_1$1b = __makeTemplateObject$1b(["\n  mutation AdminDeleteAudits($input: BulkDeleteInput!) {\n    deleteAudits(input: $input) {\n      deleted\n    }\n  }\n"], ["\n  mutation AdminDeleteAudits($input: BulkDeleteInput!) {\n    deleteAudits(input: $input) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$1b;

var DeleteDrawMapTaskComment = {};

var __makeTemplateObject$1a = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteDrawMapTaskComment, "__esModule", { value: true });
DeleteDrawMapTaskComment.DELETE_DRAW_MAP_TASK_COMMENT = void 0;
var client_1$1G = require$$0$1;
var DrawMapTaskFragment_1$2 = DrawMapTaskFragment;
DeleteDrawMapTaskComment.DELETE_DRAW_MAP_TASK_COMMENT = (0, client_1$1G.gql)(templateObject_1$1a || (templateObject_1$1a = __makeTemplateObject$1a(["\n  mutation DeleteMapDrawTaskComment($commentId: ID!) {\n    deleteMapDrawTaskComment(commentId: $commentId) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation DeleteMapDrawTaskComment($commentId: ID!) {\n    deleteMapDrawTaskComment(commentId: $commentId) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"])), DrawMapTaskFragment_1$2.DRAW_MAP_TASK_FRAGMENT);
var templateObject_1$1a;

var DeleteImage$1 = {};

var __makeTemplateObject$19 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteImage$1, "__esModule", { value: true });
DeleteImage$1.DELETE_IMAGE = void 0;
var client_1$1F = require$$0$1;
DeleteImage$1.DELETE_IMAGE = (0, client_1$1F.gql)(templateObject_1$19 || (templateObject_1$19 = __makeTemplateObject$19(["\n  mutation DeleteImage($imageId: ID!, $imageType: ImageType!) {\n    deleteImage(imageId: $imageId, imageType: $imageType) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteImage($imageId: ID!, $imageType: ImageType!) {\n    deleteImage(imageId: $imageId, imageType: $imageType) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$19;

var DeleteIndoorMapDrawTask = {};

var __makeTemplateObject$18 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteIndoorMapDrawTask, "__esModule", { value: true });
DeleteIndoorMapDrawTask.DELETE_INDOOR_MAP_DRAW_TASK = void 0;
var client_1$1E = require$$0$1;
DeleteIndoorMapDrawTask.DELETE_INDOOR_MAP_DRAW_TASK = (0, client_1$1E.gql)(templateObject_1$18 || (templateObject_1$18 = __makeTemplateObject$18(["\n  mutation DeleteIndoorMapDrawTask($taskId: ID!) {\n    deleteIndoorMapDrawTask(taskId: $taskId) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteIndoorMapDrawTask($taskId: ID!) {\n    deleteIndoorMapDrawTask(taskId: $taskId) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$18;

var DeleteRegion = {};

var __makeTemplateObject$17 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteRegion, "__esModule", { value: true });
DeleteRegion.DELETE_REGION = void 0;
var client_1$1D = require$$0$1;
DeleteRegion.DELETE_REGION = (0, client_1$1D.gql)(templateObject_1$17 || (templateObject_1$17 = __makeTemplateObject$17(["\n  mutation DeleteRegion($input: DeleteRegionInput!) {\n    deleteRegion(input: $input) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteRegion($input: DeleteRegionInput!) {\n    deleteRegion(input: $input) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$17;

var DeleteStoreTask = {};

var __makeTemplateObject$16 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteStoreTask, "__esModule", { value: true });
DeleteStoreTask.DELETE_STORE_TASK = void 0;
var client_1$1C = require$$0$1;
DeleteStoreTask.DELETE_STORE_TASK = (0, client_1$1C.gql)(templateObject_1$16 || (templateObject_1$16 = __makeTemplateObject$16(["\n    mutation DeleteStoreTask($taskId: ID!) {\n      deleteStoreTask(taskId: $taskId) {\n        deleted\n      }\n    }\n"], ["\n    mutation DeleteStoreTask($taskId: ID!) {\n      deleteStoreTask(taskId: $taskId) {\n        deleted\n      }\n    }\n"])));
var templateObject_1$16;

var DeleteTrainingPointCloud = {};

var __makeTemplateObject$15 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteTrainingPointCloud, "__esModule", { value: true });
DeleteTrainingPointCloud.DELETE_TRAINING_POINT_CLOUD = void 0;
var client_1$1B = require$$0$1;
DeleteTrainingPointCloud.DELETE_TRAINING_POINT_CLOUD = (0, client_1$1B.gql)(templateObject_1$15 || (templateObject_1$15 = __makeTemplateObject$15(["\n  mutation DeleteTrainingPointCloud($pointCloudId: ID!) {\n    deleteTrainingPointCloud(pointCloudId: $pointCloudId) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteTrainingPointCloud($pointCloudId: ID!) {\n    deleteTrainingPointCloud(pointCloudId: $pointCloudId) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$15;

var DeleteTrainingMutation = {};

var __makeTemplateObject$14 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteTrainingMutation, "__esModule", { value: true });
DeleteTrainingMutation.DELETE_TRAINING = void 0;
var client_1$1A = require$$0$1;
DeleteTrainingMutation.DELETE_TRAINING = (0, client_1$1A.gql)(templateObject_1$14 || (templateObject_1$14 = __makeTemplateObject$14(["\n  mutation DeleteTraining($input: ID!) {\n    deleteTraining(trainingId: $input) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteTraining($input: ID!) {\n    deleteTraining(trainingId: $input) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$14;

var FlagObjects = {};

var __makeTemplateObject$13 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(FlagObjects, "__esModule", { value: true });
FlagObjects.FLAG_OBJECT = void 0;
var client_1$1z = require$$0$1;
var fragments_1$k = fragments$1;
FlagObjects.FLAG_OBJECT = (0, client_1$1z.gql)(templateObject_1$13 || (templateObject_1$13 = __makeTemplateObject$13(["\n  mutation FlagObject($input: FlagObjectInput!) {\n    flagObject(input: $input) {\n      object {\n        ...FlaggableObject\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation FlagObject($input: FlagObjectInput!) {\n    flagObject(input: $input) {\n      object {\n        ...FlaggableObject\n      }\n    }\n  }\n  ", "\n"])), fragments_1$k.FLAGGABLE_OBJECT_FRAGMENT);
var templateObject_1$13;

var ReportIssue = {};

var __makeTemplateObject$12 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ReportIssue, "__esModule", { value: true });
ReportIssue.REPORT_ISSUE = void 0;
var client_1$1y = require$$0$1;
var fragments_1$j = fragments$1;
ReportIssue.REPORT_ISSUE = (0, client_1$1y.gql)(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject$12(["\n  mutation ReportIssue($input: ReportIssueInput!) {\n    reportIssue(input: $input) {\n      issue {\n        ...ReportedIssue\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation ReportIssue($input: ReportIssueInput!) {\n    reportIssue(input: $input) {\n      issue {\n        ...ReportedIssue\n      }\n    }\n  }\n  ", "\n"])), fragments_1$j.REPORTED_ISSUE_FRAGMENT);
var templateObject_1$12;

var ReportProductMarketingImage = {};

var __makeTemplateObject$11 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ReportProductMarketingImage, "__esModule", { value: true });
ReportProductMarketingImage.REPORT_PRODUCT_MARKETING_IMAGE = void 0;
var client_1$1x = require$$0$1;
ReportProductMarketingImage.REPORT_PRODUCT_MARKETING_IMAGE = (0, client_1$1x.gql)(templateObject_1$11 || (templateObject_1$11 = __makeTemplateObject$11(["\n  mutation ReportProductMarketingImage($imageId: ID!) {\n    reportProductMarketingImage(imageId: $imageId) {\n      image {\n        id\n        url\n        isBadImage\n     }\n    }\n  }\n"], ["\n  mutation ReportProductMarketingImage($imageId: ID!) {\n    reportProductMarketingImage(imageId: $imageId) {\n      image {\n        id\n        url\n        isBadImage\n     }\n    }\n  }\n"])));
var templateObject_1$11;

var ResumeOptimizations = {};

var __makeTemplateObject$10 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ResumeOptimizations, "__esModule", { value: true });
ResumeOptimizations.RESUME_OPTIMIZATIONS = void 0;
var client_1$1w = require$$0$1;
ResumeOptimizations.RESUME_OPTIMIZATIONS = (0, client_1$1w.gql)(templateObject_1$10 || (templateObject_1$10 = __makeTemplateObject$10(["\n  mutation ResumeOptimizations($input: OptimizationsInput!) {\n    resumeOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n    }\n  }\n"], ["\n  mutation ResumeOptimizations($input: OptimizationsInput!) {\n    resumeOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n    }\n  }\n"])));
var templateObject_1$10;

var SetDisplaysToBeObserved = {};

var __makeTemplateObject$$ = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SetDisplaysToBeObserved, "__esModule", { value: true });
SetDisplaysToBeObserved.SET_DISPLAYS_TO_OBSERVE = void 0;
var client_1$1v = require$$0$1;
var fragments_1$i = fragments$1;
SetDisplaysToBeObserved.SET_DISPLAYS_TO_OBSERVE = (0, client_1$1v.gql)(templateObject_1$$ || (templateObject_1$$ = __makeTemplateObject$$(["\n  mutation SetDisplaysToObserve($input: SetDisplaysToObserveInput!) {\n    setDisplaysToObserve(input: $input) {\n      displays {\n        ...Display\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation SetDisplaysToObserve($input: SetDisplaysToObserveInput!) {\n    setDisplaysToObserve(input: $input) {\n      displays {\n        ...Display\n      }\n    }\n  }\n  ", "\n"])), fragments_1$i.DISPLAY_FRAGMENT);
var templateObject_1$$;

var SoftDeleteDisplayMutation = {};

var __makeTemplateObject$_ = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SoftDeleteDisplayMutation, "__esModule", { value: true });
SoftDeleteDisplayMutation.SOFT_DELETE_DISPLAY = void 0;
var client_1$1u = require$$0$1;
var DisplayFragment_1 = DisplayFragment;
SoftDeleteDisplayMutation.SOFT_DELETE_DISPLAY = (0, client_1$1u.gql)(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject$_(["\n  mutation SoftDeleteDisplay($input: SoftDeleteDisplayInput!) {\n    softDeleteDisplay(input: $input) {\n      display {\n        ...Display\n      }\n      deletedDisplayAuditId\n    }\n  }\n  ", "\n"], ["\n  mutation SoftDeleteDisplay($input: SoftDeleteDisplayInput!) {\n    softDeleteDisplay(input: $input) {\n      display {\n        ...Display\n      }\n      deletedDisplayAuditId\n    }\n  }\n  ", "\n"])), DisplayFragment_1.DISPLAY_FRAGMENT);
var templateObject_1$_;

var RecordInventoryTransaction = {};

var __makeTemplateObject$Z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(RecordInventoryTransaction, "__esModule", { value: true });
RecordInventoryTransaction.RECORD_INVENTORY_TRANSACTIONS = void 0;
var client_1$1t = require$$0$1;
var fragments_1$h = fragments$1;
RecordInventoryTransaction.RECORD_INVENTORY_TRANSACTIONS = (0, client_1$1t.gql)(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject$Z(["\n  mutation RecordInventoryTransactions(\n    $input: RecordInventoryTransactionsInput!\n  ) {\n    recordInventoryTransactions(input: $input) {\n      newDisplayInventory {\n        ...SimpleInventory\n      }\n      newStoreInventory {\n        ...SimpleInventory\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation RecordInventoryTransactions(\n    $input: RecordInventoryTransactionsInput!\n  ) {\n    recordInventoryTransactions(input: $input) {\n      newDisplayInventory {\n        ...SimpleInventory\n      }\n      newStoreInventory {\n        ...SimpleInventory\n      }\n    }\n  }\n  ", "\n"])), fragments_1$h.SIMPLE_INVENTORY_FRAGMENT);
var templateObject_1$Z;

var StopOptimizations = {};

var __makeTemplateObject$Y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(StopOptimizations, "__esModule", { value: true });
StopOptimizations.STOP_OPTIMIZATIONS = void 0;
var client_1$1s = require$$0$1;
StopOptimizations.STOP_OPTIMIZATIONS = (0, client_1$1s.gql)(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject$Y(["\n  mutation StopOptimizations($input: OptimizationsInput!) {\n    stopOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n      optimizingPausedAt\n    }\n  }\n"], ["\n  mutation StopOptimizations($input: OptimizationsInput!) {\n    stopOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n      optimizingPausedAt\n    }\n  }\n"])));
var templateObject_1$Y;

var UpdateAuditQuestionsMutation = {};

var __makeTemplateObject$X = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateAuditQuestionsMutation, "__esModule", { value: true });
UpdateAuditQuestionsMutation.UPDATE_AUDIT_QUESTIONS = void 0;
var client_1$1r = require$$0$1;
var fragments_1$g = fragments$1;
UpdateAuditQuestionsMutation.UPDATE_AUDIT_QUESTIONS = (0, client_1$1r.gql)(templateObject_1$X || (templateObject_1$X = __makeTemplateObject$X(["\n  mutation UpdateAuditQuestions($input: UpdateAuditQuestionsInput!) {\n    updateAuditQuestions(input: $input) {\n      auditQuestions {\n        ...AuditQuestion\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateAuditQuestions($input: UpdateAuditQuestionsInput!) {\n    updateAuditQuestions(input: $input) {\n      auditQuestions {\n        ...AuditQuestion\n      }\n    }\n  }\n  ", "\n"])), fragments_1$g.AUDIT_QUESTION_FRAGMENT);
var templateObject_1$X;

var UpdateCompanyStore = {};

var __makeTemplateObject$W = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateCompanyStore, "__esModule", { value: true });
UpdateCompanyStore.UPDATE_COMPANY_STORE = void 0;
var client_1$1q = require$$0$1;
var MinimalStoreFragment_1$1 = MinimalStoreFragment;
UpdateCompanyStore.UPDATE_COMPANY_STORE = (0, client_1$1q.gql)(templateObject_1$W || (templateObject_1$W = __makeTemplateObject$W(["\n  mutation UpdateCompanyStore($input: UpdateCompanyStoreInput!) {\n    updateCompanyStore(input: $input) {\n      store {\n        ...Store\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateCompanyStore($input: UpdateCompanyStoreInput!) {\n    updateCompanyStore(input: $input) {\n      store {\n        ...Store\n      }\n    }\n  }\n  ", "\n"])), MinimalStoreFragment_1$1.MINIMAL_STORE_FRAGMENT);
var templateObject_1$W;

var UpdateDisplayMutation = {};

var __makeTemplateObject$V = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateDisplayMutation, "__esModule", { value: true });
UpdateDisplayMutation.UPDATE_DISPLAY = void 0;
var client_1$1p = require$$0$1;
var WholeDisplayFragment_1 = WholeDisplayFragment;
UpdateDisplayMutation.UPDATE_DISPLAY = (0, client_1$1p.gql)(templateObject_1$V || (templateObject_1$V = __makeTemplateObject$V(["\n  mutation UpdateDisplay($input: UpdateDisplayInput!) {\n    updateDisplay(input: $input) {\n      display {\n        ...WholeDisplay\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateDisplay($input: UpdateDisplayInput!) {\n    updateDisplay(input: $input) {\n      display {\n        ...WholeDisplay\n      }\n    }\n  }\n  ", "\n"])), WholeDisplayFragment_1.WHOLE_DISPLAY_FRAGMENT);
var templateObject_1$V;

var UpdateDrawMapTaskComment = {};

var __makeTemplateObject$U = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateDrawMapTaskComment, "__esModule", { value: true });
UpdateDrawMapTaskComment.UPDATE_DRAW_MAP_TASK_COMMENT = void 0;
var client_1$1o = require$$0$1;
var DrawMapTaskFragment_1$1 = DrawMapTaskFragment;
UpdateDrawMapTaskComment.UPDATE_DRAW_MAP_TASK_COMMENT = (0, client_1$1o.gql)(templateObject_1$U || (templateObject_1$U = __makeTemplateObject$U(["\n  mutation UpdateMapDrawTaskComment($input: UpdateMapDrawTaskCommentInput!) {\n    updateMapDrawTaskComment(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateMapDrawTaskComment($input: UpdateMapDrawTaskCommentInput!) {\n    updateMapDrawTaskComment(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"])), DrawMapTaskFragment_1$1.DRAW_MAP_TASK_FRAGMENT);
var templateObject_1$U;

var UpdateFlaggedReason = {};

var __makeTemplateObject$T = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateFlaggedReason, "__esModule", { value: true });
UpdateFlaggedReason.UPDATE_FLAGGED_REASON = void 0;
var client_1$1n = require$$0$1;
UpdateFlaggedReason.UPDATE_FLAGGED_REASON = (0, client_1$1n.gql)(templateObject_1$T || (templateObject_1$T = __makeTemplateObject$T(["\n    mutation UpdateFlaggedReason($input: UpdateFlaggedReasonInput!) {\n        updateFlaggedReason(input: $input) {\t\n            object {\n                id\n                reason\n                resolved\n            }\n        }\n  }\n"], ["\n    mutation UpdateFlaggedReason($input: UpdateFlaggedReasonInput!) {\n        updateFlaggedReason(input: $input) {\t\n            object {\n                id\n                reason\n                resolved\n            }\n        }\n  }\n"])));
var templateObject_1$T;

var UpdateGlobalOptimizationSchedule = {};

var __makeTemplateObject$S = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateGlobalOptimizationSchedule, "__esModule", { value: true });
UpdateGlobalOptimizationSchedule.UPDATE_GLOBAL_OPTIMIZATION_CADENCE = void 0;
var client_1$1m = require$$0$1;
UpdateGlobalOptimizationSchedule.UPDATE_GLOBAL_OPTIMIZATION_CADENCE = (0, client_1$1m.gql)(templateObject_1$S || (templateObject_1$S = __makeTemplateObject$S(["\n  mutation UpdateGlobalOptimizationSchedule(\n    $input: GlobalUpdateOpitimizationCadenceInput!\n  ) {\n    globalUpdateOptimizingCadence(input: $input) {\n      success\n      numTimesOptimizeHighPerYear\n      numTimesOptimizeMediumPerYear\n      numTimesOptimizeLowPerYear\n      timesPerWeekTwoDScan\n    }\n  }\n"], ["\n  mutation UpdateGlobalOptimizationSchedule(\n    $input: GlobalUpdateOpitimizationCadenceInput!\n  ) {\n    globalUpdateOptimizingCadence(input: $input) {\n      success\n      numTimesOptimizeHighPerYear\n      numTimesOptimizeMediumPerYear\n      numTimesOptimizeLowPerYear\n      timesPerWeekTwoDScan\n    }\n  }\n"])));
var templateObject_1$S;

var UpdateIndoorMapDrawTask = {};

var __makeTemplateObject$R = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateIndoorMapDrawTask, "__esModule", { value: true });
UpdateIndoorMapDrawTask.UPDATE_INDOOR_MAP_DRAW_TASK = void 0;
var client_1$1l = require$$0$1;
var DrawMapTaskFragment_1 = DrawMapTaskFragment;
UpdateIndoorMapDrawTask.UPDATE_INDOOR_MAP_DRAW_TASK = (0, client_1$1l.gql)(templateObject_1$R || (templateObject_1$R = __makeTemplateObject$R(["\n  mutation UpdateIndoorMapDrawTask($input: UpdateIndoorMapDrawTaskInput!) {\n    updateIndoorMapDrawTask(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateIndoorMapDrawTask($input: UpdateIndoorMapDrawTaskInput!) {\n    updateIndoorMapDrawTask(input: $input) {\n      indoorMapDrawTask {\n        ...DrawMapTask\n      }\n    }\n  }\n  ", "\n"])), DrawMapTaskFragment_1.DRAW_MAP_TASK_FRAGMENT);
var templateObject_1$R;

var UpdateInventoryItem = {};

var __makeTemplateObject$Q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateInventoryItem, "__esModule", { value: true });
UpdateInventoryItem.UPDATE_INVENTORY_ITEM = void 0;
var client_1$1k = require$$0$1;
UpdateInventoryItem.UPDATE_INVENTORY_ITEM = (0, client_1$1k.gql)(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject$Q(["\n  mutation UpdateInventoryItem($input: UpdateInventoryItemInput!) {\n    updateInventoryItem(input: $input) {\n      inventoryItem {\n        id\n        quantity\n      }\n    }\n  }\n"], ["\n  mutation UpdateInventoryItem($input: UpdateInventoryItemInput!) {\n    updateInventoryItem(input: $input) {\n      inventoryItem {\n        id\n        quantity\n      }\n    }\n  }\n"])));
var templateObject_1$Q;

var UpdateOptimizationSchedule = {};

var __makeTemplateObject$P = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateOptimizationSchedule, "__esModule", { value: true });
UpdateOptimizationSchedule.UPDATE_OPTIMIZATION_SCHEDULE = void 0;
var client_1$1j = require$$0$1;
UpdateOptimizationSchedule.UPDATE_OPTIMIZATION_SCHEDULE = (0, client_1$1j.gql)(templateObject_1$P || (templateObject_1$P = __makeTemplateObject$P(["\n  mutation UpdateOptimizationSchedule(\n    $input: UpdateOpitimizationCadenceInput!\n  ) {\n    updateOptimizingCadenceInCompanyStores(input: $input) {\n      success\n      storeIds\n      numTimesOptimizeHighPerYear\n      numTimesOptimizeMediumPerYear\n      numTimesOptimizeLowPerYear\n      timesPerWeekTwoDScan\n    }\n  }\n"], ["\n  mutation UpdateOptimizationSchedule(\n    $input: UpdateOpitimizationCadenceInput!\n  ) {\n    updateOptimizingCadenceInCompanyStores(input: $input) {\n      success\n      storeIds\n      numTimesOptimizeHighPerYear\n      numTimesOptimizeMediumPerYear\n      numTimesOptimizeLowPerYear\n      timesPerWeekTwoDScan\n    }\n  }\n"])));
var templateObject_1$P;

var UpdatePicOSPriority = {};

var __makeTemplateObject$O = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdatePicOSPriority, "__esModule", { value: true });
UpdatePicOSPriority.UPDATE_PICOS_PRIORITY = void 0;
var client_1$1i = require$$0$1;
var fragments_1$f = fragments$1;
UpdatePicOSPriority.UPDATE_PICOS_PRIORITY = (0, client_1$1i.gql)(templateObject_1$O || (templateObject_1$O = __makeTemplateObject$O(["\n  mutation UpdatePicOSPriority($input: UpdatePicOSPriorityInput!) {\n    updatePicosPriority(input: $input) {\n      picosPriority {\n        id\n        name\n        priority\n        dateCreated\n        startDate\n        endDate\n        description\n        mandateType\n        displayElements\n        displayTypes {\n          name\n        }\n        displayLocation {\n          name\n        }\n        swirePosElementRequired\n        otherCategoriesAllowed\n        otherBrandsAllowed\n        otherPackagingAllowed\n        otherProductsAllowed\n        storeGroup {\n          name\n        }\n        creator {\n          ...User\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdatePicOSPriority($input: UpdatePicOSPriorityInput!) {\n    updatePicosPriority(input: $input) {\n      picosPriority {\n        id\n        name\n        priority\n        dateCreated\n        startDate\n        endDate\n        description\n        mandateType\n        displayElements\n        displayTypes {\n          name\n        }\n        displayLocation {\n          name\n        }\n        swirePosElementRequired\n        otherCategoriesAllowed\n        otherBrandsAllowed\n        otherPackagingAllowed\n        otherProductsAllowed\n        storeGroup {\n          name\n        }\n        creator {\n          ...User\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$f.USER_FRAGMENT);
var templateObject_1$O;

var UpdateProduct$1 = {};

var __makeTemplateObject$N = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateProduct$1, "__esModule", { value: true });
UpdateProduct$1.UPDATE_PRODUCT = void 0;
var client_1$1h = require$$0$1;
var fragments_1$e = fragments$1;
UpdateProduct$1.UPDATE_PRODUCT = (0, client_1$1h.gql)(templateObject_1$N || (templateObject_1$N = __makeTemplateObject$N(["\n  mutation UpdateProduct($input: UpdateProductInput!) {\n    updateProduct(input: $input) {\n      product {\n        ...Product\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateProduct($input: UpdateProductInput!) {\n    updateProduct(input: $input) {\n      product {\n        ...Product\n      }\n    }\n  }\n  ", "\n"])), fragments_1$e.PRODUCT_FRAGMENT);
var templateObject_1$N;

var UpdateStoreGroup = {};

var __makeTemplateObject$M = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateStoreGroup, "__esModule", { value: true });
UpdateStoreGroup.UPDATE_STORE_GROUP = void 0;
var client_1$1g = require$$0$1;
var fragments_1$d = fragments$1;
UpdateStoreGroup.UPDATE_STORE_GROUP = (0, client_1$1g.gql)(templateObject_1$M || (templateObject_1$M = __makeTemplateObject$M(["\n  mutation UpdateStoreGroupName($input: UpdateStoreGroupInput!) {\n    updateStoreGroup(input: $input) {\n      storeGroup {\n        id\n        name\n        parentGroup {\n          name\n        }\n        groupType\n        storeList {\n          name\n        }\n        assignedTo {\n          ...User\n        }\n        region {\n          name\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateStoreGroupName($input: UpdateStoreGroupInput!) {\n    updateStoreGroup(input: $input) {\n      storeGroup {\n        id\n        name\n        parentGroup {\n          name\n        }\n        groupType\n        storeList {\n          name\n        }\n        assignedTo {\n          ...User\n        }\n        region {\n          name\n        }\n      }\n    }\n  }\n  ", "\n"])), fragments_1$d.USER_FRAGMENT);
var templateObject_1$M;

var UpdateStoreImage = {};

var __makeTemplateObject$L = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateStoreImage, "__esModule", { value: true });
UpdateStoreImage.UPDATE_STORE_IMAGE = void 0;
var client_1$1f = require$$0$1;
var MinimalStoreFragment_1 = MinimalStoreFragment;
UpdateStoreImage.UPDATE_STORE_IMAGE = (0, client_1$1f.gql)(templateObject_1$L || (templateObject_1$L = __makeTemplateObject$L(["\n  mutation UpdateStoreImage($input: UpdateStoreImageInput!) {\n    updateStoreImage(input: $input) {\n      store {\n        ...Store\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateStoreImage($input: UpdateStoreImageInput!) {\n    updateStoreImage(input: $input) {\n      store {\n        ...Store\n      }\n    }\n  }\n  ", "\n"])), MinimalStoreFragment_1.MINIMAL_STORE_FRAGMENT);
var templateObject_1$L;

var UpdateTrainingMutation = {};

var __makeTemplateObject$K = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateTrainingMutation, "__esModule", { value: true });
UpdateTrainingMutation.UPDATE_TRAINING = void 0;
var client_1$1e = require$$0$1;
UpdateTrainingMutation.UPDATE_TRAINING = (0, client_1$1e.gql)(templateObject_1$K || (templateObject_1$K = __makeTemplateObject$K(["\n  mutation UpdateTraining($input: UpdateTrainingInput!) {\n    updateTraining(input: $input) {\n      training {\n        title\n        description\n        id\n        timeRequired\n        groups {\n          id\n          name\n        }\n        deviceType\n        trainingImage {\n          id\n          url\n          bucketFileName\n        }\n      }\n    }\n  }\n"], ["\n  mutation UpdateTraining($input: UpdateTrainingInput!) {\n    updateTraining(input: $input) {\n      training {\n        title\n        description\n        id\n        timeRequired\n        groups {\n          id\n          name\n        }\n        deviceType\n        trainingImage {\n          id\n          url\n          bucketFileName\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$K;

var UpdateTrainingPointCloud = {};

var __makeTemplateObject$J = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateTrainingPointCloud, "__esModule", { value: true });
UpdateTrainingPointCloud.UPDATE_TRAINING_POINT_CLOUD = void 0;
var client_1$1d = require$$0$1;
var TrainingPointCloud_1 = TrainingPointCloud;
UpdateTrainingPointCloud.UPDATE_TRAINING_POINT_CLOUD = (0, client_1$1d.gql)(templateObject_1$J || (templateObject_1$J = __makeTemplateObject$J(["\n  mutation UpdateTrainingPointCloud($input: UpdateTrainingPointCloudInput!) {\n    updateTrainingPointCloud(input: $input) {\n      pointCloud {\n        ...TrainingPointCloud\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateTrainingPointCloud($input: UpdateTrainingPointCloudInput!) {\n    updateTrainingPointCloud(input: $input) {\n      pointCloud {\n        ...TrainingPointCloud\n      }\n    }\n  }\n  ", "\n"])), TrainingPointCloud_1.TRAINING_POINT_CLOUD_FRAGMENT);
var templateObject_1$J;

var UpdateUser = {};

var __makeTemplateObject$I = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateUser, "__esModule", { value: true });
UpdateUser.UPDATE_USER = void 0;
var client_1$1c = require$$0$1;
var fragments_1$c = fragments$1;
UpdateUser.UPDATE_USER = (0, client_1$1c.gql)(templateObject_1$I || (templateObject_1$I = __makeTemplateObject$I(["\n  mutation UpdateUser($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      user {\n        ...User\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateUser($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      user {\n        ...User\n      }\n    }\n  }\n  ", "\n"])), fragments_1$c.USER_FRAGMENT);
var templateObject_1$I;

var PauseOptimizations = {};

var __makeTemplateObject$H = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PauseOptimizations, "__esModule", { value: true });
PauseOptimizations.PAUSE_OPTIMIZATIONS = void 0;
var client_1$1b = require$$0$1;
PauseOptimizations.PAUSE_OPTIMIZATIONS = (0, client_1$1b.gql)(templateObject_1$H || (templateObject_1$H = __makeTemplateObject$H(["\n  mutation PauseOptimizations($input: PauseOptimizationsInput!) {\n    pauseOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n      optimizingPausedAt\n      resumeOptimizingAt\n    }\n  }\n"], ["\n  mutation PauseOptimizations($input: PauseOptimizationsInput!) {\n    pauseOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n      optimizingPausedAt\n      resumeOptimizingAt\n    }\n  }\n"])));
var templateObject_1$H;

var MerchandiseDisplay = {};

var __makeTemplateObject$G = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(MerchandiseDisplay, "__esModule", { value: true });
MerchandiseDisplay.MERCHANDISE_DISPLAY = void 0;
var client_1$1a = require$$0$1;
MerchandiseDisplay.MERCHANDISE_DISPLAY = (0, client_1$1a.gql)(templateObject_1$G || (templateObject_1$G = __makeTemplateObject$G(["\n  mutation MerchandiseDisplay($input: MerchandiseDisplayInput!) {\n      merchandiseDisplay(input: $input) {\n          success\n      }\n  }\n"], ["\n  mutation MerchandiseDisplay($input: MerchandiseDisplayInput!) {\n      merchandiseDisplay(input: $input) {\n          success\n      }\n  }\n"])));
var templateObject_1$G;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(AddDisplayAuditPointCloud, exports);
__exportStar(AddDisplayMutation, exports);
__exportStar(AddDisplaySceneTest, exports);
__exportStar(AddImage, exports);
__exportStar(AddImageSimpleReturn, exports);
__exportStar(AddPOSScansMutation, exports);
__exportStar(AddProductMutation, exports);
__exportStar(AddTrainingPointCloud, exports);
__exportStar(AddUser, exports);
__exportStar(AppUpdateCompanyStore, exports);
__exportStar(AssignDrawMapTask, exports);
__exportStar(AssignSupervisor, exports);
__exportStar(AssignUsersActive, exports);
__exportStar(BulkDeleteAuditQuestions, exports);
__exportStar(CheckStoreMap, exports);
__exportStar(CreateAuditQuestionMutation, exports);
__exportStar(CreateBrand$1, exports);
__exportStar(CreateComplianceAudit, exports);
__exportStar(CreateDrawMapTaskComment, exports);
__exportStar(CreateIndoorMapDrawTask, exports);
__exportStar(CreateOrUpdateGeographicTerritory, exports);
__exportStar(CreatePicOSPriority, exports);
__exportStar(CreateProductFlavor, exports);
__exportStar(CreateRegion, exports);
__exportStar(CreateStoreAudit, exports);
__exportStar(CreateStoreGroup, exports);
__exportStar(CreateStoreMap, exports);
__exportStar(CreateStoreTask, exports);
__exportStar(CreateTrainingMutation, exports);
__exportStar(DeleteAuditMutation, exports);
__exportStar(DeleteAudits, exports);
__exportStar(DeleteDrawMapTaskComment, exports);
__exportStar(DeleteImage$1, exports);
__exportStar(DeleteIndoorMapDrawTask, exports);
__exportStar(DeleteRegion, exports);
__exportStar(DeleteStoreTask, exports);
__exportStar(DeleteTrainingPointCloud, exports);
__exportStar(DeleteTrainingMutation, exports);
__exportStar(FlagObjects, exports);
__exportStar(ReportIssue, exports);
__exportStar(ReportProductMarketingImage, exports);
__exportStar(ResumeOptimizations, exports);
__exportStar(SetDisplaysToBeObserved, exports);
__exportStar(SoftDeleteDisplayMutation, exports);
__exportStar(RecordInventoryTransaction, exports);
__exportStar(StopOptimizations, exports);
__exportStar(UpdateAuditQuestionsMutation, exports);
__exportStar(UpdateCompanyStore, exports);
__exportStar(UpdateDisplayMutation, exports);
__exportStar(UpdateDrawMapTaskComment, exports);
__exportStar(UpdateFlaggedReason, exports);
__exportStar(UpdateGlobalOptimizationSchedule, exports);
__exportStar(UpdateIndoorMapDrawTask, exports);
__exportStar(UpdateInventoryItem, exports);
__exportStar(UpdateOptimizationSchedule, exports);
__exportStar(UpdatePicOSPriority, exports);
__exportStar(UpdateProduct$1, exports);
__exportStar(UpdateStoreGroup, exports);
__exportStar(UpdateStoreImage, exports);
__exportStar(UpdateTrainingMutation, exports);
__exportStar(UpdateTrainingPointCloud, exports);
__exportStar(UpdateUser, exports);
__exportStar(PauseOptimizations, exports);
__exportStar(MerchandiseDisplay, exports);
}(mutations$2));

var fragments = {};

var CategoryFragment = {};

var __makeTemplateObject$F = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CategoryFragment, "__esModule", { value: true });
CategoryFragment.CATEGORY_FRAGMENT = void 0;
var client_1$19 = require$$0$1;
CategoryFragment.CATEGORY_FRAGMENT = (0, client_1$19.gql)(templateObject_1$F || (templateObject_1$F = __makeTemplateObject$F(["\n  fragment Category on Category {\n    id\n    name\n    parent {\n      id\n      name\n    }\n  }\n"], ["\n  fragment Category on Category {\n    id\n    name\n    parent {\n      id\n      name\n    }\n  }\n"])));
var templateObject_1$F;

var BrandFragment = {};

var __makeTemplateObject$E = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(BrandFragment, "__esModule", { value: true });
BrandFragment.SABRE_BRAND_FRAGMENT = void 0;
var client_1$18 = require$$0$1;
BrandFragment.SABRE_BRAND_FRAGMENT = (0, client_1$18.gql)(templateObject_1$E || (templateObject_1$E = __makeTemplateObject$E(["\n  fragment Brand on Brand {\n    id\n    name\n    category {\n      id\n      name\n    }\n    parent {\n      id\n      name\n    }\n  }\n"], ["\n  fragment Brand on Brand {\n    id\n    name\n    category {\n      id\n      name\n    }\n    parent {\n      id\n      name\n    }\n  }\n"])));
var templateObject_1$E;

var FlavorFragment = {};

var __makeTemplateObject$D = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(FlavorFragment, "__esModule", { value: true });
FlavorFragment.SABRE_FLAVOR_FRAGMENT = void 0;
var client_1$17 = require$$0$1;
FlavorFragment.SABRE_FLAVOR_FRAGMENT = (0, client_1$17.gql)(templateObject_1$D || (templateObject_1$D = __makeTemplateObject$D(["\n  fragment Flavor on Flavor {\n    id\n    name\n    displayFlavor\n  }\n"], ["\n  fragment Flavor on Flavor {\n    id\n    name\n    displayFlavor\n  }\n"])));
var templateObject_1$D;

var DraftProductFragment = {};

var ImageFragment = {};

var __makeTemplateObject$C = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ImageFragment, "__esModule", { value: true });
ImageFragment.IMAGE_FRAGMENT = void 0;
var client_1$16 = require$$0$1;
ImageFragment.IMAGE_FRAGMENT = (0, client_1$16.gql)(templateObject_1$C || (templateObject_1$C = __makeTemplateObject$C(["\n  fragment Image on Image {\n    id\n    url\n    created\n    modified\n    type\n    width\n    height\n    orientation\n    isThumbnail\n    isPrimary\n    uploadedToGcsOn\n    bucketFileName\n    saved\n  }\n"], ["\n  fragment Image on Image {\n    id\n    url\n    created\n    modified\n    type\n    width\n    height\n    orientation\n    isThumbnail\n    isPrimary\n    uploadedToGcsOn\n    bucketFileName\n    saved\n  }\n"])));
var templateObject_1$C;

var ManufacturerFragment = {};

var __makeTemplateObject$B = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ManufacturerFragment, "__esModule", { value: true });
ManufacturerFragment.SABRE_MANUFACTURER_FRAGMENT = void 0;
var client_1$15 = require$$0$1;
ManufacturerFragment.SABRE_MANUFACTURER_FRAGMENT = (0, client_1$15.gql)(templateObject_1$B || (templateObject_1$B = __makeTemplateObject$B(["\n  fragment Manufacturer on Manufacturer {\n    id\n    name\n  }\n"], ["\n  fragment Manufacturer on Manufacturer {\n    id\n    name\n  }\n"])));
var templateObject_1$B;

var PackagingFragment = {};

var __makeTemplateObject$A = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PackagingFragment, "__esModule", { value: true });
PackagingFragment.SABRE_PACKAGING_FRAGMENT = void 0;
var client_1$14 = require$$0$1;
PackagingFragment.SABRE_PACKAGING_FRAGMENT = (0, client_1$14.gql)(templateObject_1$A || (templateObject_1$A = __makeTemplateObject$A(["\n  fragment Packaging on Packaging {\n    id\n    size\n    unit\n    quantity\n    container\n  }\n"], ["\n  fragment Packaging on Packaging {\n    id\n    size\n    unit\n    quantity\n    container\n  }\n"])));
var templateObject_1$A;

var ProductFragment = {};

var ShippingFragment = {};

var __makeTemplateObject$z = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ShippingFragment, "__esModule", { value: true });
ShippingFragment.SABRE_SHIPPING_FRAGMENT = void 0;
var client_1$13 = require$$0$1;
ShippingFragment.SABRE_SHIPPING_FRAGMENT = (0, client_1$13.gql)(templateObject_1$z || (templateObject_1$z = __makeTemplateObject$z(["\n  fragment Shipping on Shipping {\n    id\n    consumablesPerCase\n    productsPerCase\n  }\n"], ["\n  fragment Shipping on Shipping {\n    id\n    consumablesPerCase\n    productsPerCase\n  }\n"])));
var templateObject_1$z;

var PlanogramImageFragment = {};

var __makeTemplateObject$y = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(PlanogramImageFragment, "__esModule", { value: true });
PlanogramImageFragment.PLANOGRAM_IMAGES_FRAGMENT = void 0;
var client_1$12 = require$$0$1;
var ImageFragment_1$2 = ImageFragment;
PlanogramImageFragment.PLANOGRAM_IMAGES_FRAGMENT = (0, client_1$12.gql)(templateObject_1$y || (templateObject_1$y = __makeTemplateObject$y(["\n  fragment PlanogramImages on PlanogramProductImages {\n    normal {\n      ...Image\n    }\n    thumbnail {\n      ...Image\n    }\n  }\n  ", "\n"], ["\n  fragment PlanogramImages on PlanogramProductImages {\n    normal {\n      ...Image\n    }\n    thumbnail {\n      ...Image\n    }\n  }\n  ", "\n"])), ImageFragment_1$2.IMAGE_FRAGMENT);
var templateObject_1$y;

var __makeTemplateObject$x = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ProductFragment, "__esModule", { value: true });
ProductFragment.SABRE_PRODUCT_FRAGMENT = void 0;
var client_1$11 = require$$0$1;
var PackagingFragment_1$1 = PackagingFragment;
var ShippingFragment_1$1 = ShippingFragment;
var CategoryFragment_1$1 = CategoryFragment;
var ImageFragment_1$1 = ImageFragment;
var PlanogramImageFragment_1 = PlanogramImageFragment;
var FlavorFragment_1$2 = FlavorFragment;
var ManufacturerFragment_1$1 = ManufacturerFragment;
ProductFragment.SABRE_PRODUCT_FRAGMENT = (0, client_1$11.gql)(templateObject_1$x || (templateObject_1$x = __makeTemplateObject$x(["\n  fragment Product on Product {\n    id\n    created\n    modified\n    upcA\n    upcE\n    name\n    source\n    brand {\n      id\n      name\n    }\n    manufacturer {\n      ...Manufacturer\n    }\n    drafts {\n      id\n      notes\n      createdBy\n      dateResolved\n    }\n    flavors {\n      ...Flavor\n    }\n    marketingImageUrl\n    planogramImages {\n      ...PlanogramImages\n    }\n    images {\n      ...Image\n    }\n    category {\n      ...Category\n    }\n    packaging {\n      ...Packaging\n    }\n    shipping {\n      ...Shipping\n    }\n    verifiedBy\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment Product on Product {\n    id\n    created\n    modified\n    upcA\n    upcE\n    name\n    source\n    brand {\n      id\n      name\n    }\n    manufacturer {\n      ...Manufacturer\n    }\n    drafts {\n      id\n      notes\n      createdBy\n      dateResolved\n    }\n    flavors {\n      ...Flavor\n    }\n    marketingImageUrl\n    planogramImages {\n      ...PlanogramImages\n    }\n    images {\n      ...Image\n    }\n    category {\n      ...Category\n    }\n    packaging {\n      ...Packaging\n    }\n    shipping {\n      ...Shipping\n    }\n    verifiedBy\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), PlanogramImageFragment_1.PLANOGRAM_IMAGES_FRAGMENT, FlavorFragment_1$2.SABRE_FLAVOR_FRAGMENT, ImageFragment_1$1.IMAGE_FRAGMENT, CategoryFragment_1$1.CATEGORY_FRAGMENT, PackagingFragment_1$1.SABRE_PACKAGING_FRAGMENT, ShippingFragment_1$1.SABRE_SHIPPING_FRAGMENT, ManufacturerFragment_1$1.SABRE_MANUFACTURER_FRAGMENT);
var templateObject_1$x;

var __makeTemplateObject$w = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DraftProductFragment, "__esModule", { value: true });
DraftProductFragment.DRAFT_PRODUCT_FRAGMENT = void 0;
var client_1$10 = require$$0$1;
var BrandFragment_1 = BrandFragment;
var CategoryFragment_1 = CategoryFragment;
var FlavorFragment_1$1 = FlavorFragment;
var ImageFragment_1 = ImageFragment;
var ManufacturerFragment_1 = ManufacturerFragment;
var PackagingFragment_1 = PackagingFragment;
var ProductFragment_1 = ProductFragment;
var ShippingFragment_1 = ShippingFragment;
DraftProductFragment.DRAFT_PRODUCT_FRAGMENT = (0, client_1$10.gql)(templateObject_1$w || (templateObject_1$w = __makeTemplateObject$w(["\n  fragment DraftProduct on DraftProduct {\n    id\n    name\n    createdBy\n    dateResolved\n    fieldsAccepted\n    notes\n    shipping {\n      ...Shipping\n    }\n    category {\n      ...Category\n    }\n    brand {\n      ...Brand\n    }\n    packaging {\n      ...Packaging\n    }\n    manufacturer {\n      ...Manufacturer\n    }\n    flavors {\n      ...Flavor\n    }\n    product {\n      ...Product\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment DraftProduct on DraftProduct {\n    id\n    name\n    createdBy\n    dateResolved\n    fieldsAccepted\n    notes\n    shipping {\n      ...Shipping\n    }\n    category {\n      ...Category\n    }\n    brand {\n      ...Brand\n    }\n    packaging {\n      ...Packaging\n    }\n    manufacturer {\n      ...Manufacturer\n    }\n    flavors {\n      ...Flavor\n    }\n    product {\n      ...Product\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), ImageFragment_1.IMAGE_FRAGMENT, BrandFragment_1.SABRE_BRAND_FRAGMENT, FlavorFragment_1$1.SABRE_FLAVOR_FRAGMENT, CategoryFragment_1.CATEGORY_FRAGMENT, PackagingFragment_1.SABRE_PACKAGING_FRAGMENT, ShippingFragment_1.SABRE_SHIPPING_FRAGMENT, ProductFragment_1.SABRE_PRODUCT_FRAGMENT, ManufacturerFragment_1.SABRE_MANUFACTURER_FRAGMENT);
var templateObject_1$w;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(CategoryFragment, exports);
__exportStar(BrandFragment, exports);
__exportStar(FlavorFragment, exports);
__exportStar(DraftProductFragment, exports);
__exportStar(ImageFragment, exports);
__exportStar(ManufacturerFragment, exports);
__exportStar(PackagingFragment, exports);
__exportStar(PlanogramImageFragment, exports);
__exportStar(ProductFragment, exports);
__exportStar(ShippingFragment, exports);
}(fragments));

var queries$1 = {};

var GetBrands = {};

var __makeTemplateObject$v = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetBrands, "__esModule", { value: true });
GetBrands.SABRE_GET_BRANDS = void 0;
var client_1$$ = require$$0$1;
GetBrands.SABRE_GET_BRANDS = (0, client_1$$.gql)(templateObject_1$v || (templateObject_1$v = __makeTemplateObject$v(["\n  query GetBrands($input: BrandsInput) {\n    brands(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query GetBrands($input: BrandsInput) {\n    brands(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        name\n      }\n    }\n  }\n"])));
var templateObject_1$v;

var GetBrandPackaging = {};

var __makeTemplateObject$u = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetBrandPackaging, "__esModule", { value: true });
GetBrandPackaging.SABRE_GET_BRAND_PACKAGING = void 0;
var client_1$_ = require$$0$1;
var fragments_1$b = fragments;
GetBrandPackaging.SABRE_GET_BRAND_PACKAGING = (0, client_1$_.gql)(templateObject_1$u || (templateObject_1$u = __makeTemplateObject$u(["\n  query GetBrandPackaging($input: BrandPackagingSearchInput!) {\n    brandPackagingSearch(input: $input) {\n      ...Product\n    }\n  }\n  ", "\n"], ["\n  query GetBrandPackaging($input: BrandPackagingSearchInput!) {\n    brandPackagingSearch(input: $input) {\n      ...Product\n    }\n  }\n  ", "\n"])), fragments_1$b.SABRE_PRODUCT_FRAGMENT);
var templateObject_1$u;

var GetCategories = {};

var __makeTemplateObject$t = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetCategories, "__esModule", { value: true });
GetCategories.SABRE_GET_CATEGORIES = void 0;
var client_1$Z = require$$0$1;
GetCategories.SABRE_GET_CATEGORIES = (0, client_1$Z.gql)(templateObject_1$t || (templateObject_1$t = __makeTemplateObject$t(["\n  query Categories($input: CategoriesInput) {\n    categories(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        name\n        parent {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query Categories($input: CategoriesInput) {\n    categories(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        name\n        parent {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$t;

var GetFlavors = {};

var __makeTemplateObject$s = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetFlavors, "__esModule", { value: true });
GetFlavors.SABRE_GET_FLAVORS = void 0;
var client_1$Y = require$$0$1;
var FlavorFragment_1 = FlavorFragment;
GetFlavors.SABRE_GET_FLAVORS = (0, client_1$Y.gql)(templateObject_1$s || (templateObject_1$s = __makeTemplateObject$s(["\n  query GetFlavors($input: FlavorsInput) {\n    flavors(input: $input) {\n      hasMore\n      count\n      results {\n        ...Flavor\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetFlavors($input: FlavorsInput) {\n    flavors(input: $input) {\n      hasMore\n      count\n      results {\n        ...Flavor\n      }\n    }\n  }\n  ", "\n"])), FlavorFragment_1.SABRE_FLAVOR_FRAGMENT);
var templateObject_1$s;

var GetManufacturers = {};

var __makeTemplateObject$r = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetManufacturers, "__esModule", { value: true });
GetManufacturers.SABRE_GET_MANUFACTURERS = void 0;
var client_1$X = require$$0$1;
var fragments_1$a = fragments;
GetManufacturers.SABRE_GET_MANUFACTURERS = (0, client_1$X.gql)(templateObject_1$r || (templateObject_1$r = __makeTemplateObject$r(["\n  query GetManufacturers($input: ManufacturersInput) {\n    manufacturers(input: $input) {\n      count\n      hasMore\n      results {\n        ...Manufacturer\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetManufacturers($input: ManufacturersInput) {\n    manufacturers(input: $input) {\n      count\n      hasMore\n      results {\n        ...Manufacturer\n      }\n    }\n  }\n  ", "\n"])), fragments_1$a.SABRE_MANUFACTURER_FRAGMENT);
var templateObject_1$r;

var GetPackaging = {};

var __makeTemplateObject$q = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetPackaging, "__esModule", { value: true });
GetPackaging.SABRE_GET_PACKAGING = void 0;
var client_1$W = require$$0$1;
var fragments_1$9 = fragments;
GetPackaging.SABRE_GET_PACKAGING = (0, client_1$W.gql)(templateObject_1$q || (templateObject_1$q = __makeTemplateObject$q(["\n  query GetPackaging($input: PackagingQueryInput) {\n    packaging(input: $input) {\n      count\n      hasMore\n      results {\n        ...Packaging\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetPackaging($input: PackagingQueryInput) {\n    packaging(input: $input) {\n      count\n      hasMore\n      results {\n        ...Packaging\n      }\n    }\n  }\n  ", "\n"])), fragments_1$9.SABRE_PACKAGING_FRAGMENT);
var templateObject_1$q;

var GetProduct = {};

var __makeTemplateObject$p = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProduct, "__esModule", { value: true });
GetProduct.SABRE_GET_PRODUCT = void 0;
var client_1$V = require$$0$1;
var fragments_1$8 = fragments;
GetProduct.SABRE_GET_PRODUCT = (0, client_1$V.gql)(templateObject_1$p || (templateObject_1$p = __makeTemplateObject$p(["\n  query GetProduct($upc: String!) {\n    product(upc: $upc) {\n      ...Product\n    }\n  }\n  ", "\n"], ["\n  query GetProduct($upc: String!) {\n    product(upc: $upc) {\n      ...Product\n    }\n  }\n  ", "\n"])), fragments_1$8.SABRE_PRODUCT_FRAGMENT);
var templateObject_1$p;

var GetProductImages = {};

var __makeTemplateObject$o = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProductImages, "__esModule", { value: true });
GetProductImages.SABRE_GET_PRODUCT_IMAGES = void 0;
var client_1$U = require$$0$1;
var fragments_1$7 = fragments;
GetProductImages.SABRE_GET_PRODUCT_IMAGES = (0, client_1$U.gql)(templateObject_1$o || (templateObject_1$o = __makeTemplateObject$o(["\n  query GetProductImages($input: ProductImagesInput!) {\n    productImages(input: $input) {\n      count\n      hasMore\n      results {\n        ...Image\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetProductImages($input: ProductImagesInput!) {\n    productImages(input: $input) {\n      count\n      hasMore\n      results {\n        ...Image\n      }\n    }\n  }\n  ", "\n"])), fragments_1$7.IMAGE_FRAGMENT);
var templateObject_1$o;

var GetProducts = {};

var __makeTemplateObject$n = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetProducts, "__esModule", { value: true });
GetProducts.SABRE_GET_PRODUCTS = void 0;
var client_1$T = require$$0$1;
var fragments_1$6 = fragments;
GetProducts.SABRE_GET_PRODUCTS = (0, client_1$T.gql)(templateObject_1$n || (templateObject_1$n = __makeTemplateObject$n(["\n  query GetProducts($input: ProductsInput) {\n    products(input: $input) {\n      count\n      hasMore\n      results {\n        ...Product\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetProducts($input: ProductsInput) {\n    products(input: $input) {\n      count\n      hasMore\n      results {\n        ...Product\n      }\n    }\n  }\n  ", "\n"])), fragments_1$6.SABRE_PRODUCT_FRAGMENT);
var templateObject_1$n;

var GetShipping = {};

var __makeTemplateObject$m = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetShipping, "__esModule", { value: true });
GetShipping.SABRE_GET_SHIPPING = void 0;
var client_1$S = require$$0$1;
var fragments_1$5 = fragments;
GetShipping.SABRE_GET_SHIPPING = (0, client_1$S.gql)(templateObject_1$m || (templateObject_1$m = __makeTemplateObject$m(["\n  query GetShipping($input: ShippingQueryInput!) {\n    shipping(input: $input) {\n      count\n      hasMore\n      results {\n        ...Shipping\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetShipping($input: ShippingQueryInput!) {\n    shipping(input: $input) {\n      count\n      hasMore\n      results {\n        ...Shipping\n      }\n    }\n  }\n  ", "\n"])), fragments_1$5.SABRE_SHIPPING_FRAGMENT);
var templateObject_1$m;

var SearchProductsSabre = {};

var __makeTemplateObject$l = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(SearchProductsSabre, "__esModule", { value: true });
SearchProductsSabre.SEARCH_PRODUCTS_SABRE = void 0;
var client_1$R = require$$0$1;
SearchProductsSabre.SEARCH_PRODUCTS_SABRE = (0, client_1$R.gql)(templateObject_1$l || (templateObject_1$l = __makeTemplateObject$l(["\n  query SearchProducts($productsInput: ProductsInput!) {\n    products(input: $productsInput) {\n      count\n      hasMore\n      results {\n        id\n        created\n        modified\n        upcA\n        name\n        brand {\n          id\n          name\n        }\n        flavors {\n          id\n          displayFlavor\n        }\n        marketingImageUrl\n        verifiedBy\n      }\n    }\n  }\n"], ["\n  query SearchProducts($productsInput: ProductsInput!) {\n    products(input: $productsInput) {\n      count\n      hasMore\n      results {\n        id\n        created\n        modified\n        upcA\n        name\n        brand {\n          id\n          name\n        }\n        flavors {\n          id\n          displayFlavor\n        }\n        marketingImageUrl\n        verifiedBy\n      }\n    }\n  }\n"])));
var templateObject_1$l;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(GetBrands, exports);
__exportStar(GetBrandPackaging, exports);
__exportStar(GetCategories, exports);
__exportStar(GetFlavors, exports);
__exportStar(GetManufacturers, exports);
__exportStar(GetPackaging, exports);
__exportStar(GetProduct, exports);
__exportStar(GetProductImages, exports);
__exportStar(GetProducts, exports);
__exportStar(GetShipping, exports);
__exportStar(SearchProductsSabre, exports);
}(queries$1));

var mutations$1 = {};

var CreateCategory = {};

var __makeTemplateObject$k = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateCategory, "__esModule", { value: true });
CreateCategory.SABRE_CREATE_CATEGORY = void 0;
var client_1$Q = require$$0$1;
CreateCategory.SABRE_CREATE_CATEGORY = (0, client_1$Q.gql)(templateObject_1$k || (templateObject_1$k = __makeTemplateObject$k(["\n  mutation CreateCategory($input: CreateCategoryInput!) {\n    createCategory(input: $input) {\n      category {\n        id\n        name\n        parent {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateCategory($input: CreateCategoryInput!) {\n    createCategory(input: $input) {\n      category {\n        id\n        name\n        parent {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$k;

var CreateBrand = {};

var __makeTemplateObject$j = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateBrand, "__esModule", { value: true });
CreateBrand.SABRE_CREATE_BRAND = void 0;
var client_1$P = require$$0$1;
CreateBrand.SABRE_CREATE_BRAND = (0, client_1$P.gql)(templateObject_1$j || (templateObject_1$j = __makeTemplateObject$j(["\n  mutation CreateBrand($input: CreateBrandInput!) {\n    createBrand(input: $input) {\n      brand {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  mutation CreateBrand($input: CreateBrandInput!) {\n    createBrand(input: $input) {\n      brand {\n        id\n        name\n      }\n    }\n  }\n"])));
var templateObject_1$j;

var CreateImage = {};

var __makeTemplateObject$i = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateImage, "__esModule", { value: true });
CreateImage.SABRE_CREATE_IMAGE = void 0;
var client_1$O = require$$0$1;
var fragments_1$4 = fragments;
CreateImage.SABRE_CREATE_IMAGE = (0, client_1$O.gql)(templateObject_1$i || (templateObject_1$i = __makeTemplateObject$i(["\n  mutation CreateImage($input: CreateImageInput!) {\n    createImage(input: $input) {\n      image {\n        ...Image\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateImage($input: CreateImageInput!) {\n    createImage(input: $input) {\n      image {\n        ...Image\n      }\n    }\n  }\n  ", "\n"])), fragments_1$4.IMAGE_FRAGMENT);
var templateObject_1$i;

var CreateFlavor = {};

var __makeTemplateObject$h = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateFlavor, "__esModule", { value: true });
CreateFlavor.SABRE_CREATE_PRODUCT_FLAVOR = void 0;
var client_1$N = require$$0$1;
var fragments_1$3 = fragments;
CreateFlavor.SABRE_CREATE_PRODUCT_FLAVOR = (0, client_1$N.gql)(templateObject_1$h || (templateObject_1$h = __makeTemplateObject$h(["\n  mutation CreateFlavor($input: CreateFlavorInput!) {\n    createFlavor(input: $input) {\n      flavor {\n        ...Flavor\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateFlavor($input: CreateFlavorInput!) {\n    createFlavor(input: $input) {\n      flavor {\n        ...Flavor\n      }\n    }\n  }\n  ", "\n"])), fragments_1$3.SABRE_FLAVOR_FRAGMENT);
var templateObject_1$h;

var CreateManufacturer = {};

var __makeTemplateObject$g = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateManufacturer, "__esModule", { value: true });
CreateManufacturer.SABRE_CREATE_MANUFACTURER = void 0;
var client_1$M = require$$0$1;
CreateManufacturer.SABRE_CREATE_MANUFACTURER = (0, client_1$M.gql)(templateObject_1$g || (templateObject_1$g = __makeTemplateObject$g(["\n  mutation CreateManufacturer($input: CreateManufacturerInput!) {\n    createManufacturer(input: $input) {\n      manufacturer {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  mutation CreateManufacturer($input: CreateManufacturerInput!) {\n    createManufacturer(input: $input) {\n      manufacturer {\n        id\n        name\n      }\n    }\n  }\n"])));
var templateObject_1$g;

var CreateProduct = {};

var __makeTemplateObject$f = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(CreateProduct, "__esModule", { value: true });
CreateProduct.SABRE_CREATE_PRODUCT = void 0;
var client_1$L = require$$0$1;
var fragments_1$2 = fragments;
CreateProduct.SABRE_CREATE_PRODUCT = (0, client_1$L.gql)(templateObject_1$f || (templateObject_1$f = __makeTemplateObject$f(["\n  mutation CreateProduct($input: CreateProductInput!) {\n    createProduct(input: $input) {\n      product {\n        ...Product\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateProduct($input: CreateProductInput!) {\n    createProduct(input: $input) {\n      product {\n        ...Product\n      }\n    }\n  }\n  ", "\n"])), fragments_1$2.SABRE_PRODUCT_FRAGMENT);
var templateObject_1$f;

var DeleteCategory = {};

var __makeTemplateObject$e = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteCategory, "__esModule", { value: true });
DeleteCategory.SABRE_DELETE_CATEGORY = void 0;
var client_1$K = require$$0$1;
DeleteCategory.SABRE_DELETE_CATEGORY = (0, client_1$K.gql)(templateObject_1$e || (templateObject_1$e = __makeTemplateObject$e(["\n  mutation DeleteCategory($input: DeleteCategoryInput!) {\n    deleteCategory(input: $input) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteCategory($input: DeleteCategoryInput!) {\n    deleteCategory(input: $input) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$e;

var DeleteImage = {};

var __makeTemplateObject$d = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(DeleteImage, "__esModule", { value: true });
DeleteImage.SABRE_DELETE_IMAGE = void 0;
var client_1$J = require$$0$1;
DeleteImage.SABRE_DELETE_IMAGE = (0, client_1$J.gql)(templateObject_1$d || (templateObject_1$d = __makeTemplateObject$d(["\n  mutation DeleteImage($input: DeleteImageInput!) {\n    deleteImage(input: $input) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteImage($input: DeleteImageInput!) {\n    deleteImage(input: $input) {\n      deleted\n    }\n  }\n"])));
var templateObject_1$d;

var ResolveDraftProduct = {};

var __makeTemplateObject$c = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(ResolveDraftProduct, "__esModule", { value: true });
ResolveDraftProduct.SABRE_RESOLVE_DRAFT_PRODUCT = void 0;
var client_1$I = require$$0$1;
var DraftProductFragment_1 = DraftProductFragment;
ResolveDraftProduct.SABRE_RESOLVE_DRAFT_PRODUCT = (0, client_1$I.gql)(templateObject_1$c || (templateObject_1$c = __makeTemplateObject$c(["\n  mutation ResolveDraftProduct($input: ResolveDraftProductInput!) {\n    resolveDraftProduct(input: $input) {\n      draftProduct {\n        ...DraftProduct\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation ResolveDraftProduct($input: ResolveDraftProductInput!) {\n    resolveDraftProduct(input: $input) {\n      draftProduct {\n        ...DraftProduct\n      }\n    }\n  }\n  ", "\n"])), DraftProductFragment_1.DRAFT_PRODUCT_FRAGMENT);
var templateObject_1$c;

var UpdateCategory = {};

var __makeTemplateObject$b = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateCategory, "__esModule", { value: true });
UpdateCategory.SABRE_UPDATE_CATEGORY = void 0;
var client_1$H = require$$0$1;
UpdateCategory.SABRE_UPDATE_CATEGORY = (0, client_1$H.gql)(templateObject_1$b || (templateObject_1$b = __makeTemplateObject$b(["\n  mutation UpdateCategory($input: UpdateCategoryInput!) {\n    updateCategory(input: $input) {\n      category {\n        id\n        name\n        parent {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  mutation UpdateCategory($input: UpdateCategoryInput!) {\n    updateCategory(input: $input) {\n      category {\n        id\n        name\n        parent {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$b;

var UpdateImage = {};

var __makeTemplateObject$a = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateImage, "__esModule", { value: true });
UpdateImage.SABRE_UPDATE_IMAGE = void 0;
var client_1$G = require$$0$1;
var fragments_1$1 = fragments;
UpdateImage.SABRE_UPDATE_IMAGE = (0, client_1$G.gql)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject$a(["\n  mutation UpdateImage($input: UpdateImageInput!) {\n    updateImage(input: $input) {\n      image {\n        ...Image\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateImage($input: UpdateImageInput!) {\n    updateImage(input: $input) {\n      image {\n        ...Image\n      }\n    }\n  }\n  ", "\n"])), fragments_1$1.IMAGE_FRAGMENT);
var templateObject_1$a;

var UpdateProduct = {};

var __makeTemplateObject$9 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateProduct, "__esModule", { value: true });
UpdateProduct.SABRE_UPDATE_PRODUCT = void 0;
var client_1$F = require$$0$1;
var fragments_1 = fragments;
UpdateProduct.SABRE_UPDATE_PRODUCT = (0, client_1$F.gql)(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject$9(["\n  mutation UpdateProduct($input: UpdateProductInput!) {\n    updateProduct(input: $input) {\n      product {\n        ...Product\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateProduct($input: UpdateProductInput!) {\n    updateProduct(input: $input) {\n      product {\n        ...Product\n      }\n    }\n  }\n  ", "\n"])), fragments_1.SABRE_PRODUCT_FRAGMENT);
var templateObject_1$9;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(CreateCategory, exports);
__exportStar(CreateBrand, exports);
__exportStar(CreateImage, exports);
__exportStar(CreateFlavor, exports);
__exportStar(CreateManufacturer, exports);
__exportStar(CreateProduct, exports);
__exportStar(DeleteCategory, exports);
__exportStar(DeleteImage, exports);
__exportStar(ResolveDraftProduct, exports);
__exportStar(UpdateCategory, exports);
__exportStar(UpdateImage, exports);
__exportStar(UpdateProduct, exports);
}(mutations$1));

var queries = {};

var GetDailyStats = {};

var __makeTemplateObject$8 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetDailyStats, "__esModule", { value: true });
GetDailyStats.GET_DAILY_STATS = void 0;
var client_1$E = require$$0$1;
GetDailyStats.GET_DAILY_STATS = (0, client_1$E.gql)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject$8(["\n  query Stats {\n    dailyStats {\n      results {\n        numImages\n        numBoxes\n        dateString\n        email\n      }\n    }\n  }\n"], ["\n  query Stats {\n    dailyStats {\n      results {\n        numImages\n        numBoxes\n        dateString\n        email\n      }\n    }\n  }\n"])));
var templateObject_1$8;

var GetImageIdsByUser = {};

var __makeTemplateObject$7 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetImageIdsByUser, "__esModule", { value: true });
GetImageIdsByUser.GET_IMAGE_IDS_BY_USER = void 0;
var client_1$D = require$$0$1;
GetImageIdsByUser.GET_IMAGE_IDS_BY_USER = (0, client_1$D.gql)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject$7(["\n  query GetImageIdsByUser($email: String!) {\n    imageIdsByUser(email: $email) {\n      results\n    }\n  }\n"], ["\n  query GetImageIdsByUser($email: String!) {\n    imageIdsByUser(email: $email) {\n      results\n    }\n  }\n"])));
var templateObject_1$7;

var GetImageIdsUltra = {};

var __makeTemplateObject$6 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetImageIdsUltra, "__esModule", { value: true });
GetImageIdsUltra.GET_IMAGE_IDS_ULTRA = void 0;
var client_1$C = require$$0$1;
GetImageIdsUltra.GET_IMAGE_IDS_ULTRA = (0, client_1$C.gql)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject$6(["\n  query GetImageIdsToLabel {\n    imageIdsToLabel {\n      results\n    }\n  }\n"], ["\n  query GetImageIdsToLabel {\n    imageIdsToLabel {\n      results\n    }\n  }\n"])));
var templateObject_1$6;

var GetImageUltra = {};

var __makeTemplateObject$5 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetImageUltra, "__esModule", { value: true });
GetImageUltra.GET_IMAGE_ULTRA = void 0;
var client_1$B = require$$0$1;
GetImageUltra.GET_IMAGE_ULTRA = (0, client_1$B.gql)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject$5(["\n  query GetImage($imageId: ID!) {\n    imageData(imageId: $imageId) {\n      imageId\n      imageType\n      url\n      products\n      boundingBoxSet {\n        id\n        verified\n        verifiedById\n        verifiedDate\n        verifiedLocation\n        updateCount\n        boundingBoxes {\n          id\n          upcA\n          productName\n          brandName\n          packagingName\n          marketingImageUrl\n          coordinates {\n            minX\n            minY\n            maxX\n            maxY\n          }\n          verified\n          verifiedById\n          verifiedLocation\n        }\n      }\n      verified\n      verifiedById\n      verifiedByFirstName\n      verifiedByLastName\n      verifiedByEmail\n      verifiedDate\n      verifiedDate\n      eulerAngles {\n        x\n        y\n        z\n      }\n    }\n  }\n"], ["\n  query GetImage($imageId: ID!) {\n    imageData(imageId: $imageId) {\n      imageId\n      imageType\n      url\n      products\n      boundingBoxSet {\n        id\n        verified\n        verifiedById\n        verifiedDate\n        verifiedLocation\n        updateCount\n        boundingBoxes {\n          id\n          upcA\n          productName\n          brandName\n          packagingName\n          marketingImageUrl\n          coordinates {\n            minX\n            minY\n            maxX\n            maxY\n          }\n          verified\n          verifiedById\n          verifiedLocation\n        }\n      }\n      verified\n      verifiedById\n      verifiedByFirstName\n      verifiedByLastName\n      verifiedByEmail\n      verifiedDate\n      verifiedDate\n      eulerAngles {\n        x\n        y\n        z\n      }\n    }\n  }\n"])));
var templateObject_1$5;

var GetLoggedInUserUltra = {};

var __makeTemplateObject$4 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetLoggedInUserUltra, "__esModule", { value: true });
GetLoggedInUserUltra.GET_LOGGED_IN_USER_ULTRA = void 0;
var client_1$A = require$$0$1;
GetLoggedInUserUltra.GET_LOGGED_IN_USER_ULTRA = (0, client_1$A.gql)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$4(["\n  query GetLoggedInUser {\n    loggedInUser {\n      uuid\n      id\n      email\n      firstName\n      lastName\n      isStaff\n      isSuperuser\n      roles\n    }\n  }\n"], ["\n  query GetLoggedInUser {\n    loggedInUser {\n      uuid\n      id\n      email\n      firstName\n      lastName\n      isStaff\n      isSuperuser\n      roles\n    }\n  }\n"])));
var templateObject_1$4;

var GetMonthlyStats = {};

var __makeTemplateObject$3 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(GetMonthlyStats, "__esModule", { value: true });
GetMonthlyStats.GET_MONTHLY_STATS = void 0;
var client_1$z = require$$0$1;
GetMonthlyStats.GET_MONTHLY_STATS = (0, client_1$z.gql)(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$3(["\n  query Stats {\n    monthlyStats {\n      results {\n        numImages\n        numBoxes\n        dateString\n        email\n      }\n    }\n  }\n"], ["\n  query Stats {\n    monthlyStats {\n      results {\n        numImages\n        numBoxes\n        dateString\n        email\n      }\n    }\n  }\n"])));
var templateObject_1$3;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(GetDailyStats, exports);
__exportStar(GetImageIdsByUser, exports);
__exportStar(GetImageIdsUltra, exports);
__exportStar(GetImageUltra, exports);
__exportStar(GetLoggedInUserUltra, exports);
__exportStar(GetMonthlyStats, exports);
}(queries));

var mutations = {};

var FlagObjectUltra = {};

var __makeTemplateObject$2 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(FlagObjectUltra, "__esModule", { value: true });
FlagObjectUltra.FLAG_OBJECT_ULTRA = void 0;
var client_1$y = require$$0$1;
FlagObjectUltra.FLAG_OBJECT_ULTRA = (0, client_1$y.gql)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$2(["\n  mutation FlagObject($input: ID!) {\n    flagImage(imageId: $input) {\n      imageId\n    }\n  }\n"], ["\n  mutation FlagObject($input: ID!) {\n    flagImage(imageId: $input) {\n      imageId\n    }\n  }\n"])));
var templateObject_1$2;

var UnverifyBoundingBoxes = {};

var __makeTemplateObject$1 = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UnverifyBoundingBoxes, "__esModule", { value: true });
UnverifyBoundingBoxes.UPDATE_BOUNDING_BOXES = void 0;
var client_1$x = require$$0$1;
UnverifyBoundingBoxes.UPDATE_BOUNDING_BOXES = (0, client_1$x.gql)(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1(["\n  mutation UpdateBoundingBoxes($input: UpdateBoundingBoxesInput!) {\n    updateBoundingBoxes(input: $input) {\n      status\n    }\n  }\n"], ["\n  mutation UpdateBoundingBoxes($input: UpdateBoundingBoxesInput!) {\n    updateBoundingBoxes(input: $input) {\n      status\n    }\n  }\n"])));
var templateObject_1$1;

var UpdateBoundingBoxes = {};

var __makeTemplateObject = (commonjsGlobal && commonjsGlobal.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(UpdateBoundingBoxes, "__esModule", { value: true });
UpdateBoundingBoxes.UNVERIFY_BOUNDING_BOXES = void 0;
var client_1$w = require$$0$1;
UpdateBoundingBoxes.UNVERIFY_BOUNDING_BOXES = (0, client_1$w.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UnverifyBoundingBoxes($input: [ID!]!) {\n    unverifyBoundingBoxes(input: $input) {\n      status\n    }\n  }\n"], ["\n  mutation UnverifyBoundingBoxes($input: [ID!]!) {\n    unverifyBoundingBoxes(input: $input) {\n      status\n    }\n  }\n"])));
var templateObject_1;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(FlagObjectUltra, exports);
__exportStar(UnverifyBoundingBoxes, exports);
__exportStar(UpdateBoundingBoxes, exports);
}(mutations));

var gnarniaGeneratedTypes = {};

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.MLModelType = exports.LocalVersionColumns = exports.LocalShippingColumns = exports.LocalProductFlavorRelationColumns = exports.LocalProductColumns = exports.LocalPackagingColumns = exports.LocalFlavorColumns = exports.LocalCompanyCategoryColumns = exports.IssueType = exports.InventoryTransactionMemo = exports.InventoryProductInventoryTransactionMemoChoices = exports.ImageType = exports.GroupTypes = exports.ForStoreSize = exports.FlaggedType = exports.FlaggedLevel = exports.FlagModelType = exports.FlagAppType = exports.ErrorLevel = exports.DoorHandlePlacement = exports.DisplaysDisplayAreaOldChoices = exports.DisplaysAssociatedStoreTypesCategoryChoices = exports.DisplayTypeAppRule = exports.DisplayTaskType = exports.DisplaySalesVolume = exports.DisplayElements = exports.DisplayActionType = exports.DeviceType = exports.DateRangeType = exports.DAIGroupEnum = exports.CompliancePlanogramTypeChoices = exports.CompliancePlanogramProductOrientationChoices = exports.ComplianceIssue = exports.CompanyUsersSortBy = exports.CompanyStoreSortBy = exports.CompanyStoreFilterOptions = exports.CommonStatusStatusTypeChoices = exports.CommonStatusStatusChoices = exports.CommonFlaggedReasonTypeChoices = exports.CommonFlaggedReasonOptionTypeChoices = exports.BadgeType = exports.BadgeGraphicType = exports.AuditsOrderBy = exports.AuditsAuditQuestionCategoryChoices = exports.AssignOrCreatedUserTask = exports.AppMLModelType = exports.AiMLModelModelTypeChoices = exports.AggregationMethod = exports.AggregateBy = exports.AdminPortalAuditsOrderBy = void 0;
exports.ZoneTier = exports.VerifiedLocation = exports.VerificationDecision = exports.UsersFCMTokenDeviceTypeChoices = exports.UserProductivityModelOptions = exports.UploadStatus = exports.StoresStoreCategoryChoices = exports.StoreTaskSortBy = exports.StoreTaskFilterOptions = exports.StoreOrderBy = exports.StoreFilterOut = exports.StoreFilter = exports.StoreDisplaysSortBy = exports.StoreDisplaysFilterOptions = exports.StoreCategory = exports.StoreActionType = exports.SortIssueDirection = exports.SortIssueBy = exports.SortByDirection = exports.SortBy = exports.SimpleUserProductivityModelOptions = exports.SceneTypeEnum = exports.ScanType = exports.ScanPurpose = exports.RestockAdjustmentType = exports.ProductsProductSourceChoices = exports.ProductsPackagingUnitChoices = exports.ProductsPackagingContainerChoices = exports.ProductTypeEnum = exports.ProductSortBy = exports.PlanogramStatus = exports.PlanogramProductOrientation = exports.Period = exports.PerformanceReportFilter = exports.PackagingUnits = exports.PackagingType = exports.OrderByDirection = exports.MerchandisingState = exports.MerchandisingAction = exports.MerchandiserScanType = exports.MapsStoreAreaDefaultForStoreSizeChoices = exports.MandateTypes = exports.MLPurpose = void 0;
(function (AdminPortalAuditsOrderBy) {
    AdminPortalAuditsOrderBy["DATE"] = "DATE";
    AdminPortalAuditsOrderBy["EMPLOYEE"] = "EMPLOYEE";
    AdminPortalAuditsOrderBy["SCORE"] = "SCORE";
    AdminPortalAuditsOrderBy["STORE"] = "STORE";
})(exports.AdminPortalAuditsOrderBy || (exports.AdminPortalAuditsOrderBy = {}));
(function (AggregateBy) {
    AggregateBy["ALL_TIME"] = "ALL_TIME";
    AggregateBy["DAY"] = "DAY";
    AggregateBy["MONTH"] = "MONTH";
    AggregateBy["QUARTER"] = "QUARTER";
    AggregateBy["WEEK"] = "WEEK";
    AggregateBy["YEAR"] = "YEAR";
})(exports.AggregateBy || (exports.AggregateBy = {}));
(function (AggregationMethod) {
    AggregationMethod["AVG"] = "AVG";
    AggregationMethod["COUNT"] = "COUNT";
    AggregationMethod["MEDIAN"] = "MEDIAN";
    AggregationMethod["SUM"] = "SUM";
})(exports.AggregationMethod || (exports.AggregationMethod = {}));
(function (AiMLModelModelTypeChoices) {
    /** Bev */
    AiMLModelModelTypeChoices["BEV"] = "BEV";
    /** Binary */
    AiMLModelModelTypeChoices["BINARY"] = "BINARY";
    /** DaiZero */
    AiMLModelModelTypeChoices["DAI_ZERO"] = "DAI_ZERO";
    /** DensityNeonet */
    AiMLModelModelTypeChoices["DENSITY_NEONET"] = "DENSITY_NEONET";
    /** Meta */
    AiMLModelModelTypeChoices["META"] = "META";
    /** Neonet */
    AiMLModelModelTypeChoices["NEONET"] = "NEONET";
    /** PointBeamScorer */
    AiMLModelModelTypeChoices["POINT_BEAM_SCORER"] = "POINT_BEAM_SCORER";
})(exports.AiMLModelModelTypeChoices || (exports.AiMLModelModelTypeChoices = {}));
(function (AppMLModelType) {
    AppMLModelType["BEV"] = "BEV";
    AppMLModelType["BINARY"] = "BINARY";
    AppMLModelType["DAI_ZERO"] = "DAI_ZERO";
    AppMLModelType["DENSITY_NEONET"] = "DENSITY_NEONET";
    AppMLModelType["META"] = "META";
    AppMLModelType["NEONET"] = "NEONET";
    AppMLModelType["POINT_BEAM_SCORER"] = "POINT_BEAM_SCORER";
})(exports.AppMLModelType || (exports.AppMLModelType = {}));
(function (AssignOrCreatedUserTask) {
    AssignOrCreatedUserTask["ASSIGNED"] = "ASSIGNED";
    AssignOrCreatedUserTask["CREATED"] = "CREATED";
})(exports.AssignOrCreatedUserTask || (exports.AssignOrCreatedUserTask = {}));
(function (AuditsAuditQuestionCategoryChoices) {
    /** all */
    AuditsAuditQuestionCategoryChoices["AL"] = "AL";
    /** small */
    AuditsAuditQuestionCategoryChoices["CR"] = "CR";
    /** drug */
    AuditsAuditQuestionCategoryChoices["DR"] = "DR";
    /** home improvement */
    AuditsAuditQuestionCategoryChoices["HM"] = "HM";
    /** large */
    AuditsAuditQuestionCategoryChoices["LG"] = "LG";
    /** value */
    AuditsAuditQuestionCategoryChoices["VL"] = "VL";
})(exports.AuditsAuditQuestionCategoryChoices || (exports.AuditsAuditQuestionCategoryChoices = {}));
(function (AuditsOrderBy) {
    AuditsOrderBy["COMPLETED"] = "COMPLETED";
    AuditsOrderBy["DATE"] = "DATE";
    AuditsOrderBy["STORE"] = "STORE";
})(exports.AuditsOrderBy || (exports.AuditsOrderBy = {}));
(function (BadgeGraphicType) {
    BadgeGraphicType["LG"] = "LG";
    BadgeGraphicType["LK"] = "LK";
    BadgeGraphicType["SM"] = "SM";
})(exports.BadgeGraphicType || (exports.BadgeGraphicType = {}));
(function (BadgeType) {
    BadgeType["COMPLIANCE"] = "COMPLIANCE";
    BadgeType["COVERAGE"] = "COVERAGE";
    BadgeType["CROWN"] = "CROWN";
    BadgeType["MILESTONE"] = "MILESTONE";
    BadgeType["TRAINING"] = "TRAINING";
})(exports.BadgeType || (exports.BadgeType = {}));
(function (CommonFlaggedReasonOptionTypeChoices) {
    /** Common */
    CommonFlaggedReasonOptionTypeChoices["COMMON"] = "COMMON";
    /** Image */
    CommonFlaggedReasonOptionTypeChoices["IMAGE"] = "IMAGE";
    /** Planogram Segment */
    CommonFlaggedReasonOptionTypeChoices["PLAN_SEG"] = "PLAN_SEG";
    /** Product */
    CommonFlaggedReasonOptionTypeChoices["PRODUCT"] = "PRODUCT";
    /** Store Map */
    CommonFlaggedReasonOptionTypeChoices["STORE_MAP"] = "STORE_MAP";
})(exports.CommonFlaggedReasonOptionTypeChoices || (exports.CommonFlaggedReasonOptionTypeChoices = {}));
(function (CommonFlaggedReasonTypeChoices) {
    /** Common */
    CommonFlaggedReasonTypeChoices["COMMON"] = "COMMON";
    /** Image */
    CommonFlaggedReasonTypeChoices["IMAGE"] = "IMAGE";
    /** Planogram Segment */
    CommonFlaggedReasonTypeChoices["PLAN_SEG"] = "PLAN_SEG";
    /** Product */
    CommonFlaggedReasonTypeChoices["PRODUCT"] = "PRODUCT";
    /** Store Map */
    CommonFlaggedReasonTypeChoices["STORE_MAP"] = "STORE_MAP";
})(exports.CommonFlaggedReasonTypeChoices || (exports.CommonFlaggedReasonTypeChoices = {}));
(function (CommonStatusStatusChoices) {
    /** Complete */
    CommonStatusStatusChoices["COMPLETE"] = "COMPLETE";
    /** Failed */
    CommonStatusStatusChoices["FAILED"] = "FAILED";
    /** Pending */
    CommonStatusStatusChoices["PENDING"] = "PENDING";
})(exports.CommonStatusStatusChoices || (exports.CommonStatusStatusChoices = {}));
(function (CommonStatusStatusTypeChoices) {
    /** Product Health Score Set */
    CommonStatusStatusTypeChoices["PRODUCT_HEALTH_SCORE_SET"] = "PRODUCT_HEALTH_SCORE_SET";
    /** Upload Stores */
    CommonStatusStatusTypeChoices["UPLOAD_STORES"] = "UPLOAD_STORES";
})(exports.CommonStatusStatusTypeChoices || (exports.CommonStatusStatusTypeChoices = {}));
(function (CompanyStoreFilterOptions) {
    CompanyStoreFilterOptions["CONVENIENCE_RETAIL"] = "CONVENIENCE_RETAIL";
    CompanyStoreFilterOptions["DRUG"] = "DRUG";
    CompanyStoreFilterOptions["HOME_IMPROVEMENT"] = "HOME_IMPROVEMENT";
    CompanyStoreFilterOptions["LARGE_STORE"] = "LARGE_STORE";
    CompanyStoreFilterOptions["MY_STORES"] = "MY_STORES";
    CompanyStoreFilterOptions["NEEDS_AUDIT"] = "NEEDS_AUDIT";
    CompanyStoreFilterOptions["NEVER_AUDITED"] = "NEVER_AUDITED";
    CompanyStoreFilterOptions["VALUE"] = "VALUE";
})(exports.CompanyStoreFilterOptions || (exports.CompanyStoreFilterOptions = {}));
(function (CompanyStoreSortBy) {
    CompanyStoreSortBy["ALPHABETICAL_REVERSE"] = "ALPHABETICAL_REVERSE";
    CompanyStoreSortBy["ALPHABETICAL_STANDARD"] = "ALPHABETICAL_STANDARD";
    CompanyStoreSortBy["AUDITED_NEW_TO_OLD"] = "AUDITED_NEW_TO_OLD";
    CompanyStoreSortBy["AUDITED_OLD_TO_NEW"] = "AUDITED_OLD_TO_NEW";
    CompanyStoreSortBy["LOCATION_CLOSE_TO_FAR"] = "LOCATION_CLOSE_TO_FAR";
    CompanyStoreSortBy["LOCATION_FAR_TO_CLOSE"] = "LOCATION_FAR_TO_CLOSE";
})(exports.CompanyStoreSortBy || (exports.CompanyStoreSortBy = {}));
(function (CompanyUsersSortBy) {
    CompanyUsersSortBy["ALPHABETICAL_REVERSE"] = "ALPHABETICAL_REVERSE";
    CompanyUsersSortBy["ALPHABETICAL_STANDARD"] = "ALPHABETICAL_STANDARD";
})(exports.CompanyUsersSortBy || (exports.CompanyUsersSortBy = {}));
(function (ComplianceIssue) {
    ComplianceIssue["EMPTY_SLOTS"] = "EMPTY_SLOTS";
    ComplianceIssue["ENCROACHED"] = "ENCROACHED";
    ComplianceIssue["EXTRA_FACINGS"] = "EXTRA_FACINGS";
    ComplianceIssue["INCORRECT_LOCATION"] = "INCORRECT_LOCATION";
    ComplianceIssue["INCORRECT_ORIENTATION"] = "INCORRECT_ORIENTATION";
    ComplianceIssue["INCORRECT_PRODUCT"] = "INCORRECT_PRODUCT";
    ComplianceIssue["MIXED_FACING"] = "MIXED_FACING";
    ComplianceIssue["OUT_OF_STOCK"] = "OUT_OF_STOCK";
})(exports.ComplianceIssue || (exports.ComplianceIssue = {}));
(function (CompliancePlanogramProductOrientationChoices) {
    /** Front */
    CompliancePlanogramProductOrientationChoices["FRONT"] = "FRONT";
    /** Side */
    CompliancePlanogramProductOrientationChoices["SIDE"] = "SIDE";
    /** Top */
    CompliancePlanogramProductOrientationChoices["TOP"] = "TOP";
})(exports.CompliancePlanogramProductOrientationChoices || (exports.CompliancePlanogramProductOrientationChoices = {}));
(function (CompliancePlanogramTypeChoices) {
    /** Ideal Inventory State */
    CompliancePlanogramTypeChoices["IDEAL_INVENTORY"] = "IDEAL_INVENTORY";
    /** Modular Compliance */
    CompliancePlanogramTypeChoices["MODCOM"] = "MODCOM";
})(exports.CompliancePlanogramTypeChoices || (exports.CompliancePlanogramTypeChoices = {}));
(function (DAIGroupEnum) {
    DAIGroupEnum["AUDITORS"] = "AUDITORS";
    DAIGroupEnum["BRAND_AGENTS"] = "BRAND_AGENTS";
    DAIGroupEnum["COMPANY_ADMINS"] = "COMPANY_ADMINS";
    DAIGroupEnum["IMAGE_LABELERS"] = "IMAGE_LABELERS";
    DAIGroupEnum["IMAGE_REVIEWERS"] = "IMAGE_REVIEWERS";
    DAIGroupEnum["LABELERS"] = "LABELERS";
    DAIGroupEnum["MAPPERS"] = "MAPPERS";
    DAIGroupEnum["MAPPER_ADMINS"] = "MAPPER_ADMINS";
    DAIGroupEnum["MERCHANDISERS"] = "MERCHANDISERS";
    DAIGroupEnum["MERCH_MANAGERS"] = "MERCH_MANAGERS";
    DAIGroupEnum["PICOS"] = "PICOS";
    DAIGroupEnum["PLAN_COM"] = "PLAN_COM";
    DAIGroupEnum["PLAN_COM_AUDITOR"] = "PLAN_COM_AUDITOR";
    DAIGroupEnum["POINT_CLOUD_VERIFIERS"] = "POINT_CLOUD_VERIFIERS";
    DAIGroupEnum["QA"] = "QA";
    DAIGroupEnum["RED_ADMINS"] = "RED_ADMINS";
    DAIGroupEnum["RED_MANAGERS"] = "RED_MANAGERS";
    DAIGroupEnum["REPORT_VIEWERS"] = "REPORT_VIEWERS";
    DAIGroupEnum["SALES"] = "SALES";
    DAIGroupEnum["SALES_ADMINS"] = "SALES_ADMINS";
    DAIGroupEnum["SALES_MANAGERS"] = "SALES_MANAGERS";
    DAIGroupEnum["STORE_MAP_SCANNERS"] = "STORE_MAP_SCANNERS";
})(exports.DAIGroupEnum || (exports.DAIGroupEnum = {}));
(function (DateRangeType) {
    DateRangeType["NOW_VS_PAST"] = "NOW_VS_PAST";
    DateRangeType["YoY"] = "YoY";
})(exports.DateRangeType || (exports.DateRangeType = {}));
(function (DeviceType) {
    DeviceType["MOBILE"] = "MOBILE";
    DeviceType["TABLET"] = "TABLET";
})(exports.DeviceType || (exports.DeviceType = {}));
(function (DisplayActionType) {
    DisplayActionType["CREATED"] = "CREATED";
    DisplayActionType["EDITED"] = "EDITED";
    DisplayActionType["MOVED"] = "MOVED";
    DisplayActionType["RESTOCK"] = "RESTOCK";
    DisplayActionType["RETIRED"] = "RETIRED";
    DisplayActionType["SET_PLAN"] = "SET_PLAN";
    DisplayActionType["THREE_D"] = "THREE_D";
    DisplayActionType["TWO_D"] = "TWO_D";
})(exports.DisplayActionType || (exports.DisplayActionType = {}));
(function (DisplayElements) {
    DisplayElements["AD"] = "AD";
    DisplayElements["SUSTAIN"] = "SUSTAIN";
})(exports.DisplayElements || (exports.DisplayElements = {}));
(function (DisplaySalesVolume) {
    DisplaySalesVolume["HIGH"] = "HIGH";
    DisplaySalesVolume["LOW"] = "LOW";
    DisplaySalesVolume["MEDIUM"] = "MEDIUM";
})(exports.DisplaySalesVolume || (exports.DisplaySalesVolume = {}));
(function (DisplayTaskType) {
    DisplayTaskType["ADD_DISPLAY"] = "ADD_DISPLAY";
    DisplayTaskType["MOVE_DISPLAY"] = "MOVE_DISPLAY";
    DisplayTaskType["RESTOCK_DISPLAY"] = "RESTOCK_DISPLAY";
    DisplayTaskType["RETIRE_DISPLAY"] = "RETIRE_DISPLAY";
})(exports.DisplayTaskType || (exports.DisplayTaskType = {}));
(function (DisplayTypeAppRule) {
    DisplayTypeAppRule["CAN_SET_DEPTH"] = "CAN_SET_DEPTH";
    DisplayTypeAppRule["COOLER"] = "COOLER";
    DisplayTypeAppRule["EXCLUDE_PRESET_CUBE"] = "EXCLUDE_PRESET_CUBE";
    DisplayTypeAppRule["HAS_COOLER_DOORS"] = "HAS_COOLER_DOORS";
    DisplayTypeAppRule["HAS_DOOR_HANDLE"] = "HAS_DOOR_HANDLE";
    DisplayTypeAppRule["SLOTTED"] = "SLOTTED";
})(exports.DisplayTypeAppRule || (exports.DisplayTypeAppRule = {}));
(function (DisplaysAssociatedStoreTypesCategoryChoices) {
    /** Convenience Retail */
    DisplaysAssociatedStoreTypesCategoryChoices["CR"] = "CR";
    /** Drug */
    DisplaysAssociatedStoreTypesCategoryChoices["DR"] = "DR";
    /** Home Improvement */
    DisplaysAssociatedStoreTypesCategoryChoices["HM"] = "HM";
    /** Large */
    DisplaysAssociatedStoreTypesCategoryChoices["LG"] = "LG";
    /** Value */
    DisplaysAssociatedStoreTypesCategoryChoices["VL"] = "VL";
})(exports.DisplaysAssociatedStoreTypesCategoryChoices || (exports.DisplaysAssociatedStoreTypesCategoryChoices = {}));
(function (DisplaysDisplayAreaOldChoices) {
    /** Back Alley */
    DisplaysDisplayAreaOldChoices["BA"] = "BA";
    /** Bakery */
    DisplaysDisplayAreaOldChoices["BK"] = "BK";
    /** Deli */
    DisplaysDisplayAreaOldChoices["DL"] = "DL";
    /** Entrance */
    DisplaysDisplayAreaOldChoices["EN"] = "EN";
    /** Lobby */
    DisplaysDisplayAreaOldChoices["LO"] = "LO";
    /** Produce */
    DisplaysDisplayAreaOldChoices["PR"] = "PR";
    /** Secondary Floor */
    DisplaysDisplayAreaOldChoices["SF"] = "SF";
    /** Unknown */
    DisplaysDisplayAreaOldChoices["UN"] = "UN";
})(exports.DisplaysDisplayAreaOldChoices || (exports.DisplaysDisplayAreaOldChoices = {}));
(function (DoorHandlePlacement) {
    DoorHandlePlacement["LEFT"] = "LEFT";
    DoorHandlePlacement["MIDDLE"] = "MIDDLE";
    DoorHandlePlacement["RIGHT"] = "RIGHT";
    DoorHandlePlacement["SLIDING"] = "SLIDING";
})(exports.DoorHandlePlacement || (exports.DoorHandlePlacement = {}));
(function (ErrorLevel) {
    ErrorLevel["ERROR"] = "ERROR";
    ErrorLevel["WARNING"] = "WARNING";
})(exports.ErrorLevel || (exports.ErrorLevel = {}));
(function (FlagAppType) {
    FlagAppType["DISPLAYS"] = "DISPLAYS";
    FlagAppType["IMAGES"] = "IMAGES";
    FlagAppType["PRODUCTS"] = "PRODUCTS";
})(exports.FlagAppType || (exports.FlagAppType = {}));
(function (FlagModelType) {
    FlagModelType["DISPLAY_AUDIT_IMAGE"] = "DISPLAY_AUDIT_IMAGE";
    FlagModelType["DISPLAY_SEGMENT"] = "DISPLAY_SEGMENT";
    FlagModelType["PRODUCT"] = "PRODUCT";
})(exports.FlagModelType || (exports.FlagModelType = {}));
(function (FlaggedLevel) {
    FlaggedLevel["DELETE"] = "DELETE";
    FlaggedLevel["N_REVIEW"] = "N_REVIEW";
    FlaggedLevel["RED"] = "RED";
    FlaggedLevel["UNFLAG"] = "UNFLAG";
    FlaggedLevel["YELLOW"] = "YELLOW";
})(exports.FlaggedLevel || (exports.FlaggedLevel = {}));
(function (FlaggedType) {
    FlaggedType["COMMON"] = "COMMON";
    FlaggedType["IMAGE"] = "IMAGE";
    FlaggedType["PLANOGRAM_SEGMENT"] = "PLANOGRAM_SEGMENT";
    FlaggedType["PRODUCT"] = "PRODUCT";
    FlaggedType["STORE_MAP"] = "STORE_MAP";
})(exports.FlaggedType || (exports.FlaggedType = {}));
(function (ForStoreSize) {
    ForStoreSize["ALL"] = "ALL";
    ForStoreSize["DRUG"] = "DRUG";
    ForStoreSize["HOME_IMPROVEMENT"] = "HOME_IMPROVEMENT";
    ForStoreSize["LARGE"] = "LARGE";
    ForStoreSize["SMALL"] = "SMALL";
    ForStoreSize["VALUE"] = "VALUE";
})(exports.ForStoreSize || (exports.ForStoreSize = {}));
(function (GroupTypes) {
    GroupTypes["MERCH"] = "MERCH";
    GroupTypes["PICOS"] = "PICOS";
    GroupTypes["REDAUDIT"] = "REDAUDIT";
})(exports.GroupTypes || (exports.GroupTypes = {}));
(function (ImageType) {
    ImageType["AUDIT_ANSWER"] = "AUDIT_ANSWER";
    ImageType["DISPLAY"] = "DISPLAY";
    ImageType["DISPLAY_AUDIT"] = "DISPLAY_AUDIT";
    ImageType["DISPLAY_RESTOCK"] = "DISPLAY_RESTOCK";
    ImageType["EL_DORADO"] = "EL_DORADO";
    ImageType["IMAGE"] = "IMAGE";
    ImageType["MARKETING"] = "MARKETING";
    ImageType["MODCOM_COMPLIANCE"] = "MODCOM_COMPLIANCE";
    ImageType["MULTI_PRODUCT"] = "MULTI_PRODUCT";
    ImageType["PLANOGRAM"] = "PLANOGRAM";
    ImageType["PRODUCT"] = "PRODUCT";
    ImageType["SCAN"] = "SCAN";
    ImageType["STORE"] = "STORE";
    ImageType["TRAINING"] = "TRAINING";
    ImageType["USER"] = "USER";
})(exports.ImageType || (exports.ImageType = {}));
(function (InventoryProductInventoryTransactionMemoChoices) {
    /** Adjustment from manual count */
    InventoryProductInventoryTransactionMemoChoices["AD"] = "AD";
    /** Reset Inventory with new counts from 3D Scan */
    InventoryProductInventoryTransactionMemoChoices["PS"] = "PS";
    /** Return of damaged or expired product */
    InventoryProductInventoryTransactionMemoChoices["RE"] = "RE";
    /** Restock of product */
    InventoryProductInventoryTransactionMemoChoices["RS"] = "RS";
    /** Sale */
    InventoryProductInventoryTransactionMemoChoices["SA"] = "SA";
    /** Received shipment from main warehouse */
    InventoryProductInventoryTransactionMemoChoices["SH"] = "SH";
    /** Transfer of product */
    InventoryProductInventoryTransactionMemoChoices["TR"] = "TR";
})(exports.InventoryProductInventoryTransactionMemoChoices || (exports.InventoryProductInventoryTransactionMemoChoices = {}));
(function (InventoryTransactionMemo) {
    InventoryTransactionMemo["ADJUSTMENT"] = "ADJUSTMENT";
    InventoryTransactionMemo["POST_SCAN"] = "POST_SCAN";
    InventoryTransactionMemo["RESTOCK"] = "RESTOCK";
    InventoryTransactionMemo["RETURN"] = "RETURN";
    InventoryTransactionMemo["SALE"] = "SALE";
    InventoryTransactionMemo["SHIPMENT"] = "SHIPMENT";
    InventoryTransactionMemo["TRANSFER"] = "TRANSFER";
})(exports.InventoryTransactionMemo || (exports.InventoryTransactionMemo = {}));
(function (IssueType) {
    IssueType["DISPLAY_AUDIT"] = "DISPLAY_AUDIT";
})(exports.IssueType || (exports.IssueType = {}));
(function (LocalCompanyCategoryColumns) {
    LocalCompanyCategoryColumns["category"] = "category";
    LocalCompanyCategoryColumns["company_category_id"] = "company_category_id";
    LocalCompanyCategoryColumns["parent_category"] = "parent_category";
})(exports.LocalCompanyCategoryColumns || (exports.LocalCompanyCategoryColumns = {}));
(function (LocalFlavorColumns) {
    LocalFlavorColumns["display_flavor"] = "display_flavor";
    LocalFlavorColumns["flavor"] = "flavor";
})(exports.LocalFlavorColumns || (exports.LocalFlavorColumns = {}));
(function (LocalPackagingColumns) {
    LocalPackagingColumns["container"] = "container";
    LocalPackagingColumns["packaging_id"] = "packaging_id";
    LocalPackagingColumns["quantity"] = "quantity";
    LocalPackagingColumns["size"] = "size";
    LocalPackagingColumns["unit"] = "unit";
})(exports.LocalPackagingColumns || (exports.LocalPackagingColumns = {}));
(function (LocalProductColumns) {
    LocalProductColumns["appearances_in_audit"] = "appearances_in_audit";
    LocalProductColumns["brand"] = "brand";
    LocalProductColumns["brand_order"] = "brand_order";
    LocalProductColumns["category_order"] = "category_order";
    LocalProductColumns["common_name"] = "common_name";
    LocalProductColumns["company_category_id"] = "company_category_id";
    LocalProductColumns["geometry_id"] = "geometry_id";
    LocalProductColumns["is_active"] = "is_active";
    LocalProductColumns["manufacturer"] = "manufacturer";
    LocalProductColumns["marketing_image_url"] = "marketing_image_url";
    LocalProductColumns["name"] = "name";
    LocalProductColumns["packaging_id"] = "packaging_id";
    LocalProductColumns["planogram_thumbnail_image_url"] = "planogram_thumbnail_image_url";
    LocalProductColumns["product_id"] = "product_id";
    LocalProductColumns["product_order"] = "product_order";
    LocalProductColumns["shipping_id"] = "shipping_id";
    LocalProductColumns["upc_a"] = "upc_a";
    LocalProductColumns["upc_e"] = "upc_e";
})(exports.LocalProductColumns || (exports.LocalProductColumns = {}));
(function (LocalProductFlavorRelationColumns) {
    LocalProductFlavorRelationColumns["flavor"] = "flavor";
    LocalProductFlavorRelationColumns["product_id"] = "product_id";
})(exports.LocalProductFlavorRelationColumns || (exports.LocalProductFlavorRelationColumns = {}));
(function (LocalShippingColumns) {
    LocalShippingColumns["consumables_per_case"] = "consumables_per_case";
    LocalShippingColumns["products_per_case"] = "products_per_case";
    LocalShippingColumns["shipping_id"] = "shipping_id";
})(exports.LocalShippingColumns || (exports.LocalShippingColumns = {}));
(function (LocalVersionColumns) {
    LocalVersionColumns["last_updated"] = "last_updated";
})(exports.LocalVersionColumns || (exports.LocalVersionColumns = {}));
(function (MLModelType) {
    MLModelType["BEV"] = "BEV";
    MLModelType["BINARY"] = "BINARY";
    MLModelType["DAI_ZERO"] = "DAI_ZERO";
    MLModelType["DENSITY_NEONET"] = "DENSITY_NEONET";
    MLModelType["META"] = "META";
    MLModelType["NEONET"] = "NEONET";
    MLModelType["POINT_BEAM_SCORER"] = "POINT_BEAM_SCORER";
})(exports.MLModelType || (exports.MLModelType = {}));
(function (MLPurpose) {
    MLPurpose["TRAINING"] = "TRAINING";
    MLPurpose["VALIDATION"] = "VALIDATION";
})(exports.MLPurpose || (exports.MLPurpose = {}));
(function (MandateTypes) {
    MandateTypes["HQ"] = "HQ";
    MandateTypes["LOCAL"] = "LOCAL";
})(exports.MandateTypes || (exports.MandateTypes = {}));
(function (MapsStoreAreaDefaultForStoreSizeChoices) {
    /** all */
    MapsStoreAreaDefaultForStoreSizeChoices["AL"] = "AL";
    /** small */
    MapsStoreAreaDefaultForStoreSizeChoices["CR"] = "CR";
    /** drug */
    MapsStoreAreaDefaultForStoreSizeChoices["DR"] = "DR";
    /** home improvement */
    MapsStoreAreaDefaultForStoreSizeChoices["HM"] = "HM";
    /** large */
    MapsStoreAreaDefaultForStoreSizeChoices["LG"] = "LG";
    /** value */
    MapsStoreAreaDefaultForStoreSizeChoices["VL"] = "VL";
})(exports.MapsStoreAreaDefaultForStoreSizeChoices || (exports.MapsStoreAreaDefaultForStoreSizeChoices = {}));
(function (MerchandiserScanType) {
    MerchandiserScanType["ADJUSTMENT"] = "ADJUSTMENT";
    MerchandiserScanType["PRESCAN"] = "PRESCAN";
    MerchandiserScanType["RESTOCK"] = "RESTOCK";
})(exports.MerchandiserScanType || (exports.MerchandiserScanType = {}));
(function (MerchandisingAction) {
    MerchandisingAction["NONE"] = "NONE";
    MerchandisingAction["THREE_D"] = "THREE_D";
    MerchandisingAction["TWO_D"] = "TWO_D";
})(exports.MerchandisingAction || (exports.MerchandisingAction = {}));
(function (MerchandisingState) {
    MerchandisingState["EXCLUDED"] = "EXCLUDED";
    MerchandisingState["OPTIMIZED"] = "OPTIMIZED";
    MerchandisingState["OPTIMIZING"] = "OPTIMIZING";
    MerchandisingState["REMOVED"] = "REMOVED";
    MerchandisingState["UNOPTIMIZED"] = "UNOPTIMIZED";
})(exports.MerchandisingState || (exports.MerchandisingState = {}));
(function (OrderByDirection) {
    OrderByDirection["ASCENDING"] = "ASCENDING";
    OrderByDirection["DESCENDING"] = "DESCENDING";
})(exports.OrderByDirection || (exports.OrderByDirection = {}));
(function (PackagingType) {
    PackagingType["ALUMINUM_BOTTLE"] = "ALUMINUM_BOTTLE";
    PackagingType["BAG"] = "BAG";
    PackagingType["BOTTLE"] = "BOTTLE";
    PackagingType["BOX"] = "BOX";
    PackagingType["CAN"] = "CAN";
    PackagingType["CANISTER"] = "CANISTER";
    PackagingType["CARTON"] = "CARTON";
    PackagingType["GLASS_BOTTLE"] = "GLASS_BOTTLE";
    PackagingType["JAR"] = "JAR";
    PackagingType["PACKET"] = "PACKET";
})(exports.PackagingType || (exports.PackagingType = {}));
(function (PackagingUnits) {
    PackagingUnits["GALLONS"] = "GALLONS";
    PackagingUnits["LITERS"] = "LITERS";
    PackagingUnits["MILLILITERS"] = "MILLILITERS";
    PackagingUnits["OUNCES"] = "OUNCES";
})(exports.PackagingUnits || (exports.PackagingUnits = {}));
(function (PerformanceReportFilter) {
    PerformanceReportFilter["DISPLAYS"] = "DISPLAYS";
    PerformanceReportFilter["ROUTES"] = "ROUTES";
    PerformanceReportFilter["STORES"] = "STORES";
    PerformanceReportFilter["TERRITORIES"] = "TERRITORIES";
})(exports.PerformanceReportFilter || (exports.PerformanceReportFilter = {}));
(function (Period) {
    Period["ALL_TIME"] = "ALL_TIME";
    Period["DAY"] = "DAY";
    Period["MONTH"] = "MONTH";
    Period["QUARTER"] = "QUARTER";
    Period["WEEK"] = "WEEK";
    Period["YEAR"] = "YEAR";
})(exports.Period || (exports.Period = {}));
(function (PlanogramProductOrientation) {
    PlanogramProductOrientation["FRONT"] = "FRONT";
    PlanogramProductOrientation["SIDE"] = "SIDE";
    PlanogramProductOrientation["TOP"] = "TOP";
})(exports.PlanogramProductOrientation || (exports.PlanogramProductOrientation = {}));
(function (PlanogramStatus) {
    PlanogramStatus["APPROVED"] = "APPROVED";
    PlanogramStatus["DENIED"] = "DENIED";
    PlanogramStatus["DRAFT"] = "DRAFT";
    PlanogramStatus["EFFECTIVE"] = "EFFECTIVE";
    PlanogramStatus["EXPIRED"] = "EXPIRED";
    PlanogramStatus["ORPHANED"] = "ORPHANED";
})(exports.PlanogramStatus || (exports.PlanogramStatus = {}));
(function (ProductSortBy) {
    ProductSortBy["AUDIT_APP_HIGH_TO_LOW"] = "AUDIT_APP_HIGH_TO_LOW";
    ProductSortBy["AUDIT_APP_LOW_TO_HIGH"] = "AUDIT_APP_LOW_TO_HIGH";
    ProductSortBy["RECENTLY_ADDED"] = "RECENTLY_ADDED";
    ProductSortBy["RECENTLY_MODIFIED"] = "RECENTLY_MODIFIED";
})(exports.ProductSortBy || (exports.ProductSortBy = {}));
(function (ProductTypeEnum) {
    ProductTypeEnum["BOTTLE_20OZ"] = "BOTTLE_20OZ";
    ProductTypeEnum["CANBOX_12OZ_8"] = "CANBOX_12OZ_8";
    ProductTypeEnum["CANBOX_12OZ_24"] = "CANBOX_12OZ_24";
    ProductTypeEnum["CANBOX_16OZ_4"] = "CANBOX_16OZ_4";
    ProductTypeEnum["CAN_7_5OZ_6"] = "CAN_7_5OZ_6";
    ProductTypeEnum["CAN_16OZ"] = "CAN_16OZ";
    ProductTypeEnum["CEREALBOX"] = "CEREALBOX";
    ProductTypeEnum["DOYPACK"] = "DOYPACK";
    ProductTypeEnum["FLATSIDEBOTTLE_17OZ"] = "FLATSIDEBOTTLE_17OZ";
    ProductTypeEnum["GATORADEBOTTLE_12OZ_12"] = "GATORADEBOTTLE_12OZ_12";
    ProductTypeEnum["GATORADEBOTTLE_20OZ"] = "GATORADEBOTTLE_20OZ";
    ProductTypeEnum["GATORADEBOTTLE_20OZ_8"] = "GATORADEBOTTLE_20OZ_8";
    ProductTypeEnum["GATORADEBOTTLE_32OZ"] = "GATORADEBOTTLE_32OZ";
    ProductTypeEnum["ISOTONICBOTTLE_16OZ"] = "ISOTONICBOTTLE_16OZ";
    ProductTypeEnum["LAYS"] = "LAYS";
    ProductTypeEnum["ONELITER"] = "ONELITER";
    ProductTypeEnum["SIXPACK"] = "SIXPACK";
    ProductTypeEnum["SLIMCAN_12OZ"] = "SLIMCAN_12OZ";
    ProductTypeEnum["TWELVEPACK"] = "TWELVEPACK";
    ProductTypeEnum["TWOLITER"] = "TWOLITER";
    ProductTypeEnum["WRAPPEDFLATSIDEBOTTLE_17OZ_6"] = "WRAPPEDFLATSIDEBOTTLE_17OZ_6";
    ProductTypeEnum["WRAPPEDFLATSIDEBOTTLE_17OZ_12"] = "WRAPPEDFLATSIDEBOTTLE_17OZ_12";
    ProductTypeEnum["WRAPPEDFLATSIDEBOTTLE_17OZ_24"] = "WRAPPEDFLATSIDEBOTTLE_17OZ_24";
})(exports.ProductTypeEnum || (exports.ProductTypeEnum = {}));
(function (ProductsPackagingContainerChoices) {
    ProductsPackagingContainerChoices["ALUMINUM_BOTTLE"] = "ALUMINUM_BOTTLE";
    ProductsPackagingContainerChoices["BAG"] = "BAG";
    ProductsPackagingContainerChoices["BOTTLE"] = "BOTTLE";
    ProductsPackagingContainerChoices["BOX"] = "BOX";
    ProductsPackagingContainerChoices["CAN"] = "CAN";
    ProductsPackagingContainerChoices["CANISTER"] = "CANISTER";
    ProductsPackagingContainerChoices["CARTON"] = "CARTON";
    ProductsPackagingContainerChoices["GLASS_BOTTLE"] = "GLASS_BOTTLE";
    ProductsPackagingContainerChoices["JAR"] = "JAR";
    ProductsPackagingContainerChoices["PACKET"] = "PACKET";
})(exports.ProductsPackagingContainerChoices || (exports.ProductsPackagingContainerChoices = {}));
(function (ProductsPackagingUnitChoices) {
    ProductsPackagingUnitChoices["G"] = "G";
    ProductsPackagingUnitChoices["L"] = "L";
    ProductsPackagingUnitChoices["ML"] = "ML";
    ProductsPackagingUnitChoices["OZ"] = "OZ";
})(exports.ProductsPackagingUnitChoices || (exports.ProductsPackagingUnitChoices = {}));
(function (ProductsProductSourceChoices) {
    ProductsProductSourceChoices["COKE_PLANOGRAM"] = "COKE_PLANOGRAM";
    ProductsProductSourceChoices["KROGER"] = "KROGER";
    ProductsProductSourceChoices["OTHER"] = "OTHER";
    ProductsProductSourceChoices["SALSIFY"] = "SALSIFY";
    ProductsProductSourceChoices["SWIRE"] = "SWIRE";
    ProductsProductSourceChoices["TARGET"] = "TARGET";
    ProductsProductSourceChoices["WALMART"] = "WALMART";
})(exports.ProductsProductSourceChoices || (exports.ProductsProductSourceChoices = {}));
(function (RestockAdjustmentType) {
    RestockAdjustmentType["RESTOCK"] = "RESTOCK";
    RestockAdjustmentType["SET_INVENTORY"] = "SET_INVENTORY";
})(exports.RestockAdjustmentType || (exports.RestockAdjustmentType = {}));
(function (ScanPurpose) {
    ScanPurpose["AUDIT"] = "AUDIT";
    ScanPurpose["MBF_ACTIVITY"] = "MBF_ACTIVITY";
    ScanPurpose["POST_RESTOCK"] = "POST_RESTOCK";
    ScanPurpose["PRE_RESTOCK"] = "PRE_RESTOCK";
    ScanPurpose["TRAINING"] = "TRAINING";
})(exports.ScanPurpose || (exports.ScanPurpose = {}));
(function (ScanType) {
    ScanType["THREE_D"] = "THREE_D";
    ScanType["TWO_D"] = "TWO_D";
})(exports.ScanType || (exports.ScanType = {}));
(function (SceneTypeEnum) {
    SceneTypeEnum["AISLE"] = "AISLE";
    SceneTypeEnum["CASE_STACK"] = "CASE_STACK";
    SceneTypeEnum["COLD_VAULT"] = "COLD_VAULT";
    SceneTypeEnum["FRIDGE"] = "FRIDGE";
    SceneTypeEnum["FRIDGE_EC"] = "FRIDGE_EC";
    SceneTypeEnum["MIXED_SNACKS"] = "MIXED_SNACKS";
    SceneTypeEnum["ONE_SIDED_ENDCAP"] = "ONE_SIDED_ENDCAP";
    SceneTypeEnum["PALLET_DROP"] = "PALLET_DROP";
    SceneTypeEnum["SHELF"] = "SHELF";
    SceneTypeEnum["SNACKS"] = "SNACKS";
    SceneTypeEnum["STANDALONE_RACK"] = "STANDALONE_RACK";
    SceneTypeEnum["THREE_SIDED_ENDCAP"] = "THREE_SIDED_ENDCAP";
    SceneTypeEnum["TWO_SIDED_ENDCAP"] = "TWO_SIDED_ENDCAP";
})(exports.SceneTypeEnum || (exports.SceneTypeEnum = {}));
(function (SimpleUserProductivityModelOptions) {
    SimpleUserProductivityModelOptions["TEAM"] = "TEAM";
    SimpleUserProductivityModelOptions["USER"] = "USER";
})(exports.SimpleUserProductivityModelOptions || (exports.SimpleUserProductivityModelOptions = {}));
(function (SortBy) {
    SortBy["ADDRESS"] = "ADDRESS";
    SortBy["CATEGORY"] = "CATEGORY";
    SortBy["CHAIN"] = "CHAIN";
    SortBy["CUSTOMER_ID"] = "CUSTOMER_ID";
    SortBy["FORMULA_GROUP"] = "FORMULA_GROUP";
    SortBy["IS_ACTIVE"] = "IS_ACTIVE";
    SortBy["REGION"] = "REGION";
    SortBy["STORE_NAME"] = "STORE_NAME";
})(exports.SortBy || (exports.SortBy = {}));
(function (SortByDirection) {
    SortByDirection["ASCENDING"] = "ASCENDING";
    SortByDirection["DESCENDING"] = "DESCENDING";
})(exports.SortByDirection || (exports.SortByDirection = {}));
(function (SortIssueBy) {
    SortIssueBy["CREATED"] = "CREATED";
    SortIssueBy["DISPLAY"] = "DISPLAY";
    SortIssueBy["ISSUE_TYPES"] = "ISSUE_TYPES";
    SortIssueBy["IS_RESOLVED"] = "IS_RESOLVED";
    SortIssueBy["REASON"] = "REASON";
    SortIssueBy["STORE_NAME"] = "STORE_NAME";
})(exports.SortIssueBy || (exports.SortIssueBy = {}));
(function (SortIssueDirection) {
    SortIssueDirection["ASCENDING"] = "ASCENDING";
    SortIssueDirection["DESCENDING"] = "DESCENDING";
})(exports.SortIssueDirection || (exports.SortIssueDirection = {}));
(function (StoreActionType) {
    StoreActionType["EDITED"] = "EDITED";
    StoreActionType["PAUSED"] = "PAUSED";
    StoreActionType["RESUMED"] = "RESUMED";
    StoreActionType["STOPPED"] = "STOPPED";
})(exports.StoreActionType || (exports.StoreActionType = {}));
(function (StoreCategory) {
    StoreCategory["CR"] = "CR";
    StoreCategory["DR"] = "DR";
    StoreCategory["HM"] = "HM";
    StoreCategory["LG"] = "LG";
    StoreCategory["VL"] = "VL";
})(exports.StoreCategory || (exports.StoreCategory = {}));
(function (StoreDisplaysFilterOptions) {
    StoreDisplaysFilterOptions["CASE_STACKS"] = "CASE_STACKS";
    StoreDisplaysFilterOptions["COLD_VAULT"] = "COLD_VAULT";
    StoreDisplaysFilterOptions["COOLER"] = "COOLER";
    StoreDisplaysFilterOptions["END_CAP"] = "END_CAP";
    StoreDisplaysFilterOptions["OTHER"] = "OTHER";
    StoreDisplaysFilterOptions["PALLET_DROP"] = "PALLET_DROP";
    StoreDisplaysFilterOptions["STANDALONE_RACK"] = "STANDALONE_RACK";
})(exports.StoreDisplaysFilterOptions || (exports.StoreDisplaysFilterOptions = {}));
(function (StoreDisplaysSortBy) {
    StoreDisplaysSortBy["CREATED"] = "CREATED";
    StoreDisplaysSortBy["CREATED_REVERSE"] = "CREATED_REVERSE";
    StoreDisplaysSortBy["STORE_AREA_ALPHABETICAL_REVERSE"] = "STORE_AREA_ALPHABETICAL_REVERSE";
    StoreDisplaysSortBy["STORE_AREA_ALPHABETICAL_STANDARD"] = "STORE_AREA_ALPHABETICAL_STANDARD";
})(exports.StoreDisplaysSortBy || (exports.StoreDisplaysSortBy = {}));
(function (StoreFilter) {
    StoreFilter["NEEDS_TO_BE_AUDITED"] = "NEEDS_TO_BE_AUDITED";
})(exports.StoreFilter || (exports.StoreFilter = {}));
(function (StoreFilterOut) {
    StoreFilterOut["NO_NEED_FOR_AUDIT"] = "NO_NEED_FOR_AUDIT";
})(exports.StoreFilterOut || (exports.StoreFilterOut = {}));
(function (StoreOrderBy) {
    StoreOrderBy["CITY"] = "CITY";
    StoreOrderBy["DISTANCE"] = "DISTANCE";
    StoreOrderBy["NOTIFICATIONS"] = "NOTIFICATIONS";
    StoreOrderBy["RECENT_AUDIT_FIRST"] = "RECENT_AUDIT_FIRST";
    StoreOrderBy["RECENT_AUDIT_LAST"] = "RECENT_AUDIT_LAST";
    StoreOrderBy["STATE"] = "STATE";
    StoreOrderBy["STORE_NAME"] = "STORE_NAME";
})(exports.StoreOrderBy || (exports.StoreOrderBy = {}));
(function (StoreTaskFilterOptions) {
    StoreTaskFilterOptions["COMPLETE"] = "COMPLETE";
    StoreTaskFilterOptions["NOT_COMPLETE"] = "NOT_COMPLETE";
})(exports.StoreTaskFilterOptions || (exports.StoreTaskFilterOptions = {}));
(function (StoreTaskSortBy) {
    StoreTaskSortBy["COMPLETE"] = "COMPLETE";
    StoreTaskSortBy["CREATED"] = "CREATED";
    StoreTaskSortBy["CREATED_REVERSE"] = "CREATED_REVERSE";
    StoreTaskSortBy["NOT_COMPLETE"] = "NOT_COMPLETE";
})(exports.StoreTaskSortBy || (exports.StoreTaskSortBy = {}));
(function (StoresStoreCategoryChoices) {
    /** Convenience Retail */
    StoresStoreCategoryChoices["CR"] = "CR";
    /** Drug */
    StoresStoreCategoryChoices["DR"] = "DR";
    /** Home Improvement */
    StoresStoreCategoryChoices["HM"] = "HM";
    /** Large */
    StoresStoreCategoryChoices["LG"] = "LG";
    /** Value */
    StoresStoreCategoryChoices["VL"] = "VL";
})(exports.StoresStoreCategoryChoices || (exports.StoresStoreCategoryChoices = {}));
(function (UploadStatus) {
    UploadStatus["COMPLETE"] = "COMPLETE";
    UploadStatus["FAILED"] = "FAILED";
    UploadStatus["PENDING"] = "PENDING";
})(exports.UploadStatus || (exports.UploadStatus = {}));
(function (UserProductivityModelOptions) {
    UserProductivityModelOptions["DISPLAY"] = "DISPLAY";
    UserProductivityModelOptions["STORE"] = "STORE";
    UserProductivityModelOptions["TEAM"] = "TEAM";
    UserProductivityModelOptions["USER"] = "USER";
})(exports.UserProductivityModelOptions || (exports.UserProductivityModelOptions = {}));
(function (UsersFCMTokenDeviceTypeChoices) {
    /** Mobile */
    UsersFCMTokenDeviceTypeChoices["MOBILE"] = "MOBILE";
    /** Tablet */
    UsersFCMTokenDeviceTypeChoices["TABLET"] = "TABLET";
})(exports.UsersFCMTokenDeviceTypeChoices || (exports.UsersFCMTokenDeviceTypeChoices = {}));
(function (VerificationDecision) {
    VerificationDecision["FAIL"] = "FAIL";
    VerificationDecision["PASS"] = "PASS";
})(exports.VerificationDecision || (exports.VerificationDecision = {}));
(function (VerifiedLocation) {
    VerifiedLocation["FIELD"] = "FIELD";
    VerifiedLocation["FIELD_AND_WHTE_RBT"] = "FIELD_AND_WHTE_RBT";
    VerifiedLocation["WHTE_RBT"] = "WHTE_RBT";
})(exports.VerifiedLocation || (exports.VerifiedLocation = {}));
(function (ZoneTier) {
    ZoneTier["DISTRICT"] = "DISTRICT";
    ZoneTier["ROUTE"] = "ROUTE";
    ZoneTier["TERRITORY"] = "TERRITORY";
})(exports.ZoneTier || (exports.ZoneTier = {}));
}(gnarniaGeneratedTypes));

var sabreGeneratedTypes = {};

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.SabreProductImageType = exports.SabreProductImageOrientation = exports.SabrePackagingUnits = exports.SabrePackagingType = void 0;
(function (SabrePackagingType) {
    SabrePackagingType["ALUMINUM_BOTTLE"] = "ALUMINUM_BOTTLE";
    SabrePackagingType["BAG"] = "BAG";
    SabrePackagingType["BOTTLE"] = "BOTTLE";
    SabrePackagingType["BOX"] = "BOX";
    SabrePackagingType["CAN"] = "CAN";
    SabrePackagingType["CANISTER"] = "CANISTER";
    SabrePackagingType["CARTON"] = "CARTON";
    SabrePackagingType["GLASS_BOTTLE"] = "GLASS_BOTTLE";
    SabrePackagingType["JAR"] = "JAR";
    SabrePackagingType["PACKET"] = "PACKET";
})(exports.SabrePackagingType || (exports.SabrePackagingType = {}));
(function (SabrePackagingUnits) {
    SabrePackagingUnits["G"] = "G";
    SabrePackagingUnits["L"] = "L";
    SabrePackagingUnits["ML"] = "ML";
    SabrePackagingUnits["OZ"] = "OZ";
})(exports.SabrePackagingUnits || (exports.SabrePackagingUnits = {}));
(function (SabreProductImageOrientation) {
    SabreProductImageOrientation["FRONT"] = "FRONT";
    SabreProductImageOrientation["SIDE"] = "SIDE";
    SabreProductImageOrientation["TOP"] = "TOP";
})(exports.SabreProductImageOrientation || (exports.SabreProductImageOrientation = {}));
(function (SabreProductImageType) {
    SabreProductImageType["FIELD_GENERATED"] = "FIELD_GENERATED";
    SabreProductImageType["MARKETING"] = "MARKETING";
    SabreProductImageType["PLANOGRAM"] = "PLANOGRAM";
})(exports.SabreProductImageType || (exports.SabreProductImageType = {}));
}(sabreGeneratedTypes));

var intermediateTypes = {};

Object.defineProperty(intermediateTypes, "__esModule", { value: true });

var generatedIntrospectionSchema = {};

Object.defineProperty(generatedIntrospectionSchema, "__esModule", { value: true });
var result = {
    "possibleTypes": {
        "FlaggableObject": [
            "AuditAnswerImage",
            "DisplayAuditImage",
            "DisplayImage",
            "DisplaySegment",
            "DisplayTypeImage",
            "Image",
            "IndoorMap",
            "MerchandiserDisplayScanImage",
            "ModcomComplianceImage",
            "MultiProductImage",
            "PicosImage",
            "PlanogramSegmentFlaggedIssueImage",
            "Product",
            "ProductImage",
            "ProductMarketingImage",
            "ScanImage",
            "StoreImage",
            "TrainingImage",
            "UserImage"
        ],
        "ImageBase": [
            "AuditAnswerImage",
            "DisplayAuditImage",
            "DisplayImage",
            "DisplayTypeImage",
            "Image",
            "MerchandiserDisplayScanImage",
            "ModcomComplianceImage",
            "MultiProductImage",
            "PicosImage",
            "PlanogramProductImage",
            "PlanogramSegmentFlaggedIssueImage",
            "ProductImage",
            "ProductMarketingImage",
            "ScanImage",
            "StoreImage",
            "TrainingImage",
            "UserImage"
        ],
        "PicOSGroupStatsBase": [
            "PicOSAllCustomersStats",
            "PicOSCustomerStats",
            "PicOSGroupStats",
            "PicOSRegionalStats"
        ],
        "PointCloudBase": [
            "DisplayAuditPointCloud",
            "DisplayRestockPointCloud",
            "MerchandiserPointCloud",
            "SingleProductPointCloud",
            "SyntheticPointCloud",
            "TrainingPointCloud"
        ],
        "StoreTask": [
            "DisplayTask"
        ],
        "TaskBase": [
            "DisplayTask"
        ],
        "VideoBase": [
            "MultiProductVideo"
        ]
    }
};
generatedIntrospectionSchema.default = result;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatedIntrospectionSchema = void 0;
__exportStar(fragments$1, exports);
__exportStar(queries$2, exports);
__exportStar(mutations$2, exports);
__exportStar(fragments, exports);
__exportStar(queries$1, exports);
__exportStar(mutations$1, exports);
// export * from './src/ml-ultra/fragments'
__exportStar(queries, exports);
__exportStar(mutations, exports);
// export * from './sabre-generated-types'
// export * from './mlultra-generated-types'
__exportStar(gnarniaGeneratedTypes, exports);
__exportStar(sabreGeneratedTypes, exports);
__exportStar(intermediateTypes, exports);
var generated_introspection_schema_1 = generatedIntrospectionSchema;
Object.defineProperty(exports, "generatedIntrospectionSchema", { enumerable: true, get: function () { return generated_introspection_schema_1.default; } });
}(lib$4));

var lodash = {exports: {}};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
}(lodash, lodash.exports));

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var titleCase = function (string) {
    return string.replace(/(?:^|\s|-|_)\S/g, function (a) {
        return a.toUpperCase();
    });
};
var uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
var isUUID = function (string) { return uuidRegex.test(string); };
var plurality$1 = function (word, count, ignore) {
    if (ignore && ignore.includes(word.toLowerCase()))
        return word;
    var plural = count === 1 || word.endsWith('s') ? '' : 's';
    return "".concat(word).concat(plural);
};
var truncateText = function (input, charLimit) {
    if (input.length > charLimit) {
        input = input.slice(0, charLimit - 3).concat('...');
    }
    return input;
};
var isNullOrEmpty = function (str) {
    return str === null || str === undefined || str.length <= 0;
};
var enumValue = function (description) {
    return description
        .split(' ')
        .map(function (word) { return word.toUpperCase(); })
        .join('_');
};
var stringValue = function (enumValue, separator) {
    if (separator === void 0) { separator = '_'; }
    return titleCase(enumValue
        .split(separator)
        .map(function (word) { return word.toLowerCase(); })
        .join(' '));
};
var camelCaseToTitleCase = function (word) { return lodash.exports.startCase(word); };
var commaList = function (items, conjunction) {
    var length = items.length;
    if (length === 1) {
        return items;
    }
    if (length === 2) {
        return [items[0], " ".concat(conjunction, " "), items[1]];
    }
    return items.reduce(function (prevArray, item, index) {
        if (index === length - 1) {
            return __spreadArray$5(__spreadArray$5([], prevArray, true), [item], false);
        }
        else {
            var add = index === length - 2 ? ", ".concat(conjunction, " ") : ', ';
            return __spreadArray$5(__spreadArray$5([], prevArray, true), [item, add], false);
        }
    }, []);
};
var StringHelpers = {
    titleCase: titleCase,
    isUUID: isUUID,
    plurality: plurality$1,
    truncateText: truncateText,
    isNullOrEmpty: isNullOrEmpty,
    enumValue: enumValue,
    stringValue: stringValue,
    camelCaseToTitleCase: camelCaseToTitleCase,
    commaList: commaList,
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var formatProductName = function (product) {
    var flavors = product.flavors
        ? product.flavors
            .filter(function (currFlavor, idx, self) {
            var restOfList = self.filter(function (flavor) { return flavor !== currFlavor; });
            return (!product
                .brand.name.toLowerCase()
                .includes(currFlavor.toLowerCase()) &&
                !restOfList
                    .map(function (k) {
                    return k.toLowerCase().includes(currFlavor.toLowerCase());
                })
                    .some(function (include) { return include; }));
        })
            .join(' ')
        : '';
    var packaging = getPackagingDescription(product);
    return flavors.length > 0
        ? "".concat(StringHelpers.titleCase(product.brand.name), " ").concat(flavors, " ").concat(packaging)
        : "".concat(StringHelpers.titleCase(product.brand.name), " ").concat(packaging);
};
var getPackagingDescription = function (product) {
    var _a, _b, _c, _d;
    var container = ((_a = product.packaging) === null || _a === void 0 ? void 0 : _a.container)
        ? StringHelpers.titleCase(StringHelpers.stringValue(product.packaging.container))
        : '';
    var size = ((_b = product.packaging) === null || _b === void 0 ? void 0 : _b.size)
        ? product.packaging.size.toString().replace('.0', '')
        : '';
    var unit = ((_c = product.packaging) === null || _c === void 0 ? void 0 : _c.unit)
        ? product.packaging.unit === 'L'
            ? formatEnumUnits(product.packaging.unit)
            : formatEnumUnits(product.packaging.unit).toLowerCase()
        : '';
    return ((_d = product.packaging) === null || _d === void 0 ? void 0 : _d.quantity) && product.packaging.quantity > 1
        ? "".concat(product.packaging.quantity, " - ").concat(size).concat(unit, " ").concat(container, "s")
        : "".concat(size).concat(unit, " ").concat(container);
};
var mapEnumUnits = function (units) {
    if (!units) {
        return null;
    }
    switch (units) {
        case 'OZ':
            return 'OUNCES';
        case 'L':
            return 'LITERS';
        case 'G':
            return 'GALLONS';
        case 'ml':
            return 'MILLILITERS';
        case 'ML':
            return 'MILLILITERS';
        default:
            return units;
    }
};
var formatEnumUnits = function (units) {
    switch (units) {
        case 'OUNCES':
            return 'OZ';
        case 'LITERS':
            return 'L';
        case 'GALLONS':
            return 'G';
        case 'MILLILITERS':
            return 'ml';
        default:
            return units;
    }
};
var includesReplaceEnumUnits = function (units) {
    var loweredUnits = units.toLowerCase();
    if (loweredUnits.includes('ounces'))
        return 'oz';
    else if (loweredUnits.includes('milliliters'))
        return 'ml';
    else if (loweredUnits.includes('liters'))
        return 'L';
    else if (loweredUnits.includes('gallons'))
        return 'G';
    return units;
};
var getPackagingUnitEnumForMutation = function (units) {
    var loweredUnits = units.toLowerCase();
    if (loweredUnits.includes('ounces') || loweredUnits.includes('oz'))
        return lib$4.PackagingUnits.OUNCES;
    else if (loweredUnits.includes('milliliters') || loweredUnits.includes('ml'))
        return lib$4.PackagingUnits.MILLILITERS;
    else if (loweredUnits.includes('liters') || loweredUnits == 'l')
        return lib$4.PackagingUnits.LITERS;
    else if (loweredUnits.includes('gallons') || loweredUnits.includes('g'))
        return lib$4.PackagingUnits.GALLONS;
    throw Error("No packaging units found for ".concat(units));
};
var hasValidGeneratedName = function (product) {
    return ((product.packaging &&
        product.packaging.container &&
        product.packaging.unit &&
        product.packaging.size &&
        product.packaging.quantity &&
        product.brand &&
        product.brand.name &&
        !product.flagged) ||
        false);
};
var getPackagingName = function (packaging) {
    var container = packaging.container
        ? StringHelpers.titleCase(packaging.container.replace('_', ' '))
        : '';
    var size = packaging.size ? packaging.size.toString().replace('.0', '') : '';
    var unit = packaging.unit
        ? packaging.unit === 'L'
            ? packaging.unit + ' '
            : packaging.unit.toLowerCase() + ' '
        : '';
    return packaging.quantity && packaging.quantity > 1
        ? "".concat(packaging.quantity, " - ").concat(size).concat(unit).concat(container, "s")
        : "".concat(size).concat(unit).concat(container);
};
var ProductFormattingHelpers = {
    formatProductName: formatProductName,
    formatEnumUnits: formatEnumUnits,
    mapEnumUnits: mapEnumUnits,
    getPackagingUnitEnumForMutation: getPackagingUnitEnumForMutation,
    hasValidGeneratedName: hasValidGeneratedName,
    getPackagingDescription: getPackagingDescription,
    getPackagingName: getPackagingName,
    includesReplaceEnumUnits: includesReplaceEnumUnits,
};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Andrew Merrill <andrew.merrill@deliciousai.com>
 */
var ProductDetailRaw = function (props) {
    var _a;
    var product = props.product; props.rightAddOn; props.InfoIcon; props.showVerifiedIcon; props.overflowWrap; props.simple;
    isProductType(product) ? product.name : product.description;
    isProductType(product) ? product.brand : null;
    isProductType(product)
        ? ProductFormattingHelpers.getPackagingDescription(product)
        : null;
    isProductType(product) ? product.upcA : product.id;
    isProductType(product)
        ? ((_a = product.primaryMarketingImage) === null || _a === void 0 ? void 0 : _a.url) || product.marketingImageUrl
        : product.marketingImageUrl;
    var _e = React.useState(false); _e[0]; _e[1];
    var _f = React.useState(false); _f[0]; _f[1];
    return React__default["default"].createElement("div", null);
    // return (
    //   <Flex sx={{ alignItems: 'center' }}>
    //     <Box
    //       sx={{
    //         position: 'relative',
    //         width: 60,
    //         minWidth: 60,
    //         height: 80,
    //         minHeight: 80,
    //         backgroundPosition: 'center',
    //         backgroundSize: 'contain',
    //         backgroundRepeat: 'no-repeat',
    //         backgroundImage: imageUri
    //           ? `url("${imageUri}")`
    //           : 'url("/delish-bottle.png")',
    //       }}
    //       onMouseEnter={() => delay()}
    //       onMouseOut={() => (changeMouseOver(false), changeDelay(false))}
    //     >
    //       {isMouseOver && hasDelay ? (
    //         <Box
    //           sx={{
    //             zIndex: 100,
    //             backgroundPosition: 'center',
    //             backgroundSize: 'contain',
    //             backgroundRepeat: 'no-repeat',
    //             flexDirection: 'row',
    //             width: '300px',
    //             height: '400px',
    //             minWidth: '300px',
    //             minHeight: '400px',
    //             backgroundColor: `${theme.colors.white}`,
    //             position: 'fixed',
    //             left: '30px',
    //             top: '30px',
    //             borderColor: `${Colors.GRAY_2}`,
    //             borderWidth: '4px',
    //             borderRadius: `${theme.radii.box}px`,
    //             borderStyle: 'solid',
    //             filter: 'drop-shadow(0px 2px 25px rgba(0, 0, 0, 0.15))',
    //             backgroundImage: imageUri
    //               ? `url("${imageUri}")`
    //               : 'url("/delish-bottle.png")',
    //           }}
    //           onMouseEnter={() => (changeDelay(true), changeMouseOver(true))}
    //           onMouseOut={() => (changeMouseOver(false), changeDelay(false))}
    //         />
    //       ) : null}
    //     </Box>
    //     <Flex
    //       sx={{
    //         ...(theme.flex.col as ThemeUIStyleObject),
    //         ...{ overflowWrap: 'anywhere' },
    //       }}
    //       marginLeft="large"
    //     >
    //       <Text
    //         data-tip
    //         data-for={product.id}
    //         sx={{
    //           ...theme.text.listItemHeader,
    //           whiteSpace: overflowWrap ? 'break-spaces' : 'nowrap',
    //         }}
    //       >
    //         {isProductType(product) &&
    //         ProductFormattingHelpers.hasValidGeneratedName(product)
    //           ? ProductFormattingHelpers.formatProductName(product)
    //           : name}
    //       </Text>
    //       {!simple && <Text sx={theme.text.listItemText}>{brand?.name}</Text>}
    //       {!simple && <Text sx={theme.text.listItemText}>{packaging}</Text>}
    //       <Text sx={theme.text.listItemText}>{code}</Text>
    //     </Flex>
    //     <Box sx={{ marginLeft: 'auto', paddingLeft: 'large' }}>{rightAddOn}</Box>
    //     {InfoIcon}
    //     {isProductType(product) &&
    //       product.verified &&
    //       !product.productInfoError &&
    //       showVerifiedIcon && (
    //         <Image
    //           src="/verified.svg"
    //           sx={{ height: 20, position: 'absolute', top: 10, right: 10 }}
    //         />
    //       )}
    //   </Flex>
    // )
};

var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter$8(this, void 0, void 0, function () {
        return __generator$8(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter$8(this, void 0, void 0, function () {
        var items, files;
        return __generator$8(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter$8(this, void 0, void 0, function () {
        return __generator$8(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter$8(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator$8(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter$8(this, void 0, void 0, function () {
        return __generator$8(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files';

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties$2(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties$2(_useDropzone, _excluded2);

  React.useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,

  /**
   * Custom validation function 
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var rootRef = React.useRef(null);
  var inputRef = React.useRef(null);

  var _useReducer = React.useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = React.useCallback(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  React.useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = React.useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = React.useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = React.useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = React.useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = React.useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  React.useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = React.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = React.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = React.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = React.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function (file) {
          var _fileAccepted = fileAccepted(file, accept),
              _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
              accepted = _fileAccepted2[0],
              acceptError = _fileAccepted2[1];

          var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
              _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
              sizeMatch = _fileMatchSize2[0],
              sizeError = _fileMatchSize2[1];

          var customErrors = validator ? validator(file) : null;

          if (accepted && sizeMatch && !customErrors) {
            acceptedFiles.push(file);
          } else {
            var errors = [acceptError, sizeError];

            if (customErrors) {
              errors = errors.concat(customErrors);
            }

            fileRejections.push({
              file: file,
              errors: errors.filter(function (e) {
                return e;
              })
            });
          }
        });

        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
          // Reject everything and empty accepted files
          acceptedFiles.forEach(function (file) {
            fileRejections.push({
              file: file,
              errors: [TOO_MANY_FILES_REJECTION]
            });
          });
          acceptedFiles.splice(0);
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          fileRejections: fileRejections,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, fileRejections, event);
        }

        if (fileRejections.length > 0 && onDropRejected) {
          onDropRejected(fileRejections, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, maxFiles, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling, validator]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = React.useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties$2(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = React.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = React.useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties$2(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread(_objectSpread({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread(_objectSpread({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

var lib$3 = {};

var utils$t = {};

var date = {};

var constants$2 = {};

var auth = {};

/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
Object.defineProperty(auth, "__esModule", { value: true });
auth.PICOS_USERS = auth.AUDIT_USERS = auth.GROUPS_ALLOWED_TO_LOGIN_ADMIN = void 0;
var graphql_1$v = lib$4;
auth.GROUPS_ALLOWED_TO_LOGIN_ADMIN = [
    graphql_1$v.DAIGroupEnum.RED_ADMINS,
    graphql_1$v.DAIGroupEnum.RED_MANAGERS,
    graphql_1$v.DAIGroupEnum.PICOS,
];
auth.AUDIT_USERS = [
    graphql_1$v.DAIGroupEnum.RED_ADMINS,
    graphql_1$v.DAIGroupEnum.RED_MANAGERS,
    graphql_1$v.DAIGroupEnum.AUDITORS,
];
auth.PICOS_USERS = [graphql_1$v.DAIGroupEnum.PICOS];

var dateTime_constants = {};

(function (exports) {
/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.THIRTY_DAYS_VALUE_UNIQUE = exports.THIRTY_DAYS_YOY = exports.TWELVE_MONTHS = exports.SIX_MONTHS = exports.NINETY_DAYS = exports.THIRTY_DAYS = exports.DateTimeConstants = void 0;
var YYYY_MM_DD = 'YYYY-MM-DD';
var YYYY_MM = 'YYYY-MM';
var MM_DD = 'MM-DD';
var DD_MM_YY = 'DD/MM/YY';
var MM_DD_YY = 'MM/DD/YY';
var MM_DD_YYYY = 'MM/DD/YYYY';
var MM_DD_YYYY_H_MM_A = 'MM/DD/YYYY h:mm A';
var MMM_YYYY_TEXT = 'MMM YYYY';
var YYYY_TEXT = 'YYYY';
var MMMM_D_YYYY = 'MMMM D, YYYY';
exports.DateTimeConstants = {
    THIRTY_DAYS: 30,
    TWO_WEEKS: 14,
    WEEK_DAYS: 7,
    MONTHS_IN_YEAR: 12,
    DAYS_IN_YEAR: 365,
    SIXTY_DAYS: 60,
    YYYY_MM_DD: YYYY_MM_DD,
    YYYY_MM: YYYY_MM,
    MM_DD: MM_DD,
    DD_MM_YY: DD_MM_YY,
    MM_DD_YY: MM_DD_YY,
    MMM_YYYY_TEXT: MMM_YYYY_TEXT,
    YYYY_TEXT: YYYY_TEXT,
    MM_DD_YYYY: MM_DD_YYYY,
    MMMM_D_YYYY: MMMM_D_YYYY,
    MM_DD_YYYY_H_MM_A: MM_DD_YYYY_H_MM_A,
};
exports.THIRTY_DAYS = 'Past 30 Days vs Prev. 30 Days';
exports.NINETY_DAYS = 'Past 90 Days vs Prev. 90 Days';
exports.SIX_MONTHS = 'Past 6 Months vs Prev. 6 Months';
exports.TWELVE_MONTHS = 'Past 12 Months vs Prev. 12 Months';
exports.THIRTY_DAYS_YOY = 'Past 30 Days Year-over-Year';
exports.THIRTY_DAYS_VALUE_UNIQUE = String(exports.DateTimeConstants.THIRTY_DAYS) + '.0';
}(dateTime_constants));

(function (exports) {
/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(auth, exports);
__exportStar(dateTime_constants, exports);
}(constants$2));

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(date, "__esModule", { value: true });
date.DateTimeHelpers = void 0;
var dayjs_1 = __importDefault$1(dayjs__default["default"]);
var constants_1 = constants$2;
var getDateStringMonthDayYear = function (date) {
    return "".concat(date.getMonth() + 1, "/").concat(date.getDay(), "/").concat(date.getFullYear());
};
var getDateWeekDelta = function (numWeeks, startDate) {
    if (numWeeks === void 0) { numWeeks = 0; }
    if (startDate === void 0) { startDate = new Date(); }
    var daysDelta = constants_1.DateTimeConstants.WEEK_DAYS * numWeeks;
    return (0, dayjs_1.default)(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + daysDelta));
};
var getDateDaysDelta = function (numDays, startDate) {
    if (numDays === void 0) { numDays = 0; }
    if (startDate === void 0) { startDate = new Date(); }
    return (0, dayjs_1.default)(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + numDays));
};
var getDateFromStringYearMonthDay = function (date) {
    return new Date(date).toISOString().slice(0, 10);
};
/**
 *
 * @param date
 * returns a string in the following format 8.10.22
 */
var getFormattedDateStringDot = function (date) {
    return "".concat(date.getMonth() + 1, ".").concat(date.getDate() + 1, ".").concat(date.getFullYear().toString().slice(2, 4));
};
var getDateRangeString = function (startDate, endDate) {
    return "".concat((0, dayjs_1.default)(new Date(startDate)).format(constants_1.DateTimeConstants.MM_DD_YY), " \u2014 ").concat((0, dayjs_1.default)(new Date(endDate)).format(constants_1.DateTimeConstants.MM_DD_YY));
};
var getDiffDays = function (startDate, endDate) {
    var diff = Math.abs(new Date(startDate).getTime() - new Date(endDate).getTime());
    return Math.ceil(diff / (1000 * 3600 * 24));
};
var isDiffDaysLessThanOrEQ = function (startDate, endDate, daysThreshold) { return getDiffDays(startDate, endDate) <= daysThreshold; };
date.DateTimeHelpers = {
    getDateWeekDelta: getDateWeekDelta,
    getDateFromStringYearMonthDay: getDateFromStringYearMonthDay,
    getDateStringMonthDayYear: getDateStringMonthDayYear,
    getDateDaysDelta: getDateDaysDelta,
    getDateRangeString: getDateRangeString,
    getDiffDays: getDiffDays,
    isDiffDaysLessThanOrEQ: isDiffDaysLessThanOrEQ,
    getFormattedDateStringDot: getFormattedDateStringDot,
};

var ApolloUtils = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var __assign$k = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$k = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$k.apply(this, arguments);
};
var __rest$b = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray$4 = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(ApolloUtils, "__esModule", { value: true });
ApolloUtils.addOperationNameToUrl = ApolloUtils.keyArgsIgnoreOffsetLimit = ApolloUtils.mergePreferIncoming = ApolloUtils.mergePaginatedResults = void 0;
var client_1$v = require$$0$1;
var dedupById$1 = function (results, readField) {
    return results.reduce(function (acc, item) {
        var match = acc.find(function (exItem) { return readField('id', exItem) === readField('id', item); });
        if (match) {
            return acc;
        }
        else {
            return __spreadArray$4(__spreadArray$4([], acc, true), [item], false);
        }
    }, []);
};
var mergePaginatedResults = function (existing, incoming, options) {
    var _a;
    var readField = options.readField;
    if (incoming.results.length) {
        var results = [];
        if ((_a = existing === null || existing === void 0 ? void 0 : existing.results) === null || _a === void 0 ? void 0 : _a.length) {
            var existingIds_1 = new Set(existing.results.map(function (item) { return readField('id', item); }));
            var uniqueExisting = dedupById$1(existing.results, readField);
            var uniqueIncoming = incoming.results.filter(function (item) { return !existingIds_1.has(readField('id', item)); });
            results = __spreadArray$4(__spreadArray$4([], uniqueExisting, true), uniqueIncoming, true);
        }
        else {
            results = __spreadArray$4([], incoming.results, true);
        }
        return __assign$k(__assign$k({}, incoming), { results: results });
    }
    return (existing === null || existing === void 0 ? void 0 : existing.results) ? dedupById$1(existing === null || existing === void 0 ? void 0 : existing.results, readField) : existing;
};
ApolloUtils.mergePaginatedResults = mergePaginatedResults;
var mergePreferIncoming = function (existing, incoming) {
    if (incoming.length === 0) {
        return existing;
    }
    return incoming;
};
ApolloUtils.mergePreferIncoming = mergePreferIncoming;
var keyArgsIgnoreOffsetLimit = function (args) {
    if (args === null || args === void 0 ? void 0 : args.input) {
        var _a = args.input; _a.offset; _a.limit; var rest = __rest$b(_a, ["offset", "limit"]);
        return JSON.stringify(Object.values(rest));
    }
};
ApolloUtils.keyArgsIgnoreOffsetLimit = keyArgsIgnoreOffsetLimit;
ApolloUtils.addOperationNameToUrl = new client_1$v.ApolloLink(function (operation, forward) {
    if (process.env.NODE_ENV === 'development') {
        var context = operation.getContext();
        var contextURI = context.uri || '/graphql';
        operation.setContext({
            uri: "".concat(contextURI, "?").concat(operation.operationName),
        });
    }
    return forward(operation);
});

var IDUtils = {};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || rng)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || unsafeStringify(b);
}

function parse(uuid) {
  if (!validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = parse(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return unsafeStringify(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

const v3 = v35('v3', 0x30, md5);
var v3$1 = v3;

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f$1(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f$1(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

const v5 = v35('v5', 0x50, sha1);
var v5$1 = v5;

var nil = '00000000-0000-0000-0000-000000000000';

function version(uuid) {
  if (!validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

var esmBrowser = /*#__PURE__*/Object.freeze({
    __proto__: null,
    v1: v1,
    v3: v3$1,
    v4: v4,
    v5: v5$1,
    NIL: nil,
    version: version,
    validate: validate,
    stringify: stringify,
    parse: parse
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(esmBrowser);

/**
 * Copyright © 2020 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
Object.defineProperty(IDUtils, "__esModule", { value: true });
IDUtils.uniqueId = void 0;
var uuid_1 = require$$0;
var uniqueId = function () { return (0, uuid_1.v4)(); };
IDUtils.uniqueId = uniqueId;

var maps = {};

(function (exports) {
/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Clark Sandholtz <clark.sandholtz@deliciousai.com>
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelFeatures = exports.getStoreCenterFromMap = exports.getPolygonMidpoint = exports.mapboxBoundsToPoints = exports.pointToMapboxCoordinates = exports.mapboxCoordinatesToPoint = void 0;
var mapboxCoordinatesToPoint = function (coordinates) {
    var longitude = coordinates[0], latitude = coordinates[1];
    return { longitude: longitude, latitude: latitude };
};
exports.mapboxCoordinatesToPoint = mapboxCoordinatesToPoint;
var pointToMapboxCoordinates = function (point) {
    return [point.longitude, point.latitude];
};
exports.pointToMapboxCoordinates = pointToMapboxCoordinates;
var mapboxBoundsToPoints = function (bounds) {
    return {
        ne: { latitude: bounds[0][1], longitude: bounds[0][0] },
        sw: { latitude: bounds[1][1], longitude: bounds[1][0] },
    };
};
exports.mapboxBoundsToPoints = mapboxBoundsToPoints;
var getPolygonMidpoint = function (coordinates) {
    var minLng = coordinates.reduce(function (min, coordinate) {
        return Math.abs(coordinate[0]) < Math.abs(min) ? coordinate[0] : min;
    }, coordinates[0][0]);
    var maxLng = coordinates.reduce(function (max, coordinate) {
        return Math.abs(coordinate[0]) > Math.abs(max) ? coordinate[0] : max;
    }, coordinates[0][0]);
    var minLat = coordinates.reduce(function (min, coordinate) {
        return Math.abs(coordinate[1]) < Math.abs(min) ? coordinate[1] : min;
    }, coordinates[0][1]);
    var maxLat = coordinates.reduce(function (max, coordinate) {
        return Math.abs(coordinate[1]) > Math.abs(max) ? coordinate[1] : max;
    }, coordinates[0][1]);
    var midpointLng = minLng + (maxLng - minLng) / 2;
    var midpointLat = minLat + (maxLat - minLat) / 2;
    return [midpointLng, midpointLat];
};
exports.getPolygonMidpoint = getPolygonMidpoint;
var getStoreCenterFromMap = function (storeMap) {
    var store = storeMap.features.find(function (f) { return f.properties.type === 'store'; });
    if (store && store.geometry.type === 'Polygon') {
        var coords_1 = store === null || store === void 0 ? void 0 : store.geometry.coordinates[0];
        return coords_1
            ? (0, exports.mapboxCoordinatesToPoint)((0, exports.getPolygonMidpoint)(coords_1))
            : undefined;
    }
    else if (store) {
        var coords_2 = store === null || store === void 0 ? void 0 : store.geometry.coordinates;
        return coords_2
            ? (0, exports.mapboxCoordinatesToPoint)((0, exports.getPolygonMidpoint)(coords_2))
            : undefined;
    }
    var other = storeMap.features.find(function (f) { return f.properties.type === 'area'; });
    var coords = other === null || other === void 0 ? void 0 : other.geometry.coordinates;
    return coords
        ? (0, exports.mapboxCoordinatesToPoint)((0, exports.getPolygonMidpoint)(coords))
        : undefined;
};
exports.getStoreCenterFromMap = getStoreCenterFromMap;
var getLabelFeatures = function (features) {
    var areaLabels = features
        .filter(function (feature) { var _a, _b; return ((_a = feature.properties) === null || _a === void 0 ? void 0 : _a.name) || ((_b = feature.properties) === null || _b === void 0 ? void 0 : _b.area); })
        .map(function (feature) {
        var _a, _b;
        return {
            type: 'Feature',
            properties: {
                description: ((_a = feature.properties) === null || _a === void 0 ? void 0 : _a.name) || ((_b = feature.properties) === null || _b === void 0 ? void 0 : _b.area) || '',
                type: feature.properties.type,
            },
            geometry: {
                type: 'Point',
                coordinates: (0, exports.getPolygonMidpoint)(feature.geometry.type === 'Polygon'
                    ? feature.geometry.coordinates[0]
                    : feature.geometry.coordinates),
            },
        };
    });
    return { type: 'FeatureCollection', features: areaLabels };
};
exports.getLabelFeatures = getLabelFeatures;
}(maps));

var utils$s = {};

/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var __spreadArray$3 = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(utils$s, "__esModule", { value: true });
utils$s.plurality = utils$s.toTitleCase = utils$s.dedupById = utils$s.notNullOrUndefined = void 0;
var notNullOrUndefined = function (value) {
    return value !== null && value !== undefined;
};
utils$s.notNullOrUndefined = notNullOrUndefined;
var dedupById = function (items) {
    return items.reduce(function (uniqueItems, item) {
        var match = uniqueItems.find(function (i) { return i.id === item.id; });
        if (match) {
            return uniqueItems;
        }
        else {
            return __spreadArray$3(__spreadArray$3([], uniqueItems, true), [item], false);
        }
    }, []);
};
utils$s.dedupById = dedupById;
function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
utils$s.toTitleCase = toTitleCase;
/**
 * Adds 's' to a word for counts greater than 1
 * @param word
 * @param count
 * @param ignore
 * @returns formatted string
 */
var plurality = function (word, count, ignore) {
    if (ignore && ignore.includes(word.toLowerCase()))
        return word;
    var plural = count === 1 || word.endsWith('s') ? '' : 's';
    return "".concat(word).concat(plural);
};
utils$s.plurality = plurality;

var UserUtils = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
Object.defineProperty(UserUtils, "__esModule", { value: true });
UserUtils.getName = UserUtils.hasGroups = UserUtils.hasGroup = UserUtils.hasPermission = void 0;
var hasPermission = function (user, allowedRoles, options) {
    if (user) {
        if (allowedRoles === undefined ||
            (user.isSuperuser && !(options === null || options === void 0 ? void 0 : options.ignoreSuperuser))) {
            return true;
        }
        return (!!allowedRoles && allowedRoles.some(function (role) { return user.roles.includes(role); }));
    }
    return false;
};
UserUtils.hasPermission = hasPermission;
var hasGroup = function (user, role) {
    return !!user && !!(user === null || user === void 0 ? void 0 : user.roles) && (user === null || user === void 0 ? void 0 : user.roles.includes(role));
};
UserUtils.hasGroup = hasGroup;
var hasGroups = function (user, allowedRoles) {
    return (!!(user === null || user === void 0 ? void 0 : user.roles) &&
        !!allowedRoles &&
        allowedRoles.every(function (role) { return user === null || user === void 0 ? void 0 : user.roles.includes(role); }));
};
UserUtils.hasGroups = hasGroups;
var getName = function (user) {
    if (user) {
        var firstName = user.firstName, lastName = user.lastName, email = user.email;
        if (firstName || lastName) {
            return "".concat(firstName, " ").concat(lastName);
        }
        return email;
    }
    return 'User';
};
UserUtils.getName = getName;

var FileUtils = {};

var utf8$5 = {};

var utils$r = {};

var support$5 = {};

var nodestream;
var blob;

support$5.base64 = true;
support$5.array = true;
support$5.string = true;
support$5.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
support$5.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
support$5.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    blob = support$5.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        blob = support$5.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            blob = support$5.blob = builder.getBlob("application/zip").size === 0;
        }
        catch (e) {
            blob = support$5.blob = false;
        }
    }
}

try {
    nodestream = support$5.nodestream = !!require("readable-stream").Readable;
} catch(e) {
    nodestream = support$5.nodestream = false;
}

var base64$1 = {};

var utils$q = utils$r;
var support$4 = support$5;
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
base64$1.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;

    var isArray = utils$q.getTypeOf(input) !== "string";
    while (i < input.length) {
        remainingBytes = len - i;

        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;

        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));

    }

    return output.join("");
};

// public method for decoding
base64$1.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;

    var dataUrlPrefix = "data:";

    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
        // This is a common error: people give a data url
        // (data:image/png;base64,iVBOR...) with a {base64: true} and
        // wonders why things don't work.
        // We can detect that the string input looks like a data url but we
        // *can't* be sure it is one: removing everything up to the comma would
        // be too dangerous.
        throw new Error("Invalid base64 input, it looks like a data url.");
    }

    input = input.replace(/[^A-Za-z0-9+/=]/g, "");

    var totalLength = input.length * 3 / 4;
    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if (totalLength % 1 !== 0) {
        // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        //   beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
    }
    var output;
    if (support$4.uint8array) {
        output = new Uint8Array(totalLength|0);
    } else {
        output = new Array(totalLength|0);
    }

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output[resultIndex++] = chr1;

        if (enc3 !== 64) {
            output[resultIndex++] = chr2;
        }
        if (enc4 !== 64) {
            output[resultIndex++] = chr3;
        }

    }

    return output;
};

var nodejsUtils$2 = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */
    isNode : typeof Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer from an existing content.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */
    newBufferFrom: function(data, encoding) {
        if (Buffer.from && Buffer.from !== Uint8Array.from) {
            return Buffer.from(data, encoding);
        } else {
            if (typeof data === "number") {
                // Safeguard for old Node.js versions. On newer versions,
                // Buffer.from(number) / Buffer(number, encoding) already throw.
                throw new Error("The \"data\" argument must not be a number");
            }
            return new Buffer(data, encoding);
        }
    },
    /**
     * Create a new nodejs Buffer with the specified size.
     * @param {Integer} size the size of the buffer.
     * @return {Buffer} a new Buffer.
     */
    allocBuffer: function (size) {
        if (Buffer.alloc) {
            return Buffer.alloc(size);
        } else {
            var buf = new Buffer(size);
            buf.fill(0);
            return buf;
        }
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */
    isBuffer : function(b){
        return Buffer.isBuffer(b);
    },

    isStream : function (obj) {
        return obj &&
            typeof obj.on === "function" &&
            typeof obj.pause === "function" &&
            typeof obj.resume === "function";
    }
};

var Mutation = commonjsGlobal.MutationObserver || commonjsGlobal.WebKitMutationObserver;

var scheduleDrain;

if (process.browser) {
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = commonjsGlobal.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!commonjsGlobal.setImmediate && typeof commonjsGlobal.MessageChannel !== 'undefined') {
    var channel = new commonjsGlobal.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in commonjsGlobal && 'onreadystatechange' in commonjsGlobal.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = commonjsGlobal.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      commonjsGlobal.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
} else {
  scheduleDrain = function () {
    process.nextTick(nextTick);
  };
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

var lib$2 = immediate$1;
function immediate$1(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

var immediate = lib$2;

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];
/* istanbul ignore else */
if (!process.browser) {
  // in which we actually take advantage of JS scoping
  var UNHANDLED = ['UNHANDLED'];
}

var lib$1 = Promise$1;

function Promise$1(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  /* istanbul ignore else */
  if (!process.browser) {
    this.handled = UNHANDLED;
  }
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise$1.prototype.finally = function (callback) {
  if (typeof callback !== 'function') {
    return this;
  }
  var p = this.constructor;
  return this.then(resolve, reject);

  function resolve(value) {
    function yes () {
      return value;
    }
    return p.resolve(callback()).then(yes);
  }
  function reject(reason) {
    function no () {
      throw reason;
    }
    return p.resolve(callback()).then(no);
  }
};
Promise$1.prototype.catch = function (onRejected) {
  return this.then(null, onRejected);
};
Promise$1.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  /* istanbul ignore else */
  if (!process.browser) {
    if (this.handled === UNHANDLED) {
      this.handled = null;
    }
  }
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  /* istanbul ignore else */
  if (!process.browser) {
    if (self.handled === UNHANDLED) {
      immediate(function () {
        if (self.handled === UNHANDLED) {
          process.emit('unhandledRejection', error, self);
        }
      });
    }
  }
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise$1.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise$1.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise$1.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise$1.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var ES6Promise = null;
if (typeof Promise !== "undefined") {
    ES6Promise = Promise;
} else {
    ES6Promise = lib$1;
}

/**
 * Let the user use/change some implementations.
 */
var external$3 = {
    Promise: ES6Promise
};

(function (global, undefined$1) {

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined$1, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof commonjsGlobal === "undefined" ? commonjsGlobal : commonjsGlobal : self));

(function (exports) {

var support = support$5;
var base64 = base64$1;
var nodejsUtils = nodejsUtils$2;
var external = external$3;



/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */
function string2binary(str) {
    var result = null;
    if (support.uint8array) {
        result = new Uint8Array(str.length);
    } else {
        result = new Array(str.length);
    }
    return stringToArrayLike(str, result);
}

/**
 * Create a new blob with the given content and the given type.
 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 *
 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
 * when a large amount of Array is used to create the Blob, the amount of
 * memory consumed is nearly 100 times the original data amount.
 *
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */
exports.newBlob = function(part, type) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob([part], {
            type: type
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(part);
            return builder.getBlob(type);
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * An helper for the function arrayLikeToString.
 * This contains static information and functions that
 * can be optimized by the browser JIT compiler.
 */
var arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */
    stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
        }
        while (k < len) {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */
    stringifyByChar: function(array){
        var resultStr = "";
        for(var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
        }
        return resultStr;
    },
    applyCanBeUsed : {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */
        uint8array : (function () {
            try {
                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        })(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */
        nodebuffer : (function () {
            try {
                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        })()
    }
};

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536,
        type = exports.getTypeOf(array),
        canUseApply = true;
    if (type === "uint8array") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
    } else if (type === "nodebuffer") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
    }

    if (canUseApply) {
        while (chunk > 1) {
            try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
    }

    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return arrayToStringHelper.stringifyByChar(array);
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return input.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Resolve all relative path components, "." and "..", in a path. If these relative components
 * traverse above the root then the resulting path will only contain the final path component.
 *
 * All empty components, e.g. "//", are removed.
 * @param {string} path A path with / or \ separators
 * @returns {string} The path with all relative path components resolved.
 */
exports.resolve = function(path) {
    var parts = path.split("/");
    var result = [];
    for (var index = 0; index < parts.length; index++) {
        var part = parts[index];
        // Allow the first and last component to be empty for trailing slashes.
        if (part === "." || (part === "" && index !== 0 && index !== parts.length - 1)) {
            continue;
        } else if (part === "..") {
            result.pop();
        } else {
            result.push(part);
        }
    }
    return result.join("/");
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this platform");
    }
};

exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = "",
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */
exports.delay = function(callback, args, self) {
    setImmediate(function () {
        callback.apply(self || null, args || []);
    });
};

/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */
exports.inherits = function (ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
exports.extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (Object.prototype.hasOwnProperty.call(arguments[i], attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */
exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {

    // if inputData is already a promise, this flatten it.
    var promise = external.Promise.resolve(inputData).then(function(data) {


        var isBlob = support.blob && (data instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(data)) !== -1);

        if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
        } else {
            return data;
        }
    });

    return promise.then(function(data) {
        var dataType = exports.getTypeOf(data);

        if (!dataType) {
            return external.Promise.reject(
                new Error("Can't read the data of '" + name + "'. Is it " +
                          "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
            );
        }
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
        } else if (dataType === "string") {
            if (isBase64) {
                data = base64.decode(data);
            }
            else if (isBinary) {
                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                if (isOptimizedBinaryString !== true) {
                    // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
        }
        return data;
    });
};
}(utils$r));

/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */
function GenericWorker$b(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        "data":[],
        "end":[],
        "error":[]
    };
    // the previous worker, if any
    this.previous = null;
}

GenericWorker$b.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */
    push : function (chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */
    end : function () {
        if (this.isFinished) {
            return false;
        }

        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */
    error : function (e) {
        if (this.isFinished) {
            return false;
        }

        if(this.isPaused) {
            this.generatedError = e;
        } else {
            this.isFinished = true;

            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if(this.previous) {
                this.previous.error(e);
            }

            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */
    on : function (name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */
    cleanUp : function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */
    emit : function (name, arg) {
        if (this._listeners[name]) {
            for(var i = 0; i < this._listeners[name].length; i++) {
                this._listeners[name][i].call(this, arg);
            }
        }
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */
    pipe : function (next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */
    registerPrevious : function (previous) {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }

        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous =  previous;
        var self = this;
        previous.on("data", function (chunk) {
            self.processChunk(chunk);
        });
        previous.on("end", function () {
            self.end();
        });
        previous.on("error", function (e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */
    pause : function () {
        if(this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = true;

        if(this.previous) {
            this.previous.pause();
        }
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */
    resume : function () {
        if(!this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = false;

        // if true, the worker tried to resume but failed
        var withError = false;
        if(this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if(this.previous) {
            this.previous.resume();
        }

        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */
    flush : function () {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */
    processChunk : function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */
    withStreamInfo : function (key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */
    mergeStreamInfo : function () {
        for(var key in this.extraStreamInfo) {
            if (!Object.prototype.hasOwnProperty.call(this.extraStreamInfo, key)) {
                continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },

    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */
    lock: function () {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }
        this.isLocked = true;
        if (this.previous) {
            this.previous.lock();
        }
    },

    /**
     *
     * Pretty print the workers chain.
     */
    toString : function () {
        var me = "Worker " + this.name;
        if (this.previous) {
            return this.previous + " -> " + me;
        } else {
            return me;
        }
    }
};

var GenericWorker_1 = GenericWorker$b;

(function (exports) {

var utils = utils$r;
var support = support$5;
var nodejsUtils = nodejsUtils$2;
var GenericWorker = GenericWorker_1;

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
    _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodejsUtils.newBufferFrom(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    return buf2string(buf);
};

/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */
function Utf8DecodeWorker() {
    GenericWorker.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
utils.inherits(Utf8DecodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8DecodeWorker.prototype.processChunk = function (chunk) {

    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if(support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else {
            data = this.leftOver.concat(data);
        }
        this.leftOver = null;
    }

    var nextBoundary = utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }

    this.push({
        data : exports.utf8decode(usableData),
        meta : chunk.meta
    });
};

/**
 * @see GenericWorker.flush
 */
Utf8DecodeWorker.prototype.flush = function () {
    if(this.leftOver && this.leftOver.length) {
        this.push({
            data : exports.utf8decode(this.leftOver),
            meta : {}
        });
        this.leftOver = null;
    }
};
exports.Utf8DecodeWorker = Utf8DecodeWorker;

/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */
function Utf8EncodeWorker() {
    GenericWorker.call(this, "utf-8 encode");
}
utils.inherits(Utf8EncodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8EncodeWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : exports.utf8encode(chunk.data),
        meta : chunk.meta
    });
};
exports.Utf8EncodeWorker = Utf8EncodeWorker;
}(utf8$5));

var GenericWorker$a = GenericWorker_1;
var utils$p = utils$r;

/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */
function ConvertWorker$1(destType) {
    GenericWorker$a.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
utils$p.inherits(ConvertWorker$1, GenericWorker$a);

/**
 * @see GenericWorker.processChunk
 */
ConvertWorker$1.prototype.processChunk = function (chunk) {
    this.push({
        data : utils$p.transformTo(this.destType, chunk.data),
        meta : chunk.meta
    });
};
var ConvertWorker_1 = ConvertWorker$1;

var utils$o = utils$r;
var ConvertWorker = ConvertWorker_1;
var GenericWorker$9 = GenericWorker_1;
var base64 = base64$1;
var support$3 = support$5;
var external$2 = external$3;

var NodejsStreamOutputAdapter = null;
if (support$3.nodestream) {
    try {
        NodejsStreamOutputAdapter = require("../nodejs/NodejsStreamOutputAdapter");
    } catch(e) {
        // ignore
    }
}

/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} type the name of the final type
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */
function transformZipOutput(type, content, mimeType) {
    switch(type) {
    case "blob" :
        return utils$o.newBlob(utils$o.transformTo("arraybuffer", content), mimeType);
    case "base64" :
        return base64.encode(content);
    default :
        return utils$o.transformTo(type, content);
    }
}

/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */
function concat (type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++) {
        totalLength += dataArray[i].length;
    }
    switch(type) {
    case "string":
        return dataArray.join("");
    case "array":
        return Array.prototype.concat.apply([], dataArray);
    case "uint8array":
        res = new Uint8Array(totalLength);
        for(i = 0; i < dataArray.length; i++) {
            res.set(dataArray[i], index);
            index += dataArray[i].length;
        }
        return res;
    case "nodebuffer":
        return Buffer.concat(dataArray);
    default:
        throw new Error("concat : unsupported type '"  + type + "'");
    }
}

/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */
function accumulate(helper, updateCallback) {
    return new external$2.Promise(function (resolve, reject){
        var dataArray = [];
        var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
        helper
            .on("data", function (data, meta) {
                dataArray.push(data);
                if(updateCallback) {
                    updateCallback(meta);
                }
            })
            .on("error", function(err) {
                dataArray = [];
                reject(err);
            })
            .on("end", function (){
                try {
                    var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
                    resolve(result);
                } catch (e) {
                    reject(e);
                }
                dataArray = [];
            })
            .resume();
    });
}

/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */
function StreamHelper$2(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType) {
    case "blob":
    case "arraybuffer":
        internalType = "uint8array";
        break;
    case "base64":
        internalType = "string";
        break;
    }

    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        utils$o.checkSupport(internalType);
        this._worker = worker.pipe(new ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch(e) {
        this._worker = new GenericWorker$9("error");
        this._worker.error(e);
    }
}

StreamHelper$2.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */
    accumulate : function (updateCb) {
        return accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */
    on : function (evt, fn) {
        var self = this;

        if(evt === "data") {
            this._worker.on(evt, function (chunk) {
                fn.call(self, chunk.data, chunk.meta);
            });
        } else {
            this._worker.on(evt, function () {
                utils$o.delay(fn, arguments, self);
            });
        }
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    resume : function () {
        utils$o.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    pause : function () {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */
    toNodejsStream : function (updateCb) {
        utils$o.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
        }

        return new NodejsStreamOutputAdapter(this, {
            objectMode : this._outputType !== "nodebuffer"
        }, updateCb);
    }
};


var StreamHelper_1 = StreamHelper$2;

var defaults$1 = {};

defaults$1.base64 = false;
defaults$1.binary = false;
defaults$1.dir = false;
defaults$1.createFolders = true;
defaults$1.date = null;
defaults$1.compression = null;
defaults$1.compressionOptions = null;
defaults$1.comment = null;
defaults$1.unixPermissions = null;
defaults$1.dosPermissions = null;

var utils$n = utils$r;
var GenericWorker$8 = GenericWorker_1;

// the size of the generated chunks
// TODO expose this as a public variable
var DEFAULT_BLOCK_SIZE = 16 * 1024;

/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */
function DataWorker$2(dataP) {
    GenericWorker$8.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";

    this._tickScheduled = false;

    dataP.then(function (data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = utils$n.getTypeOf(data);
        if(!self.isPaused) {
            self._tickAndRepeat();
        }
    }, function (e) {
        self.error(e);
    });
}

utils$n.inherits(DataWorker$2, GenericWorker$8);

/**
 * @see GenericWorker.cleanUp
 */
DataWorker$2.prototype.cleanUp = function () {
    GenericWorker$8.prototype.cleanUp.call(this);
    this.data = null;
};

/**
 * @see GenericWorker.resume
 */
DataWorker$2.prototype.resume = function () {
    if(!GenericWorker$8.prototype.resume.call(this)) {
        return false;
    }

    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        utils$n.delay(this._tickAndRepeat, [], this);
    }
    return true;
};

/**
 * Trigger a tick a schedule an other call to this function.
 */
DataWorker$2.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if(this.isPaused || this.isFinished) {
        return;
    }
    this._tick();
    if(!this.isFinished) {
        utils$n.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};

/**
 * Read and push a chunk.
 */
DataWorker$2.prototype._tick = function() {

    if(this.isPaused || this.isFinished) {
        return false;
    }

    var size = DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) {
        // EOF
        return this.end();
    } else {
        switch(this.type) {
        case "string":
            data = this.data.substring(this.index, nextIndex);
            break;
        case "uint8array":
            data = this.data.subarray(this.index, nextIndex);
            break;
        case "array":
        case "nodebuffer":
            data = this.data.slice(this.index, nextIndex);
            break;
        }
        this.index = nextIndex;
        return this.push({
            data : data,
            meta : {
                percent : this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};

var DataWorker_1 = DataWorker$2;

var utils$m = utils$r;

/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Use ordinary array, since untyped makes no boost here
function makeTable$1() {
    var c, table = [];

    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
    }

    return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable$1 = makeTable$1();


function crc32$5(crc, buf, len, pos) {
    var t = crcTable$1, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

// That's all for the pako functions.

/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */
function crc32str(crc, str, len, pos) {
    var t = crcTable$1, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

var crc32_1$1 = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils$m.getTypeOf(input) !== "string";

    if(isArray) {
        return crc32$5(crc|0, input, input.length, 0);
    } else {
        return crc32str(crc|0, input, input.length, 0);
    }
};

var GenericWorker$7 = GenericWorker_1;
var crc32$4 = crc32_1$1;
var utils$l = utils$r;

/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */
function Crc32Probe$2() {
    GenericWorker$7.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
utils$l.inherits(Crc32Probe$2, GenericWorker$7);

/**
 * @see GenericWorker.processChunk
 */
Crc32Probe$2.prototype.processChunk = function (chunk) {
    this.streamInfo.crc32 = crc32$4(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
var Crc32Probe_1 = Crc32Probe$2;

var utils$k = utils$r;
var GenericWorker$6 = GenericWorker_1;

/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */
function DataLengthProbe$1(propName) {
    GenericWorker$6.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
utils$k.inherits(DataLengthProbe$1, GenericWorker$6);

/**
 * @see GenericWorker.processChunk
 */
DataLengthProbe$1.prototype.processChunk = function (chunk) {
    if(chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    GenericWorker$6.prototype.processChunk.call(this, chunk);
};
var DataLengthProbe_1 = DataLengthProbe$1;

var external$1 = external$3;
var DataWorker$1 = DataWorker_1;
var Crc32Probe$1 = Crc32Probe_1;
var DataLengthProbe = DataLengthProbe_1;

/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */
function CompressedObject$3(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}

CompressedObject$3.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */
    getContentWorker: function () {
        var worker = new DataWorker$1(external$1.Promise.resolve(this.compressedContent))
            .pipe(this.compression.uncompressWorker())
            .pipe(new DataLengthProbe("data_length"));

        var that = this;
        worker.on("end", function () {
            if (this.streamInfo["data_length"] !== that.uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */
    getCompressedWorker: function () {
        return new DataWorker$1(external$1.Promise.resolve(this.compressedContent))
            .withStreamInfo("compressedSize", this.compressedSize)
            .withStreamInfo("uncompressedSize", this.uncompressedSize)
            .withStreamInfo("crc32", this.crc32)
            .withStreamInfo("compression", this.compression)
        ;
    }
};

/**
 * Chain the given worker with other workers to compress the content with the
 * given compression.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */
CompressedObject$3.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker
        .pipe(new Crc32Probe$1())
        .pipe(new DataLengthProbe("uncompressedSize"))
        .pipe(compression.compressWorker(compressionOptions))
        .pipe(new DataLengthProbe("compressedSize"))
        .withStreamInfo("compression", compression);
};

var compressedObject = CompressedObject$3;

var StreamHelper$1 = StreamHelper_1;
var DataWorker = DataWorker_1;
var utf8$4 = utf8$5;
var CompressedObject$2 = compressedObject;
var GenericWorker$5 = GenericWorker_1;

/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject$1 = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;

    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression : options.compression,
        compressionOptions : options.compressionOptions
    };
};

ZipObject$1.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */
    internalStream: function (type) {
        var result = null, outputType = "string";
        try {
            if (!type) {
                throw new Error("No output type specified.");
            }
            outputType = type.toLowerCase();
            var askUnicodeString = outputType === "string" || outputType === "text";
            if (outputType === "binarystring" || outputType === "text") {
                outputType = "string";
            }
            result = this._decompressWorker();

            var isUnicodeString = !this._dataBinary;

            if (isUnicodeString && !askUnicodeString) {
                result = result.pipe(new utf8$4.Utf8EncodeWorker());
            }
            if (!isUnicodeString && askUnicodeString) {
                result = result.pipe(new utf8$4.Utf8DecodeWorker());
            }
        } catch (e) {
            result = new GenericWorker$5("error");
            result.error(e);
        }

        return new StreamHelper$1(result, outputType, "");
    },

    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */
    async: function (type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },

    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */
    nodeStream: function (type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },

    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */
    _compressWorker: function (compression, compressionOptions) {
        if (
            this._data instanceof CompressedObject$2 &&
            this._data.compression.magic === compression.magic
        ) {
            return this._data.getCompressedWorker();
        } else {
            var result = this._decompressWorker();
            if(!this._dataBinary) {
                result = result.pipe(new utf8$4.Utf8EncodeWorker());
            }
            return CompressedObject$2.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */
    _decompressWorker : function () {
        if (this._data instanceof CompressedObject$2) {
            return this._data.getContentWorker();
        } else if (this._data instanceof GenericWorker$5) {
            return this._data;
        } else {
            return new DataWorker(this._data);
        }
    }
};

var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
var removedFn = function () {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};

for(var i$1 = 0; i$1 < removedMethods.length; i$1++) {
    ZipObject$1.prototype[removedMethods[i$1]] = removedFn;
}
var zipObject = ZipObject$1;

var generate$1 = {};

var compressions$2 = {};

var flate = {};

var common = {};

(function (exports) {


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);
}(common));

var deflate$4 = {};

var deflate$3 = {};

var trees$1 = {};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils$j = common;

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED$1               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN$1             = 2;

/*============================================================================*/


function zero$1(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH$1    = 3;
var MAX_MATCH$1    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES$1  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS$1      = 256;
/* number of literal bytes 0..255 */

var L_CODES$1       = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES$1       = 30;
/* number of distance codes */

var BL_CODES$1      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE$1     = 2 * L_CODES$1 + 1;
/* maximum heap size */

var MAX_BITS$1      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES$1);
zero$1(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES$1);
zero$1(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS$1; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS$1 + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES$1 - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES$1; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES$1 + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES$1; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES$1, MAX_BITS$1);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES$1, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES$1;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES$1;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES$1; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils$j.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE$1;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS$1; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN$1) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

trees$1._tr_init  = _tr_init;
trees$1._tr_stored_block = _tr_stored_block;
trees$1._tr_flush_block  = _tr_flush_block;
trees$1._tr_tally = _tr_tally;
trees$1._tr_align = _tr_align;

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32$2(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


var adler32_1 = adler32$2;

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32$3(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


var crc32_1 = crc32$3;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var messages = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils$i   = common;
var trees   = trees$1;
var adler32$1 = adler32_1;
var crc32$2   = crc32_1;
var msg$2     = messages;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH$1      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH$2        = 4;
var Z_BLOCK$1         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK$2            = 0;
var Z_STREAM_END$2    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR$1  = -2;
var Z_DATA_ERROR$1    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR$1     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION$1 = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY$1    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED$2  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS$1 = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg$2[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils$i.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils$i.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32$1(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32$2(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils$i.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH$2) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH$2) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH$2) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$2) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH$1) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$2) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED$2; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils$i.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils$i.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils$i.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils$i.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils$i.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils$i.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR$1);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH$1;
  trees._tr_init(s);
  return Z_OK$2;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK$2) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR$1; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR$1; }
  strm.state.gzhead = head;
  return Z_OK$2;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR$1;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION$1) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR$1);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils$i.Buf8(s.w_size * 2);
  s.head = new utils$i.Buf16(s.hash_size);
  s.prev = new utils$i.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils$i.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
}


function deflate$2(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK$1 || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR$1) : Z_STREAM_ERROR$1;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH$2)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$1);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32$2(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED$2 + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK$2;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH$2) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH$1 && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK$2;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK$1) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK$2;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH$2) { return Z_OK$2; }
  if (s.wrap <= 0) { return Z_STREAM_END$2; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK$2 : Z_STREAM_END$2;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR$1;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR$1);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$1) : Z_OK$2;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR$1;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR$1;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32$1(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils$i.Buf8(s.w_size);
    utils$i.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK$2;
}


deflate$3.deflateInit = deflateInit;
deflate$3.deflateInit2 = deflateInit2;
deflate$3.deflateReset = deflateReset;
deflate$3.deflateResetKeep = deflateResetKeep;
deflate$3.deflateSetHeader = deflateSetHeader;
deflate$3.deflate = deflate$2;
deflate$3.deflateEnd = deflateEnd;
deflate$3.deflateSetDictionary = deflateSetDictionary;
deflate$3.deflateInfo = 'pako deflate (from Nodeca project)';

var strings$2 = {};

var utils$h = common;


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils$h.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
strings$2.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils$h.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils$h.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
strings$2.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
strings$2.binstring2buf = function (str) {
  var buf = new utils$h.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
strings$2.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
strings$2.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream$2() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

var zstream = ZStream$2;

var zlib_deflate = deflate$3;
var utils$g        = common;
var strings$1      = strings$2;
var msg$1          = messages;
var ZStream$1      = zstream;

var toString$1 = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH$1        = 4;

var Z_OK$1            = 0;
var Z_STREAM_END$1    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED$1  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils$g.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream$1();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK$1) {
    throw new Error(msg$1[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings$1.string2buf(opt.dictionary);
    } else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK$1) {
      throw new Error(msg$1[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH$1 : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings$1.string2buf(data);
  } else if (toString$1.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils$g.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END$1 && status !== Z_OK$1) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH$1 || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings$1.buf2binstring(utils$g.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils$g.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END$1);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH$1) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK$1;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK$1);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK$1) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils$g.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate$1(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg$1[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate$1(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate$1(input, options);
}


deflate$4.Deflate = Deflate;
deflate$4.deflate = deflate$1;
deflate$4.deflateRaw = deflateRaw;
deflate$4.gzip = gzip;

var inflate$4 = {};

var inflate$3 = {};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD$1 = 30;       /* got a data error -- remain here until reset */
var TYPE$1 = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
var inffast = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD$1;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD$1;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD$1;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE$1;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD$1;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils$f = common;

var MAXBITS = 15;
var ENOUGH_LENS$1 = 852;
var ENOUGH_DISTS$1 = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES$1 = 0;
var LENS$1 = 1;
var DISTS$1 = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

var inftrees = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils$f.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils$f.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES$1 || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES$1) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS$1) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
    (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
        (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils$e         = common;
var adler32       = adler32_1;
var crc32$1         = crc32_1;
var inflate_fast  = inffast;
var inflate_table = inftrees;

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils$e.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils$e.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils$e.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils$e.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils$e.Buf32(512);
    distfix = new utils$e.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils$e.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils$e.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils$e.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils$e.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate$2(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils$e.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32$1(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32$1(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32$1(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32$1(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32$1(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils$e.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32$1(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32$1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32$1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils$e.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32$1(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32$1(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

inflate$3.inflateReset = inflateReset;
inflate$3.inflateReset2 = inflateReset2;
inflate$3.inflateResetKeep = inflateResetKeep;
inflate$3.inflateInit = inflateInit;
inflate$3.inflateInit2 = inflateInit2;
inflate$3.inflate = inflate$2;
inflate$3.inflateEnd = inflateEnd;
inflate$3.inflateGetHeader = inflateGetHeader;
inflate$3.inflateSetDictionary = inflateSetDictionary;
inflate$3.inflateInfo = 'pako inflate (from Nodeca project)';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var constants$1 = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader$1() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

var gzheader = GZheader$1;

var zlib_inflate = inflate$3;
var utils$d        = common;
var strings      = strings$2;
var c$1            = constants$1;
var msg          = messages;
var ZStream      = zstream;
var GZheader     = gzheader;

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils$d.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c$1.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== c$1.Z_OK) {
        throw new Error(msg[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c$1.Z_FINISH : c$1.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils$d.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c$1.Z_NO_FLUSH);    /* no bad return value */

    if (status === c$1.Z_NEED_DICT && dictionary) {
      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
    }

    if (status === c$1.Z_BUF_ERROR && allowBufError === true) {
      status = c$1.Z_OK;
      allowBufError = false;
    }

    if (status !== c$1.Z_STREAM_END && status !== c$1.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c$1.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c$1.Z_FINISH || _mode === c$1.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils$d.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils$d.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c$1.Z_STREAM_END);

  if (status === c$1.Z_STREAM_END) {
    _mode = c$1.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c$1.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c$1.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c$1.Z_SYNC_FLUSH) {
    this.onEnd(c$1.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c$1.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 aligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils$d.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate$1(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate$1(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


inflate$4.Inflate = Inflate;
inflate$4.inflate = inflate$1;
inflate$4.inflateRaw = inflateRaw;
inflate$4.ungzip  = inflate$1;

var assign    = common.assign;

var deflate   = deflate$4;
var inflate   = inflate$4;
var constants = constants$1;

var pako$1 = {};

assign(pako$1, deflate, inflate, constants);

var pako_1 = pako$1;

var USE_TYPEDARRAY = (typeof Uint8Array !== "undefined") && (typeof Uint16Array !== "undefined") && (typeof Uint32Array !== "undefined");

var pako = pako_1;
var utils$c = utils$r;
var GenericWorker$4 = GenericWorker_1;

var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";

flate.magic = "\x08\x00";

/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */
function FlateWorker(action, options) {
    GenericWorker$4.call(this, "FlateWorker/" + action);

    this._pako = null;
    this._pakoAction = action;
    this._pakoOptions = options;
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};
}

utils$c.inherits(FlateWorker, GenericWorker$4);

/**
 * @see GenericWorker.processChunk
 */
FlateWorker.prototype.processChunk = function (chunk) {
    this.meta = chunk.meta;
    if (this._pako === null) {
        this._createPako();
    }
    this._pako.push(utils$c.transformTo(ARRAY_TYPE, chunk.data), false);
};

/**
 * @see GenericWorker.flush
 */
FlateWorker.prototype.flush = function () {
    GenericWorker$4.prototype.flush.call(this);
    if (this._pako === null) {
        this._createPako();
    }
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */
FlateWorker.prototype.cleanUp = function () {
    GenericWorker$4.prototype.cleanUp.call(this);
    this._pako = null;
};

/**
 * Create the _pako object.
 * TODO: lazy-loading this object isn't the best solution but it's the
 * quickest. The best solution is to lazy-load the worker list. See also the
 * issue #446.
 */
FlateWorker.prototype._createPako = function () {
    this._pako = new pako[this._pakoAction]({
        raw: true,
        level: this._pakoOptions.level || -1 // default compression
    });
    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data : data,
            meta : self.meta
        });
    };
};

flate.compressWorker = function (compressionOptions) {
    return new FlateWorker("Deflate", compressionOptions);
};
flate.uncompressWorker = function () {
    return new FlateWorker("Inflate", {});
};

var GenericWorker$3 = GenericWorker_1;

compressions$2.STORE = {
    magic: "\x00\x00",
    compressWorker : function () {
        return new GenericWorker$3("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker$3("STORE decompression");
    }
};
compressions$2.DEFLATE = flate;

var signature$1 = {};

signature$1.LOCAL_FILE_HEADER = "PK\x03\x04";
signature$1.CENTRAL_FILE_HEADER = "PK\x01\x02";
signature$1.CENTRAL_DIRECTORY_END = "PK\x05\x06";
signature$1.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
signature$1.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
signature$1.DATA_DESCRIPTOR = "PK\x07\x08";

var utils$b = utils$r;
var GenericWorker$2 = GenericWorker_1;
var utf8$3 = utf8$5;
var crc32 = crc32_1$1;
var signature = signature$1;

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "", i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */
var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

    var result = unixPermissions;
    if (!unixPermissions) {
        // I can't use octal values in strict mode, hence the hexa.
        //  040775 => 0x41fd
        // 0100664 => 0x81b4
        result = isDir ? 0x41fd : 0x81b4;
    }
    return (result & 0xFFFF) << 16;
};

/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */
var generateDosExternalFileAttr = function (dosPermissions) {
    // the dir flag is already set for compatibility
    return (dosPermissions || 0)  & 0x3F;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with information about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */
var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo["file"],
        compression = streamInfo["compression"],
        useCustomEncoding = encodeFileName !== utf8$3.utf8encode,
        encodedFileName = utils$b.transformTo("string", encodeFileName(file.name)),
        utfEncodedFileName = utils$b.transformTo("string", utf8$3.utf8encode(file.name)),
        comment = file.comment,
        encodedComment = utils$b.transformTo("string", encodeFileName(comment)),
        utfEncodedComment = utils$b.transformTo("string", utf8$3.utf8encode(comment)),
        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
        useUTF8ForComment = utfEncodedComment.length !== comment.length,
        dosTime,
        dosDate,
        extraFields = "",
        unicodePathExtraField = "",
        unicodeCommentExtraField = "",
        dir = file.dir,
        date = file.date;


    var dataInfo = {
        crc32 : 0,
        compressedSize : 0,
        uncompressedSize : 0
    };

    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo["crc32"];
        dataInfo.compressedSize = streamInfo["compressedSize"];
        dataInfo.uncompressedSize = streamInfo["uncompressedSize"];
    }

    var bitflag = 0;
    if (streamedContent) {
        // Bit 3: the sizes/crc32 are set to zero in the local header.
        // The correct values are put in the data descriptor immediately
        // following the compressed data.
        bitflag |= 0x0008;
    }
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
        // Bit 11: Language encoding flag (EFS).
        bitflag |= 0x0800;
    }


    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) {
        // dos or unix, we set the dos dir flag
        extFileAttr |= 0x00010;
    }
    if(platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else { // DOS or other, fallback to DOS
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions);
    }

    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;

    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getUTCMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(encodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(crc32(encodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    header += decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(dataInfo.crc32, 4);
    // compressed size
    header += decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += decToHex(encodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};

/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */
var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = utils$b.transformTo("string", encodeFileName(comment));

    // end of central dir signature
    dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;

    return dirEnd;
};

/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing information
 * on the file entry.
 * @return {String} the data descriptors.
 */
var generateDataDescriptors = function (streamInfo) {
    var descriptor = "";
    descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo["crc32"], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo["compressedSize"], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo["uncompressedSize"], 4);

    return descriptor;
};


/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */
function ZipFileWorker$1(streamFiles, comment, platform, encodeFileName) {
    GenericWorker$2.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emitted metadata.
    this.currentFile = null;



    this._sources = [];
}
utils$b.inherits(ZipFileWorker$1, GenericWorker$2);

/**
 * @see GenericWorker.push
 */
ZipFileWorker$1.prototype.push = function (chunk) {

    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;

    if(this.accumulate) {
        this.contentBuffer.push(chunk);
    } else {
        this.bytesWritten += chunk.data.length;

        GenericWorker$2.prototype.push.call(this, {
            data : chunk.data,
            meta : {
                currentFile : this.currentFile,
                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};

/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */
ZipFileWorker$1.prototype.openedSource = function (streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo["file"].name;

    var streamedContent = this.streamFiles && !streamInfo["file"].dir;

    // don't stream folders (because they don't have any content)
    if(streamedContent) {
        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
    } else {
        // we need to wait for the whole file before pushing anything
        this.accumulate = true;
    }
};

/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */
ZipFileWorker$1.prototype.closedSource = function (streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);

    this.dirRecords.push(record.dirRecord);
    if(streamedContent) {
        // after the streamed file, we put data descriptors
        this.push({
            data : generateDataDescriptors(streamInfo),
            meta : {percent:100}
        });
    } else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
        while(this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
        }
    }
    this.currentFile = null;
};

/**
 * @see GenericWorker.flush
 */
ZipFileWorker$1.prototype.flush = function () {

    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++) {
        this.push({
            data : this.dirRecords[i],
            meta : {percent:100}
        });
    }
    var centralDirLength = this.bytesWritten - localDirLength;

    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);

    this.push({
        data : dirEnd,
        meta : {percent:100}
    });
};

/**
 * Prepare the next source to be read.
 */
ZipFileWorker$1.prototype.prepareNextSource = function () {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) {
        this.previous.pause();
    } else {
        this.previous.resume();
    }
};

/**
 * @see GenericWorker.registerPrevious
 */
ZipFileWorker$1.prototype.registerPrevious = function (previous) {
    this._sources.push(previous);
    var self = this;

    previous.on("data", function (chunk) {
        self.processChunk(chunk);
    });
    previous.on("end", function () {
        self.closedSource(self.previous.streamInfo);
        if(self._sources.length) {
            self.prepareNextSource();
        } else {
            self.end();
        }
    });
    previous.on("error", function (e) {
        self.error(e);
    });
    return this;
};

/**
 * @see GenericWorker.resume
 */
ZipFileWorker$1.prototype.resume = function () {
    if(!GenericWorker$2.prototype.resume.call(this)) {
        return false;
    }

    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};

/**
 * @see GenericWorker.error
 */
ZipFileWorker$1.prototype.error = function (e) {
    var sources = this._sources;
    if(!GenericWorker$2.prototype.error.call(this, e)) {
        return false;
    }
    for(var i = 0; i < sources.length; i++) {
        try {
            sources[i].error(e);
        } catch(e) {
            // the `error` exploded, nothing to do
        }
    }
    return true;
};

/**
 * @see GenericWorker.lock
 */
ZipFileWorker$1.prototype.lock = function () {
    GenericWorker$2.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++) {
        sources[i].lock();
    }
};

var ZipFileWorker_1 = ZipFileWorker$1;

var compressions$1 = compressions$2;
var ZipFileWorker = ZipFileWorker_1;

/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */
var getCompression = function (fileCompression, zipCompression) {

    var compressionName = fileCompression || zipCompression;
    var compression = compressions$1[compressionName];
    if (!compression) {
        throw new Error(compressionName + " is not a valid compression method !");
    }
    return compression;
};

/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */
generate$1.generateWorker = function (zip, options, comment) {

    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {

        zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;

            file._compressWorker(compression, compressionOptions)
                .withStreamInfo("file", {
                    name : relativePath,
                    dir : dir,
                    date : date,
                    comment : file.comment || "",
                    unixPermissions : file.unixPermissions,
                    dosPermissions : file.dosPermissions
                })
                .pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }

    return zipFileWorker;
};

var utils$a = utils$r;
var GenericWorker$1 = GenericWorker_1;

/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */
function NodejsStreamInputAdapter$1(filename, stream) {
    GenericWorker$1.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}

utils$a.inherits(NodejsStreamInputAdapter$1, GenericWorker$1);

/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */
NodejsStreamInputAdapter$1.prototype._bindStream = function (stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream
        .on("data", function (chunk) {
            self.push({
                data: chunk,
                meta : {
                    percent : 0
                }
            });
        })
        .on("error", function (e) {
            if(self.isPaused) {
                this.generatedError = e;
            } else {
                self.error(e);
            }
        })
        .on("end", function () {
            if(self.isPaused) {
                self._upstreamEnded = true;
            } else {
                self.end();
            }
        });
};
NodejsStreamInputAdapter$1.prototype.pause = function () {
    if(!GenericWorker$1.prototype.pause.call(this)) {
        return false;
    }
    this._stream.pause();
    return true;
};
NodejsStreamInputAdapter$1.prototype.resume = function () {
    if(!GenericWorker$1.prototype.resume.call(this)) {
        return false;
    }

    if(this._upstreamEnded) {
        this.end();
    } else {
        this._stream.resume();
    }

    return true;
};

var NodejsStreamInputAdapter_1 = NodejsStreamInputAdapter$1;

var utf8$2 = utf8$5;
var utils$9 = utils$r;
var GenericWorker = GenericWorker_1;
var StreamHelper = StreamHelper_1;
var defaults = defaults$1;
var CompressedObject$1 = compressedObject;
var ZipObject = zipObject;
var generate = generate$1;
var nodejsUtils$1 = nodejsUtils$2;
var NodejsStreamInputAdapter = NodejsStreamInputAdapter_1;


/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = utils$9.getTypeOf(data),
        parent;


    /*
     * Correct options.
     */

    var o = utils$9.extend(originalOptions || {}, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) {
        o.compression = o.compression.toUpperCase();
    }

    if (typeof o.unixPermissions === "string") {
        o.unixPermissions = parseInt(o.unixPermissions, 8);
    }

    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
        o.dir = true;
    }
    // Bit 4    Directory
    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
        o.dir = true;
    }

    if (o.dir) {
        name = forceTrailingSlash(name);
    }
    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") {
        o.binary = !isUnicodeString;
    }


    var isCompressedEmpty = (data instanceof CompressedObject$1) && data.uncompressedSize === 0;

    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }

    /*
     * Convert content to fit.
     */

    var zipObjectContent = null;
    if (data instanceof CompressedObject$1 || data instanceof GenericWorker) {
        zipObjectContent = data;
    } else if (nodejsUtils$1.isNode && nodejsUtils$1.isStream(data)) {
        zipObjectContent = new NodejsStreamInputAdapter(name, data);
    } else {
        zipObjectContent = utils$9.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    }

    var object = new ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
    /*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) === "/") {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf("/");
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */
var forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") {
        path += "/"; // IE doesn't like substr(-1)
    }
    return path;
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    createFolders = (typeof createFolders !== "undefined") ? createFolders : defaults.createFolders;

    name = forceTrailingSlash(name);

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}

// return the actual prototype of JSZip
var out = {
    /**
     * @see loadAsync
     */
    load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },


    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */
    forEach: function(cb) {
        var filename, relativePath, file;
        // ignore warning about unwanted properties because this.files is a null prototype object
        /* eslint-disable-next-line guard-for-in */
        for (filename in this.files) {
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
        }
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [];
        this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) { // the file matches the function
                result.push(entry);
            }

        });
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) {
                    return obj;
                } else {
                    return null;
                }
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * @deprecated This method has been removed in JSZip 3.0, please check the upgrade guide.
     */
    generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },

    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */
    generateInternalStream: function(options) {
        var worker, opts = {};
        try {
            opts = utils$9.extend(options || {}, {
                streamFiles: false,
                compression: "STORE",
                compressionOptions : null,
                type: "",
                platform: "DOS",
                comment: null,
                mimeType: "application/zip",
                encodeFileName: utf8$2.utf8encode
            });

            opts.type = opts.type.toLowerCase();
            opts.compression = opts.compression.toUpperCase();

            // "binarystring" is preferred but the internals use "string".
            if(opts.type === "binarystring") {
                opts.type = "string";
            }

            if (!opts.type) {
                throw new Error("No output type specified.");
            }

            utils$9.checkSupport(opts.type);

            // accept nodejs `process.platform`
            if(
                opts.platform === "darwin" ||
                opts.platform === "freebsd" ||
                opts.platform === "linux" ||
                opts.platform === "sunos"
            ) {
                opts.platform = "UNIX";
            }
            if (opts.platform === "win32") {
                opts.platform = "DOS";
            }

            var comment = opts.comment || this.comment || "";
            worker = generate.generateWorker(this, opts, comment);
        } catch (e) {
            worker = new GenericWorker("error");
            worker.error(e);
        }
        return new StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) {
            options.type = "nodebuffer";
        }
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
var object = out;

var utils$8 = utils$r;

function DataReader$2(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
DataReader$2.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specified index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function() {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils$8.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function() {
        // see implementations
    },
    /**
     * Find the last occurrence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurrence, -1 if not found.
     */
    lastIndexOfSignature: function() {
        // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */
    readAndCheckSignature: function() {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC(
            ((dostime >> 25) & 0x7f) + 1980, // year
            ((dostime >> 21) & 0x0f) - 1, // month
            (dostime >> 16) & 0x1f, // day
            (dostime >> 11) & 0x1f, // hour
            (dostime >> 5) & 0x3f, // minute
            (dostime & 0x1f) << 1)); // second
    }
};
var DataReader_1 = DataReader$2;

var DataReader$1 = DataReader_1;
var utils$7 = utils$r;

function ArrayReader$2(data) {
    DataReader$1.call(this, data);
    for(var i = 0; i < this.data.length; i++) {
        data[i] = data[i] & 0xFF;
    }
}
utils$7.inherits(ArrayReader$2, DataReader$1);
/**
 * @see DataReader.byteAt
 */
ArrayReader$2.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
ArrayReader$2.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
        }
    }

    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */
ArrayReader$2.prototype.readAndCheckSignature = function (sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3),
        data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */
ArrayReader$2.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        return [];
    }
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
var ArrayReader_1 = ArrayReader$2;

var DataReader = DataReader_1;
var utils$6 = utils$r;

function StringReader$1(data) {
    DataReader.call(this, data);
}
utils$6.inherits(StringReader$1, DataReader);
/**
 * @see DataReader.byteAt
 */
StringReader$1.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader$1.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */
StringReader$1.prototype.readAndCheckSignature = function (sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */
StringReader$1.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
var StringReader_1 = StringReader$1;

var ArrayReader$1 = ArrayReader_1;
var utils$5 = utils$r;

function Uint8ArrayReader$2(data) {
    ArrayReader$1.call(this, data);
}
utils$5.inherits(Uint8ArrayReader$2, ArrayReader$1);
/**
 * @see DataReader.readData
 */
Uint8ArrayReader$2.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
var Uint8ArrayReader_1 = Uint8ArrayReader$2;

var Uint8ArrayReader$1 = Uint8ArrayReader_1;
var utils$4 = utils$r;

function NodeBufferReader$1(data) {
    Uint8ArrayReader$1.call(this, data);
}
utils$4.inherits(NodeBufferReader$1, Uint8ArrayReader$1);

/**
 * @see DataReader.readData
 */
NodeBufferReader$1.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
var NodeBufferReader_1 = NodeBufferReader$1;

var utils$3 = utils$r;
var support$2 = support$5;
var ArrayReader = ArrayReader_1;
var StringReader = StringReader_1;
var NodeBufferReader = NodeBufferReader_1;
var Uint8ArrayReader = Uint8ArrayReader_1;

/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */
var readerFor$2 = function (data) {
    var type = utils$3.getTypeOf(data);
    utils$3.checkSupport(type);
    if (type === "string" && !support$2.uint8array) {
        return new StringReader(data);
    }
    if (type === "nodebuffer") {
        return new NodeBufferReader(data);
    }
    if (support$2.uint8array) {
        return new Uint8ArrayReader(utils$3.transformTo("uint8array", data));
    }
    return new ArrayReader(utils$3.transformTo("array", data));
};

var readerFor$1 = readerFor$2;
var utils$2 = utils$r;
var CompressedObject = compressedObject;
var crc32fn = crc32_1$1;
var utf8$1 = utf8$5;
var compressions = compressions$2;
var support$1 = support$5;

var MADE_BY_DOS = 0x00;
var MADE_BY_UNIX = 0x03;

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
var findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!Object.prototype.hasOwnProperty.call(compressions, method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};

// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry$1(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry$1.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough information from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
        }

        compression = findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils$2.pretty(this.compressionMethod) + " unknown (inner file : " + utils$2.transformTo("string", this.fileName) + ")");
        }
        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },

    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */
    processAttributes: function () {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;

        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

        if(madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
        }

        if(madeBy === MADE_BY_UNIX) {
            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
        }

        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === "/") {
            this.dir = true;
        }
    },

    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function() {
        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = readerFor$1(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils$2.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils$2.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils$2.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils$2.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        if (!this.extraFields) {
            this.extraFields = {};
        }

        while (reader.index + 4 < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }

        reader.setIndex(end);
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        var decodeParamType = support$1.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = utf8$1.utf8decode(this.fileName);
            this.fileCommentStr = utf8$1.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileNameStr = upath;
            } else {
                // ASCII text or unsupported code page
                var fileNameByteArray =  utils$2.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }

            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileCommentStr = ucomment;
            } else {
                // ASCII text or unsupported code page
                var commentByteArray =  utils$2.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = readerFor$1(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8$1.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = readerFor$1(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8$1.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
var zipEntry = ZipEntry$1;

var readerFor = readerFor$2;
var utils$1 = utils$r;
var sig = signature$1;
var ZipEntry = zipEntry;
var support = support$5;
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries$1(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
ZipEntries$1.prototype = {
    /**
     * Check that the reader is on the specified signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils$1.pretty(signature) + ", expected " + utils$1.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */
    isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = utils$1.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }

        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
                // We expected some records but couldn't find ANY.
                // This is really suspicious, as if something went wrong.
                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            }
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

            if (isGarbage) {
                throw new Error("Can't find end of central directory : is this a zip file ? " +
                                "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
                throw new Error("Corrupted zip: can't find end of central directory");
            }

        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils$1.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils$1.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils$1.MAX_VALUE_16BITS || this.centralDirRecords === utils$1.MAX_VALUE_16BITS || this.centralDirSize === utils$1.MAX_VALUE_32BITS || this.centralDirOffset === utils$1.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }

        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
        }

        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) ; else {
                // the offset is wrong, update the "zero" of the reader
                // this happens if data has been prepended (crx files for example)
                this.reader.zero = extraBytes;
            }
        } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
        }
    },
    prepareReader: function(data) {
        this.reader = readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
var zipEntries = ZipEntries$1;

var utils = utils$r;
var external = external$3;
var utf8 = utf8$5;
var ZipEntries = zipEntries;
var Crc32Probe = Crc32Probe_1;
var nodejsUtils = nodejsUtils$2;

/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */
function checkEntryCRC32(zipEntry) {
    return new external.Promise(function (resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
        worker.on("error", function (e) {
            reject(e);
        })
            .on("end", function () {
                if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
                    reject(new Error("Corrupted zip : CRC32 mismatch"));
                } else {
                    resolve();
                }
            })
            .resume();
    });
}

var load = function (data, options) {
    var zip = this;
    options = utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: utf8.utf8decode
    });

    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    }

    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
        .then(function (data) {
            var zipEntries = new ZipEntries(options);
            zipEntries.load(data);
            return zipEntries;
        }).then(function checkCRC32(zipEntries) {
            var promises = [external.Promise.resolve(zipEntries)];
            var files = zipEntries.files;
            if (options.checkCRC32) {
                for (var i = 0; i < files.length; i++) {
                    promises.push(checkEntryCRC32(files[i]));
                }
            }
            return external.Promise.all(promises);
        }).then(function addFiles(results) {
            var zipEntries = results.shift();
            var files = zipEntries.files;
            for (var i = 0; i < files.length; i++) {
                var input = files[i];

                var unsafeName = input.fileNameStr;
                var safeName = utils.resolve(input.fileNameStr);

                zip.file(safeName, input.decompressed, {
                    binary: true,
                    optimizedBinaryString: true,
                    date: input.date,
                    dir: input.dir,
                    comment: input.fileCommentStr.length ? input.fileCommentStr : null,
                    unixPermissions: input.unixPermissions,
                    dosPermissions: input.dosPermissions,
                    createFolders: options.createFolders
                });
                if (!input.dir) {
                    zip.file(safeName).unsafeOriginalName = unsafeName;
                }
            }
            if (zipEntries.zipComment.length) {
                zip.comment = zipEntries.zipComment;
            }

            return zip;
        });
};

/**
 * Representation a of zip file in js
 * @constructor
 */
function JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZip)) {
        return new JSZip();
    }

    if(arguments.length) {
        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    }

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    // NOTE: we use a null prototype because we do not
    // want filenames like "toString" coming from a zip file
    // to overwrite methods and attributes in a normal Object.
    this.files = Object.create(null);

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new JSZip();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZip.prototype = object;
JSZip.prototype.loadAsync = load;
JSZip.support = support$5;
JSZip.defaults = defaults$1;

// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
JSZip.version = "3.10.1";

JSZip.loadAsync = function (content, options) {
    return new JSZip().loadAsync(content, options);
};

JSZip.external = external$3;
var lib = JSZip;

/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var __awaiter$7 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$7 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(FileUtils, "__esModule", { value: true });
FileUtils.getStoreMapPath = FileUtils.readAndParseJsonFile = FileUtils.downloadFileFromUrl = FileUtils.humanReadableSize = FileUtils.readAsDataUrlSync = FileUtils.compressFiles = FileUtils.isFileType = void 0;
var jszip_1 = __importDefault(lib);
var isFileType = function (file, type) {
    var pattern = new RegExp('\\.' + type + '$');
    return pattern.test(file.name);
};
FileUtils.isFileType = isFileType;
var compressFiles = function (files) { return __awaiter$7(void 0, void 0, void 0, function () {
    var zip, _i, files_1, file, generatedZip;
    return __generator$7(this, function (_a) {
        switch (_a.label) {
            case 0:
                zip = new jszip_1.default();
                for (_i = 0, files_1 = files; _i < files_1.length; _i++) {
                    file = files_1[_i];
                    zip.file(file.path, file);
                }
                return [4 /*yield*/, zip.generateAsync({ type: 'blob' })];
            case 1:
                generatedZip = _a.sent();
                return [2 /*return*/, generatedZip];
        }
    });
}); };
FileUtils.compressFiles = compressFiles;
var bufferToString = function (buffer) {
    return String.fromCharCode.apply(null, Array.from(new Uint16Array(buffer)));
};
var readAsDataUrlSync = function (file) { return __awaiter$7(void 0, void 0, void 0, function () {
    var resultBase64;
    return __generator$7(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) {
                    var reader = new FileReader();
                    reader.onload = function () {
                        var result = reader.result;
                        if (result instanceof ArrayBuffer) {
                            resolve(bufferToString(result));
                            return;
                        }
                        resolve(result || undefined);
                    };
                    reader.readAsDataURL(file);
                })];
            case 1:
                resultBase64 = _a.sent();
                return [2 /*return*/, resultBase64];
        }
    });
}); };
FileUtils.readAsDataUrlSync = readAsDataUrlSync;
var humanReadableSize = function (bytes, precision) {
    var index = Math.floor(Math.log(bytes) / Math.log(1024));
    var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var roughSize = bytes / Math.pow(1024, index);
    var roundedSize = precision
        ? parseFloat(roughSize.toFixed(precision)) * 1
        : Math.round(roughSize);
    return "".concat(roundedSize, " ").concat(sizes[index]);
};
FileUtils.humanReadableSize = humanReadableSize;
var downloadFileFromUrl = function (downloadUrl) {
    var link = document.createElement('a');
    link.href = downloadUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
FileUtils.downloadFileFromUrl = downloadFileFromUrl;
var readAndParseJsonFile = function (file) { return __awaiter$7(void 0, void 0, void 0, function () {
    var jsonResult;
    return __generator$7(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                    var fileReader = new FileReader();
                    fileReader.addEventListener('load', function (e) {
                        if (typeof fileReader.result === 'string') {
                            try {
                                var json = JSON.parse(fileReader.result);
                                resolve(json);
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                    });
                    fileReader.readAsText(file);
                })];
            case 1:
                jsonResult = _a.sent();
                return [2 /*return*/, jsonResult];
        }
    });
}); };
FileUtils.readAndParseJsonFile = readAndParseJsonFile;
var formatDir = function (value) {
    return value.toLowerCase().split(' ').join('-');
};
var getStoreMapPath = function (store) {
    if (store && store.address) {
        var address = store.address, category = store.category;
        var state = address.state, city = address.city;
        return "".concat(formatDir(state), "/").concat(formatDir(city), "/").concat(category);
    }
    return null;
};
FileUtils.getStoreMapPath = getStoreMapPath;

var levenshtein = {};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
Object.defineProperty(levenshtein, "__esModule", { value: true });
levenshtein.levenshteinDistance = void 0;
var levenshteinDistance = function (arr1, arr2) {
    var track = Array(arr2.length + 1)
        .fill(null)
        .map(function () { return Array(arr1.length + 1).fill(null); });
    for (var i = 0; i <= arr1.length; i += 1) {
        track[0][i] = i;
    }
    for (var j = 0; j <= arr2.length; j += 1) {
        track[j][0] = j;
    }
    for (var j = 1; j <= arr2.length; j += 1) {
        for (var i = 1; i <= arr1.length; i += 1) {
            var indicator = arr1[i - 1] === arr2[j - 1] ? 0 : 1;
            track[j][i] = Math.min(track[j][i - 1] + 1, // deletion
            track[j - 1][i] + 1, // insertion
            track[j - 1][i - 1] + indicator);
        }
    }
    return track[arr2.length][arr1.length];
};
levenshtein.levenshteinDistance = levenshteinDistance;

(function (exports) {
/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(date, exports);
__exportStar(ApolloUtils, exports);
__exportStar(IDUtils, exports);
__exportStar(maps, exports);
__exportStar(utils$s, exports);
__exportStar(UserUtils, exports);
__exportStar(FileUtils, exports);
__exportStar(levenshtein, exports);
}(utils$t));

var hooks = {};

var useGetPhysicalStores$1 = {};

function c(u,e,c){var i=this,a=React.useRef(null),o=React.useRef(0),f=React.useRef(null),l=React.useRef([]),m=React.useRef(),v=React.useRef(),d=React.useRef(u),p=React.useRef(!0);React.useEffect(function(){d.current=u;},[u]);var g=!e&&0!==e&&"undefined"!=typeof window;if("function"!=typeof u)throw new TypeError("Expected a function");e=+e||0;var w=!!(c=c||{}).leading,s=!("trailing"in c)||!!c.trailing,x="maxWait"in c,y=x?Math.max(+c.maxWait||0,e):null;React.useEffect(function(){return p.current=!0,function(){p.current=!1;}},[]);var h=React.useMemo(function(){var r=function(r){var n=l.current,t=m.current;return l.current=m.current=null,o.current=r,v.current=d.current.apply(t,n)},n=function(r,n){g&&cancelAnimationFrame(f.current),f.current=g?requestAnimationFrame(r):setTimeout(r,n);},t=function(r){if(!p.current)return !1;var n=r-a.current;return !a.current||n>=e||n<0||x&&r-o.current>=y},u=function(n){return f.current=null,s&&l.current?r(n):(l.current=m.current=null,v.current)},c=function r(){var c=Date.now();if(t(c))return u(c);if(p.current){var i=e-(c-a.current),f=x?Math.min(i,y-(c-o.current)):i;n(r,f);}},h=function(){var u=Date.now(),d=t(u);if(l.current=[].slice.call(arguments),m.current=i,a.current=u,d){if(!f.current&&p.current)return o.current=a.current,n(c,e),w?r(a.current):v.current;if(x)return n(c,e),r(a.current)}return f.current||n(c,e),v.current};return h.cancel=function(){f.current&&(g?cancelAnimationFrame(f.current):clearTimeout(f.current)),o.current=0,l.current=a.current=m.current=f.current=null;},h.isPending=function(){return !!f.current},h.flush=function(){return f.current?u(Date.now()):v.current},h},[w,x,e,y,s,g]);return h}function i(r,n){return r===n}function a(r){return "function"==typeof r?function(){return r}:r}function o(n,t,o){var f,l,m=o&&o.equalityFn||i,v=(f=React.useState(a(n)),l=f[1],[f[0],React.useCallback(function(r){return l(a(r))},[])]),d=v[0],p=v[1],g=c(React.useCallback(function(r){return p(r)},[p]),t,o),w=React.useRef(n);return m(w.current,n)||(g(n),w.current=n),[d,g]}function f(r,n,t){var u=void 0===t?{}:t,e=u.leading,i=u.trailing;return c(r,n,{maxWait:n,leading:void 0===e||e,trailing:void 0===i||i})}

var index_module = /*#__PURE__*/Object.freeze({
    __proto__: null,
    useDebounce: o,
    useDebouncedCallback: c,
    useThrottledCallback: f
});

var require$$3 = /*@__PURE__*/getAugmentedNamespace(index_module);

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var __assign$j = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$j = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$j.apply(this, arguments);
};
var __awaiter$6 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$6 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray$2 = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(useGetPhysicalStores$1, "__esModule", { value: true });
useGetPhysicalStores$1.useGetPhysicalStores = void 0;
var client_1$u = require$$0$1;
var graphql_1$u = lib$4;
var react_1$3 = React__default["default"];
var use_debounce_1 = require$$3;
var useGetPhysicalStores = function (input, fetchPolicy) {
    var _a = (0, client_1$u.useLazyQuery)(graphql_1$u.GET_PHYSICAL_STORES, { fetchPolicy: fetchPolicy }), getPhysicalStores = _a[0], _b = _a[1], data = _b.data, loading = _b.loading, error = _b.error, fetchMore = _b.fetchMore;
    var _c = (0, react_1$3.useState)(''), searchTerm = _c[0], setSearchTerm = _c[1];
    var debouncedSearchTerm = (0, use_debounce_1.useDebounce)(searchTerm, 750)[0];
    (0, react_1$3.useEffect)(function () {
        getPhysicalStores({ variables: { input: __assign$j(__assign$j({}, input), { searchTerm: searchTerm }) } });
    }, [debouncedSearchTerm]);
    var storesData = data === null || data === void 0 ? void 0 : data.stores;
    var stores = storesData === null || storesData === void 0 ? void 0 : storesData.results;
    var fetchNextPage = function () { return __awaiter$6(void 0, void 0, void 0, function () {
        return __generator$6(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(stores && (storesData === null || storesData === void 0 ? void 0 : storesData.hasMore) && fetchMore)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchMore({
                            variables: { input: { searchTerm: searchTerm, offset: stores.length } },
                            updateQuery: function (prev, _a) {
                                var fetchMoreResult = _a.fetchMoreResult;
                                if (!fetchMoreResult)
                                    return prev;
                                return {
                                    stores: __assign$j(__assign$j({}, fetchMoreResult.stores), { results: __spreadArray$2(__spreadArray$2([], prev.stores.results, true), fetchMoreResult.stores.results, true) }),
                                };
                            },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        searchTerm: searchTerm,
        setSearchTerm: setSearchTerm,
        stores: stores,
        hasMore: storesData === null || storesData === void 0 ? void 0 : storesData.hasMore,
        count: storesData === null || storesData === void 0 ? void 0 : storesData.count,
        loading: loading,
        error: error,
        fetchNextPage: fetchNextPage,
    };
};
useGetPhysicalStores$1.useGetPhysicalStores = useGetPhysicalStores;

var useStoreAreas$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
Object.defineProperty(useStoreAreas$1, "__esModule", { value: true });
useStoreAreas$1.useStoreAreas = void 0;
var client_1$t = require$$0$1;
var graphql_1$t = lib$4;
var useStoreAreas = function () {
    var _a = (0, client_1$t.useQuery)(graphql_1$t.GET_STORE_AREAS), data = _a.data, loading = _a.loading, error = _a.error;
    var areas = (data === null || data === void 0 ? void 0 : data.storeAreas) || [];
    var areaNames = (data === null || data === void 0 ? void 0 : data.storeAreas.map(function (a) { return a.name; })) || [];
    return { areas: areas, areaNames: areaNames, loading: loading, error: error };
};
useStoreAreas$1.useStoreAreas = useStoreAreas;

var useDrawMapTasksMutations$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
Object.defineProperty(useDrawMapTasksMutations$1, "__esModule", { value: true });
useDrawMapTasksMutations$1.useDrawMapTasksMutations = void 0;
var client_1$s = require$$0$1;
var graphql_1$s = lib$4;
var useDrawMapTasksMutations = function () {
    var createIndoorMapDrawTask = (0, client_1$s.useMutation)(graphql_1$s.CREATE_INDOOR_MAP_DRAW_TASK)[0];
    var updateIndoorMapDrawTask = (0, client_1$s.useMutation)(graphql_1$s.UPDATE_INDOOR_MAP_DRAW_TASK)[0];
    var assignDrawMapTask = (0, client_1$s.useMutation)(graphql_1$s.ASSIGN_DRAW_MAP_TASK)[0];
    var createDrawMapTaskComment = (0, client_1$s.useMutation)(graphql_1$s.CREATE_DRAW_MAP_TASK_COMMENT)[0];
    var deleteDrawMapTaskComment = (0, client_1$s.useMutation)(graphql_1$s.DELETE_DRAW_MAP_TASK_COMMENT)[0];
    var updateDrawMapTaskComment = (0, client_1$s.useMutation)(graphql_1$s.UPDATE_DRAW_MAP_TASK_COMMENT)[0];
    var createStoreMap = (0, client_1$s.useMutation)(graphql_1$s.CREATE_STORE_MAP)[0];
    return {
        createIndoorMapDrawTask: createIndoorMapDrawTask,
        updateIndoorMapDrawTask: updateIndoorMapDrawTask,
        assignDrawMapTask: assignDrawMapTask,
        deleteDrawMapTaskComment: deleteDrawMapTaskComment,
        updateDrawMapTaskComment: updateDrawMapTaskComment,
        createDrawMapTaskComment: createDrawMapTaskComment,
        createStoreMap: createStoreMap,
    };
};
useDrawMapTasksMutations$1.useDrawMapTasksMutations = useDrawMapTasksMutations;

var useGetDrawMapTasks$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var __assign$i = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$i = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$i.apply(this, arguments);
};
var __awaiter$5 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$5 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray$1 = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(useGetDrawMapTasks$1, "__esModule", { value: true });
useGetDrawMapTasks$1.useGetDrawMapTasks = void 0;
var client_1$r = require$$0$1;
var graphql_1$r = lib$4;
var useGetDrawMapTasks = function (variables, fetchPolicy) {
    var _a = (0, client_1$r.useQuery)(graphql_1$r.GET_DRAW_MAP_TASKS, { variables: variables, fetchPolicy: fetchPolicy }), data = _a.data, loading = _a.loading, fetchMore = _a.fetchMore, error = _a.error;
    var tasksResult = data && data.drawMapTasks;
    var tasks = tasksResult && tasksResult.results;
    var fetchNextPage = function () { return __awaiter$5(void 0, void 0, void 0, function () {
        return __generator$5(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((tasksResult === null || tasksResult === void 0 ? void 0 : tasksResult.hasMore) && fetchMore && tasks)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchMore({
                            variables: { input: __assign$i(__assign$i({}, variables.input), { offset: tasks.length }) },
                            updateQuery: function (prev, _a) {
                                var fetchMoreResult = _a.fetchMoreResult;
                                if (!fetchMoreResult)
                                    return prev;
                                return {
                                    drawMapTasks: __assign$i(__assign$i({}, fetchMoreResult.drawMapTasks), { results: __spreadArray$1(__spreadArray$1([], prev.drawMapTasks.results, true), fetchMoreResult.drawMapTasks.results, true) }),
                                };
                            },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        tasks: tasks,
        hasMore: tasksResult === null || tasksResult === void 0 ? void 0 : tasksResult.hasMore,
        count: tasksResult === null || tasksResult === void 0 ? void 0 : tasksResult.count,
        loading: loading,
        error: error,
        fetchNextPage: fetchNextPage,
    };
};
useGetDrawMapTasks$1.useGetDrawMapTasks = useGetDrawMapTasks;

var useGetDrawMapTask$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
Object.defineProperty(useGetDrawMapTask$1, "__esModule", { value: true });
useGetDrawMapTask$1.useGetDrawMapTask = void 0;
var client_1$q = require$$0$1;
var graphql_1$q = lib$4;
var useGetDrawMapTask = function (variables) {
    var _a = (0, client_1$q.useQuery)(graphql_1$q.GET_DRAW_MAP_TASK, { variables: variables }), data = _a.data, loading = _a.loading, error = _a.error;
    var task = data === null || data === void 0 ? void 0 : data.getDrawMapTask;
    return {
        task: task,
        loading: loading,
        error: error,
    };
};
useGetDrawMapTask$1.useGetDrawMapTask = useGetDrawMapTask;

var useAuditQuestionAnswers$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
Object.defineProperty(useAuditQuestionAnswers$1, "__esModule", { value: true });
useAuditQuestionAnswers$1.useAuditQuestionAnswers = void 0;
var client_1$p = require$$0$1;
var graphql_1$p = lib$4;
var useAuditQuestionAnswers = function (props) {
    var auditId = props.auditId;
    var _a = (0, client_1$p.useQuery)(graphql_1$p.GET_STORE_AUDIT, { fetchPolicy: 'cache-first', variables: { auditId: auditId } }), data = _a.data, loading = _a.loading;
    var answers = data === null || data === void 0 ? void 0 : data.audit.auditAnswers;
    return { answers: answers, loading: loading };
};
useAuditQuestionAnswers$1.useAuditQuestionAnswers = useAuditQuestionAnswers;

var useAuditQuestions$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
Object.defineProperty(useAuditQuestions$1, "__esModule", { value: true });
useAuditQuestions$1.useAuditQuestions = void 0;
var client_1$o = require$$0$1;
var graphql_1$o = lib$4;
var useAuditQuestions = function (props) {
    var storeId = props.storeId;
    var _a = (0, client_1$o.useQuery)(graphql_1$o.GET_STORE, {
        fetchPolicy: 'cache-first',
        nextFetchPolicy: 'cache-first',
        variables: { storeId: storeId },
    }), storeData = _a.data, storeLoading = _a.loading;
    var _b = (0, client_1$o.useQuery)(graphql_1$o.GET_AUDIT_QUESTIONS, {
        fetchPolicy: 'cache-and-network',
    }), data = _b.data, loading = _b.loading;
    var questions = storeData && data
        ? data.auditQuestions.filter(function (question) {
            return question.category === graphql_1$o.AuditsAuditQuestionCategoryChoices.AL ||
                question.category === storeData.store.category;
        })
        : undefined;
    return { questions: questions, loading: loading || storeLoading };
};
useAuditQuestions$1.useAuditQuestions = useAuditQuestions;

var useCompanyAuditQuestions$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __assign$h = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$h = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$h.apply(this, arguments);
};
var __rest$a = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useCompanyAuditQuestions$1, "__esModule", { value: true });
useCompanyAuditQuestions$1.useCompanyAuditQuestions = void 0;
var client_1$n = require$$0$1;
var graphql_1$n = lib$4;
var useCompanyAuditQuestions = function () {
    var _a = (0, client_1$n.useQuery)(graphql_1$n.GET_AUDIT_QUESTIONS, {
        fetchPolicy: 'cache-and-network',
    }), data = _a.data, loading = _a.loading, rest = __rest$a(_a, ["data", "loading"]);
    var questions = data === null || data === void 0 ? void 0 : data.auditQuestions;
    return __assign$h({ questions: questions, loading: loading }, rest);
};
useCompanyAuditQuestions$1.useCompanyAuditQuestions = useCompanyAuditQuestions;

var useAudit$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __assign$g = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$g = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$g.apply(this, arguments);
};
var __rest$9 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useAudit$1, "__esModule", { value: true });
useAudit$1.useAudit = void 0;
var client_1$m = require$$0$1;
var graphql_1$m = lib$4;
var useAudit = function (props) {
    var auditId = props.auditId;
    var _a = (0, client_1$m.useQuery)(graphql_1$m.GET_STORE_AUDIT, {
        fetchPolicy: 'cache-and-network',
        variables: { auditId: auditId },
    }), data = _a.data, loading = _a.loading, rest = __rest$9(_a, ["data", "loading"]);
    var audit = data === null || data === void 0 ? void 0 : data.audit;
    return __assign$g({ audit: audit, loading: loading }, rest);
};
useAudit$1.useAudit = useAudit;

var useAdminAudit$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __assign$f = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$f = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$f.apply(this, arguments);
};
var __rest$8 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useAdminAudit$1, "__esModule", { value: true });
useAdminAudit$1.useAdminAudit = void 0;
var client_1$l = require$$0$1;
var graphql_1$l = lib$4;
var useAdminAudit = function (props) {
    var auditId = props.auditId;
    var _a = (0, client_1$l.useQuery)(graphql_1$l.GET_ADMIN_STORE_AUDIT, {
        fetchPolicy: 'cache-and-network',
        variables: { auditId: auditId },
    }), data = _a.data, loading = _a.loading, rest = __rest$8(_a, ["data", "loading"]);
    var audit = data === null || data === void 0 ? void 0 : data.audit;
    return __assign$f({ audit: audit, loading: loading }, rest);
};
useAdminAudit$1.useAdminAudit = useAdminAudit;

var useGetCompanyUsers$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var __assign$e = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$e = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$e.apply(this, arguments);
};
var __awaiter$4 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$4 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(useGetCompanyUsers$1, "__esModule", { value: true });
useGetCompanyUsers$1.useGetCompanyUsers = void 0;
var client_1$k = require$$0$1;
var graphql_1$k = lib$4;
var useGetCompanyUsers = function (input) {
    var _a = (0, client_1$k.useQuery)(graphql_1$k.GET_COMPANY_USERS, {
        variables: { input: input },
        notifyOnNetworkStatusChange: true,
    }), data = _a.data, loading = _a.loading, error = _a.error, fetchMore = _a.fetchMore, refetch = _a.refetch;
    var companyUsersData = data === null || data === void 0 ? void 0 : data.companyUsers;
    var users = (companyUsersData === null || companyUsersData === void 0 ? void 0 : companyUsersData.results) || [];
    var hasMore = companyUsersData === null || companyUsersData === void 0 ? void 0 : companyUsersData.hasMore;
    var count = (companyUsersData === null || companyUsersData === void 0 ? void 0 : companyUsersData.count) || 0;
    var fetchNextPage = function () { return __awaiter$4(void 0, void 0, void 0, function () {
        return __generator$4(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(users && hasMore && fetchMore)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchMore({
                            variables: {
                                input: __assign$e(__assign$e({}, input), { offset: users.length }),
                                fetchPolicy: 'cache-first',
                            },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        users: users,
        hasMore: hasMore,
        count: count,
        loading: loading,
        error: error,
        refetch: refetch,
        fetchNextPage: fetchNextPage,
    };
};
useGetCompanyUsers$1.useGetCompanyUsers = useGetCompanyUsers;

var useGetStores$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __assign$d = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$d = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$d.apply(this, arguments);
};
var __awaiter$3 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$3 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(useGetStores$1, "__esModule", { value: true });
useGetStores$1.useGetStores = void 0;
var client_1$j = require$$0$1;
var graphql_1$j = lib$4;
var useGetStores = function (input) {
    var _a = (0, client_1$j.useQuery)(graphql_1$j.GET_STORES, { variables: { input: input } }), data = _a.data, loading = _a.loading, error = _a.error, refetch = _a.refetch, fetchMore = _a.fetchMore;
    var storeData = data === null || data === void 0 ? void 0 : data.companyStores;
    var stores = (storeData === null || storeData === void 0 ? void 0 : storeData.results) || [];
    var hasMore = storeData === null || storeData === void 0 ? void 0 : storeData.hasMore;
    var count = (storeData === null || storeData === void 0 ? void 0 : storeData.count) || 0;
    var fetchNextPage = function () { return __awaiter$3(void 0, void 0, void 0, function () {
        return __generator$3(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(stores && hasMore && fetchMore)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchMore({
                            variables: { input: __assign$d(__assign$d({}, input), { offset: stores.length }) },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        stores: stores,
        hasMore: hasMore,
        count: count,
        loading: loading,
        error: error,
        refetch: refetch,
        fetchNextPage: fetchNextPage,
    };
};
useGetStores$1.useGetStores = useGetStores;

var useGetUserStores$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
Object.defineProperty(useGetUserStores$1, "__esModule", { value: true });
useGetUserStores$1.useGetUserStores = void 0;
var client_1$i = require$$0$1;
var graphql_1$i = lib$4;
var useGetUserStores = function (input) {
    var _a = (0, client_1$i.useLazyQuery)(graphql_1$i.GET_USER_STORES, { variables: { input: input }, fetchPolicy: 'no-cache' }), getUserStores = _a[0], _b = _a[1], data = _b.data, refetch = _b.refetch;
    var userStores = (data === null || data === void 0 ? void 0 : data.userStores) || [];
    var refetchUserStores = refetch;
    return {
        getUserStores: getUserStores,
        refetchUserStores: refetchUserStores,
        userStores: userStores,
    };
};
useGetUserStores$1.useGetUserStores = useGetUserStores;

var useGetAdminCompanyStores$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
var __assign$c = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$c = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$c.apply(this, arguments);
};
var __awaiter$2 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$2 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(useGetAdminCompanyStores$1, "__esModule", { value: true });
useGetAdminCompanyStores$1.useGetAdminCompanyStores = void 0;
var client_1$h = require$$0$1;
var graphql_1$h = lib$4;
var react_1$2 = React__default["default"];
var useGetAdminCompanyStores = function (input) {
    var _a = (0, client_1$h.useQuery)(graphql_1$h.GET_ADMIN_COMPANY_STORES, {
        variables: { input: input },
        notifyOnNetworkStatusChange: true,
    }), data = _a.data, loading = _a.loading, error = _a.error, fetchMore = _a.fetchMore, refetch = _a.refetch;
    var storeData = data === null || data === void 0 ? void 0 : data.adminCompanyStores;
    var stores = (storeData === null || storeData === void 0 ? void 0 : storeData.results) || [];
    var hasMore = storeData === null || storeData === void 0 ? void 0 : storeData.hasMore;
    var count = (storeData === null || storeData === void 0 ? void 0 : storeData.count) || 0;
    var fetchNextPage = function () { return __awaiter$2(void 0, void 0, void 0, function () {
        return __generator$2(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(stores && hasMore && fetchMore)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchMore({
                            variables: { input: __assign$c(__assign$c({}, input), { offset: stores.length }) },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var _b = (0, react_1$2.useState)(false), fetchRest = _b[0], setFetchRest = _b[1];
    var _c = (0, react_1$2.useState)(0), fetchProgress = _c[0], setFetchProgress = _c[1];
    (0, react_1$2.useEffect)(function () {
        if (fetchRest) {
            setFetchProgress((stores.length / count) * 100);
            if (hasMore) {
                fetchMore({
                    variables: { input: __assign$c(__assign$c({}, input), { offset: stores.length }) },
                });
            }
            else {
                setTimeout(function () {
                    setFetchRest(false);
                }, 500);
            }
        }
    }, [fetchRest, stores.length]);
    return {
        stores: stores,
        hasMore: hasMore,
        count: count,
        loading: loading || fetchRest,
        error: error,
        refetch: refetch,
        fetchNextPage: fetchNextPage,
        fetchRest: fetchRest,
        fetchProgress: fetchProgress,
        setFetchRest: setFetchRest,
    };
};
useGetAdminCompanyStores$1.useGetAdminCompanyStores = useGetAdminCompanyStores;

var useGetAdminCompanyStore$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __assign$b = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$b = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$b.apply(this, arguments);
};
var __rest$7 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useGetAdminCompanyStore$1, "__esModule", { value: true });
useGetAdminCompanyStore$1.useGetAdminCompanyStore = void 0;
var client_1$g = require$$0$1;
var graphql_1$g = lib$4;
var useGetAdminCompanyStore = function (storeId) {
    var _a = (0, client_1$g.useQuery)(graphql_1$g.GET_ADMIN_STORE, { variables: { storeId: storeId } }), data = _a.data, loading = _a.loading, error = _a.error, rest = __rest$7(_a, ["data", "loading", "error"]);
    var store = data === null || data === void 0 ? void 0 : data.store;
    return __assign$b({ store: store, loading: loading, error: error }, rest);
};
useGetAdminCompanyStore$1.useGetAdminCompanyStore = useGetAdminCompanyStore;

var useAuditQuestionsMutations$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
Object.defineProperty(useAuditQuestionsMutations$1, "__esModule", { value: true });
useAuditQuestionsMutations$1.useAuditQuestionsMutations = void 0;
var client_1$f = require$$0$1;
var graphql_1$f = lib$4;
var useAuditQuestionsMutations = function () {
    var _deleteAuditQuestions = (0, client_1$f.useMutation)(graphql_1$f.BULK_DELETE_AUDIT_QUESTIONS)[0];
    var _CreateAuditQuestionMutation = (0, client_1$f.useMutation)(graphql_1$f.CREATE_AUDIT_QUESTION)[0];
    var _editAuditQuestions = (0, client_1$f.useMutation)(graphql_1$f.UPDATE_AUDIT_QUESTIONS)[0];
    var deleteAuditQuestions = function (ids) {
        return _deleteAuditQuestions({ variables: { input: { ids: ids } } });
    };
    var CreateAuditQuestionMutation = function (variables) {
        return _CreateAuditQuestionMutation({ variables: variables });
    };
    var UpdateAuditQuestionsMutation = function (variables) {
        _editAuditQuestions({ variables: variables });
    };
    return {
        deleteAuditQuestions: deleteAuditQuestions,
        CreateAuditQuestionMutation: CreateAuditQuestionMutation,
        UpdateAuditQuestionsMutation: UpdateAuditQuestionsMutation,
    };
};
useAuditQuestionsMutations$1.useAuditQuestionsMutations = useAuditQuestionsMutations;

var useGetAdminAudits$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
var __assign$a = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$a = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$a.apply(this, arguments);
};
var __awaiter$1 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$1 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(useGetAdminAudits$1, "__esModule", { value: true });
useGetAdminAudits$1.useGetAdminAudits = void 0;
var client_1$e = require$$0$1;
var graphql_1$e = lib$4;
var useGetAdminAudits = function (input) {
    var _a = (0, client_1$e.useQuery)(graphql_1$e.GET_ADMIN_PORTAL_AUDITS, {
        variables: { input: input },
        fetchPolicy: 'cache-and-network',
    }), data = _a.data, loading = _a.loading, error = _a.error, fetchMore = _a.fetchMore, refetch = _a.refetch;
    var auditData = data === null || data === void 0 ? void 0 : data.adminPortalAudits;
    var audits = (auditData === null || auditData === void 0 ? void 0 : auditData.results) || [];
    var hasMore = auditData === null || auditData === void 0 ? void 0 : auditData.hasMore;
    var count = (auditData === null || auditData === void 0 ? void 0 : auditData.count) || 0;
    var fetchNextPage = function () { return __awaiter$1(void 0, void 0, void 0, function () {
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(audits && hasMore && fetchMore)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchMore({
                            variables: { input: __assign$a(__assign$a({}, input), { offset: audits.length }) },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        audits: audits,
        hasMore: hasMore,
        count: count,
        loading: loading,
        error: error,
        refetch: refetch,
        fetchNextPage: fetchNextPage,
    };
};
useGetAdminAudits$1.useGetAdminAudits = useGetAdminAudits;

var useWindowDimensions$1 = {};

/**
 * Copyright © 2021 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
Object.defineProperty(useWindowDimensions$1, "__esModule", { value: true });
useWindowDimensions$1.useWindowDimensions = void 0;
var react_1$1 = React__default["default"];
function getWindowDimensions() {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height,
    };
}
var useWindowDimensions = function () {
    var _a = (0, react_1$1.useState)(getWindowDimensions()), windowDimensions = _a[0], setWindowDimensions = _a[1];
    (0, react_1$1.useEffect)(function () {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowDimensions;
};
useWindowDimensions$1.useWindowDimensions = useWindowDimensions;

var useGetGroups$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __assign$9 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$9 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$9.apply(this, arguments);
};
var __rest$6 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useGetGroups$1, "__esModule", { value: true });
useGetGroups$1.useGetGroups = void 0;
var client_1$d = require$$0$1;
var graphql_1$d = lib$4;
var DAI_GROUPS = [
    graphql_1$d.DAIGroupEnum.IMAGE_LABELERS,
    graphql_1$d.DAIGroupEnum.POINT_CLOUD_VERIFIERS,
    graphql_1$d.DAIGroupEnum.MAPPERS,
    graphql_1$d.DAIGroupEnum.MAPPER_ADMINS,
    graphql_1$d.DAIGroupEnum.STORE_MAP_SCANNERS,
];
var useGetGroups = function () {
    var _a = (0, client_1$d.useQuery)(graphql_1$d.GET_GROUPS, {
        notifyOnNetworkStatusChange: true,
    }), data = _a.data, rest = __rest$6(_a, ["data"]);
    var allGroups = data === null || data === void 0 ? void 0 : data.groups;
    var groups = allGroups === null || allGroups === void 0 ? void 0 : allGroups.filter(function (group) {
        return !DAI_GROUPS.some(function (g) { return group.name.toLowerCase() === g.toString().toLowerCase(); });
    });
    var handleGetGroupByName = function (name) {
        return allGroups === null || allGroups === void 0 ? void 0 : allGroups.find(function (g) { return g.name === name; });
    };
    return __assign$9({ allGroups: allGroups, groups: groups, handleGetGroupByName: handleGetGroupByName }, rest);
};
useGetGroups$1.useGetGroups = useGetGroups;

var usePauseOptimizations$1 = {};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */
var __assign$8 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$8 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$8.apply(this, arguments);
};
var __rest$5 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(usePauseOptimizations$1, "__esModule", { value: true });
usePauseOptimizations$1.usePauseOptimizations = void 0;
var client_1$c = require$$0$1;
var graphql_1$c = lib$4;
var usePauseOptimizations = function (input) {
    var _a = (0, client_1$c.useMutation)(graphql_1$c.PAUSE_OPTIMIZATIONS, {
        update: function (cache, _a) {
            var _b;
            var data = _a.data;
            if ((_b = data === null || data === void 0 ? void 0 : data.pauseOptimizationsInCompanyStores) === null || _b === void 0 ? void 0 : _b.success) {
                var _c = data.pauseOptimizationsInCompanyStores, storeIds_1 = _c.storeIds, resumeOptimizingAt_1 = _c.resumeOptimizingAt, optimizingPausedAt_1 = _c.optimizingPausedAt;
                var existing = cache.readQuery({ query: graphql_1$c.GET_ADMIN_COMPANY_STORES, variables: { input: input } });
                if (existing) {
                    var newResults = existing.adminCompanyStores.results.map(function (store) {
                        return storeIds_1.includes(store.id)
                            ? __assign$8(__assign$8({}, store), { allOptimizingPaused: true, resumeOptimizingAt: resumeOptimizingAt_1, optimizingPausedAt: optimizingPausedAt_1 }) : store;
                    });
                    cache.writeQuery({
                        query: graphql_1$c.GET_ADMIN_COMPANY_STORES,
                        variables: { input: input },
                        data: __assign$8(__assign$8({}, existing), { adminCompanyStores: __assign$8(__assign$8({}, existing.adminCompanyStores), { results: newResults }) }),
                    });
                }
            }
        },
    }), _pauseOptimizations = _a[0], _b = _a[1], rest = __rest$5(_b, []);
    var pauseOptimizations = function (variables) {
        return _pauseOptimizations({ variables: variables });
    };
    return __assign$8({ pauseOptimizations: pauseOptimizations }, rest);
};
usePauseOptimizations$1.usePauseOptimizations = usePauseOptimizations;

var useStopOptimizations$1 = {};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */
var __assign$7 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$7 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$7.apply(this, arguments);
};
var __rest$4 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useStopOptimizations$1, "__esModule", { value: true });
useStopOptimizations$1.useStopOptimizations = void 0;
var client_1$b = require$$0$1;
var graphql_1$b = lib$4;
var useStopOptimizations = function (input) {
    var _a = (0, client_1$b.useMutation)(graphql_1$b.STOP_OPTIMIZATIONS, {
        update: function (cache, _a) {
            var _b;
            var data = _a.data;
            if ((_b = data === null || data === void 0 ? void 0 : data.stopOptimizationsInCompanyStores) === null || _b === void 0 ? void 0 : _b.success) {
                var _c = data.stopOptimizationsInCompanyStores, storeIds_1 = _c.storeIds, optimizingPausedAt_1 = _c.optimizingPausedAt;
                var existing = cache.readQuery({ query: graphql_1$b.GET_ADMIN_COMPANY_STORES, variables: { input: input } });
                if (existing) {
                    var newResults = existing.adminCompanyStores.results.map(function (store) {
                        return storeIds_1.includes(store.id)
                            ? __assign$7(__assign$7({}, store), { allOptimizingPaused: true, resumeOptimizingAt: null, optimizingPausedAt: optimizingPausedAt_1 }) : store;
                    });
                    cache.writeQuery({
                        query: graphql_1$b.GET_ADMIN_COMPANY_STORES,
                        variables: { input: input },
                        data: __assign$7(__assign$7({}, existing), { adminCompanyStores: __assign$7(__assign$7({}, existing.adminCompanyStores), { results: newResults }) }),
                    });
                }
            }
        },
    }), _stopOptimizations = _a[0], _b = _a[1], rest = __rest$4(_b, []);
    var stopOptimizations = function (variables) {
        return _stopOptimizations({ variables: variables });
    };
    return __assign$7({ stopOptimizations: stopOptimizations }, rest);
};
useStopOptimizations$1.useStopOptimizations = useStopOptimizations;

var useResumeOptimizations$1 = {};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */
var __assign$6 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$6 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$6.apply(this, arguments);
};
var __rest$3 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useResumeOptimizations$1, "__esModule", { value: true });
useResumeOptimizations$1.useResumeOptimizations = void 0;
var client_1$a = require$$0$1;
var graphql_1$a = lib$4;
var useResumeOptimizations = function (input) {
    var _a = (0, client_1$a.useMutation)(graphql_1$a.RESUME_OPTIMIZATIONS, {
        update: function (cache, _a) {
            var _b;
            var data = _a.data;
            if ((_b = data === null || data === void 0 ? void 0 : data.resumeOptimizationsInCompanyStores) === null || _b === void 0 ? void 0 : _b.success) {
                var storeIds_1 = data.resumeOptimizationsInCompanyStores.storeIds;
                var existing = cache.readQuery({ query: graphql_1$a.GET_ADMIN_COMPANY_STORES, variables: { input: input } });
                if (existing) {
                    var newResults = existing.adminCompanyStores.results.map(function (store) {
                        return storeIds_1.includes(store.id)
                            ? __assign$6(__assign$6({}, store), { allOptimizingPaused: false, resumeOptimizingAt: null, optimizingPausedAt: null }) : store;
                    });
                    cache.writeQuery({
                        query: graphql_1$a.GET_ADMIN_COMPANY_STORES,
                        variables: { input: input },
                        data: __assign$6(__assign$6({}, existing), { adminCompanyStores: __assign$6(__assign$6({}, existing.adminCompanyStores), { results: newResults }) }),
                    });
                }
            }
        },
    }), _resumeOptimizations = _a[0], _b = _a[1], rest = __rest$3(_b, []);
    var resumeOptimizations = function (variables) {
        return _resumeOptimizations({ variables: variables });
    };
    return __assign$6({ resumeOptimizations: resumeOptimizations }, rest);
};
useResumeOptimizations$1.useResumeOptimizations = useResumeOptimizations;

var useGetStoreHistory$1 = {};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */
var __assign$5 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$5 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(useGetStoreHistory$1, "__esModule", { value: true });
useGetStoreHistory$1.useGetStoreHistory = void 0;
var client_1$9 = require$$0$1;
var graphql_1$9 = lib$4;
var useGetStoreHistory = function (input) {
    var _a = (0, client_1$9.useQuery)(graphql_1$9.GET_ADMIN_STORE_HISTORY, {
        variables: { input: input },
        notifyOnNetworkStatusChange: true,
    }), data = _a.data, loading = _a.loading, error = _a.error, fetchMore = _a.fetchMore, refetch = _a.refetch;
    var storeData = data === null || data === void 0 ? void 0 : data.storeHistory;
    var actions = (storeData === null || storeData === void 0 ? void 0 : storeData.results) || [];
    var hasMore = storeData === null || storeData === void 0 ? void 0 : storeData.hasMore;
    var count = (storeData === null || storeData === void 0 ? void 0 : storeData.count) || 0;
    var fetchNextPage = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(actions && hasMore && fetchMore)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchMore({
                            variables: { input: __assign$5(__assign$5({}, input), { offset: actions.length }) },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        actions: actions,
        hasMore: hasMore,
        count: count,
        loading: loading,
        error: error,
        refetch: refetch,
        fetchNextPage: fetchNextPage,
    };
};
useGetStoreHistory$1.useGetStoreHistory = useGetStoreHistory;

var useUpdateOptimizationSchedule$1 = {};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */
var __assign$4 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$4 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};
Object.defineProperty(useUpdateOptimizationSchedule$1, "__esModule", { value: true });
useUpdateOptimizationSchedule$1.useUpdateOptimizationSchedule = void 0;
var client_1$8 = require$$0$1;
var graphql_1$8 = lib$4;
var useUpdateOptimizationSchedule = function (input) {
    var _UpdateOptimizationScheduleMutation = (0, client_1$8.useMutation)(graphql_1$8.UPDATE_OPTIMIZATION_SCHEDULE, {
        update: function (cache, _a) {
            var _b;
            var data = _a.data;
            if ((_b = data === null || data === void 0 ? void 0 : data.updateOptimizingCadenceInCompanyStores) === null || _b === void 0 ? void 0 : _b.success) {
                var _c = data.updateOptimizingCadenceInCompanyStores, storeIds_1 = _c.storeIds, numTimesOptimizeHighPerYear_1 = _c.numTimesOptimizeHighPerYear, numTimesOptimizeMediumPerYear_1 = _c.numTimesOptimizeMediumPerYear, numTimesOptimizeLowPerYear_1 = _c.numTimesOptimizeLowPerYear, timesPerWeekTwoDScan_1 = _c.timesPerWeekTwoDScan;
                var existing = cache.readQuery({ query: graphql_1$8.GET_ADMIN_COMPANY_STORES, variables: { input: input } });
                if (existing) {
                    var newResults = existing.adminCompanyStores.results.map(function (store) {
                        return storeIds_1.includes(store.id)
                            ? __assign$4(__assign$4({}, store), { numTimesOptimizeHighPerYear: numTimesOptimizeHighPerYear_1, numTimesOptimizeMediumPerYear: numTimesOptimizeMediumPerYear_1, numTimesOptimizeLowPerYear: numTimesOptimizeLowPerYear_1, timesPerWeekTwoDScan: timesPerWeekTwoDScan_1 }) : store;
                    });
                    cache.writeQuery({
                        query: graphql_1$8.GET_ADMIN_COMPANY_STORES,
                        variables: { input: input },
                        data: __assign$4(__assign$4({}, existing), { AdminCompanyStoresQuery: __assign$4(__assign$4({}, existing.adminCompanyStores), { results: newResults }) }),
                    });
                }
            }
        },
    })[0];
    var UpdateOptimizationScheduleMutation = function (variables) {
        return _UpdateOptimizationScheduleMutation({ variables: variables });
    };
    var _UpdateGlobalOptimizationScheduleMutation = (0, client_1$8.useMutation)(graphql_1$8.UPDATE_GLOBAL_OPTIMIZATION_CADENCE, {
        update: function (cache, _a) {
            var _b;
            var data = _a.data;
            if ((_b = data === null || data === void 0 ? void 0 : data.globalUpdateOptimizingCadence) === null || _b === void 0 ? void 0 : _b.success) {
                var _c = data.globalUpdateOptimizingCadence, numTimesOptimizeHighPerYear_2 = _c.numTimesOptimizeHighPerYear, numTimesOptimizeMediumPerYear_2 = _c.numTimesOptimizeMediumPerYear, numTimesOptimizeLowPerYear_2 = _c.numTimesOptimizeLowPerYear, timesPerWeekTwoDScan_2 = _c.timesPerWeekTwoDScan;
                var existing = cache.readQuery({ query: graphql_1$8.GET_ADMIN_COMPANY_STORES, variables: { input: input } });
                if (existing) {
                    var newResults = existing.adminCompanyStores.results.map(function (store) { return (__assign$4(__assign$4({}, store), { numTimesOptimizeHighPerYear: numTimesOptimizeHighPerYear_2, numTimesOptimizeMediumPerYear: numTimesOptimizeMediumPerYear_2, numTimesOptimizeLowPerYear: numTimesOptimizeLowPerYear_2, timesPerWeekTwoDScan: timesPerWeekTwoDScan_2 })); });
                    cache.writeQuery({
                        query: graphql_1$8.GET_ADMIN_COMPANY_STORES,
                        variables: { input: input },
                        data: __assign$4(__assign$4({}, existing), { AdminCompanyStoresQuery: __assign$4(__assign$4({}, existing.adminCompanyStores), { results: newResults }) }),
                    });
                }
            }
        },
    })[0];
    var UpdateGlobalOptimizationScheduleMutation = function (variables) {
        return _UpdateGlobalOptimizationScheduleMutation({ variables: variables });
    };
    return {
        UpdateOptimizationScheduleMutation: UpdateOptimizationScheduleMutation,
        UpdateGlobalOptimizationScheduleMutation: UpdateGlobalOptimizationScheduleMutation,
    };
};
useUpdateOptimizationSchedule$1.useUpdateOptimizationSchedule = useUpdateOptimizationSchedule;

var useGetAdminCompanyRegions$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
Object.defineProperty(useGetAdminCompanyRegions$1, "__esModule", { value: true });
useGetAdminCompanyRegions$1.useGetAdminCompanyRegions = void 0;
var client_1$7 = require$$0$1;
var graphql_1$7 = lib$4;
var useGetAdminCompanyRegions = function () {
    var _a = (0, client_1$7.useQuery)(graphql_1$7.GET_ADMIN_COMPANY_REGIONS), data = _a.data, loading = _a.loading, error = _a.error;
    // @ts-ignore
    var regions = (data === null || data === void 0 ? void 0 : data.regions) || [];
    return {
        regions: regions,
        loading: loading,
        error: error,
    };
};
useGetAdminCompanyRegions$1.useGetAdminCompanyRegions = useGetAdminCompanyRegions;

var useGetCompanyRegions$1 = {};

var arrayToTree_min = {};

(function (exports) {
var __assign=commonjsGlobal&&commonjsGlobal.__assign||function(){return (__assign=Object.assign||function(e){for(var r,t=1,n=arguments.length;t<n;t++)for(var o in r=arguments[t])Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o]);return e}).apply(this,arguments)},defaultConfig=(Object.defineProperty(exports,"__esModule",{value:!0}),{id:"id",parentId:"parentId",dataField:"data",childrenField:"children",throwIfOrphans:!1,rootParentIds:{"":!(exports.countNodes=exports.arrayToTree=void 0)},nestedIds:!0,assign:!1});function arrayToTree(c,e){void 0===e&&(e={});for(var r,t=__assign(__assign({},defaultConfig),e),n=[],o={},a=t.throwIfOrphans?new Set:null,s=0,h=c;s<h.length;s++){var i=h[s],d=t.nestedIds?getNestedProperty(i,t.id):i[t.id],l=t.nestedIds?getNestedProperty(i,t.parentId):i[t.parentId];if(t.rootParentIds[d])throw new Error("The item array contains a node whose parentId both exists in another node and is in "+'`rootParentIds` (`itemId`: "'.concat(d,'", `rootParentIds`: ').concat(Object.keys(t.rootParentIds).map(function(e){return '"'.concat(e,'"')}).join(", "),")."));Object.prototype.hasOwnProperty.call(o,d)||(o[d]=((r={})[t.childrenField]=[],r)),a&&a.delete(d),t.dataField?o[d][t.dataField]=i:t.assign?o[d]=Object.assign(i,((r={})[t.childrenField]=o[d][t.childrenField],r)):o[d]=__assign(__assign({},i),((i={})[t.childrenField]=o[d][t.childrenField],i));i=o[d];null==l||t.rootParentIds[l]?n.push(i):(Object.prototype.hasOwnProperty.call(o,l)||(o[l]=((d={})[t.childrenField]=[],d),a&&a.add(l)),o[l][t.childrenField].push(i));}if(null!=a&&a.size)throw new Error("The items array contains orphans that point to the following parentIds: "+"[".concat(Array.from(a),"]. These parentIds do not exist in the items array. Hint: prevent orphans to result ")+"in an error by passing the following option: { throwIfOrphans: false }");if(t.throwIfOrphans&&countNodes(n,t.childrenField)<Object.keys(o).length)throw new Error("The items array contains nodes with a circular parent/child relationship.");return n}function countNodes(e,t){return e.reduce(function(e,r){return e+1+(r[t]&&countNodes(r[t],t))},0)}function getNestedProperty(e,r){return r.split(".").reduce(function(e,r){return e&&e[r]},e)}exports.arrayToTree=arrayToTree,exports.countNodes=countNodes;
}(arrayToTree_min));

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
Object.defineProperty(useGetCompanyRegions$1, "__esModule", { value: true });
useGetCompanyRegions$1.useGetCompanyRegions = void 0;
var client_1$6 = require$$0$1;
var graphql_1$6 = lib$4;
var performant_array_to_tree_1 = arrayToTree_min;
var useGetCompanyRegions = function (companyId) {
    var _a = (0, client_1$6.useQuery)(graphql_1$6.GET_COMPANY_REGIONS, { variables: { companyId: companyId } }), data = _a.data, loading = _a.loading, error = _a.error;
    var flatRegions = (data === null || data === void 0 ? void 0 : data.companyRegions) || [];
    var allRegionIds = flatRegions.map(function (region) { return region.id; });
    var regionTree = (0, performant_array_to_tree_1.arrayToTree)(flatRegions, {
        dataField: null,
        childrenField: 'subregions',
    });
    return {
        flatRegions: flatRegions,
        allRegionIds: allRegionIds,
        regions: regionTree,
        loading: loading,
        error: error,
    };
};
useGetCompanyRegions$1.useGetCompanyRegions = useGetCompanyRegions;

var useGetCompanyRegion$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
Object.defineProperty(useGetCompanyRegion$1, "__esModule", { value: true });
useGetCompanyRegion$1.useGetCompanyRegion = void 0;
var client_1$5 = require$$0$1;
var graphql_1$5 = lib$4;
var react_1 = React__default["default"];
var useGetCompanyRegion = function (regionId) {
    var _a = (0, client_1$5.useLazyQuery)(graphql_1$5.GET_COMPANY_REGION), getCompanyRegion = _a[0], _b = _a[1], data = _b.data, loading = _b.loading, error = _b.error;
    (0, react_1.useEffect)(function () {
        if (regionId) {
            getCompanyRegion({ variables: { regionId: regionId } });
        }
    }, [regionId]);
    var region = data === null || data === void 0 ? void 0 : data.companyRegion;
    return {
        region: region,
        loading: loading,
        error: error,
    };
};
useGetCompanyRegion$1.useGetCompanyRegion = useGetCompanyRegion;

var useCreateRegion$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var __assign$3 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(useCreateRegion$1, "__esModule", { value: true });
useCreateRegion$1.useCreateRegion = void 0;
var client_1$4 = require$$0$1;
var graphql_1$4 = lib$4;
var utils_1 = utils$t;
var updateHandler$1 = function (input) {
    var companyId = input.companyId;
    return function (cache, _a) {
        var _b;
        var data = _a.data;
        if (!((_b = data === null || data === void 0 ? void 0 : data.createRegion) === null || _b === void 0 ? void 0 : _b.region)) {
            return;
        }
        var region = data === null || data === void 0 ? void 0 : data.createRegion.region;
        try {
            var cachedData = cache.readQuery({ query: graphql_1$4.GET_COMPANY_REGIONS, variables: { companyId: companyId } });
            var allRegions = (cachedData === null || cachedData === void 0 ? void 0 : cachedData.companyRegions) || [];
            cache.writeQuery({
                query: graphql_1$4.GET_COMPANY_REGIONS,
                variables: { companyId: companyId },
                data: { companyRegions: __spreadArray(__spreadArray([], allRegions, true), [region], false) },
            });
        }
        catch (error) {
            console.error(error);
        }
    };
};
var useCreateRegion = function () {
    var _a = (0, client_1$4.useMutation)(graphql_1$4.CREATE_REGION), _createRegion = _a[0], _b = _a[1], loading = _b.loading, error = _b.error;
    var createRegion = function (input) {
        var id = String(input.regionId || (0, utils_1.uniqueId)());
        _createRegion({
            variables: {
                input: input,
            },
            optimisticResponse: {
                createRegion: {
                    __typename: 'CreateRegion',
                    region: __assign$3(__assign$3({}, input), { __typename: 'Region', id: id, parentId: input.parentId ? String(input.parentId) : null, users: [], stores: [] }),
                },
            },
            update: updateHandler$1(__assign$3({ regionId: id }, input)),
        });
    };
    return {
        createRegion: createRegion,
        loading: loading,
        error: error,
    };
};
useCreateRegion$1.useCreateRegion = useCreateRegion;

var useDeleteRegion$1 = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var __assign$2 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
var __rest$2 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useDeleteRegion$1, "__esModule", { value: true });
useDeleteRegion$1.useDeleteRegion = void 0;
var client_1$3 = require$$0$1;
var graphql_1$3 = lib$4;
var updateHandler = function (args) {
    var companyId = args.companyId, regionId = args.regionId, deleteDescendants = args.deleteDescendants, regions = args.regions;
    return function (cache, _a) {
        var _b;
        var data = _a.data;
        if (!((_b = data === null || data === void 0 ? void 0 : data.deleteRegion) === null || _b === void 0 ? void 0 : _b.deleted)) {
            return;
        }
        try {
            var cachedData = cache.readQuery({
                query: graphql_1$3.GET_COMPANY_REGIONS,
                variables: { companyId: companyId },
            });
            var cachedRegions = (cachedData === null || cachedData === void 0 ? void 0 : cachedData.companyRegions) || [];
            var regionIds_1 = regions.map(function (region) { return region.id; });
            var updatedRegions = deleteDescendants
                ? cachedRegions.filter(function (region) { return !regionIds_1.includes(region.id); })
                : cachedRegions
                    .filter(function (region) { return region.id !== regionId; })
                    .map(function (region) {
                    return region.parentId === regionId
                        ? __assign$2(__assign$2({}, region), { parentId: null }) : region;
                });
            cache.writeQuery({
                query: graphql_1$3.GET_COMPANY_REGIONS,
                variables: { companyId: companyId },
                data: {
                    companyRegions: updatedRegions,
                },
            });
        }
        catch (error) {
            console.error(error);
        }
    };
};
var useDeleteRegion = function () {
    var _a = (0, client_1$3.useMutation)(graphql_1$3.DELETE_REGION), _deleteRegion = _a[0], _b = _a[1], loading = _b.loading, error = _b.error;
    var deleteRegion = function (args) {
        args.companyId; args.regions; var input = __rest$2(args, ["companyId", "regions"]);
        _deleteRegion({
            variables: {
                input: input,
            },
            optimisticResponse: {
                deleteRegion: {
                    __typename: 'DeleteRegion',
                    deleted: true,
                },
            },
            update: updateHandler(args),
        });
    };
    return {
        deleteRegion: deleteRegion,
        loading: loading,
        error: error,
    };
};
useDeleteRegion$1.useDeleteRegion = useDeleteRegion;

var useGetCompanyStore$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var __rest$1 = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useGetCompanyStore$1, "__esModule", { value: true });
useGetCompanyStore$1.useGetCompanyStore = void 0;
var client_1$2 = require$$0$1;
var graphql_1$2 = lib$4;
var useGetCompanyStore = function (storeId) {
    var _a = (0, client_1$2.useQuery)(graphql_1$2.GET_STORE, { variables: { storeId: storeId } }), data = _a.data, loading = _a.loading, error = _a.error, rest = __rest$1(_a, ["data", "loading", "error"]);
    var store = data === null || data === void 0 ? void 0 : data.store;
    return __assign$1({ store: store, loading: loading, error: error }, rest);
};
useGetCompanyStore$1.useGetCompanyStore = useGetCompanyStore;

var useCompanyFormulaGroups$1 = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
Object.defineProperty(useCompanyFormulaGroups$1, "__esModule", { value: true });
useCompanyFormulaGroups$1.useCompanyFormulaGroups = void 0;
var client_1$1 = require$$0$1;
var graphql_1$1 = lib$4;
var useCompanyFormulaGroups = function () {
    var coldData = (0, client_1$1.useQuery)(graphql_1$1.COMPANY_COLD_AVAILABILITY_FORMULA_GROUPS).data;
    var categoryData = (0, client_1$1.useQuery)(graphql_1$1.COMPANY_CATEGORY_SOVI_FORMULA_GROUPS).data;
    var coldAvailabilityFormulaGroups = coldData === null || coldData === void 0 ? void 0 : coldData.companyColdAvailabilityFormulaGroups;
    var categorySoviFormulaGroups = categoryData === null || categoryData === void 0 ? void 0 : categoryData.companyCategorySoviFormulaGroups;
    return { coldAvailabilityFormulaGroups: coldAvailabilityFormulaGroups, categorySoviFormulaGroups: categorySoviFormulaGroups };
};
useCompanyFormulaGroups$1.useCompanyFormulaGroups = useCompanyFormulaGroups;

var useUpdateCompanyStore = {};

/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(useUpdateCompanyStore, "__esModule", { value: true });
useUpdateCompanyStore.useUpdateCompanyStoreMutation = void 0;
var client_1 = require$$0$1;
var graphql_1 = lib$4;
var useUpdateCompanyStoreMutation = function () {
    var _a = (0, client_1.useMutation)(graphql_1.UPDATE_COMPANY_STORE), _updateCompanyStore = _a[0], _b = _a[1], rest = __rest(_b, []);
    var updateCompanyStore = function (variables) {
        return _updateCompanyStore({ variables: variables });
    };
    return __assign({ updateCompanyStore: updateCompanyStore }, rest);
};
useUpdateCompanyStore.useUpdateCompanyStoreMutation = useUpdateCompanyStoreMutation;

(function (exports) {
/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateOptimizationSchedule = exports.useGetStoreHistory = exports.useResumeOptimizations = exports.useStopOptimizations = exports.usePauseOptimizations = exports.useGetGroups = exports.useWindowDimensions = exports.useGetAdminAudits = exports.useAuditQuestionsMutations = exports.useGetAdminCompanyStore = exports.useGetAdminCompanyStores = exports.useGetUserStores = exports.useGetStores = exports.useGetCompanyUsers = exports.useAdminAudit = exports.useAudit = exports.useCompanyAuditQuestions = exports.useAuditQuestions = exports.useAuditQuestionAnswers = exports.useGetDrawMapTask = exports.useGetDrawMapTasks = exports.useDrawMapTasksMutations = exports.useStoreAreas = exports.useGetPhysicalStores = void 0;
var useGetPhysicalStores_1 = useGetPhysicalStores$1;
Object.defineProperty(exports, "useGetPhysicalStores", { enumerable: true, get: function () { return useGetPhysicalStores_1.useGetPhysicalStores; } });
var useStoreAreas_1 = useStoreAreas$1;
Object.defineProperty(exports, "useStoreAreas", { enumerable: true, get: function () { return useStoreAreas_1.useStoreAreas; } });
var useDrawMapTasksMutations_1 = useDrawMapTasksMutations$1;
Object.defineProperty(exports, "useDrawMapTasksMutations", { enumerable: true, get: function () { return useDrawMapTasksMutations_1.useDrawMapTasksMutations; } });
var useGetDrawMapTasks_1 = useGetDrawMapTasks$1;
Object.defineProperty(exports, "useGetDrawMapTasks", { enumerable: true, get: function () { return useGetDrawMapTasks_1.useGetDrawMapTasks; } });
var useGetDrawMapTask_1 = useGetDrawMapTask$1;
Object.defineProperty(exports, "useGetDrawMapTask", { enumerable: true, get: function () { return useGetDrawMapTask_1.useGetDrawMapTask; } });
var useAuditQuestionAnswers_1 = useAuditQuestionAnswers$1;
Object.defineProperty(exports, "useAuditQuestionAnswers", { enumerable: true, get: function () { return useAuditQuestionAnswers_1.useAuditQuestionAnswers; } });
var useAuditQuestions_1 = useAuditQuestions$1;
Object.defineProperty(exports, "useAuditQuestions", { enumerable: true, get: function () { return useAuditQuestions_1.useAuditQuestions; } });
var useCompanyAuditQuestions_1 = useCompanyAuditQuestions$1;
Object.defineProperty(exports, "useCompanyAuditQuestions", { enumerable: true, get: function () { return useCompanyAuditQuestions_1.useCompanyAuditQuestions; } });
var useAudit_1 = useAudit$1;
Object.defineProperty(exports, "useAudit", { enumerable: true, get: function () { return useAudit_1.useAudit; } });
var useAdminAudit_1 = useAdminAudit$1;
Object.defineProperty(exports, "useAdminAudit", { enumerable: true, get: function () { return useAdminAudit_1.useAdminAudit; } });
var useGetCompanyUsers_1 = useGetCompanyUsers$1;
Object.defineProperty(exports, "useGetCompanyUsers", { enumerable: true, get: function () { return useGetCompanyUsers_1.useGetCompanyUsers; } });
var useGetStores_1 = useGetStores$1;
Object.defineProperty(exports, "useGetStores", { enumerable: true, get: function () { return useGetStores_1.useGetStores; } });
var useGetUserStores_1 = useGetUserStores$1;
Object.defineProperty(exports, "useGetUserStores", { enumerable: true, get: function () { return useGetUserStores_1.useGetUserStores; } });
var useGetAdminCompanyStores_1 = useGetAdminCompanyStores$1;
Object.defineProperty(exports, "useGetAdminCompanyStores", { enumerable: true, get: function () { return useGetAdminCompanyStores_1.useGetAdminCompanyStores; } });
var useGetAdminCompanyStore_1 = useGetAdminCompanyStore$1;
Object.defineProperty(exports, "useGetAdminCompanyStore", { enumerable: true, get: function () { return useGetAdminCompanyStore_1.useGetAdminCompanyStore; } });
var useAuditQuestionsMutations_1 = useAuditQuestionsMutations$1;
Object.defineProperty(exports, "useAuditQuestionsMutations", { enumerable: true, get: function () { return useAuditQuestionsMutations_1.useAuditQuestionsMutations; } });
var useGetAdminAudits_1 = useGetAdminAudits$1;
Object.defineProperty(exports, "useGetAdminAudits", { enumerable: true, get: function () { return useGetAdminAudits_1.useGetAdminAudits; } });
var useWindowDimensions_1 = useWindowDimensions$1;
Object.defineProperty(exports, "useWindowDimensions", { enumerable: true, get: function () { return useWindowDimensions_1.useWindowDimensions; } });
var useGetGroups_1 = useGetGroups$1;
Object.defineProperty(exports, "useGetGroups", { enumerable: true, get: function () { return useGetGroups_1.useGetGroups; } });
var usePauseOptimizations_1 = usePauseOptimizations$1;
Object.defineProperty(exports, "usePauseOptimizations", { enumerable: true, get: function () { return usePauseOptimizations_1.usePauseOptimizations; } });
var useStopOptimizations_1 = useStopOptimizations$1;
Object.defineProperty(exports, "useStopOptimizations", { enumerable: true, get: function () { return useStopOptimizations_1.useStopOptimizations; } });
var useResumeOptimizations_1 = useResumeOptimizations$1;
Object.defineProperty(exports, "useResumeOptimizations", { enumerable: true, get: function () { return useResumeOptimizations_1.useResumeOptimizations; } });
var useGetStoreHistory_1 = useGetStoreHistory$1;
Object.defineProperty(exports, "useGetStoreHistory", { enumerable: true, get: function () { return useGetStoreHistory_1.useGetStoreHistory; } });
var useUpdateOptimizationSchedule_1 = useUpdateOptimizationSchedule$1;
Object.defineProperty(exports, "useUpdateOptimizationSchedule", { enumerable: true, get: function () { return useUpdateOptimizationSchedule_1.useUpdateOptimizationSchedule; } });
__exportStar(useGetAdminCompanyRegions$1, exports);
__exportStar(useGetCompanyRegions$1, exports);
__exportStar(useGetCompanyRegion$1, exports);
__exportStar(useCreateRegion$1, exports);
__exportStar(useDeleteRegion$1, exports);
__exportStar(useGetCompanyStore$1, exports);
__exportStar(useCompanyFormulaGroups$1, exports);
__exportStar(useUpdateCompanyStore, exports);
}(hooks));

var types = {};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
Object.defineProperty(types, "__esModule", { value: true });

var helpers = {};

var Color_helpers = {};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
Object.defineProperty(Color_helpers, "__esModule", { value: true });
Color_helpers.ColorHelpers = void 0;
var pickTextColorBasedOnBgColor = function (bgColor, lightColor, darkColor) {
    var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uiColors = [r / 255, g / 255, b / 255];
    var c = uiColors.map(function (col) {
        if (col <= 0.03928) {
            return col / 12.92;
        }
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.179 ? darkColor : lightColor;
};
Color_helpers.ColorHelpers = {
    pickTextColorBasedOnBgColor: pickTextColorBasedOnBgColor,
};

(function (exports) {
/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Color_helpers, exports);
}(helpers));

(function (exports) {
/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(utils$t, exports);
__exportStar(hooks, exports);
__exportStar(types, exports);
__exportStar(constants$2, exports);
__exportStar(helpers, exports);
}(lib$3));

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var AvatarWithText = function (props) {
    var children = props.children, _a = props.avatarColor, avatarColor = _a === void 0 ? 'secondary' : _a, avatarVariant = props.avatarVariant, primaryText = props.primaryText, secondaryText = props.secondaryText, boldSecondary = props.boldSecondary, boldPrimary = props.boldPrimary, _b = props.textColor, textColor = _b === void 0 ? exports.ThemeVariantsEnum.DARK : _b, ListItemAvatarSx = props.ListItemAvatarSx, ListItemSx = props.ListItemSx, AvatarSx = props.AvatarSx;
    var StyledAvatar = styled(material.Avatar)(function (_a) {
        var theme = _a.theme;
        return ({
            backgroundColor: avatarColor === 'primary'
                ? theme.palette.primary.main
                : avatarColor === 'secondary'
                    ? theme.palette.secondary.main
                    : avatarColor,
        });
    });
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__default["default"].createElement(ListItem__default["default"], { sx: __assign$l({ p: 0 }, ListItemSx) },
            React__default["default"].createElement(material.ListItemAvatar, { sx: ListItemAvatarSx },
                React__default["default"].createElement(StyledAvatar, { variant: avatarVariant, sx: AvatarSx }, children)),
            React__default["default"].createElement(ListItemText__default["default"], { className: textColor, primary: primaryText, secondary: secondaryText, secondaryTypographyProps: {
                    fontWeight: boldSecondary ? 'bold' : undefined,
                }, primaryTypographyProps: {
                    fontWeight: boldPrimary ? 'bold' : undefined,
                } }))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FileUploader = function (props) {
    var title = props.title, files = props.files, onFilesSelected = props.onFilesSelected, _a = props.allowedFileTypes, allowedFileTypes = _a === void 0 ? [] : _a, initialPreviewImageUrl = props.initialPreviewImageUrl, onClearFiles = props.onClearFiles;
    var _b = React.useState(), previewImage = _b[0], setPreviewImage = _b[1];
    var _c = React.useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var file = files && files.length && files[0];
    var onDrop = React.useCallback(function (acceptedFiles) {
        onFilesSelected(acceptedFiles);
    }, [onFilesSelected]);
    var _d = useDropzone({
        onDrop: onDrop,
        accept: allowedFileTypes,
        onDropRejected: function (fileRejections, event) {
            if (fileRejections &&
                fileRejections.length > 0 &&
                fileRejections[0].errors.length > 0) {
                setErrorMessage(fileRejections[0].errors[0].message);
            }
        },
    }), getRootProps = _d.getRootProps, getInputProps = _d.getInputProps, isDragActive = _d.isDragActive;
    var isImageFile = function (file) { return file.type.includes('image'); };
    React.useEffect(function () {
        var getFirstImagePreview = function () { return __awaiter$8(void 0, void 0, void 0, function () {
            var imageFile, dataUrl, _a;
            return __generator$8(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        imageFile = files === null || files === void 0 ? void 0 : files.find(isImageFile);
                        if (!imageFile) return [3 /*break*/, 2];
                        return [4 /*yield*/, lib$3.readAsDataUrlSync(imageFile)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = undefined;
                        _b.label = 3;
                    case 3:
                        dataUrl = _a;
                        setPreviewImage(dataUrl || undefined);
                        return [2 /*return*/];
                }
            });
        }); };
        getFirstImagePreview();
    }, [files]);
    React.useEffect(function () {
        if (initialPreviewImageUrl) {
            setPreviewImage(initialPreviewImageUrl);
        }
    }, [initialPreviewImageUrl, setPreviewImage]);
    React.useEffect(function () {
        setErrorMessage(null);
    }, [onDrop]);
    return (React__default["default"].createElement(material.Card, __assign$l({}, (!file && getRootProps()), { sx: function (theme) { return ({
            width: {
                xl: theme.sizes.modal.md,
                lg: theme.sizes.modal.md,
                md: theme.sizes.modal.md,
                sm: theme.sizes.modal.sm,
                xs: theme.sizes.modal.sm,
            },
        }); }, elevation: !title ? 0 : 2 }),
        title && React__default["default"].createElement(material.CardHeader, { title: title }),
        React__default["default"].createElement(material.CardContent, { sx: { cursor: 'pointer' } }, previewImage ? (React__default["default"].createElement(material.CardMedia, { component: "img", sx: function (theme) { return ({
                objectFit: 'contain',
                height: theme.sizes.img.md,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            }); }, image: previewImage })) : (React__default["default"].createElement(AvatarWithText, { avatarColor: "primary", primaryText: isDragActive ? 'Drop files here...' : 'Drag or click to select' },
            React__default["default"].createElement(iconsMaterial.FileUpload, { color: "secondary" })))),
        React__default["default"].createElement(material.CardActions, null,
            errorMessage && React__default["default"].createElement(material.Typography, null,
                "Error: ",
                errorMessage),
            file && (React__default["default"].createElement(FlexBox.RowBetween, { flexGrow: 1 },
                React__default["default"].createElement(material.Typography, null,
                    file.name,
                    " (",
                    lib$3.humanReadableSize(file.size),
                    ")"),
                React__default["default"].createElement(material.IconButton, { onClick: function (e) {
                        e.stopPropagation();
                        onClearFiles && onClearFiles();
                    } },
                    React__default["default"].createElement(iconsMaterial.Delete, null))))),
        React__default["default"].createElement("input", __assign$l({}, getInputProps()))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var getSubOptions = function (filterBy, label) {
    var options = filterBy.options;
    return options.find(function (opt) { return opt.label === label; });
};
var getNewOptionsFromSelectedSubOption = function (selected, subOption) {
    return !selected.includes(subOption.value)
        ? __spreadArray$5(__spreadArray$5([], selected, true), [subOption.value], false) : selected.filter(function (sl) { return sl !== subOption.value; });
};
var getNewOptionsFromSelectedOption = function (selected, option) {
    return !selected.includes(option)
        ? __spreadArray$5(__spreadArray$5([], selected, true), [option], false) : selected.filter(function (sl) { return sl !== option; });
};
var stringOptionsTyped = function (options) {
    return options.filter(function (opt) { return typeof opt === 'string'; });
};
var subOptionsTyped = function (options) {
    return options.filter(function (opt) { return typeof opt !== 'string'; });
};
var getSelectedOfAllSubOptions = function (filterBy) {
    var options = subOptionsTyped(filterBy.options);
    return options.reduce(function (agg, curr) { return __spreadArray$5(__spreadArray$5([], agg, true), curr.selected, true); }, []);
};
var getDateFilterLabels = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var filter = _a.filter, setFilter = _a.setFilter, join = _a.join;
    if (join) {
        return [
            {
                title: lib$3.DateTimeHelpers.getDateRangeString(((_c = (_b = filter.filterBy) === null || _b === void 0 ? void 0 : _b.dateOptions) === null || _c === void 0 ? void 0 : _c.startDate) || '', ((_e = (_d = filter.filterBy) === null || _d === void 0 ? void 0 : _d.dateOptions) === null || _e === void 0 ? void 0 : _e.endDate) || ''),
                onClick: function () {
                    setFilter(__assign$l(__assign$l({}, filter), { filterBy: __assign$l(__assign$l({}, filter.filterBy), { dateOptions: {
                                startDate: '',
                                endDate: '',
                            } }) }));
                },
            },
        ];
    }
    var startDate = (_g = (_f = filter.filterBy) === null || _f === void 0 ? void 0 : _f.dateOptions) === null || _g === void 0 ? void 0 : _g.startDate;
    var endDate = (_j = (_h = filter.filterBy) === null || _h === void 0 ? void 0 : _h.dateOptions) === null || _j === void 0 ? void 0 : _j.endDate;
    var start = startDate
        ? {
            title: "Start: ".concat(dayjs__default["default"](new Date(startDate)).format(lib$3.DateTimeConstants.MM_DD_YY)),
            onClick: function () {
                setFilter(__assign$l(__assign$l({}, filter), { filterBy: __assign$l(__assign$l({}, filter.filterBy), { dateOptions: {
                            endDate: endDate || '',
                            startDate: '',
                        } }) }));
            },
        }
        : undefined;
    var end = endDate
        ? {
            title: "End: ".concat(dayjs__default["default"](new Date(endDate)).format(lib$3.DateTimeConstants.MM_DD_YY)),
            onClick: function () {
                setFilter(__assign$l(__assign$l({}, filter), { filterBy: __assign$l(__assign$l({}, filter.filterBy), { dateOptions: {
                            startDate: startDate || '',
                            endDate: '',
                        } }) }));
            },
        }
        : undefined;
    return [start, end].filter(function (label) { return label; });
};
var FilterHelpers = {
    getSubOptions: getSubOptions,
    getNewOptionsFromSelectedSubOption: getNewOptionsFromSelectedSubOption,
    getNewOptionsFromSelectedOption: getNewOptionsFromSelectedOption,
    stringOptionsTyped: stringOptionsTyped,
    subOptionsTyped: subOptionsTyped,
    getSelectedOfAllSubOptions: getSelectedOfAllSubOptions,
    getDateFilterLabels: getDateFilterLabels,
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var MUIDatePicker = function (props) {
    var date = props.date, onDateChange = props.onDateChange, label = props.label, _a = props.variant, variant = _a === void 0 ? 'outlined' : _a, _b = props.textProps, textProps = _b === void 0 ? {} : _b, open = props.open, error = props.error, helperText = props.helperText, sx = props.sx;
    var styles = {
        sx: function (theme) { return ({
            '& .MuiButtonBase-root': {
                backgroundColor: theme.palette.grey['200'],
            },
        }); },
    };
    return (React__namespace.createElement(material.Box, { sx: sx },
        React__namespace.createElement(LocalizationProvider.LocalizationProvider, { dateAdapter: AdapterDayjs.AdapterDayjs },
            React__namespace.createElement(DatePicker.DatePicker, { DialogProps: styles, PaperProps: styles, label: label, value: date, open: open, onChange: function (newValue) {
                    onDateChange(newValue);
                }, renderInput: function (params) { return (React__namespace.createElement(TextField__default["default"], __assign$l({ sx: { width: '100%' } }, params, textProps, { variant: variant, helperText: helperText, error: !!error }))); } }))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FilterSubheader = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'sticky',
        top: 0,
        margin: theme.spacing(0, -2),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.grey['200'],
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.palette.secondary.main,
        zIndex: 1,
    });
});
var ExpandMoreOp = styled(function (props) {
    props.expand; var other = __rest$c(props, ["expand"]);
    return React__default["default"].createElement(IconButton__default["default"], __assign$l({}, other));
})(function (_a) {
    var theme = _a.theme, expand = _a.expand;
    return ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    });
});
var OptionSelectBody = function (props) {
    var popoverTitle = props.popoverTitle, sections = props.sections, updateSections = props.updateSections, toggleExpanded = props.toggleExpanded, updateDateOptions = props.updateDateOptions;
    return (React__default["default"].createElement(material.Card, { sx: { width: MuiTheme.sizes.filter.width } },
        React__default["default"].createElement(material.CardHeader, { title: popoverTitle }),
        React__default["default"].createElement(material.CardContent, { sx: function (theme) { return ({
                maxHeight: theme.sizes.modal.lg,
                overflowY: 'scroll',
                p: theme.spacing(0, 2),
            }); } },
            React__default["default"].createElement(material.List, { sx: { p: 0 } }, Object.entries(sections)
                .sort(function (_a, _b) {
                var a = _a[0];
                var b = _b[0];
                return a.localeCompare(b);
            })
                .map(function (_a) {
                var sectionTitle = _a[0], attr = _a[1];
                return (React__default["default"].createElement("div", { key: "section-".concat(sectionTitle) },
                    React__default["default"].createElement(FilterSubheader, null, StringHelpers.camelCaseToTitleCase(sectionTitle)),
                    attr.dateOptions ? (React__default["default"].createElement(React__default["default"].Fragment, null,
                        React__default["default"].createElement(material.ListItem, { disableGutters: true, secondaryAction: React__default["default"].createElement(MUIDatePicker, { onDateChange: function (newDate) {
                                    return updateDateOptions === null || updateDateOptions === void 0 ? void 0 : updateDateOptions('startDate', newDate.toISOString());
                                }, date: dayjs__default["default"](attr.dateOptions.startDate), label: '', variant: "standard", textProps: { sx: { borderBottom: '0px' } } }) },
                            React__default["default"].createElement(material.ListItemText, null, 'Start Date')),
                        React__default["default"].createElement(material.ListItem, { disableGutters: true, secondaryAction: React__default["default"].createElement(MUIDatePicker, { onDateChange: function (newDate) {
                                    return updateDateOptions === null || updateDateOptions === void 0 ? void 0 : updateDateOptions('endDate', newDate.toISOString());
                                }, date: dayjs__default["default"](attr.dateOptions.endDate), label: '', variant: "standard", textProps: { sx: { borderBottom: '0px' } } }) },
                            React__default["default"].createElement(material.ListItemText, null, 'End Date')))) : (attr.options
                        .sort(function (a, b) {
                        if (typeof a === 'string') {
                            return a.localeCompare(b);
                        }
                        return a.label.localeCompare(b.label);
                    })
                        .map(function (option, idx) { return (React__default["default"].createElement("div", { key: "option-".concat(idx) },
                        React__default["default"].createElement(material.ListItem, { disableGutters: true, secondaryAction: typeof option !== 'string' ? (toggleExpanded && (React__default["default"].createElement(ExpandMoreOp, { edge: 'end', expand: !!option.expanded, onClick: function () {
                                    return toggleExpanded(sectionTitle, option.label, !option.expanded);
                                } },
                                React__default["default"].createElement(iconsMaterial.ExpandMore, null)))) : typeof attr.selected === 'string' ? (React__default["default"].createElement(material.Radio, { edge: 'end', checked: attr.selected === option, onChange: function () {
                                    return updateSections(sectionTitle, option);
                                } })) : (React__default["default"].createElement(material.Checkbox, { edge: 'end', checked: attr.selected.includes(option), onChange: function () {
                                    var newOptions = FilterHelpers.getNewOptionsFromSelectedOption(attr.selected, option);
                                    updateSections(sectionTitle, newOptions);
                                } })) },
                            React__default["default"].createElement(material.ListItemText, null, typeof option === 'string' ? option : option.label),
                            typeof option !== 'string' &&
                                !!option.selected.length && (React__default["default"].createElement(material.Avatar, { sx: function (theme) { return ({
                                    bgcolor: theme.palette.primary.main,
                                    height: 30,
                                    width: 30,
                                }); } }, option.selected.length))),
                        typeof option !== 'string' && (React__default["default"].createElement(material.Collapse, { in: option.expanded, timeout: "auto", unmountOnExit: true, sx: function (theme) { return ({
                                maxHeight: theme.sizes.forms.lg,
                                overflowY: 'scroll',
                            }); } },
                            option.showSearch && props.handleSearchTermUpdate && (React__default["default"].createElement(material.Box, { sx: function (theme) { return ({
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 1,
                                    backgroundColor: theme.palette.primary.light,
                                }); } },
                                React__default["default"].createElement(SearchBar, { onChange: function (term) {
                                        return props.handleSearchTermUpdate &&
                                            props.handleSearchTermUpdate(sectionTitle, option.label, term);
                                    } }))),
                            React__default["default"].createElement(material.List, null, option.subOptions
                                .filter(function (opt) {
                                var _a;
                                return !StringHelpers.isNullOrEmpty(option.searchTerm)
                                    ? opt.display
                                        .toLowerCase()
                                        .includes(((_a = option === null || option === void 0 ? void 0 : option.searchTerm) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ||
                                        '')
                                    : true;
                            })
                                .map(function (subOption) { return (React__default["default"].createElement(material.ListItem, { key: "sub-option-".concat(subOption.value), secondaryAction: React__default["default"].createElement(material.Checkbox, { edge: 'end', checked: option.selected.includes(subOption.value), onChange: function () {
                                        var newOptions = FilterHelpers.getNewOptionsFromSelectedSubOption(option
                                            .selected, subOption);
                                        updateSections(sectionTitle, newOptions, option.label);
                                    } }) },
                                React__default["default"].createElement(material.ListItemText, null, subOption.display))); })),
                            React__default["default"].createElement(material.Divider, { sx: function (theme) { return ({
                                    position: 'sticky',
                                    bottom: 0,
                                    zIndex: 1,
                                    color: theme.palette.grey['50'],
                                }); } }))))); }))));
            })))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var Filter = function (props) {
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(Tooltip__default["default"], { title: props.filterTitle },
            React__default["default"].createElement(material.Badge, { badgeContent: props.numberOfItemsSelected, color: "primary", overlap: "circular" },
                React__default["default"].createElement(IconButton__default["default"], { onClick: function (event) { return setAnchorEl(event.currentTarget); } },
                    React__default["default"].createElement(iconsMaterial.FilterList, null)))),
        React__default["default"].createElement(material.Popover, { open: open, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, elevation: 10 },
            React__default["default"].createElement(OptionSelectBody, { popoverTitle: props.filterTitle, toggleExpanded: props.handleToggleExpanded, sections: props.filter, updateSections: props.handleUpdateFilter, handleSearchTermUpdate: props.handleSearchTermUpdate, updateDateOptions: props.updateDateOptions }))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var StyledListItem = styled(material.ListItem)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: 0,
        margin: theme.spacing(0, 0, 2, 0),
    });
});
var SearchableListWithSkeleton = function (props) {
    var _a = props.items, items = _a === void 0 ? [] : _a, onSearchChange = props.onSearchChange, renderItem = props.renderItem, loading = props.loading, _b = props.skeletonListSize, skeletonListSize = _b === void 0 ? 5 : _b, filterProps = props.filterProps, hasMore = props.hasMore, _c = props.fetchMore, fetchMore = _c === void 0 ? function () { return null; } : _c;
    var skeletonizedItems = Array.from(Array(skeletonListSize));
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        onSearchChange && (React__default["default"].createElement(material.Stack, { sx: function (theme) { return ({
                m: theme.spacing(0, 2, 1, 2),
            }); }, spacing: 2, direction: "row", justifyContent: 'space-between' },
            React__default["default"].createElement(Box__default["default"], { flexGrow: 1 },
                React__default["default"].createElement(SearchBar, { onChange: onSearchChange })),
            filterProps && React__default["default"].createElement(Filter, __assign$l({}, filterProps)))),
        !(items === null || items === void 0 ? void 0 : items.length) && !loading ? (React__default["default"].createElement(FlexBox.ColCenter, { flexGrow: 1 },
            React__default["default"].createElement(Box__default["default"], null,
                React__default["default"].createElement(AvatarWithText, { primaryText: 'No results matched that search.', boldPrimary: true },
                    React__default["default"].createElement(iconsMaterial.SearchOff, { color: 'secondary' }))))) : (React__default["default"].createElement(material.List, { sx: { flex: 1, overflowY: 'scroll' }, id: "list" },
            React__default["default"].createElement(InfiniteScroll__default["default"], { next: fetchMore, hasMore: !loading && !!hasMore, loader: React__default["default"].createElement(FlexBox.RowCenter, { width: '100%', my: 1 },
                    React__default["default"].createElement(material.CircularProgress, { size: 50 })), dataLength: (items === null || items === void 0 ? void 0 : items.length) || 0, scrollableTarget: "list" }, (loading && !items.length ? skeletonizedItems : items).map(function (item, index) { return (React__default["default"].createElement(StyledListItem, { disablePadding: true, key: "item-".concat(index) }, renderItem({ item: item, index: index, loading: loading }))); }))))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FILL_GRID_ALL_SCREENS = {
    xl: 12,
    lg: 12,
    md: 12,
    sm: 12,
    xs: 12,
};
var gridAllScreens = function (scale) { return ({
    xl: scale,
    lg: scale,
    md: scale,
    sm: scale,
    xs: scale,
}); };

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var Sidebar = function (props) {
    var _a = props.side, side = _a === void 0 ? 'left' : _a, _b = props.variant, variant = _b === void 0 ? 'lg' : _b, children = props.children, Header = props.Header, FooterButtons = props.FooterButtons;
    var isOpen = React.useContext(NavigationDrawerContext).isOpen;
    var spacerWidth = side === 'left'
        ? MuiTheme.navigation.drawer.width[isOpen ? 'open' : 'closed']
        : 0;
    var sidebarWidth = MuiTheme.sizes.sidebar.width.variant[variant];
    var sidebarWidthMixin = function (theme, useSpacer) {
        return Object.keys(sidebarWidth).reduce(function (css, bp) {
            var _a;
            return (__assign$l(__assign$l({}, css), (_a = {}, _a[theme.breakpoints.only(bp)] = {
                // @ts-ignore
                width: sidebarWidth[bp] + (useSpacer ? spacerWidth : 0),
            }, _a)));
        }, {});
    };
    var openedMixin = function (theme, useSpacer) { return (__assign$l({ transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }), overflowX: 'hidden', boxSizing: 'border-box' }, sidebarWidthMixin(theme, useSpacer))); };
    var closedMixin = function (theme, useSpacer) { return (__assign$l(__assign$l({ transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }), overflowX: 'hidden' }, sidebarWidthMixin(theme, useSpacer)), { boxSizing: 'border-box' })); };
    return (React__default["default"].createElement(ScreenController.LargeScreen, { sx: function (theme) { return (__assign$l(__assign$l({ zIndex: 0, flexShrink: 0, whiteSpace: 'nowrap' }, (isOpen && __assign$l(__assign$l({}, openedMixin(theme, false)), { '& .MuiDrawer-paper': openedMixin(theme, true) }))), (!isOpen && __assign$l(__assign$l({}, closedMixin(theme, false)), { '& .MuiDrawer-paper': closedMixin(theme, true) })))); } },
        React__default["default"].createElement(material.Drawer, { variant: "permanent", anchor: side },
            React__default["default"].createElement(FlexBox.Row, { height: '100vh' },
                React__default["default"].createElement(material.Box, { sx: { height: '100%', width: spacerWidth } }),
                React__default["default"].createElement(material.Box, { display: 'flex', flexGrow: 1, sx: { pt: 2 } },
                    React__default["default"].createElement(FlexBox.Col, { width: '100%' },
                        React__default["default"].createElement(Toolbar__default["default"], null),
                        Header && (React__default["default"].createElement(material.Box, { sx: function (theme) { return ({ m: theme.spacing(0, 2, 2, 2) }); } }, Header)),
                        children,
                        FooterButtons && (React__default["default"].createElement(material.Grid, { container: true, spacing: 2, sx: { p: 2 }, justifyContent: "center", alignItems: "center" }, FooterButtons.map(function (button, idx) { return (React__default["default"].createElement(material.Grid, __assign$l({ item: true }, gridAllScreens(12 / FooterButtons.length), { key: "footer-button-side-".concat(idx) }),
                            React__default["default"].createElement(material.Button, __assign$l({}, button, { fullWidth: true })))); })))))))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FilterLabel = function (props) {
    var title = props.title, onClick = props.onClick, fillWidth = props.fillWidth;
    return (React__default["default"].createElement(material.Tooltip, { title: 'Remove From Filter' },
        React__default["default"].createElement(material.Button, { onClick: onClick, color: 'secondary', sx: function (theme) { return ({
                fontWeight: theme.typography.fontWeightBold,
                fontSize: theme.typography.htmlFontSize,
                color: theme.palette.grey['600'],
                borderColor: theme.palette.grey['600'],
                minHeight: 44,
                width: fillWidth ? '100%' : undefined,
                textTransform: 'capitalize',
            }); }, variant: 'outlined', size: 'small', endIcon: React__default["default"].createElement(iconsMaterial.Close, { sx: function (theme) { return (__assign$l(__assign$l({}, theme.sizes.icon.sm), { color: theme.palette.grey['800'] })); } }) }, title)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var NotificationContext = React__default["default"].createContext({
    success: undefined,
    error: undefined,
    setError: function (_) { return null; },
    setSuccess: function (_) { return null; },
});

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var NotificationAlert = function () {
    var _a = React.useContext(NotificationContext), success = _a.success, error = _a.error, setSuccess = _a.setSuccess, setError = _a.setError;
    var handleClose = function () {
        setSuccess(undefined);
        setError(undefined);
    };
    var errorMessage = error
        ? "The operation could not be completed: ".concat(error)
        : undefined;
    return (React__default["default"].createElement(material.Snackbar, { open: !!success || !!error, autoHideDuration: MuiTheme.duration.snackbarClose, onClose: handleClose },
        React__default["default"].createElement(material.Alert, { onClose: handleClose, severity: error ? 'error' : 'success', sx: { width: '100%' } }, success || errorMessage)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var DateRangePicker = function (props) {
    var onDonePress = props.onDonePress, onNonePress = props.onNonePress;
    var _a = React.useState(null), startDate = _a[0], setStartDate = _a[1];
    var _b = React.useState(null), endDate = _b[0], setEndDate = _b[1];
    var _c = React.useState(false), showRange = _c[0], setShowRange = _c[1];
    return (React__default["default"].createElement(material.Box, { sx: { my: 2 } }, showRange ? (React__default["default"].createElement(material.Card, { variant: "outlined", sx: { position: 'relative' } },
        React__default["default"].createElement(material.CardContent, { sx: { justifyContent: 'center' } },
            React__default["default"].createElement(material.Stack, { direction: "row", spacing: 2 },
                React__default["default"].createElement(MUIDatePicker, { label: "Start Date", date: startDate, onDateChange: setStartDate }),
                React__default["default"].createElement(MUIDatePicker, { label: "End Date", date: endDate, onDateChange: setEndDate }),
                React__default["default"].createElement(CloseIcon__default["default"], { sx: { position: 'absolute', right: 0, top: 0 }, onClick: function () {
                        setShowRange(false);
                        onNonePress();
                    } }),
                React__default["default"].createElement(material.Button, { onClick: function () {
                        onDonePress(startDate, endDate);
                    }, variant: "contained", disableElevation: true }, "Search"))))) : (React__default["default"].createElement(material.Button, { variant: "contained", disableElevation: true, onClick: function () { return setShowRange(true); } }, "Pick Dates"))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var CreateNewPopover = function (props) {
    var buttonLabel = props.buttonLabel, inputLabel = props.inputLabel, onSave = props.onSave;
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = React.useState(''), newValue = _b[0], setNewValue = _b[1];
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(material.Button, { startIcon: React__default["default"].createElement(iconsMaterial.Add, null), color: "secondary", sx: { width: '100%' }, onClick: function (e) { return setAnchorEl(e.currentTarget); } }, buttonLabel),
        React__default["default"].createElement(material.Popover, { open: Boolean(anchorEl), anchorEl: anchorEl, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, onClose: function () { return setAnchorEl(null); } },
            React__default["default"].createElement(material.Box, { p: 2 },
                React__default["default"].createElement(material.TextField, { label: inputLabel, variant: "standard", value: newValue, required: true, onChange: function (e) { return setNewValue(e.currentTarget.value); }, type: "text", InputProps: {
                        endAdornment: (React__default["default"].createElement(Tooltip__default["default"], { title: "Save" },
                            React__default["default"].createElement(material.IconButton, { onClick: function () {
                                    onSave(newValue);
                                    setAnchorEl(null);
                                } },
                                React__default["default"].createElement(iconsMaterial.Save, null)))),
                    } })))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var StatCard = function (props) {
    var title = props.title, stat = props.stat, extraComponent = props.extraComponent, _a = props.extraComponentPlacement, extraComponentPlacement = _a === void 0 ? 'left' : _a, footer = props.footer, _b = props.loading, loading = _b === void 0 ? false : _b;
    var direction = extraComponentPlacement === 'left' ? 'row' : 'row-reverse';
    var stackStyles = loading ? { width: '100%' } : {};
    return (React__default["default"].createElement(material.Card, { sx: {
            display: { xl: 'flex', xs: 'inline-block' },
            flex: 1,
            minWidth: 250,
        } },
        React__default["default"].createElement(material.Stack, __assign$l({ direction: "column", p: 2, spacing: 0.5 }, stackStyles),
            React__default["default"].createElement(material.Typography, { variant: "subtitle1", width: '100%' }, loading ? React__default["default"].createElement(material.Skeleton, null) : title),
            React__default["default"].createElement(material.Stack, { spacing: 1, direction: 'row', flexDirection: direction, justifyContent: 'left', alignItems: 'center' },
                !loading && extraComponent,
                React__default["default"].createElement(material.Typography, { variant: "h4", width: '100%' }, loading ? (React__default["default"].createElement(material.Stack, { direction: 'row', alignItems: 'center', spacing: 1 },
                    React__default["default"].createElement(material.Skeleton, { sx: { width: 30, height: 30 }, variant: 'circular' }),
                    React__default["default"].createElement(material.Skeleton, { width: '80%' }))) : (stat))),
            loading ? React__default["default"].createElement(material.Skeleton, null) : footer)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var ReportContainerLayout = function (props) {
    var Breadcrumbs = props.Breadcrumbs, Header = props.Header, Summary = props.Summary, Body = props.Body;
    var numAutoRows = Breadcrumbs ? 3 : 2;
    return (React__default["default"].createElement(material.Box, { sx: {
            display: 'grid',
            gridTemplateRows: "repeat(".concat(numAutoRows, ", auto) 1fr"),
            gap: 2,
        } },
        Breadcrumbs,
        Header,
        Summary,
        Body));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */
var ReportLayout = function (props) {
    var title = props.title, subtitle = props.subtitle, statistic = props.statistic, container = props.container, moreInfo = props.moreInfo, HeaderRightComponent = props.HeaderRightComponent, _a = props.FilterAndSearch, FilterAndSearch = _a === void 0 ? React__default["default"].createElement(React__default["default"].Fragment, null) : _a, Body = props.Body;
    var width = lib$3.useWindowDimensions().width;
    var isMobile = width < MuiTheme.breakpoints.values.sm;
    var Content = (React__default["default"].createElement(ReportContainerLayout, { Header: React__default["default"].createElement(material.Grid, { container: true, direction: 'row', spacing: 1, alignItems: 'center' },
            React__default["default"].createElement(material.Grid, __assign$l({ item: true }, gridAllScreens(HeaderRightComponent ? 6 : 12), { xs: 12 }),
                React__default["default"].createElement(material.Stack, { direction: "row", spacing: 2, justifyContent: { xs: 'space-between', sm: 'flex-start' } },
                    React__default["default"].createElement(FlexBox.Col, null,
                        React__default["default"].createElement(FlexBox.Row, { alignItems: 'center' },
                            React__default["default"].createElement(material.Typography, { variant: "h5", fontWeight: container ? 'normal' : 'bold', fontSize: container
                                    ? MuiTheme.typography.h5.fontSize
                                    : MuiTheme.typography.h6.fontSize }, title),
                            statistic && (React__default["default"].createElement(material.Typography, { pl: 2, color: MuiTheme.palette.grey['800'], fontSize: container
                                    ? MuiTheme.typography.h5.fontSize
                                    : MuiTheme.typography.h6.fontSize }, statistic))),
                        subtitle && React__default["default"].createElement(material.Typography, null, subtitle)),
                    moreInfo && React__default["default"].createElement(material.Chip, { variant: 'bold-dark', label: moreInfo }))),
            HeaderRightComponent && (React__default["default"].createElement(material.Grid, __assign$l({ direction: 'row', item: true }, gridAllScreens(6), { xs: 12 }),
                React__default["default"].createElement(ScreenController.LargeScreen, null,
                    React__default["default"].createElement(FlexBox.RowRight, null, HeaderRightComponent)),
                React__default["default"].createElement(ScreenController.Mobile, null,
                    React__default["default"].createElement(FlexBox.RowCenter, null, HeaderRightComponent))))), Summary: FilterAndSearch, Body: Body }));
    if (container) {
        return React__default["default"].createElement(material.Paper, { sx: { p: 2 } }, Content);
    }
    return React__default["default"].createElement(material.Box, { p: !isMobile ? 2 : 0 }, Content);
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var CaptionStack = function (props) {
    var caption = props.caption, _a = props.placement, placement = _a === void 0 ? 'bottom' : _a, _b = props.alignment, alignment = _b === void 0 ? 'center' : _b, children = props.children, sx = props.sx;
    var flexDirection = placement === 'top' ? 'column-reverse' : 'column';
    var margin = placement === 'top' ? { mb: 1 } : { mt: 1 };
    return (React__default["default"].createElement(FlexBox.Col, { sx: __assign$l({ flexDirection: flexDirection, alignItems: alignment }, sx) },
        children,
        React__default["default"].createElement(material.Typography, __assign$l({ variant: "caption" }, margin), caption)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var CollapsibleContent = function (props) {
    var _a = props.LeftComponent, LeftComponent = _a === void 0 ? React__default["default"].createElement(material.Box, null) : _a, _b = props.toggleColor, toggleColor = _b === void 0 ? MuiTheme.palette.grey['600'] : _b, _c = props.underline, underline = _c === void 0 ? true : _c, children = props.children;
    var _d = React__default["default"].useState(true), showContent = _d[0], setShowContent = _d[1];
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(FlexBox.RowBetween, null,
            LeftComponent,
            React__default["default"].createElement(material.Typography, { onClick: function () { return setShowContent(!showContent); }, color: toggleColor, sx: __assign$l({ cursor: 'pointer' }, (underline && { textDecoration: 'underline' })) }, showContent ? 'Hide' : 'Show')),
        showContent && React__default["default"].createElement(React__default["default"].Fragment, null, children)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var DEFAULT_SIZE = 50;
var DEFAULT_FONT_SIZE = 0.75;
var CircularProgress = function (props) {
    var value = props.value, backgroundColor = props.backgroundColor; props.children; var _a = props.showPercentageLabel, showPercentageLabel = _a === void 0 ? false : _a; props.scaleLabel; var _c = props.thickness, thickness = _c === void 0 ? 6 : _c, _d = props.size, size = _d === void 0 ? DEFAULT_SIZE : _d, rest = __rest$c(props, ["value", "backgroundColor", "children", "showPercentageLabel", "scaleLabel", "thickness", "size"]);
    var scaledFontSize = DEFAULT_FONT_SIZE * (size / DEFAULT_SIZE);
    var fontSize = "".concat(scaledFontSize, "rem");
    return (React__default["default"].createElement(material.Box, { sx: { position: 'relative', display: 'inline-flex' } },
        React__default["default"].createElement(material.CircularProgress, __assign$l({}, rest, { size: size, variant: "determinate", value: 100, thickness: thickness, sx: function (theme) { return ({
                color: backgroundColor || theme.palette.grey[400],
                position: 'absolute',
                right: 0,
                '& .MuiCircularProgress-svg': {
                    filter: "drop-shadow(0px 2px 2px ".concat(theme.palette.grey[500], ")"),
                },
            }); } })),
        React__default["default"].createElement(material.CircularProgress, __assign$l({}, rest, { size: size, variant: "determinate", thickness: thickness, color: rest.color, sx: { zIndex: 2, position: 'relative' }, value: value })),
        showPercentageLabel && (React__default["default"].createElement(material.Box, { sx: {
                top: 0,
                left: 4,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            React__default["default"].createElement(material.Typography, { variant: "caption", fontWeight: "bold", component: "div", color: "text.secondary", fontSize: fontSize }, "".concat(Math.round(value), "%"))))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var CircularProgressThresholds = function (props) {
    var _a = props.thresholds, warning = _a.warning, success = _a.success, value = props.value, rest = __rest$c(props, ["thresholds", "value"]);
    return (React__default["default"].createElement(CircularProgress, __assign$l({ value: value, color: value >= success ? 'success' : value >= warning ? 'warning' : 'error' }, rest)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var ComplianceCard = function (props) {
    var title = props.title, compliance = props.compliance, details = props.details, _a = props.actionTitle, actionTitle = _a === void 0 ? 'Select' : _a, onSelect = props.onSelect, loading = props.loading, sx = props.sx;
    return (React__default["default"].createElement(material.Card, { sx: sx || { width: 360 } },
        React__default["default"].createElement(material.CardContent, null,
            React__default["default"].createElement(FlexBox.RowBetween, { mb: 2 },
                React__default["default"].createElement(material.Stack, { direction: "column", spacing: 2 },
                    React__default["default"].createElement(material.Typography, { variant: "h5" }, loading ? React__default["default"].createElement(material.Skeleton, { width: 150 }) : title),
                    React__default["default"].createElement(material.Stack, { direction: "row", spacing: 2 }, details.map(function (detail) { return (React__default["default"].createElement(material.Typography, { sx: function (theme) { return ({ color: theme.palette.grey[700] }); } }, loading ? (React__default["default"].createElement(material.Skeleton, { width: 80 })) : ("".concat(detail.count, " ").concat(detail.name)))); }))),
                React__default["default"].createElement(CaptionStack, { caption: "Compliance" }, loading ? (React__default["default"].createElement(material.Skeleton, { variant: "circular", height: 75, width: 75 })) : (React__default["default"].createElement(CircularProgressThresholds, { size: 75, showPercentageLabel: true, value: compliance * 100, thresholds: { warning: 50, success: 80 } })))),
            React__default["default"].createElement(material.Button, { variant: "contained", color: "secondary", disableElevation: true, fullWidth: true, onClick: onSelect, disabled: loading }, actionTitle))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ChangeOverTimeChip = function (props) {
    var change = props.change, isBadChange = props.isBadChange, timeLabel = props.timeLabel;
    return (React__default["default"].createElement(material.Chip, { label: React__default["default"].createElement(material.Stack, { direction: "row", spacing: 1 },
            React__default["default"].createElement(material.Typography, { color: MuiTheme.palette[isBadChange ? 'primary' : 'success'].main }, change),
            React__default["default"].createElement(material.Typography, { color: MuiTheme.palette.secondary.main, fontWeight: MuiTheme.typography.fontWeightMedium }, timeLabel)) }));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var SquaredChip = function (props) {
    var color = props.color, label = props.label, sx = props.sx, _a = props.typographyVariant, typographyVariant = _a === void 0 ? 'caption' : _a;
    return (React__default["default"].createElement(FlexBox.RowCenter, { sx: __assign$l({ py: 0.5, px: 1, backgroundColor: color, width: 'fit-content', borderRadius: 0.5 }, sx) },
        React__default["default"].createElement(material.Typography, { variant: typographyVariant, sx: function (theme) { return ({
                color: theme.palette.background.default,
            }); } }, label)));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PicOSPriorityDetails = function (props) {
    var priority = props.priority, name = props.name, mandateType = props.mandateType, displayElements = props.displayElements, imageUrl = props.imageUrl, _a = props.compact, compact = _a === void 0 ? true : _a, sx = props.sx;
    var theme = material.useTheme();
    var mandateTypeColor = mandateType === lib$4.MandateTypes.HQ
        ? theme.palette.primary.main
        : theme.palette.primary.dark;
    return (React__default["default"].createElement(FlexBox.RowLeft, { sx: sx },
        React__default["default"].createElement(SquaredChip, { label: priority, color: mandateTypeColor, typographyVariant: "h5", sx: { py: 0.25 } }),
        React__default["default"].createElement(material.CardMedia, { component: "img", src: imageUrl || '', alt: "PicOS Priority Image", width: 80, height: 60, sx: function (theme) { return ({
                mx: theme.spacing(1),
                borderRadius: 0.5,
                height: 60,
                width: 80,
                objectFit: 'scale-down',
            }); } }),
        React__default["default"].createElement(material.Box, { sx: {
                display: 'flex',
                flexDirection: compact ? 'column' : 'row',
                alignItems: compact ? 'left' : 'center',
                justifyContent: 'left',
            } },
            React__default["default"].createElement(material.Typography, { variant: "body2" }, name),
            React__default["default"].createElement(material.Stack, __assign$l({ direction: "row" }, (compact ? { mt: 0.5 } : { ml: 1 }), { spacing: 0.5 }),
                React__default["default"].createElement(SquaredChip, { label: mandateType === lib$4.MandateTypes.LOCAL
                        ? lib$3.toTitleCase(mandateType)
                        : mandateType, color: mandateTypeColor }),
                React__default["default"].createElement(SquaredChip, { label: displayElements === lib$4.DisplayElements.AD ? 'OnAd' : 'Sustain', color: displayElements === lib$4.DisplayElements.AD
                        ? theme.palette.success.main
                        : theme.palette.primary.dark })))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var AddressBlock = function (props) {
    var _a = props.address, address1 = _a.address1, city = _a.city, state = _a.state, postalCode = _a.postalCode;
    return (React__default["default"].createElement(material.Stack, null,
        React__default["default"].createElement(material.Typography, null, address1),
        React__default["default"].createElement(material.Typography, null, "".concat(city, ", ").concat(state, " ").concat(postalCode))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var RankingChangeOverTime = function (props) {
    var rank = props.rank, previousRank = props.previousRank;
    var previous = previousRank || 0;
    var delta = previous - rank;
    var deltaStr = delta === null ? 'n/a' : delta >= 0 ? "+".concat(delta) : String(delta);
    return (React__default["default"].createElement(material.Stack, { direction: "row", spacing: 0.5, alignItems: "center" },
        delta > 0 ? (React__default["default"].createElement(ExpandLess__default["default"], { color: "success" })) : !delta ? (React__default["default"].createElement(Remove__default["default"], { color: "disabled" })) : (React__default["default"].createElement(ExpandMore__default["default"], { color: "error" })),
        React__default["default"].createElement(material.Typography, { variant: "h6" }, rank),
        React__default["default"].createElement(material.Typography, { variant: "body2" }, "(".concat(deltaStr, ")"))));
};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var DEFAULT_HEIGHT = 100;
var ProductImage = function (props) {
    var upc = props.upc, imageUrl = props.imageUrl, sx = props.sx;
    return (React__default["default"].createElement(material.CardMedia, { component: "img", image: imageUrl || '', alt: upc, sx: __assign$l({ objectFit: 'contain', height: DEFAULT_HEIGHT, flex: 1 }, sx) }));
};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PlanogramSegment = function (props) {
    var segment = props.segment, productImages = props.productImages, sx = props.sx;
    var theme = material.useTheme();
    return (React__default["default"].createElement(material.Stack, { spacing: 1, direction: "column", sx: __assign$l({ border: "10px solid ".concat(theme.palette.primary.dark) }, sx) }, segment.map(function (shelf, index) { return (React__default["default"].createElement(FlexBox.Row, { key: "shelf:".concat(index), sx: function (theme) { return ({
            borderBottom: "5px solid ".concat(theme.palette.primary.dark),
            flex: 1,
        }); } }, shelf.map(function (upc, index) { return (React__default["default"].createElement(ProductImage, { key: "".concat(upc, ":").concat(index), upc: upc, imageUrl: productImages[upc], sx: { margin: 1 } })); }))); })));
};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PlaceholderBox = function (props) {
    var message = props.message, sx = props.sx;
    var theme = material.useTheme();
    return (React__default["default"].createElement(FlexBox.RowCenter, { sx: __assign$l({ background: theme.palette.grey[500], borderRadius: theme.shape.borderRadius }, sx) },
        React__default["default"].createElement(material.Typography, null, message)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FlexScrollHorizontal = function (props) {
    var _a, _b, _c;
    var items = props.items, renderItem = props.renderItem, _d = props.flexBp, flexBp = _d === void 0 ? 'xl' : _d, _e = props.spacing, spacing = _e === void 0 ? 2 : _e;
    return (React__default["default"].createElement(material.Stack, { spacing: spacing, display: (_a = {}, _a[flexBp] = 'flex', _a.xs = 'block', _a), direction: "row", overflow: (_b = {}, _b[flexBp] = 'inherit', _b.xs = 'scroll', _b), whiteSpace: (_c = {}, _c[flexBp] = 'inherit', _c.xs = 'nowrap', _c) }, items.map(renderItem)));
};
var FlexScroll = {
    Horizontal: FlexScrollHorizontal,
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var StatCardSkeleton = function () { return React__default["default"].createElement(StatCard, { title: "", stat: "", loading: true }); };
var CollapsibleReportStats = function (props) {
    var title = props.title, subtitle = props.subtitle, items = props.items, loading = props.loading, _a = props.numSkeletonCards, numSkeletonCards = _a === void 0 ? 4 : _a;
    var skeletonArray = Array.from({ length: numSkeletonCards }).fill({});
    return (React__default["default"].createElement(CollapsibleContent, { LeftComponent: React__default["default"].createElement(material.Stack, { direction: "row", spacing: 1 },
            React__default["default"].createElement(material.Chip, { variant: 'bold-light-hoverable', label: title }),
            React__default["default"].createElement(material.Chip, { variant: 'bold-dark-hoverable', label: subtitle })) }, loading ? (React__default["default"].createElement(FlexScroll.Horizontal, { items: skeletonArray, renderItem: StatCardSkeleton })) : (React__default["default"].createElement(FlexScroll.Horizontal, { items: items, renderItem: StatCard }))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var EmptyResults = function () {
    return (React__default["default"].createElement(FlexBox.ColCenter, { sx: function (theme) { return ({ height: 200, padding: theme.spacing(3) }); } },
        React__default["default"].createElement(material.Typography, { variant: "h6" }, "No Available Data")));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var ComplianceCardSkeleton = function () { return (React__default["default"].createElement(ComplianceCard, { title: "", compliance: 0, details: [], onSelect: function () { return null; }, loading: true })); };
var ComplianceCardGrid = function (props) {
    var complianceItems = props.complianceItems, loading = props.loading, pageSize = props.pageSize, currentPage = props.currentPage, totalPages = props.totalPages, onPageChange = props.onPageChange, onSelect = props.onSelect;
    return (React__default["default"].createElement(material.Stack, { direction: "column", spacing: 2.5 },
        React__default["default"].createElement(material.Grid, { container: true, spacing: 2 }, loading ? (React__default["default"].createElement(React__default["default"].Fragment, null, Array.from({ length: pageSize })
            .fill(0)
            .map(function (_, index) { return (React__default["default"].createElement(material.Grid, { key: index, item: true },
            React__default["default"].createElement(ComplianceCardSkeleton, null))); }))) : (React__default["default"].createElement(React__default["default"].Fragment, null, complianceItems.map(function (item) { return (React__default["default"].createElement(material.Grid, { key: item.id, item: true },
            React__default["default"].createElement(ComplianceCard, __assign$l({}, item, { onSelect: function () { return onSelect({ id: item.id, name: item.title }); } })))); })))),
        React__default["default"].createElement(material.Pagination, { page: currentPage, count: totalPages, shape: "rounded", onChange: onPageChange, sx: { marginLeft: 'auto !important' } })));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PicOSReportBody = function (props) {
    var title = props.title, titleComponent = props.titleComponent, onSearch = props.onSearch; props.onClickExportCsv; var children = props.children;
    var width = lib$3.useWindowDimensions().width;
    var theme = material.useTheme();
    var isMobile = width <= theme.breakpoints.values.sm;
    return (React__default["default"].createElement(material.Card, null,
        React__default["default"].createElement(material.CardContent, { sx: function (theme) { return ({ padding: theme.spacing(3) }); } },
            React__default["default"].createElement(FlexBox.ColLeft, null,
                titleComponent || React__default["default"].createElement(material.Typography, { variant: "h5" }, title),
                React__default["default"].createElement(FlexBox.RowBetween, { mt: 5, mb: 2 },
                    React__default["default"].createElement(material.TextField, { label: "Search", variant: "outlined", size: "small", sx: { width: isMobile ? 250 : 300 }, onChange: onSearch }))),
            children)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PicOSReportContext = React__default["default"].createContext({
    reportType: 'Divisions',
    selectedCustomer: null,
    selectedDivision: null,
    selectedSalesCenter: null,
    selectedStore: null,
    selectedDateRange: { start: dayjs__default["default"](), end: dayjs__default["default"]() },
    selectedPriority: null,
    setReportType: lodash.exports.noop,
    setSelectedCustomer: lodash.exports.noop,
    setSelectedDivision: lodash.exports.noop,
    setSelectedSalesCenter: lodash.exports.noop,
    setSelectedStore: lodash.exports.noop,
    setSelectedPriority: lodash.exports.noop,
    setDateRange: lodash.exports.noop,
    handleSetDate: lodash.exports.noop,
});

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PicOSReportHeader = function () {
    var _a = React.useContext(PicOSReportContext), reportType = _a.reportType, setReportType = _a.setReportType, selectedDateRange = _a.selectedDateRange, handleSetDate = _a.handleSetDate;
    var handleChange = function (event) {
        setReportType(event.target.value);
    };
    return (React__default["default"].createElement(FlexBox.RowBetween, null,
        React__default["default"].createElement(FormControl__default["default"], { sx: function (theme) {
                var _a;
                return (_a = {
                        width: 200
                    },
                    _a[theme.breakpoints.down('md')] = { mr: theme.spacing(1) },
                    _a);
            } },
            React__default["default"].createElement(InputLabel__default["default"], { id: "report-type-select-label" }, "Report Type"),
            React__default["default"].createElement(Select__default["default"], { labelId: "report-type-select-label", id: "demo-simple-select", value: reportType, label: "Report Type", onChange: handleChange, sx: function (theme) { return ({ backgroundColor: theme.palette.background.default }); } },
                React__default["default"].createElement(MenuItem__default["default"], { value: 'Divisions' }, "Divisions"),
                React__default["default"].createElement(MenuItem__default["default"], { value: 'All Priorities' }, "All Priorities"))),
        React__default["default"].createElement(FlexBox.RowBetween, null,
            React__default["default"].createElement(MUIDatePicker, { date: selectedDateRange.start, label: "Start Date", onDateChange: function (date) { return handleSetDate('start', date); }, sx: function (theme) { return ({
                    mr: theme.spacing(1),
                    backgroundColor: theme.palette.background.default,
                }); } }),
            React__default["default"].createElement(MUIDatePicker, { date: selectedDateRange.end, label: "End Date", onDateChange: function (date) { return handleSetDate('end', date); }, sx: function (theme) { return ({
                    backgroundColor: theme.palette.background.default,
                }); } }))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PicOSComplianceCardReport = function (props) {
    var title = props.title, onSearch = props.onSearch, onSelect = props.onSelect, onClickExportCsv = props.onClickExportCsv, complianceItems = props.complianceItems, statItems = props.statItems, loadingComplianceItems = props.loadingComplianceItems, loadingStats = props.loadingStats, pageSize = props.pageSize, currentPage = props.currentPage, totalPages = props.totalPages, onPageChange = props.onPageChange;
    return (React__default["default"].createElement(ReportContainerLayout, { Header: React__default["default"].createElement(PicOSReportHeader, null), Summary: React__default["default"].createElement(CollapsibleReportStats, { title: title, subtitle: "Overview Summary", items: statItems, loading: loadingStats }), Body: React__default["default"].createElement(PicOSReportBody, { title: title, onSearch: onSearch, onClickExportCsv: onClickExportCsv }, !complianceItems.length && !loadingComplianceItems ? (React__default["default"].createElement(EmptyResults, null)) : (React__default["default"].createElement(ComplianceCardGrid, { complianceItems: complianceItems, loading: loadingComplianceItems, pageSize: pageSize, currentPage: currentPage, totalPages: totalPages, onPageChange: onPageChange, onSelect: onSelect }))) }));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var StyledTableCell = styled(TableCell__default["default"])(function (_a) {
    var _b;
    var theme = _a.theme, sx = _a.sx;
    return (_b = {},
        _b["&.".concat(TableCell.tableCellClasses.head)] = __assign$l({ backgroundColor: theme.palette.primary.main, color: theme.palette.common.white }, sx),
        _b["&.".concat(TableCell.tableCellClasses.body)] = __assign$l({ fontSize: 14 }, sx),
        _b);
});
var StyledTableRow = styled(TableRow__default["default"])(function (_a) {
    var theme = _a.theme;
    return ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    });
});

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var DAITableHeader = function (props) {
    var onSelectAllClick = props.onSelectAllClick, order = props.order, orderBy = props.orderBy, numSelected = props.numSelected, rowCount = props.rowCount, onRequestSort = props.onRequestSort, columns = props.columns, showCheckbox = props.showCheckbox, disableSelectAll = props.disableSelectAll, disabledSortColumns = props.disabledSortColumns, sxCell = props.sxCell;
    var createSortHandler = function (property) { return function (event) {
        onRequestSort(event, property);
    }; };
    return (React__default["default"].createElement(TableHead__default["default"], null,
        React__default["default"].createElement(TableRow__default["default"], null,
            showCheckbox && (React__default["default"].createElement(StyledTableCell, { padding: "checkbox", onClick: function () {
                    if (!disableSelectAll)
                        onSelectAllClick === null || onSelectAllClick === void 0 ? void 0 : onSelectAllClick(rowCount > 0 && numSelected === rowCount);
                } }, !disableSelectAll && (React__default["default"].createElement(material.Checkbox, { color: 'secondary', checked: rowCount > 0 && numSelected === rowCount, onChange: function () { return null; } })))),
            columns.map(function (headCell, index) { return (React__default["default"].createElement(StyledTableCell, { sx: sxCell, padding: !showCheckbox && index === 0 ? 'normal' : 'none', key: headCell.field, sortDirection: orderBy === headCell.field ? order : false }, disabledSortColumns.includes(headCell.field) ? (React__default["default"].createElement(material.Typography, null, headCell.headerName)) : (React__default["default"].createElement(TableSortLabel__default["default"], { active: orderBy === headCell.field, direction: orderBy === headCell.field ? order : 'asc', onClick: createSortHandler(headCell.field), centerRipple: true, sx: function (theme) { return ({ fontWeight: theme.typography.fontWeightBold }); } }, headCell.headerName)))); }))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
exports.TableContainerClass = void 0;
(function (TableContainerClass) {
    TableContainerClass["DAI_TABLE"] = "dai-table";
    TableContainerClass["MODAL"] = "modal";
    TableContainerClass["NONE"] = "";
})(exports.TableContainerClass || (exports.TableContainerClass = {}));

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var descendingComparator = function (a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
};
var additionalPadding = function (a) {
    if (typeof a === 'boolean') {
        return '30px';
    }
    if (typeof a === 'number') {
        return '30px';
    }
    return undefined;
};
var getComparator = function (order, orderBy) {
    return order === 'desc'
        ? function (a, b) { return descendingComparator(a, b, orderBy); }
        : function (a, b) { return -descendingComparator(a, b, orderBy); };
};
var stableSort = function (array, comparator) {
    var stabilizedThis = array.map(function (el, index) { return [el, index]; });
    stabilizedThis.sort(function (a, b) {
        var order = comparator(a[0], b[0]);
        if (order !== 0)
            return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(function (el) { return el[0]; });
};
var formatDateTime = function (date) {
    return ((date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
        '/' +
        (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
        '/' +
        date.getFullYear() +
        ' ' +
        (date.getHours() > 12 ? date.getHours() - 12 : date.getHours()) +
        ':' +
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ' ' +
        (date.getHours() > 12 ? 'PM' : 'AM'));
};
var isSelected = function (selected, name) {
    return selected.indexOf(name) !== -1;
};
var TableHelpers = {
    descendingComparator: descendingComparator,
    additionalPadding: additionalPadding,
    getComparator: getComparator,
    stableSort: stableSort,
    formatDateTime: formatDateTime,
    isSelected: isSelected,
};

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CheckCircle = React.forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$1(_ref, ["color", "size"]);

  return /*#__PURE__*/React__default["default"].createElement("svg", _extends$1({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
  }), /*#__PURE__*/React__default["default"].createElement("polyline", {
    points: "22 4 12 14.01 9 11.01"
  }));
});
CheckCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CheckCircle.displayName = 'CheckCircle';
var CheckCircle$1 = CheckCircle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var XCircle = React.forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("line", {
    x1: "15",
    y1: "9",
    x2: "9",
    y2: "15"
  }), /*#__PURE__*/React__default["default"].createElement("line", {
    x1: "9",
    y1: "9",
    x2: "15",
    y2: "15"
  }));
});
XCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
XCircle.displayName = 'XCircle';
var XCircle$1 = XCircle;

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var DAITableBody = function (props) {
    var columns = props.columns, sortedRows = props.sortedRows, _a = props.tableState, page = _a.page, rowsPerPage = _a.rowsPerPage, handleClick = props.handleClick, onRowSelect = props.onRowSelect, showCheckbox = props.showCheckbox, selected = props.selected, loading = props.loading, _b = props.skeletonListSize, skeletonListSize = _b === void 0 ? 15 : _b;
    var tableRows = loading
        ? Array.from(Array(page * rowsPerPage + skeletonListSize))
        : sortedRows;
    return (React__default["default"].createElement(TableBody__default["default"], null, tableRows
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map(function (row, idx) {
        var isItemSelected = loading
            ? false
            : TableHelpers.isSelected(selected, row.id);
        var labelId = "enhanced-table-checkbox-".concat(idx);
        return (React__default["default"].createElement(StyledTableRow, { onClick: function (event) {
                if (!loading)
                    handleClick(event, row.id);
            }, role: "checkbox", "aria-checked": isItemSelected, tabIndex: -1, key: "row-".concat(idx), sx: function (theme) { return ({
                height: theme.sizes.table.rowHeight,
                cursor: onRowSelect ? 'pointer' : '',
            }); }, selected: isItemSelected },
            showCheckbox && (React__default["default"].createElement(TableCell__default["default"], { padding: "checkbox" },
                React__default["default"].createElement(material.Checkbox, { checked: isItemSelected, onChange: function () { return null; }, disabled: loading }))),
            columns.map(function (column, index) { return (React__default["default"].createElement(StyledTableCell, { key: "table-body-item-".concat(idx, "-").concat(index), component: "td", id: labelId, scope: "row", padding: !showCheckbox && index === 0 ? 'normal' : 'none', style: {
                    width: column.width,
                } }, loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                    height: "calc(".concat(theme.sizes.table.rowHeight, "px - ").concat(theme.spacing(2), ")"),
                    m: theme.spacing(0, 2, 0, 0),
                }); }, variant: 'rectangular' })) : typeof row[column.field] === 'boolean' ? (row[column.field] ? (React__default["default"].createElement(CheckCircle$1, { color: 'green' })) : (React__default["default"].createElement(XCircle$1, { color: 'red' }))) : typeof row[column.field] === 'string' ? (column.field.toString().includes('date') ? (TableHelpers.formatDateTime(new Date(row[column.field]))) : (row[column.field])) : typeof row[column.field] === 'string' ? (column.field.toString().includes('date') ? (TableHelpers.formatDateTime(new Date(row[column.field]))) : (row[column.field])) : (row[column.field]))); })));
    })));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var TableToolbar = function (props) {
    var _a;
    var tableTitle = props.tableTitle, titleSx = props.titleSx, right = props.right;
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__default["default"].createElement(FlexBox.RowBetween, { sx: function (theme) { return theme.mixins.toolbar; }, paddingLeft: 2, paddingRight: 1 },
            React__default["default"].createElement(Typography__default["default"], { variant: "h6", id: "tableTitle", component: "div", sx: titleSx }, tableTitle),
            React__default["default"].createElement(FlexBox.RowCenter, null, (_a = right === null || right === void 0 ? void 0 : right.others) === null || _a === void 0 ? void 0 :
                _a.map(function (other, idx) { return (React__default["default"].createElement(Box__default["default"], { key: idx, sx: { ml: { xs: 0.5, sm: 1 }, mr: { xs: 0.5, sm: 1 } } }, other)); }),
                (right === null || right === void 0 ? void 0 : right.iconButton) && (React__default["default"].createElement(Box__default["default"], { sx: { ml: { xs: 0.5, sm: 1 } } },
                    React__default["default"].createElement(Tooltip__default["default"], { title: right.iconButton.toolTipLabel },
                        React__default["default"].createElement(IconButton__default["default"], __assign$l({}, right.iconButton.buttonProps), right.iconButton.icon))))))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var DAITable = /** @class */ (function (_super) {
    __extends(DAITable, _super);
    function DAITable(props) {
        var _this = _super.call(this, props) || this;
        _this.setSelectedIds = function (ids) {
            _this.setState({ selected: ids });
        };
        _this.handleRequestSort = function (event, property) {
            var _a = _this.state, order = _a.order, orderBy = _a.orderBy, disabledSortColumns = _a.disabledSortColumns;
            if (disabledSortColumns.includes(property)) {
                return;
            }
            var isAsc = orderBy === property && order === 'asc';
            if (_this.props.onSortChange) {
                _this.props.onSortChange(property, isAsc ? 'desc' : 'asc');
                _this.setState({ order: isAsc ? 'desc' : 'asc', orderBy: property });
            }
            else {
                _this.setState({ order: isAsc ? 'desc' : 'asc', orderBy: property });
            }
            _this.returnToFirstPage();
        };
        _this._setSelected = function (selected) {
            _this.setState({ selected: selected });
            _this.props.onSelectionChange && _this.props.onSelectionChange(selected);
        };
        _this.handleSelectAllClick = function (allChecked) {
            if (!allChecked) {
                var newSelected = _this.props.rows.map(function (n) { return n.id; });
                _this._setSelected(newSelected);
                return;
            }
            _this._setSelected([]);
        };
        _this.handleClick = function (event, name) {
            var selected = _this.state.selected;
            var selectedIndex = selected.indexOf(name);
            var newSelected = [];
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, name);
            }
            else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            }
            else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            }
            else if (selectedIndex > 0) {
                newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
            }
            if (_this.props.singleSelect) {
                if (selected[0] && selected[0] === name) {
                    newSelected = [];
                }
                else {
                    newSelected = [name];
                }
            }
            if (_this.props.onRowSelect) {
                _this.props.onRowSelect(name);
            }
            _this._setSelected(newSelected);
        };
        _this.returnToFirstPage = function () {
            _this.setState({ page: 0 });
            _this.props.onPageChange && _this.props.onPageChange(0, 0);
        };
        _this.handleChangePage = function (event, newPage) {
            _this.setState({ page: newPage });
            _this.props.onPageChange &&
                _this.props.onPageChange(newPage, newPage * _this.state.rowsPerPage);
        };
        _this.handleChangeRowsPerPage = function (event) {
            var page = 0;
            var rowsPerPage = parseInt(event.target.value, 10);
            _this.setState({ rowsPerPage: rowsPerPage, page: page });
            _this.props.onPageChange &&
                _this.props.onPageChange(page, (page + 1) * _this.state.rowsPerPage); // TODO: look at this logic
        };
        _this.state = {
            order: 'asc',
            orderBy: props.defaultOrderBy || null,
            selected: props.initialSelected || [],
            page: 0,
            rowsPerPage: props.pageSize || 10,
            disabledSortColumns: props.columns
                .filter(function (col) { return col.disableSort === true; })
                .map(function (col) { return col.field; }),
        };
        return _this;
    }
    DAITable.prototype.render = function () {
        var _a = this.state, selected = _a.selected, rowsPerPage = _a.rowsPerPage, page = _a.page, order = _a.order, orderBy = _a.orderBy;
        var _b = this.props, rows = _b.rows, tableToolBarProps = _b.tableToolBarProps, columns = _b.columns, bulkActions = _b.bulkActions, rowCount = _b.rowCount, rowsPerPageOptions = _b.rowsPerPageOptions, disableBulkActions = _b.disableBulkActions, onRowSelect = _b.onRowSelect, showCheckbox = _b.showCheckbox, disableSelectAll = _b.disableSelectAll, disablePagination = _b.disablePagination, loading = _b.loading, _c = _b.className, className = _c === void 0 ? exports.TableContainerClass.DAI_TABLE : _c;
        var sortedRows = this.props.onSortChange
            ? rows
            : TableHelpers.stableSort(rows, 
            // @ts-ignore
            TableHelpers.getComparator(order, orderBy));
        return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
            React__default["default"].createElement(Paper__default["default"], { sx: { width: '100%' }, elevation: 0 },
                tableToolBarProps && React__default["default"].createElement(TableToolbar, __assign$l({}, tableToolBarProps)),
                React__default["default"].createElement(TableContainer__default["default"], { className: className },
                    React__default["default"].createElement(Table__default["default"], { stickyHeader: true, "aria-labelledby": "tableTitle", size: 'medium', "aria-label": "enhanced table" },
                        React__default["default"].createElement(DAITableHeader, { showCheckbox: !!bulkActions || showCheckbox || false, numSelected: selected.length, disableSelectAll: disableSelectAll, order: order, orderBy: orderBy, onSelectAllClick: this.handleSelectAllClick, onRequestSort: this.handleRequestSort, disabledSortColumns: columns
                                .filter(function (col) { return col.disableSort; })
                                .map(function (col) { return col.field; }), rowCount: rows.length, columns: columns, sxCell: this.props.sxHeaderCell }),
                        React__default["default"].createElement(DAITableBody, { loading: loading, columns: columns, sortedRows: sortedRows, tableState: this.state, handleClick: this.handleClick, onRowSelect: onRowSelect, showCheckbox: !!(bulkActions && bulkActions.length) || !!showCheckbox, selected: selected }))),
                !disablePagination && (React__default["default"].createElement(TablePagination__default["default"], { component: "div", rowsPerPageOptions: rowsPerPageOptions || [
                        MuiTheme.sizes.table.page.xs,
                        MuiTheme.sizes.table.page.sm,
                        MuiTheme.sizes.table.page.md,
                    ], count: rowCount || rows.length, rowsPerPage: rowsPerPage, page: page, onPageChange: this.handleChangePage, onRowsPerPageChange: this.handleChangeRowsPerPage })),
                !!bulkActions && selected.length > 0 && !disableBulkActions && (React__default["default"].createElement(ActionBar, { count: selected.length, bulkActions: bulkActions })))));
    };
    return DAITable;
}(React__default["default"].Component));

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PicOSComplianceTableReport = function (props) {
    var title = props.title, titleComponent = props.titleComponent, onSearch = props.onSearch, onClickExportCsv = props.onClickExportCsv, statItems = props.statItems, loadingStats = props.loadingStats, loadingComplianceItems = props.loadingComplianceItems, rows = props.rows, columns = props.columns;
    var columnDetails = columns.map(function (col) { return (__assign$l(__assign$l({}, col), { disableSort: true })); });
    return (React__default["default"].createElement(ReportContainerLayout, { Header: React__default["default"].createElement(PicOSReportHeader, null), Summary: React__default["default"].createElement(CollapsibleReportStats, { title: title, subtitle: "Overview Summary", items: statItems, loading: loadingStats }), Body: React__default["default"].createElement(PicOSReportBody, { title: title, titleComponent: titleComponent, onSearch: onSearch, onClickExportCsv: onClickExportCsv }, !rows.length && !loadingComplianceItems ? (React__default["default"].createElement(EmptyResults, null)) : (React__default["default"].createElement(DAITable, { rows: rows, columns: columnDetails, loading: loadingComplianceItems, sxHeaderCell: function (theme) { return ({
                backgroundColor: "".concat(theme.palette.background.default, " !important"),
                color: "".concat(theme.palette.primary.dark, " !important"),
            }); } }))) }));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var PicOSComplianceDataGridReport = function (props) {
    var title = props.title, titleComponent = props.titleComponent, onSelect = props.onSelect, onSearch = props.onSearch, statItems = props.statItems, loadingStats = props.loadingStats, loadingComplianceItems = props.loadingComplianceItems, rows = props.rows, columns = props.columns, pageSize = props.pageSize, onPageChange = props.onPageChange, rowHeight = props.rowHeight;
    return (React__default["default"].createElement(ReportContainerLayout, { Header: React__default["default"].createElement(PicOSReportHeader, null), Summary: React__default["default"].createElement(CollapsibleReportStats, { title: title, subtitle: "Overview Summary", items: statItems, loading: loadingStats }), Body: React__default["default"].createElement(PicOSReportBody, { title: title, titleComponent: titleComponent, onSearch: onSearch, onClickExportCsv: function () { return null; } }, !rows.length && !loadingComplianceItems ? (React__default["default"].createElement(EmptyResults, null)) : (React__default["default"].createElement(material.Box, { height: 700, width: '100%' },
            React__default["default"].createElement(xDataGrid.DataGrid, { columns: columns, rows: rows, pageSize: pageSize, rowHeight: rowHeight, disableVirtualization: true, onPageChange: onPageChange, onCellClick: onSelect })))) }));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
function useCommonFilter(defaultFilter) {
    var _a = React.useState(defaultFilter), filter = _a[0], setFilter = _a[1];
    var handleUpdateFilter = function (sectionTitle, selected, label) {
        var _a, _b;
        var _c, _d;
        if (label) {
            var sectionTitledTyped = sectionTitle;
            var stringOptions = FilterHelpers.stringOptionsTyped(((_c = filter[sectionTitledTyped]) === null || _c === void 0 ? void 0 : _c.options) || ['']);
            var options = FilterHelpers.subOptionsTyped(((_d = filter[sectionTitledTyped]) === null || _d === void 0 ? void 0 : _d.options) || ['']);
            var selectedOption = options.find(function (opt) { return opt.label === label; });
            setFilter(__assign$l(__assign$l({}, filter), (_a = {}, _a[sectionTitle] = __assign$l(__assign$l({}, filter[sectionTitle]), { options: __spreadArray$5(__spreadArray$5(__spreadArray$5([], stringOptions, true), options.filter(function (opt) { return opt.label !== label; }), true), [
                    __assign$l(__assign$l({}, selectedOption), { selected: selected }),
                ], false) }), _a)));
        }
        else {
            setFilter(__assign$l(__assign$l({}, filter), (_b = {}, _b[sectionTitle] = __assign$l(__assign$l({}, filter[sectionTitle]), { selected: selected }), _b)));
        }
    };
    var updateDateOptions = function (dateSectionTitle, newDate) {
        var _a;
        var _b;
        setFilter(__assign$l(__assign$l({}, filter), { filterBy: __assign$l(__assign$l({}, filter.filterBy), { dateOptions: __assign$l(__assign$l({}, (_b = filter.filterBy) === null || _b === void 0 ? void 0 : _b.dateOptions), (_a = {}, _a[dateSectionTitle] = newDate, _a)) }) }));
    };
    var filterHasDateRangeSet = function () {
        var _a, _b, _c, _d;
        return ((_b = (_a = filter.filterBy) === null || _a === void 0 ? void 0 : _a.dateOptions) === null || _b === void 0 ? void 0 : _b.startDate) &&
            ((_d = (_c = filter.filterBy) === null || _c === void 0 ? void 0 : _c.dateOptions) === null || _d === void 0 ? void 0 : _d.endDate);
    };
    var handleToggleExpanded = function (sectionTitle, label, expanded) {
        var _a;
        var _b, _c;
        var sectionTitledTyped = sectionTitle;
        var stringOptions = FilterHelpers.stringOptionsTyped(((_b = filter[sectionTitledTyped]) === null || _b === void 0 ? void 0 : _b.options) || ['']);
        var options = FilterHelpers.subOptionsTyped(((_c = filter[sectionTitledTyped]) === null || _c === void 0 ? void 0 : _c.options) || ['']);
        var selectedOption = options.find(function (opt) { return opt.label === label; });
        setFilter(__assign$l(__assign$l({}, filter), (_a = {}, _a[sectionTitle] = __assign$l(__assign$l({}, filter[sectionTitle]), { options: __spreadArray$5(__spreadArray$5(__spreadArray$5([], stringOptions, true), options
                .filter(function (opt) { return opt.label !== label; })
                .map(function (opt) { return (__assign$l(__assign$l({}, opt), { expanded: false })); }), true), [
                __assign$l(__assign$l({}, selectedOption), { expanded: expanded, searchTerm: !expanded ? undefined : selectedOption.searchTerm }),
            ], false) }), _a)));
    };
    var handleSearchTermUpdate = function (sectionTitle, label, searchTerm) {
        var _a;
        var _b, _c;
        var sectionTitledTyped = sectionTitle;
        var stringOptions = FilterHelpers.stringOptionsTyped(((_b = filter[sectionTitledTyped]) === null || _b === void 0 ? void 0 : _b.options) || ['']);
        var options = FilterHelpers.subOptionsTyped(((_c = filter[sectionTitledTyped]) === null || _c === void 0 ? void 0 : _c.options) || ['']);
        var selectedOption = options.find(function (opt) { return opt.label === label; });
        setFilter(__assign$l(__assign$l({}, filter), (_a = {}, _a[sectionTitle] = __assign$l(__assign$l({}, filter[sectionTitle]), { options: __spreadArray$5(__spreadArray$5(__spreadArray$5([], stringOptions, true), options.filter(function (opt) { return opt.label !== label; }), true), [
                __assign$l(__assign$l({}, selectedOption), { searchTerm: searchTerm, expanded: true }),
            ], false) }), _a)));
    };
    var handleSetSubOptions = function (subOptions, label) {
        var _a, _b;
        var stringOptions = FilterHelpers.stringOptionsTyped(((_a = filter.filterBy) === null || _a === void 0 ? void 0 : _a.options) || ['']);
        var options = FilterHelpers.subOptionsTyped(((_b = filter === null || filter === void 0 ? void 0 : filter.filterBy) === null || _b === void 0 ? void 0 : _b.options) || ['']);
        var selectedOption = options.find(function (opt) { return opt.label === label; });
        setFilter(__assign$l(__assign$l({}, filter), { filterBy: __assign$l(__assign$l({}, filter.filterBy), { options: __spreadArray$5(__spreadArray$5(__spreadArray$5([], stringOptions, true), options.filter(function (opt) { return opt.label !== label; }), true), [
                    __assign$l(__assign$l({}, selectedOption), { subOptions: subOptions }),
                ], false) }) }));
    };
    var numberOfItemsSelected = filter.filterBy
        ? filter.filterBy.selected.length +
            filter.filterBy.options.filter(function (opt) { return typeof opt !== 'string'; }).reduce(function (sum, curr) { return sum + curr.selected.length; }, 0)
        : 0;
    return {
        filter: filter,
        handleUpdateFilter: handleUpdateFilter,
        handleToggleExpanded: handleToggleExpanded,
        handleSearchTermUpdate: handleSearchTermUpdate,
        updateDateOptions: updateDateOptions,
        numberOfItemsSelected: numberOfItemsSelected,
        handleSetSubOptions: handleSetSubOptions,
        setFilter: setFilter,
        filterHasDateRangeSet: filterHasDateRangeSet,
    };
}

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var useStepper = function (steps) {
    var _a = React.useState(0), activeStep = _a[0], setActiveStep = _a[1];
    var _b = React.useState({}), completed = _b[0], setCompleted = _b[1];
    var totalSteps = steps.length;
    var completedSteps = Object.keys(completed).length;
    var isLastStep = activeStep === totalSteps - 1;
    var allStepsCompleted = completedSteps === totalSteps;
    var handleNext = function () {
        var newActiveStep = isLastStep && !allStepsCompleted
            ? // It's the last step, but not all steps have been completed,
                // find the first step that has been completed
                steps.findIndex(function (step, i) { return !(i in completed); })
            : activeStep + 1;
        setActiveStep(newActiveStep);
    };
    var handleBack = function () { return setActiveStep(function (prevActiveStep) { return prevActiveStep - 1; }); };
    var handleStep = function (step) { return function () { return setActiveStep(step); }; };
    var handleComplete = function () {
        var newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted(newCompleted);
        handleNext();
    };
    var handleReset = function () {
        setActiveStep(0);
        setCompleted({});
    };
    return {
        state: {
            activeStep: activeStep,
            setActiveStep: setActiveStep,
            completed: completed,
            setCompleted: setCompleted,
        },
        handle: {
            handleNext: handleNext,
            handleBack: handleBack,
            handleStep: handleStep,
            handleComplete: handleComplete,
            handleReset: handleReset,
        },
        data: {
            totalSteps: totalSteps,
            completedSteps: completedSteps,
            isLastStep: isLastStep,
            allStepsCompleted: allStepsCompleted,
        },
    };
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var DEFAULT_OFFSET = 0;
var DEFAULT_PAGE = 20;
var DEFAULT_LIMIT = 20;
var PaginationConstants = {
    DEFAULT_LIMIT: DEFAULT_LIMIT,
    DEFAULT_OFFSET: DEFAULT_OFFSET,
    DEFAULT_PAGE: DEFAULT_PAGE,
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var usePagination = function (_a) {
    var _b = _a === void 0 ? {
        pageSize: PaginationConstants.DEFAULT_PAGE,
    } : _a, pageSize = _b.pageSize;
    var _c = React.useState(pageSize), limit = _c[0], setLimit = _c[1];
    var _d = React.useState(PaginationConstants.DEFAULT_OFFSET), offset = _d[0], setOffset = _d[1];
    var currentPage = Math.floor(offset / pageSize) + 1;
    var nextPage = function () { return setOffset(offset + pageSize); };
    var previousPage = function () { return setOffset(offset - pageSize); };
    var returnToStart = function () { return setOffset(0); };
    var goToPage = function (page) { return setOffset((page - 1) * pageSize); };
    return {
        limit: limit,
        setLimit: setLimit,
        offset: offset,
        setOffset: setOffset,
        currentPage: currentPage,
        handleOffset: {
            nextPage: nextPage,
            previousPage: previousPage,
            returnToStart: returnToStart,
            goToPage: goToPage,
        },
    };
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var useDebouncedItemQuery = function (_a) {
    var queryStr = _a.queryStr, options = _a.options, debounceDelay = _a.debounceDelay, queryOnMount = _a.queryOnMount, paginationPageSize = _a.paginationPageSize;
    var _b = React.useState(''), itemQuery = _b[0], setItemQuery = _b[1];
    var debouncedQuery = o(itemQuery, debounceDelay || 500)[0];
    var Pagination = paginationPageSize
        ? usePagination({ pageSize: paginationPageSize })
        : usePagination();
    var _c = useLazyQuery(queryStr, options), query = _c[0], meta = _c[1];
    React.useEffect(function () {
        if (queryOnMount && options.variables) {
            query({
                variables: options.variables,
            });
        }
    }, []);
    return {
        itemQuery: itemQuery,
        setItemQuery: setItemQuery,
        debouncedQuery: debouncedQuery,
        Pagination: Pagination,
        lazyQuery: {
            query: query,
            meta: meta,
        },
    };
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var useInfiniteScrollAndSearch = function (_a) {
    var LazyQuery = _a.LazyQuery, QueryVariables = _a.QueryVariables, _b = _a.resetQueryDependencies, resetQueryDependencies = _b === void 0 ? [] : _b, queryResponse = _a.queryResponse;
    var _c = React.useState([]), itemsCache = _c[0], setItemsCache = _c[1];
    // query with offset fn
    var query = function (offset) {
        var variables = QueryVariables;
        if (offset !== undefined) {
            if ('offset' in variables) {
                // @ts-ignore
                variables.offset = offset;
                // @ts-ignore
            }
            else if ('input' in variables && 'offset' in variables.input) {
                // @ts-ignore
                variables.input.offset = offset;
            }
        }
        LazyQuery.lazyQuery.query({ variables: variables });
    };
    // Effect that resets offset and cache, and runs query
    React.useEffect(function () {
        LazyQuery.Pagination.setOffset(0);
        setItemsCache([]);
        query(0);
    }, __spreadArray$5([LazyQuery.debouncedQuery], resetQueryDependencies, true));
    // Effect that runs query with dependency on offset
    React.useEffect(function () {
        if (LazyQuery.Pagination.offset) {
            query();
        }
    }, [LazyQuery.Pagination.offset]);
    // Append to cache with new results
    React.useEffect(function () {
        if (!LazyQuery.lazyQuery.meta.loading && queryResponse.length) {
            setItemsCache(__spreadArray$5(__spreadArray$5([], itemsCache, true), queryResponse, true));
        }
    }, [LazyQuery.lazyQuery.meta.loading, queryResponse.length]);
    return {
        itemsCache: itemsCache,
        setItemsCache: setItemsCache,
        query: query,
    };
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var useMuiForm = function (_a) {
    var formState = _a.formState, setFormState = _a.setFormState;
    var handleOnChange = function (key, id, event) {
        var _a, _b;
        if (!setFormState) {
            return;
        }
        var _c = key === 'text' && formState[key][id].validationFn
            ? formState[key][id].validationFn(event.target.value)
            : { error: false, help: formState[key][id].help }, error = _c.error, help = _c.help;
        setFormState(__assign$l(__assign$l({}, formState), (_a = {}, _a[key] = __assign$l(__assign$l({}, formState[key]), (_b = {}, _b[id] = __assign$l(__assign$l({}, formState[key][id]), { value: event.target.value, help: help, error: error }), _b)), _a)));
    };
    var formHasError = Object.values(formState || {}).reduce(function (hasError, curr) {
        return hasError ||
            Object.values(curr).reduce(function (keyHasError, _curr) { return keyHasError || _curr.error; }, false);
    }, false);
    var requiredItemNotCompleted = formState
        ? Object.values(formState).reduce(function (required, formType) {
            return required ||
                Object.values(formType).reduce(function (fieldRequired, state) {
                    return fieldRequired ||
                        (!!state.required &&
                            state.required &&
                            (!state.value ||
                                (Array.isArray(state.value) && !state.value.length))) ||
                        (!!state.input && state.input.required && !state.value);
                }, false);
        }, false)
        : false;
    var hasSomeItemCompleted = formState
        ? Object.values(formState).reduce(function (completed, formType) {
            return completed ||
                Object.values(formType).reduce(function (fieldCompleted, state) {
                    if (!state.value) {
                        return fieldCompleted;
                    }
                    if (typeof state.value === 'string') {
                        return fieldCompleted || !StringHelpers.isNullOrEmpty(state.value);
                    }
                    return (fieldCompleted ||
                        !!state.value ||
                        (Array.isArray(state.value) && !!state.value.length));
                }, false);
        }, false)
        : false;
    return {
        handle: {
            handleOnChange: handleOnChange,
        },
        data: {
            canSubmit: !formHasError && !requiredItemNotCompleted,
            hasSomeItemCompleted: hasSomeItemCompleted,
        },
    };
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var useNotificationState = function () {
    var _a = React.useState(), mutationSuccess = _a[0], setMutationSuccess = _a[1];
    var _b = React.useState(), mutationError = _b[0], setMutationError = _b[1];
    return {
        success: mutationSuccess,
        error: mutationError,
        setSuccess: setMutationSuccess,
        setError: setMutationError,
    };
};

/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Clark Sandholtz <clark.sandholtz@deliciousai.com>
 */
var createInputFromBoundingBoxes = function (boxes, forcedUpdatedBoxes) {
    if (forcedUpdatedBoxes === void 0) { forcedUpdatedBoxes = []; }
    return {
        objects: boxes
            .filter(function (box) {
            return box.verifiedLocation !== lib$4.VerifiedLocation.FIELD &&
                box.verifiedLocation !== lib$4.VerifiedLocation.FIELD_AND_WHTE_RBT;
        })
            .concat(forcedUpdatedBoxes)
            .map(function (box) { return ({
            id: box.id,
            elDoradoProductId: box.elDoradoProductId,
            label: box.label,
            confidence: box.confidence,
            coordinates: {
                minX: box.minX,
                maxX: box.maxX,
                minY: box.minY,
                maxY: box.maxY,
            },
        }); }),
    };
};
var transformBoundingBoxes = function (boxes) {
    // @ts-ignore
    return boxes.boundingBoxes.map(function (box) { return ({
        id: box.id,
        label: box.label,
        product: null,
        elDoradoProductId: box.elDoradoId || undefined,
        confidence: box.confidence,
        minX: box.coordinates.minX,
        minY: box.coordinates.minY,
        maxX: box.coordinates.maxX,
        maxY: box.coordinates.maxY,
        verifiedLocation: box.verifiedLocation || undefined,
    }); });
};
var allBoxesMappedToElDoradoProduct = function (boxes, knownProducts) {
    return boxes.every(function (box) {
        return knownProducts.some(function (p) { return box.elDoradoProductId === p.id; });
    });
};
var unknownProductBoxes = function (boxes, knownProducts) {
    return boxes.reduce(function (boxes, box) {
        return !knownProducts.some(function (product) { return product.id === box.elDoradoProductId; })
            ? __spreadArray$5(__spreadArray$5([], boxes, true), [box], false) : boxes;
    }, []);
};
var getDescriptionFromProducts = function (products, productId) {
    var product = products.find(function (p) { return p.id === productId; });
    return product ? product.description : '';
};
var getImageUrlFromProducts = function (products, productId) {
    var product = products.find(function (p) { return p.id === productId; });
    return product ? product.marketingImageUrl : undefined;
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FillContainerLoading = function (props) { return (React__default["default"].createElement(Grid__default["default"], __assign$l({ container: true }, FILL_GRID_ALL_SCREENS, { justifyContent: 'center', alignItems: 'center', flexDirection: 'column', minHeight: props.minHeight || '100%' }),
    props.Above ? props.Above : null,
    React__default["default"].createElement(material.CircularProgress, { size: props.progressSize || 75 }),
    props.Below ? props.Below : null)); };

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var formatGroups = function (user) {
    if (user.isSuperuser) {
        return 'DeliciousAI Superuser';
    }
    return user.roles
        .map(function (role) {
        return StringHelpers.titleCase(StringHelpers.stringValue(role.toLowerCase()));
    })
        .join(', ');
};
var formatName = function (_a) {
    var user = _a.user, options = _a.options;
    if (options === null || options === void 0 ? void 0 : options.trimFirst)
        return "".concat(user.firstName[0], ". ").concat(user.lastName);
    if (options === null || options === void 0 ? void 0 : options.trimLast)
        return "".concat(user.firstName, " ").concat(user.lastName[0], ".");
    return "".concat(user.firstName, " ").concat(user.lastName);
};
var UserHelpers = {
    formatGroups: formatGroups,
    formatName: formatName,
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var openedMixin = function (theme) { return ({
    width: theme.navigation.drawer.width.open,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
}); };
var closedMixin = function (theme) { return ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.navigation.drawer.width.closed,
}); };
var WebDrawerContainer = styled(MuiDrawer__default["default"], {
    shouldForwardProp: function (prop) { return prop !== 'open'; },
})(function (_a) {
    var theme = _a.theme, open = _a.open;
    return (__assign$l(__assign$l({ flexShrink: 0, whiteSpace: 'nowrap', boxSizing: 'border-box' }, (open && __assign$l(__assign$l({}, openedMixin(theme)), { '& .MuiDrawer-paper': openedMixin(theme) }))), (!open && __assign$l(__assign$l({}, closedMixin(theme)), { '& .MuiDrawer-paper': closedMixin(theme) }))));
});
var StyledList = styled(List__default["default"])(function () { return ({
    '&& .Mui-selected, && .Mui-selected:hover': {
        backgroundColor: '#7b0006',
    },
    '& .MuiListItemButton-root:hover': {
        backgroundColor: '#a1464a',
    },
}); });
var NavigationDrawer = function (props) {
    var user = props.user, navItemsBeforeFilter = props.navItems, children = props.children, logout = props.logout;
    var navItemsBeforeMoreFilter = navItemsBeforeFilter.filter(function (n) { return !n.hide; });
    var navItems = navItemsBeforeMoreFilter.map(function (n) {
        return n.more ? __assign$l(__assign$l({}, n), { more: n.more.filter(function (m) { return !m.hide; }) }) : n;
    });
    var _a = React__namespace.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = React__namespace.useState(navItems[0].route), selectedRoute = _b[0], setSelectedRoute = _b[1];
    var location = reactRouterDom.useLocation();
    var _c = React__namespace.useState({}), moreOptionsOpenMap = _c[0], setMoreOptionsOpenMore = _c[1];
    var history = reactRouterDom.useHistory();
    React__namespace.useEffect(function () {
        var prevRoute = history.location.pathname.indexOf('/') === 0
            ? history.location.pathname.slice(1)
            : history.location.pathname;
        var prevPage = navItems.reduce(function (prev, navItem) {
            return prev ||
                (prevRoute === navItem.route.toLowerCase()
                    ? navItem.route
                    : navItem.more
                        ? navItem.more.some(function (moreOpt) { return moreOpt.route.toLowerCase() === prevRoute; })
                            ? navItem.route
                            : ''
                        : '');
        }, '');
        setSelectedRoute(prevPage);
    }, []);
    var renderNavItemMobile = function (item) {
        var _a;
        return (React__namespace.createElement("div", { key: "mobile-div-".concat(item.route) },
            React__namespace.createElement(reactRouterDom.NavLink, { to: "/".concat(item.route.toLowerCase()), key: item.route, onClick: function (event) {
                    return item.more && item.more.length ? event.preventDefault() : null;
                } },
                React__namespace.createElement(ListItem__default["default"], { disablePadding: true, key: item.route },
                    React__namespace.createElement(ListItemButton__default["default"], { onClick: function () {
                            var _a;
                            setMoreOptionsOpenMore(__assign$l(__assign$l({}, moreOptionsOpenMap), (_a = {}, _a[item.route] = !moreOptionsOpenMap[item.route], _a)));
                            if (!item.more) {
                                setSelectedRoute(item.route);
                                setIsOpen(false);
                            }
                        }, selected: selectedRoute === item.route.toLowerCase() },
                        React__namespace.createElement(ListItemIcon__default["default"], null, item.icon),
                        React__namespace.createElement(ListItemText__default["default"], { primary: item.label, className: exports.ThemeVariantsEnum.LIGHT }),
                        !((_a = item.more) === null || _a === void 0 ? void 0 : _a.length) ? null : moreOptionsOpenMap[item.route] ? (React__namespace.createElement(ExpandLess__default["default"], { color: "secondary" })) : (React__namespace.createElement(ExpandMore__default["default"], { color: "secondary" }))))),
            item.more && (React__namespace.createElement(material.Collapse, { in: moreOptionsOpenMap[item.route], unmountOnExit: true },
                React__namespace.createElement(List__default["default"], { component: "div", disablePadding: true }, item.more.map(function (mr) { return (React__namespace.createElement(reactRouterDom.NavLink, { to: "/".concat(mr.route.toLowerCase()), key: mr.route },
                    React__namespace.createElement(ListItemButton__default["default"], { sx: { pl: 4 }, selected: selectedRoute === mr.route, onClick: function () {
                            setSelectedRoute(mr.route);
                            setIsOpen(false);
                        } },
                        React__namespace.createElement(ListItemIcon__default["default"], null, mr.icon),
                        React__namespace.createElement(ListItemText__default["default"], { primary: mr.label, className: exports.ThemeVariantsEnum.LIGHT })))); }))))));
    };
    var renderNavItemLarge = function (item) { return (React__namespace.createElement(reactRouterDom.NavLink, { to: "/".concat(item.route.toLowerCase()), key: item.route },
        React__namespace.createElement(ListItem__default["default"], { disablePadding: true },
            React__namespace.createElement(ListItemButton__default["default"], { selected: selectedRoute === item.route, onClick: function () { return setSelectedRoute(item.route); } },
                React__namespace.createElement(ListItemIcon__default["default"], null, item.icon),
                React__namespace.createElement(ListItemText__default["default"], { primary: item.label, className: exports.ThemeVariantsEnum.LIGHT }))))); };
    var handleDrawerToggle = function () {
        setIsOpen(!isOpen);
    };
    if (!user) {
        return (React__namespace.createElement(styles.ThemeProvider, { theme: MuiTheme },
            React__namespace.createElement(FillContainerLoading, { minHeight: '100vh' })));
    }
    var DrawerContents = function (renderNavItem) { return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(Box__default["default"], { flex: 1 },
            React__namespace.createElement(Divider__default["default"], { color: MuiTheme.palette.secondary.light }),
            React__namespace.createElement(ScreenController.LargeScreen, null,
                React__namespace.createElement(Toolbar__default["default"], null)),
            React__namespace.createElement(StyledList, null, navItems.map(renderNavItem))),
        React__namespace.createElement(Box__default["default"], null,
            React__namespace.createElement(Box__default["default"], null,
                React__namespace.createElement(AvatarWithText, { ListItemSx: { paddingLeft: 1 }, ListItemAvatarSx: { marginRight: 1 }, avatarColor: MuiTheme.palette.secondary.light, textColor: exports.ThemeVariantsEnum.LIGHT, primaryText: "".concat(user.firstName, " ").concat(user.lastName), secondaryText: UserHelpers.formatGroups(user) },
                    user.firstName[0],
                    user.lastName[0]),
                React__namespace.createElement(ListItemButton__default["default"], { onClick: logout },
                    React__namespace.createElement(ListItemIcon__default["default"], null,
                        React__namespace.createElement(LogoutIcon__default["default"], { color: "secondary" })),
                    React__namespace.createElement(ListItemText__default["default"], { primary: 'Logout', className: exports.ThemeVariantsEnum.LIGHT }))),
            React__namespace.createElement(Divider__default["default"], { color: MuiTheme.palette.secondary.light }),
            isOpen ? (React__namespace.createElement(FlexBox.RowRight, { sx: MuiTheme.mixins.toolbar },
                React__namespace.createElement(IconButton__default["default"], { onClick: handleDrawerToggle },
                    React__namespace.createElement(ChevronLeftIcon__default["default"], { color: "secondary" })))) : (React__namespace.createElement(FlexBox.RowCenter, { sx: MuiTheme.mixins.toolbar },
                React__namespace.createElement(IconButton__default["default"], { onClick: handleDrawerToggle },
                    React__namespace.createElement(ChevronRightIcon__default["default"], { color: "secondary" }))))))); };
    var breadcrumbs = location.pathname
        .split('/')
        .filter(function (path) { return path.length && !StringHelpers.isUUID(path); });
    return (React__namespace.createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__namespace.createElement(Box__default["default"], { sx: { display: { sm: 'flex', xs: 'block' } } },
            React__namespace.createElement(CssBaseline__default["default"], null),
            React__namespace.createElement(AppBar__default["default"], { position: "fixed", color: "secondary" },
                React__namespace.createElement(ScreenController.Mobile, null,
                    React__namespace.createElement(FlexBox.RowBetween, { sx: MuiTheme.mixins.toolbar, flexGrow: 1, paddingLeft: 2, paddingRight: 2 },
                        React__namespace.createElement(IconButton__default["default"], { edge: "start", onClick: handleDrawerToggle, sx: { mr: MuiTheme.spacing(1) } },
                            React__namespace.createElement(MenuIcon__default["default"], { color: "secondary" })),
                        React__namespace.createElement(Breadcrumbs__default["default"], { separator: React__namespace.createElement(NavigateNextIcon__default["default"], { fontSize: "small", color: "secondary" }) }, breadcrumbs.map(function (route, index) { return (React__namespace.createElement(Typography__default["default"], { key: "breadcrumb-".concat(index), color: MuiTheme.palette.primary.light, fontWeight: index === breadcrumbs.length - 1
                                ? MuiTheme.typography.fontWeightBold
                                : undefined }, StringHelpers.titleCase(route))); }))))),
            React__namespace.createElement(Box__default["default"], { component: "nav", sx: { flexShrink: { sm: 0 } } },
                React__namespace.createElement(MuiDrawer__default["default"], { container: function () { return window.document.body; }, variant: "temporary", open: isOpen, onClose: handleDrawerToggle, ModalProps: {
                        keepMounted: true,
                    }, PaperProps: {
                        sx: { backgroundColor: MuiTheme.palette.secondary.main },
                    }, sx: {
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: MuiTheme.navigation.drawer.width.open,
                        },
                    } },
                    React__namespace.createElement(FlexBox.ColCenter, { sx: MuiTheme.mixins.toolbar },
                        React__namespace.createElement("img", { src: '/logo-white.svg', style: { height: 24 } })),
                    DrawerContents(renderNavItemMobile)),
                React__namespace.createElement(WebDrawerContainer, { variant: "permanent", open: isOpen, sx: {
                        display: { xs: 'none', sm: 'block' },
                    }, PaperProps: {
                        sx: { backgroundColor: MuiTheme.palette.secondary.main },
                    } },
                    React__namespace.createElement(FlexBox.ColCenter, { sx: MuiTheme.mixins.toolbar },
                        React__namespace.createElement("img", { src: isOpen ? '/logo-white.svg' : '/logo-white-mini.svg', style: { height: MuiTheme.sizes.icon.sm.height } })),
                    DrawerContents(renderNavItemLarge))),
            React__namespace.createElement(Box__default["default"], { component: "main", sx: { flexGrow: 1, height: '100vh', overflowY: 'scroll' } },
                React__namespace.createElement(ScreenController.Mobile, null,
                    React__namespace.createElement(Toolbar__default["default"], null)),
                React__namespace.createElement(NavigationDrawerContext.Provider, { value: {
                        isOpen: isOpen,
                        setIsOpen: setIsOpen,
                    } }, children)))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var LinkTab = function (props) {
    var theme = styles.useTheme();
    return (React__default["default"].createElement(reactRouterDom.NavLink, { to: props.href, style: { color: theme.palette.secondary.main } },
        React__default["default"].createElement(material.Tab, { label: props.label, disableRipple: true, onClick: props.onClick })));
};
var NavigationTabs = function (props) {
    var location = reactRouterDom.useLocation();
    var links = props.tabs.map(function (rt) { return rt.ext; });
    var screen = links.indexOf(links.find(function (li) { return location.pathname.includes(li); }));
    return (React__default["default"].createElement(material.Tabs, { value: screen }, props.tabs.map(function (route) { return (React__default["default"].createElement(LinkTab, { key: "navigation-tab-key-".concat(route.label), label: route.label, href: "/".concat(props.routeBase, "/").concat(route.ext), onClick: route.onClick })); })));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FullScreenLayout = function (props) {
    var header = props.header, body = props.body, bodyStyle = props.bodyStyle;
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__default["default"].createElement(FlexBox.Col, { height: '100%' },
            header,
            React__default["default"].createElement(FlexBox.Col, { height: '100%', sx: function (theme) { return (__assign$l({ p: theme.spacing(2) }, bodyStyle)); } }, body))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ModalTitle = function (props) {
    var children = props.children, onClose = props.onClose, other = __rest$c(props, ["children", "onClose"]);
    return (React__namespace.createElement(DialogTitle__default["default"], __assign$l({ sx: function (theme) { return ({ m: 0, p: theme.spacing(2) }); } }, other),
        children,
        onClose ? (React__namespace.createElement(IconButton__default["default"], { "aria-label": "close", onClick: onClose, sx: function (theme) { return ({
                position: 'absolute',
                right: theme.spacing(1),
                top: theme.spacing(1),
                color: theme.palette.secondary.main,
            }); } },
            React__namespace.createElement(CloseIcon__default["default"], null))) : null));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var BootstrapDialog = styles.styled(Dialog__default["default"])(function (_a) {
    var _b;
    var theme = _a.theme, sx = _a.sx;
    return ({
        '& .MuiDialogContent-root': __assign$l({ padding: theme.spacing(2) }, sx),
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
        '& .MuiPaper-root': (_b = {},
            _b[theme.breakpoints.only('xs')] = {
                minWidth: "calc(100% - ".concat(theme.spacing(4), ")"),
            },
            _b[theme.breakpoints.up('sm')] = {
                minWidth: theme.sizes.modal.lg,
            },
            _b),
    });
});
var MuiFormModal = function (props) {
    var title = props.title, subtitle = props.subtitle, isOpen = props.isOpen, handleClose = props.handleClose, actionButtonsProps = props.actionButtonsProps, otherButtonsProps = props.otherButtonsProps, modalContent = props.children, sx = props.sx;
    var theme = material.useTheme();
    return (React__namespace.createElement(BootstrapDialog, { onClose: handleClose, "aria-labelledby": "customized-dialog-title", open: isOpen, sx: sx },
        React__namespace.createElement(ModalTitle, { id: "customized-dialog-title", onClose: handleClose },
            React__namespace.createElement(Typography__default["default"], { variant: "h5" }, title),
            React__namespace.createElement(Typography__default["default"], { variant: "h6", sx: function (theme) {
                    var _a;
                    return (_a = {},
                        _a[theme.breakpoints.only('xs')] = {
                            fontSize: 16,
                        },
                        _a);
                } }, subtitle)),
        React__namespace.createElement(DialogContent__default["default"], { dividers: true, sx: { display: 'flex', flexDirection: 'column', gap: theme.spacing(2) } },
            React__namespace.createElement(material.Box, null, modalContent),
            otherButtonsProps && otherButtonsProps.length && (React__namespace.createElement(material.ButtonGroup, null, otherButtonsProps
                .filter(function (buttonProps) { return !buttonProps.hide; })
                .map(function (buttonProps) { return (React__namespace.createElement(Button__default["default"], __assign$l({ key: "modal-button-".concat(buttonProps.children) }, buttonProps, { variant: buttonProps.variant || 'contained', disableElevation: true }))); })))),
        !!actionButtonsProps.length && (React__namespace.createElement(DialogActions__default["default"], null,
            React__namespace.createElement(material.ButtonGroup, null, actionButtonsProps
                .filter(function (buttonProps) { return !buttonProps.hide; })
                .map(function (buttonProps) { return (React__namespace.createElement(Button__default["default"], __assign$l({ key: "modal-button-".concat(buttonProps.children) }, buttonProps, { variant: buttonProps.variant || 'contained', disableElevation: true }))); }))))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ImageCarousel = function (props) {
    var _a;
    var title = props.title, formTitle = props.formTitle, images = props.images, buttons = props.buttons, primaryImageUri = props.primaryImageUri, loading = props.loading, _b = props.enableDelete, enableDelete = _b === void 0 ? false : _b, enableUpload = props.enableUpload, _c = props.transparentImageBackground, transparentImageBackground = _c === void 0 ? false : _c, onPinPress = props.onPinPress, onConfirmUploadImage = props.onConfirmUploadImage, onDeleteImage = props.onDeleteImage;
    var _d = React.useState(0), selectedPage = _d[0], setSelectedPage = _d[1];
    var _e = React.useState(false), showDeleteImage = _e[0], setShowDeleteImage = _e[1];
    var _f = React.useState(false), showUploadImage = _f[0], setShowUploadImage = _f[1];
    var _g = React.useState(), newImageFile = _g[0], setNewImageFile = _g[1];
    var selectedImage = images.length ? images[selectedPage].uri : undefined;
    var isDefaultImage = !!images.length && primaryImageUri === ((_a = images[selectedPage]) === null || _a === void 0 ? void 0 : _a.uri);
    var _h = React.useState(null), moreMenuAnchorEl = _h[0], setMoreMenuAnchorEl = _h[1];
    var width = lib$3.useWindowDimensions().width;
    var notificationState = useNotificationState();
    var moreMenuOpen = Boolean(moreMenuAnchorEl);
    var isDesktop = width >= MuiTheme.breakpoints.values.lg;
    var actionsButtons = __spreadArray$5([], buttons, true);
    if (onPinPress) {
        actionsButtons.push({
            tooltip: 'Set the current image as the default',
            icon: React__default["default"].createElement(iconsMaterial.PushPin, null),
            onClick: function () { return onPinPress(images[selectedPage]); },
            gridProps: __assign$l(__assign$l({}, gridAllScreens(1)), { xs: 1.5 }),
            disabled: !images.length,
        });
    }
    if (enableUpload) {
        actionsButtons.push({
            tooltip: 'Upload new image',
            icon: React__default["default"].createElement(iconsMaterial.CloudUpload, null),
            onClick: function () { return setShowUploadImage(true); },
            gridProps: __assign$l(__assign$l({}, gridAllScreens(1)), { xs: 1.5 }),
        });
    }
    if (enableDelete) {
        actionsButtons.push({
            tooltip: 'Delete image',
            icon: React__default["default"].createElement(iconsMaterial.Delete, { color: !selectedImage ? 'disabled' : 'primary' }),
            onClick: function () { return setShowDeleteImage(true); },
            gridProps: __assign$l(__assign$l({}, gridAllScreens(1)), { xs: 1.5 }),
            disabled: !selectedImage,
        });
    }
    var paginatorGridXsSize = 12 -
        (actionsButtons.length && isDesktop
            ? actionsButtons.reduce(function (sum, butt) { return sum + butt.gridProps.xs; }, 0)
            : 1.5);
    var handleMoreMenuClick = function (event) {
        return setMoreMenuAnchorEl(event.currentTarget);
    };
    var handleConfirmDeleteImage = function () { return __awaiter$8(void 0, void 0, void 0, function () {
        var image;
        return __generator$8(this, function (_a) {
            image = images[selectedPage];
            if (image && onDeleteImage) {
                onDeleteImage(image.id);
                setShowDeleteImage(false);
            }
            return [2 /*return*/];
        });
    }); };
    var handleConfirmUploadImage = function () { return __awaiter$8(void 0, void 0, void 0, function () {
        return __generator$8(this, function (_a) {
            if (newImageFile && onConfirmUploadImage) {
                onConfirmUploadImage(newImageFile);
                setShowUploadImage(false);
                setNewImageFile(undefined);
            }
            return [2 /*return*/];
        });
    }); };
    var pngBackgroundRef = React.useRef(null);
    var _j = React.useState('light'), checkerboardMode = _j[0], setCheckerboardMode = _j[1];
    var _k = React.useState(false), checkerboardBackground = _k[0], setCheckerboardBackground = _k[1];
    var _l = React.useState({ width: 0, height: 0 }), dimensions = _l[0], setDimensions = _l[1];
    React.useEffect(function () {
        if (pngBackgroundRef.current) {
            setDimensions({
                width: pngBackgroundRef.current.offsetWidth,
                height: pngBackgroundRef.current.offsetHeight,
            });
        }
    }, [pngBackgroundRef.current]);
    return (React__default["default"].createElement(NotificationContext.Provider, { value: notificationState },
        React__default["default"].createElement(NotificationAlert, null),
        React__default["default"].createElement(material.Card, { sx: { flexGrow: 1 } },
            React__default["default"].createElement(material.CardHeader, { action: loading ? (React__default["default"].createElement(material.Skeleton, { variant: "circular", sx: function (theme) { return ({
                        height: theme.sizes.skeleton.lg,
                        width: theme.sizes.skeleton.lg,
                        mb: "".concat(theme.sizes.skeleton.xs, "px"),
                    }); } })) : isDefaultImage ? (React__default["default"].createElement(material.Avatar, { sx: function (theme) { return ({ bgcolor: theme.palette.success.main }); } },
                    React__default["default"].createElement(iconsMaterial.PushPin, { color: "secondary" }))) : transparentImageBackground ? (React__default["default"].createElement(material.Box, { sx: function (theme) { return ({ gap: theme.spacing(1) }); } },
                    checkerboardBackground && (React__default["default"].createElement(material.IconButton, { onClick: function () {
                            return setCheckerboardMode(function (value) {
                                return value === 'dark' ? 'light' : 'dark';
                            });
                        } }, checkerboardMode === 'dark' ? React__default["default"].createElement(iconsMaterial.LightMode, null) : React__default["default"].createElement(iconsMaterial.DarkMode, null))),
                    React__default["default"].createElement(material.IconButton, { onClick: function () { return setCheckerboardBackground(function (value) { return !value; }); } }, checkerboardBackground ? React__default["default"].createElement(iconsMaterial.GridOff, null) : React__default["default"].createElement(iconsMaterial.GridOn, null)))) : null, title: loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                        height: theme.sizes.skeleton.sm,
                        width: '80%',
                        mb: "".concat(theme.sizes.skeleton.xs, "px"),
                    }); } })) : (title), subheader: loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                        height: theme.sizes.skeleton.sm,
                        width: '40%',
                        mb: "".concat(theme.sizes.skeleton.xs, "px"),
                    }); } })) : null }),
            loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                    height: theme.sizes.img.md,
                    width: '100%',
                    mb: "".concat(theme.sizes.skeleton.xs, "px"),
                }); }, variant: 'rectangular' })) : transparentImageBackground && checkerboardBackground ? (React__default["default"].createElement(material.Grid, { container: true, alignItems: 'center', justifyContent: 'center', direction: "column" },
                React__default["default"].createElement(material.CardMedia, { ref: pngBackgroundRef, component: "img", sx: function (theme) {
                        var width = dimensions.width, height = dimensions.height;
                        var aspectRatio = (width || 1) / (height || 1);
                        var minNumFourSquaresAlongOneEdge = 8;
                        var defaultPercent = 100 / minNumFourSquaresAlongOneEdge;
                        // These are the percent width/height of each four square
                        // if both percents are 50%, there will be a 2x2 of four-squares (4 four-squares) (16 total squares)
                        // if both percents are 10%, there will be a 10x10 of four-squares (100 four-squares) (400 total squares)
                        // each percent should be a factor of 100 (percent * whole number === 100)
                        // (or else there will be a fraction of a square on the edges)
                        var widthPercent = width <= height
                            ? defaultPercent
                            : (1 / aspectRatio) * defaultPercent;
                        var heightPercent = width <= height
                            ? aspectRatio * defaultPercent
                            : defaultPercent;
                        return {
                            objectFit: 'contain',
                            height: theme.sizes.img.md,
                            width: 'fit-content',
                            background: "repeating-conic-gradient(\n                  ".concat(checkerboardMode === 'dark' ? '#242424' : '#ffffff', " 0 90deg,\n                  ").concat(checkerboardMode === 'dark' ? '#141414' : '#efefef', " 0 180deg) \n              0 0/").concat(widthPercent, "% ").concat(heightPercent, "%"),
                        };
                    }, resource: '/delish-bottle-square.png', image: selectedImage || '/delish-bottle-square.png' }))) : (React__default["default"].createElement(material.CardMedia, { component: "img", sx: function (theme) { return ({ objectFit: 'contain', height: theme.sizes.img.md }); }, resource: '/delish-bottle-square.png', image: selectedImage || '/delish-bottle-square.png' })),
            React__default["default"].createElement(material.CardActions, null,
                React__default["default"].createElement(FlexBox.RowCenter, { flexGrow: 1 }, loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                        height: theme.sizes.skeleton.sm,
                        width: '100%',
                        mb: "".concat(theme.sizes.skeleton.xs, "px"),
                    }); } })) : (React__default["default"].createElement(material.Grid, { container: true, direction: "row", justifyContent: 'space-between', alignItems: 'center' },
                    React__default["default"].createElement(material.Grid, __assign$l({ item: true }, gridAllScreens(9), { md: paginatorGridXsSize, xs: paginatorGridXsSize }),
                        React__default["default"].createElement(material.Pagination, { count: images.length, hideNextButton: !(images.length > 1), hidePrevButton: !(images.length > 1), onChange: function (_, page) { return setSelectedPage(page - 1); }, variant: "outlined", shape: "rounded", size: "medium", siblingCount: !isDesktop ? 0 : 1 })),
                    actionsButtons.map(function (button) { return (React__default["default"].createElement(ScreenController.Desktop, { key: "button-icon-img-crsl-".concat(button.tooltip) },
                        React__default["default"].createElement(material.Grid, __assign$l({ item: true }, button.gridProps),
                            React__default["default"].createElement(material.Tooltip, { title: button.tooltip },
                                React__default["default"].createElement(material.IconButton
                                // disabled={button.disabled}
                                , { 
                                    // disabled={button.disabled}
                                    onClick: button.onClick }, button.icon))))); }),
                    React__default["default"].createElement(ScreenController.NonDesktop, null,
                        React__default["default"].createElement(material.Grid, { item: true, xs: 1.5 },
                            React__default["default"].createElement(material.IconButton, { onClick: handleMoreMenuClick },
                                React__default["default"].createElement(iconsMaterial.MoreVert, null))),
                        React__default["default"].createElement(material.Menu, { onClose: function () { return setMoreMenuAnchorEl(null); }, open: moreMenuOpen, anchorEl: moreMenuAnchorEl }, actionsButtons.map(function (btn) { return (React__default["default"].createElement(material.MenuItem, { key: "menu-item-img-crsl-".concat(btn.tooltip), onClick: function () {
                                btn.onClick();
                                setMoreMenuAnchorEl(null);
                            } },
                            React__default["default"].createElement(AvatarWithText, { primaryText: btn.tooltip, avatarColor: MuiTheme.palette.grey['200'] }, btn.icon))); })))))))),
        React__default["default"].createElement(MuiFormModal, { title: 'Delete Image', subtitle: 'Are you sure?', handleClose: function () { return setShowDeleteImage(false); }, actionButtonsProps: [
                {
                    children: 'Cancel',
                    onClick: function () { return setShowDeleteImage(false); },
                    startIcon: React__default["default"].createElement(iconsMaterial.Close, { color: "secondary" }),
                    color: 'secondary',
                },
                {
                    children: 'Delete',
                    startIcon: React__default["default"].createElement(iconsMaterial.Delete, { color: "secondary" }),
                    onClick: handleConfirmDeleteImage,
                },
            ], isOpen: showDeleteImage },
            React__default["default"].createElement(Typography__default["default"], { variant: "h6" }, "Are you sure you want to delete this image?"),
            React__default["default"].createElement(material.CardMedia, { component: "img", sx: function (theme) { return ({ objectFit: 'contain', height: theme.sizes.img.md }); }, resource: '/delish-bottle-square.png', image: selectedImage || '/delish-bottle-square.png' })),
        React__default["default"].createElement(MuiFormModal, { title: formTitle || 'Upload new marketing image', isOpen: showUploadImage, handleClose: function () { return setShowUploadImage(false); }, actionButtonsProps: [
                {
                    children: 'Cancel',
                    color: 'secondary',
                    onClick: function () {
                        setShowUploadImage(false);
                        setNewImageFile(undefined);
                    },
                    startIcon: React__default["default"].createElement(iconsMaterial.Close, { color: "secondary" }),
                },
                {
                    onClick: handleConfirmUploadImage,
                    children: 'Save',
                    startIcon: React__default["default"].createElement(iconsMaterial.Save, { color: "secondary" }),
                    disabled: !newImageFile,
                },
            ] },
            React__default["default"].createElement(FileUploader, { onFilesSelected: function (files) { return setNewImageFile(files[0]); }, files: newImageFile ? [newImageFile] : undefined, onClearFiles: function () { return setNewImageFile(undefined); }, allowedFileTypes: ['.jpg', '.jpeg', '.png', '.PNG', '.JPG', '.JPEG'] }))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ProductTile = function (props) {
    var isLoading = props.loading, product = props.product, _a = props.onSelect, onSelect = _a === void 0 ? function () { return null; } : _a, _b = props.selected, selected = _b === void 0 ? false : _b, Extra = props.Extra, 
    // hideVerified = false,
    _c = props.enableShowLargeImage, 
    // hideVerified = false,
    enableShowLargeImage = _c === void 0 ? false : _c;
    var loading = isLoading || !product;
    var _d = React__default["default"].useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var sidebarWidthMixin = function (theme) {
        return Object.keys(theme.sizes.sidebar.width.variant.lg).reduce(function (css, bp) {
            var _a;
            return (__assign$l(__assign$l({}, css), (_a = {}, _a[theme.breakpoints.only(bp)] = {
                // @ts-ignore
                maxWidth: theme.sizes.sidebar.width.variant.lg[bp] * 0.5,
            }, _a)));
        }, {});
    };
    var primaryImage = loading ? undefined : product.marketingImageUrl;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        enableShowLargeImage && (React__default["default"].createElement(material.Popover, { sx: {
                pointerEvents: 'none',
            }, open: Boolean(anchorEl), anchorEl: anchorEl, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, onClose: function () { return setAnchorEl(null); } }, primaryImage && (React__default["default"].createElement(material.CardMedia, { component: "img", sx: function (theme) { return ({
                padding: 1,
                width: theme.sizes.img.xl - 8,
                height: theme.sizes.img.xl - 8,
            }); }, image: primaryImage })))),
        React__default["default"].createElement(material.Card, { elevation: selected ? 10 : 1, sx: function (theme) { return ({ width: '100%' }); }, onClick: function () {
                if (!isLoading && (product === null || product === void 0 ? void 0 : product.upcA)) {
                    onSelect(product.upcA);
                }
            } },
            selected && (React__default["default"].createElement(material.CardHeader, { sx: { p: 1 }, avatar: React__default["default"].createElement(iconsMaterial.PushPin, { color: "primary" }) })),
            React__default["default"].createElement(FlexBox.RowCenter, null,
                loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                        width: theme.sizes.img.sm,
                        height: theme.sizes.img.sm,
                    }); }, variant: "rectangular" })) : (React__default["default"].createElement(material.CardMedia, { component: "img", sx: function (theme) { return ({
                        padding: 1,
                        width: theme.sizes.img.sm - 8,
                        height: theme.sizes.img.sm - 8,
                    }); }, onMouseEnter: function (e) {
                        if (primaryImage)
                            setAnchorEl(e.currentTarget);
                    }, onMouseLeave: function () { return setAnchorEl(null); }, image: primaryImage || '/delish-bottle-square.png' })),
                React__default["default"].createElement(material.CardContent, { sx: { flexGrow: 1 } },
                    React__default["default"].createElement(FlexBox.Col, null, loading ? (React__default["default"].createElement(React__default["default"].Fragment, null,
                        React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                                height: theme.sizes.skeleton.sm,
                                mb: "".concat(theme.sizes.skeleton.xs, "px"),
                            }); } }),
                        React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                                height: theme.sizes.skeleton.xs,
                                mb: "".concat(theme.sizes.skeleton.xs, "px"),
                            }); } }),
                        React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                                height: theme.sizes.skeleton.xs,
                                mb: "".concat(theme.sizes.skeleton.xs, "px"),
                            }); } }),
                        React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                                height: theme.sizes.skeleton.xs,
                            }); } }))) : (React__default["default"].createElement(Box__default["default"], { sx: function (theme) {
                            var _a;
                            return (__assign$l(__assign$l({}, sidebarWidthMixin(theme)), (_a = {}, _a[theme.breakpoints.only('xs')] = {
                                maxWidth: 200,
                            }, _a)));
                        } },
                        React__default["default"].createElement(material.Typography, { variant: "body2", component: "p", fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden' }, product.productName),
                        React__default["default"].createElement(material.Typography, { variant: "body2", component: "p" }, product.brandName),
                        React__default["default"].createElement(material.Typography, { variant: "body2", component: "p" }, product.upcA))))),
                Extra))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var ProductTileOnlyUpc = function (props) {
    var upc = props.upc, rest = __rest$c(props, ["upc"]);
    var _a = useQuery(lib$4.GET_PRODUCT_BY_UPC, {
        context: {
            endPoint: 'sabre',
        },
        variables: { upc: upc },
        fetchPolicy: 'cache-first',
    }), loading = _a.loading, data = _a.data;
    var simpleProductToProps = function (prod) {
        var _a;
        return {
            id: prod.id,
            upcA: prod.upcA,
            productName: prod.name,
            brandName: (_a = prod.brand) === null || _a === void 0 ? void 0 : _a.name,
            marketingImageUrl: prod.marketingImageUrl || undefined,
        };
    };
    return (React__namespace.createElement(ProductTile, __assign$l({}, rest, { loading: loading, product: (data === null || data === void 0 ? void 0 : data.productByUpc) ? simpleProductToProps(data.productByUpc) : undefined })));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var useProductSearch = function () {
    var ProductLazyQuery = useDebouncedItemQuery({
        queryStr: lib$4.SABRE_GET_PRODUCTS,
        options: { fetchPolicy: 'network-only', context: { endPoint: 'sabre' } },
    });
    var BrandLazyQuery = useDebouncedItemQuery({
        queryStr: lib$4.SABRE_GET_BRANDS,
        options: { fetchPolicy: 'cache-first', context: { endPoint: 'sabre' } },
    });
    var ManufacturerLazyQuery = useDebouncedItemQuery({
        queryStr: lib$4.SABRE_GET_MANUFACTURERS,
        options: { fetchPolicy: 'network-only', context: { endPoint: 'sabre' } },
    });
    var ProductFlavorsLazyQuery = useDebouncedItemQuery({
        queryStr: lib$4.SABRE_GET_FLAVORS,
        options: { fetchPolicy: 'network-only', context: { endPoint: 'sabre' } },
    });
    var ProductCategoriesLazyQuery = useDebouncedItemQuery({
        queryStr: lib$4.GET_COMPANY_PRODUCT_CATEGORIES,
        options: { fetchPolicy: 'cache-first' },
    });
    var ProductMarketingImageLazyQuery = useDebouncedItemQuery({
        queryStr: lib$4.SABRE_GET_PRODUCT_IMAGES,
        options: { fetchPolicy: 'network-only', context: { endPoint: 'sabre' } },
    });
    return {
        ProductLazyQuery: ProductLazyQuery,
        BrandLazyQuery: BrandLazyQuery,
        ManufacturerLazyQuery: ManufacturerLazyQuery,
        ProductFlavorsLazyQuery: ProductFlavorsLazyQuery,
        ProductCategoriesLazyQuery: ProductCategoriesLazyQuery,
        ProductMarketingImageLazyQuery: ProductMarketingImageLazyQuery,
    };
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var isCustomerProduct = function (upc, customerDistributedUpcs) { return customerDistributedUpcs.includes(upc); };

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var FormContext = React__default["default"].createContext({
    formState: undefined,
    handleOnChange: function (_) { return null; },
    loading: false,
});

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
function not(a, b) {
    var bValues = b.map(function (_b) { return _b.value; });
    return a.filter(function (value) { return bValues.indexOf(value.value) === -1; });
}
function intersection(a, b) {
    var bValues = b.map(function (_b) { return _b.value; });
    return a.filter(function (value) { return bValues.indexOf(value.value) !== -1; });
}
function union(a, b) {
    return __spreadArray$5(__spreadArray$5([], a, true), not(b, a), true);
}
function _in(a, b) {
    return a.find(function (_a) { return _a.value === b.value; });
}
var SelectableListHelpers = {
    not: not,
    intersection: intersection,
    union: union,
    _in: _in,
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var SearchableSelectInput = function (props) {
    var _a, _b;
    var label = props.label, options = props.options, selectedOption = props.selectedOption, setSelectedOption = props.setSelectedOption, setSearchText = props.setSearchText, _c = props.variant, variant = _c === void 0 ? 'outlined' : _c, _d = props.loading, loading = _d === void 0 ? false : _d, _e = props.multiple, multiple = _e === void 0 ? false : _e, _f = props.required, required = _f === void 0 ? false : _f, Footer = props.Footer, help = props.help, _g = props.size, size = _g === void 0 ? 'medium' : _g, _h = props.hasMore, hasMore = _h === void 0 ? false : _h, _j = props.fetchMore, fetchMore = _j === void 0 ? lodash.exports.noop : _j, minWidth = props.minWidth, _k = props.selectAllEnabled, selectAllEnabled = _k === void 0 ? false : _k;
    var _l = React.useState(null), anchorEl = _l[0], setAnchorEl = _l[1];
    var ref = React.useRef(null);
    var open = Boolean(anchorEl);
    var handleChange = function (selected) {
        if (multiple) {
            var selectedTyped = selectedOption;
            var options_1 = selectedTyped && SelectableListHelpers._in(selectedTyped, selected)
                ? SelectableListHelpers.not(selectedTyped, [selected])
                : selectedTyped
                    ? __spreadArray$5(__spreadArray$5([], selectedTyped, true), [selected], false) : [selected];
            setSelectedOption(options_1);
        }
        else {
            var selectedTyped = selectedOption;
            setAnchorEl(null);
            setSelectedOption(selected.value === (selectedTyped === null || selectedTyped === void 0 ? void 0 : selectedTyped.value) ? undefined : selected);
        }
    };
    var selectedOptionsArray = selectedOption
        ? Array.isArray(selectedOption)
            ? selectedOption
            : options.filter(function (opt) { return opt.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value); })
        : [];
    var selectedMenuOptionIds = selectedOptionsArray.map(function (opt) { return opt.value; });
    var menuOptions = selectedMenuOptionIds.length
        ? __spreadArray$5(__spreadArray$5([], selectedOptionsArray, true), options.filter(function (opt) { return !selectedMenuOptionIds.includes(opt.value); }), true) : options || [];
    var menuWidth = minWidth && minWidth > (((_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0)
        ? minWidth
        : (_b = ref.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
    var allItemsSelected = Array.isArray(selectedOption) && !!selectedOption.length
        ? SelectableListHelpers.intersection(selectedOption, menuOptions).length === menuOptions.length
        : false;
    var handleToggleAllItems = function () {
        return setSelectedOption(allItemsSelected ? [] : menuOptions);
    };
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__default["default"].createElement(material.FormControl, { variant: variant, fullWidth: true, required: required, color: 'secondary', size: size },
            React__default["default"].createElement(material.TextField, { ref: ref, required: required, variant: variant, key: label, value: selectedOptionsArray.map(function (opt) { return opt.display; }), size: size, label: label, focused: open, InputProps: {
                    endAdornment: (React__default["default"].createElement(material.InputAdornment, { position: "end" }, open ? React__default["default"].createElement(iconsMaterial.KeyboardArrowUp, null) : React__default["default"].createElement(iconsMaterial.KeyboardArrowDown, null))),
                }, onClick: function (event) { return setAnchorEl(event.currentTarget); } }),
            help && (React__default["default"].createElement(material.FormHelperText, { id: "helper-".concat(help, "-search-select") }, help)),
            React__default["default"].createElement(material.Menu, { open: open, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, PaperProps: {
                    sx: { width: menuWidth, paddingTop: 1 },
                }, elevation: 10 },
                React__default["default"].createElement(material.ListSubheader, null,
                    React__default["default"].createElement(material.TextField, { size: "small", color: "info", autoFocus: true, placeholder: "Type to search...", fullWidth: true, contentEditable: false, helperText: !loading &&
                            !menuOptions.length && (React__default["default"].createElement(material.Typography, { sx: { color: 'black', marginY: 1 } }, "No results matched that search.")), InputProps: {
                            startAdornment: (React__default["default"].createElement(material.InputAdornment, { position: "start" }, loading ? (React__default["default"].createElement(material.CircularProgress, { size: 18, sx: { mr: 1 } })) : (React__default["default"].createElement(SearchIcon__default["default"], null)))),
                        }, onChange: function (e) { return setSearchText(e.target.value); }, onKeyDown: function (e) {
                            if (e.key !== 'Escape') {
                                e.stopPropagation();
                            }
                        } }),
                    selectAllEnabled && menuOptions.length > 0 && (React__default["default"].createElement(material.FormControlLabel, { sx: { px: 0, mx: 0, color: 'black' }, label: allItemsSelected ? 'Deselect All' : 'Select All', control: React__default["default"].createElement(material.Checkbox, { checked: allItemsSelected, onChange: handleToggleAllItems }) }))),
                React__default["default"].createElement(Box__default["default"], { id: "scrollableDiv", sx: function (theme) { return ({
                        maxHeight: theme.sizes.searchSelect,
                        overflowY: 'scroll',
                    }); } },
                    React__default["default"].createElement(InfiniteScroll__default["default"], { dataLength: menuOptions.length, next: fetchMore, hasMore: hasMore, loader: React__default["default"].createElement(FlexBox.RowCenter, { width: '100%', my: 1 },
                            React__default["default"].createElement(material.CircularProgress, { size: 25 })), scrollableTarget: "scrollableDiv", style: { minWidth: 'fit-content' } }, menuOptions.map(function (option, i) {
                        var isSelected = selectedOption
                            ? !Array.isArray(selectedOption)
                                ? option.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)
                                : selectedMenuOptionIds.includes(option.value)
                            : false;
                        return (React__default["default"].createElement(material.MenuItem, { sx: { minWidth: 'fit-content' }, selected: isSelected, color: "info", key: i, value: option.value, onClick: function () { return handleChange(option); } },
                            selectAllEnabled && React__default["default"].createElement(material.Checkbox, { checked: isSelected }),
                            option.display));
                    }))),
                Footer && (React__default["default"].createElement(Box__default["default"], { sx: function (theme) { return ({
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 1,
                        backgroundColor: theme.palette.primary.light,
                    }); } },
                    React__default["default"].createElement(material.Divider, { sx: function (theme) { return ({ backgroundColor: theme.palette.grey['50'] }); } }),
                    React__default["default"].createElement(Box__default["default"], { padding: 2 }, Footer)))))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */
var getOptionFromValue = function (options, value) {
    var option = options.find(function (o) { return o.value === value; });
    return option;
};
var getUpdatedOptions = function (currentlySelected, clicked) {
    if (!clicked) {
        return currentlySelected;
    }
    if (currentlySelected.some(function (o) { return o.value === clicked.value; })) {
        return currentlySelected.filter(function (o) { return o.value !== clicked.value; });
    }
    return __spreadArray$5(__spreadArray$5([], currentlySelected, true), [clicked], false);
};
var getOptionsFromSelectedValues = function (values, options) {
    return options.filter(function (o) { return values.includes(o.value); });
};
var getDisplayedFromValue = function (options, selectedValue) { var _a; return (_a = options === null || options === void 0 ? void 0 : options.find(function (opt) { return opt.value === selectedValue; })) === null || _a === void 0 ? void 0 : _a.display; };
var MuiFormHelpers = {
    getOptionFromValue: getOptionFromValue,
    getUpdatedOptions: getUpdatedOptions,
    getOptionsFromSelectedValues: getOptionsFromSelectedValues,
    getDisplayedFromValue: getDisplayedFromValue,
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var TextForm = function (props) {
    var formState = props.formState, handleOnChange = props.handleOnChange, _a = props.loading, loading = _a === void 0 ? false : _a;
    return (React__default["default"].createElement(React__default["default"].Fragment, null, Object.entries(formState).map(function (_a) {
        var id = _a[0], text = _a[1];
        return (React__default["default"].createElement(material.Grid, __assign$l({ item: true }, text.gridProps, { key: "grid-item-text-".concat(id) }), loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({ height: theme.sizes.skeleton.lg }); } })) : (React__default["default"].createElement(material.FormControl, { fullWidth: true, variant: "filled", id: id, sx: { minWidth: text.minWidth } }, text.input.type === 'date' ? (React__default["default"].createElement(MUIDatePicker, { label: text.input.label, date: dayjs__default["default"](text.value), onDateChange: function (newDay) {
                text.onChange && text.onChange(newDay.toISOString());
                handleOnChange === null || handleOnChange === void 0 ? void 0 : handleOnChange('text', id, {
                    target: { value: newDay.toISOString() },
                });
            }, error: text.error, helperText: text.help })) : (React__default["default"].createElement(material.TextField, __assign$l({}, text.input, { error: text.error, id: id, value: text.value, onChange: function (event) {
                text.onChange && text.onChange(event.target.value);
                handleOnChange === null || handleOnChange === void 0 ? void 0 : handleOnChange('text', id, event);
            }, helperText: text.help })))))));
    })));
};
var SelectForm = function (props) {
    var formState = props.formState, handleOnChange = props.handleOnChange, _a = props.loading, loading = _a === void 0 ? false : _a;
    return (React__default["default"].createElement(React__default["default"].Fragment, null, Object.entries(formState).map(function (_a) {
        var id = _a[0], select = _a[1];
        return (React__default["default"].createElement(material.Grid, __assign$l({ item: true }, select.gridProps, { key: "grid-item-select-".concat(id) }), loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({ height: theme.sizes.skeleton.lg }); } })) : (React__default["default"].createElement(material.FormControl, { fullWidth: true, variant: select.variant, id: id, required: select.input.required, sx: { minWidth: select.minWidth } },
            React__default["default"].createElement(material.InputLabel, { id: "select-".concat(id, "-label") }, select.label),
            React__default["default"].createElement(material.Select, __assign$l({}, select.input, { labelId: "".concat(id, "-label"), error: select.error, id: id, value: select.value, onChange: function (event) {
                    var value = event.target.value;
                    var newOption = MuiFormHelpers.getOptionFromValue(select.options, value);
                    if (select.onChange) {
                        if (Array.isArray(select.value)) {
                            // we want to get the new selected options
                            var selectedOptions = MuiFormHelpers.getOptionsFromSelectedValues(select.value, select.options);
                            var newOptions = MuiFormHelpers.getUpdatedOptions(selectedOptions, newOption);
                            select.onChange(newOptions);
                        }
                        else {
                            select.onChange(newOption ? [newOption] : []);
                        }
                    }
                    handleOnChange === null || handleOnChange === void 0 ? void 0 : handleOnChange('select', id, event);
                } }), select.options.map(function (opt) { return (React__default["default"].createElement(material.MenuItem, __assign$l({}, opt, { key: "menu-item-".concat(opt.value) }), opt.display)); })),
            React__default["default"].createElement(material.FormHelperText, { id: "helper-".concat(id, "-select") }, select.help)))));
    })));
};
var SearchSelectForm = function (props) {
    var formState = props.formState, handleOnChange = props.handleOnChange, _a = props.loading, loading = _a === void 0 ? false : _a;
    return (React__default["default"].createElement(React__default["default"].Fragment, null, Object.entries(formState || {}).map(function (_a) {
        var id = _a[0], searchSelect = _a[1];
        var valueTyped = searchSelect.value;
        var selectedOptions = Array.isArray(valueTyped)
            ? searchSelect.options.filter(function (opt) { return valueTyped.includes(opt.value); })
            : searchSelect.options.find(function (opt) { return opt.value === valueTyped; });
        return (React__default["default"].createElement(material.Grid, __assign$l({ item: true }, searchSelect.gridProps, { key: "grid-item-radio-".concat(id) }), loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({ height: theme.sizes.skeleton.lg }); } })) : (React__default["default"].createElement(SearchableSelectInput, { loading: searchSelect.loading, variant: searchSelect.variant, required: searchSelect.required, label: searchSelect.label, multiple: searchSelect.multiple, setSearchText: searchSelect.setSearchText, options: searchSelect.options, selectedOption: selectedOptions, help: searchSelect.help, size: searchSelect.size, hasMore: searchSelect.hasMore, fetchMore: searchSelect.fetchMore, minWidth: searchSelect.minWidth, selectAllEnabled: searchSelect.selectAllEnabled, setSelectedOption: function (selected) {
                var selectedOptions = Array.isArray(selected)
                    ? selected
                    : selected
                        ? [selected]
                        : [];
                searchSelect.onChange &&
                    searchSelect.onChange(selectedOptions);
                handleOnChange === null || handleOnChange === void 0 ? void 0 : handleOnChange('searchSelect', id, {
                    target: { value: selectedOptions.map(function (s) { return s.value; }) },
                });
            }, Footer: searchSelect.Footer }))));
    })));
};
var RadioForm = function (props) {
    var formState = props.formState, handleOnChange = props.handleOnChange;
    return (React__default["default"].createElement(React__default["default"].Fragment, null, Object.entries(formState).map(function (_a) {
        var id = _a[0], radio = _a[1];
        return (React__default["default"].createElement(material.Grid, __assign$l({ item: true }, radio.gridProps, { key: "grid-item-radio-".concat(id) }),
            React__default["default"].createElement(material.FormControl, { fullWidth: true, id: id, required: radio.required, sx: { minWidth: radio.minWidth } },
                React__default["default"].createElement(material.FormLabel, { id: "radio-".concat(id, "-label"), color: 'secondary', error: radio.error }, radio.label),
                React__default["default"].createElement(material.RadioGroup, __assign$l({ row: radio.row === undefined ? true : radio.row }, radio.group, { value: radio.value, onChange: function (event, value) {
                        var optionClicked = MuiFormHelpers.getOptionFromValue(radio.options, value);
                        radio.onChange && radio.onChange(optionClicked);
                        handleOnChange === null || handleOnChange === void 0 ? void 0 : handleOnChange('radio', id, event);
                    } }), radio.options.map(function (option) { return (React__default["default"].createElement(material.FormControlLabel, { label: option.display, value: option.value, checked: option.value.toString() === radio.value, control: React__default["default"].createElement(material.Radio, null), key: "radio-".concat(option.display) })); })),
                React__default["default"].createElement(material.FormHelperText, { id: "helper-".concat(id, "-radio") }, radio.help))));
    })));
};
var CheckboxForm = function (props) {
    var formState = props.formState, handleOnChange = props.handleOnChange;
    return (React__default["default"].createElement(React__default["default"].Fragment, null, Object.entries(formState || {}).map(function (_a) {
        var id = _a[0], checkbox = _a[1];
        return (React__default["default"].createElement(material.Grid, __assign$l({ item: true }, checkbox.gridProps, { key: "grid-item-checkbox-".concat(id) }),
            React__default["default"].createElement(material.FormControl, { fullWidth: true, id: id, required: checkbox.required, sx: { minWidth: checkbox.minWidth } },
                React__default["default"].createElement(material.FormLabel, { id: "checkbox-".concat(id, "-label"), color: 'secondary', error: checkbox.error }, checkbox.label),
                React__default["default"].createElement(material.FormGroup, __assign$l({ row: true }, checkbox.group), checkbox.options.map(function (option) {
                    var _a;
                    return (React__default["default"].createElement(material.FormControlLabel, { key: "checkbox-".concat(option.display), label: option.display, value: option.value, control: React__default["default"].createElement(material.Checkbox, { checked: (_a = checkbox.value) === null || _a === void 0 ? void 0 : _a.includes(option.value), onChange: function (event) {
                                var _a;
                                var currValues = checkbox.value || [];
                                var currentOptions = MuiFormHelpers.getOptionsFromSelectedValues(currValues, checkbox.options);
                                var clickedOption = MuiFormHelpers.getOptionFromValue(checkbox.options, event.target.value);
                                var newOptions = MuiFormHelpers.getUpdatedOptions(currentOptions, clickedOption);
                                handleOnChange === null || handleOnChange === void 0 ? void 0 : handleOnChange('checkbox', id, {
                                    target: { value: newOptions.map(function (o) { return o.value; }) },
                                });
                                (_a = checkbox.onChange) === null || _a === void 0 ? void 0 : _a.call(checkbox, newOptions);
                            } }) }));
                })),
                React__default["default"].createElement(material.FormHelperText, { id: "helper-".concat(id, "-checkbox") }, checkbox.help))));
    })));
};
var AutocompleteForm = function (props) {
    var formState = props.formState, handleOnChange = props.handleOnChange, _a = props.loading, loading = _a === void 0 ? false : _a;
    return (React__default["default"].createElement(React__default["default"].Fragment, null, Object.entries(formState || {}).map(function (_a) {
        var id = _a[0], autocomplete = _a[1];
        return (React__default["default"].createElement(material.Grid, __assign$l({ item: true }, autocomplete.gridProps, { key: "grid-item-autocomplete-".concat(id) }), loading ? (React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({ height: theme.sizes.skeleton.lg }); } })) : (React__default["default"].createElement(material.FormControl, { fullWidth: true, id: id, required: autocomplete.required, sx: { minWidth: autocomplete.minWidth } },
            React__default["default"].createElement(material.Autocomplete, { inputValue: MuiFormHelpers.getDisplayedFromValue(autocomplete.options, autocomplete.value), isOptionEqualToValue: function (opt) { return opt.value === autocomplete.value; }, filterOptions: function (options) { return options; }, onChange: function (_, value) {
                    var changedValue = value ? value.value : '';
                    var changedOption = MuiFormHelpers.getOptionFromValue(autocomplete.options, changedValue);
                    autocomplete.onChange && autocomplete.onChange(changedOption);
                    handleOnChange === null || handleOnChange === void 0 ? void 0 : handleOnChange('autocomplete', id, {
                        target: { value: changedValue },
                    });
                }, renderInput: function (params) { return (React__default["default"].createElement(material.TextField, __assign$l({}, params, { label: autocomplete.label, variant: autocomplete.variant }))); }, options: autocomplete.options, groupBy: autocomplete.groupBy, getOptionLabel: function (option) { return option.display; } }),
            React__default["default"].createElement(material.FormHelperText, { id: "helper-".concat(id, "-autocomplete") }, autocomplete.help)))));
    })));
};
var MuiFormController = {
    text: TextForm,
    select: SelectForm,
    searchSelect: SearchSelectForm,
    radio: RadioForm,
    checkbox: CheckboxForm,
    autocomplete: AutocompleteForm,
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var MuiForm = function (props) {
    var _a = props.orderOfForms, orderOfForms = _a === void 0 ? Object.keys(MuiFormController) : _a, _b = props.loading, loading = _b === void 0 ? false : _b, _c = props.handleOnChange, handleOnChange = _c === void 0 ? function (_) { return null; } : _c, formState = props.formState, _d = props.disableGrid, disableGrid = _d === void 0 ? false : _d;
    var Content = orderOfForms.map(function (formKey) {
        var Form = MuiFormController[formKey];
        var formStateChecked = formState[formKey];
        return formStateChecked ? (React__default["default"].createElement(Form, { key: formKey, 
            // @ts-ignore
            formState: formStateChecked, handleOnChange: handleOnChange, loading: loading })) : null;
    });
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme }, disableGrid ? (React__default["default"].createElement(React__default["default"].Fragment, null, Content)) : (React__default["default"].createElement(material.Grid, { container: true, spacing: 2 }, Content))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Michael Selander <michael.selander@deliciousai.com>
 */
var AutocompleteSelectInput = function (props) {
    var label = props.label, options = props.options, selectedOptionProp = props.selectedOption, setSelectedOption = props.setSelectedOption, setSearchText = props.setSearchText, searchText = props.searchText, _a = props.variant, variant = _a === void 0 ? 'outlined' : _a, loading = props.loading;
    var theme = material.useTheme();
    var _b = React.useState(null); _b[0]; _b[1];
    React.useRef(null);
    var icon = React__default["default"].createElement(CheckBoxOutlineBlankIcon__default["default"], { fontSize: "small" });
    var checkedIcon = React__default["default"].createElement(CheckBoxIcon__default["default"], { fontSize: "small" });
    var _c = React.useState(selectedOptionProp || []), value = _c[0], setValue = _c[1];
    React.useEffect(function () {
        if (selectedOptionProp) {
            setValue(selectedOptionProp);
        }
    }, [selectedOptionProp]);
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__default["default"].createElement(material.Autocomplete, { multiple: true, filterOptions: function (x) { return x; }, options: options, loading: loading, value: value, disableCloseOnSelect: true, includeInputInList: true, inputValue: searchText, onInputChange: function (event, newValue, reason) {
                if (reason == 'input') {
                    setSearchText(newValue);
                }
            }, onChange: function (event, newValue) {
                setSelectedOption(newValue.map(function (option) { return option; }));
                setSearchText('');
            }, isOptionEqualToValue: function (option, value) {
                return (option.value ==
                    value.value);
            }, renderTags: function (tagValue, getTagProps) {
                return tagValue.map(function (option, index) { return (React__default["default"].createElement(material.Chip, __assign$l({}, getTagProps({ index: index }), { label: option.display, variant: 'bold-dark', sx: {
                        '& .MuiChip-deleteIcon': {
                            color: theme.palette.grey['400'],
                        },
                        '&:hover .MuiChip-deleteIcon': {
                            color: theme.palette.grey['500'],
                        },
                    } }))); });
            }, renderOption: function (props, option, _a) {
                var selected = _a.selected;
                return (React__default["default"].createElement("li", __assign$l({}, props),
                    React__default["default"].createElement(material.Checkbox, { icon: icon, checkedIcon: checkedIcon, style: { marginRight: 8 }, checked: selected }),
                    option.display));
            }, getOptionLabel: function (option) {
                return option.display || option;
            }, style: { width: 500 }, renderInput: function (params) {
                return (React__default["default"].createElement(material.TextField, __assign$l({}, params, { variant: variant, label: label, placeholder: 'Type to search...' })));
            } })));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var Transition = React__default["default"].forwardRef(function (props, ref) {
    return React__default["default"].createElement(material.Slide, __assign$l({ direction: "up", ref: ref }, props));
});
var FullScreenModal = function (props) {
    var title = props.title, handleClose = props.handleClose, open = props.open, FooterButtons = props.FooterButtons, _a = props.mobileOnly, mobileOnly = _a === void 0 ? false : _a, children = props.children;
    var Container = mobileOnly ? ScreenController.Mobile : material.Box;
    return (React__default["default"].createElement(Container, null,
        React__default["default"].createElement(material.Dialog, { open: open, fullScreen: true, TransitionComponent: Transition },
            React__default["default"].createElement(FlexBox.Col, { height: '100vh' },
                React__default["default"].createElement(ModalTitle, { id: "customized-dialog-title", onClose: handleClose },
                    React__default["default"].createElement(Typography__default["default"], { variant: "h5" }, title)),
                children,
                FooterButtons && (React__default["default"].createElement(material.Grid, { container: true, spacing: 2, sx: { p: 2 }, justifyContent: "center", alignItems: "center" }, FooterButtons.map(function (button, idx) { return (React__default["default"].createElement(material.Grid, __assign$l({ item: true }, gridAllScreens(12 / FooterButtons.length), { key: "footer-button-side-".concat(idx) }),
                    React__default["default"].createElement(material.Button, __assign$l({}, button, { fullWidth: true })))); })))))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
/**
 * A component used to reduce multiple input fields into one field that is accessed
 * via a dropdown
 */
var CondensedInputWithDropdown = function (props) {
    var _a;
    var label = props.label, formState = props.formState, setFormState = props.setFormState, orderOfForms = props.orderOfForms, loading = props.loading;
    var _b = React__default["default"].useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var isOpen = Boolean(anchorEl);
    var ref = React.useRef(null);
    var handleOnChange = useMuiForm({
        formState: formState,
        setFormState: setFormState,
    }).handle.handleOnChange;
    var values = Object.values(formState)
        .filter(function (formType) { return Object.values(formType).length; })
        .map(function (formType) { return Object.values(formType); })
        .flat()
        .map(function (form) { return MuiFormHelpers.getDisplayedFromValue(form.options, form.value); })
        .filter(function (val) { return !StringHelpers.isNullOrEmpty(val); })
        .map(function (val) { return StringHelpers.titleCase(val.toLowerCase()); });
    return (React__default["default"].createElement(material.FormControl, { fullWidth: true, variant: "filled" },
        React__default["default"].createElement(material.TextField, { ref: ref, onClick: function (event) { return setAnchorEl(event.currentTarget); }, label: label, variant: "filled", value: !values.length ? 'Select Options...' : values.join(' | '), contentEditable: false }),
        React__default["default"].createElement(material.Menu, { open: isOpen, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, elevation: 10, PaperProps: {
                sx: { p: 2, width: ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 250 },
            } },
            React__default["default"].createElement(MuiForm, { orderOfForms: orderOfForms, formState: formState, handleOnChange: handleOnChange, loading: loading }))));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var EmptyReportBody = function () { return (React__default["default"].createElement(material.Stack, { direction: 'column', spacing: 2, alignItems: 'center', height: '100%', justifyContent: 'center' },
    React__default["default"].createElement(iconsMaterial.AnalyticsOutlined, { sx: { height: 50, width: 50 } }),
    React__default["default"].createElement(material.Typography, { variant: 'h5' }, "No Results Found"),
    React__default["default"].createElement(material.Typography, { variant: 'body2', fontSize: 18, textAlign: 'center' }, "Update your search parameters to view results for this report"))); };

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var AmchartBase = function (props) {
    var data = props.data, isEmpty = props.isEmpty, isLoading = props.isLoading, mountChart = props.mountChart, chartId = props.chartId, style = props.style, _a = props.numberFormat, numberFormat = _a === void 0 ? '#.##a' : _a, _b = props.smallNumberPrefixes, smallNumberPrefixes = _b === void 0 ? [] : _b, renderExtraSeries = props.renderExtraSeries;
    // Listening to the width and navigation drawer is hacky...
    var width = lib$3.useWindowDimensions().width;
    var isOpen = React.useContext(NavigationDrawerContext).isOpen;
    var _c = o(isOpen, 350), isOpenDebounced = _c[0]; _c[1];
    var height = { xl: 800, lg: 700, md: 600, sm: 600, xs: 600 };
    React.useLayoutEffect(function () {
        if (isEmpty || isLoading)
            return;
        am5__namespace.array.each(am5__namespace.registry.rootElements, function (root) {
            if ((root === null || root === void 0 ? void 0 : root.dom.id) === chartId) {
                root.dispose();
            }
        });
        var _a = mountChart(data), root = _a.root, chart = _a.chart, seriesRenderExtras = __rest$c(_a, ["root", "chart"]);
        root.numberFormatter.setAll({
            numberFormat: numberFormat,
            smallNumberThreshold: 0.1,
            smallNumberPrefixes: smallNumberPrefixes,
            bigNumberPrefixes: [
                { number: 1e3, suffix: 'k' },
                { number: 1e6, suffix: 'M' },
                { number: 1e9, suffix: 'B' },
            ],
        });
        renderExtraSeries &&
            renderExtraSeries(__assign$l({ root: root, chart: chart }, seriesRenderExtras));
        root.setThemes([am5themes_Animated__default["default"].new(root)]);
        chart.appear(1000, 100);
        return function () { return root.dispose(); };
    }, [chartId, data, width, isOpenDebounced]);
    if (isEmpty || isLoading) {
        return (React__default["default"].createElement(material.Card, { variant: 'outlined', sx: {
                mb: { xs: 2 },
                height: height,
                p: 2,
                alignItems: 'center',
                justifyContent: 'center',
            } }, isLoading ? React__default["default"].createElement(FillContainerLoading, null) : React__default["default"].createElement(EmptyReportBody, null)));
    }
    return React__default["default"].createElement(material.Box, { sx: __assign$l({ height: height }, style), id: chartId, component: 'div' });
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var mapBubbleColors = ['#FFC75F', '#FF9671', '#FF6F91', '#D65DB1', '#845EC2'];
var XY = {
    DefaultChartSettings: {
        panX: true,
        panY: true,
        wheelY: 'zoomXY',
        pinchZoomX: true,
        pinchZoomY: true,
    },
    Templates: {
        Circle: function (root, series, onClick) {
            var circleTemplate = am5.Template.new({});
            circleTemplate.adapters.add('fill', function (fill, target) {
                var _a, _b, _c, _d;
                var color = (_b = (_a = target.dataItem) === null || _a === void 0 ? void 0 : _a.dataContext) === null || _b === void 0 ? void 0 : _b.color;
                if (color)
                    return am5.Color.fromString(color);
                var colorIndex = (_d = (_c = target.dataItem) === null || _c === void 0 ? void 0 : _c.dataContext) === null || _d === void 0 ? void 0 : _d.colorIndex;
                if (colorIndex != null)
                    return am5.Color.fromString(mapBubbleColors[colorIndex % mapBubbleColors.length]);
                return fill;
            });
            if (onClick) {
                circleTemplate.events.on('click', function (event) { var _a, _b; return onClick((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.dataItem) === null || _b === void 0 ? void 0 : _b.dataContext); });
            }
            series.set('heatRules', [
                {
                    target: circleTemplate,
                    min: 3,
                    max: 30,
                    dataField: 'value',
                    key: 'radius',
                },
            ]);
            return {
                circle: function () {
                    return am5.Circle.new(root, {
                        radius: 5,
                        fill: series.get('fill'),
                        fillOpacity: 0.8,
                    }, circleTemplate);
                },
                template: circleTemplate,
            };
        },
        SmallCircle: function (root, series, onClick) {
            var circleTemplate = am5.Template.new({});
            circleTemplate.adapters.add('fill', function (fill, target) {
                var _a, _b, _c, _d;
                var color = (_b = (_a = target.dataItem) === null || _a === void 0 ? void 0 : _a.dataContext) === null || _b === void 0 ? void 0 : _b.color;
                if (color)
                    return am5.Color.fromString(color);
                var colorIndex = (_d = (_c = target.dataItem) === null || _c === void 0 ? void 0 : _c.dataContext) === null || _d === void 0 ? void 0 : _d.colorIndex;
                // @ts-ignore
                if (colorIndex)
                    return series.get('colors').getIndex(colorIndex);
                return fill;
            });
            if (onClick) {
                circleTemplate.events.on('click', function (event) { var _a, _b; return onClick((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.dataItem) === null || _b === void 0 ? void 0 : _b.dataContext); });
            }
            series.set('heatRules', [
                {
                    target: circleTemplate,
                    min: 5,
                    max: 10,
                    dataField: 'value',
                    key: 'radius',
                },
            ]);
            return {
                circle: function () {
                    return am5.Circle.new(root, {
                        radius: 5,
                        fill: series.get('fill'),
                        fillOpacity: 0.8,
                    }, circleTemplate);
                },
                template: circleTemplate,
            };
        },
    },
    ChartPlugins: {
        Scrollbar: function (_a) {
            var root = _a.root, chart = _a.chart, vertical = _a.vertical, horizontal = _a.horizontal;
            if (horizontal) {
                chart.set('scrollbarX', am5.Scrollbar.new(root, {
                    orientation: 'horizontal',
                }));
            }
            if (vertical) {
                chart.set('scrollbarY', am5.Scrollbar.new(root, {
                    orientation: 'vertical',
                }));
            }
        },
        Cursor: function (_a) {
            var root = _a.root, chart = _a.chart, xAxis = _a.xAxis, yAxis = _a.yAxis, series = _a.series;
            chart.set('cursor', xy.XYCursor.new(root, {
                xAxis: xAxis,
                yAxis: yAxis,
                snapToSeries: series,
            }));
        },
    },
};
/**
 * See https://www.amcharts.com/docs/v5/concepts/formatters/text-styling/
 */
var formatLabelText = function (labels) {
    var format = function (label) {
        var formatting = '';
        if (label.fontSize)
            formatting += "fontSize: ".concat(label.fontSize, "px;");
        if (label.color)
            formatting += "".concat(label.color, ";");
        if (label.bold)
            formatting += "bold;";
        if (formatting.length > 0)
            formatting = "[".concat(formatting, "]");
        var newline = label.newline ? '\n' : ' ';
        return "".concat(formatting).concat(label.text, "[/]").concat(newline);
    };
    return labels.map(format).join('');
};
var ToolTip = function (root, labels, settings, getFillFromSprite) {
    var _a;
    if (settings === void 0) { settings = {}; }
    if (getFillFromSprite === void 0) { getFillFromSprite = false; }
    var tooltip = am5.Tooltip.new(root, __assign$l({ getFillFromSprite: getFillFromSprite, labelText: formatLabelText(labels) }, settings));
    if (!getFillFromSprite) {
        (_a = tooltip === null || tooltip === void 0 ? void 0 : tooltip.get('background')) === null || _a === void 0 ? void 0 : _a.setAll({
            fill: am5.color(MuiTheme.palette.grey['100']),
            fillOpacity: 0.8,
        });
    }
    return tooltip;
};
var filterBySearchTerm = function (item, searchTerm, indexBy) {
    return StringHelpers.isNullOrEmpty(searchTerm)
        ? true
        : item[indexBy]
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
};
var ReportingHelpers = {
    XY: XY,
    ALL: {
        formatLabelText: formatLabelText,
        ToolTip: ToolTip,
    },
    TABLE: {
        filterBySearchTerm: filterBySearchTerm,
    },
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var BubbleChart = function (props) {
    var chartId = props.chartId, xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel, tooltip = props.tooltip, onClick = props.onClick, rest = __rest$c(props, ["chartId", "xAxisLabel", "yAxisLabel", "tooltip", "onClick"]);
    var mountChart = function (data) {
        var root = am5.Root.new(chartId);
        var chart = root.container.children.push(xy.XYChart.new(root, {
            panX: true,
            panY: true,
            wheelY: 'zoomXY',
            pinchZoomX: true,
            pinchZoomY: true,
        }));
        var xAxis = chart.xAxes.push(xy.ValueAxis.new(root, {
            renderer: xy.AxisRendererX.new(root, {}),
            tooltip: am5.Tooltip.new(root, {}),
        }));
        xAxis.children.moveValue(am5.Label.new(root, {
            text: xAxisLabel,
            x: am5.p50,
            centerX: am5.p50,
        }), xAxis.children.length - 1);
        var yAxis = chart.yAxes.push(xy.ValueAxis.new(root, {
            renderer: xy.AxisRendererY.new(root, {
                inversed: false,
            }),
            tooltip: am5.Tooltip.new(root, {}),
        }));
        yAxis.children.moveValue(am5.Label.new(root, {
            rotation: -90,
            text: yAxisLabel,
            y: am5.p50,
            centerX: am5.p50,
        }), 0);
        var series = chart.series.push(xy.LineSeries.new(root, {
            calculateAggregates: true,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: 'y',
            valueXField: 'x',
            valueField: 'value',
            seriesTooltipTarget: 'bullet',
            tooltip: tooltip
                ? ReportingHelpers.ALL.ToolTip(root, tooltip, {}, true)
                : undefined,
        }));
        series.strokes.template.set('visible', false);
        var circle = ReportingHelpers.XY.Templates.Circle(root, series, onClick).circle;
        series.bullets.push(function () { return am5.Bullet.new(root, { sprite: circle() }); });
        series.data.setAll(data);
        ReportingHelpers.XY.ChartPlugins.Cursor({
            root: root,
            chart: chart,
            xAxis: xAxis,
            yAxis: yAxis,
            series: [series],
        });
        ReportingHelpers.XY.ChartPlugins.Scrollbar({
            root: root,
            chart: chart,
            horizontal: true,
            vertical: true,
        });
        return { root: root, chart: chart, xAxis: xAxis, yAxis: yAxis };
    };
    return (React__default["default"].createElement(AmchartBase, __assign$l({ chartId: chartId, mountChart: mountChart }, rest)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var LineChart = function (props) {
    var chartId = props.chartId, xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel, tooltipLabels = props.tooltip, rest = __rest$c(props, ["chartId", "xAxisLabel", "yAxisLabel", "tooltip"]);
    var mountChart = function (data) {
        var root = am5.Root.new(chartId);
        var chart = root.container.children.push(xy.XYChart.new(root, {
            panX: true,
            panY: true,
            wheelX: 'panX',
            wheelY: 'zoomX',
            pinchZoomX: true,
        }));
        var xAxis = chart.xAxes.push(xy.DateAxis.new(root, {
            maxDeviation: 0.2,
            baseInterval: {
                timeUnit: 'day',
                count: 1,
            },
            renderer: xy.AxisRendererX.new(root, {}),
        }));
        var yAxis = chart.yAxes.push(xy.ValueAxis.new(root, {
            renderer: xy.AxisRendererY.new(root, {}),
        }));
        xAxis.children.moveValue(am5.Label.new(root, {
            text: xAxisLabel,
            x: am5.p50,
            centerX: am5.p50,
        }), xAxis.children.length - 1);
        yAxis.children.moveValue(am5.Label.new(root, {
            rotation: -90,
            text: yAxisLabel,
            y: am5.p50,
            centerX: am5.p50,
        }), 0);
        for (var _i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            var series = chart.series.push(xy.LineSeries.new(root, {
                name: 'Series',
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: 'value',
                valueXField: 'date',
                tooltip: tooltipLabels
                    ? ReportingHelpers.ALL.ToolTip(root, __spreadArray$5([
                        {
                            text: key,
                            color: MuiTheme.palette.secondary.light,
                            newline: true,
                        }
                    ], tooltipLabels, true))
                    : undefined,
            }));
            series.data.setAll(value);
            ReportingHelpers.XY.ChartPlugins.Cursor({
                root: root,
                chart: chart,
                series: [series],
            });
        }
        ReportingHelpers.XY.ChartPlugins.Scrollbar({
            root: root,
            chart: chart,
            horizontal: true,
            vertical: false,
        });
        return { root: root, chart: chart, xAxis: xAxis, yAxis: yAxis };
    };
    return React__default["default"].createElement(AmchartBase, __assign$l({ mountChart: mountChart, chartId: chartId }, rest));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ScatterChart = function (props) {
    var chartId = props.chartId, data = props.data, tooltip = props.tooltip, onClick = props.onClick, xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel, renderExtraSeries = props.renderExtraSeries, rest = __rest$c(props, ["chartId", "data", "tooltip", "onClick", "xAxisLabel", "yAxisLabel", "renderExtraSeries"]);
    var mountChart = function (data) {
        var root = am5.Root.new(chartId);
        var chart = root.container.children.push(xy.XYChart.new(root, {
            panX: true,
            panY: true,
            wheelY: 'zoomXY',
            pinchZoomX: true,
            pinchZoomY: true,
        }));
        var xAxis = chart.xAxes.push(xy.ValueAxis.new(root, {
            renderer: xy.AxisRendererX.new(root, { minGridDistance: 75 }),
            tooltip: am5.Tooltip.new(root, {}),
        }));
        xAxis.children.moveValue(am5.Label.new(root, {
            text: xAxisLabel,
            x: am5.p50,
            centerX: am5.p50,
        }), xAxis.children.length - 1);
        var yAxis = chart.yAxes.push(xy.ValueAxis.new(root, {
            renderer: xy.AxisRendererY.new(root, {}),
            tooltip: am5.Tooltip.new(root, {}),
        }));
        yAxis.children.moveValue(am5.Label.new(root, {
            rotation: -90,
            text: yAxisLabel,
            y: am5.p50,
            centerX: am5.p50,
        }), 0);
        var series = chart.series.push(xy.LineSeries.new(root, {
            calculateAggregates: true,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: 'y',
            valueXField: 'x',
            valueField: 'value',
            tooltip: tooltip
                ? ReportingHelpers.ALL.ToolTip(root, tooltip, {}, true)
                : undefined,
        }));
        var circle = ReportingHelpers.XY.Templates.SmallCircle(root, series, onClick).circle;
        series.bullets.push(function () {
            return am5.Bullet.new(root, {
                sprite: circle(),
            });
        });
        series.strokes.template.set('strokeOpacity', 0);
        ReportingHelpers.XY.ChartPlugins.Cursor({
            root: root,
            chart: chart,
            xAxis: xAxis,
            yAxis: yAxis,
            series: [series],
        });
        ReportingHelpers.XY.ChartPlugins.Scrollbar({
            root: root,
            chart: chart,
            horizontal: true,
            vertical: true,
        });
        series.data.setAll(data);
        series.appear(100);
        renderExtraSeries && renderExtraSeries({ root: root, chart: chart, xAxis: xAxis, yAxis: yAxis });
        return { root: root, chart: chart, xAxis: xAxis, yAxis: yAxis };
    };
    return (React__default["default"].createElement(AmchartBase, __assign$l({ chartId: chartId, data: data, mountChart: mountChart }, rest)));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var BarChart = function (props) {
    var horizontal = props.horizontal, chartId = props.chartId, tooltip = props.tooltip, _a = props.color, defaultColor = _a === void 0 ? MuiTheme.palette.secondary.main : _a, xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel, rest = __rest$c(props, ["horizontal", "chartId", "tooltip", "color", "xAxisLabel", "yAxisLabel"]);
    var getAxis = function (root, chart) {
        var xAxis;
        var yAxis;
        var xRenderer = xy.AxisRendererX.new(root, { minGridDistance: 30 });
        var yRenderer = xy.AxisRendererY.new(root, { minGridDistance: 30 });
        var labelSettings = {
            rotation: -45,
            centerY: am5__namespace.p50,
            centerX: am5__namespace.p100,
            paddingRight: 15,
        };
        xRenderer.labels.template.setAll(labelSettings);
        if (horizontal) {
            yAxis = chart.yAxes.push(xy.CategoryAxis.new(root, {
                maxDeviation: 0,
                categoryField: 'category',
                renderer: yRenderer,
            }));
            xAxis = chart.xAxes.push(xy.ValueAxis.new(root, {
                maxDeviation: 0,
                min: 0,
                extraMax: 0.1,
                renderer: xRenderer,
            }));
        }
        else {
            yAxis = chart.yAxes.push(xy.ValueAxis.new(root, {
                maxDeviation: 0,
                renderer: yRenderer,
            }));
            xAxis = chart.xAxes.push(xy.CategoryAxis.new(root, {
                maxDeviation: 0,
                categoryField: 'category',
                renderer: xRenderer,
            }));
        }
        xAxis.children.moveValue(am5.Label.new(root, {
            text: xAxisLabel,
            x: am5.p50,
            centerX: am5.p50,
        }), 0);
        yAxis.children.moveValue(am5.Label.new(root, {
            rotation: -90,
            text: yAxisLabel,
            y: am5.p50,
            centerX: am5.p50,
        }), 0);
        return { xAxis: xAxis, yAxis: yAxis };
    };
    var mountChart = function (data) {
        var root = am5.Root.new(chartId);
        var chart = root.container.children.push(xy.XYChart.new(root, {
            panX: true,
            panY: true,
            wheelX: 'panX',
            wheelY: 'zoomX',
            pinchZoomX: true,
        }));
        ReportingHelpers.XY.ChartPlugins.Scrollbar({
            root: root,
            chart: chart,
            horizontal: true,
            vertical: false,
        });
        var _a = getAxis(root, chart), xAxis = _a.xAxis, yAxis = _a.yAxis;
        var fields = horizontal
            ? {
                valueXField: 'value',
                categoryYField: 'category',
            }
            : {
                valueYField: 'value',
                categoryXField: 'category',
            };
        var series = chart.series.push(xy.ColumnSeries.new(root, __assign$l({ name: 'Series 1', xAxis: xAxis, yAxis: yAxis, tooltip: tooltip
                ? ReportingHelpers.ALL.ToolTip(root, tooltip)
                : undefined }, fields)));
        ReportingHelpers.XY.ChartPlugins.Cursor({
            root: root,
            chart: chart,
            series: [series],
        });
        series.columns.template.setAll({
            cornerRadiusTR: 5,
            cornerRadiusBR: horizontal ? 5 : 0,
            cornerRadiusTL: horizontal ? 0 : 5,
        });
        series.columns.template.adapters.add('fill', function () { return am5.color(defaultColor); });
        series.columns.template.adapters.add('stroke', function () { return am5.color(defaultColor); });
        if (horizontal) {
            yAxis.data.setAll(data);
        }
        else {
            xAxis.data.setAll(data);
        }
        series.data.setAll(data);
        series.appear(1000);
        return { root: root, chart: chart, xAxis: xAxis, yAxis: yAxis };
    };
    return React__default["default"].createElement(AmchartBase, __assign$l({ mountChart: mountChart, chartId: chartId }, rest));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var SwireUSAMapChart = function (props) {
    var chartId = props.chartId, data = props.data, regions = props.regions, tooltip = props.tooltip, rest = __rest$c(props, ["chartId", "data", "regions", "tooltip"]);
    var newMapData = __assign$l(__assign$l({}, map_data__default["default"]), { features: map_data__default["default"].features.filter(function (feat) { var _a; return regions.indexOf((_a = feat.properties) === null || _a === void 0 ? void 0 : _a.id) != -1; }) });
    var mountChart = function (data) {
        var root = am5.Root.new(chartId);
        // Need this here. Otherwise, it would break the zooming animation
        root.setThemes([am5themes_Animated__default["default"].new(root)]);
        var chart = root.container.children.push(map.MapChart.new(root, {}));
        var polygonSeries = chart.series.push(map.MapPolygonSeries.new(root, {
            geoJSON: newMapData,
            fill: am5.Color.fromString('#D6EFFF'),
            // @ts-ignore
            strokeWidth: 10,
            stroke: am5.Color.fromString('#000000'),
        }));
        polygonSeries.mapPolygons.template.events.on('click', function (ev) {
            var _a, _b;
            var chart = (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.series) === null || _b === void 0 ? void 0 : _b.chart;
            chart === null || chart === void 0 ? void 0 : chart.zoomToGeoPoint(ev.target.geoCentroid(), 3);
        });
        polygonSeries.mapPolygons.template.states.create('hover', {
            fill: am5.Color.fromString('#C6DFFF'),
        });
        var bubbleSeries = chart.series.push(map.MapPointSeries.new(root, {
            calculateAggregates: true,
            valueField: 'size',
            latitudeField: 'latitude',
            longitudeField: 'longitude',
            showTooltipOn: 'always',
        }));
        var circle = ReportingHelpers.XY.Templates.Circle(root, bubbleSeries).circle;
        bubbleSeries.bullets.push(function () {
            var cir = circle();
            cir.set('tooltip', tooltip ? ReportingHelpers.ALL.ToolTip(root, tooltip) : undefined);
            cir.set('tooltipText', ' '); // For some reason, without this the tooltip breaks
            return am5.Bullet.new(root, {
                sprite: cir,
            });
        });
        bubbleSeries.data.setAll(data);
        var zoomOut = root.tooltipContainer.children.push(am5.Button.new(root, {
            x: am5.p100,
            y: 0,
            centerX: am5.p100,
            centerY: 0,
            paddingTop: 18,
            paddingBottom: 18,
            paddingLeft: 12,
            paddingRight: 12,
            dx: -20,
            dy: 20,
            themeTags: ['zoom'],
            icon: am5.Graphics.new(root, {
                themeTags: ['button', 'icon'],
                strokeOpacity: 0.7,
            }),
        }));
        zoomOut.events.on('click', function () { return chart.goHome(); });
        return { root: root, chart: chart };
    };
    return (React__default["default"].createElement(AmchartBase, __assign$l({ mountChart: mountChart, chartId: chartId, data: data }, rest)));
};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var UserTile = function (props) {
    var user = props.user, isLoading = props.isLoading, selected = props.selected, onPress = props.onPress, children = props.children, RightComponent = props.RightComponent;
    var loading = isLoading || !user;
    return (React__default["default"].createElement(material.Card, { elevation: selected ? 10 : 1, style: { width: '100%' }, onClick: onPress },
        selected && (React__default["default"].createElement(material.CardHeader, { sx: { p: 1 }, avatar: React__default["default"].createElement(iconsMaterial.PushPin, { color: "primary" }) })),
        React__default["default"].createElement(material.CardContent, { sx: { flexGrow: 1 } },
            React__default["default"].createElement(FlexBox.Col, null, loading ? (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                        height: theme.sizes.skeleton.sm,
                        mb: "".concat(theme.sizes.skeleton.xs, "px"),
                    }); } }),
                React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                        height: theme.sizes.skeleton.xs,
                        mb: "".concat(theme.sizes.skeleton.xs, "px"),
                    }); } }),
                React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                        height: theme.sizes.skeleton.xs,
                        mb: "".concat(theme.sizes.skeleton.xs, "px"),
                    }); } }),
                React__default["default"].createElement(material.Skeleton, { sx: function (theme) { return ({
                        height: theme.sizes.skeleton.xs,
                    }); } }))) : (React__default["default"].createElement(FlexBox.RowBetween, null,
                React__default["default"].createElement(material.Box, null,
                    React__default["default"].createElement(material.Typography, { variant: "subtitle1", component: "p", fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden' },
                        user.firstName,
                        " ",
                        user.lastName),
                    React__default["default"].createElement(material.Typography, { variant: "body1", component: "p" }, user.mainRole),
                    React__default["default"].createElement(material.Typography, { variant: "body2", component: "p" }, user.email)),
                RightComponent)))),
        children && React__default["default"].createElement(material.CardActions, null, children)));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var GridSections = function (props) {
    var items = props.items, _a = props.spacing, spacing = _a === void 0 ? 2 : _a;
    return (React__default["default"].createElement(material.Grid, { spacing: spacing }, Object.entries(items).map(function (_a) {
        var sectionTitle = _a[0], _b = _a[1], body = _b.body, gridProps = _b.gridProps;
        return (React__default["default"].createElement(Box__default["default"], { sx: { mb: 1 }, id: sectionTitle },
            React__default["default"].createElement(material.Typography, { variant: "h6", fontWeight: function (theme) { return theme.typography.fontWeightBold; } }, sectionTitle),
            React__default["default"].createElement(material.Grid, __assign$l({ container: true }, gridProps), body)));
    })));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var ButtonWithProgress = function (props) {
    var loading = props.loading, rest = __rest$c(props, ["loading"]);
    return (React__default["default"].createElement(styles.ThemeProvider, { theme: MuiTheme },
        React__default["default"].createElement(Box__default["default"], { sx: { position: 'relative' } },
            React__default["default"].createElement(Button__default["default"], __assign$l({}, rest), props.children),
            loading && (React__default["default"].createElement(material.CircularProgress, { size: 24, sx: function (theme) { return ({
                    color: theme.palette.success.main,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                }); } })))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var defaultThresholds = { warning: 25, success: 75 };
var LinearProgressWithThresholds = function (props) {
    var value = props.value, label = props.label, _a = props.thresholds, _b = _a === void 0 ? defaultThresholds : _a, warning = _b.warning, success = _b.success, sx = props.sx;
    var color = value >= success ? 'success' : value >= warning ? 'warning' : 'error';
    if (label) {
        return (React__default["default"].createElement(CaptionStack, { caption: "".concat(String(Math.round(value)), "% ").concat(label), placement: "top", alignment: "left", sx: sx },
            React__default["default"].createElement(material.Box, { width: "100%" },
                React__default["default"].createElement(material.LinearProgress, { variant: "determinate", value: value, color: color }))));
    }
    return (React__default["default"].createElement(material.LinearProgress, { variant: "determinate", value: value, color: color, sx: sx }));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var TransferList = function (props) {
    var label = props.label, items = props.items, onSearchChange = props.onSearchChange, checked = props.checked, setChecked = props.setChecked;
    var handleToggle = function (selected) { return function () {
        var currentIndex = checked.map(function (ch) { return ch.value; }).indexOf(selected.value);
        var newChecked = __spreadArray$5([], checked, true);
        if (currentIndex === -1) {
            newChecked.push(selected);
        }
        else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    }; };
    var numberOfChecked = function (items) {
        return SelectableListHelpers.intersection(checked, items).length;
    };
    var handleToggleAll = function (items) { return function () {
        if (numberOfChecked(items) === items.length) {
            setChecked(SelectableListHelpers.not(checked, items));
        }
        else {
            setChecked(SelectableListHelpers.union(checked, items));
        }
    }; };
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(material.Typography, { variant: "body2", pb: 1, color: 'rgba(0, 0, 0, 0.6)' }, label),
        React__namespace.createElement(Card__default["default"], null,
            React__namespace.createElement(CardHeader__default["default"], { avatar: React__namespace.createElement(Checkbox__default["default"], { onClick: handleToggleAll(items), checked: numberOfChecked(items) === items.length && items.length !== 0, indeterminate: numberOfChecked(items) !== items.length &&
                        numberOfChecked(items) !== 0, disabled: items.length === 0 }), title: React__namespace.createElement(SearchBar, { onChange: onSearchChange }) }),
            React__namespace.createElement(Divider__default["default"], null),
            React__namespace.createElement(List__default["default"], { sx: function (theme) { return ({
                    height: theme.sizes.forms.lg,
                    overflow: 'auto',
                }); }, dense: true, component: "div", role: "list" },
                items.length ? (items.map(function (item) { return (React__namespace.createElement(ListItem__default["default"], { key: item.value, role: "listitem", onClick: handleToggle(item) },
                    React__namespace.createElement(ListItemIcon__default["default"], null,
                        React__namespace.createElement(Checkbox__default["default"], { checked: checked.map(function (ch) { return ch.value; }).indexOf(item.value) !== -1, tabIndex: -1, disableRipple: true })),
                    React__namespace.createElement(ListItemText__default["default"], { primary: item.display }))); })) : (React__namespace.createElement(FlexBox.ColCenter, { p: 4 },
                    React__namespace.createElement(AvatarWithText, { primaryText: 'Use arrow buttons to move items to this list.' },
                        React__namespace.createElement(iconsMaterial.Add, { color: 'secondary' })))),
                React__namespace.createElement(ListItem__default["default"], null)))));
};

/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var TransferListContainer = function (props) {
    var choices = props.choices, setChoices = props.setChoices, chosen = props.chosen, setChosen = props.setChosen, choicesLabel = props.choicesLabel, chosenLabel = props.chosenLabel;
    var _a = React.useState([]), checked = _a[0], setChecked = _a[1];
    var _b = React.useState(''), choiceSearchTerm = _b[0], setChoiceSearchTerm = _b[1];
    var _c = React.useState(''), chosenSearchTerm = _c[0], setChosenSearchTerm = _c[1];
    var choicesChecked = SelectableListHelpers.intersection(checked, choices);
    var chosenChecked = SelectableListHelpers.intersection(checked, chosen);
    var handleCheckedRight = function () {
        setChosen(chosen.concat(choicesChecked));
        setChoices(SelectableListHelpers.not(choices, choicesChecked));
        setChecked(SelectableListHelpers.not(checked, choicesChecked));
    };
    var handleCheckedLeft = function () {
        setChoices(choices.concat(chosenChecked));
        setChosen(SelectableListHelpers.not(chosen, chosenChecked));
        setChecked(SelectableListHelpers.not(checked, chosenChecked));
    };
    var choicesFiltered = React.useMemo(function () {
        return choices.filter(function (ch) {
            return ch.display.toLowerCase().includes(choiceSearchTerm.toLowerCase());
        });
    }, [choices, choiceSearchTerm]);
    var chosenFiltered = React.useMemo(function () {
        return chosen.filter(function (ch) {
            return ch.display.toLowerCase().includes(chosenSearchTerm.toLowerCase());
        });
    }, [chosen, chosenSearchTerm]);
    return (React__namespace.createElement(material.Grid, { container: true, spacing: 2, justifyContent: "center", alignItems: "center" },
        React__namespace.createElement(material.Grid, __assign$l({ item: true }, gridAllScreens(5)),
            React__namespace.createElement(TransferList, { label: choicesLabel, items: choicesFiltered, onSearchChange: setChoiceSearchTerm, checked: checked, setChecked: setChecked })),
        React__namespace.createElement(material.Grid, __assign$l({ item: true }, gridAllScreens(2)),
            React__namespace.createElement(material.Grid, { container: true, direction: "column", alignItems: "center" },
                React__namespace.createElement(Button__default["default"], { sx: { my: 1, height: 64 }, variant: "outlined", onClick: handleCheckedRight, disabled: choicesChecked.length === 0 },
                    React__namespace.createElement(iconsMaterial.ChevronRight, { sx: function (theme) { return ({
                            color: choicesChecked.length === 0
                                ? theme.palette.grey['400']
                                : theme.palette.primary.main,
                        }); } })),
                React__namespace.createElement(Button__default["default"], { sx: { my: 1, height: 64 }, variant: "outlined", onClick: handleCheckedLeft, disabled: chosenChecked.length === 0 },
                    React__namespace.createElement(iconsMaterial.ChevronLeft, { sx: function (theme) { return ({
                            color: chosenChecked.length === 0
                                ? theme.palette.grey['400']
                                : theme.palette.primary.main,
                        }); } })))),
        React__namespace.createElement(material.Grid, __assign$l({ item: true }, gridAllScreens(5)),
            React__namespace.createElement(TransferList, { label: chosenLabel, items: chosenFiltered, onSearchChange: setChosenSearchTerm, checked: checked, setChecked: setChecked }))));
};

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var Square = function (_a) {
    var children = _a.children, size = _a.size, color = _a.color, radius = _a.radius, variant = _a.variant;
    return (React__default["default"].createElement(material.Card, { variant: variant === 'outlined' ? variant : undefined, elevation: 0, color: variant === 'outlined' ? color : undefined, sx: function (theme) { return (__assign$l(__assign$l({ borderRadius: radius || 2, width: size, height: size }, theme.view.col.center), (variant === 'fill' && {
            bgcolor: color,
        }))); } },
        React__default["default"].createElement(material.Typography, { variant: "h5", sx: function (theme) { return ({
                color: variant === 'outlined'
                    ? theme.palette.secondary.main
                    : theme.palette.primary.main,
            }); } }, children)));
};

/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var DIVISION_REPORT_TABLE_COLUMNS = [
    {
        field: 'name',
        headerName: 'Sales Center',
    },
    {
        field: 'compliance',
        headerName: 'Compliance',
    },
    {
        field: 'storesSurveyed',
        headerName: 'Stores Surveyed',
    },
    {
        field: 'totalPriorities',
        headerName: 'Number of Priorities',
    },
    {
        field: 'rank',
        headerName: 'Sales Center Ranking',
    },
    {
        field: 'action',
        headerName: '',
    },
];
var SALES_CENTER_REPORT_GRID_COLUMNS = [
    {
        field: 'name',
        headerName: 'Store Name',
    },
    {
        field: 'address',
        headerName: 'Store Address',
        renderCell: function (params) { return (React__default["default"].createElement(AddressBlock, { address: params.value })); },
    },
    {
        field: 'compliance',
        headerName: 'Compliance',
        renderCell: function (params) { return (React__default["default"].createElement(LinearProgressWithThresholds, { value: params.value, label: "Compliant", sx: { width: '80%' } })); },
    },
    {
        field: 'totalPriorities',
        headerName: 'Number of Priorities',
    },
    {
        field: 'rank',
        headerName: 'Store Ranking',
    },
    {
        field: 'action',
        headerName: '',
    },
];
var SALES_CENTER_REPORT_TABLE_COLUMNS = [
    {
        field: 'name',
        headerName: 'Store Name',
    },
    {
        field: 'address',
        headerName: 'Store Address',
    },
    {
        field: 'compliance',
        headerName: 'Compliance',
    },
    {
        field: 'totalPriorities',
        headerName: 'Number of Priorities',
    },
    {
        field: 'rank',
        headerName: 'Store Ranking',
    },
    {
        field: 'action',
        headerName: '',
    },
];
var STORE_REPORT_TABLE_COLUMNS = [
    {
        field: 'priority',
        headerName: 'Priority',
    },
    {
        field: 'description',
        headerName: 'Description',
        width: 200,
    },
    {
        field: 'cost',
        headerName: 'Display Cost',
    },
    {
        field: 'compliant',
        headerName: 'Compliant',
    },
];
/** Priority Views */
var complianceColumn = function (props) { return (__assign$l({ minWidth: 110, flex: 1, sortable: false, disableColumnMenu: true, renderCell: function (params) {
        return params.value ? (React__default["default"].createElement(LinearProgressWithThresholds, { value: params.value, label: "Compliant" })) : ('N/A');
    } }, props)); };
var priorityColumn = function (props) { return (__assign$l({ field: 'priority', headerName: 'Priority', width: 250, sortable: false, disableColumnMenu: true, renderCell: function (params) {
        return params.value ? (React__default["default"].createElement(PicOSPriorityDetails, __assign$l({}, params.value, { sx: function (theme) { return ({ paddingY: theme.spacing(1) }); } }))) : ('N/A');
    } }, props)); };
var PRIORITY_STORE_TABLE_COLUMNS = [
    {
        field: 'name',
        headerName: 'Store Name',
    },
    {
        field: 'address',
        headerName: 'Store Address',
    },
    {
        field: 'compliant',
        headerName: 'Compliant',
    },
    {
        field: 'cost',
        headerName: 'Display Cost',
    },
];

/**
 * Copyright © 2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
var formatAddress = function (address, options) {
    var nl = (options === null || options === void 0 ? void 0 : options.newLineABeforeCity) ? '\n' : ' ';
    return "".concat(address.address1, " ").concat(address.address2).concat(nl).concat(StringHelpers.titleCase(address.city.toLocaleLowerCase()), ", ").concat(address.state, " ").concat(address.postalCode);
};
var StoresHelpers = {
    formatAddress: formatAddress,
};

exports.ActionBar = ActionBar;
exports.AddressBlock = AddressBlock;
exports.AmchartBase = AmchartBase;
exports.AutocompleteSelectInput = AutocompleteSelectInput;
exports.AvatarWithText = AvatarWithText;
exports.BarChart = BarChart;
exports.BubbleChart = BubbleChart;
exports.ButtonWithProgress = ButtonWithProgress;
exports.CaptionStack = CaptionStack;
exports.ChangeOverTimeChip = ChangeOverTimeChip;
exports.CircularProgress = CircularProgress;
exports.CircularProgressThresholds = CircularProgressThresholds;
exports.CollapsibleContent = CollapsibleContent;
exports.Colors = Colors;
exports.ComplianceCard = ComplianceCard;
exports.CondensedInputWithDropdown = CondensedInputWithDropdown;
exports.CreateNewPopover = CreateNewPopover;
exports.CustomIcon = CustomIcon;
exports.DAITable = DAITable;
exports.DIVISION_REPORT_TABLE_COLUMNS = DIVISION_REPORT_TABLE_COLUMNS;
exports.DateRangePicker = DateRangePicker;
exports.EmptyReportBody = EmptyReportBody;
exports.FILL_GRID_ALL_SCREENS = FILL_GRID_ALL_SCREENS;
exports.FileUploader = FileUploader;
exports.FillContainerLoading = FillContainerLoading;
exports.Filter = Filter;
exports.FilterHelpers = FilterHelpers;
exports.FilterLabel = FilterLabel;
exports.FlexBox = FlexBox;
exports.FlexScroll = FlexScroll;
exports.FormContext = FormContext;
exports.FullScreenLayout = FullScreenLayout;
exports.FullScreenModal = FullScreenModal;
exports.GenericImageCard = GenericImageCard;
exports.GridSections = GridSections;
exports.ImageCarousel = ImageCarousel;
exports.ItemList = ItemList;
exports.Layout = Layout;
exports.LevelSelector = LevelSelector;
exports.LineChart = LineChart;
exports.LinearProgressWithThresholds = LinearProgressWithThresholds;
exports.MUIDatePicker = MUIDatePicker;
exports.MuiForm = MuiForm;
exports.MuiFormController = MuiFormController;
exports.MuiFormHelpers = MuiFormHelpers;
exports.MuiFormModal = MuiFormModal;
exports.MuiTheme = MuiTheme;
exports.NavBar = NavBar;
exports.NavItem = NavItem;
exports.NavigationDrawer = NavigationDrawer;
exports.NavigationDrawerContext = NavigationDrawerContext;
exports.NavigationTabs = NavigationTabs;
exports.NotificationAlert = NotificationAlert;
exports.NotificationContext = NotificationContext;
exports.OptionSelectBody = OptionSelectBody;
exports.PRIORITY_STORE_TABLE_COLUMNS = PRIORITY_STORE_TABLE_COLUMNS;
exports.PageTitle = PageTitle;
exports.PaginationConstants = PaginationConstants;
exports.PicOSComplianceCardReport = PicOSComplianceCardReport;
exports.PicOSComplianceDataGridReport = PicOSComplianceDataGridReport;
exports.PicOSComplianceTableReport = PicOSComplianceTableReport;
exports.PicOSPriorityDetails = PicOSPriorityDetails;
exports.PicOSReportContext = PicOSReportContext;
exports.PlaceholderBox = PlaceholderBox;
exports.PlanogramSegment = PlanogramSegment;
exports.ProductDetailRaw = ProductDetailRaw;
exports.ProductFormattingHelpers = ProductFormattingHelpers;
exports.ProductTile = ProductTile;
exports.ProductTileOnlyUpc = ProductTileOnlyUpc;
exports.RankingChangeOverTime = RankingChangeOverTime;
exports.ReportContainerLayout = ReportContainerLayout;
exports.ReportLayout = ReportLayout;
exports.ReportingHelpers = ReportingHelpers;
exports.SALES_CENTER_REPORT_GRID_COLUMNS = SALES_CENTER_REPORT_GRID_COLUMNS;
exports.SALES_CENTER_REPORT_TABLE_COLUMNS = SALES_CENTER_REPORT_TABLE_COLUMNS;
exports.STORE_REPORT_TABLE_COLUMNS = STORE_REPORT_TABLE_COLUMNS;
exports.ScatterChart = ScatterChart;
exports.ScreenController = ScreenController;
exports.SearchBar = SearchBar;
exports.SearchableListWithSkeleton = SearchableListWithSkeleton;
exports.SearchableSelectInput = SearchableSelectInput;
exports.SelectInputWrapper = SelectInputWrapper;
exports.SelectableListHelpers = SelectableListHelpers;
exports.Shades = Shades;
exports.Sidebar = Sidebar;
exports.SortedShadesList = SortedShadesList;
exports.Square = Square;
exports.StatCard = StatCard;
exports.StoresHelpers = StoresHelpers;
exports.StringHelpers = StringHelpers;
exports.SwireUSAMapChart = SwireUSAMapChart;
exports.TextInputWrapper = TextInputWrapper;
exports.Tints = Tints;
exports.TransferListContainer = TransferListContainer;
exports.UNIDENTIFIED_PRODUCT = UNIDENTIFIED_PRODUCT;
exports.UserHelpers = UserHelpers;
exports.UserTile = UserTile;
exports.allBoxesMappedToElDoradoProduct = allBoxesMappedToElDoradoProduct;
exports.complianceColumn = complianceColumn;
exports.createInputFromBoundingBoxes = createInputFromBoundingBoxes;
exports.daiThemeOptions = daiThemeOptions;
exports.getDescriptionFromProducts = getDescriptionFromProducts;
exports.getElDoradoProduct = getElDoradoProduct;
exports.getImageUrlFromProducts = getImageUrlFromProducts;
exports.getProduct = getProduct;
exports.getProductWithInfoErrors = getProductWithInfoErrors;
exports.gridAllScreens = gridAllScreens;
exports.isCustomerProduct = isCustomerProduct;
exports.isProductType = isProductType;
exports.priorityColumn = priorityColumn;
exports.styled = styled;
exports.transformBoundingBoxes = transformBoundingBoxes;
exports.transformProduct = transformProduct;
exports.transformProductInfoErrors = transformProductInfoErrors;
exports.transformSingleProductImage = transformSingleProductImage;
exports.transformSuggestedProducts = transformSuggestedProducts;
exports.unknownProductBoxes = unknownProductBoxes;
exports.useCommonFilter = useCommonFilter;
exports.useDebouncedItemQuery = useDebouncedItemQuery;
exports.useInfiniteScrollAndSearch = useInfiniteScrollAndSearch;
exports.useMuiForm = useMuiForm;
exports.useNotificationState = useNotificationState;
exports.useOutsideAlerter = useOutsideAlerter;
exports.usePagination = usePagination;
exports.useProductSearch = useProductSearch;
exports.useStepper = useStepper;
//# sourceMappingURL=index.js.map
